import * as React from 'react';
import React__default, { useMemo } from 'react';
import AnimateHeight from 'react-animate-height';
import ReactDOM, { flushSync } from 'react-dom';
import Tippy from '@tippyjs/react';
import tippy, { sticky, followCursor } from 'tippy.js';
import fuzzysort from 'fuzzysort';
import { deburr, escapeRegExp, get, isFinite as isFinite$1, isArray, isString, isNumber as isNumber$1, cloneDeep, set, some as some$1, has, debounce, throttle as throttle$1, isNil as isNil$1, isFunction, pick, isEqual, capitalize, noop as noop$1, defaultsDeep, remove, omitBy, isUndefined, isBoolean, isEmpty, merge } from 'lodash';
import classnames from 'classnames/bind';
import { getElementName, deepFind } from 'react-children-utilities';
import { match, P } from 'ts-pattern';
import { useDebounce } from '@react-hook/debounce';
import useResizeObserver$1 from '@react-hook/resize-observer';
import { useTranslation as useTranslation$1, Trans as Trans$1, I18nextProvider } from 'react-i18next';
import { useController, useFormContext as useFormContext$1, useWatch, useFieldArray, useFormState, useForm, FormProvider as FormProvider$1 } from 'react-hook-form';
import * as Yup from 'yup';
import { AsYouType, findPhoneNumbersInText } from 'libphonenumber-js';
import throttle from 'lodash/throttle';
import cx$1S from 'classnames';
import IMask from 'imask';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useFloating, offset, flip, shift, limitShift, autoUpdate, useFloatingRootContext, useDismiss, useFocus, useRole, useInteractions, autoPlacement, arrow } from '@floating-ui/react';
import axios from 'axios';
import FocusLock from 'react-focus-lock';
import { sort } from 'fast-sort';
import { Draggable, Droppable, DragDropContext } from '@hello-pangea/dnd';
import difference from 'set.prototype.difference';
import union from 'set.prototype.union';
import intersection from 'set.prototype.intersection';
import { DateTime, Settings } from 'luxon';
import ReactCalendar from 'react-calendar';
import { yupResolver } from '@hookform/resolvers/yup';
import { enUS, enCA, enGB, frCA } from '@appliedsystems/base-translations';
import i18next from 'i18next';
import Pseudo from 'i18next-pseudo';

/* istanbul ignore file */
// cSpell:ignore livefill
/**
 * LiveFill defines an `ADS` get/set property on `window`  before ADS is loaded, so that it may:
 *   * Receive/Intercept our AdsGlobalObject via the setter
 *   * Store it in a backing field to delegate to, as necessary.
 *     - Ideally forwards calls it hasn't implemented to the original `AdsGlobalObject`.
 *     - Example: The `.version` property is currently forwarded. The behavior is:
 *          - Before `window.ADS` is set to `AdsGlobalObject`, `.version` will return empty string `''`.
 *          - After receiving `AdsGlobalObject`, `.version` calls will return the value provided by the real `AdsGlobalObject`.
 *            *(this means ADS has to detect this & still call the factory instead of returning the `preexisting` ADS value)*
 *   * The LiveFIll ADS object's type is a `@webcomponents/custom-elements`'s customElement that extends `HTMLElement` providing ShadowDom.
 *     It overrides ADS's:
 *      - `injectStyle` & `injectFont`: to ensure all injections are properly placed in ShadowDom.
 *      - `portalElement`: to return React's `renderTarget` element which is a child element of `.shadowRoot`
 *
 *  __Please contact LiveFillExtension team if making breaking changes__
 */
window.ADS = ((preexisting, factory) => {
    /**
     * @example
     * // NOTE: the first occurrence matching the regexp in ../scripts/set-version.js is replaced:
     * @link https://gitlab.com/appliedsystems/enterprise/user-interface/applied-design-system/-/blob/v6.5.0/scripts/set-version.js}
     */
    const thisVersion = '7.7.3';
    if (preexisting &&
        // verify the shape
        'version' in preexisting &&
        'injectStyle' in preexisting &&
        'injectFont' in preexisting &&
        'portalElement' in preexisting &&
        // verify compliance
        typeof preexisting.version === 'string' &&
        typeof preexisting.injectStyle === 'function' &&
        typeof preexisting.injectFont === 'function' &&
        typeof preexisting.portalElement === 'function' &&
        // use version to ensure preexisting is functionally the same
        preexisting.version === thisVersion) {
        // Avoid multiple initializations, because:
        // * hidden state variables:  __adsStyleContainer & __adsStyleTag
        // * methods may have been intentionally overwritten to provide custom functionality: injectStyle, injectFont, & portalElement
        return preexisting;
    }
    return factory(thisVersion);
})(window.ADS, function ADSFactory(adsVersion) {
    let __adsStyleContainer;
    let __adsStyleTag;
    // Use a DocumentFragment to batch style operations for better performance
    let __styleFragment;
    function sanitizeCSS(css) {
        css = css === null || css === void 0 ? void 0 : css.trim();
        // strip potential UTF-8 BOM if css was read from a file
        if (css.length > 0 && css.charCodeAt(0) === 0xfeff) {
            css = css.substring(1);
        }
        return css;
    }
    // By default we render portals inside document.body, but there are cases where
    // consuming apps may want to control this (live fill for example renders in a shadow dom).
    function __portalElement() {
        return document.body;
    }
    // We need to inject fonts differently than styles. Custom fonts have to be installed in the page's head tag.
    // We detect custom fonts by looking at the file's path to see if includes the /fonts/ folder (see rollup config)
    function __injectFont(css, _) {
        if (!css) {
            return;
        }
        // If open sans is already installed or ADS has
        // already injected the font we can abort.
        if (document.getElementById('ads-injected-font')) {
            return;
        }
        const style = document.createElement('style');
        style.setAttribute('id', 'ads-injected-font');
        style.setAttribute('data-version', window.ADS.version);
        style.setAttribute('type', 'text/css');
        // Use textContent instead of innerHTML for better performance
        style.textContent = sanitizeCSS(css);
        // Inject into head no matter what
        document
            .getElementsByTagName('head')[0]
            .insertAdjacentElement('afterbegin', style);
    }
    // Custom style injector where we allow our styles to be injected into the `#ads-injected-styles` element OR fallback
    // to the head of the page.
    function __injectStyle(css) {
        var _a;
        if (!css) {
            return;
        }
        // If we don't have a container yet, find #ads-injected-styles or fallback to head of the page.
        if (!__adsStyleContainer) {
            __adsStyleContainer =
                (_a = document.getElementById('ads-injected-styles')) !== null && _a !== void 0 ? _a : document.getElementsByTagName('head')[0];
        }
        // If we haven't created a style element yet, create it and inject it as child of our container
        if (!__adsStyleTag) {
            __adsStyleTag = document.createElement('style');
            __adsStyleTag.setAttribute('type', 'text/css');
            __adsStyleTag.setAttribute('data-version', window.ADS.version);
            __adsStyleContainer.insertAdjacentElement('beforeend', __adsStyleTag);
            // Create a document fragment to batch style operations
            __styleFragment = document.createDocumentFragment();
        }
        // Use a text node instead of innerHTML for better performance
        // This avoids reparsing the entire innerHTML content each time
        const sanitizedCss = sanitizeCSS(css);
        const textNode = document.createTextNode(sanitizedCss);
        // Add to the fragment (batching changes)
        // This defers the DOM updates until we append the fragment to the style tag
        if (__styleFragment) {
            __styleFragment.appendChild(textNode);
            // Use requestAnimationFrame to batch the DOM updates
            // This ensures we're not causing multiple reflows/repaints
            requestAnimationFrame(() => {
                if (__adsStyleTag && __styleFragment) {
                    __adsStyleTag.appendChild(__styleFragment);
                    // Reset the fragment for future style injections
                    __styleFragment = document.createDocumentFragment();
                }
            });
        }
    }
    /** @global AdsGlobalObject */
    const ADS = {
        version: adsVersion,
        injectStyle: __injectStyle,
        injectFont: __injectFont,
        portalElement: __portalElement
    };
    return ADS;
});

var BadgeType;
(function (BadgeType) {
    // Brand
    BadgeType["Info"] = "info";
    BadgeType["Success"] = "success";
    BadgeType["Error"] = "error";
    BadgeType["Warning"] = "warning";
    // Pill-Shape Only
    BadgeType["Default"] = "default";
    BadgeType["Accordion"] = "accordion";
    BadgeType["Applied"] = "applied";
})(BadgeType || (BadgeType = {}));
const ExactMatchOptionKeys = ['matchCase', 'matchDiacritics'];
var SelectType;
(function (SelectType) {
    SelectType["Select"] = "select";
    SelectType["Embedded"] = "embedded";
})(SelectType || (SelectType = {}));
var AccordionTypes;
(function (AccordionTypes) {
    AccordionTypes["H2"] = "h2";
    AccordionTypes["H3"] = "h3";
    AccordionTypes["H4"] = "h4";
})(AccordionTypes || (AccordionTypes = {}));
var SectionTypes;
(function (SectionTypes) {
    SectionTypes["H1"] = "h1";
    SectionTypes["H2"] = "h2";
    SectionTypes["H3"] = "h3";
    SectionTypes["H4"] = "h4";
})(SectionTypes || (SectionTypes = {}));
var BreakPoint;
(function (BreakPoint) {
    BreakPoint["XS"] = "xs";
    BreakPoint["SM"] = "sm";
    BreakPoint["MD"] = "md";
    BreakPoint["LG"] = "lg";
    BreakPoint["XL"] = "xl";
    BreakPoint["XXL"] = "xxl";
})(BreakPoint || (BreakPoint = {}));
var NestedPaginationLevel;
(function (NestedPaginationLevel) {
    NestedPaginationLevel["ALL"] = "all";
    NestedPaginationLevel["PARENT"] = "parent";
    // CHILD = 1, // These have weird implementation challenges
    // GRANDCHILD = 2 // not implementing until requested.
})(NestedPaginationLevel || (NestedPaginationLevel = {}));
var AddressFields;
(function (AddressFields) {
    AddressFields["AddressSearch"] = "addressSearch";
    AddressFields["AddressSearchOptions"] = "addressSearchOptions";
    AddressFields["Street"] = "streetLine";
    AddressFields["Address2"] = "address2";
    AddressFields["Address3"] = "address3";
    AddressFields["Address4"] = "address4";
    AddressFields["City"] = "city";
    AddressFields["State"] = "state";
    AddressFields["Province"] = "province";
    AddressFields["ZipCode"] = "zipCode";
    AddressFields["PostalCode"] = "postalCode";
    AddressFields["County"] = "county";
    AddressFields["Country"] = "country";
    AddressFields["Verified"] = "verified";
})(AddressFields || (AddressFields = {}));
var AddressMode;
(function (AddressMode) {
    AddressMode["Default"] = "default";
    AddressMode["Lookup"] = "lookup";
    AddressMode["Strict"] = "strict";
})(AddressMode || (AddressMode = {}));
var AlertMessageType;
(function (AlertMessageType) {
    AlertMessageType["Notification"] = "notification";
    AlertMessageType["Toast"] = "toast";
})(AlertMessageType || (AlertMessageType = {}));
var BrandType;
(function (BrandType) {
    BrandType["Info"] = "info";
    BrandType["Success"] = "success";
    BrandType["Error"] = "error";
    BrandType["Warning"] = "warning";
    BrandType["Inverse"] = "inverse";
})(BrandType || (BrandType = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection || (SortDirection = {}));
var ColumnMode;
(function (ColumnMode) {
    ColumnMode["Single"] = "single";
    ColumnMode["Multi"] = "multi";
})(ColumnMode || (ColumnMode = {}));
var DismissedBy;
(function (DismissedBy) {
    DismissedBy["AutoDismiss"] = "auto dismiss";
    DismissedBy["CloseClick"] = "close button";
    DismissedBy["Escape"] = "escape key";
    DismissedBy["Programmatically"] = "programmatically";
})(DismissedBy || (DismissedBy = {}));
var IconPlacement;
(function (IconPlacement) {
    IconPlacement["Start"] = "start";
    IconPlacement["End"] = "end";
})(IconPlacement || (IconPlacement = {}));
var Align;
(function (Align) {
    Align["Left"] = "left";
    Align["Center"] = "center";
    Align["Right"] = "right";
})(Align || (Align = {}));
var TextAlign;
(function (TextAlign) {
    TextAlign["Left"] = "left";
    TextAlign["Right"] = "right";
})(TextAlign || (TextAlign = {}));
var PlacementPosition;
(function (PlacementPosition) {
    PlacementPosition["TopRight"] = "top-right";
    PlacementPosition["TopLeft"] = "top-left";
    PlacementPosition["BottomLeft"] = "bottom-left";
    PlacementPosition["BottomRight"] = "bottom-right";
})(PlacementPosition || (PlacementPosition = {}));
var FormValidationState;
(function (FormValidationState) {
    FormValidationState["None"] = "none";
    FormValidationState["Success"] = "success";
    FormValidationState["Error"] = "error";
})(FormValidationState || (FormValidationState = {}));

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @deprecated Use string literal type 'ADSInputFieldFormat' instead.
 * This enum is being deprecated in favor of string literals and reduce the need for explicit enum imports. Will be removed in ADS v8.0.0.
 *
 * Instead of `TextFieldFormats.SSN`, use `"SSN"` directly.
 * @example
 * Deprecated usage:
 * format={TextFieldFormats.SSN}
 *
 * Preferred usage:
 * format="SSN"
 *
 * Change made for ticket DX-942
 */
var TextFieldFormats;
(function (TextFieldFormats) {
    TextFieldFormats["SSN"] = "SSN";
    TextFieldFormats["FEIN"] = "FEIN";
    TextFieldFormats["NUMERIC"] = "Number";
    TextFieldFormats["UPPER"] = "Upper";
    TextFieldFormats["LOWER"] = "Lower";
    TextFieldFormats["ZIPCODE"] = "ZIPCODE";
    TextFieldFormats["CANPOST"] = "CANPOST";
    TextFieldFormats["UKPOST"] = "UKPOST";
    TextFieldFormats["DECIMAL_DIGITS"] = "DECIMAL_DIGITS";
    TextFieldFormats["DRIVERS_LICENSE"] = "DRIVERS_LICENSE";
    // DATE = 'Date'
})(TextFieldFormats || (TextFieldFormats = {}));
const ADSFieldFormats = [
    // address
    'can-post',
    'uk-post',
    'zip-code',
    // casing
    'lowercase',
    'uppercase',
    // miscellaneous
    'decimal-digits',
    'drivers-license',
    'fein',
    'number',
    'ssn'
];
const isADSFieldFormat = (value) => {
    return ADSFieldFormats.some((f) => f === value);
};
const enumToUnion = {
    [TextFieldFormats.SSN]: 'ssn',
    [TextFieldFormats.FEIN]: 'fein',
    [TextFieldFormats.NUMERIC]: 'number',
    [TextFieldFormats.UPPER]: 'uppercase',
    [TextFieldFormats.LOWER]: 'lowercase',
    [TextFieldFormats.ZIPCODE]: 'zip-code',
    [TextFieldFormats.CANPOST]: 'can-post',
    [TextFieldFormats.UKPOST]: 'uk-post',
    [TextFieldFormats.DECIMAL_DIGITS]: 'decimal-digits',
    [TextFieldFormats.DRIVERS_LICENSE]: 'drivers-license'
};
const FormatterMap = {
    // address
    'can-post': {
        pattern: 'a0a 0a0]',
        prepare: (v) => v.toUpperCase()
    },
    'uk-post': {
        // regex form: [A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}
        prepare: (v) => v.toUpperCase(),
        pattern: 'a[a]b[c] 0dd',
        definitions: {
            b: /[0-9Rr]/,
            c: /[0-9A-Za-z]/,
            d: /[ABD-HJLNP-UW-Zabd-hjlnp-uw-z]/
        }
    },
    'zip-code': { pattern: '00000[-0000]' },
    // casing
    lowercase: {
        pattern: String,
        prepare: (v) => v.toLowerCase()
    },
    uppercase: {
        pattern: String,
        prepare: (v) => v.toUpperCase()
    },
    // miscellaneous
    'decimal-digits': { pattern: /^\d+$/ },
    'drivers-license': {
        prepare: (v) => v.toUpperCase(),
        pattern: /^(?=.*[0-9a-zA-Z])[-0-9a-zA-Z\s]*$/
    },
    fein: { pattern: '00-0000000' },
    ssn: { pattern: '000-00-0000' },
    number: { pattern: Number }
};
function getFormatter(fieldFormat) {
    const key = isADSFieldFormat(fieldFormat)
        ? fieldFormat
        : enumToUnion[fieldFormat];
    return FormatterMap[key];
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function useIsMountedRef() {
    const isMountedRef = React__default.useRef(false);
    React__default.useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    });
    return isMountedRef;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const CONSTANTS$4 = {
    animationDurationMs: 200 // milliseconds
};
// Handles the complexity of animating a component's height.
// If the component can stay mounted this is really simple. if you
// need unmount after it's hidden, it gets more complicated.
// See Accordion for simple use case, and DataGridChildContainer for complex case
const AnimateHeightRender = ({ animationProps, animateOnRender = true, children }) => {
    const isMountedRef = useIsMountedRef();
    const [height, setHeight] = React__default.useState(animateOnRender ? 0 : 'auto');
    animationProps = Object.assign({
        duration: CONSTANTS$4.animationDurationMs,
        animateOpacity: true,
        easing: 'cubic-bezier(0.25, 0.25, 0.25, 1)'
    }, animationProps);
    React__default.useEffect(() => {
        requestAnimationFrame(() => {
            if (!isMountedRef.current) {
                return;
            }
            /*
             * While migrating to React 18, we needed to ensure that the `setHeight` calls were not batched.
             * This is because it made the animation clunky when opening the drop-down (it would not show the transition and instead,
             * just appear fully opened without the animation). Wrapping `setHeight` with `flushSync`
             * will ensure that these two state updates are not batched.
             */
            flushSync(() => {
                setHeight('auto');
            });
        });
    }, [isMountedRef]);
    const childProps = {
        animateExit: (cb) => {
            setHeight(0);
            if (cb) {
                /*
                 * While migrating to React 18, we needed to ensure that the `setHeight` and `animateExit` calls were not batched.
                 * This caused issues when closing and reopening a combobox, preventing it from highlighting the currently selected value on open.
                 * Wrapping `cb` with `flushSync` will ensure that these two state updates are not batched.
                 */
                setTimeout(() => flushSync(() => cb()), CONSTANTS$4.animationDurationMs);
            }
        }
    };
    return (React__default.createElement(AnimateHeight, Object.assign({ height: height, className: "fpp" }, animationProps), typeof children === 'function' ? children(childProps) : children));
};

var css$2m = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{background-color:#333;border-radius:4px;color:#fff;font-size:14px;line-height:1.4;outline:0;position:relative;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{border-top-color:initial;border-width:8px 8px 0;bottom:-7px;left:0;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{border-bottom-color:initial;border-width:0 8px 8px;left:0;top:-7px;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-left-color:initial;border-width:8px 0 8px 8px;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{border-right-color:initial;border-width:8px 8px 8px 0;left:-7px;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{color:#333;height:16px;width:16px}.tippy-arrow:before{border-color:#0000;border-style:solid;content:\"\";position:absolute}.tippy-content{padding:5px 9px;position:relative;z-index:1}.ads-tippy.tippy-box{background-color:#363840;overflow-wrap:break-word}.ads-tippy.tippy-box .tippy-arrow{color:#363840}.ads-tippy.tippy-box a{color:#aabff8}";
window.ADS.injectStyle(css$2m,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Tooltip/Tippy.scss");

var css$2l = ".Tooltip_module_target__dadfb561{display:inline-block}";
window.ADS.injectStyle(css$2l,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Tooltip/Tooltip.module.scss");
var modules_16974fb0 = {"target":"Tooltip_module_target__dadfb561"};

const defaultDelay = [300, 250];
/**
 * `Tooltip` is a lightweight wrapper around [Tippyjs](https://github.com/atomiks/tippyjs-react).
 */
const Tooltip = ({ customDataProps, content, trigger = 'mouseenter', placement = 'top', visible, interactive = false, sticky: sticky$1 = false, followCursor: followCursor$1 = false, delay = defaultDelay, disabled = false, className = modules_16974fb0.target, children, testId = 'tooltip-testid' }) => {
    // If they are setting a value for visible, then we are in manual mode.
    const isManual = visible !== undefined;
    // Determine which plugins to use based on props
    const plugins = [];
    if (sticky$1)
        plugins.push(sticky);
    if (followCursor$1)
        plugins.push(followCursor);
    return (React__default.createElement(Tippy, { content: content, interactive: interactive, 
        // if we are in manual mode, we don't want to pass a trigger
        trigger: isManual ? undefined : trigger, delay: delay, placement: placement, 
        // interactive mode should append to body, otherwise it will be placed in the DOM
        // under the target element which can cause issues with z-index and the content.
        // this is the default for non-interactive tooltips already, so we're just explicitly using it here.
        // see further: https://atomiks.github.io/tippyjs/v6/all-props/#appendto
        appendTo: () => document.body, disabled: disabled, visible: visible, className: "ads-tippy", sticky: sticky$1, followCursor: followCursor$1, plugins: plugins },
        React__default.createElement("span", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: className }), children)));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
// A search result's score must be higher than this threshold to be included;
const MIN_MATCH_SCORE_THRESHOLD = -31000;
const MIN_HIGHLIGHT_CHARACTERS$1 = 3;
const HighlightedText = ({ children }) => (React__default.createElement("span", { className: "ads-highlight" }, children));
function highlightExactMatch(result, searchTerm) {
    const normalizedSearchTerm = deburr(searchTerm).toLowerCase();
    if (!result.cells) {
        return;
    }
    Object.values(result.cells).forEach((cell, cellIndex) => {
        const columnResult = cell.text;
        const normalizedColumnResult = deburr(columnResult).toLowerCase();
        const startIndex = normalizedColumnResult.indexOf(normalizedSearchTerm);
        if (startIndex === -1) {
            return;
        }
        const endIndex = startIndex + normalizedSearchTerm.length;
        const highlighted = (React__default.createElement(React__default.Fragment, null,
            columnResult.slice(0, startIndex),
            React__default.createElement(HighlightedText, { key: cellIndex }, columnResult.slice(startIndex, endIndex)),
            columnResult.slice(endIndex)));
        const searchCell = cell;
        searchCell.highlightText(highlighted);
    });
}
// This function loops through all the "column" search results and if there is a
// match, finds the SearchableCell instance and calls it's highlight method using
// fuzzysort's highlight uptility and our HighlightText react component.
function highlightFuzzyMatch(result) {
    for (const resultProp in result) {
        // If the propert is a number it's a cell of a search result
        const columnResult = result[resultProp];
        // The result object provided by fuzzsort is kind of weird. It has numerical
        // properties which map to the keys we passed it when doing the search.
        // If we have a property that is a number (meaning it's a colum search result)
        // try and highlight.
        if (!isNaN(Number(resultProp)) && columnResult) {
            // If the matched characters is greae
            const highlighted = fuzzysort.highlight(columnResult, (matchedCharacters, key) => matchedCharacters.length >= MIN_HIGHLIGHT_CHARACTERS$1 ? (React__default.createElement(HighlightedText, { key: key }, matchedCharacters)) : (matchedCharacters));
            const cell = result.obj.cells[resultProp];
            cell.highlightText(highlighted);
        }
    }
}
function parseClientSearchResults(searchTerm, results, exactMatch = false) {
    return results.map((result) => {
        if (searchTerm.length >= MIN_HIGHLIGHT_CHARACTERS$1) {
            if (exactMatch) {
                highlightExactMatch(result, searchTerm);
            }
            else {
                highlightFuzzyMatch(result);
            }
        }
        return exactMatch ? result : result.obj;
    });
}
// Define normalizers for each option in ExactMatchConfig
const normalizers = {
    matchCase: (str) => str.toLowerCase(),
    matchDiacritics: deburr
};
// Apply the normalizers to a string based on the provided options.
function applyNormalizers(str, options) {
    return ExactMatchOptionKeys.filter((key) => !(options === null || options === void 0 ? void 0 : options[key])).reduce((acc, currentKey) => normalizers[currentKey](acc), str);
}
function filterRows(rows, searchKeys, normalizedSearchTerm, options) {
    return rows.filter((row) => {
        for (const key of searchKeys) {
            const keys = key.split('.');
            const value = keys.reduce((obj, k) => (obj || {})[k], row);
            // Normalize the value based on the exact match options
            const normalizedValue = applyNormalizers(String(value) || '', options);
            if (normalizedValue.includes(normalizedSearchTerm)) {
                return true;
            }
        }
        return false;
    });
}
/**
 * A custom React Hook to do a in-memory fuzzy text search
 * using fuzzysort library.
 */
function FuzzSearch(rows, searchKeys, searchTerm = '', exactMatch, idField) {
    let results = rows;
    if (rows && searchTerm) {
        if (exactMatch && exactMatch.enabled) {
            // Apply normalizers to the search term based on the exactMatch options
            const normalizedSearchTerm = applyNormalizers(searchTerm, exactMatch.options);
            // Filter rows based on the normalized search term and exactMatch options
            const exactResults = filterRows(rows, searchKeys, normalizedSearchTerm, exactMatch.options);
            // Parse the search results
            results = parseClientSearchResults(searchTerm, exactResults, true);
        }
        else {
            const fuzzResults = fuzzysort.go(searchTerm, rows, {
                threshold: MIN_MATCH_SCORE_THRESHOLD,
                keys: searchKeys
            });
            results = parseClientSearchResults(searchTerm, fuzzResults);
        }
    }
    // add the parents back in, if they were removed by the search.
    if (results.findIndex((r) => { var _a; return ((_a = r.parents) === null || _a === void 0 ? void 0 : _a.length) > 0; }) > -1) {
        results
            .filter((r) => r.parents.length > 0)
            .forEach((c) => {
            c.parents.forEach((p) => {
                if (!results.find((check) => idField
                    ? rows[p].item[idField] === check.item[idField]
                    : rows[p].item.id === check.item.id)) {
                    results.push(rows[p]);
                }
            });
        });
    }
    return results;
}

// Min amount of characters required to trigger highlighting.
const MIN_HIGHLIGHT_CHARACTERS = 3;
// This will find exact matches and highlight them using the passed searchKeys
// Treats space separated words as separate search terms per design requests.
function HighlightOnly(searchTerm, searchKeys, rows) {
    var _a;
    if (!rows || !searchTerm) {
        return rows;
    }
    searchTerm = searchTerm.trim();
    if (searchTerm.length < MIN_HIGHLIGHT_CHARACTERS) {
        return rows;
    }
    // We are blessed with the requirement of treating space separated words like
    // separate search terms to highlight, so we build an array of space separated words
    // and then build a regex that will look for groups of our terms globally.
    searchTerm = deburr(escapeRegExp(searchTerm));
    const terms = searchTerm.split(' ').length > 1
        ? searchTerm
            .split(' ')
            .filter((t) => t.length >= MIN_HIGHLIGHT_CHARACTERS)
            .map((t) => `(${t})`)
            .join('|')
        : searchTerm;
    const searchRegex = new RegExp(terms, 'gi');
    // Loop through our rows and search across the ones with data
    for (const row of rows) {
        if (row === null || row === void 0 ? void 0 : row.item) {
            // For rows with loaded data (i.e. have data property) loop over all our columns
            // that we will search and highlight any exact matches of our search term.
            for (const searchPath of searchKeys) {
                const cellPath = searchPath.split('.text')[0];
                const cell = get(row, cellPath);
                if (cell) {
                    const deburredText = deburr((_a = cell === null || cell === void 0 ? void 0 : cell.text) !== null && _a !== void 0 ? _a : '');
                    // Grab all the starting indexes of matches
                    const matches = [...deburredText.matchAll(searchRegex)].map((m) => {
                        var _a, _b;
                        return {
                            startIndex: (_a = m.index) !== null && _a !== void 0 ? _a : 0,
                            endIndex: ((_b = m.index) !== null && _b !== void 0 ? _b : 0) + m[0].length
                        };
                    });
                    // If we have any matches process them
                    if (matches.length) {
                        const content = [];
                        let processedTo = 0;
                        for (const match of matches) {
                            // Add the text before
                            content.push(cell.text.substring(processedTo, match.startIndex), React__default.createElement(HighlightedText, { key: match.startIndex }, cell.text.substring(match.startIndex, match.endIndex))
                            // Grab rest after this match till next match
                            );
                            processedTo = match.endIndex;
                        }
                        // If there is any remaining text after our last match, grab it.
                        if (cell.text.length > processedTo) {
                            content.push(cell.text.substring(processedTo));
                        }
                        cell.highlightText(content);
                    }
                }
            }
        }
    }
}

// Class that manages heights for a list. Handles a defult height, storing / updating
// a list item's height as well as support for calculating the height from a range
// within the list. You can also give it a height and it will tell you which range
// of indices in the list cover that height.
class ListHeightCache {
    constructor() {
        this.cache = new Map();
    }
    get size() {
        return this.hasDefaultHeight ? this.cache.size + 1 : this.cache.size;
    }
    get hasDefaultHeight() {
        return !!this.defaultHeight;
    }
    get getDefaultHeight() {
        return this.defaultHeight;
    }
    // We only need to store our height if it's different than the defaultHeight.
    // For our use case, it is expected MOST rows will have the same height as
    // their siblings, but the row height will not match from instance to instance.
    // For this reason the first height stored we treat as a special defaultHeight,
    // which we expect to be more efficent than storing every row's height as we
    // expect a high number of duplicates. This also returns true / false on if
    // the value changed.
    set(index, height) {
        // If we don't have a default this is the new default
        if (!this.defaultHeight) {
            this.defaultHeight = height;
            return true;
        }
        // If this value equals the default, we are done (make sure to clean up previously
        // value if this just changed to the default value).
        if (height === this.defaultHeight) {
            if (this.cache.has(index)) {
                this.cache.delete(index);
                return true;
            }
            return false;
        }
        // Check if we already have this value set
        if (this.cache.get(index) === height) {
            return false;
        }
        // If we got here then we've changed our value
        this.cache.set(index, height);
        return true;
    }
    // If we have a value at that index, retrieve that, but fallback to our
    // first entry and then after that our default.
    get(index) {
        var _a;
        return (_a = this.cache.get(index)) !== null && _a !== void 0 ? _a : this.defaultHeight;
    }
    clear() {
        this.defaultHeight = undefined;
        this.cache.clear();
    }
    // Given a range of indices, return the sum of their height. Use the first
    // row as a default value if we don't have a row's height yet.
    getHeightFromRange(startIndex, endIndex) {
        if (!this.defaultHeight) {
            return 0;
        }
        let height = 0;
        for (let i = startIndex; i < endIndex; i++) {
            height += this.get(i);
        }
        return height;
    }
    // Given a height amount, find the range that would cover that height amount.
    getRangeFromHeight(height, startIndex) {
        startIndex = startIndex && startIndex >= 0 ? startIndex : 0;
        if (!this.defaultHeight) {
            return [0, 0];
        }
        let i = startIndex - 1;
        let foundHeight = 0;
        do {
            i++;
            foundHeight += this.get(i);
        } while (foundHeight < height);
        return [startIndex, i];
    }
}

class OpenCloseCache {
    constructor(mode = 'close', exceptions = [], type = 'openclose', generation, bypassDisabledList = false) {
        this.generationMap = {
            0: 'parent',
            1: 'child',
            2: 'grandchild'
        };
        this.mode = mode;
        this.type = type;
        this.search = false;
        this.disabledIndicesList = [];
        this.bypassDisabledList = bypassDisabledList;
        this.exceptions = exceptions;
        this.nestingData = [];
        this.idList = [];
        this.idListWithGeneration = [];
        this.lostExceptions = [];
        this.lastIndex = -1;
        this.generation = generation;
        this.unseenListItems = [];
    }
    // updates the exception list to point at new indexes
    // returns true if nesting should be updated (happens externally).
    sortIdList(sortList) {
        // Check to see if the lists actually changed:
        if (this.idList.length === sortList.length &&
            this.idList.findIndex((o, idx) => o !== sortList[idx]) === -1) {
            return false;
        }
        // list had not been set yet, set it.
        if (this.idList.length < 1) {
            this.idList = sortList;
            if (this.exceptions.length === 0 && this.lostExceptions.length === 0) {
                return true;
            }
        }
        // we're updating the list - do the exceptions too.
        const newExceptions = [];
        // run through exception list
        // get id of exception on list
        this.exceptions.forEach((exp) => {
            const newException = sortList.indexOf(this.idList[exp.index]);
            if (newException > -1 &&
                !newExceptions.some((exception) => exception.index === newException)) {
                // assign to new id based on new sorted list.
                newExceptions.push({
                    index: newException,
                    generation: exp.generation
                });
            }
            else if (newException === -1) {
                // item id isn't in the list, keep track of the ID, maybe it'll return
                this.lostExceptions.push({
                    id: this.idList[exp.index],
                    generation: this.getRowGeneration(exp.index)
                });
            }
        });
        this.lostExceptions.forEach((lost) => {
            const lostException = sortList.indexOf(lost.id);
            if (lostException > -1 &&
                !newExceptions.some((exception) => exception.index === lostException)) {
                newExceptions.push({
                    index: lostException,
                    generation: lost.generation
                });
            }
        });
        // any lost exceptions that have been found can be removed from the list
        this.lostExceptions = this.lostExceptions.filter((l) => sortList.indexOf(l.id) === -1);
        // assign sortList to idList when done.
        this.idList = sortList;
        this.exceptions = newExceptions;
        this.unseenListItems = this.unseenListItems.filter((unseenListItem) => {
            const index = this.idList.findIndex((id) => id === unseenListItem.id);
            // keep row id in the unseen list because it is still unseen
            if (index < 0) {
                return true;
            }
            // add the unseen list item to the exception list since it is in the opposite mode than the cache.
            if (unseenListItem.mode !== this.mode) {
                this.exceptions.push({
                    index: index,
                    generation: this.getRowGeneration(index)
                });
            }
            // remove the unseen item from the unseen list
            return false;
        });
        return true;
    }
    // nesting conditional list: for complex nesting scenarios
    // uses IDs for parent data.
    setNesting(data) {
        this.nestingData = data;
        return this;
    }
    nesting() {
        return this.nestingData.length > 0;
    }
    setSearching(searching) {
        this.search = searching;
    }
    setDisabledIndicesList(indices, disabled) {
        this.disabledIndicesList = disabled ? [...indices] : [];
    }
    // checks to see if parents indexes are open
    parentsOpen(index) {
        var _a;
        return (this.nesting() &&
            ((_a = this.nestingData[index].parentIds) === null || _a === void 0 ? void 0 : _a.reduce((prev, curr) => prev && this.isOpen(this.idList.indexOf(curr)), true)));
    }
    getRowGeneration(index) {
        var _a, _b, _c;
        const generationNumber = (_c = (_b = (_a = this.nestingData[index]) === null || _a === void 0 ? void 0 : _a.parentIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        return this.generationMap[generationNumber];
    }
    // for situations where parent rows need to show "mix" when only some children are open.
    getNestedOpenStatus(index) {
        var _a, _b, _c;
        // if the item is in the disabled list, we want to indicate that the item is NOT checked.
        // This gets reflected in the UI as a disabled checkbox.
        if (!this.bypassDisabledList && this.disabledIndicesList.includes(index)) {
            return 'close';
        }
        if (this.nesting() && ((_a = this.nestingData[index]) === null || _a === void 0 ? void 0 : _a.hasChildren)) {
            // if an item has children, figure out how many children are open
            // if some are open, return mix.
            const children = this.nestingData
                .map((item, index) => {
                return { item, index };
            })
                .filter((c) => c.item.parentIds.includes(this.idList[index]));
            // Check if all children are in the disabled list
            if (!this.bypassDisabledList) {
                const allChildrenDisabled = children.every((c) => this.disabledIndicesList.includes(c.index));
                if (allChildrenDisabled && this.isOpen(index)) {
                    return 'open';
                }
            }
            const openChildren = children.filter((c) => this.getNestedOpenStatus(c.index) === 'open');
            const lostOpenChildren = (_b = this.nestingData[index]) === null || _b === void 0 ? void 0 : _b.childIds.filter((missing) => !this.idList.includes(missing)).filter((c) => this.mode === 'close'
                ? this.lostExceptions.some((exception) => exception.id === c)
                : !this.lostExceptions.some((exception) => exception.id === c));
            if (openChildren.length === 0 && lostOpenChildren.length === 0) {
                return 'close';
            }
            else if (openChildren.length + lostOpenChildren.length ===
                ((_c = this.nestingData[index]) === null || _c === void 0 ? void 0 : _c.childIds.length)) {
                return 'open';
            }
            else {
                return 'mix';
            }
        }
        else {
            // if an item has no children or we're not nesting rows, it can only be opened or closed.
            return this.isOpen(index) ? 'open' : 'close';
        }
    }
    // this indicates when the open state changes.  The number
    // is intended to be unique for all modes when things are open, or all closed.
    totalOpenCalc() {
        return this.mode === 'open'
            ? -this.exceptions.length
            : this.exceptions.length;
    }
    // the openClose cache doesn't know the total number of items,
    // this function will you that amount if everything is opened or closed.
    totalOpen(itemCount, generation) {
        if (generation) {
            const exceptionsInGeneration = this.exceptions.filter((exception) => exception.generation === generation).length;
            const lostExceptionsInGeneration = this.lostExceptions.filter((exception) => exception.generation === generation).length;
            const openCount = exceptionsInGeneration + lostExceptionsInGeneration;
            const totalOpen = this.mode === 'open' ? itemCount - openCount : openCount;
            /*
             * We saw a render where this appeared as -1 which does not make sense. This ensures that won't happen.
             * It is due to the fact that there is a render where the number of rows is not accurate. This happens
             * when we have a search term and remove it. There is a render or two where the row count is what is visible.
             * This check can be removed once we accurately maintain a list of the rows (or hidden rows) when applying a filter.
             */
            return totalOpen >= 0 ? totalOpen : 0;
        }
        const openCount = this.exceptions.length + this.lostExceptions.length;
        return this.mode === 'open' ? itemCount - openCount : openCount;
    }
    // Check if a specific index is open.
    // Note - lost exceptions have no index (only ID), so this function cannot check for them.
    isOpen(index) {
        var _a;
        // All items match the mode, unless their id is listed in the exceptions array.
        // For that reason, an item is only open if it matches either case:
        //   - mode is open and the id is NOT listed in the exceptions array
        //   - mode is closed and the id IS listed in the exceptions array
        if (this.nesting() &&
            this.type === 'openclose' &&
            !((_a = this.nestingData[index]) === null || _a === void 0 ? void 0 : _a.hasChildren)) {
            // openclose type in nested mode will always return false for elements that do not have children
            // because those elements cannot be opened or closed.
            return false;
        }
        else if (
        // In 'open' mode, an item is open if its index is not an exception and either `bypassDisabledList` is true or its index is not in the `disabledList`.
        // In 'close' mode, an item is open if its index is an exception and either `bypassDisabledList` is true or its index is not in the `disabledList`.
        // If either condition is met, the function will return true, indicating that the item is open.
        (this.mode === 'open' &&
            !this.exceptions.some((exception) => exception.index === index) &&
            (this.bypassDisabledList ||
                !this.disabledIndicesList.includes(index))) ||
            (this.mode === 'close' &&
                this.exceptions.some((exception) => exception.index === index) &&
                (this.bypassDisabledList || !this.disabledIndicesList.includes(index)))) {
            return true;
        }
        return false;
    }
    lastOpen() {
        return this.lastIndex;
    }
    // Check the status of all items
    status() {
        if (this.search && this.type === 'check') {
            if (this.mode === 'close' &&
                this.idList.length > 0 &&
                this.exceptions.length === this.idList.length) {
                return 'open';
            }
            else {
                if (this.exceptions.length) {
                    return !this.bypassDisabledList &&
                        this.disabledIndicesList.length <= 0
                        ? 'mix'
                        : 'mix-disabled';
                }
                return this.mode;
            }
        }
        else {
            if (this.exceptions.length) {
                return !this.bypassDisabledList && this.disabledIndicesList.length <= 0
                    ? 'mix'
                    : 'mix-disabled';
            }
            return this.mode;
        }
    }
    getDisabledList() {
        return this.disabledIndicesList;
    }
    openAll() {
        this.mode = 'open';
        this.exceptions = [];
        // update the mode for all unseen list items to match the new mode
        this.unseenListItems = this.unseenListItems.map((unseenListItem) => (Object.assign(Object.assign({}, unseenListItem), { mode: this.mode })));
        if (!this.search) {
            this.lostExceptions = [];
        }
        return this;
    }
    closeAll() {
        this.mode = 'close';
        this.exceptions = [];
        // update the mode for all unseen list items to match the new mode
        this.unseenListItems = this.unseenListItems.map((unseenListItem) => (Object.assign(Object.assign({}, unseenListItem), { mode: this.mode })));
        if (!this.search) {
            this.lostExceptions = [];
        }
        return this;
    }
    // Toggle the status of a single item
    toggle(index) {
        if (this.isOpen(index)) {
            // If we are open and the mode is open, we need to close by
            // adding this id to our list of exceptions.
            if (this.mode === 'open') {
                this.exceptions.push({
                    index,
                    generation: this.getRowGeneration(index)
                });
            }
            else {
                // This means the mode is close, and this id is currently
                // in the list of exceptions so we need to remove it.
                this.exceptions = this.exceptions.filter((exception) => exception.index !== index);
            }
        }
        else {
            // This id is currently closed
            if (this.mode === 'open') {
                // If we are trying to open and the mode is open, then remove this
                // id from the list of exceptions.
                this.exceptions = this.exceptions.filter((exception) => exception.index !== index);
            }
            else {
                // If mode is closed, but we are trying to open, then add this id
                // to the list of exceptions.
                this.exceptions.push({
                    index,
                    generation: this.getRowGeneration(index)
                });
            }
        }
        this.lastIndex = index;
        // check if we've reached "everything is open or closed" state
        // if normal list - every item is expanded.
        // if nested list - every parent and child with children is expanded.
        if ((!this.search &&
            this.idList.length > 0 &&
            this.idList.length === this.exceptions.length) ||
            (this.nesting() &&
                this.type === 'openclose' && //this only applies to nested open/close caches, not check/unchecked cache
                this.nestingData.filter((p) => p.parentIds.length < 2 && p.hasChildren)
                    .length === this.exceptions.length)) {
            if (this.mode === 'open') {
                return this.closeAll();
            }
            else {
                return this.openAll();
            }
        }
        return this;
    }
    // Toggle the state of an item align all of its children to the new state.
    // returns an array of indexes that were changed.
    toggleFamily(parentIndex) {
        var _a, _b, _c, _d, _e;
        // If the parent is in the disabled list, don't toggle it or its descendants
        if (this.disabledIndicesList.includes(parentIndex) &&
            !this.bypassDisabledList) {
            return [];
        }
        const parentId = this.idList[parentIndex];
        const changed = [];
        this.toggle(parentIndex);
        changed.push(parentIndex);
        // only do something if nesting data provided.
        if (!this.nesting()) {
            return changed;
        }
        const open = this.isOpen(parentIndex);
        if (this.type === 'check') {
            // toggle all children and grandchildren
            this.nestingData
                .map((i, idx) => {
                return Object.assign({ idx }, i);
            })
                .filter(
            // get only the children of this parent
            (i) => i.parentIds.includes(parentId))
                .forEach((i) => {
                // If the child is in the disabled list, don't toggle it
                if (this.disabledIndicesList.includes(i.idx) &&
                    !this.bypassDisabledList) {
                    return;
                }
                if ((open && !this.isOpen(i.idx)) || (!open && this.isOpen(i.idx))) {
                    if (i.hasChildren) {
                        this.toggleFamily(i.idx).forEach((modified) => !changed.includes(modified) && changed.push(modified));
                    }
                    else {
                        this.toggle(i.idx);
                        if (!changed.includes(i.idx))
                            changed.push(i.idx);
                    }
                }
            });
            // check if the parent had children which are not in the id list
            // these should be toggled too, but put on the lost items list directly.
            if (((_b = (_a = this.nestingData[parentIndex]) === null || _a === void 0 ? void 0 : _a.childIds.length) !== null && _b !== void 0 ? _b : -1) > 0) {
                (_c = this.nestingData[parentIndex]) === null || _c === void 0 ? void 0 : _c.childIds.forEach((c) => {
                    if (!this.idList.includes(c)) {
                        if (
                        // TIL there is no logical XOR in JS
                        ((open && this.mode === 'close') ||
                            (!open && this.mode !== 'close')) &&
                            !this.lostExceptions.some((exception) => exception.id === c)) {
                            // adding to the exception list
                            this.lostExceptions.push({
                                id: c,
                                generation: this.getRowGeneration(this.idList.indexOf(c))
                            });
                        }
                        else if (((!open && this.mode === 'close') ||
                            (open && this.mode !== 'close')) &&
                            this.lostExceptions.some((exception) => exception.id === c)) {
                            this.lostExceptions = this.lostExceptions.filter((l) => l.id !== c);
                        }
                    }
                });
            }
            if (((_e = (_d = this.nestingData[parentIndex]) === null || _d === void 0 ? void 0 : _d.parentIds.length) !== null && _e !== void 0 ? _e : -1) > 0) {
                // determine if parent rows for the checked item are now out of sync
                // internally.  checked/mix count as "checked" for parent items.
                this.nestingData[parentIndex].parentIds.forEach((pid) => {
                    const pidx = this.idList.indexOf(pid);
                    if ((this.getNestedOpenStatus(pidx) === 'close' && this.isOpen(pidx)) ||
                        (this.getNestedOpenStatus(pidx) !== 'close' && !this.isOpen(pidx))) {
                        this.toggle(pidx);
                        if (!changed.includes(pidx))
                            changed.push(pidx);
                    }
                });
            }
        }
        else {
            // 'open/close' mode doesn't have a status for grandchild items
            this.nestingData
                .map((i, idx) => {
                return Object.assign({ idx }, i);
            })
                .filter(
            // get only the children that can be toggled, not grandchildren
            (i) => i.parentIds.includes(parentId) &&
                i.parentIds.length < 2 &&
                i.hasChildren)
                .forEach((i) => {
                if ((open && !this.isOpen(i.idx)) || (!open && this.isOpen(i.idx))) {
                    this.toggle(i.idx);
                    if (!changed.includes(i.idx))
                        changed.push(i.idx);
                }
            });
        }
        this.lastIndex = parentIndex;
        return changed;
    }
    toggleGroup(clickedIndex) {
        const last = this.lastIndex;
        const changed = [];
        const clickedOpen = this.isOpen(clickedIndex);
        if (last === -1) {
            this.toggle(clickedIndex);
            changed.push(clickedIndex);
        }
        else {
            // if a child element was clicked, we don't want to toggle
            // its parents directly, since that'd just toggle all those
            // children of those parents.  Skip 'em.
            const skippers = (this.nesting() &&
                this.nestingData[clickedIndex].parentIds.map((pid) => this.idList.indexOf(pid))) ||
                [];
            if (last < clickedIndex) {
                for (let i = last; i <= clickedIndex; i++) {
                    if (this.isOpen(i) === clickedOpen && !skippers.includes(i)) {
                        this.toggleFamily(i).forEach((modified) => !changed.includes(modified) && changed.push(modified));
                    }
                }
            }
            else {
                for (let i = last; i >= clickedIndex; i--) {
                    if (this.isOpen(i) === clickedOpen && !skippers.includes(i)) {
                        this.toggleFamily(i).forEach((modified) => !changed.includes(modified) && changed.push(modified));
                    }
                }
            }
        }
        return changed;
    }
    // sets the open state for all parents, if they have children.
    // might seem similar to toggle all - use this when some
    // items are hidden - e.g. searching.  This won't trigger the
    // status of any parents that have no children shown.
    openParents() {
        if (this.nesting())
            this.nestingData
                .filter((c) => c.parentIds.length > 0)
                .forEach((c) => {
                c.parentIds.forEach((p) => {
                    const parentIndex = this.idList.indexOf(p);
                    if (!this.isOpen(parentIndex)) {
                        this.toggle(parentIndex);
                    }
                });
            });
        return this;
    }
    // Toggle status of all items.  Returns indexes of items modified.
    toggleAll() {
        let changed = [];
        if (this.status() === 'mix' || this.status() === 'close') {
            if (this.search && this.idList.length > 0) {
                // we're in search mode, so we can't toggle everything
                this.idList.forEach((_, idx) => {
                    if (!this.isOpen(idx))
                        this.toggleFamily(idx).forEach((modified) => !changed.includes(modified) && changed.push(modified));
                });
            }
            else {
                // we have the whole list - get the list of items we're gonna modify
                changed = [...Array(this.idList.length).keys()].filter((i) => {
                    const exceptionExistsInIdList = this.exceptions.some((exception) => exception.index === i);
                    // In 'open' mode, 'changed' contains items found in the exceptions list.
                    // In 'close' mode, 'changed' contains items not found in the exceptions list.
                    return (((this.mode === 'open' && exceptionExistsInIdList) ||
                        (this.mode === 'close' && !exceptionExistsInIdList)) &&
                        (this.bypassDisabledList || !this.disabledIndicesList.includes(i)));
                });
                if (this.disabledIndicesList.length > 0 && !this.bypassDisabledList) {
                    changed.forEach((idx) => {
                        // We need to only toggleFamily if the idx is a parent row
                        // otherwise we're toggling the children twice:
                        // Once here and then again when we get into the toggleFamily function.
                        if (this.nestingData.length > 0 &&
                            !this.nestingData[idx].hasChildren) {
                            this.toggleFamily(idx).forEach((c) => !changed.includes(c) && changed.push(c));
                        }
                        else {
                            this.toggle(idx);
                        }
                    });
                }
                else {
                    this.openAll();
                }
            }
        }
        else {
            if (this.search && this.idList.length > 0) {
                // we're in search mode, so we can't toggle everything
                this.idList.forEach((_, idx) => {
                    if (this.isOpen(idx))
                        this.toggleFamily(idx).forEach((modified) => !changed.includes(modified) && changed.push(modified));
                });
            }
            else {
                // we have the whole list - get the list of items we're gonna modify
                changed = [...Array(this.idList.length).keys()].filter((i) => !this.exceptions.some((exception) => exception.index === i));
                this.closeAll();
            }
        }
        this.lastIndex = -1;
        return changed;
    }
    hiddenExceptionIds() {
        if (!this.generation) {
            return this.lostExceptions.map((exception) => exception.id);
        }
        return this.lostExceptions
            .filter((exception) => exception.generation === this.generation)
            .map((exception) => exception.id);
    }
    toggleUnseenRow(id) {
        // If the unseen item is not in the list, add it with the opposite mode
        if (!this.unseenListItems.some((listItem) => listItem.id === id)) {
            this.unseenListItems.push({
                id,
                mode: this.mode === 'open' ? 'close' : 'open'
            });
        }
        else {
            this.unseenListItems = this.unseenListItems.map((unseenListItem) => {
                // If the unseen item is in the list, flip the mode
                if (unseenListItem.id === id) {
                    return {
                        id,
                        mode: unseenListItem.mode === 'open' ? 'close' : 'open'
                    };
                }
                return unseenListItem;
            });
        }
    }
    setIdListWithGeneration() {
        // If there is no generation (aka, no row actions), then we don't need to populate this list
        if (!this.generation) {
            return;
        }
        this.idListWithGeneration = this.idList.map((id) => {
            const generation = this.getRowGeneration(this.idList.indexOf(id));
            return { id, generation };
        });
    }
    relevantIdListCount() {
        if (!this.generation) {
            return this.idList.length;
        }
        return this.idListWithGeneration.filter((idInfo) => idInfo.generation === this.generation).length;
    }
    hiddenExceptionCount(total) {
        if (this.mode === 'close') {
            return this.hiddenExceptionIds().length;
        }
        const openTotal = total - this.relevantIdListCount() - this.hiddenExceptionIds().length;
        return openTotal < 0 ? 0 : openTotal;
    }
    getOpenUnseenIds() {
        return this.unseenListItems
            .filter((unseenListItem) => unseenListItem.mode === 'open')
            .map((unseenListItem) => unseenListItem.id);
    }
    // Returns a new instance of the cache. This is needed when the cache
    // is used as React state. A new instance triggers a re-render.
    clone() {
        return new OpenCloseCache(this.mode, this.exceptions);
    }
    /**
     * As of January 22, 2025, this method has not been tested against nested rows and should not be used for nested rows
     * until it is updated to handle that logic.
     */
    purgeRowReferences(ids) {
        // hold onto the old ID list so we can update the exceptions' indices
        const oldIdList = [...this.idList];
        this.lostExceptions = this.lostExceptions.filter((exception) => !ids.includes(exception.id));
        this.unseenListItems = this.unseenListItems.filter((listItem) => !ids.includes(listItem.id));
        this.idList = this.idList.filter((id) => !ids.includes(id));
        this.idListWithGeneration = this.idListWithGeneration.filter((idWithGeneration) => !ids.includes(idWithGeneration.id));
        this.exceptions = this.exceptions
            // remove exceptions that are in the list of IDs to remove
            .filter((exception) => !ids.includes(oldIdList[exception.index]))
            // update the indexes of the exceptions now that our idList has changed
            .map((exception) => (Object.assign(Object.assign({}, exception), { index: this.idList.indexOf(oldIdList[exception.index]) })));
    }
}

/**
 * A predicate function.
 * - Returns `true` if the input array has at least one element.
 * - Returns `false` otherwise.
 * @param array
 * @returns
 */
function isOneOrMore(array) {
    return array.length > 0;
}
const OneOrMoreUtils = {
    isOneOrMore
};

const None = { type: 'none' };
function some(value) {
    return { type: 'some', value };
}
function value(option, defaultValue) {
    return match(option)
        .with({ type: 'none' }, () => defaultValue)
        .with({ type: 'some' }, (some) => some.value)
        .exhaustive();
}
const OptionUtils = {
    some,
    value
};

// Produces a globally unique 36 character identifier (GUID)
// Optional length param allows for shorter guids
/* eslint-disable */
function UUIDv4(length = 36) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    })
        .substring(0, length);
}
function FormatNumber(number, options = {
    maximumDecimals: 2,
    minimumDecimals: 0,
    style: undefined,
    currency: undefined,
    locale: 'en-US'
}) {
    return new Intl.NumberFormat(options.locale, {
        style: options.style,
        currency: options.currency,
        minimumFractionDigits: options.minimumDecimals,
        maximumFractionDigits: options.maximumDecimals
    }).format(number);
}
/**
 * Parse a localized number to a float. This removes all characters except for numbers
 * and converts decimal separator into a period character before parsing as a float
 */
function ToLocaleNumber(stringNumber, locale = 'en') {
    // Blank space can be tricky and needs to be in regex form as \s.
    const separtorRegexToken = (separator) => {
        return separator.trim() === '' ? 's' : separator;
    };
    if (stringNumber === '-') {
        return 0;
    }
    // Detect the decimal separator for this locale.
    const decimalSeparator = Intl.NumberFormat(locale).formatToParts(1.1)[1].value;
    const decimalRegex = separtorRegexToken(decimalSeparator);
    // Remove all characters except for numbers, our decimal separator, and an optional negative sign.
    stringNumber = stringNumber.replace(new RegExp(`[^-?0-9\\${decimalRegex}]`, 'g'), '');
    // Convert decimal separator to period character and parse as a float
    return parseFloat(stringNumber.replace(new RegExp(`\\${decimalRegex}`), '.'));
}
function HasVerticalScrollBars(el) {
    return el.scrollHeight > el.clientHeight;
}
/**
 * Creates a simple mapping between keyboard event key codes, and a handler. Use like this:
     const onKeyDownHandler = (e: React.KeyboardEvent) => {
        KeyHandleMap(e, [
          { Escape: handleEscapeKey },
          { Enter: handleEnterKey },
          { F4: handleF4Key },
        ]);
      };
 * */
function KeyHandleMap(e, hmaps) {
    for (const hmap of hmaps) {
        for (let [key, handler] of Object.entries(hmap)) {
            if (e.key === key) {
                handler(e);
                return true;
            }
        }
    }
    return false;
}
function IsFalseyOrEmpty(value) {
    if (value !== false && value !== 0 && !value) {
        return true;
    }
    if (value.length !== undefined) {
        return value.length < 1;
    }
    if (IsObject(value) && Object.keys(value).length < 1) {
        return true;
    }
    return false;
}
function IsElementTruncated(el) {
    return el.clientWidth < el.scrollWidth;
}
// Lodash's IsObject treats arrays as objects, but we only want
// actual objects to return true here
function IsObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
// Given an extractor, which is either a property name to use to look up the value,
// or a function that will return the value, extract the value and return it.
function ExtractValue(data, extractor) {
    if (typeof extractor === 'string') {
        return data[extractor];
    }
    return extractor(data);
}
// Given a JSX component, replace a child of a certain type with the provided JSX content.
function ReplaceComponentContentsWith(component, content, type) {
    // Keep track if we find our needle
    let found = false;
    function searchChildren(comp) {
        const processChild = (child) => {
            var _a;
            // If the needle has been found we can short circuit our search
            if (found) {
                return child;
            }
            // Check this component
            if (getElementName(child) === type) {
                found = true;
                return React__default.cloneElement(child, child.props, content);
                // If this component is not it, see if we need to search it's children
            }
            else if ((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.children) {
                return searchChildren(child);
                // This component is not it nor does it have any children, we are done
                // with this branch of the tree
            }
            else {
                return child;
            }
        };
        // If we have an array of children process them as an array, if not
        // just process the one single child. This matters for how React
        // generates compnonent's key prop.
        const children = Array.isArray(comp.props.children)
            ? React__default.Children.map(comp.props.children, processChild)
            : processChild(comp.props.children);
        // If we found it update the children content
        if (found) {
            return React__default.cloneElement(comp, comp.props, children);
        }
        return comp;
    }
    if (!component) {
        return null;
    }
    // If our top level component is the one we are looking for, return the replacement
    // conent.
    if (getElementName(component) === type) {
        return React__default.cloneElement(component, component.props, content);
    }
    // If component has no children we are done
    if (!component.props.children) {
        return component;
    }
    // If there are children, we need to search the tree for our needle
    return searchChildren(component);
}
// Given a React.ReactNode (jsx) return the inner text or string the JSX would render.
// This allows you to pass ReactToString(<div>This is a <b>string</b>.</div>) and
// it would return `This is a string.`.
function ReactToString(jsx) {
    const hasProps = (jsx) => Object.prototype.hasOwnProperty.call(jsx, 'props');
    const reduceJsxToString = (previous, current) => previous + ReactToString(current);
    // Empty
    if (jsx === null || typeof jsx === 'boolean' || typeof jsx === 'undefined') {
        return '';
    }
    // Numeric children.
    if (typeof jsx === 'number') {
        return jsx.toString();
    }
    // String literals.
    if (typeof jsx === 'string') {
        return jsx;
    }
    // Array of JSX.
    if (Array.isArray(jsx)) {
        return jsx.reduce(reduceJsxToString, '');
    }
    // Children prop.
    if (hasProps(jsx) &&
        Object.prototype.hasOwnProperty.call(jsx.props, 'children')) {
        return ReactToString(jsx.props.children);
    }
    // Default
    return '';
}
// React events don't let you return false to stop both default behavior and
// stop propagation. You have to call both methods separately if you want to do
// that.
function CancelReactEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function CancelNativeEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
// If the focus is outside the list of els, fire the callback
function OnFocusOutside(e, els, callback) {
    if (e.relatedTarget && els.length > 0) {
        for (const el of els) {
            if (el && el.contains(e.relatedTarget)) {
                return;
            }
        }
    }
    callback();
}
// Given a subjectElement, is it one of the passed in elements or one of it's children?
function ElementIsOrChildOf(subjectEl, els) {
    if (subjectEl && els.length > 0) {
        for (const el of els) {
            if (el && el.contains(subjectEl)) {
                return true;
            }
        }
    }
    return false;
}
// Utility function to handle getting the next or prev indexes in an array with
// the bookend approach (first index can't go prev, and last can't go next)
function BookEndArray(arr, currIndex) {
    const next = () => {
        // If we are at the end of the array, use current element.
        if (currIndex === arr.length - 1) {
            return arr[currIndex];
        }
        return arr[currIndex + 1];
    };
    const prev = () => {
        // If we are at the start, use current element
        if (currIndex === 0) {
            return arr[currIndex];
        }
        return arr[currIndex - 1];
    };
    return { next, prev };
}
function ScrollIntoView(el) {
    el &&
        el.scrollIntoView({
            block: 'nearest'
        });
}
// Every browser / OS combination can have a different scrollbar width.
// We want to calculate this once, and pass it to our components through a
// context. To calculate this we create a div with a scrollbar calculate
// the scrollbar's width and return it.
function GetBrowsersScrollbarWidth() {
    const div = document.createElement('div');
    // Added the 'ads-theme' class to the <div> to apply styles related to the scrollbar.
    // Without this change, the width calculation is inaccurate as it doesn't account for style changes in 'ads-theme'.
    div.classList.add('ads-theme');
    let width = 0;
    div.innerHTML =
        '<div style="width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;"><div style="width:1px;height:100px;"></div></div>';
    const childDiv = div.firstChild;
    document.body.appendChild(div);
    if (childDiv) {
        width = childDiv.offsetWidth - childDiv.clientWidth;
    }
    document.body.removeChild(div);
    return width;
}
function SyntaxHighlightJS(js, classNames) {
    let json = JSON.stringify(js, null, 2);
    json = json
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = classNames.number;
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = classNames.key;
            }
            else {
                cls = classNames.string;
            }
        }
        else if (/true|false/.test(match)) {
            cls = classNames.boolean;
        }
        else if (/null/.test(match)) {
            cls = classNames.null;
        }
        return '<span class="' + cls + '">' + match + '</span>';
    });
}
function isNil(value) {
    return value === null || value === undefined;
}
function BindStyles(styles) {
    return classnames.bind(styles);
}
function BindStylesV2(styles) {
    const cx = classnames.bind(styles);
    return function v2(locals = null, globals = null) {
        const globalClasses = globals ? classnames(...globals) : '';
        const localClasses = locals ? cx(...locals) : '';
        return [globalClasses, localClasses].join(' ').trim() || undefined;
    };
}
function ADSError(msg, data = '') {
    console.error(`ADS Error: ${msg}`, data);
}
function ADSWarn(msg, data = '') {
    console.warn(`ADS warn: ${msg}`, data);
}
// Like the native Array.fill(number) except will use values
// from the passed in array, and can start from the startIndex.
function ArrayFillFrom(arr, startIndex, length) {
    const result = new Array(length).fill(undefined);
    for (let i = startIndex; i < Math.min(startIndex + arr.length, length); i++) {
        for (let j in arr) {
            if (i < length) {
                result[i] = arr[j];
                i++;
            }
        }
    }
    return result;
}
function ArrayConcatAt(arr, mergeArr, start) {
    for (const index in mergeArr) {
        arr[start] = mergeArr[index];
        start += 1;
    }
    return arr;
}
function ArrayNestedConcat(arr, length) {
    const result = new Array(length).fill(undefined);
    let resultIndex = 0;
    for (let i = 0; i < length; i++) {
        const pageItem = arr.filter((r) => { var _a; return ((_a = r === null || r === void 0 ? void 0 : r.pageIndex) !== null && _a !== void 0 ? _a : -1) === i; });
        if (pageItem.length > 0) {
            result.splice(resultIndex, 1, ...pageItem);
            resultIndex += pageItem.length;
        }
        else
            resultIndex++;
    }
    const fixedIndexes = result.map((r, index) => {
        return { index, data: r };
    });
    return fixedIndexes;
}
function MergeRefs(refs) {
    return (value) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        });
    };
}
// Utility function to get all focusable children of the passed in element.
function GetAllFocusableElements(parentEl) {
    if (!parentEl) {
        return [];
    }
    // We are looking for all focusable elements. A focusable element is an input
    // field or element with a positive tabIndex that isn't disabled
    return Array.from(parentEl.querySelectorAll(`button:not([disabled]),
      [href],
      input:not([disabled]),
      select:not([disabled]),
      textarea:not([disabled]),
      [tabindex]:not([tabindex="-1"]):not([disabled]),
      details:not([disabled]),
      summary:not(:disabled)`));
}
function IsISODateString(val) {
    return /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/.test(val);
}
function AddTimezoneOffset(date) {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}
function SubtractTimezoneOffset(date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}
function FormatFileSize(n) {
    const k = n > 0 ? Math.floor(Math.log2(n) / 10) : 0;
    const rank = (k > 0 ? 'KMGT'[k - 1] : '') + 'B';
    const count = Math.floor(n / Math.pow(1024, k));
    return {
        full: `${count} ${rank}`,
        count: count.toString(),
        rank: rank
    };
}
const isTextOrSpan = (child) => {
    return (typeof child === 'string' ||
        (React__default.isValidElement(child) && child.type === 'span'));
};
/**
 * Takes an {@link HTMLElement} and a {@link AdsComponentType} to determine if an element is a specific ADS component type.
 */
function IsAdsComponent(targetElement, type) {
    return targetElement.getAttribute('data-ads-component-type') === type;
}
/**
 * Returns the icon name for the given file name.
 * @param fileName The name of the file
 *
 * Example: GetFileIcon('example.doc') will return 'DocumentWordIcon'
 */
function GetFileIcon(fileName) {
    var _a;
    const extension = ((_a = fileName.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'default';
    switch (extension) {
        case 'doc':
        case 'docx':
        case 'docm':
            return 'DocumentWordIcon';
        case 'xls':
        case 'xlsx':
            return 'DocumentExcelIcon';
        case 'pdf':
            return 'DocumentPDFIcon';
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'raw':
        case 'svg':
        case 'tiff':
            return 'DocumentImageIcon';
        case 'eml':
        case 'emlx':
        case 'msg':
            return 'DocumentEmailIcon';
        default:
            return 'DocumentAnyIcon';
    }
}
/**
 * Returns the last word of the {@link input} string with any ending blank-space
 * characters removed.
 *
 * @param input
 * @returns an {@link Option} that possibly contains the last word
 */
function trySplitLastWord(input) {
    if (!input || !input.trim()) {
        return None;
    } // asserted: input is not empty
    const tail = input
        // remove trailing whitespace
        .trimEnd()
        // split by whitespace
        .split(' ')
        // take the last word
        .at(-1);
    // handle unexpected error
    if (!tail) {
        ADSError(`Unknown failure trying to split the last word of a non-empty string: "${input}"`);
        return None;
    } // asserted: tail exists
    const tailIndex = input.lastIndexOf(tail);
    const head = input.slice(0, tailIndex);
    return OptionUtils.some([head, tail]);
}
/**
 * Returns at most the last {@link n}-characters word(s) of the {@link input} string
 * without removing any ending blank-space characters.
 *
 * **If {@link n} characters cannot be split from the {@link input} string, then the
 * greatest possible number of characters will be returned in the split `head`,**
 * which can leave the `tail` empty (`''`).
 *
 * @param input
 * @param n
 * @returns an {@link Option} that possibly contains the last {@link n} word(s)
 */
function trySplitLastWordsOfNLengthOrGreater(input, n) {
    var _a, _b;
    if (!input || !input.trim()) {
        return None;
    } // asserted: input is not empty
    if (n < 0 || !isFinite$1(n)) {
        return None;
    } // asserted: n is non-negative & finite
    // case: we cannot split all n characters from the input, so split the most that we can
    if (n >= input.trim().length) {
        return OptionUtils.some([
            // any starting blank space
            (_b = (_a = input.match(/^\s*/)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '',
            // the rest of the input including any ending blank space
            input
        ]);
    } // asserted: we can split n characters from the input
    let head = input;
    let tail = '';
    while (tail.length < n) {
        const opt = trySplitLastWord(head);
        // - for debugging -
        // console.log('opt.type', opt.type);
        if (opt.type === 'none') {
            return None;
        } // asserted: opt is some
        // - for debugging -
        // console.group('in loop');
        // console.log('head', head);
        // console.log('tail', tail);
        // console.log('opt.value', opt.value);
        // console.groupEnd();
        const [_head, newTailWord] = opt.value;
        tail = input.slice(head.lastIndexOf(newTailWord));
        head = _head;
    }
    // - for debugging -
    // console.log('final head', head);
    // console.log('final tail', tail);
    return OptionUtils.some([head, tail]);
}
/**
 * Example:
 * input =>  padArray<number | string>([1, 2, 3, 4], 6, 'foo')
 * output => [1, 2, 3, 4, 'foo', 'foo']
 *
 * @param array The array of items of type T
 * @param length The desired length of the array
 * @param fillValue The value of type T to fill each padded item
 * @returns
 */
function padArray(array, length = 1, fillValue) {
    if (array.length >= length)
        return array;
    const newArray = [...array]; // Create copy
    newArray.length = length;
    return newArray.fill(fillValue, array.length);
}
/**
 * Example:
 * input => getDatasetTotals([{ id: 1, children: [{ id: 11, children: [{id: 111}]}] }, { id: 2, children: [] }, { id: 3, children: [] }])
 * output => { parentTotal: 3, childTotal: 2, grandchildTotal: 1, total: 6 }
 *
 * @param items The array of items to calculate the totals for
 * @returns The dataset totals object containing the parent, child, grandchild, and total counts
 */
function getDatasetTotals(items) {
    var _a, _b, _c;
    const parentTotal = items.length;
    let childTotal = 0;
    let grandchildTotal = 0;
    for (const item of items !== null && items !== void 0 ? items : []) {
        const children = (_a = item === null || item === void 0 ? void 0 : item.children) !== null && _a !== void 0 ? _a : [];
        childTotal += children.length;
        for (const child of children) {
            grandchildTotal += (_c = (_b = child === null || child === void 0 ? void 0 : child.children) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        }
    }
    return {
        parentTotal,
        childTotal,
        grandchildTotal,
        total: parentTotal + childTotal + grandchildTotal
    };
}

/* eslint-disable react/display-name */
// HOC that will return either the uncontrolled comp or controlled one based on if
// the value prop has a value or not.
const withStandAlone = (UnControlledComp, ControlledComp) => (props) => {
    return props.onChange === undefined ? (React__default.createElement(UnControlledComp, Object.assign({}, props))) : (React__default.createElement(ControlledComp, Object.assign({}, props)));
};
const withStandAloneGeneric = (UnControlledComp, ControlledComp, propName) => (props) => {
    return props[propName] === undefined ? (React__default.createElement(UnControlledComp, Object.assign({}, props))) : (React__default.createElement(ControlledComp, Object.assign({}, props)));
};

/**
 * Returns the {@link Size} of the input {@link el} element.
 *
 * @deprecated Use {@link useSizeV2} instead. This function incorrectly would wait to
 * set the initial size by {@link wait} milliseconds due to its debouncing logic,
 * causing needlessly wasted renders to occur where the {@link Size} is not yet set for
 * an element that now exists.
 *
 * @param el
 * @param wait
 * @returns
 */
function useSize(el, wait = 30) {
    const [size, _setSize] = useDebounce({ width: null, height: null }, wait);
    const setSize = React__default.useCallback((el) => {
        _setSize((s) => {
            // Only update if there is a difference
            if (s.height !== (el === null || el === void 0 ? void 0 : el.offsetHeight) || s.width !== (el === null || el === void 0 ? void 0 : el.offsetWidth)) {
                return {
                    width: el ? el.offsetWidth : null,
                    height: el ? el.offsetHeight : null
                };
            }
            return s;
        });
    }, [_setSize]);
    React__default.useLayoutEffect(() => {
        setSize(el);
    }, [el, setSize]);
    useResizeObserver$1(el, (entry) => 
    // 💀 dangerous code: entry.target is Element (which equates to {}). This cast gives us access to additional properties.
    setSize(entry.target));
    return size;
}
/**
 * Returns the {@link Size} of the input {@link el} element.
 *
 * @param el
 * @param wait
 * @returns
 */
function useSizeV2(el, wait = 30) {
    const [size, _setSize, setSizeImmediate] = useDebounce({ width: null, height: null }, wait);
    const hasSetImmediatelyRef = React__default.useRef(false);
    const hasValidSizeRef = React__default.useRef(false);
    React__default.useEffect(() => {
        hasValidSizeRef.current = size.width !== null && size.height !== null;
    });
    const setSize = React__default.useCallback(({ height, width }) => {
        if (!hasSetImmediatelyRef.current &&
            !hasValidSizeRef.current &&
            height !== null &&
            width !== null) {
            // console.log('set size immediately:', height, width); // debugging
            setSizeImmediate(() => ({ height, width }));
            hasSetImmediatelyRef.current = true;
        }
        _setSize((prev) => {
            // Only update if there is a difference
            if (prev.height !== height || prev.width !== width) {
                // console.log('set size debounced:', height, width, 'prev', prev); // debugging
                return {
                    height: height,
                    width: width
                };
            }
            // console.log("don't set size - value has not changed"); // debugging
            return prev;
        });
    }, [_setSize, setSizeImmediate]);
    React__default.useLayoutEffect(() => {
        var _a, _b;
        // console.log('size change - caused by layout effect');
        setSize({
            height: (_a = el === null || el === void 0 ? void 0 : el.offsetHeight) !== null && _a !== void 0 ? _a : null,
            width: (_b = el === null || el === void 0 ? void 0 : el.offsetWidth) !== null && _b !== void 0 ? _b : null
        });
    }, [el, setSize]);
    useResizeObserver$1(el, (entry) => {
        // console.log('size change - caused by resize-observer hook');
        const element = entry.target;
        /**
         * @remarks
         * Since our input `el` is of type `HTMLElement | null` as of Q1 2025,
         * there is little risk in asserting `element` is an instance of `HTMLElement`.
         */
        if (!(element instanceof HTMLElement)) {
            return;
        }
        const { offsetHeight, offsetWidth } = element;
        setSize({ height: offsetHeight, width: offsetWidth });
    });
    return size;
}

function useTextTruncated(ref) {
    const [isTextTruncated, setTextTruncated] = React__default.useState(false);
    const refSize = useSize(ref === null || ref === void 0 ? void 0 : ref.current);
    React__default.useEffect(() => {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            setTextTruncated(IsElementTruncated(ref.current));
        }
    }, [ref, refSize.width]);
    return isTextTruncated;
}

var css$2k = ".CellText_module_cellText__8b4007a2{overflow:hidden;text-align:left;white-space:nowrap}.CellText_module_cellText__8b4007a2.CellText_module_right__8b4007a2{text-align:right}.CellText_module_cellText__8b4007a2.CellText_module_center__8b4007a2{text-align:center}.CellText_module_cellText__8b4007a2.CellText_module_disabled__8b4007a2{color:#b0b4bf}";
window.ADS.injectStyle(css$2k,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/common/atoms/CellText/CellText.module.scss");
var modules_d1ea6c3f = {"cellText":"CellText_module_cellText__8b4007a2","right":"CellText_module_right__8b4007a2","center":"CellText_module_center__8b4007a2","disabled":"CellText_module_disabled__8b4007a2"};

const cx$1R = BindStyles(modules_d1ea6c3f);
// Two ways this component is used:
//   1. DropdownCell component in the Combobox detects it's rendering just text,
//      it will wrap the text in this component.
//   2. Consuming app provides Combobox cell with JSX and wraps it's text in this component.
const CellText = ({ customDataProps, testId, alignText = 'left', children, disabled = false, tooltip }) => {
    const ref = React__default.useRef(null);
    const isTextTruncated = useTextTruncated(ref);
    // When we detect text is getting truncated and when CSS applies, seems to be slightly
    // off. So when we detect scrollWidth is greater than clientWidth, we also apply
    // the ellipsis truncated CSS prop so both JS and CSS are in sync on when text is getting the ellipsis.
    const style = isTextTruncated ? { textOverflow: 'ellipsis' } : {};
    const renderContent = () => {
        // If tooltip prop is provided, override the default tooltip behavior
        // and render the tooltip directly
        if (tooltip) {
            return (
            // Passing 'none' as className to prevent the default className in Tooltip from being applied
            // when no className is explicitly provided in the tooltip props
            React__default.createElement(Tooltip, Object.assign({ className: "none" }, tooltip, { followCursor: "horizontal" }),
                React__default.createElement(React__default.Fragment, null, children)));
        }
        // If text is truncated, wrap with TooltipCell
        if (isTextTruncated) {
            return React__default.createElement(TooltipCell, null, children);
        }
        // Otherwise, just render children directly
        return children;
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'cell-text', "data-truncated": isTextTruncated, ref: ref, className: cx$1R('cellText', alignText, { disabled }), style: style }), renderContent()));
};
const TooltipCell = ({ children }) => (React__default.createElement(Tippy
// We should only ever have text, unless this cell is being highlighted, in that
// case we will have some simple markup like a span tag, so we just need to
// get the boiled down string version of any JSX version of children
, { 
    // We should only ever have text, unless this cell is being highlighted, in that
    // case we will have some simple markup like a span tag, so we just need to
    // get the boiled down string version of any JSX version of children
    className: "ads-tippy", content: ReactToString(children), delay: [500, 0], followCursor: "horizontal", plugins: [followCursor] },
    React__default.createElement("span", null, children)));

// Simple utility component that prevents click events from bubbling
const ClickEventBoundary = ({ customDataProps, testId, children, allowPropagate: _allowPropagate = false, allowPropigate = false }) => {
    const allowPropagate = _allowPropagate || allowPropigate;
    if (allowPropagate) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'click-event-boundary', style: { display: 'inline-block' }, onClick: (e) => !allowPropagate && e.stopPropagation() }), children));
};

// Class that handles being given either text string or JSX that contains text.
// This will property handle parsing both situations and exposing a `content` and
// `text` property so we can access both the content to render in the UI, and `text`
// to use for searching and highlighting or tooltip.
class SearchableCell {
    // Getter for content, if we have content serve it back, if not
    // use the text version
    get content() {
        // Render trumps all as we use this slot for when highlighting
        if (this._render) {
            return this._render;
        }
        // If they have given us JSX but we didn't find any text then invoke the function everytime
        // the cells content needs to be rendered so they have full power over cell's content.
        if (this.isJSX && !this.text) {
            return this._contentCreator();
        }
        // Otherwise fallback to the generated content or text
        return this._content || this.text;
    }
    constructor(id, createContent) {
        this.text = '';
        this.id = id;
        this._contentCreator = createContent;
        const content = this._contentCreator();
        // If we detect the cell's content is JSX and not just a string
        // we need to store content for rendering and then create the
        // right `text` version of the cell.
        if (React__default.isValidElement(content)) {
            this.isJSX = true;
            this._content = content;
            // Find the cell text component and use it's text as our text prop.
            const cellText = deepFind(content, (child) => getElementName(child) === CellText.name);
            if (cellText) {
                this.text = ReactToString(cellText);
            }
        }
        else {
            // If we are just a string of content things are simplier
            this.isJSX = false;
            this.text = `${content !== null && content !== void 0 ? content : ''}`;
        }
    }
    // Highlighing is make a new version of our content and sticking it in `_render`.
    // So unlighting is removing that so our original content shines back through.
    unHighlightText() {
        this._render = null;
    }
    // Highlighting is modifying our content to incldue highlighting component.
    highlightText(highlightedText) {
        // If we are a simple text cell just update
        if (!this.isJSX) {
            this._render = highlightedText;
        }
        // If we are dealing with a JSX cell we have to find the CellText component
        // and update it's content.
        else {
            const content = this._content;
            this._render = ReplaceComponentContentsWith(content, highlightedText, CellText.name);
        }
    }
}

var css$2j = "@keyframes SkeletonLoader_module_load__82e93a31{0%{left:-100%}to{left:100%}}.SkeletonLoader_module_skeleton__82e93a31{background-color:#f5f5f7;border-radius:3px;height:100%;overflow:hidden;position:relative;width:100%}.SkeletonLoader_module_skeleton__82e93a31:before{animation:SkeletonLoader_module_load__82e93a31 1.75s cubic-bezier(.4,0,.2,1) infinite;background:linear-gradient(90deg,#0000 0,#fffc 45%,#fffc 55%,#0000);content:\"\";display:block;height:100%;left:-100%;position:absolute;top:0;transform:translateZ(0);width:100%;will-change:transform}";
window.ADS.injectStyle(css$2j,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/common/atoms/SkeletonLoader/SkeletonLoader.module.scss");
var modules_b819045f = {"skeleton":"SkeletonLoader_module_skeleton__82e93a31","load":"SkeletonLoader_module_load__82e93a31"};

const cx$1Q = BindStyles(modules_b819045f);
const SkeletonLoader = ({ height = 32, className, testId }) => {
    const styles = { height };
    return (React__default.createElement("div", { className: cx$1Q('skeleton', className), style: styles, "data-test": testId }));
};

const Stripe = ({ color = '#1db3e7', height = 6 }) => {
    const styles = { height, background: color };
    return React__default.createElement("div", { style: styles });
};

/**
 * Global context set on the `<Theme>` component.
 */
const ADSContext = React__default.createContext(undefined);
const AccordionContext = React__default.createContext(undefined);
const SectionContext = React__default.createContext(undefined);

/**
 * Will log an ADS message to the console exactly once.
 * @param level - determines the log type
 * @param message
 * @param condition - an optional condition that narrows when the error is logged
 */
function useADSConsoleOnce(message, level, condition = true) {
    const hasOutputOnceRef = React__default.useRef(false);
    React__default.useEffect(() => {
        if (condition === false || hasOutputOnceRef.current)
            return;
        hasOutputOnceRef.current = true;
        switch (level) {
            case 'error':
                ADSError(message);
                break;
            case 'warn':
                ADSWarn(message);
                break;
        }
    }, [message, condition, level]);
}

/**
 * Will log an ADS error exactly once.
 * @param message
 * @param condition - an optional condition that narrows when the error is logged
 */
function useADSErrorOnce(message, condition = true) {
    useADSConsoleOnce(message, 'error', condition);
}

/**
 * Will log an ADS warning exactly once.
 * @param message
 * @param condition - an optional condition that narrows when the warning is logged
 */
function useADSWarnOnce(message, condition = true) {
    useADSConsoleOnce(message, 'warn', condition);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// Handles getting text from a column by using cellRender (which can return JSX)
// or the legacy toValue
function CellTextExtractor(column) {
    var _a;
    if (column.cellRenderer) {
        return (data) => {
            var _a;
            const content = ExtractValue(data, (_a = column.cellRenderer) !== null && _a !== void 0 ? _a : '');
            if (React__default.isValidElement(content)) {
                // If we are JSX we need to extract the label from our CellText
                const cellText = deepFind(content, (child) => getElementName(child) === CellText.name);
                return ReactToString(cellText);
            }
            return content;
        };
    }
    return (_a = column.toValue) !== null && _a !== void 0 ? _a : undefined;
}
function processColumns(columns) {
    var _a, _b;
    // When we search, we need a key for every column.
    const searchKeys = [];
    columns.forEach((_column, i) => {
        searchKeys.push(`data.cells.${i}.text`);
    });
    // Find the column marked as the label column. If none exists default to the
    // first column.
    const labelColumn = (() => {
        const labelColumn = columns.find((c) => c.isLabel);
        return labelColumn !== null && labelColumn !== void 0 ? labelColumn : columns[0];
    })();
    const labelExtractor = (_b = (_a = labelColumn.toLabel) !== null && _a !== void 0 ? _a : CellTextExtractor(labelColumn)) !== null && _b !== void 0 ? _b : labelColumn.name;
    // Return our column config object.
    return {
        mode: columns.length < 2 ? ColumnMode.Single : ColumnMode.Multi,
        columns,
        labelColumn,
        labelExtractor,
        searchKeys
    };
}
// We default to single column setup.
const columnDefault = [
    { title: '', name: '', toValue: (data) => data, index: 0 }
];
function useColumns(columns = columnDefault) {
    return React__default.useMemo(() => processColumns(columns), [columns]);
}

const getTotalsAndType = (total = 0) => {
    return match(total)
        .returnType()
        .with(P.number, (total) => ({
        type: 'number',
        totals: {
            parentTotal: total,
            childTotal: 0,
            grandchildTotal: 0,
            total
        },
        total
    }))
        .otherwise((totals) => ({
        type: 'record',
        totals,
        total: totals.total
    }));
};
const calculateDatasetTotals = (nested, nestedTotals, searchTotal) => {
    return nested.enabled && (nestedTotals === null || nestedTotals === void 0 ? void 0 : nestedTotals.length)
        ? {
            total: nestedTotals[0] + nestedTotals[1] + nestedTotals[2],
            parentTotal: nestedTotals[0],
            childTotal: nestedTotals[1],
            grandchildTotal: nestedTotals[2]
        }
        : {
            total: searchTotal || 0,
            parentTotal: searchTotal || 0,
            childTotal: 0,
            grandchildTotal: 0
        };
};

/* eslint-disable @typescript-eslint/no-explicit-any */
function convertDataToRows(data, startIndex, itemToData = (item) => item //note, this defaults to a no-op function
) {
    return data.map((i, index) => {
        return {
            index: index + startIndex,
            data: itemToData(i, index)
        };
    });
}
function validatePagination(numItems, page) {
    const { start, end, total, datasetTotal } = page;
    const datasetTotalsType = getTotalsAndType(datasetTotal); // This gets the type of the datasetTotal
    let failureReason = null;
    if (!isFinite$1(start)) {
        // Ensure start is a number, excluding +/- Infinity and NaN
        failureReason = 'Pagination start is not a finite primitive number';
    }
    else if (!isFinite$1(total)) {
        // Ensure total is a number, excluding +/- Infinity and NaN
        failureReason = 'Pagination total is not a finite primitive number';
    }
    else if (!isFinite$1(end)) {
        // Ensure end is a number, excluding +/- Infinity and NaN
        failureReason = 'Pagination end is not a finite primitive number';
    }
    else if (start < 0) {
        failureReason = 'Pagination start is a negative number';
    }
    else if (end < 0) {
        failureReason = 'Pagination end is a negative number';
    }
    else if (total < 0) {
        failureReason = 'Pagination total is a negative number';
    }
    else if (end > 0 && start > end) {
        failureReason = 'Pagination start is greater than pagination end';
    }
    else if (total > 0 && start > total) {
        failureReason = 'Pagination start is greater than pagination total';
    }
    else if (total > 0 && end > total) {
        failureReason = 'Pagination end is greater than pagination total';
    }
    else if (numItems > total) {
        failureReason = 'The number of items is greater than the pagination total';
    }
    else if (end - start !== numItems) {
        failureReason =
            'The difference between pagination end and pagination start is not equal to the number of items provided';
    }
    else if (total > 0 && numItems <= 0) {
        // Number of items should be greater than zero when
        // total is greater than zero
        failureReason =
            'Pagination total is positive but the number of items is either zero or negative';
    }
    else if (datasetTotal && datasetTotalsType.totals.total < total) {
        failureReason = 'The datasetTotal is less than the total pagination total';
    }
    return failureReason;
}
// Hook that centralizes the logic of working with a dataSource. Must be
// passed a dataSource and a convertDataToRows function, it will return rows
// and a getData function.
function useDataSource(dataSource, pageLevel = -1, itemToData // This allows consumer to control how the data field of each row item
) {
    const [rowState, setRowState] = React__default.useState({
        rows: undefined,
        rowsLastChanged: null
    });
    const setRowStateWrapper = React__default.useCallback((value) => {
        setRowState((prev) => ({
            rows: typeof value === 'function' ? value(prev.rows) : value,
            rowsLastChanged: Date.now()
        }));
    }, []);
    const [lastPagination, setLastPagination] = React__default.useState(null);
    const mapDataRows = React__default.useCallback((transform) => {
        setRowState((previous) => {
            var _a;
            return {
                rows: (_a = previous.rows) === null || _a === void 0 ? void 0 : _a.map((v, i, a) => transform(v, i, a)),
                rowsLastChanged: Date.now()
            };
        });
    }, []);
    // This function handles the data once it's passed back to us
    const handleReturnedData = React__default.useCallback((items, pagination, merge) => {
        var _a;
        // We have had a hard time debugging issues when a consumer uses a dataSource and the pagination data they returned is not
        // valid. These are some preflight checks to catch those cases earlier / quicker.
        let itemCount = (_a = items === null || items === void 0 ? void 0 : items.length) !== null && _a !== void 0 ? _a : 0;
        if (pageLevel > -1 && items) {
            itemCount = items.filter((i) => { var _a, _b; return ((_b = (_a = i.parents) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : -1) === pageLevel; }).length;
        }
        const failureReason = validatePagination(itemCount, pagination);
        if (failureReason) {
            ADSError(failureReason, pagination);
            return;
        }
        setLastPagination(pagination);
        setRowStateWrapper((rows) => {
            var _a, _b;
            if (!items) {
                return undefined;
            }
            // If this is the first page of data, then we need to make sure we create
            // the full array of data. We also need to handle the case where we are given a
            // fewer number of items than we had rows. If this happens we have been given fresh data
            // and need to not merge.
            if (!merge ||
                (pageLevel === -1 && pagination.total < ((_a = rows === null || rows === void 0 ? void 0 : rows.length) !== null && _a !== void 0 ? _a : 0)) ||
                pagination.newData) {
                if (pageLevel === -1) {
                    return convertDataToRows(ArrayFillFrom(items, pagination.start, pagination.total), 0, itemToData);
                }
                else {
                    return ArrayNestedConcat(convertDataToRows(items, pagination.start, itemToData).map((r) => r.data), pagination.total);
                }
            }
            // If not the first page, then we just merge in the data at the right index
            // We use the spread operator to make sure it's a new array each time. If we
            // don't do this and just update the array in place, React will not detect
            // a change.
            else {
                // If not a nested row
                if (pageLevel === -1) {
                    return [
                        ...ArrayConcatAt(rows !== null && rows !== void 0 ? rows : [], convertDataToRows(items, pagination.start, itemToData), pagination.start)
                    ];
                }
                const freshIndexes = items.map((i) => { var _a; return (_a = i === null || i === void 0 ? void 0 : i.pageIndex) !== null && _a !== void 0 ? _a : 0; });
                // combine the set of known items with the new items received.
                // discard old values when a known page index is found in the fresh list.
                // also discard the indexes, they will need to be reset due to new items.
                const knownItems = [
                    ...((_b = rows === null || rows === void 0 ? void 0 : rows.filter((r) => { var _a, _b; return r.data && !freshIndexes.includes((_b = (_a = r.data) === null || _a === void 0 ? void 0 : _a.pageIndex) !== null && _b !== void 0 ? _b : -1); }).map((r) => r.data)) !== null && _b !== void 0 ? _b : []),
                    ...convertDataToRows(items, 0, itemToData).map((r) => r.data)
                ];
                const result = ArrayNestedConcat(knownItems, pagination.total);
                return result;
            }
        });
    }, [setRowStateWrapper, itemToData, pageLevel]);
    const getData = React__default.useCallback((startIndex, columnSortState, search, merge, cb) => {
        // Ask for data from our dataSource
        dataSource(function (items, pagination) {
            handleReturnedData(items, pagination, merge);
            // if a callback was provided invoke it once we are done setting rows
            cb && cb(pagination);
        }, startIndex, columnSortState, search);
    }, [dataSource, handleReturnedData]);
    const { rows, rowsLastChanged } = rowState;
    return { lastPagination, rows, rowsLastChanged, getData, mapDataRows };
}

// We maintain the date format only for the DatePicker component.
const LocaleDataMap = {
    'en-US': {
        date: 'MM/dd/yyyy',
        currency: 'USD',
        fractionDelimiter: '.',
        numberDelimiter: ','
    },
    'en-CA': {
        date: 'yyyy-MM-dd',
        currency: 'CAD',
        fractionDelimiter: '.',
        numberDelimiter: ','
    },
    'fr-CA': {
        date: 'yyyy-MM-dd',
        currency: 'CAD',
        currencyIconPlacement: IconPlacement.End,
        fractionDelimiter: ',',
        alternateDelimiters: '.',
        numberDelimiter: ' '
    },
    'en-GB': {
        date: 'dd/MM/yyyy',
        currency: 'GBP',
        currencyIcon: 'PoundIcon',
        fractionDelimiter: '.',
        numberDelimiter: ','
    }
};
const USStatesFull = [
    { name: 'Alaska', code: 'AK' },
    { name: 'Alabama', code: 'AL' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'California', code: 'CA' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'District of Columbia', code: 'DC' },
    { name: 'Delaware', code: 'DE' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Maine', code: 'ME' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Montana', code: 'MT' },
    { name: 'North Carolina', code: 'NC' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New York', code: 'NY' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Washington', code: 'WA' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wyoming', code: 'WY' },
    { name: 'Armed Forces Americas (except Canada)', code: 'AA' },
    { name: 'Armed Forces Europe, the Middle East, and Canada', code: 'AE' },
    { name: 'Armed Forces Pacific', code: 'AP' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'Guam', code: 'GU' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Northern Mariana Island', code: 'MP' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'US Minor Outlying Islands', code: 'UM' },
    { name: 'US Virgin Islands', code: 'VI' }
];
USStatesFull.map((state) => state.code);
const CAProvinces = [
    'AB',
    'BC',
    'MB',
    'NB',
    'NL',
    'NS',
    'NT',
    'NU',
    'ON',
    'PE',
    'QC',
    'SK',
    'YT'
];
const UKCounties = [
    'Aberdeenshire',
    'Angus',
    'Antrim',
    'Argyll & Bute',
    'Armagh',
    'Ayrshire',
    'Banffshire',
    'Bath and North East Somerset',
    'Bedfordshire',
    'Berkshire',
    'Berwickshire',
    'Blaenau Gwent',
    'Borders',
    'Bridgend',
    'Bristol',
    'Buckinghamshire',
    'Caerphilly',
    'Caithness',
    'Cambridgeshire',
    'Cardiff',
    'Carmarthenshire',
    'Ceredigion',
    'Cheshire',
    'Clackmannanshire',
    'Conwy',
    'Cornwall',
    'County Durham',
    'Cumbria',
    'Denbighshire',
    'Derbyshire',
    'Devon',
    'Dorset',
    'Down',
    'Dumfries & Galloway',
    'Dunbartonshire',
    'East Ayrshire',
    'East Dunbartonshire',
    'East Lothian',
    'East Renfrewshire',
    'East Riding of Yorkshire',
    'East Sussex',
    'Essex',
    'Fermanagh',
    'Fife',
    'Flintshire',
    'Gloucestershire',
    'Greater London',
    'Greater Manchester',
    'Gwynedd',
    'Hampshire',
    'Herefordshire',
    'Hertfordshire',
    'Highland',
    'Inverclyde',
    'Isle of Anglesey',
    'Isle of Wight',
    'Isles of Scilly',
    'Kent',
    'Kincardineshire',
    'Lanarkshire',
    'Lancashire',
    'Leicestershire',
    'Lincolnshire',
    'Londonderry',
    'London',
    'Merseyside',
    'Merthyr Tydfil',
    'Midlothian',
    'Monmouthshire',
    'Moray',
    'Neath Port Talbot',
    'Newport',
    'Norfolk',
    'North Ayrshire',
    'North Lanarkshire',
    'North Somerset',
    'North Yorkshire',
    'Northamptonshire',
    'Northumberland',
    'Nottinghamshire',
    'Orkney',
    'Oxfordshire',
    'Pembrokeshire',
    'Perth & Kinross',
    'Powys',
    'Renfrewshire',
    'Rhondda Cynon Taff',
    'Rutland',
    'Shetland',
    'Shropshire',
    'Somerset',
    'South Ayrshire',
    'South Gloucestershire',
    'South Lanarkshire',
    'South Yorkshire',
    'Staffordshire',
    'Stirlingshire',
    'Suffolk',
    'Surrey',
    'Swansea',
    'Torfaen',
    'Tyne & Wear',
    'Tyrone',
    'Vale of Glamorgan',
    'Warwickshire',
    'West Dunbartonshire',
    'West Lothian',
    'West Midlands',
    'West Sussex',
    'West Yorkshire',
    'Western Isles',
    'Wiltshire',
    'Worcestershire',
    'Wrexham'
];
const BrandTypeColorMap = {
    [BrandType.Info]: '#365ef6', // electric-blue-500
    [BrandType.Success]: '#03866a', // ads-green-700
    [BrandType.Error]: '#ea0a3b', // ads-red-600
    [BrandType.Warning]: '#F45110', // ads-orange-600
    [BrandType.Inverse]: '#fff' // white
};
const countryData = [
    {
        name: 'Afghanistan',
        dialingCode: 93,
        code: 'AF',
        code3: 'AFG'
    },
    {
        name: 'Åland Islands',
        dialingCode: 358,
        code: 'AX',
        code3: 'ALA'
    },
    {
        name: 'Albania',
        dialingCode: 355,
        code: 'AL',
        code3: 'ALB'
    },
    {
        name: 'Algeria',
        dialingCode: 213,
        code: 'DZ',
        code3: 'DZA'
    },
    {
        name: 'American Samoa',
        dialingCode: 1684,
        code: 'AS',
        code3: 'ASM'
    },
    {
        name: 'Andorra',
        dialingCode: 376,
        code: 'AD',
        code3: 'AND'
    },
    {
        name: 'Angola',
        dialingCode: 244,
        code: 'AO',
        code3: 'AGO'
    },
    {
        name: 'Anguilla',
        dialingCode: 1264,
        code: 'AI',
        code3: 'AIA'
    },
    {
        name: 'Antigua and Barbuda',
        dialingCode: 1268,
        code: 'AG',
        code3: 'ATG'
    },
    {
        name: 'Argentina',
        dialingCode: 54,
        code: 'AR',
        code3: 'ARG'
    },
    {
        name: 'Armenia',
        dialingCode: 374,
        code: 'AM',
        code3: 'ARM'
    },
    {
        name: 'Aruba',
        dialingCode: 297,
        code: 'AW',
        code3: 'ABW'
    },
    {
        name: 'Australia',
        dialingCode: 61,
        code: 'AU',
        code3: 'AUS'
    },
    {
        name: 'Austria',
        dialingCode: 43,
        code: 'AT',
        code3: 'AUT'
    },
    {
        name: 'Azerbaijan',
        dialingCode: 994,
        code: 'AZ',
        code3: 'AZE'
    },
    {
        name: 'Bahamas',
        dialingCode: 1242,
        code: 'BS',
        code3: 'BHS'
    },
    {
        name: 'Bahrain',
        dialingCode: 973,
        code: 'BH',
        code3: 'BHR'
    },
    {
        name: 'Bangladesh',
        dialingCode: 880,
        code: 'BD',
        code3: 'BGD'
    },
    {
        name: 'Barbados',
        dialingCode: 1246,
        code: 'BB',
        code3: 'BRB'
    },
    {
        name: 'Belarus',
        dialingCode: 375,
        code: 'BY',
        code3: 'BLR'
    },
    {
        name: 'Belgium',
        dialingCode: 32,
        code: 'BE',
        code3: 'BEL'
    },
    {
        name: 'Belize',
        dialingCode: 501,
        code: 'BZ',
        code3: 'BLZ'
    },
    {
        name: 'Benin',
        dialingCode: 229,
        code: 'BJ',
        code3: 'BEN'
    },
    {
        name: 'Bermuda',
        dialingCode: 1441,
        code: 'BM',
        code3: 'BMU'
    },
    {
        name: 'Bhutan',
        dialingCode: 975,
        code: 'BT',
        code3: 'BTN'
    },
    {
        name: 'Bolivia, Plurinational State of bolivia',
        dialingCode: 591,
        code: 'BO',
        code3: 'BOL'
    },
    {
        name: 'Bosnia and Herzegovina',
        dialingCode: 387,
        code: 'BA',
        code3: 'BIH'
    },
    {
        name: 'Botswana',
        dialingCode: 267,
        code: 'BW',
        code3: 'BWA'
    },
    {
        name: 'Brazil',
        dialingCode: 55,
        code: 'BR',
        code3: 'BRA'
    },
    {
        name: 'British Indian Ocean Territory',
        dialingCode: 246,
        code: 'IO',
        code3: 'IOT'
    },
    {
        name: 'Brunei Darussalam',
        dialingCode: 673,
        code: 'BN',
        code3: 'BRN'
    },
    {
        name: 'Bulgaria',
        dialingCode: 359,
        code: 'BG',
        code3: 'BGR'
    },
    {
        name: 'Burkina Faso',
        dialingCode: 226,
        code: 'BF',
        code3: 'BFA'
    },
    {
        name: 'Burundi',
        dialingCode: 257,
        code: 'BI',
        code3: 'BDI'
    },
    {
        name: 'Cambodia',
        dialingCode: 855,
        code: 'KH',
        code3: 'KHM'
    },
    {
        name: 'Cameroon',
        dialingCode: 237,
        code: 'CM',
        code3: 'CMR'
    },
    {
        name: 'Canada',
        dialingCode: 1,
        code: 'CA',
        code3: 'CAN'
    },
    {
        name: 'Cape Verde',
        dialingCode: 238,
        code: 'CV',
        code3: 'CPV'
    },
    {
        name: 'Cayman Islands',
        dialingCode: 1345,
        code: 'KY',
        code3: 'CYM'
    },
    {
        name: 'Central African Republic',
        dialingCode: 236,
        code: 'CF',
        code3: 'CAF'
    },
    {
        name: 'Chad',
        dialingCode: 235,
        code: 'TD',
        code3: 'TCD'
    },
    {
        name: 'Chile',
        dialingCode: 56,
        code: 'CL',
        code3: 'CHL'
    },
    {
        name: 'China',
        dialingCode: 86,
        code: 'CN',
        code3: 'CHN'
    },
    {
        name: 'Christmas Island',
        dialingCode: 61,
        code: 'CX',
        code3: 'CXR'
    },
    {
        name: 'Cocos (Keeling) Islands',
        dialingCode: 61,
        code: 'CC',
        code3: 'CCK'
    },
    {
        name: 'Colombia',
        dialingCode: 57,
        code: 'CO',
        code3: 'COL'
    },
    {
        name: 'Comoros',
        dialingCode: 269,
        code: 'KM',
        code3: 'COM'
    },
    {
        name: 'Congo',
        dialingCode: 242,
        code: 'CG',
        code3: 'COG'
    },
    {
        name: 'Congo, The Democratic Republic of the Congo',
        dialingCode: 243,
        code: 'CD',
        code3: 'COD'
    },
    {
        name: 'Cook Islands',
        dialingCode: 682,
        code: 'CK',
        code3: 'COK'
    },
    {
        name: 'Costa Rica',
        dialingCode: 506,
        code: 'CR',
        code3: 'CRI'
    },
    {
        name: "Cote d'Ivoire",
        dialingCode: 225,
        code: 'CI',
        code3: 'CIV'
    },
    {
        name: 'Croatia',
        dialingCode: 385,
        code: 'HR',
        code3: 'HRV'
    },
    {
        name: 'Cuba',
        dialingCode: 53,
        code: 'CU',
        code3: 'CUB'
    },
    {
        name: 'Cyprus',
        dialingCode: 357,
        code: 'CY',
        code3: 'CYP'
    },
    {
        name: 'Czech Republic',
        dialingCode: 420,
        code: 'CZ',
        code3: 'CZE'
    },
    {
        name: 'Denmark',
        dialingCode: 45,
        code: 'DK',
        code3: 'DNK'
    },
    {
        name: 'Djibouti',
        dialingCode: 253,
        code: 'DJ',
        code3: 'DJI'
    },
    {
        name: 'Dominica',
        dialingCode: 1767,
        code: 'DM',
        code3: 'DMA'
    },
    {
        name: 'Dominican Republic',
        dialingCode: 1849,
        code: 'DO',
        code3: 'DOM'
    },
    {
        name: 'Ecuador',
        dialingCode: 593,
        code: 'EC',
        code3: 'ECU'
    },
    {
        name: 'Egypt',
        dialingCode: 20,
        code: 'EG',
        code3: 'EGY'
    },
    {
        name: 'El Salvador',
        dialingCode: 503,
        code: 'SV',
        code3: 'SLV'
    },
    {
        name: 'Equatorial Guinea',
        dialingCode: 240,
        code: 'GQ',
        code3: 'GNQ'
    },
    {
        name: 'Eritrea',
        dialingCode: 291,
        code: 'ER',
        code3: 'ERI'
    },
    {
        name: 'Estonia',
        dialingCode: 372,
        code: 'EE',
        code3: 'EST'
    },
    {
        name: 'Ethiopia',
        dialingCode: 251,
        code: 'ET',
        code3: 'ETH'
    },
    {
        name: 'Falkland Islands (Malvinas)',
        dialingCode: 500,
        code: 'FK',
        code3: 'FLK'
    },
    {
        name: 'Faroe Islands',
        dialingCode: 298,
        code: 'FO',
        code3: 'FRO'
    },
    {
        name: 'Fiji',
        dialingCode: 679,
        code: 'FJ',
        code3: 'FJI'
    },
    {
        name: 'Finland',
        dialingCode: 358,
        code: 'FI',
        code3: 'FIN'
    },
    {
        name: 'France',
        dialingCode: 33,
        code: 'FR',
        code3: 'FRA'
    },
    {
        name: 'French Guiana',
        dialingCode: 594,
        code: 'GF',
        code3: 'GUF'
    },
    {
        name: 'French Polynesia',
        dialingCode: 689,
        code: 'PF',
        code3: 'PYF'
    },
    {
        name: 'Gabon',
        dialingCode: 241,
        code: 'GA',
        code3: 'GAB'
    },
    {
        name: 'Gambia',
        dialingCode: 220,
        code: 'GM',
        code3: 'GMB'
    },
    {
        name: 'Georgia',
        dialingCode: 995,
        code: 'GE',
        code3: 'GEO'
    },
    {
        name: 'Germany',
        dialingCode: 49,
        code: 'DE',
        code3: 'DEU'
    },
    {
        name: 'Ghana',
        dialingCode: 233,
        code: 'GH',
        code3: 'GHA'
    },
    {
        name: 'Gibraltar',
        dialingCode: 350,
        code: 'GI',
        code3: 'GIB'
    },
    {
        name: 'Greece',
        dialingCode: 30,
        code: 'GR',
        code3: 'GRC'
    },
    {
        name: 'Greenland',
        dialingCode: 299,
        code: 'GL',
        code3: 'GRL'
    },
    {
        name: 'Grenada',
        dialingCode: 1473,
        code: 'GD',
        code3: 'GRD'
    },
    {
        name: 'Guadeloupe',
        dialingCode: 590,
        code: 'GP',
        code3: 'GLP'
    },
    {
        name: 'Guam',
        dialingCode: 1671,
        code: 'GU',
        code3: 'GUM'
    },
    {
        name: 'Guatemala',
        dialingCode: 502,
        code: 'GT',
        code3: 'GTM'
    },
    {
        name: 'Guernsey',
        dialingCode: 44,
        code: 'GG',
        code3: 'GGY'
    },
    {
        name: 'Guinea',
        dialingCode: 224,
        code: 'GN',
        code3: 'GIN'
    },
    {
        name: 'Guinea-Bissau',
        dialingCode: 245,
        code: 'GW',
        code3: 'GNB'
    },
    {
        name: 'Guyana',
        dialingCode: 592,
        code: 'GY',
        code3: 'GUY'
    },
    {
        name: 'Haiti',
        dialingCode: 509,
        code: 'HT',
        code3: 'HTI'
    },
    {
        name: 'Holy See (Vatican City State)',
        dialingCode: 379,
        code: 'VA',
        code3: 'VAT'
    },
    {
        name: 'Honduras',
        dialingCode: 504,
        code: 'HN',
        code3: 'HND'
    },
    {
        name: 'Hong Kong',
        dialingCode: 852,
        code: 'HK',
        code3: 'HKG'
    },
    {
        name: 'Hungary',
        dialingCode: 36,
        code: 'HU',
        code3: 'HUN'
    },
    {
        name: 'Iceland',
        dialingCode: 354,
        code: 'IS',
        code3: 'ISL'
    },
    {
        name: 'India',
        dialingCode: 91,
        code: 'IN',
        code3: 'IND'
    },
    {
        name: 'Indonesia',
        dialingCode: 62,
        code: 'ID',
        code3: 'IDN'
    },
    {
        name: 'Iran, Islamic Republic of Persian Gulf',
        dialingCode: 98,
        code: 'IR',
        code3: 'IRN'
    },
    {
        name: 'Iraq',
        dialingCode: 964,
        code: 'IQ',
        code3: 'IRQ'
    },
    {
        name: 'Ireland',
        dialingCode: 353,
        code: 'IE',
        code3: 'IRL'
    },
    {
        name: 'Isle of Man',
        dialingCode: 44,
        code: 'IM',
        code3: 'IMN'
    },
    {
        name: 'Israel',
        dialingCode: 972,
        code: 'IL',
        code3: 'ISR'
    },
    {
        name: 'Italy',
        dialingCode: 39,
        code: 'IT',
        code3: 'ITA'
    },
    {
        name: 'Jamaica',
        dialingCode: 1876,
        code: 'JM',
        code3: 'JAM'
    },
    {
        name: 'Japan',
        dialingCode: 81,
        code: 'JP',
        code3: 'JPN'
    },
    {
        name: 'Jersey',
        dialingCode: 44,
        code: 'JE',
        code3: 'JEY'
    },
    {
        name: 'Jordan',
        dialingCode: 962,
        code: 'JO',
        code3: 'JOR'
    },
    {
        name: 'Kazakhstan',
        dialingCode: 7,
        code: 'KZ',
        code3: 'KAZ'
    },
    {
        name: 'Kenya',
        dialingCode: 254,
        code: 'KE',
        code3: 'KEN'
    },
    {
        name: 'Kiribati',
        dialingCode: 686,
        code: 'KI',
        code3: 'KIR'
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        dialingCode: 850,
        code: 'KP',
        code3: 'PRK'
    },
    {
        name: 'Korea, Republic of South Korea',
        dialingCode: 82,
        code: 'KR',
        code3: 'KOR'
    },
    {
        name: 'Kosovo',
        dialingCode: 383,
        code: 'XK',
        code3: 'KOS'
    },
    {
        name: 'Kuwait',
        dialingCode: 965,
        code: 'KW',
        code3: 'KWT'
    },
    {
        name: 'Kyrgyzstan',
        dialingCode: 996,
        code: 'KG',
        code3: 'KGZ'
    },
    {
        name: 'Laos',
        dialingCode: 856,
        code: 'LA',
        code3: 'LAO'
    },
    {
        name: 'Latvia',
        dialingCode: 371,
        code: 'LV',
        code3: 'LVA'
    },
    {
        name: 'Lebanon',
        dialingCode: 961,
        code: 'LB',
        code3: 'LBN'
    },
    {
        name: 'Lesotho',
        dialingCode: 266,
        code: 'LS',
        code3: 'LSO'
    },
    {
        name: 'Liberia',
        dialingCode: 231,
        code: 'LR',
        code3: 'LBR'
    },
    {
        name: 'Libyan Arab Jamahiriya',
        dialingCode: 218,
        code: 'LY',
        code3: 'LBY'
    },
    {
        name: 'Liechtenstein',
        dialingCode: 423,
        code: 'LI',
        code3: 'LIE'
    },
    {
        name: 'Lithuania',
        dialingCode: 370,
        code: 'LT',
        code3: 'LTU'
    },
    {
        name: 'Luxembourg',
        dialingCode: 352,
        code: 'LU',
        code3: 'LUX'
    },
    {
        name: 'Macao',
        dialingCode: 853,
        code: 'MO',
        code3: 'MAC'
    },
    {
        name: 'Macedonia',
        dialingCode: 389,
        code: 'MK',
        code3: 'MKD'
    },
    {
        name: 'Madagascar',
        dialingCode: 261,
        code: 'MG',
        code3: 'MDG'
    },
    {
        name: 'Malawi',
        dialingCode: 265,
        code: 'MW',
        code3: 'MWI'
    },
    {
        name: 'Malaysia',
        dialingCode: 60,
        code: 'MY',
        code3: 'MYS'
    },
    {
        name: 'Maldives',
        dialingCode: 960,
        code: 'MV',
        code3: 'MDV'
    },
    {
        name: 'Mali',
        dialingCode: 223,
        code: 'ML',
        code3: 'MLI'
    },
    {
        name: 'Malta',
        dialingCode: 356,
        code: 'MT',
        code3: 'MLT'
    },
    {
        name: 'Marshall Islands',
        dialingCode: 692,
        code: 'MH',
        code3: 'MHL'
    },
    {
        name: 'Martinique',
        dialingCode: 596,
        code: 'MQ',
        code3: 'MTQ'
    },
    {
        name: 'Mauritania',
        dialingCode: 222,
        code: 'MR',
        code3: 'MRT'
    },
    {
        name: 'Mauritius',
        dialingCode: 230,
        code: 'MU',
        code3: 'MUS'
    },
    {
        name: 'Mayotte',
        dialingCode: 262,
        code: 'YT',
        code3: 'MYT'
    },
    {
        name: 'Mexico',
        dialingCode: 52,
        code: 'MX',
        code3: 'MEX'
    },
    {
        name: 'Micronesia, Federated States of Micronesia',
        dialingCode: 691,
        code: 'FM',
        code3: 'FSM'
    },
    {
        name: 'Moldova',
        dialingCode: 373,
        code: 'MD',
        code3: 'MDA'
    },
    {
        name: 'Monaco',
        dialingCode: 377,
        code: 'MC',
        code3: 'MCO'
    },
    {
        name: 'Mongolia',
        dialingCode: 976,
        code: 'MN',
        code3: 'MNG'
    },
    {
        name: 'Montenegro',
        dialingCode: 382,
        code: 'ME',
        code3: 'MNE'
    },
    {
        name: 'Montserrat',
        dialingCode: 1664,
        code: 'MS',
        code3: 'MSR'
    },
    {
        name: 'Morocco',
        dialingCode: 212,
        code: 'MA',
        code3: 'MAR'
    },
    {
        name: 'Mozambique',
        dialingCode: 258,
        code: 'MZ',
        code3: 'MOZ'
    },
    {
        name: 'Myanmar',
        dialingCode: 95,
        code: 'MM',
        code3: 'MMR'
    },
    {
        name: 'Namibia',
        dialingCode: 264,
        code: 'NA',
        code3: 'NAM'
    },
    {
        name: 'Nauru',
        dialingCode: 674,
        code: 'NR',
        code3: 'NRU'
    },
    {
        name: 'Nepal',
        dialingCode: 977,
        code: 'NP',
        code3: 'NPL'
    },
    {
        name: 'Netherlands',
        dialingCode: 31,
        code: 'NL',
        code3: 'NLD'
    },
    {
        name: 'New Caledonia',
        dialingCode: 687,
        code: 'NC',
        code3: 'NCL'
    },
    {
        name: 'New Zealand',
        dialingCode: 64,
        code: 'NZ',
        code3: 'NZL'
    },
    {
        name: 'Nicaragua',
        dialingCode: 505,
        code: 'NI',
        code3: 'NIC'
    },
    {
        name: 'Niger',
        dialingCode: 227,
        code: 'NE',
        code3: 'NER'
    },
    {
        name: 'Nigeria',
        dialingCode: 234,
        code: 'NG',
        code3: 'NGA'
    },
    {
        name: 'Niue',
        dialingCode: 683,
        code: 'NU',
        code3: 'NIU'
    },
    {
        name: 'Norfolk Island',
        dialingCode: 672,
        code: 'NF',
        code3: 'NFK'
    },
    {
        name: 'Northern Mariana Islands',
        dialingCode: 1670,
        code: 'MP',
        code3: 'MNP'
    },
    {
        name: 'Norway',
        dialingCode: 47,
        code: 'NO',
        code3: 'NOR'
    },
    {
        name: 'Oman',
        dialingCode: 968,
        code: 'OM',
        code3: 'OMN'
    },
    {
        name: 'Pakistan',
        dialingCode: 92,
        code: 'PK',
        code3: 'PAK'
    },
    {
        name: 'Palau',
        dialingCode: 680,
        code: 'PW',
        code3: 'PLW'
    },
    {
        name: 'Palestinian Territory, Occupied',
        dialingCode: 970,
        code: 'PS',
        code3: 'PSE'
    },
    {
        name: 'Panama',
        dialingCode: 507,
        code: 'PA',
        code3: 'PAN'
    },
    {
        name: 'Papua New Guinea',
        dialingCode: 675,
        code: 'PG',
        code3: 'PNG'
    },
    {
        name: 'Paraguay',
        dialingCode: 595,
        code: 'PY',
        code3: 'PRY'
    },
    {
        name: 'Peru',
        dialingCode: 51,
        code: 'PE',
        code3: 'PER'
    },
    {
        name: 'Philippines',
        dialingCode: 63,
        code: 'PH',
        code3: 'PHL'
    },
    {
        name: 'Poland',
        dialingCode: 48,
        code: 'PL',
        code3: 'POL'
    },
    {
        name: 'Portugal',
        dialingCode: 351,
        code: 'PT',
        code3: 'PRT'
    },
    {
        name: 'Puerto Rico',
        dialingCode: 1939,
        code: 'PR',
        code3: 'PRI'
    },
    {
        name: 'Qatar',
        dialingCode: 974,
        code: 'QA',
        code3: 'QAT'
    },
    {
        name: 'Romania',
        dialingCode: 40,
        code: 'RO',
        code3: 'ROU'
    },
    {
        name: 'Russia',
        dialingCode: 7,
        code: 'RU',
        code3: 'RUS'
    },
    {
        name: 'Rwanda',
        dialingCode: 250,
        code: 'RW',
        code3: 'RWA'
    },
    {
        name: 'Reunion',
        dialingCode: 262,
        code: 'RE',
        code3: 'REU'
    },
    {
        name: 'Saint Barthelemy',
        dialingCode: 590,
        code: 'BL',
        code3: 'BLM'
    },
    {
        name: 'Saint Helena, Ascension and Tristan Da Cunha',
        dialingCode: 290,
        code: 'SH',
        code3: 'SHN'
    },
    {
        name: 'Saint Kitts and Nevis',
        dialingCode: 1869,
        code: 'KN',
        code3: 'KNA'
    },
    {
        name: 'Saint Lucia',
        dialingCode: 1758,
        code: 'LC',
        code3: 'LCA'
    },
    {
        name: 'Saint Martin',
        dialingCode: 590,
        code: 'MF',
        code3: 'MAF'
    },
    {
        name: 'Saint Pierre and Miquelon',
        dialingCode: 508,
        code: 'PM',
        code3: 'SPM'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        dialingCode: 1784,
        code: 'VC',
        code3: 'VCT'
    },
    {
        name: 'Samoa',
        dialingCode: 685,
        code: 'WS',
        code3: 'WSM'
    },
    {
        name: 'San Marino',
        dialingCode: 378,
        code: 'SM',
        code3: 'SMR'
    },
    {
        name: 'Sao Tome and Principe',
        dialingCode: 239,
        code: 'ST',
        code3: 'STP'
    },
    {
        name: 'Saudi Arabia',
        dialingCode: 966,
        code: 'SA',
        code3: 'SAU'
    },
    {
        name: 'Senegal',
        dialingCode: 221,
        code: 'SN',
        code3: 'SEN'
    },
    {
        name: 'Serbia',
        dialingCode: 381,
        code: 'RS',
        code3: 'SRB'
    },
    {
        name: 'Seychelles',
        dialingCode: 248,
        code: 'SC',
        code3: 'SYC'
    },
    {
        name: 'Sierra Leone',
        dialingCode: 232,
        code: 'SL',
        code3: 'SLE'
    },
    {
        name: 'Singapore',
        dialingCode: 65,
        code: 'SG',
        code3: 'SGP'
    },
    {
        name: 'Slovakia',
        dialingCode: 421,
        code: 'SK',
        code3: 'SVK'
    },
    {
        name: 'Slovenia',
        dialingCode: 386,
        code: 'SI',
        code3: 'SVN'
    },
    {
        name: 'Solomon Islands',
        dialingCode: 677,
        code: 'SB',
        code3: 'SLB'
    },
    {
        name: 'Somalia',
        dialingCode: 252,
        code: 'SO',
        code3: 'SOM'
    },
    {
        name: 'South Africa',
        dialingCode: 27,
        code: 'ZA',
        code3: 'ZAF'
    },
    {
        name: 'South Sudan',
        dialingCode: 211,
        code: 'SS',
        code3: 'SSD'
    },
    {
        name: 'Spain',
        dialingCode: 34,
        code: 'ES',
        code3: 'ESP'
    },
    {
        name: 'Sri Lanka',
        dialingCode: 94,
        code: 'LK',
        code3: 'LKA'
    },
    {
        name: 'Sudan',
        dialingCode: 249,
        code: 'SD',
        code3: 'SDN'
    },
    {
        name: 'Suriname',
        dialingCode: 597,
        code: 'SR',
        code3: 'SUR'
    },
    {
        name: 'Svalbard and Jan Mayen',
        dialingCode: 47,
        code: 'SJ',
        code3: 'SJM'
    },
    {
        name: 'Swaziland',
        dialingCode: 268,
        code: 'SZ',
        code3: 'SWZ'
    },
    {
        name: 'Sweden',
        dialingCode: 46,
        code: 'SE',
        code3: 'SWE'
    },
    {
        name: 'Switzerland',
        dialingCode: 41,
        code: 'CH',
        code3: 'CHE'
    },
    {
        name: 'Syrian Arab Republic',
        dialingCode: 963,
        code: 'SY',
        code3: 'SYR'
    },
    {
        name: 'Taiwan',
        dialingCode: 886,
        code: 'TW',
        code3: 'TWN'
    },
    {
        name: 'Tajikistan',
        dialingCode: 992,
        code: 'TJ',
        code3: 'TJK'
    },
    {
        name: 'Tanzania, United Republic of Tanzania',
        dialingCode: 255,
        code: 'TZ',
        code3: 'TZA'
    },
    {
        name: 'Thailand',
        dialingCode: 66,
        code: 'TH',
        code3: 'THA'
    },
    {
        name: 'Timor-Leste',
        dialingCode: 670,
        code: 'TL',
        code3: 'TLS'
    },
    {
        name: 'Togo',
        dialingCode: 228,
        code: 'TG',
        code3: 'TGO'
    },
    {
        name: 'Tokelau',
        dialingCode: 690,
        code: 'TK',
        code3: 'TKL'
    },
    {
        name: 'Tonga',
        dialingCode: 676,
        code: 'TO',
        code3: 'TON'
    },
    {
        name: 'Trinidad and Tobago',
        dialingCode: 1868,
        code: 'TT',
        code3: 'TTO'
    },
    {
        name: 'Tunisia',
        dialingCode: 216,
        code: 'TN',
        code3: 'TUN'
    },
    {
        name: 'Turkey',
        dialingCode: 90,
        code: 'TR',
        code3: 'TUR'
    },
    {
        name: 'Turkmenistan',
        dialingCode: 993,
        code: 'TM',
        code3: 'TKM'
    },
    {
        name: 'Turks and Caicos Islands',
        dialingCode: 1649,
        code: 'TC',
        code3: 'TCA'
    },
    {
        name: 'Tuvalu',
        dialingCode: 688,
        code: 'TV',
        code3: 'TUV'
    },
    {
        name: 'Uganda',
        dialingCode: 256,
        code: 'UG',
        code3: 'UGA'
    },
    {
        name: 'Ukraine',
        dialingCode: 380,
        code: 'UA',
        code3: 'UKR'
    },
    {
        name: 'United Arab Emirates',
        dialingCode: 971,
        code: 'AE',
        code3: 'ARE'
    },
    {
        name: 'United Kingdom',
        dialingCode: 44,
        code: 'GB',
        code3: 'GBR'
    },
    {
        name: 'United States',
        dialingCode: 1,
        code: 'US',
        code3: 'USA'
    },
    {
        name: 'Uruguay',
        dialingCode: 598,
        code: 'UY',
        code3: 'URY'
    },
    {
        name: 'Uzbekistan',
        dialingCode: 998,
        code: 'UZ',
        code3: 'UZB'
    },
    {
        name: 'Vanuatu',
        dialingCode: 678,
        code: 'VU',
        code3: 'VUT'
    },
    {
        name: 'Venezuela, Bolivarian Republic of Venezuela',
        dialingCode: 58,
        code: 'VE',
        code3: 'VEN'
    },
    {
        name: 'Vietnam',
        dialingCode: 84,
        code: 'VN',
        code3: 'VNM'
    },
    {
        name: 'Virgin Islands, British',
        dialingCode: 1284,
        code: 'VG',
        code3: 'VGB'
    },
    {
        name: 'Virgin Islands, U.S.',
        dialingCode: 1340,
        code: 'VI',
        code3: 'VIR'
    },
    {
        name: 'Wallis and Futuna',
        dialingCode: 681,
        code: 'WF',
        code3: 'WLF'
    },
    {
        name: 'Yemen',
        dialingCode: 967,
        code: 'YE',
        code3: 'YEM'
    },
    {
        name: 'Zambia',
        dialingCode: 260,
        code: 'ZM',
        code3: 'ZMB'
    },
    {
        name: 'Zimbabwe',
        dialingCode: 263,
        code: 'ZW',
        code3: 'ZWE'
    }
];
const CountryData = countryData.sort((a, b) => a.code > b.code ? 1 : -1);
function GetCountryByCode(code) {
    if (code.length === 2) {
        return CountryData.find((i) => i.code === code);
    }
    else if (code.length === 3) {
        return CountryData.find((i) => i.code3 === code);
    }
    else {
        return undefined;
    }
}
function GetCountryByName(name) {
    return CountryData.find((i) => i.name === name);
}

// We wrap i18next's hook so we can modify it in the future or swap out our i18n's library solution
function useTranslation() {
    return useTranslation$1();
}
const Trans = Trans$1;

function useGetCountryByTranslatedName() {
    const { t } = useTranslation();
    // Translate country names and memoize it
    const countryNames = useMemo(() => {
        return CountryData.map((a) => {
            return Object.assign(Object.assign({}, a), { translatedName: t(`COUNTRY_${a.code}`) });
        });
    }, [t]);
    // Helper function to lookup country by translated name.
    const getCountryByTranslatedName = (translatedName) => {
        return countryNames.find((c) => c.translatedName === translatedName);
    };
    // Find country via code
    const getCountryWithTranslatedNameByCode = (code) => {
        if (code.length === 2) {
            return countryNames.find((i) => i.code === code);
        }
        else if (code.length === 3) {
            return countryNames.find((i) => i.code3 === code);
        }
        else {
            return undefined;
        }
    };
    return {
        getCountryByTranslatedName,
        getCountryWithTranslatedNameByCode
    };
}

function useLocaleCountryCode() {
    var _a;
    const context = React__default.useContext(ADSContext);
    return (_a = context === null || context === void 0 ? void 0 : context.locale) === null || _a === void 0 ? void 0 : _a.split('-')[1];
}

const DEFAULT_COUNTRY$1 = 'US';
// Returns the translated version of the country based on the local set on the theme (defaults to US is there is no theme).
function useDefaultCountry() {
    const userCountryCode = useLocaleCountryCode();
    const { getCountryWithTranslatedNameByCode } = useGetCountryByTranslatedName();
    const country = React__default.useMemo(() => {
        var _a;
        return (_a = getCountryWithTranslatedNameByCode(userCountryCode !== null && userCountryCode !== void 0 ? userCountryCode : DEFAULT_COUNTRY$1)) === null || _a === void 0 ? void 0 : _a.translatedName;
    }, [getCountryWithTranslatedNameByCode, userCountryCode]);
    return { country };
}

const useEventListener = (eventName, handler, elements = [window]) => {
    const eventNames = React__default.useMemo(() => (isArray(eventName) ? eventName : [eventName]), [eventName]);
    // Create a ref that stores handler
    const savedHandler = React__default.useRef();
    // Update ref.current value if handler changes.
    // This allows our effect below to always get latest handler ...
    // ... without us needing to pass it in effect deps array ...
    // ... and potentially cause effect to re-run every render.
    React__default.useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    React__default.useEffect(() => {
        // Create event listener that calls handler function stored in ref
        const eventListener = (event) => savedHandler.current && savedHandler.current(event);
        // Add event listener
        for (const el of elements) {
            for (const eventName of eventNames) {
                el === null || el === void 0 ? void 0 : el.addEventListener(eventName, eventListener);
            }
        }
        // Remove event listener on cleanup
        return () => {
            for (const el of elements) {
                for (const eventName of eventNames) {
                    el === null || el === void 0 ? void 0 : el.removeEventListener(eventName, eventListener);
                }
            }
        };
    }, [eventNames, elements] // Re-run if eventNames or element changes
    );
};

// Use this index value if no row is active.
const NO_ACTIVE_INDEX = -1;
const DROPDOWN_ACTION_FUNCTIONS = {
    enabled: {
        firstEnabledIndex: () => 0,
        deselectIndex: () => NO_ACTIVE_INDEX,
        toggleDropdownOpenIndex: (previouslyOpen) => {
            if (previouslyOpen) {
                /// if previously open, then close
                return DROPDOWN_ACTION_FUNCTIONS.enabled.deselectIndex();
            }
            else {
                // else previously closed, then open
                return 0;
            }
        },
        decrementCurrentIndex: (prev) => prev - 1,
        incrementCurrentIndex: (prev) => prev + 1
    },
    disabled: {
        firstEnabledIndex: (getFirstEnabledIndex_up) => {
            var _a;
            // Using `-1` here purposefully since we always want to start at `0` and
            // work our way up; thus, `-1` is always the correct number here.
            return (_a = getFirstEnabledIndex_up(-1)) !== null && _a !== void 0 ? _a : NO_ACTIVE_INDEX;
        },
        deselectIndex: () => NO_ACTIVE_INDEX,
        toggleDropdownOpenIndex: (previouslyOpen, getFirstEnabledIndex_up) => {
            if (previouslyOpen) {
                // if previously open, then close
                return DROPDOWN_ACTION_FUNCTIONS.disabled.deselectIndex();
            }
            else {
                // else previously closed, then open
                return DROPDOWN_ACTION_FUNCTIONS.disabled.firstEnabledIndex(getFirstEnabledIndex_up);
            }
        },
        decrementCurrentIndex: (prev, getFirstEnabledIndex_down) => {
            var _a;
            // get the "next" index if it exists, otherwise return the current index
            return (_a = getFirstEnabledIndex_down(prev)) !== null && _a !== void 0 ? _a : prev;
        },
        incrementCurrentIndex: (prev, getFirstEnabledIndex_up) => {
            var _a;
            // get the "next" index if it exists, otherwise return the current index
            return (_a = getFirstEnabledIndex_up(prev)) !== null && _a !== void 0 ? _a : prev;
        }
    }
};
function useDropdownActiveRowIndex(numberOfItems, disabledIndices) {
    // firstly, we need to know if we have any disabled indices or not
    const mode = React__default.useMemo(() => {
        return disabledIndices === undefined || disabledIndices.length === 0
            ? 'enabled'
            : 'disabled';
    }, [disabledIndices]);
    // if we have disabled indices, we make some helper arrays
    // if not, we can short circuit this calculation
    const [allIndices, allIndicesReversed] = React__default.useMemo(() => {
        if (mode === 'enabled') {
            return [null, null];
        }
        const all = [...Array(numberOfItems).keys()];
        const reversed = structuredClone(all).reverse();
        return [all, reversed];
    }, [mode, numberOfItems]);
    // for when we have disabled indices. "get me the first enabled index below me"
    const getFirstEnabledIndexDownward = React__default.useCallback((currentIndex) => {
        if (allIndicesReversed === null) {
            return;
        }
        const maybeFirst = allIndicesReversed
            // for all the indices below our current index...
            .slice(allIndicesReversed.length - currentIndex)
            // ... find the first one that is not disabled
            .find((i) => !(disabledIndices === null || disabledIndices === void 0 ? void 0 : disabledIndices.includes(i)));
        return maybeFirst;
    }, [allIndicesReversed, disabledIndices]);
    // for when we have disabled indices. "get me the first enabled index above me"
    const getFirstEnabledIndexUpward = React__default.useCallback((currentIndex) => {
        if (allIndices === null) {
            return;
        }
        const maybeFirst = allIndices
            // for all the indices above our current index...
            .slice(currentIndex + 1)
            // ... find the first one that is not disabled
            .find((i) => !(disabledIndices === null || disabledIndices === void 0 ? void 0 : disabledIndices.includes(i)));
        return maybeFirst;
    }, [allIndices, disabledIndices]);
    // for both enabled & disabled modes. "will the next index up be out of bounds?"
    const willOverflow = React__default.useCallback((current) => current >= numberOfItems - 1, [numberOfItems]);
    // for both enabled & disabled modes. "will the next index down be out of bounds?"
    const willUnderflow = React__default.useCallback((current) => current <= 0, []);
    // build all the possible actions on row indices & also return the initial
    // index for the `useState` hook to use
    const [actions, initialValidIndex] = React__default.useMemo(() => {
        switch (mode) {
            case 'enabled': {
                const { firstEnabledIndex, deselectIndex, toggleDropdownOpenIndex, decrementCurrentIndex, incrementCurrentIndex } = DROPDOWN_ACTION_FUNCTIONS.enabled;
                const actions = {
                    firstEnabledIndex: () => {
                        setActiveRowIndex(firstEnabledIndex);
                    },
                    deselectIndex: () => {
                        setActiveRowIndex(deselectIndex);
                    },
                    toggleDropdownOpenIndex: (previouslyOpen) => {
                        setActiveRowIndex(toggleDropdownOpenIndex(previouslyOpen));
                    },
                    decrementCurrentIndex: () => {
                        setActiveRowIndex((prev) => {
                            if (willUnderflow(prev)) {
                                return prev;
                            }
                            else {
                                return decrementCurrentIndex(prev);
                            }
                        });
                    },
                    incrementCurrentIndex: () => {
                        setActiveRowIndex((prev) => {
                            if (willOverflow(prev)) {
                                return prev;
                            }
                            else {
                                return incrementCurrentIndex(prev);
                            }
                        });
                    }
                };
                return [actions, firstEnabledIndex()];
            }
            case 'disabled': {
                const { firstEnabledIndex, deselectIndex, toggleDropdownOpenIndex, decrementCurrentIndex, incrementCurrentIndex } = DROPDOWN_ACTION_FUNCTIONS.disabled;
                const actions = {
                    firstEnabledIndex: () => {
                        setActiveRowIndex(firstEnabledIndex(getFirstEnabledIndexUpward));
                    },
                    deselectIndex: () => {
                        setActiveRowIndex(deselectIndex);
                    },
                    toggleDropdownOpenIndex: (previouslyOpen) => {
                        setActiveRowIndex(toggleDropdownOpenIndex(previouslyOpen, getFirstEnabledIndexUpward));
                    },
                    decrementCurrentIndex: () => {
                        setActiveRowIndex((prev) => {
                            if (willUnderflow(prev)) {
                                return prev;
                            }
                            else {
                                return decrementCurrentIndex(prev, getFirstEnabledIndexDownward);
                            }
                        });
                    },
                    incrementCurrentIndex: () => {
                        setActiveRowIndex((prev) => {
                            if (willOverflow(prev)) {
                                return prev;
                            }
                            else {
                                return incrementCurrentIndex(prev, getFirstEnabledIndexUpward);
                            }
                        });
                    }
                };
                return [
                    actions,
                    firstEnabledIndex(getFirstEnabledIndexUpward)
                ];
            }
        }
    }, [
        mode,
        getFirstEnabledIndexDownward,
        getFirstEnabledIndexUpward,
        willOverflow,
        willUnderflow
    ]);
    const [activeRowIndex, setActiveRowIndex] = React__default.useState(initialValidIndex);
    return {
        activeRowIndex,
        setActiveRowIndex,
        rowIndexActions: actions
    };
}
//#endregion END - 👉 the `useActiveRowIndex` hook 👉

/* eslint-disable @typescript-eslint/no-explicit-any */
const LETTER_KEYS = Array(95)
    .fill(32)
    .map((key, idx) => String.fromCharCode(key + idx));
// 🔽 the `useDropdown` hook 🔽
// Core logic of handling dropdown lives here.
// TODO: Add documentation of how to use once its API has settled
function useDropdown({ disabledIndices, keyboardEnabled = true, numberOfItems, openOnArrowDown = true, openOnSpace = false, keydownConfig = {
    listenTo: 'anchor-and-dropdown'
}, onArrowDownKey, onArrowUpKey, onEnterKey, onEscapeKey, onLetterKey, onPageDownKey, onPageUpKey, onTabKey }) {
    // We need references to both the anchor and dropdown elements.
    const [anchorEl, setAnchorEl] = React__default.useState(null);
    const [dropdownEl, setDropdownEl] = React__default.useState(null);
    const [open, setOpen] = React__default.useState(false);
    const { activeRowIndex, setActiveRowIndex, rowIndexActions } = useDropdownActiveRowIndex(numberOfItems, disabledIndices);
    // unwrap and rename
    const { firstEnabledIndex: resetActiveRowIndex } = rowIndexActions;
    // This will be applied to the dropdown component
    const dropdownProps = {
        anchorEl,
        open,
        ref: setDropdownEl
    };
    const toggle = () => {
        rowIndexActions.toggleDropdownOpenIndex(open);
        setOpen(!open);
    };
    const handleArrowDownKey = () => {
        // In some cases we don't want to open the dropdown on arrow down.
        if (!open && openOnArrowDown) {
            setOpen(true);
            rowIndexActions.firstEnabledIndex();
        }
        else {
            rowIndexActions.incrementCurrentIndex();
        }
    };
    const handleSpaceKey = (e) => {
        if (!open && openOnSpace) {
            setOpen(true);
            rowIndexActions.firstEnabledIndex();
            // We want to cancel the way the browser natively handles space key press on buttons (triggers the button onClick),
            // but only if we are opening the dropdown.
            CancelNativeEvent(e);
        }
    };
    const handleArrowUpKey = () => {
        // This only comes into play if we are currently showing the dropdown drawer.
        if (open) {
            rowIndexActions.decrementCurrentIndex();
        }
    };
    const handleLetterKey = (e) => {
        // confirm the key is a letter
        if (onLetterKey) {
            onLetterKey(e.key);
        }
    };
    const handleEscapeKey = () => {
        setOpen(false);
        rowIndexActions.deselectIndex();
    };
    const handleF4Key = () => {
        toggle();
    };
    const keyDownHandler = (e) => {
        // type predicate to guarantee we have a `KeyboardEvent`
        if (!isKeyboardEvent(e)) {
            return;
        }
        // Want some debug logs? If so, uncomment and check your console! [Do not commit!]
        // _keyMapConsoleDebugger(anchorEl, dropdownEl, e);
        if (!keyboardEnabled) {
            return;
        }
        const keyMap = [
            { Escape: onEscapeKey !== null && onEscapeKey !== void 0 ? onEscapeKey : handleEscapeKey },
            { F4: handleF4Key },
            { ArrowDown: onArrowDownKey !== null && onArrowDownKey !== void 0 ? onArrowDownKey : handleArrowDownKey },
            { ArrowUp: onArrowUpKey !== null && onArrowUpKey !== void 0 ? onArrowUpKey : handleArrowUpKey },
            { ' ': handleSpaceKey }
        ];
        // Only if we are having to handle enter do we add it to our map.
        if (onEnterKey) {
            keyMap.push({ Enter: onEnterKey });
        }
        if (onPageDownKey) {
            keyMap.push({ PageDown: onPageDownKey });
        }
        if (onPageUpKey) {
            keyMap.push({ PageUp: onPageUpKey });
        }
        if (onTabKey) {
            keyMap.push({ Tab: onTabKey });
        }
        if (onLetterKey) {
            // fills in all chars in ascii range 33-127
            LETTER_KEYS.forEach((k) => {
                keyMap.push({ [k]: handleLetterKey });
            });
        }
        // Handle the event based off which key was pressed
        const handled = KeyHandleMap(e, keyMap);
        const isTabKey = e.key === 'Tab';
        const isSpaceKey = e.key === ' ';
        // If we handled the keydown event, cancel it from propagating
        if (handled && !isTabKey && !isSpaceKey) {
            CancelNativeEvent(e);
        }
    };
    const listenedToElements = React__default.useMemo(() => match(keydownConfig.listenTo)
        .with('anchor-and-dropdown', () => [anchorEl, dropdownEl])
        .with('dropdown', () => [dropdownEl])
        .exhaustive(), [keydownConfig.listenTo, anchorEl, dropdownEl]);
    useEventListener('keydown', keyDownHandler, listenedToElements);
    // If blur happens outside both this and the dropdown we need to close. We
    // have to use a ref to avoid rebinding to onblur with every re-render.
    const onAnchorBlur = (e) => {
        if (open && anchorEl && dropdownEl) {
            OnFocusOutside(e, [anchorEl, dropdownEl], () => setOpen(false));
        }
    };
    return {
        dropdown: {
            activeRowIndex,
            el: dropdownEl,
            open,
            blurred: onAnchorBlur,
            resetActiveRowIndex,
            setActiveRowIndex,
            setOpen,
            toggle
        },
        dropdownAnchorRef: setAnchorEl,
        dropdownProps
    };
}
function isEventOfType(event, type) {
    return event.type === type;
}
function isKeyboardEvent(event) {
    return (isEventOfType(event, 'keydown') ||
        isEventOfType(event, 'keypress') ||
        isEventOfType(event, 'keyup'));
}

function useFetchingDataBlock() {
    const fetchingRef = React__default.useRef({
        batchSize: null,
        index: null
    });
    const setBatchSize = (size) => {
        fetchingRef.current.batchSize = size;
    };
    const setRowIndexInFlight = (index) => {
        fetchingRef.current.index = index;
    };
    const isRowIndexInFlight = (index) => {
        var _a, _b, _c;
        if (((_a = fetchingRef.current.index) !== null && _a !== void 0 ? _a : -1) >= 0 &&
            fetchingRef.current.batchSize) {
            const endIndex = ((_b = fetchingRef.current.index) !== null && _b !== void 0 ? _b : 0) + fetchingRef.current.batchSize;
            return index >= ((_c = fetchingRef.current.index) !== null && _c !== void 0 ? _c : 0) && index <= endIndex;
        }
        return false;
    };
    return {
        setBatchSize,
        setRowIndexInFlight,
        isRowIndexInFlight,
        clearInFlightRowIndex: () => setRowIndexInFlight(null)
    };
}

// Wrapper around react hook form's useController hook. We have several places where
// we need to centralize the logic of when to show field messages.
function useFieldController(name) {
    const { field, fieldState, formState } = useController({ name });
    return {
        field,
        fieldState,
        formState,
        showMessages: fieldState.isTouched || formState.isSubmitted
    };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// Adds 'desired' to all Yup schema types
Yup.addMethod(Yup.Schema, 'desired', function desired() {
    return this.test({
        name: 'desired',
        test() {
            return true;
        }
    });
});
/**
 * Combines concat from Yup's object https://github.com/jquense/yup/blob/v0.32.11/src/object.ts#L282-L309
 * and Yup's schema https://github.com/jquense/yup/blob/v0.32.11/src/schema.ts#L217-L269
 * from version v0.32.11. This is to ensure we can still merge schemas together (like with subForms) per the suggestion
 * from the maintainer https://github.com/jquense/yup/issues/1921.
 */
Yup.addMethod(Yup.Schema, 'concat', function concat(schema) {
    if (!schema || schema === this)
        return this;
    if (schema.type !== this.type && this.type !== 'mixed')
        throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    const combined = schema.clone();
    /**
     * **ADS Comment**
     * Optional/Required used to be managed as a 'presence' prop which could be 'Required' or 'Optional'. When merging these two strings,
     * the latter string would win. With the latest Yup, `optional` is the prop name that can be true or false. This sort of spreading does not work
     * for booleans in teh same way. As a result, we have updated the logic to account for this.
     */
    const isConcatenatedSchemaRequired = !combined.spec.optional;
    const mergedSpec = Object.assign(Object.assign(Object.assign({}, this.spec), combined.spec), { optional: isConcatenatedSchemaRequired ? false : this.spec.optional });
    combined.spec = mergedSpec;
    // @ts-expect-error internal to yup's Schema class
    combined.internalTests = Object.assign(Object.assign({}, this.internalTests), combined.internalTests);
    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = this._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = this._blacklist.merge(schema._blacklist, schema._whitelist);
    // start with the current tests
    combined.tests = this.tests;
    combined.exclusiveTests = this.exclusiveTests;
    // manually add the new tests to ensure
    // the de-duping logic is consistent
    combined.withMutation((next) => {
        schema.tests.forEach((fn) => {
            next.test(fn.OPTIONS);
        });
    });
    combined.transforms = [...this.transforms, ...combined.transforms];
    return combined;
});

const messages = {
    required: '${path} is required',
    maxString: '${path} cannot exceed ${max} characters',
    isValid: '${path} is not valid',
    isValidUrl: '${path} must be a valid URL',
    mustBeChecked: '${path} must be checked',
    mustSelectOne: 'A selection from the ${path} table is required'
};
// Set default message text.
Yup.setLocale({
    mixed: {
        required: messages.required
    },
    string: {
        max: messages.maxString
    }
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const array = () => Yup.array().default([]).nullable();
Yup.addMethod(Yup.array, 'files', function files(message) {
    return this.test({
        name: 'files',
        message: message !== null && message !== void 0 ? message : messages.required,
        test: (value) => {
            if (value) {
                return (value.length > 0 &&
                    value.filter((f) => ['success', 'defer'].includes(f.status)).length === value.length);
            }
            else {
                return true;
            }
        }
    });
});
Yup.addMethod(Yup.array, 'required', function required(message) {
    return Yup.Schema.prototype.required
        .call(this)
        .min(1, message || messages.required);
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const boolean = () => Yup.boolean().nullable();
Yup.addMethod(Yup.boolean, 'mustBeChecked', function mustBeChecked(message) {
    return this.test({
        name: 'mustBeTrue',
        message: message !== null && message !== void 0 ? message : messages.mustBeChecked,
        test(value) {
            return !!value;
        }
    });
});

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Taken from Yup's create (https://github.com/jquense/yup/blob/v1.2.0/src/object.ts#L82-L90) which helps drive our inner object shape into
 * our derived type.
 */
function object(spec) {
    return new Yup.ObjectSchema(spec).nullable();
}
/**
 * Combines concat from Yup's object https://github.com/jquense/yup/blob/v0.32.11/src/object.ts#L282-L309
 * and Yup's schema https://github.com/jquense/yup/blob/v0.32.11/src/schema.ts#L217-L269
 * from version v0.32.11. This is to ensure we can still merge schemas together (like with subForms) per the suggestion
 * from the maintainer https://github.com/jquense/yup/issues/1921.
 */
Yup.addMethod(Yup.object, 'concat', function concat(schema) {
    const next = Yup.Schema.prototype.concat.call(this, schema);
    const nextFields = next.fields;
    for (const [field, schemaOrRef] of Object.entries(this.fields)) {
        const target = nextFields[field];
        if (target === undefined) {
            nextFields[field] = schemaOrRef;
        }
        else if (target instanceof Yup.Schema &&
            schemaOrRef instanceof Yup.Schema) {
            nextFields[field] = schemaOrRef.concat(target);
        }
    }
    return next.withMutation((s) => 
    // XXX: excludes here is wrong
    // @ts-expect-error internal to yup's Schema class
    s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges]));
});

function dataGrid({ hasRowSelection, message = messages.mustSelectOne }) {
    switch (hasRowSelection) {
        case false:
            return object();
        case 'required':
            return object({
                selected: object()
                /**
                 * We use a .test here instead of placing .required() on the selected object
                 * because we want to have access to the parent dataGrid label for this error message.
                 */
            }).test('required', message, function (value) {
                if (!(value === null || value === void 0 ? void 0 : value.selected)) {
                    return this.createError({ message, path: `${this.path}.selected` });
                }
                return true;
            });
        case 'desired':
            return object({
                selected: object().desired()
            });
        case 'optional':
            return object({ selected: object() });
        default:
            throw new Error(`Invalid hasRowSelection value: ${hasRowSelection}`);
    }
}

const date = () => Yup.date().nullable();

const number = () => Yup.number().nullable();

class PhoneNumber {
    getAyt() {
        var _a;
        return new AsYouType(((_a = this.countryCode) === null || _a === void 0 ? void 0 : _a.code) || undefined);
    }
    detectedCountry() {
        const ayt = new AsYouType();
        ayt.input(this.value);
        const country = ayt.getCountry();
        return country
            ? this.countryList.find((c) => c.code === country)
            : undefined;
    }
    dialingCodeToString(c) {
        const stringDialingCode = c.dialingCode.toString();
        return stringDialingCode.length === 4
            ? `1 ${stringDialingCode.substring(1)}`
            : stringDialingCode;
    }
    constructor(countryList) {
        this.value = '';
        this.countryList =
            countryList && countryList.length > 0
                ? CountryData.filter((c) => countryList.includes(c.code) || countryList.includes(c.code3))
                : CountryData;
    }
    toString() {
        return this.getAyt().input(this.value);
    }
    toInternationalString() {
        var _a;
        const ayt = this.getAyt();
        ayt.input(this.value);
        return (_a = ayt.getNumber()) === null || _a === void 0 ? void 0 : _a.number;
    }
    isValid() {
        const ayt = this.getAyt();
        ayt.input(this.value);
        const valid = ayt.isValid();
        if (valid) {
            // isValid no longer checks for numbers not valid for a region.
            // See this issue: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/139
            // ================================================================
            // Workaround to manually parse the number and compare the country with the currently set country code.
            // Returns false when the country does not match the phone number region.
            const matches = findPhoneNumbersInText(this.value, ayt.getCountry());
            if (matches.length > 0 &&
                matches[0].number.country !== ayt.getCountry()) {
                return false;
            }
        }
        return valid;
    }
    getValue() {
        return this.value;
    }
    getCountry() {
        return this.countryCode;
    }
    getUsersCountry() {
        return this.userCountryCode;
    }
    hasDialingCode() {
        return this.value[0] === '+';
    }
    // Sets internal value, but also parses the phone number and detects it's country
    // code
    setValue(v) {
        var _a, _b, _c;
        this.value = v;
        // If they are using a dialing code, we will try and detect the country being used
        // to see if it matches the user's locale's dialing code.
        if (this.hasDialingCode()) {
            const detectedCountry = this.detectedCountry();
            // If they use a dialing code but it's the same country as the user's country code
            // and the selected code, just remove the dialing code
            if (detectedCountry &&
                this.countryCode &&
                this.userCountryCode &&
                this.countryCode.code === this.userCountryCode.code &&
                detectedCountry.code === this.countryCode.code) {
                this.value = this.value.replace(`+${detectedCountry.dialingCode} `, '');
            }
            // if the detected country is different than what we currently have
            // update what we currently have.
            if (detectedCountry && (detectedCountry === null || detectedCountry === void 0 ? void 0 : detectedCountry.code) !== ((_a = this.countryCode) === null || _a === void 0 ? void 0 : _a.code)) {
                this.countryCode = detectedCountry;
            }
        }
        else {
            // If the user is not using the dialing code (i.e. no +X)
            // we switch to international formatting to see if we can detect
            // if the country is different than what we currently have set.
            // This handles cases like using a CA area code or one of the many
            // area codes that actually signify another country (i.e. +1 242, +1 705 etc.)
            // Note the detectedCountryCode must exist within the countryList
            const ayt = this.getAyt();
            ayt.input(`+${(_b = this.countryCode) === null || _b === void 0 ? void 0 : _b.dialingCode} ${this.value}`);
            const detectedCountryCode = ayt.getCountry();
            if (detectedCountryCode &&
                ((_c = this.countryCode) === null || _c === void 0 ? void 0 : _c.name) !== detectedCountryCode &&
                this.countryList.find((country) => country.code === detectedCountryCode)) {
                this.setCountryCode(detectedCountryCode);
            }
        }
        return this;
    }
    setUsersCountryCode(c) {
        if (!this.userCountryCode || this.userCountryCode.name !== c) {
            const newCountry = this.countryList.find((cdi) => cdi.code === c || cdi.code3 === c);
            this.userCountryCode = newCountry || this.countryCode;
        }
        return this;
    }
    setCountryCode(c) {
        if (this.countryCode &&
            (this.countryCode.code === c || this.countryCode.code3 === c)) {
            return this;
        }
        // Update our country code.
        const newCountry = this.countryList.find((cdi) => cdi.code === c || cdi.code3 === c);
        if (!newCountry) {
            return this;
        }
        // If we have gotten here, we have a new country code to set.
        this.countryCode = newCountry;
        // If the value currently has a dialing code remove it and we can detect it's country
        // remove the current dialing
        if (this.hasDialingCode()) {
            const detectedCountry = this.detectedCountry();
            // Not 100% sure why, but for some countries it can't detect the country with
            // just the dialing code. For those we fallback to extracting the dialing code
            if (detectedCountry) {
                this.value = this.value.replace(`+${this.dialingCodeToString(detectedCountry)} `, '');
            }
            else {
                const asYouType = new AsYouType();
                asYouType.input(this.value);
                if (asYouType.getCallingCode()) {
                    this.value = this.value.replace(`+${asYouType.getCallingCode()} `, '');
                }
                else {
                    // something is causing the VA dialing code to not be found.  Manually check
                    // for it and replace it.
                    this.value = this.value.replace(`+379 `, '');
                }
            }
        }
        // Dealing with dialing codes that have 4 digits require some extra handling. 4 digit
        // dialing codes are all the overloaded +1 country codes. We need to check for if they
        // are in the value, and remove them.
        if (this.countryCode.dialingCode.toString().length === 4) {
            // We need to remove the following cases using BS (1242) as an example.
            // 1242
            // 1 242
            // 242
            if (this.value.startsWith('1')) {
                this.value = this.value.substring(1);
            }
            this.value = this.value.trim();
            const areaCode = this.countryCode.dialingCode.toString().slice(1);
            if (this.value.startsWith(areaCode)) {
                this.value = this.value.replace(`${areaCode}`, '');
            }
        }
        // Special case if the number starts with 1, and we are switching to international
        // format that starts with 1.
        if (this.value.startsWith('1') && this.countryCode.dialingCode === 1) {
            this.value = this.value.substring(1).trim();
        }
        // If new country code does not match the user's dialing code, then we prefix the value
        // with the new country code's dialing code.
        if (this.userCountryCode &&
            this.userCountryCode.code !== this.countryCode.code) {
            this.value = `+${this.dialingCodeToString(this.countryCode)} ${this.value}`;
        }
        return this;
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function phoneNumber(props) {
    return new ADSPhoneNumberSchema(props)
        .test({
        message: messages.isValid,
        name: 'valid',
        exclusive: false,
        test: (value) => {
            if (value && value.phoneNumber) {
                return value.isValid === true;
            }
            else {
                return true;
            }
        }
    })
        .nullable();
}
// This is needed to have the types work correctly with Yup schema type inference
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class ADSPhoneNumberSchema extends Yup.ObjectSchema {
    constructor({ countries, defaultCountry, userCountryCode } = {}) {
        super();
        this.defaultCountry = defaultCountry;
        this.countries = countries;
        this.userCountryCode = userCountryCode;
    }
    required(message) {
        return this.test({
            message: message !== null && message !== void 0 ? message : messages.required,
            name: 'required',
            exclusive: true,
            test: (value) => value && value.phoneNumber
        });
    }
    default(defaultValue) {
        if (isString(defaultValue) || isNumber$1(defaultValue)) {
            return super.default(getPhoneNumberDefault({
                value: defaultValue,
                countries: this.countries,
                defaultCountry: this.defaultCountry,
                userCountryCode: this.userCountryCode
            }));
        }
        return super.default(defaultValue);
    }
    /*
      All of Yup's extension methods (label, nullable, required, etc) use the `clone` method to return a new, immutable schema.
      We override this to ensure that we don't lose access to our extended props that we use in our own other functions.
      Without it, when a consumer calls any method on a phoneNumber() schema, like phoneNumber().label(), for example, we would lose access
      to phoneNumberFormatter and defaultCountryData in subsequent extension method calls.
    */
    clone(spec) {
        const clone = super.clone(spec);
        clone.countries = this.countries;
        clone.defaultCountry = this.defaultCountry;
        clone.userCountryCode = this.userCountryCode;
        return clone;
    }
}
function getPhoneNumberDefault({ countries, defaultCountry, userCountryCode, value }) {
    var _a, _b, _c;
    const phoneNumberFormatter = new PhoneNumber(countries);
    const defaultCountryData = GetCountryByCode(defaultCountry !== null && defaultCountry !== void 0 ? defaultCountry : 'US');
    if (userCountryCode) {
        phoneNumberFormatter.setUsersCountryCode(userCountryCode);
    }
    phoneNumberFormatter.setCountryCode((_a = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code) !== null && _a !== void 0 ? _a : 'US');
    if (isString(value) || isNumber$1(value)) {
        const validNumber = !/[a-zA-Z]/.test(`${value}`);
        const formatted = phoneNumberFormatter.setValue(`${value}`).toString();
        return {
            countryCode: (_b = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code) !== null && _b !== void 0 ? _b : 'US',
            countryCode3: (_c = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code3) !== null && _c !== void 0 ? _c : 'USA',
            phoneNumber: validNumber ? formatted : '',
            E164Number: phoneNumberFormatter.toInternationalString(),
            isValid: phoneNumberFormatter.isValid()
        };
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const string = () => Yup.string().strict(true).nullable();
const emailRegex = 
// eslint-disable-next-line no-control-regex, no-useless-escape
/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
/**
 * Uses logic from Yup v0.32.11 to keep email validation strictness.
 * https://github.com/jquense/yup/blob/v0.32.11/src/string.ts#L136-L142 is the original code and
 * https://github.com/jquense/yup/blob/v0.32.11/src/string.ts#L9 is the original regex
 */
Yup.addMethod(Yup.string, 'email', function email(message = '${path} must be a valid email') {
    return this.matches(emailRegex, {
        name: 'email',
        message,
        excludeEmptyString: true
    });
});
Yup.addMethod(Yup.string, 'looseURL', function looseURL(message) {
    const reg = 
    // eslint-disable-next-line no-useless-escape
    /^(((https?|ftp):)?\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
    return this.test({
        name: 'looseURL',
        message: message !== null && message !== void 0 ? message : messages.isValidUrl,
        test: (value) => {
            if (value) {
                return value.search(reg) !== -1;
            }
            else {
                return true;
            }
        }
    });
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const fieldRow = (obj = object()) => {
    return array().of(obj).default([]);
};
// Utility function where an object can be passed in that will extend any field
// schema rules where property keys match.
const objectExtend = (data, schema) => {
    for (const key in schema) {
        const dataField = data[key];
        if (dataField) {
            if (dataField.value) {
                schema[key] = schema[key].default(dataField.value);
            }
            if (dataField.required) {
                schema[key] = schema[key].required();
            }
            if (dataField.desired) {
                schema[key] = schema[key].desired();
            }
            if (dataField.maxLength) {
                schema[key] = schema[key].max(dataField.maxLength);
            }
        }
    }
    return object(schema);
};
const getSchemaField = Yup.reach;

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Recursively converts plain objects to `yup.object()` schemas
 */
const convertNestedObjectsToSchemas = (obj) => {
    for (const k in obj) {
        const nestedObj = obj[k];
        if (!(nestedObj instanceof Yup.Schema)) {
            obj[k] = convertNestedObjectsToSchemas(nestedObj);
        }
    }
    return object(obj);
};
const defaultState$1 = {
    combinedSchema: object(),
    formId: '',
    formSchema: object(),
    subFormSchemas: {}
};
function combineSchemas(schema, subFormSchemas) {
    let newCombinedSchema = schema.clone();
    Object.entries(subFormSchemas).forEach(([name, schema]) => {
        // Lodash's set builds out any missing parts of our name (i.e. the path)
        const schemaPartial = convertNestedObjectsToSchemas(set({}, name, schema));
        // Yup's concat will merge our fields in
        newCombinedSchema = newCombinedSchema.concat(schemaPartial);
    });
    return newCombinedSchema;
}
function reducer$2(state, action) {
    switch (action.type) {
        case 'registerSchema': {
            // If the new schema references the same schema that is in state, don't bother updating the state.
            // This happens on the first render of Form since we try to register our schema, but we have already provided
            // it as part of the default state.
            if (state.formSchema === action.schema) {
                return state;
            }
            const newCombinedSchema = combineSchemas(action.schema, state.subFormSchemas);
            return Object.assign(Object.assign({}, state), { combinedSchema: newCombinedSchema, formSchema: action.schema });
        }
        case 'unRegisterSubSchema': {
            const newSubFormSchemas = cloneDeep(state.subFormSchemas);
            delete newSubFormSchemas[action.name];
            const newCombinedSchema = combineSchemas(state.formSchema, newSubFormSchemas);
            return Object.assign(Object.assign({}, state), { subFormSchemas: newSubFormSchemas, combinedSchema: newCombinedSchema });
        }
        case 'registerSubSchema': {
            const newSubFormSchemas = cloneDeep(Object.assign(Object.assign({}, state.subFormSchemas), { [action.name]: action.schema }));
            const newCombinedSchema = combineSchemas(state.formSchema, newSubFormSchemas);
            return Object.assign(Object.assign({}, state), { subFormSchemas: newSubFormSchemas, combinedSchema: newCombinedSchema });
        }
        case 'setIsDisabled': {
            return Object.assign(Object.assign({}, state), { disabled: action.isDisabled });
        }
        case 'setIsReadOnly': {
            return Object.assign(Object.assign({}, state), { readOnly: action.isReadOnly });
        }
        default:
            throw new Error(`unknown action ${String(action)}`);
    }
}
const initialContext = {
    state: defaultState$1,
    dispatch: () => {
        /* empty function */
    }
};
const FormContext = React__default.createContext(initialContext);
function FormProvider({ children, initialState = {} }) {
    const [state, dispatch] = React__default.useReducer(reducer$2, Object.assign(Object.assign({}, defaultState$1), initialState));
    const contextValue = React__default.useMemo(() => {
        return {
            state,
            dispatch
        };
    }, [state]);
    return (React__default.createElement(FormContext.Provider, { value: contextValue }, children));
}
function useInternalFormContext() {
    const { dispatch, state } = React__default.useContext(FormContext);
    const registerSchema = React__default.useCallback((schema) => {
        dispatch({ type: 'registerSchema', schema });
    }, [dispatch]);
    const registerSubSchema = React__default.useCallback((name, schema) => {
        dispatch({ type: 'registerSubSchema', name, schema });
    }, [dispatch]);
    const unRegisterSubSchema = React__default.useCallback((name) => {
        dispatch({
            type: 'unRegisterSubSchema',
            name
        });
    }, [dispatch]);
    const setIsDisabled = React__default.useCallback((isDisabled) => {
        dispatch({
            type: 'setIsDisabled',
            isDisabled
        });
    }, [dispatch]);
    const setIsReadOnly = React__default.useCallback((isReadOnly) => {
        dispatch({
            type: 'setIsReadOnly',
            isReadOnly
        });
    }, [dispatch]);
    return {
        inForm: Boolean(state.inForm),
        clearSchemaOnUnmount: state.clearSchemaOnUnmount,
        disabled: state.disabled,
        formId: state.formId,
        formSchema: state.combinedSchema,
        readOnly: state.readOnly,
        registerSchema: registerSchema,
        registerSubSchema: registerSubSchema,
        setIsDisabled: setIsDisabled,
        setIsReadOnly: setIsReadOnly,
        subFormSchemas: state.subFormSchemas,
        unRegisterSubSchema: unRegisterSubSchema
    };
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Given a field's name, looks up the validation schema for this field. Requires
 * `FormProvider` being present higher up in the tree. This allows
 * the validation schema to drive things like label and required values.
 */
function useFieldSchema(name) {
    var _a;
    const form = useInternalFormContext();
    /**
     * We cast this as a partial because we may not be in a form which would result in useFormContext
     * returning undefined. This partial enforces that Typescript will give us an error if we don't check
     * that these functions are defined before using them.
     */
    const { getValues, trigger, watch } = ((_a = useFormContext$1()) !== null && _a !== void 0 ? _a : {});
    const path = React__default.useMemo(() => {
        if (!name) {
            return undefined;
        }
        const nameInParts = name.split('.');
        // remove the last element from the list
        nameInParts.pop();
        // return the path of the field, excluding the field name
        return nameInParts.join('.');
    }, [name]);
    const fieldSchema = React__default.useMemo(() => {
        if (!name) {
            return undefined;
        }
        try {
            return Yup.reach(form.formSchema, name);
        }
        catch (_a) {
            // Yup.reach will throw an error if it doesn't find a field via the name.
            return undefined;
        }
    }, [form.formSchema, name]);
    const [fieldDetails, setFieldDetails] = React__default.useState(() => {
        if (!fieldSchema) {
            return null;
        }
        const context = getValues && getValues();
        return getFieldDetails({
            context,
            parent: path ? getValues && getValues(path) : context,
            schema: fieldSchema
        });
    });
    const assignFieldDetails = React__default.useCallback(({ context, name, parent, schema }) => {
        const newFieldDetails = getFieldDetails({
            context,
            parent,
            schema
        });
        setFieldDetails((oldFieldDetails) => {
            /**
             * Only override the state value if the field details have changed. This prevents
             * unnecessary re-renders.
             */
            if ((oldFieldDetails === null || oldFieldDetails === void 0 ? void 0 : oldFieldDetails.desired) !== newFieldDetails.desired ||
                (oldFieldDetails === null || oldFieldDetails === void 0 ? void 0 : oldFieldDetails.label) !== newFieldDetails.label ||
                (oldFieldDetails === null || oldFieldDetails === void 0 ? void 0 : oldFieldDetails.required) !== newFieldDetails.required) {
                /**
                 * Trigger the validation of the field in question since their required details have changed.
                 * react-hook-form does not validate the entire form every time a field value changes (see https://github.com/orgs/react-hook-form/discussions/2612#discussioncomment-52369 and
                 * https://github.com/react-hook-form/react-hook-form/issues/3642#issuecomment-742086058 from the maintainer).
                 */
                trigger && trigger(name);
                return newFieldDetails;
            }
            else {
                return oldFieldDetails;
            }
        });
    }, [trigger]);
    // Anytime our field schema changes, we need to update the field details
    React__default.useEffect(() => {
        if (!fieldSchema || !name) {
            return;
        }
        assignFieldDetails({
            schema: fieldSchema,
            name,
            context: getValues && getValues(),
            parent: path ? getValues && getValues(path) : getValues && getValues()
        });
    }, [assignFieldDetails, fieldSchema, getValues, name, path]);
    React__default.useEffect(() => {
        var _a;
        if (!fieldSchema || !name) {
            return;
        }
        // @ts-expect-error Accessing private variable
        const conditions = fieldSchema.conditions;
        let includesContextScope = false;
        const dependencies = (_a = conditions === null || conditions === void 0 ? void 0 : conditions.flatMap((condition) => {
            return condition.refs.map((ref) => {
                if (ref.isContext) {
                    includesContextScope = true;
                }
                if (!path) {
                    return ref.key;
                }
                else {
                    return `${path}.${ref.key}`;
                }
            });
        })) !== null && _a !== void 0 ? _a : [];
        if (!(conditions === null || conditions === void 0 ? void 0 : conditions.length)) {
            return;
        }
        /**
         * The schema has changed and there are conditions. We should trigger validation to ensure react-hook-form
         * is reporting the correct error state for all visible fields.
         */
        trigger && trigger(name);
        /**
         * Creates a subscription that watches for field value changes BUT does not cause the top level Form to re-render (like would be the case
         * if we did not use the watch callback syntax). This is important because we don't want to re-render the entire form every time a field
         * value changes. We only want to re-render the fields that are affected by the change.
         */
        const subscription = watch &&
            watch((data, { name: fieldThatChanged, type }) => {
                if (!fieldThatChanged ||
                    // type will be undefined when we add a new row
                    (type !== 'change' && type !== undefined) ||
                    path === undefined) {
                    return;
                }
                /**
                 * If our condition relies on the entire context OR the path of the dependency matches the field that changed,
                 * we need to update the field details.
                 */
                if (includesContextScope ||
                    dependencies.some((dependencyPath) => dependencyPath === fieldThatChanged)) {
                    const parent = path ? get(data, path) : data;
                    assignFieldDetails({
                        schema: fieldSchema,
                        name,
                        context: getValues && getValues(),
                        parent: parent
                    });
                }
            });
        return () => subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
    }, [assignFieldDetails, fieldSchema, getValues, name, path, trigger, watch]);
    return {
        form: {
            disabled: form.disabled,
            readOnly: form.readOnly
        },
        field: fieldDetails
    };
}
const getFieldDetails = ({ context, parent, schema }) => {
    const field = schema.describe({
        parent,
        context
    });
    return {
        label: field.label,
        required: !!field.tests.find((t) => t.name === 'required') || !field.optional,
        desired: !!field.tests.find((t) => t.name === 'desired')
    };
};

const SubFormContext = React__default.createContext(undefined);
function useInternalSubFormContext() {
    const subForm = React__default.useContext(SubFormContext);
    const { formId, subFormSchemas } = useInternalFormContext();
    return React__default.useMemo(() => {
        /**
         * If our nearest form context has an id that matches our subForm's parent form id, return the name and the schema of the subForm.
         * Otherwise, other subSchemas' names would be added to this sub-schema's chained name, even though they
         * are not part of the current form context.
         */
        if (subForm && formId && subForm.parentFormId === formId) {
            return {
                name: subForm.name,
                subFormSchema: subFormSchemas[subForm.name]
            };
        }
        return { name: undefined, subFormSchema: undefined };
    }, [formId, subForm, subFormSchemas]);
}

const useFieldSchemaName = (name) => {
    const subForm = useInternalSubFormContext();
    return subForm.name ? `${subForm.name}.${name}` : name;
};

const DRAGGING_TIMEOUT = 250;
const useFileDragging = () => {
    const [dragging, setDragging] = React__default.useState(false);
    const [dragType, setDragType] = React__default.useState(null);
    React__default.useEffect(() => {
        let timer = setTimeout(() => {
            setDragging(false);
        }, DRAGGING_TIMEOUT);
        const dragStartListener = () => {
            // dragStart only happens for elements, not files.
            setDragType('element');
        };
        const dragEndListener = () => {
            // dragEnd also only happens for elements, not files.
            setDragType(null);
        };
        const dragListener = (e) => {
            CancelNativeEvent(e);
            // This controls the cursor message that the OS supplies.
            // we need to find a way to set this to "None" for this hook,
            // but override it in the FileDropZone component to copy.
            if (e.dataTransfer)
                e.dataTransfer.dropEffect = 'copy';
            // dragOver events happen continuously.
            // OS File dragging does not trigger dragStart or dragEnd
            // We need to set a timeout to determine when the dragging has stopped.
            setDragging(true);
            setDragType((prev) => prev !== null && prev !== void 0 ? prev : 'file');
            clearTimeout(timer);
            timer = setTimeout(() => {
                setDragging(false);
                setDragType((prev) => (prev !== 'file' ? prev : null));
            }, DRAGGING_TIMEOUT);
        };
        window.addEventListener('dragover', dragListener);
        window.addEventListener('dragstart', dragStartListener);
        window.addEventListener('dragend', dragEndListener);
        return () => {
            window.removeEventListener('dragover', dragListener);
            window.removeEventListener('dragstart', dragStartListener);
            window.removeEventListener('dragend', dragEndListener);
            clearTimeout(timer);
        };
    }, []);
    return { dragActive: dragging && dragType === 'file' };
};

function useFormContext() {
    const fc = useFormContext$1();
    const form = useInternalFormContext();
    return Object.assign(Object.assign({ disabled: form === null || form === void 0 ? void 0 : form.disabled, readOnly: form === null || form === void 0 ? void 0 : form.readOnly }, fc), { useWatch });
}

function useGetFormSectionStatus(fieldNames) {
    const formContext = useFormContext$1();
    if (!formContext) {
        ADSError('useGetFormSectionStatus - no form context detected');
    }
    const { getValues, setValue, formState: { isSubmitted, touchedFields, errors }, getFieldState } = formContext;
    const isTouched = some$1(fieldNames, (name) => has(touchedFields, name));
    const containError = some$1(fieldNames, (name) => has(errors, name));
    const onBlur = () => {
        /**
         * When the user blurs this section, if they touched any fields, we go ahead
         * and touch all the fields so all validation messages are displayed. We see
         * this as an action that the user missed fields in this section we want to
         * alert them to.
         *
         * We have to use `getFieldState` here instead of `isTouched` because the `touchedFields`
         * value is one render behind. When using this hook within the Accordion, it would require touching
         * a field twice before the validation messages would show.
         */
        if (some$1(fieldNames, (name) => getFieldState(name).isTouched)) {
            const fieldValues = getValues(fieldNames).reduce((values, v, i) => {
                values[fieldNames[i]] = v;
                return values;
            }, {});
            for (const [name, value] of Object.entries(fieldValues)) {
                setValue(name, value, { shouldTouch: true, shouldValidate: true });
            }
        }
    };
    const state = {
        status: FormValidationState.None,
        onBlur
    };
    // If form is submitted and not valid, and one of our fields has an error return error state
    if (isSubmitted && containError) {
        state.status = FormValidationState.Error;
        return state;
    }
    // If the form has not been submitted, but any of our fields has an error AND has been touched,
    // display an error
    if (isTouched) {
        // If none of our fields contain an error we can assume this section is valid.
        if (!containError) {
            state.status = FormValidationState.Success;
            return state;
        }
        // If we contain an error, and that particular field that has an error has also been touched
        // then we are in error state.
        if (some$1(fieldNames, (name) => has(errors, name) && has(touchedFields, name))) {
            state.status = FormValidationState.Error;
            return state;
        }
    }
    return state;
}

function useIsFirstRun() {
    // Track which ids have ran
    const mapRef = React__default.useRef(new Map());
    // useEffects should place a register function at the end of their funciton body.
    const registerRun = React__default.useCallback((id) => {
        mapRef.current.set(id, true);
    }, []);
    // It's their first run if we don't have a record for them. If we do, it's a 2nd-n run.
    const isFirstRun = React__default.useCallback((id) => !mapRef.current.get(id), []);
    return { registerRun, isFirstRun };
}

const FIRST_NON_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/;
// Returns the passed in locale or the Theme's set locale
function useLocale(locale) {
    var _a;
    const context = React__default.useContext(ADSContext);
    const effectiveLocale = (_a = locale !== null && locale !== void 0 ? locale : context === null || context === void 0 ? void 0 : context.locale) !== null && _a !== void 0 ? _a : 'en-US';
    const localeData = React__default.useMemo(() => {
        const baseLocaleData = LocaleDataMap[effectiveLocale];
        const delimiter = extractDelimiter(baseLocaleData.date);
        const configuredDateOrderFormat = context === null || context === void 0 ? void 0 : context.configuration.dateOrderFormat;
        const { dateFormat, dateOrderFormat } = determineFormats({
            baseFormat: baseLocaleData.date,
            delimiter,
            configuredDateOrderFormat
        });
        return Object.assign(Object.assign({}, baseLocaleData), { date: dateFormat, dateDelimiter: delimiter, dateOrderFormat });
    }, [context === null || context === void 0 ? void 0 : context.configuration.dateOrderFormat, effectiveLocale]);
    return {
        locale: effectiveLocale,
        localeData
    };
}
// Extract the delimiter from the date format string
function extractDelimiter(dateFormat) {
    var _a, _b;
    return (_b = (_a = dateFormat.match(FIRST_NON_ALPHANUMERIC_REGEX)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '/';
}
// Determine the date format and order format based on inputs
function determineFormats({ baseFormat, delimiter, configuredDateOrderFormat }) {
    const formatParts = baseFormat.split(delimiter);
    if (configuredDateOrderFormat) {
        // Use the configured date order format
        return {
            dateFormat: applyConfiguredOrderFormat(formatParts, configuredDateOrderFormat, delimiter),
            dateOrderFormat: configuredDateOrderFormat
        };
    }
    else {
        // Derive date order format from the base format
        const derivedDateOrderFormat = deriveOrderFormat(formatParts);
        return {
            dateFormat: baseFormat,
            dateOrderFormat: derivedDateOrderFormat
        };
    }
}
// Apply a configured order format to date format parts
function applyConfiguredOrderFormat(formatParts, orderFormat, delimiter) {
    return orderFormat
        .split('') // split the date order format into an array of characters
        .map((orderPart) => {
        return formatParts.find((formatPart) => formatPart.toLowerCase().startsWith(orderPart.toLowerCase()));
    })
        .join(delimiter);
}
// Derive the order format from format parts
function deriveOrderFormat(formatParts) {
    return formatParts
        .map((part) => part[0].toUpperCase())
        /**
         * Casting is not recommended but we have tests that ensure this is always a valid date order format.
         * If new locales or date order formats are added, our tests will fail with Typescript errors.
         */
        .join('');
}

function useNotifications() {
    const adsContext = React__default.useContext(ADSContext);
    const removeNotification = (id, dismissalMethod = DismissedBy.Programmatically, cb) => {
        adsContext === null || adsContext === void 0 ? void 0 : adsContext.setNotificationState((state) => {
            const notificationToRemove = state.notifications.find((n) => n.id === id);
            if (notificationToRemove && notificationToRemove.onRemoved) {
                notificationToRemove.onRemoved(dismissalMethod, notificationToRemove);
            }
            const newState = {
                notifications: state.notifications.filter((notification) => notification.id !== id)
            };
            cb && cb(!!notificationToRemove, newState.notifications);
            return newState;
        });
    };
    const addNotification = (items, onNotificationAdded) => {
        items = Array.isArray(items) ? items : [items];
        // We need to generate a unique id used to track this notification.
        const newNotifications = items.map((i) => {
            return Object.assign(Object.assign({}, i), { 
                // We tack on our id and dismissal func here converting this from a
                // NotificationItem to a full NotificationProp object.
                id: UUIDv4(), onDismissal: removeNotification });
        });
        adsContext === null || adsContext === void 0 ? void 0 : adsContext.setNotificationState((state) => {
            const newState = {
                notifications: [...newNotifications, ...state.notifications]
            };
            onNotificationAdded && onNotificationAdded(newState.notifications);
            return newState;
        });
    };
    return { addNotification, removeNotification };
}

const observerEntries = new Map();
const dimensionsChanged = (observeOptions, prevDimensions, newDimensions) => {
    switch (observeOptions) {
        case 'all':
            return (prevDimensions.width !== newDimensions.width ||
                prevDimensions.height !== newDimensions.height);
        case 'width':
            return prevDimensions.width !== newDimensions.width;
        case 'height':
            return prevDimensions.height !== newDimensions.height;
        default:
            return false;
    }
};
const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
        const observerEntry = observerEntries.get(entry.target);
        if (!observerEntry)
            continue;
        const newDimensions = {
            width: entry.contentRect.width,
            height: entry.contentRect.height
        };
        const { observeOptions, prevDimensions, throttledOnResize } = observerEntry;
        if (!dimensionsChanged(observeOptions, prevDimensions, newDimensions))
            continue;
        throttledOnResize(newDimensions, prevDimensions);
        observerEntry.prevDimensions = newDimensions;
    }
});
/**
 * A custom hook that observes dimension changes of an HTML element.
 * Can be configured to watch for height, width, or both.
 *
 * @remarks
 *
 * This hook can only be used once per element ref.
 */
function useResizeObserver({ ref, throttleAmount = 0, onResize, observeOptions = 'all' }) {
    React__default.useEffect(() => {
        const currentRef = ref.current;
        if (currentRef) {
            const entry = {
                observeOptions,
                prevDimensions: {
                    width: currentRef.clientWidth,
                    height: currentRef.clientHeight
                },
                throttledOnResize: throttle((newDimensions, prevDimensions) => {
                    onResize(newDimensions, prevDimensions);
                }, throttleAmount)
            };
            observerEntries.set(currentRef, entry);
            observer.observe(currentRef);
            // Manually call the onResize callback when the component loads
            const initialDimensions = {
                width: currentRef.clientWidth,
                height: currentRef.clientHeight
            };
            entry.throttledOnResize(initialDimensions, initialDimensions);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
                observerEntries.delete(currentRef);
            }
        };
    }, [ref, onResize, observeOptions, throttleAmount]);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function useRestrictedChildType(name, allowedChildTypes, children) {
    React__default.useEffect(() => {
        const displayError = (foundType) => {
            console.error(`Invalid Child Type: <${name}> detected children of type <${foundType}>. Only children of type <${allowedChildTypes}> are allowed.`);
            return;
        };
        // Filter out any children that aren't react components (i.e. null or undefined)
        React__default.Children.toArray(children)
            .filter(React__default.isValidElement)
            .forEach((child) => {
            var _a;
            const childName = child === null ? null : (_a = child.type.displayName) !== null && _a !== void 0 ? _a : child.type.name;
            if (!allowedChildTypes.includes(childName)) {
                displayError(childName);
            }
        });
    }, [name, children, allowedChildTypes]);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
function useSubFormContext(name) {
    var _a, _b;
    const { setValue } = useFormContext$1();
    const subForm = useInternalSubFormContext();
    // if they pass in a path use that, otherwise we default to the SubForm context we find
    const path = (_a = name !== null && name !== void 0 ? name : subForm.name) !== null && _a !== void 0 ? _a : '';
    useADSWarnOnce('useSubFormContext() was used and was not a child of a <SubForm> nor was it given a name of a subForm.', !subForm.name && !name);
    const setSubFormValue = React__default.useCallback((fieldName, value, opts) => {
        setValue(`${path}.${fieldName}`, value, opts);
    }, [setValue, path]);
    const subFormValues = (_b = useWatch({ name: path })) !== null && _b !== void 0 ? _b : {};
    return {
        subFormValues,
        setSubFormValue
    };
}

function useSubFormPath() {
    const { name } = useInternalSubFormContext();
    if (!name) {
        ADSWarn('useSubFormPath() was used and was not a child of a <SubForm>.');
    }
    return name !== null && name !== void 0 ? name : '';
}

function useToast() {
    const adsContext = React__default.useContext(ADSContext);
    const burnToast = (id, dismissalMethod = DismissedBy.Programmatically, cb) => {
        adsContext === null || adsContext === void 0 ? void 0 : adsContext.setToastState((state) => {
            const toastToRemove = state.toasts.find((n) => n.id === id);
            if (toastToRemove && toastToRemove.onRemoved) {
                toastToRemove.onRemoved(dismissalMethod, toastToRemove);
            }
            const newState = {
                toasts: state.toasts.filter((toast) => toast.id !== id)
            };
            cb && cb(!!toastToRemove, newState.toasts);
            return newState;
        });
    };
    const addToast = (items, onToastAdded) => {
        items = Array.isArray(items) ? items : [items];
        // We need to generate a unique id used to track this toast.
        const newToasts = items.map((i) => {
            return Object.assign(Object.assign({}, i), { 
                // We tack on our id and dismissal func here converting this from a
                // ToastItem to a full ToastProp object.
                id: UUIDv4(), onDismissal: burnToast });
        });
        adsContext === null || adsContext === void 0 ? void 0 : adsContext.setToastState((state) => {
            const newState = {
                toasts: [...newToasts, ...state.toasts]
            };
            onToastAdded && onToastAdded(newState.toasts);
            return newState;
        });
    };
    return { addToast, removeToast: burnToast };
}

/**
 * If and only if the returned function is called, then its referential equality is broken.
 *
 * @returns The callable function.
 *
 * @see{@link Trigger}
 */
function useTrigger() {
    const [cycle, setCycle] = React__default.useState(() => 0);
    const previousCycleRef = React__default.useRef(null);
    const setterRef = React__default.useRef(incrementCycle(setCycle));
    const trigger = React__default.useMemo(() => {
        // edge case: do not allow useMemo's cache purges to break referential equality
        if (cycle === previousCycleRef.current) {
            return setterRef.current;
        }
        /**
         * At this point, we can assume the trigger function has been invoked.
         *
         * We need to do (2) things.
         *
         * Algorithm:
         * 1) Update the {@link cycle} state (reactive memory) to ensure a new render will occur.
         * 2) Increment "this cycle" to be the new {@link previousCycleRef}.
         * 3) Update the {@link trigger} function's reference to break referential equality.
         */
        // 1) Update the cycle state (reactive memory) to ensure a new render will occur.
        setterRef.current = incrementCycle(setCycle);
        // 2) Increment "this cycle" to be the new {@link previousCycleRef}.
        previousCycleRef.current = cycle;
        // 3) Update the trigger function's reference to break referential equality.
        return setterRef.current;
    }, [cycle]);
    return trigger;
}
/**
 * Given a current {@link cycle} (number), we want to increment it by one.
 *
 * However, we need to ensure that the cycle is an integer and does not overflow.
 *
 * @param setCycle
 * @returns
 */
function incrementCycle(setCycle) {
    /**
     * Given a current {@link cycle} (number), we want to:
     *
     * Algorithm:
     * 1) Ensure the existing cycle is an integer.
     * 2) Check if the existing cycle will overflow if incremented.
     * 3.A) If the next cycle [OVERFLOWS], set it to {@link Number.MIN_SAFE_INTEGER}.
     * 3.B) If the next cycle will [NOT] overflow, increment the current by one.
     */
    const incr = () => {
        setCycle((prevCycle) => {
            // 1) Ensure the existing cycle is an integer.
            const prevCycleInt = Math.round(prevCycle);
            // 2) Check if the existing cycle will overflow if incremented.
            if (prevCycleInt >= Number.MAX_SAFE_INTEGER) {
                // 3.A) If the next cycle [OVERFLOWS], set it to {@link Number.MIN_SAFE_INTEGER}.
                return Number.MIN_SAFE_INTEGER;
            }
            // 3.B) If the next cycle will [NOT] overflow, increment the current by one.
            return prevCycleInt + 1;
        });
    };
    return incr;
}

const BUFFER_PIXEL_SIZE = 10;
// This hook does the heavy lifting of calculating which section of an array should be
// rendered to the user to avoid having to render the whole list. It also handles
// the items in the array being different heights. Instead of returning a slice of the
// array it returns the start and end indices, along with the spacing
function useVariableVirtualList({ rowCount = 0, windowHeight = 0, windowRef, opened = 0 }) {
    const [state, setState] = React__default.useState({
        initialRender: false,
        virtualRange: {
            start: 0,
            end: 0
        },
        spacing: { before: 0, after: 0 }
    });
    // Start a new cache and use a ref so we retain the same reference to the cache
    // on every re-render.
    const cacheRef = React__default.useRef(null);
    const heightCache = () => {
        if (cacheRef.current === null) {
            cacheRef.current = new ListHeightCache();
        }
        return cacheRef.current;
    };
    const setVirtualRows = React__default.useCallback((scrollTop) => {
        const BUFFERROWS = 6;
        /**
         * We have three areas to deal with here.
         *  1. beforeGap - the area before the viewing area
         *  2. viewingArea - the area the user can view
         *  3. afterGap - the area below the viewingArea.
            --------------
           |              |
           |  beforeGap   |
           |              |
          a --------------
           |              |
           |              |
           |  viewingArea |
           |              |
           |              |
          b --------------
           |              |
           |  afterGap    |
           |              |
            --------------
         */
        // Figure out endIndex of beforeGap (point a above)
        const beforeGapEndIndex = heightCache().getRangeFromHeight(scrollTop)[1];
        // Calculate the range of the viewable area. This will return point
        // a (minus bufferrows) and point b (plus bufferrows).
        const [startIndex, endIndex] = heightCache().getRangeFromHeight(windowHeight, beforeGapEndIndex);
        // Make sure we don't start below zero and don't end past the last index.
        // Also take into account our buffer rows.
        const start = Math.max(0, startIndex - BUFFERROWS - Math.abs(opened));
        const end = Math.min(rowCount, endIndex + BUFFERROWS + Math.abs(opened));
        const isAtStart = start === 0;
        const isAtEnd = end === rowCount;
        const spacing = {
            before: !isAtStart ? heightCache().getHeightFromRange(0, start) : 0,
            after: !isAtEnd ? heightCache().getHeightFromRange(end, rowCount) : 0
        };
        setState({
            initialRender: false,
            virtualRange: { start, end },
            spacing
        });
    }, [rowCount, setState, windowHeight, opened]);
    const handleScroll = React__default.useCallback(() => {
        if (windowRef && windowRef.current) {
            setVirtualRows(windowRef.current.scrollTop);
        }
    }, [windowRef, setVirtualRows]);
    // Everytime a row is rendered it's height is reported here.
    const updateRowHeight = React__default.useCallback((index, height) => {
        const updated = heightCache().set(index, height);
        // If we detect a row's height changed, we need to recaculate
        // which virtual rows we need rendrered along with our before and after
        // space, but only if it's changed from the last run.
        if (updated) {
            handleScroll();
        }
    }, [handleScroll]);
    const scrollToIndex = React__default.useCallback((index, visibilityBehaviorConfig) => {
        var _a;
        if (!windowRef || !windowRef.current) {
            return;
        }
        const height = heightCache().getHeightFromRange(0, index);
        // If the visibility behavior config is set to only scroll if hidden, we need to determine if the row is fully visible and scroll accordingly.
        if (visibilityBehaviorConfig === null || visibilityBehaviorConfig === void 0 ? void 0 : visibilityBehaviorConfig.onlyScrollIfHidden) {
            // STEP 1: DETERMINE IF WE NEED TO SCROLL
            // Figure out the endIndex of the beforeGap
            const beforeGapEndIndex = heightCache().getRangeFromHeight(windowRef.current.scrollTop)[1];
            // The easiest way to grab the column header element is to grab the first child of the windowRef (which should always be the column header).
            // Note: If there is ever a change to the structure of the windowRef, this will need to be updated.
            const columnHeader = windowRef.current.firstElementChild;
            // Since the column header is considered part of the windowHeight,
            // we need to remove it from the windowHeight when calculating the afterGapStartIndex.
            // This gives us the "true" viewable area (everything from below the column header to above the footer).
            const afterGapStartIndex = heightCache().getRangeFromHeight(windowRef.current.scrollTop + windowHeight - columnHeader.offsetHeight)[1];
            // If the row is fully visible (i.e., not completely or partially hidden), we don't want to scroll.
            if (index > beforeGapEndIndex && index < afterGapStartIndex)
                return;
            // STEP 2: DETERMINE WHERE TO SCROLL
            // The buffer helps ensure that rows which are just out of view are brought into view, providing a smoother user experience.
            // Specifically, the afterGapStartIndexWithBuffer is calculated by adding a small buffer (10 pixels) to the scroll position.
            // This ensures that if a row is just below the viewable area, it will be scrolled into view, making the scrolling behavior more intuitive and responsive.
            const afterGapStartIndexWithBuffer = heightCache().getRangeFromHeight(windowRef.current.scrollTop +
                (windowHeight - columnHeader.offsetHeight) +
                BUFFER_PIXEL_SIZE)[1];
            // Determine if we should scroll the row to the bottom of the viewable area based on if the row is partially hidden at the bottom and the visibility behavior config.
            const shouldScrollToBottom = ((_a = visibilityBehaviorConfig.partialHiddenConfig) === null || _a === void 0 ? void 0 : _a.atBottom) ===
                'scrollToBottom' &&
                (index === afterGapStartIndex ||
                    index === afterGapStartIndexWithBuffer);
            // VARIABLE BREAKDOWN:
            // - height: the height from the top of the list (row 0) to the row we want to scroll to (index).
            // - windowHeight: the height of the viewable area from the top of the column header to the bottom of the list (excluding the footer)
            // - columnHeader.offsetHeight: the height of the column header
            // - heightCache().get(index): the height of the row we want to scroll to
            if (shouldScrollToBottom) {
                const windowHeightWithoutColHeader = windowHeight - columnHeader.offsetHeight;
                const rowHeight = heightCache().get(index);
                windowRef.current.scrollTop =
                    height - windowHeightWithoutColHeader + rowHeight;
            }
            else {
                windowRef.current.scrollTop = height;
            }
            handleScroll();
        }
        else {
            windowRef.current.scrollTop = height;
            handleScroll();
        }
    }, [windowRef, windowHeight, handleScroll]);
    const resetHeightCache = React__default.useCallback(() => {
        // We need to clear our cache if we toggle all our row containers. This will
        // reset the default height and update our calculation of how much space we need
        // to make the scrollbar accurate.
        heightCache().clear();
    }, []);
    // Run through the entire list of nested items - any that are closed, set their height to 0.
    const setNestedHeights = React__default.useCallback((ocCache, rows) => {
        const defaultRowHeight = heightCache().getDefaultHeight;
        if (rows && defaultRowHeight) {
            let updated = false;
            rows.forEach((c) => {
                const rowOpen = ocCache.parentsOpen(c.index); // if row is a parent, this is always true.
                const rowCurrentHeight = heightCache().get(c.index);
                if (rowOpen && rowCurrentHeight > 0) {
                    // if a row is open and has a unique height, don't change anything.
                    // if row was the default height, it would be undefined - and miss this condition.
                    return;
                }
                // if the the row is closed, set the height to 0.
                // if open, but its height was 0, set it to the default height.
                // note - scroll will adjust the height of the row if it's open to its real value.
                updated =
                    heightCache().set(c.index, rowOpen ? defaultRowHeight : 0) ||
                        updated;
            });
            if (updated)
                handleScroll();
        }
        else {
            handleScroll();
        }
    }, [handleScroll]);
    React__default.useEffect(() => {
        // This is a bit weird but we need to render one row if we haven't yet
        // so we can know the height of our rows, then we can render the rest.
        if (!heightCache().hasDefaultHeight) {
            setState({
                initialRender: true,
                virtualRange: { start: 0, end: 1 },
                spacing: { before: 0, after: 0 }
            });
        }
        else {
            // We need this so that every time rows change, we update our virtualRows
            handleScroll();
        }
    }, [setVirtualRows, rowCount, handleScroll, setState]);
    // TODO: Use interesction observer and see if it's more performant than scroll listener
    React__default.useEffect(() => {
        const windowEl = windowRef.current;
        if (windowEl && handleScroll) {
            const debouncedScroll = debounce(handleScroll, 10);
            // We need to add a passive (more performant) event listener to the scroll
            // event.
            windowEl.addEventListener('scroll', debouncedScroll, { passive: true });
            // We need to remove the event listener if this effect gets re-ran.
            return () => {
                if (windowEl)
                    windowEl.removeEventListener('scroll', debouncedScroll);
            };
        }
    }, [windowRef, handleScroll]);
    return Object.assign(Object.assign({}, state), { updateRowHeight,
        resetHeightCache,
        setNestedHeights,
        scrollToIndex });
}

/**
 * A custom React Hook that helps with building a fixed height virtual list. A virtual list
 * is where not all items are rendered in the DOM. Only the items the user will
 * see. The scrollbar is manipulated to look like it's a normal list with the items
 * always there, but items are rendered / removed from the DOM as the user scrolls.
 *
 * This hook returns back an object with the following properties:
 *    setWindowListEl - setter for passing in the dom el to the list container
 *    virtualItems - list of items that needs to be rendered in list
 *    listStyle - style block to be applied to the list element
 *    resetVirtualList - function to reset the virtualList back to position 0
 *
 * There are three pieces to make a virtual list work, the window element,
 * the list element, and then the virtual items in the list. Here is how they work:
 *
 *     Window Element - This is the top most parent for the virtual list. It is what sets the
 *                      height of the viewing window and how many items the list needs to render.
 *                      This element has to have a height or max-height set, and overflow-y needs
 *                      to be either scroll or auto.
 *     List Element -   This is a child of the window element and houses all the items that will be rendered.
 *                      It's height has to account for every item that COULD be rendered. So it's height is the
 *                      product of items.length times and the itemHeight. The listStyle object needs to be set
 *                      on this element. As the user scrolls the top padding will be updated so the scroll bar is
 *                      in the correct position.
 *     Virtual Items -  The items actually rendered are called the virtual items. Only the items the user can see through
 *                      the window element are rendered (plus some buffered items). As the user scrolls, items are
 *                      added and removed from this sub set of items.
 */
function useVirtualList({ rows, windowListEl, // reference to DOM El that will contain our list
windowHeight, // Height of the viewing area
itemHeight, // Height of each rendered item
bufferSize = 0 // how many extra rows we want to render
 }) {
    const [state, setState] = React__default.useState({
        rows: [],
        listStyle: {
            paddingTop: 0,
            height: windowHeight
        }
    });
    // This is the meat and potatoes of the virtual list hook. Depending on the
    // scrollTop value, we need to calculate our startIndex, endIndex, and the gap
    // we need to add to the top of the list for items we aren't going to render
    // but need to account for with padding.
    const setVirtualItems = React__default.useCallback((scrollTop) => {
        // startIndex is either 0 or the amount the user has scrolled divided
        // by our item height. We then subtract buffer if we can.
        const startIndex = Math.max(0, Math.floor(scrollTop / itemHeight) - bufferSize);
        // endIndex is either the end of our list of items (length - 1) or
        // the amount the user has scrolled plus the height of our window divided
        // by the item height, plus add in buffer if we can.
        const endIndex = Math.min(rows.length - 1, Math.floor((scrollTop + windowHeight) / itemHeight) + bufferSize);
        // We need to figure out how much of a gap we need to account for above
        // our first rendered item.
        const gapHeight = startIndex * itemHeight;
        // We need the height of the list to span all the possible items that
        // could be rendered.
        const listHeight = rows.length * itemHeight;
        // Set our virtual items based on our starting and ending index. We add one
        // to the endIndex because Array.slice extracts up to but not including the endIndex.
        setState({
            rows: rows.slice(startIndex, endIndex + 1),
            listStyle: {
                height: listHeight,
                paddingTop: gapHeight
            }
        });
    }, [bufferSize, itemHeight, rows, windowHeight, setState]);
    const onScroll = React__default.useCallback(() => {
        if (windowListEl) {
            setVirtualItems(windowListEl.scrollTop);
        }
    }, [setVirtualItems, windowListEl]);
    // Things don't kick off till we have a windowListEl set. If we do
    // then we bind a scroll event listener.
    React__default.useEffect(() => {
        if (windowListEl && onScroll) {
            // We need to add a passive (more performant) event listener to the scroll
            // event.
            windowListEl.addEventListener('scroll', onScroll, {
                passive: true
            });
            // We need to remove the event listener if this effect gets re-ran.
            return () => {
                windowListEl.removeEventListener('scroll', onScroll);
            };
        }
    }, [windowListEl, onScroll]);
    // We need to start with our first page of items otherwise the drawer is empty.
    // If our list isn't big enough to need a scroll bar then we are done.
    React__default.useEffect(() => {
        var _a;
        setVirtualItems((_a = windowListEl === null || windowListEl === void 0 ? void 0 : windowListEl.scrollTop) !== null && _a !== void 0 ? _a : 0);
    }, [setVirtualItems, windowListEl]);
    // Consumer sometimes needs to reset our list
    // (like when sorting happens, or dropdown is closed)
    const reset = React__default.useCallback(() => {
        if (windowListEl) {
            windowListEl.scrollTop = 0;
        }
        setVirtualItems(0);
    }, [windowListEl, setVirtualItems]);
    return {
        virtualList: Object.assign({ reset }, state)
    };
}

function useWindowSize(throttleTime = 100) {
    const [windowSize, setWindowSize] = React__default.useState({
        width: 0,
        height: 0
    });
    React__default.useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        const throttled = throttle$1(handleResize, throttleTime);
        // Add event listener
        window.addEventListener('resize', throttled);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', throttled);
    }, [throttleTime]); // Empty array ensures that effect is only run on mount
    return windowSize;
}

var css$2i = ".Icon_module_wrapper__5dda31e7{align-items:center;align-self:center;background:#0000;display:flex;height:100%;justify-content:center;text-align:center;width:100%}.Icon_module_wrapper__5dda31e7:focus{outline:none}.Icon_module_icon__5dda31e7{align-self:center;transition:all .2s cubic-bezier(.78,.14,.15,.86)}.Icon_module_icon__5dda31e7 svg:focus{outline:none}.Icon_module_disabled__5dda31e7 path{fill:#b0b4bf}.Icon_module_stroke__5dda31e7{stroke:currentColor}.Icon_module_stroke__5dda31e7 circle:first-child{stroke:#e5e6eb}.Icon_module_fill__5dda31e7{fill:currentColor}";
window.ADS.injectStyle(css$2i,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/Icon.module.scss");
var modules_c4937a59 = {"wrapper":"Icon_module_wrapper__5dda31e7","icon":"Icon_module_icon__5dda31e7","disabled":"Icon_module_disabled__5dda31e7","stroke":"Icon_module_stroke__5dda31e7","fill":"Icon_module_fill__5dda31e7"};

var css$2h = ".AddIcon_module_overrideStroke__c74d36c1{stroke:none!important}";
window.ADS.injectStyle(css$2h,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/AddIcon.module.scss");
var modules_ed86e5fe = {"overrideStroke":"AddIcon_module_overrideStroke__c74d36c1"};

const iconNativeSize = {
    AddIcon: 16,
    BackArrowIcon: 16,
    CalendarIcon: 16,
    CheckedCheckboxGroupIcon: 16,
    CheckCircle16Icon: 16,
    CheckmarkIcon: 12,
    ChevronDoubleIcon: 16,
    ChevronDoubleUpIcon: 16,
    ChevronIcon: 16,
    ChevronUpIcon: 16,
    ContactCard16Icon: 16,
    Copy12Icon: 12,
    CloseIcon: 20,
    ContactCardIcon: 32,
    CrossCircleIcon: 24,
    DashIcon: 16,
    DeleteIcon: 20,
    DesiredIndicatorIcon: 12,
    DocumentAnyIcon: 20,
    DocumentEmailIcon: 20,
    DocumentExcelIcon: 20,
    DocumentMultiFileIcon: 16,
    DocumentIcon: 16,
    DocumentImageIcon: 20,
    DocumentPDFIcon: 20,
    DocumentWordIcon: 20,
    DollarIcon: 16,
    DoNotIcon: 16,
    DownloadIcon: 16,
    EllipsisMessageBubble20Icon: 20,
    EnvelopeLetterIcon: 16,
    ErrorIcon: 24,
    ErrorIconFilled: 16,
    EyeIcon: 16,
    EyeOffIcon: 16,
    FilterIcon: 16,
    FolderIcon: 16,
    ForwardArrowIcon: 16,
    FrenchFriesIcon: 16,
    Gear20Icon: 20,
    GlobeIcon: 16,
    HamburgerIcon: 16,
    ICircle20Icon: 20,
    ICircleIcon: 16,
    InfoIcon: 24,
    InfoIconFilled: 16,
    LockIcon: 16,
    MeatballIcon: 16,
    OpenIcon: 16,
    PencilIcon: 16,
    PeopleIcon: 32,
    PercentIcon: 16,
    PhoneSlashIcon: 16,
    PlayIcon: 16,
    PoundIcon: 16,
    PrintIcon: 16,
    QuestionCircleIcon: 20,
    RefreshIcon: 16,
    RequiredIndicatorIcon: 12,
    RightwardTriangleIcon: 16,
    SearchIcon: 16,
    ShiftDownIcon: 16,
    ShiftUpIcon: 16,
    SixDotsIcon: 16,
    SmCloseIcon: 16,
    SortArrowIcon: 16,
    SpinnerIcon: 64,
    StarIcon: 12,
    SuccessIcon: 24,
    SuccessIconFilled: 16,
    TextBubblesIcon: 16,
    TrashCanIcon: 16,
    TriangleLeft16Icon: 16,
    TriangleRight16Icon: 16,
    Undo16Icon: 16,
    UploadIcon: 32,
    WarningIcon: 24,
    WarningIconFilled: 16
};
const viewBox = (icon) => `0 0 ${iconNativeSize[icon]} ${iconNativeSize[icon]}`;

const AddIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('AddIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C8.55228 2 9 2.44772 9 3V7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H9V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V9H3C2.44772 9 2 8.55228 2 8C2 7.44772 2.44772 7 3 7H7V3C7 2.44772 7.44772 2 8 2Z", className: `${fillClass} ${cx$1S(modules_ed86e5fe.overrideStroke)}` })));
};

var css$2g = ".BackArrowIcon_module_overrideStroke__1b505d84{stroke:none!important}";
window.ADS.injectStyle(css$2g,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/BackArrowIcon.module.scss");
var modules_b032e26f = {"overrideStroke":"BackArrowIcon_module_overrideStroke__1b505d84"};

const BackArrowIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('BackArrowIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.58682 4.08682C7.91096 3.76269 7.91096 3.23716 7.58682 2.91302C7.26269 2.58889 6.73716 2.58889 6.41302 2.91302L1.91302 7.41302C1.58889 7.73716 1.58889 8.26269 1.91302 8.58682L6.41302 13.0868C6.73716 13.411 7.26269 13.411 7.58682 13.0868C7.91096 12.7627 7.91096 12.2372 7.58682 11.913L4.50372 8.82992H13.4999C13.9583 8.82992 14.3299 8.45832 14.3299 7.99992C14.3299 7.54153 13.9583 7.16992 13.4999 7.16992H4.50372L7.58682 4.08682Z", className: `${fillClass} ${cx$1S(modules_b032e26f.overrideStroke)}` })));
};

const CalendarIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, viewBox: viewBox('CalendarIcon'), fill: "none", className: svgClass, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5.75 7.25H4.25V8.75H5.75V7.25Z", className: `${fillClass}` }),
        React.createElement("path", { d: "M8.75 7.25H7.25V8.75H8.75V7.25Z", className: `${fillClass}` }),
        React.createElement("path", { d: "M10.25 7.25H11.75V8.75H10.25V7.25Z", className: `${fillClass}` }),
        React.createElement("path", { d: "M11.75 10.25H10.25V11.75H11.75V10.25Z", className: `${fillClass}` }),
        React.createElement("path", { d: "M8.75 10.25H7.25V11.75H8.75V10.25Z", className: `${fillClass}` }),
        React.createElement("path", { d: "M5.75 10.25H4.25V11.75H5.75V10.25Z", className: `${fillClass}` }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 0C4.91421 0 5.25 0.335786 5.25 0.75V1H10.75V0.75C10.75 0.335786 11.0858 0 11.5 0C11.9142 0 12.25 0.335786 12.25 0.75V1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H3.75V0.75C3.75 0.335786 4.08579 0 4.5 0ZM4.5 3C4.08579 3 3.75 2.66421 3.75 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V3.875H13.75V3C13.75 2.58579 13.4142 2.25 13 2.25H12.25C12.25 2.66421 11.9142 3 11.5 3C11.0858 3 10.75 2.66421 10.75 2.25H5.25C5.25 2.66421 4.91421 3 4.5 3ZM2.25 13V5.125H13.75V13C13.75 13.4142 13.4142 13.75 13 13.75H3C2.58579 13.75 2.25 13.4142 2.25 13Z", className: `${fillClass}` })));
};

var css$2f = ".CheckCircle16Icon_module_overrideStroke__0605f0ec{stroke:none!important}";
window.ADS.injectStyle(css$2f,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/CheckCircle16Icon.module.scss");
var modules_9526b374 = {"overrideStroke":"CheckCircle16Icon_module_overrideStroke__0605f0ec"};

const cx$1P = classnames.bind(modules_9526b374);
const CheckCircle16Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('CheckCircle16Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1P(modules_9526b374.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1P(modules_9526b374.overrideStroke)}`, d: "M11.1062 7.0767C11.4334 6.74949 11.4334 6.21895 11.1062 5.89172C10.779 5.5645 10.2485 5.5645 9.92125 5.89172L7.1621 8.65088L6.07878 7.56754C5.75155 7.24034 5.22102 7.24034 4.89379 7.56754C4.56657 7.89475 4.56657 8.42531 4.89379 8.75252L6.56962 10.4283C6.89682 10.7555 7.42738 10.7555 7.75459 10.4283L11.1062 7.0767Z" })));
};

const CheckmarkIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, viewBox: viewBox('CheckmarkIcon'), fill: "none", className: svgClass, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.2325 1.8246C10.6055 2.09104 10.6919 2.60942 10.4255 2.98243L5.4254 9.98243C5.27593 10.1917 5.03789 10.3198 4.78091 10.3294C4.52392 10.339 4.27701 10.2289 4.11238 10.0314L1.61238 7.03135C1.31892 6.6792 1.3665 6.15583 1.71865 5.86238C2.0708 5.56892 2.59417 5.6165 2.88763 5.96865L4.69944 8.14282L9.07467 2.01757C9.34111 1.64456 9.85948 1.55816 10.2325 1.8246Z", className: `${fillClass}` })));
};

var css$2e = ".ChevronIcon_module_fill__ea09e4c8{fill:#585c6a}.ChevronIcon_module_up__ea09e4c8{transform:rotate(180deg)}.ChevronIcon_module_overrideStroke__ea09e4c8 path{stroke:none!important}";
window.ADS.injectStyle(css$2e,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ChevronIcon.module.scss");
var modules_a7afe8e4 = {"fill":"ChevronIcon_module_fill__ea09e4c8","up":"ChevronIcon_module_up__ea09e4c8","overrideStroke":"ChevronIcon_module_overrideStroke__ea09e4c8"};

// note - this icon is an intentional copy of the ChevronDoubleIcon and rotated to face down.
// it is copied to allow later modifications to not impact the corresponding facing up icon.
const ChevronDoubleIcon = ({ size, svgClass, fillClass = '' }) => {
    return (React__default.createElement("svg", { height: size, width: size, viewBox: viewBox('ChevronDoubleIcon'), fill: "none", className: `${svgClass} ${cx$1S(modules_a7afe8e4.up, modules_a7afe8e4.overrideStroke)}`, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M12.5869 12.4169C12.2628 12.741 11.7373 12.741 11.4131 12.4169L8.00004 9.0038L4.58694 12.4169C4.26281 12.741 3.73728 12.741 3.41315 12.4169C3.08901 12.0928 3.08901 11.5672 3.41315 11.2431L7.41314 7.2431C7.73728 6.91897 8.26281 6.91897 8.58694 7.2431L12.5869 11.2431C12.9111 11.5672 12.9111 12.0928 12.5869 12.4169Z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) }),
        React__default.createElement("path", { d: "M12.5869 7.4169C12.2628 7.74103 11.7373 7.74103 11.4131 7.4169L8.00004 4.0038L4.58694 7.4169C4.26281 7.74104 3.73728 7.74103 3.41315 7.4169C3.08901 7.09276 3.08901 6.56724 3.41315 6.2431L7.41314 2.2431C7.73728 1.91897 8.26281 1.91897 8.58694 2.2431L12.5869 6.2431C12.9111 6.56724 12.9111 7.09276 12.5869 7.4169Z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) })));
};

const ChevronDoubleUpIcon = ({ size, svgClass, fillClass = '' }) => {
    return (React__default.createElement("svg", { height: size, width: size, viewBox: viewBox('ChevronDoubleUpIcon'), fill: "none", className: `${svgClass} ${cx$1S(modules_a7afe8e4.overrideStroke)}`, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M12.5869 12.4169C12.2628 12.741 11.7373 12.741 11.4131 12.4169L8.00004 9.0038L4.58694 12.4169C4.26281 12.741 3.73728 12.741 3.41315 12.4169C3.08901 12.0928 3.08901 11.5672 3.41315 11.2431L7.41314 7.2431C7.73728 6.91897 8.26281 6.91897 8.58694 7.2431L12.5869 11.2431C12.9111 11.5672 12.9111 12.0928 12.5869 12.4169Z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) }),
        React__default.createElement("path", { d: "M12.5869 7.4169C12.2628 7.74103 11.7373 7.74103 11.4131 7.4169L8.00004 4.0038L4.58694 7.4169C4.26281 7.74104 3.73728 7.74103 3.41315 7.4169C3.08901 7.09276 3.08901 6.56724 3.41315 6.2431L7.41314 2.2431C7.73728 1.91897 8.26281 1.91897 8.58694 2.2431L12.5869 6.2431C12.9111 6.56724 12.9111 7.09276 12.5869 7.4169Z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) })));
};

const ChevronIcon = ({ size, svgClass, fillClass = '', focused }) => {
    const styles = {};
    if (focused) {
        styles.transform = 'rotate(180deg)';
    }
    return (React__default.createElement("svg", { height: size, width: size, viewBox: viewBox('ChevronIcon'), fill: "none", style: styles, className: `${svgClass} ${cx$1S(modules_a7afe8e4.overrideStroke)}`, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.293 5.293a1 1 0 0 1 1.414 0L8 9.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) })));
};

// note - this icon is an intentional copy of the ChevronIcon and rotated to face up.
// it is copied to allow later modifications to not impact the corresponding facing down icon.
const ChevronUpIcon = ({ size, svgClass, fillClass = '' }) => {
    return (React__default.createElement("svg", { height: size, width: size, viewBox: viewBox('ChevronUpIcon'), fill: "none", className: `${svgClass} ${cx$1S(modules_a7afe8e4.up, modules_a7afe8e4.overrideStroke)}`, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.293 5.293a1 1 0 0 1 1.414 0L8 9.586l4.293-4.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414z", className: fillClass ? fillClass : cx$1S(modules_a7afe8e4.fill) })));
};

var css$2d = ".CloseIcon_module_overrideStroke__48191ef7{stroke:none!important}";
window.ADS.injectStyle(css$2d,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/CloseIcon.module.scss");
var modules_2bf86810 = {"overrideStroke":"CloseIcon_module_overrideStroke__48191ef7"};

const CloseIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('CloseIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4.58529 3.41315C4.26116 3.08901 3.73563 3.08901 3.4115 3.41315C3.08736 3.73728 3.08736 4.26281 3.4115 4.58694L8.8246 10L3.4115 15.4131C3.08736 15.7373 3.08736 16.2628 3.4115 16.5869C3.73563 16.9111 4.26116 16.9111 4.58529 16.5869L9.9984 11.1738L15.4115 16.5869C15.7356 16.9111 16.2612 16.9111 16.5853 16.5869C16.9094 16.2628 16.9094 15.7373 16.5853 15.4131L11.1722 10L16.5853 4.58694C16.9094 4.26281 16.9094 3.73728 16.5853 3.41315C16.2612 3.08901 15.7356 3.08901 15.4115 3.41315L9.9984 8.82625L4.58529 3.41315Z", className: `${fillClass} ${cx$1S(modules_2bf86810.overrideStroke)}` })));
};

var css$2c = ".ContactCard16Icon_module_overrideStroke__a8fcf5ef{stroke:none!important}";
window.ADS.injectStyle(css$2c,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ContactCard16Icon.module.scss");
var modules_43c1edb8 = {"overrideStroke":"ContactCard16Icon_module_overrideStroke__a8fcf5ef"};

const cx$1O = classnames.bind(modules_43c1edb8);
const ContactCard16Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('ContactCard16Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1O(modules_43c1edb8.overrideStroke)}`, d: "M8.19915 8.75414C7.2923 8.41681 6.28398 7.99362 6.20154 7.72989V7.45389C6.39179 7.26989 6.53765 7.00616 6.62643 6.70563C6.8357 6.56457 6.89278 6.27017 6.71521 6.06164V5.44832C6.71521 4.81046 6.3474 4.375 5.51031 4.375C4.67321 4.375 4.3054 4.81046 4.3054 5.44832V6.06164C4.12784 6.27017 4.18491 6.56457 4.39418 6.70563C4.48297 7.0123 4.62882 7.26989 4.81907 7.45389V7.72989C4.73663 7.99362 3.72832 8.41068 2.82147 8.75414C2.74537 8.78481 2.69464 8.8584 2.69464 8.93814V9.80374C2.69464 9.91413 2.78342 10 2.89122 10H8.12305C8.23085 10 8.31964 9.91413 8.31964 9.80374V8.93814C8.31964 8.8584 8.2689 8.78481 8.1928 8.75414H8.19915Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1O(modules_43c1edb8.overrideStroke)}`, d: "M10.125 5.75C9.77982 5.75 9.5 6.02982 9.5 6.375C9.5 6.72018 9.77982 7 10.125 7H12.375C12.7202 7 13 6.72018 13 6.375C13 6.02982 12.7202 5.75 12.375 5.75H10.125Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1O(modules_43c1edb8.overrideStroke)}`, d: "M10.125 8C9.77982 8 9.5 8.27982 9.5 8.625C9.5 8.97018 9.77982 9.25 10.125 9.25H12.375C12.7202 9.25 13 8.97018 13 8.625C13 8.27982 12.7202 8 12.375 8H10.125Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1O(modules_43c1edb8.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M0 2.25C0 1.55964 0.559644 1 1.25 1H14.75C15.4404 1 16 1.55964 16 2.25V13.75C16 14.4404 15.4404 15 14.75 15H12.25C11.9048 15 11.625 14.7202 11.625 14.375V13.75C11.625 13.4048 11.3452 13.125 11 13.125C10.6548 13.125 10.375 13.4048 10.375 13.75V14.375C10.375 14.7202 10.0952 15 9.75 15H6.25C5.90482 15 5.625 14.7202 5.625 14.375V13.75C5.625 13.4048 5.34518 13.125 5 13.125C4.65482 13.125 4.375 13.4048 4.375 13.75V14.375C4.375 14.7202 4.09518 15 3.75 15H1.25C0.559644 15 0 14.4404 0 13.75V2.25ZM12.875 13.75C12.875 12.7145 12.0355 11.875 11 11.875C9.96447 11.875 9.125 12.7145 9.125 13.75H6.875C6.875 12.7145 6.03553 11.875 5 11.875C3.96447 11.875 3.125 12.7145 3.125 13.75H1.58C1.39775 13.75 1.25 13.6023 1.25 13.42V2.58C1.25 2.39775 1.39775 2.25 1.58 2.25H14.42C14.6023 2.25 14.75 2.39775 14.75 2.58V13.42C14.75 13.6023 14.6023 13.75 14.42 13.75H12.875Z" })));
};

var css$2b = ".ContactCardIcon_module_fill__65305e67{path-fill:#444750}.ContactCardIcon_module_overrideStroke__65305e67{stroke:none!important}";
window.ADS.injectStyle(css$2b,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ContactCardIcon.module.scss");
var modules_d648ffe1 = {"fill":"ContactCardIcon_module_fill__65305e67","overrideStroke":"ContactCardIcon_module_overrideStroke__65305e67"};

const cx$1N = classnames.bind(modules_d648ffe1);
const ContactCardIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: `${cx$1N(modules_d648ffe1.fill)} ${cx$1N(svgClass)}`, viewBox: viewBox('ContactCardIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${cx$1N(strokeClass, fillClass)}`, style: { stroke: 'none' }, d: "M15.8072 17.0066C14.3563 16.4669 12.743 15.7898 12.611 15.3678V14.9262C12.9154 14.6318 13.1488 14.2099 13.2909 13.729C13.6257 13.5033 13.717 13.0323 13.4329 12.6986V11.7173C13.4329 10.6967 12.8444 10 11.5051 10C10.1657 10 9.57723 10.6967 9.57723 11.7173V12.6986C9.29312 13.0323 9.38444 13.5033 9.71928 13.729C9.86133 14.2197 10.0947 14.6318 10.3991 14.9262V15.3678C10.2672 15.7898 8.65389 16.4571 7.20293 17.0066C7.08117 17.0557 7 17.1734 7 17.301V18.686C7 18.8626 7.14205 19 7.31454 19H15.6855C15.8579 19 16 18.8626 16 18.686V17.301C16 17.1734 15.9188 17.0557 15.7971 17.0066H15.8072Z" }),
        React.createElement("path", { className: `${cx$1N(strokeClass, fillClass)}`, style: { stroke: 'none' }, d: "M19 12C18.4477 12 18 12.4477 18 13C18 13.5523 18.4477 14 19 14H24C24.5523 14 25 13.5523 25 13C25 12.4477 24.5523 12 24 12H19Z" }),
        React.createElement("path", { className: `${cx$1N(strokeClass, fillClass)}`, style: { stroke: 'none' }, d: "M19 16C18.4477 16 18 16.4477 18 17C18 17.5523 18.4477 18 19 18H24C24.5523 18 25 17.5523 25 17C25 16.4477 24.5523 16 24 16H19Z" }),
        React.createElement("path", { className: `${cx$1N(strokeClass, fillClass)}`, style: { stroke: 'none' }, fillRule: "evenodd", clipRule: "evenodd", d: "M3 7C3 5.89543 3.89543 5 5 5H27C28.1046 5 29 5.89543 29 7V25C29 26.1046 28.1046 27 27 27H24C23.4477 27 23 26.5523 23 26V25C23 24.4477 22.5523 24 22 24C21.4477 24 21 24.4477 21 25V26C21 26.5523 20.5523 27 20 27H13C12.4477 27 12 26.5523 12 26V25C12 24.4477 11.5523 24 11 24C10.4477 24 10 24.4477 10 25V26C10 26.5523 9.55228 27 9 27H5C3.89543 27 3 26.1046 3 25V7ZM25 25C25 23.3431 23.6569 22 22 22C20.3431 22 19 23.3431 19 25H14C14 23.3431 12.6569 22 11 22C9.34315 22 8 23.3431 8 25H5V7H27V25H25Z" })));
};

var css$2a = ".Copy12Icon_module_overrideStroke__20fa76ec{stroke:none!important}";
window.ADS.injectStyle(css$2a,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/Copy12Icon.module.scss");
var modules_df69c716 = {"overrideStroke":"Copy12Icon_module_overrideStroke__20fa76ec"};

const cx$1M = classnames.bind(modules_df69c716);
const Copy12Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('Copy12Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1M(modules_df69c716.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M2.7618 1.995C2.33829 1.995 1.99498 2.33832 1.99498 2.76182V6.335C1.99498 6.70227 1.69725 7 1.32998 7C0.962709 7 0.664978 6.70227 0.664978 6.335V2.76182C0.664978 1.60378 1.60376 0.665001 2.7618 0.665001H6.335C6.70227 0.665001 7 0.962732 7 1.33C7 1.69727 6.70227 1.995 6.335 1.995H2.7618Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1M(modules_df69c716.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M8.99999 5H5.49999C5.22385 5 4.99999 5.22386 4.99999 5.5V9C4.99999 9.27614 5.22385 9.5 5.49999 9.5H8.99999C9.27613 9.5 9.49999 9.27614 9.49999 9V5.5C9.49999 5.22386 9.27613 5 8.99999 5ZM5.49999 3.5C4.39542 3.5 3.49999 4.39543 3.49999 5.5V9C3.49999 10.1046 4.39542 11 5.49999 11H8.99999C10.1046 11 11 10.1046 11 9V5.5C11 4.39543 10.1046 3.5 8.99999 3.5H5.49999Z" })));
};

const CrossCircleIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('CrossCircleIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: fillClass, d: "M10.0071 8.59291C9.61657 8.20239 8.9834 8.20239 8.59288 8.59291C8.20236 8.98344 8.20236 9.6166 8.59288 10.0071L10.5858 12L8.59289 13.9929C8.20237 14.3834 8.20237 15.0166 8.59289 15.4071C8.98342 15.7976 9.61658 15.7976 10.0071 15.4071L12 13.4142L13.993 15.4072C14.3835 15.7977 15.0167 15.7977 15.4072 15.4072C15.7977 15.0167 15.7977 14.3835 15.4072 13.993L13.4142 12L15.4024 10.0118C15.793 9.62125 15.793 8.98809 15.4024 8.59756C15.0119 8.20704 14.3787 8.20704 13.9882 8.59756L12 10.5858L10.0071 8.59291Z" }),
        React.createElement("path", { className: fillClass, fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z" })));
};

var css$29 = ".DashIcon_module_overrideStroke__5b79b6e1{stroke:none!important}";
window.ADS.injectStyle(css$29,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/DashIcon.module.scss");
var modules_e3c0eb11 = {"overrideStroke":"DashIcon_module_overrideStroke__5b79b6e1"};

const DashIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("svg", { height: size, width: size, className: (cx$1S('datagridFill'), svgClass), viewBox: viewBox('DashIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 8a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1z", className: `${fillClass} ${cx$1S(modules_e3c0eb11.overrideStroke)}` }))));
};

const DeleteIcon = ({ size, svgClass, strokeClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DeleteIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { x: "0.5", y: "0.5", width: "19", height: "19", rx: "2.5", className: strokeClass }),
        React.createElement("path", { d: "M6 14L14 6", className: strokeClass, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M14 14L6 6", className: strokeClass, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};

var css$28 = ".DocumentIcon_module_fillEmail__240f5ab3,.DocumentIcon_module_fill__240f5ab3{fill:#444750}.DocumentIcon_module_fillExcel__240f5ab3{fill:#107c41}.DocumentIcon_module_fillImage__240f5ab3{fill:#ad851d}.DocumentIcon_module_fillPDF__240f5ab3{fill:#b30b00}.DocumentIcon_module_fillWord__240f5ab3{fill:#185abd}";
window.ADS.injectStyle(css$28,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/DocumentIcon.module.scss");
var modules_5853b245 = {"fill":"DocumentIcon_module_fill__240f5ab3","fillEmail":"DocumentIcon_module_fillEmail__240f5ab3","fillExcel":"DocumentIcon_module_fillExcel__240f5ab3","fillImage":"DocumentIcon_module_fillImage__240f5ab3","fillPDF":"DocumentIcon_module_fillPDF__240f5ab3","fillWord":"DocumentIcon_module_fillWord__240f5ab3"};

// this is very similar to DocumentIcon, but is intentionally offset to align with the other specific document type icons and has the same viewBox.
const DocumentAnyIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentAnyIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.99847 3.08C4.99847 1.93 5.92781 1 7.07699 1H12.5231C13.0727 1 13.6023 1.22 13.9921 1.6L18.3789 5.96C18.7686 6.35 18.9985 6.88 18.9985 7.44V16.92C18.9985 18.07 18.0691 19 16.92 19H7.07699C5.92781 19 4.99847 18.07 4.99847 16.92V3.08ZM6.65729 3.08C6.65729 2.85 6.84715 2.66 7.07699 2.66H11.9935V5.9C11.9935 7.05 12.9228 7.98 14.072 7.98H17.3197V16.91C17.3197 17.14 17.1298 17.33 16.9 17.33H7.07699C6.84715 17.33 6.65729 17.14 6.65729 16.91V3.08ZM16.3803 6.32L13.6523 3.62V5.91C13.6523 6.14 13.8422 6.33 14.072 6.33H16.3803V6.32Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fill) })));
};

const DocumentEmailIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentEmailIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.08129 2.6625C6.85002 2.6625 6.66254 2.84998 6.66254 3.08125V7H10.5C11.173 7 11.7424 7.44318 11.9325 8.05361L6.49997 11.2447L1.06753 8.05364C1.25754 7.4432 1.82701 7 2.5 7H5.00004V3.08125C5.00004 1.93181 5.93184 1 7.08129 1H12.5264C13.0754 1 13.6023 1.21698 13.9921 1.60368L18.3832 5.9596C18.7771 6.35038 18.9987 6.88228 18.9987 7.43716L18.9986 16.9188C18.9986 18.0682 18.0668 19 16.9174 19H7.08125C5.93181 19 5 18.0682 5 16.9188L5.00002 16H2.5C1.67157 16 1 15.3284 1 14.5V9.52453L6.10232 12.5217C6.35057 12.6675 6.64937 12.6675 6.89762 12.5217L12 9.52449V14.5C12 15.3284 11.3284 16 10.5 16H6.66252L6.6625 16.9188C6.6625 17.1501 6.84998 17.3375 7.08125 17.3375H16.9174C17.1487 17.3375 17.3361 17.1501 17.3361 16.9188L17.3362 7.98774H14.0832C12.9338 7.98774 12.0019 7.05593 12.0019 5.90649V2.6625H7.08129ZM13.6644 3.62039L16.3911 6.32524H14.0832C13.8519 6.32524 13.6644 6.13776 13.6644 5.90649V3.62039Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fillEmail) })));
};

const DocumentExcelIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentExcelIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.08129 1C5.93184 1 5.00004 1.93181 5.00004 3.08125V6H3C1.89543 6 1 6.89543 1 8V14C1 15.1046 1.89543 16 3 16H5.00002L5 16.9188C5 18.0682 5.93181 19 7.08125 19H16.9174C18.0668 19 18.9986 18.0682 18.9986 16.9188L18.9987 7.43716C18.9987 6.88228 18.7771 6.35038 18.3832 5.9596L13.9921 1.60368C13.6023 1.21698 13.0754 1 12.5264 1H7.08129ZM7.08129 2.6625C6.85002 2.6625 6.66254 2.84998 6.66254 3.08125V6H9C10.1046 6 11 6.89543 11 8V14C11 15.1046 10.1046 16 9 16H6.66252L6.6625 16.9188C6.6625 17.1501 6.84998 17.3375 7.08125 17.3375H16.9174C17.1487 17.3375 17.3361 17.1501 17.3361 16.9188L17.3362 7.98774H14.0832C12.9338 7.98774 12.0019 7.05593 12.0019 5.90649V2.6625H7.08129ZM13.6644 3.62039L16.3911 6.32524H14.0832C13.8519 6.32524 13.6644 6.13776 13.6644 5.90649V3.62039ZM3.31091 8L5.24368 10.8571L3.15125 14H4.63024L5.96637 11.9244L7.2773 14H8.84872L6.75629 10.8655L8.68066 8H7.23528L6.01679 9.91597L4.84032 8H3.31091Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fillExcel) })));
};

const DocumentIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.60967 1.60967C2.99972 1.21962 3.52654 1 4.08 1H8.47662C8.85057 1 9.20921 1.14855 9.47364 1.41298L13.587 5.52636C13.8514 5.79079 14 6.14943 14 6.52338V12.92C14 13.4735 13.7804 14.0003 13.3903 14.3903C13.0003 14.7804 12.4735 15 11.92 15H4.08C3.52654 15 2.99972 14.7804 2.60967 14.3903C2.21962 14.0003 2 13.4735 2 12.92V3.08C2 2.52654 2.21962 1.99972 2.60967 1.60967ZM4.08 2.5C3.92621 2.5 3.78038 2.56028 3.67033 2.67033C3.56028 2.78038 3.5 2.92621 3.5 3.08V12.92C3.5 13.0738 3.56028 13.2196 3.67033 13.3297C3.78038 13.4397 3.92621 13.5 4.08 13.5H11.92C12.0738 13.5 12.2196 13.4397 12.3297 13.3297C12.4397 13.2196 12.5 13.0738 12.5 12.92V7H8.75C8.33579 7 8 6.66421 8 6.25V2.5H4.08ZM9.5 3.56066L11.4393 5.5H9.5V3.56066Z", fill: "#444750", className: (cx$1S(modules_5853b245.fill), fillClass) })));
};

const DocumentImageIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentImageIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.08129 1C5.93184 1 5.00004 1.93181 5.00004 3.08125V6H3C1.89543 6 1 6.89543 1 8V14C1 15.1046 1.89543 16 3 16H5.00002L5 16.9188C5 18.0682 5.93181 19 7.08125 19H16.9174C18.0668 19 18.9986 18.0682 18.9986 16.9188L18.9987 7.43716C18.9987 6.88228 18.7771 6.35038 18.3832 5.9596L13.9921 1.60368C13.6023 1.21698 13.0754 1 12.5264 1H7.08129ZM7.08129 2.6625C6.85002 2.6625 6.66254 2.84998 6.66254 3.08125V6H9C10.1046 6 11 6.89543 11 8V14C11 15.1046 10.1046 16 9 16H6.66252L6.6625 16.9188C6.6625 17.1501 6.84998 17.3375 7.08125 17.3375H16.9174C17.1487 17.3375 17.3361 17.1501 17.3361 16.9188L17.3362 7.98774H14.0832C12.9338 7.98774 12.0019 7.05593 12.0019 5.90649V2.6625H7.08129ZM13.6644 3.62039L16.3911 6.32524H14.0832C13.8519 6.32524 13.6644 6.13776 13.6644 5.90649V3.62039ZM6.00011 9C6.00011 9.69036 5.44047 10.25 4.75011 10.25C4.05976 10.25 3.50011 9.69036 3.50011 9C3.50011 8.30964 4.05976 7.75 4.75011 7.75C5.44047 7.75 6.00011 8.30964 6.00011 9ZM3.53028 11.7685L2.26849 13.6086C2.15473 13.7745 2.27352 14 2.47467 14H9.59273C9.77927 14 9.9001 13.8031 9.81562 13.6368L7.92435 9.91333C7.83425 9.73595 7.5831 9.72977 7.48439 9.90251L5.60469 13.192C5.51892 13.3421 5.31033 13.3619 5.19782 13.2307L3.92628 11.7472C3.81935 11.6224 3.6232 11.633 3.53028 11.7685Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fillImage) })));
};

const DocumentMultiFileIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentMultiFileIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.62481 0.60967C6.01485 0.219624 6.54168 0 7.09514 0H9.99015C10.3649 0 10.7242 0.149162 10.9887 0.414549L15.0886 4.52732C15.3521 4.79162 15.5 5.14959 15.5 5.52277V9.92C15.5 10.4524 15.3088 10.986 14.9045 11.3903C14.5299 11.7649 14.0293 11.9823 13.5 11.999V12.17C13.5 12.6569 13.3069 13.1202 12.9636 13.4636C12.6202 13.807 12.1568 14 11.67 14H11.5V14.17C11.5 14.6569 11.3069 15.1202 10.9636 15.4636C10.6202 15.807 10.1568 16 9.67 16H2.83C2.34315 16 1.87983 15.807 1.53645 15.4636C1.19307 15.1202 1 14.6569 1 14.17V5.33003C1 4.84318 1.19307 4.37986 1.53645 4.03648C1.87983 3.6931 2.34315 3.50003 2.83 3.50003H3V3.33003C3 2.84318 3.19307 2.37986 3.53645 2.03648C3.87983 1.6931 4.34315 1.50003 4.83 1.50003H5.08669C5.1906 1.1583 5.38157 0.85291 5.62481 0.60967ZM5.62481 11.3903C6.01485 11.7804 6.54168 12 7.09514 12H12.5V12.17C12.5 12.3904 12.4132 12.5998 12.2564 12.7565C12.0997 12.9132 11.8904 13 11.67 13H4.83C4.6096 13 4.40027 12.9132 4.24355 12.7565C4.08684 12.5998 4 12.3904 4 12.17V3.33003C4 3.10963 4.08684 2.9003 4.24355 2.74358C4.40027 2.58687 4.6096 2.50003 4.83 2.50003H5V9.92C5 10.4946 5.25052 11.016 5.62481 11.3903ZM7.09514 1.5C6.94135 1.5 6.79552 1.56028 6.68547 1.67033C6.55966 1.79614 6.5 1.94735 6.5 2.08V9.92C6.5 10.0526 6.55966 10.2039 6.68547 10.3297C6.79552 10.4397 6.94135 10.5 7.09514 10.5H13.4341C13.5879 10.5 13.7338 10.4397 13.8438 10.3297C13.9396 10.2339 14 10.0948 14 9.92V6.00003H10.25C9.83579 6.00003 9.5 5.66424 9.5 5.25003V1.5H7.09514ZM12.9434 4.50003L11 2.55051V4.50003H12.9434ZM10.2564 14.7565C10.4132 14.5998 10.5 14.3904 10.5 14.17V14H4.83C4.34315 14 3.87983 13.807 3.53645 13.4636C3.19307 13.1202 3 12.6569 3 12.17V4.50003H2.83C2.6096 4.50003 2.40027 4.58687 2.24355 4.74358C2.08684 4.9003 2 5.10963 2 5.33003V14.17C2 14.3904 2.08684 14.5998 2.24355 14.7565C2.40027 14.9132 2.6096 15 2.83 15H9.67C9.8904 15 10.0997 14.9132 10.2564 14.7565Z", className: (cx$1S(modules_5853b245.fill), fillClass) })));
};

const DocumentPDFIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentPDFIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.00004 6V3.08125C5.00004 1.93181 5.93184 1 7.08129 1H12.5264C13.0754 1 13.6023 1.21698 13.9921 1.60368L18.3832 5.9596C18.7771 6.35038 18.9987 6.88228 18.9987 7.43716L18.9986 16.9188C18.9986 18.0682 18.0668 19 16.9174 19H7.08125C5.93181 19 5 18.0682 5 16.9188L5.00002 16H3C1.89543 16 1 15.1046 1 14V8C1 6.89543 1.89543 6 3 6H5.00004ZM6.66254 3.08125C6.66254 2.84998 6.85002 2.6625 7.08129 2.6625H12.0019V5.90649C12.0019 7.05593 12.9338 7.98774 14.0832 7.98774H17.3362L17.3361 16.9188C17.3361 17.1501 17.1487 17.3375 16.9174 17.3375H7.08125C6.84998 17.3375 6.6625 17.1501 6.6625 16.9188L6.66252 16H9C10.1046 16 11 15.1046 11 14V8C11 6.89543 10.1046 6 9 6H6.66254V3.08125ZM16.3911 6.32524L13.6644 3.62039V5.90649C13.6644 6.13776 13.8519 6.32524 14.0832 6.32524H16.3911ZM8.04371 11.1965C8.55097 11.1971 8.88427 11.3427 9.0901 11.5547C9.34492 11.8172 9.42108 12.2167 9.19983 12.525C9.03826 12.7502 8.75011 12.8856 8.3254 12.9017C7.85227 12.9196 7.40806 12.6809 7.11433 12.4802C6.9609 12.3753 6.83328 12.2702 6.74395 12.1913C6.73383 12.1824 6.72302 12.1788 6.70982 12.1813C6.34163 12.2501 5.98071 12.3522 5.62034 12.4542C5.55096 12.4738 5.48143 12.4935 5.41204 12.5128L5.4096 12.5135C5.18515 12.8936 4.9384 13.2594 4.67068 13.609C4.36372 14.0205 4.01161 14.2461 3.67263 14.3124C3.3475 14.3761 3.00232 14.2904 2.81747 14.0331C2.66149 13.8161 2.63443 13.5166 2.72918 13.2844C3.00353 12.6123 3.80821 12.2193 4.44521 11.9858C4.46106 11.9541 4.47996 11.9157 4.50161 11.8707C4.57589 11.7164 4.68261 11.4846 4.80993 11.1791C4.93619 10.876 5.04769 10.5706 5.12789 10.34C5.16609 10.2302 5.19699 10.1379 5.2188 10.0716C5.08394 9.72692 4.98912 9.3672 4.93634 8.99978L4.93529 8.99246L4.93456 8.98509C4.90638 8.69913 4.89846 8.39441 4.98874 8.15006C5.03732 8.01857 5.11908 7.89089 5.25146 7.79828C5.38343 7.70597 5.53668 7.6688 5.69296 7.66706C5.84187 7.6654 5.98788 7.6926 6.12024 7.76344C6.25441 7.83524 6.35375 7.94078 6.42438 8.06274C6.55681 8.29141 6.59325 8.58725 6.60017 8.88071L6.60036 8.88856C6.60036 9.38706 6.48518 9.87212 6.34216 10.319C6.63285 10.8148 6.77 10.97 7.03 11.26C7.37 11.21 7.62028 11.1897 8.04371 11.1965Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fillPDF) })));
};

const DocumentWordIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DocumentWordIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.08129 1C5.93184 1 5.00004 1.93181 5.00004 3.08125V6H3C1.89543 6 1 6.89543 1 8V14C1 15.1046 1.89543 16 3 16H5.00002L5 16.9188C5 18.0682 5.93181 19 7.08125 19H16.9174C18.0668 19 18.9986 18.0682 18.9986 16.9188L18.9987 7.43716C18.9987 6.88228 18.7771 6.35038 18.3832 5.9596L13.9921 1.60368C13.6023 1.21698 13.0754 1 12.5264 1H7.08129ZM7.08129 2.6625C6.85002 2.6625 6.66254 2.84998 6.66254 3.08125V6H9C10.1046 6 11 6.89543 11 8V14C11 15.1046 10.1046 16 9 16H6.66252L6.6625 16.9188C6.6625 17.1501 6.84998 17.3375 7.08125 17.3375H16.9174C17.1487 17.3375 17.3361 17.1501 17.3361 16.9188L17.3362 7.98774H14.0832C12.9338 7.98774 12.0019 7.05593 12.0019 5.90649V2.6625H7.08129ZM13.6644 3.62039L16.3911 6.32524H14.0832C13.8519 6.32524 13.6644 6.13776 13.6644 5.90649V3.62039ZM6.00001 9.91597L7.01682 14H8.32774L9.94119 8H8.64707L7.66388 12.1345H7.64707L6.62186 8H5.38657L4.34455 12.084H4.32774L3.37817 8H2.05884L3.64707 14H4.98321L5.98321 9.91597H6.00001Z", className: colorOverride ? fillClass : cx$1S(modules_5853b245.fillWord) })));
};

var css$27 = ".DollarIcon_module_fill__8d097241{fill:#444750}";
window.ADS.injectStyle(css$27,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/DollarIcon.module.scss");
var modules_39947229 = {"fill":"DollarIcon_module_fill__8d097241"};

const DollarIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_39947229.fill), viewBox: viewBox('DollarIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.665 2.64999C8.665 2.28272 8.36727 1.98499 8 1.98499C7.63273 1.98499 7.335 2.28272 7.335 2.64999V3.28676C7.13072 3.30683 6.93158 3.33949 6.73929 3.38395C5.47012 3.67734 4.25 4.5841 4.25 5.99998C4.25 6.99857 4.85977 7.67297 5.56824 8.0775C6.09164 8.37636 6.71562 8.56147 7.335 8.66753V11.1448C6.62104 11.0251 5.82349 10.7662 4.99748 10.3351C4.63027 10.1434 4.17722 10.2857 3.98557 10.653C3.79391 11.0202 3.93622 11.4732 4.30343 11.6649C5.33514 12.2033 6.3732 12.5323 7.335 12.6617V13.3499C7.335 13.7172 7.63273 14.015 8 14.015C8.36727 14.015 8.665 13.7166 8.665 13.3494V12.7106C8.83808 12.6985 9.00654 12.6786 9.16975 12.6511C9.85988 12.5347 10.497 12.2735 10.9734 11.8346C11.4648 11.382 11.75 10.77 11.75 10.0577C11.75 8.97637 11.0043 8.28921 10.2926 7.90126C9.77725 7.62039 9.19228 7.44175 8.665 7.33996V4.86154C9.18119 4.98163 9.71302 5.21705 10.2144 5.5972C10.5445 5.84745 11.015 5.78273 11.2652 5.45266C11.5155 5.12258 11.4507 4.65214 11.1207 4.40189C10.3414 3.81107 9.49187 3.46951 8.665 3.33302V2.64999ZM7.335 4.79728C7.24672 4.80998 7.16065 4.8261 7.07713 4.8454C6.12957 5.06445 5.75 5.59353 5.75 5.99998C5.75 6.28295 5.89374 6.53605 6.31202 6.77489C6.58607 6.93137 6.93852 7.05392 7.335 7.14001V4.79728ZM8.665 8.87598V11.2055C8.75304 11.1971 8.83822 11.1858 8.92034 11.172C9.41099 11.0893 9.75137 10.9209 9.95718 10.7314C10.1481 10.5555 10.25 10.3401 10.25 10.0577C10.25 9.77595 10.0738 9.4904 9.57469 9.21833C9.30233 9.06988 8.98285 8.95624 8.665 8.87598Z", className: fillClass })));
};

const DoNotIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('DoNotIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM10.7574 12.1716C9.96696 12.6951 9.01909 13 8 13C5.23858 13 3 10.7614 3 8C3 6.98091 3.30488 6.03304 3.8284 5.2426L10.7574 12.1716ZM12.1716 10.7574L5.24262 3.82839C6.03305 3.30487 6.98092 3 8 3C10.7614 3 13 5.23858 13 8C13 9.01908 12.6951 9.96695 12.1716 10.7574Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$26 = ".DownloadIcon_module_fill__159c0065{path-fill:#444750}";
window.ADS.injectStyle(css$26,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/DownloadIcon.module.scss");
var modules_ac4141ba = {"fill":"DownloadIcon_module_fill__159c0065"};

const DownloadIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React__default.createElement("svg", { height: size, width: size, className: `${cx$1S(modules_ac4141ba.fill)} ${svgClass}`, viewBox: viewBox('DownloadIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M8.47019 10.4702C8.21049 10.7299 7.78944 10.7299 7.52974 10.4702L4.52974 7.47019C4.27004 7.21049 4.27004 6.78943 4.52974 6.52973C4.78944 6.27004 5.21049 6.27004 5.47019 6.52973L7.33496 8.39451L7.33496 1.99996C7.33496 1.63269 7.63269 1.33496 7.99996 1.33496C8.36723 1.33496 8.66496 1.63269 8.66496 1.99996L8.66496 8.39451L10.5297 6.52973C10.7894 6.27004 11.2105 6.27004 11.4702 6.52973C11.7299 6.78943 11.7299 7.21049 11.4702 7.47019L8.47019 10.4702Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } }),
        React__default.createElement("path", { d: "M1.6665 9.99998C2.0346 9.99998 2.333 10.2984 2.333 10.6665V13.337C2.333 13.5192 2.48075 13.667 2.663 13.667H13.337C13.5193 13.667 13.667 13.5192 13.667 13.337V10.6665C13.667 10.2984 13.9654 9.99998 14.3335 9.99998C14.7016 9.99998 15 10.2984 15 10.6665V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V10.6665C1 10.2984 1.2984 9.99998 1.6665 9.99998Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$25 = ".EllipsisMessageBubble20Icon_module_overrideStroke__5a69b28f{stroke:none!important}";
window.ADS.injectStyle(css$25,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/EllipsisMessageBubble20Icon.module.scss");
var modules_0c532555 = {"overrideStroke":"EllipsisMessageBubble20Icon_module_overrideStroke__5a69b28f"};

const cx$1L = classnames.bind(modules_0c532555);
const EllipsisMessageBubble20Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('EllipsisMessageBubble20Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1L(modules_0c532555.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M16.34 7.00014L16.3401 12C16.3402 12.4588 16.0675 13.0526 15.5606 13.5597C15.0538 14.0668 14.4601 14.34 14 14.34H11.0002C10.8144 14.34 10.6339 14.4023 10.4878 14.517L7.66016 16.736V15.17C7.66016 14.7116 7.28856 14.34 6.83018 14.34L6.82429 14.34L6.80587 14.34L6.7374 14.3397C6.67955 14.3394 6.6008 14.3387 6.51662 14.3374C6.32972 14.3346 6.1731 14.3292 6.12313 14.3237C6.09307 14.3204 6.06286 14.3187 6.03262 14.3187C5.56654 14.3187 4.96535 14.0309 4.44635 13.5069C3.92256 12.978 3.66 12.3888 3.66 12V7C3.66 6.53978 3.93274 5.94706 4.43905 5.44146C4.94531 4.9359 5.53909 4.6633 6 4.6633L14 4.66C14.4605 4.66014 15.0543 4.93301 15.5606 5.43931C16.0669 5.94568 16.3399 6.53947 16.34 7.00014ZM6.00016 15.9792V18.4424C6.00016 18.7601 6.18146 19.0499 6.46711 19.1888C6.75277 19.3278 7.09267 19.2915 7.34256 19.0954L11.2869 16H14C15.04 16 16.0315 15.4368 16.7347 14.7332C17.4379 14.0297 18.0002 13.0384 18.0001 12L18 6.99999C17.9998 5.96048 17.4379 4.96908 16.7344 4.26554C16.0309 3.56201 15.0396 3 14 3L6 3.0033C4.96119 3.00342 3.96977 3.56412 3.26607 4.26684C2.56234 4.96959 2 5.96022 2 7V12C2 12.9888 2.57252 13.9739 3.26692 14.675C3.95693 15.3717 4.94 15.963 5.99061 15.9784C5.99376 15.9787 5.99694 15.979 6.00016 15.9792Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1L(modules_0c532555.overrideStroke)}`, d: "M14.5001 9.49664C14.5001 10.187 13.9405 10.7466 13.2501 10.7466C12.5598 10.7466 12.0001 10.187 12.0001 9.49664C12.0001 8.80629 12.5598 8.24664 13.2501 8.24664C13.9405 8.24664 14.5001 8.80629 14.5001 9.49664Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1L(modules_0c532555.overrideStroke)}`, d: "M11.2501 9.49664C11.2501 10.187 10.6905 10.7466 10.0001 10.7466C9.30977 10.7466 8.75012 10.187 8.75012 9.49664C8.75012 8.80629 9.30977 8.24664 10.0001 8.24664C10.6905 8.24664 11.2501 8.80629 11.2501 9.49664Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1L(modules_0c532555.overrideStroke)}`, d: "M8.00012 9.49664C8.00012 10.187 7.44048 10.7466 6.75012 10.7466C6.05977 10.7466 5.50012 10.187 5.50012 9.49664C5.50012 8.80629 6.05977 8.24664 6.75012 8.24664C7.44048 8.24664 8.00012 8.80629 8.00012 9.49664Z" })));
};

const EnvelopeLetterIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React__default.createElement("svg", { height: size, width: size, className: `${svgClass}`, viewBox: viewBox('EnvelopeLetterIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M5.5 4C5.22386 4 5 4.22386 5 4.5C5 4.77614 5.22386 5 5.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H5.5Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } }),
        React__default.createElement("path", { d: "M5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H10.5C10.7761 7 11 6.77614 11 6.5C11 6.22386 10.7761 6 10.5 6H5.5Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 6.5C15 5.94772 14.5523 5.5 14 5.5H13.5V3C13.5 1.89543 12.6046 1 11.5 1H4.5C3.39543 1 2.5 1.89543 2.5 3V5.5H2C1.44772 5.5 1 5.94772 1 6.5V13.34C1 14.2568 1.74321 15 2.66 15H13.34C14.2568 15 15 14.2568 15 13.34V6.5ZM7.86481 9.91309L3.83 7.31929V3C3.83 2.62997 4.12997 2.33 4.5 2.33H11.5C11.87 2.33 12.17 2.62997 12.17 3V7.31929L8.13519 9.91309C8.05284 9.96603 7.94716 9.96603 7.86481 9.91309ZM7.1456 11.0319L2.33 7.93612V13.34C2.33 13.5222 2.47774 13.67 2.66 13.67H13.34C13.5223 13.67 13.67 13.5222 13.67 13.34V7.93612L8.8544 11.0319C8.33393 11.3664 7.66606 11.3664 7.1456 11.0319Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$24 = ".ErrorIcon_module_circle__478b8c5f{fill:#ea0a3b}";
window.ADS.injectStyle(css$24,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ErrorIcon.module.scss");
var modules_a9d031ad = {"circle":"ErrorIcon_module_circle__478b8c5f"};

const ErrorIcon$1 = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: size, width: size, className: svgClass, viewBox: viewBox('ErrorIcon') },
        React.createElement("path", { d: "M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8Z", className: colorOverride ? fillClass : cx$1S(modules_a9d031ad.circle) }),
        React.createElement("path", { d: "M12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H12.01C12.5623 17 13.01 16.5523 13.01 16C13.01 15.4477 12.5623 15 12.01 15H12Z", className: colorOverride ? fillClass : cx$1S(modules_a9d031ad.circle) }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z", className: colorOverride ? fillClass : cx$1S(modules_a9d031ad.circle) })));
};

var css$23 = ".ErrorIconFilled_module_circle__b5af2a62{fill:#ea0a3b}";
window.ADS.injectStyle(css$23,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ErrorIconFilled.module.scss");
var modules_7a18245e = {"circle":"ErrorIconFilled_module_circle__b5af2a62"};

const ErrorIconFilled = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: size, width: size, className: svgClass, viewBox: viewBox('ErrorIconFilled') },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V7.25C7 7.80228 7.44772 8.25 8 8.25C8.55229 8.25 9 7.80228 9 7.25V5ZM8 12.25C8.69036 12.25 9.25 11.6904 9.25 11C9.25 10.3096 8.69036 9.75 8 9.75C7.30964 9.75 6.75 10.3096 6.75 11C6.75 11.6904 7.30964 12.25 8 12.25Z", className: colorOverride ? fillClass : cx$1S(modules_7a18245e.circle) })));
};

var css$22 = ".EyeIcon_module_fill__e7efde16{fill:#444750}";
window.ADS.injectStyle(css$22,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/EyeIcon.module.scss");
var modules_08be735d = {"fill":"EyeIcon_module_fill__e7efde16"};

const cx$1K = classnames.bind(modules_08be735d);
// missed opportunity to name this "Eyecon"
const EyeIcon = ({ size, svgClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('EyeIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.99999 9.5999C8.42434 9.5999 8.83131 9.43133 9.13136 9.13127C9.43142 8.83121 9.59999 8.42425 9.59999 7.9999C9.59999 7.57556 9.43142 7.16859 9.13136 6.86853C8.83131 6.56847 8.42434 6.3999 7.99999 6.3999C7.57565 6.3999 7.16868 6.56847 6.86862 6.86853C6.56857 7.16859 6.39999 7.57556 6.39999 7.9999C6.39999 8.42425 6.56857 8.83121 6.86862 9.13127C7.16868 9.43133 7.57565 9.5999 7.99999 9.5999Z", className: cx$1K('fill') }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.366394 7.9999C1.38559 4.7543 4.41759 2.3999 7.99999 2.3999C11.5824 2.3999 14.6144 4.7543 15.6336 7.9999C14.6144 11.2455 11.5824 13.5999 7.99999 13.5999C4.41759 13.5999 1.38559 11.2455 0.366394 7.9999ZM11.2 7.9999C11.2 8.8486 10.8629 9.66253 10.2627 10.2626C9.66262 10.8628 8.84869 11.1999 7.99999 11.1999C7.1513 11.1999 6.33737 10.8628 5.73725 10.2626C5.13714 9.66253 4.79999 8.8486 4.79999 7.9999C4.79999 7.15121 5.13714 6.33728 5.73725 5.73716C6.33737 5.13704 7.1513 4.7999 7.99999 4.7999C8.84869 4.7999 9.66262 5.13704 10.2627 5.73716C10.8629 6.33728 11.2 7.15121 11.2 7.9999Z", className: cx$1K('fill') })));
};

const cx$1J = classnames.bind(modules_08be735d);
const EyeOffIcon = ({ size, svgClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('EyeOffIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.9656 1.83443C2.81472 1.68871 2.61264 1.60807 2.40288 1.60989C2.19312 1.61172 1.99247 1.69585 1.84415 1.84418C1.69582 1.9925 1.61169 2.19315 1.60986 2.40291C1.60804 2.61267 1.68868 2.81475 1.8344 2.96563L13.0344 14.1656C13.1853 14.3114 13.3874 14.392 13.5971 14.3902C13.8069 14.3884 14.0075 14.3042 14.1559 14.1559C14.3042 14.0076 14.3883 13.8069 14.3901 13.5972C14.392 13.3874 14.3113 13.1853 14.1656 13.0344L12.9872 11.856C14.2332 10.8625 15.1546 9.51997 15.6336 8.00003C14.6144 4.75443 11.5824 2.40003 8 2.40003C6.74595 2.39833 5.5092 2.69272 4.3904 3.25923L2.9664 1.83443H2.9656ZM6.3744 5.24243L7.5856 6.45443C7.85687 6.38239 8.14231 6.38287 8.41334 6.45582C8.68437 6.52876 8.93148 6.67162 9.12995 6.87009C9.32842 7.06855 9.47127 7.31567 9.54422 7.5867C9.61716 7.85773 9.61764 8.14316 9.5456 8.41443L10.7568 9.62563C11.1176 9.01445 11.265 8.30067 11.1757 7.59657C11.0865 6.89248 10.7657 6.23803 10.2639 5.73618C9.76201 5.23432 9.10756 4.91355 8.40346 4.82431C7.69937 4.73508 6.98558 4.88244 6.3744 5.24323V5.24243Z", 
            // fill="#444750"
            className: cx$1J('fill') }),
        React.createElement("path", { d: "M9.96319 13.3577L7.79999 11.1937C7.02214 11.1449 6.28882 10.814 5.73764 10.263C5.18646 9.71193 4.85533 8.97869 4.80639 8.20085L1.86799 5.26245C1.19216 6.06726 0.681873 6.99758 0.366394 8.00005C1.38559 11.2457 4.41839 13.6 7.99999 13.6C8.67759 13.6 9.33519 13.5161 9.96319 13.3577Z", 
            // fill="#444750"
            className: cx$1J('fill') })));
};

var css$21 = ".FilterIcon_module_overrideStroke__7539fa21 path{stroke:none!important}";
window.ADS.injectStyle(css$21,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/FilterIcon.module.scss");
var modules_ef810479 = {"overrideStroke":"FilterIcon_module_overrideStroke__7539fa21"};

const FilterIcon = ({ size, svgClass, fillClass = '' }) => {
    return (React__default.createElement("svg", { height: size, width: size, viewBox: viewBox('FilterIcon'), fill: "none", className: `${svgClass} ${cx$1S(modules_ef810479.overrideStroke)}`, xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4C15 4.55228 14.5523 5 14 5H2C1.44772 5 1 4.55228 1 4ZM3.5 8C3.5 7.44772 3.94772 7 4.5 7H11.5C12.0523 7 12.5 7.44772 12.5 8C12.5 8.55228 12.0523 9 11.5 9H4.5C3.94772 9 3.5 8.55228 3.5 8ZM6 12C6 11.4477 6.44772 11 7 11H9C9.55228 11 10 11.4477 10 12C10 12.5523 9.55228 13 9 13H7C6.44772 13 6 12.5523 6 12Z", className: fillClass ? fillClass : cx$1S(modules_ef810479.fill) })));
};

var css$20 = ".FolderIcon_module_overrideStroke__c76c4cd1{stroke:none!important}";
window.ADS.injectStyle(css$20,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/FolderIcon.module.scss");
var modules_0629efb7 = {"overrideStroke":"FolderIcon_module_overrideStroke__c76c4cd1"};

const FolderIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('FolderIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.67157 1C6.20201 1 6.71071 1.21071 7.08579 1.58579L8.20711 2.70711C8.39464 2.89464 8.649 3 8.91421 3H13C14.1046 3 15 3.89543 15 5V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V3C1 1.89543 1.89543 1 3 1H5.67157ZM8.91421 4.33C8.29626 4.33 7.70362 4.08452 7.26666 3.64756L6.14533 2.52624C6.01968 2.40059 5.84927 2.33 5.67157 2.33H3C2.62997 2.33 2.33 2.62997 2.33 3V12C2.33 12.37 2.62997 12.67 3 12.67H13C13.37 12.67 13.67 12.37 13.67 12V5C13.67 4.62997 13.37 4.33 13 4.33H8.91421Z", className: `${fillClass} ${cx$1S(modules_0629efb7.overrideStroke)}` })));
};

var css$1$ = ".ForwardArrowIcon_module_overrideStroke__e6e84ee5{stroke:none!important}.ForwardArrowIcon_module_forward__e6e84ee5{transform:rotate(180deg)}";
window.ADS.injectStyle(css$1$,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ForwardArrowIcon.module.scss");
var modules_90848620 = {"overrideStroke":"ForwardArrowIcon_module_overrideStroke__e6e84ee5","forward":"ForwardArrowIcon_module_forward__e6e84ee5"};

const ForwardArrowIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: `${svgClass} ${cx$1S(modules_90848620.forward)}`, viewBox: viewBox('ForwardArrowIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.58682 4.08682C7.91096 3.76269 7.91096 3.23716 7.58682 2.91302C7.26269 2.58889 6.73716 2.58889 6.41302 2.91302L1.91302 7.41302C1.58889 7.73716 1.58889 8.26269 1.91302 8.58682L6.41302 13.0868C6.73716 13.411 7.26269 13.411 7.58682 13.0868C7.91096 12.7627 7.91096 12.2372 7.58682 11.913L4.50372 8.82992H13.4999C13.9583 8.82992 14.3299 8.45832 14.3299 7.99992C14.3299 7.54153 13.9583 7.16992 13.4999 7.16992H4.50372L7.58682 4.08682Z", className: `${fillClass} ${cx$1S(modules_90848620.overrideStroke)}` })));
};

var css$1_ = ".FrenchFriesIcon_module_fill__1f01a2df{path-fill:#444750}.FrenchFriesIcon_module_overrideStroke__1f01a2df{stroke:none!important}";
window.ADS.injectStyle(css$1_,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/FrenchFriesIcon.module.scss");
var modules_9bd9d2af = {"fill":"FrenchFriesIcon_module_fill__1f01a2df","overrideStroke":"FrenchFriesIcon_module_overrideStroke__1f01a2df"};

const cx$1I = classnames.bind(modules_9bd9d2af);
const FrenchFriesIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1I(svgClass, modules_9bd9d2af.fill), viewBox: viewBox('FrenchFriesIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 15C2.44772 15 2 14.5523 2 14V2C2 1.44771 2.44772 1 3 1C3.55229 1 4 1.44771 4 2L4 14C4 14.5523 3.55228 15 3 15Z", className: `${cx$1I(strokeClass, fillClass)}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C7.44772 15 7 14.5523 7 14L7 2C7 1.44771 7.44772 1 8 1C8.55229 1 9 1.44771 9 2L9 14C9 14.5523 8.55228 15 8 15Z", className: `${cx$1I(strokeClass, fillClass)}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 14C12 14.5523 12.4477 15 13 15C13.5523 15 14 14.5523 14 14L14 2C14 1.44771 13.5523 1 13 1C12.4477 1 12 1.44771 12 2L12 14Z", className: `${cx$1I(strokeClass, fillClass)}`, style: { stroke: 'none' } })));
};

var css$1Z = ".Gear20Icon_module_overrideStroke__d0054a60{stroke:none!important}";
window.ADS.injectStyle(css$1Z,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/Gear20Icon.module.scss");
var modules_58d57fe1 = {"overrideStroke":"Gear20Icon_module_overrideStroke__d0054a60"};

const cx$1H = classnames.bind(modules_58d57fe1);
const Gear20Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('Gear20Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1H(modules_58d57fe1.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M7.73556 3.3087C7.73556 2.0585 8.74904 1.04501 9.99924 1.04501C11.2508 1.04501 12.2629 2.06331 12.2629 3.3087C12.2629 3.56433 12.4031 3.73873 12.5679 3.81215C12.7127 3.87664 12.9156 3.88171 13.131 3.66639C14.015 2.78236 15.4483 2.78236 16.3323 3.66639C17.2172 4.55134 17.2129 5.9871 16.3323 6.86772C16.1515 7.04848 16.1273 7.27089 16.1919 7.43936C16.2486 7.58703 16.3881 7.73385 16.6913 7.73444C17.9415 7.73444 18.955 8.74777 18.955 9.99796C18.955 11.2495 17.9367 12.2616 16.6913 12.2616C16.4357 12.2616 16.2613 12.4018 16.1879 12.5666C16.1234 12.7114 16.1183 12.9144 16.3336 13.1297C17.2169 14.0138 17.2161 15.4469 16.3324 16.3307C15.4474 17.2156 14.0116 17.2113 13.131 16.3307C12.9503 16.1499 12.7279 16.1257 12.5594 16.1903C12.4117 16.247 12.2649 16.3865 12.2643 16.6897C12.2643 17.9399 11.251 18.9534 10.0008 18.9534C8.74927 18.9534 7.7371 17.9351 7.7371 16.6897C7.7371 16.4341 7.59696 16.2597 7.43214 16.1863C7.28737 16.1218 7.08439 16.1167 6.86907 16.332C5.98504 17.2161 4.55176 17.2161 3.66774 16.332C2.78278 15.4471 2.78711 14.0113 3.66774 13.1307C3.8485 12.9499 3.87271 12.7275 3.80809 12.5591C3.75143 12.4114 3.61194 12.2646 3.3087 12.264C2.0585 12.264 1.04501 11.2507 1.04501 10.0005C1.04501 8.74895 2.06331 7.73678 3.3087 7.73678C3.56433 7.73678 3.73872 7.59664 3.81215 7.43182C3.87664 7.28705 3.88171 7.08407 3.66639 6.86875C2.78316 5.98466 2.78391 4.55149 3.66767 3.66774C4.55262 2.78278 5.98838 2.78712 6.869 3.66774C7.04976 3.8485 7.27217 3.87271 7.44063 3.80809C7.5883 3.75144 7.73497 3.61194 7.73556 3.3087ZM4.84098 5.69575C5.54561 6.40099 5.67028 7.34006 5.3285 8.10731C4.99552 8.85479 4.23729 9.39678 3.3087 9.39678C2.97747 9.39678 2.70501 9.66838 2.70501 10.0005C2.70501 10.3333 2.9743 10.6032 3.30687 10.6041C4.30436 10.6041 5.05699 11.18 5.35795 11.9645C5.65105 12.7285 5.49814 13.6479 4.84153 14.3045C4.60732 14.5387 4.60671 14.9234 4.84153 15.1582C5.07729 15.394 5.45952 15.394 5.69527 15.1582C6.40061 14.4529 7.34009 14.328 8.10763 14.6699C8.85511 15.0029 9.3971 15.7611 9.3971 16.6897C9.3971 17.021 9.6687 17.2934 10.0008 17.2934C10.3336 17.2934 10.6035 17.0241 10.6045 16.6916C10.6045 15.6941 11.1803 14.9414 11.9648 14.6405C12.7288 14.3474 13.6482 14.5003 14.3048 15.1569C14.539 15.3911 14.9237 15.3917 15.1586 15.1569C15.3943 14.9211 15.3943 14.5389 15.1586 14.3032C14.4539 13.5979 14.3297 12.6584 14.6715 11.8911C15.0045 11.1436 15.7627 10.6016 16.6913 10.6016C17.0226 10.6016 17.295 10.3301 17.295 9.99796C17.295 9.66517 17.0257 9.39527 16.6932 9.39428C15.6957 9.39428 14.943 8.81843 14.6421 8.03394C14.349 7.26993 14.5019 6.35053 15.1585 5.69392C15.3927 5.45971 15.3933 5.07501 15.1585 4.84019C14.9227 4.60443 14.5405 4.60443 14.3048 4.84019C13.5994 5.54552 12.6599 5.67041 11.8924 5.3285C11.1449 4.99552 10.6029 4.23729 10.6029 3.3087C10.6029 2.97747 10.3313 2.70501 9.99924 2.70501C9.66644 2.70501 9.39655 2.9743 9.39556 3.30686C9.39556 4.30435 8.81971 5.05699 8.03521 5.35795C7.27121 5.65105 6.35181 5.49815 5.6952 4.84153C5.46099 4.60732 5.07629 4.60671 4.84146 4.84153C4.60571 5.07729 4.60523 5.46 4.84098 5.69575Z", fill: "#444750" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1H(modules_58d57fe1.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M10 8.75001C9.30966 8.75001 8.75001 9.30966 8.75001 10C8.75001 10.6904 9.30966 11.25 10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30966 10.6904 8.75001 10 8.75001ZM7.25001 10C7.25001 8.48123 8.48123 7.25001 10 7.25001C11.5188 7.25001 12.75 8.48123 12.75 10C12.75 11.5188 11.5188 12.75 10 12.75C8.48123 12.75 7.25001 11.5188 7.25001 10Z", fill: "#444750" })));
};

const GlobeIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React__default.createElement("svg", { height: size, width: size, className: `${svgClass}`, viewBox: viewBox('GlobeIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM6.05373 13.3271C5.47668 12.1782 5.0886 10.5278 5.01336 8.665H2.36858C2.62035 10.8201 4.08066 12.6061 6.05373 13.3271ZM7.10114 12.4258C6.70203 11.4946 6.41123 10.1817 6.34453 8.665H9.65547C9.58877 10.1817 9.29797 11.4946 8.89886 12.4258C8.66965 12.9606 8.43088 13.3085 8.2335 13.5033C8.10209 13.633 8.02441 13.6632 8 13.6694C7.9756 13.6632 7.89791 13.633 7.7665 13.5033C7.56912 13.3085 7.33035 12.9606 7.10114 12.4258ZM7.10114 3.57417C6.70203 4.50543 6.41123 5.81827 6.34453 7.335H9.65547C9.58877 5.81827 9.29797 4.50543 8.89886 3.57417C8.66965 3.03935 8.43088 2.69152 8.2335 2.49672C8.10208 2.36703 8.0244 2.3368 8 2.33062C7.9756 2.3368 7.89792 2.36703 7.7665 2.49672C7.56912 2.69152 7.33035 3.03935 7.10114 3.57417ZM9.94627 13.3271C10.5233 12.1782 10.9114 10.5278 10.9866 8.665H13.6314C13.3796 10.8201 11.9193 12.6061 9.94627 13.3271ZM9.94627 2.67286C10.5233 3.82178 10.9114 5.47219 10.9866 7.335H13.6314C13.3796 5.17989 11.9193 3.39392 9.94627 2.67286ZM6.05373 2.67286C4.08066 3.39392 2.62035 5.17989 2.36858 7.335H5.01336C5.0886 5.47219 5.47668 3.82178 6.05373 2.67286Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$1Y = ".HamburgerIcon_module_fill__d871c260{path-fill:#444750}.HamburgerIcon_module_overrideStroke__d871c260{stroke:none!important}";
window.ADS.injectStyle(css$1Y,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/HamburgerIcon.module.scss");
var modules_0bda5c7a = {"fill":"HamburgerIcon_module_fill__d871c260","overrideStroke":"HamburgerIcon_module_overrideStroke__d871c260"};

const cx$1G = classnames.bind(modules_0bda5c7a);
const HamburgerIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1G(svgClass, modules_0bda5c7a.fill), viewBox: viewBox('HamburgerIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3C1 2.44772 1.44772 2 2 2L14 2C14.5523 2 15 2.44772 15 3C15 3.55229 14.5523 4 14 4L2 4C1.44772 4 1 3.55228 1 3Z", className: `${cx$1G(strokeClass, fillClass)}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8C1 7.44772 1.44772 7 2 7L14 7C14.5523 7 15 7.44772 15 8C15 8.55229 14.5523 9 14 9L2 9C1.44772 9 1 8.55228 1 8Z", className: `${cx$1G(strokeClass, fillClass)}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 13C1 12.4477 1.44772 12 2 12L14 12C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14L2 14C1.44772 14 1 13.5523 1 13Z", className: `${cx$1G(strokeClass, fillClass)}`, style: { stroke: 'none' } })));
};

var css$1X = ".ICircle20Icon_module_fill__97ef2034{fill:#6a6f82}.ICircle20Icon_module_fill__97ef2034:hover{fill:#444750}";
window.ADS.injectStyle(css$1X,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ICircle20Icon.module.scss");
var modules_bf5fc225 = {"fill":"ICircle20Icon_module_fill__97ef2034"};

const ICircle20Icon = ({ colorOverride, fillClass, size, svgClass }) => {
    const className = colorOverride ? cx$1S(fillClass) : cx$1S(modules_bf5fc225.disk);
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_bf5fc225.fill), viewBox: viewBox('ICircle20Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10.0022 14.0114C9.51841 14.0114 9.12618 13.6192 9.12618 13.1354L9.12618 10.38C9.12618 9.89616 9.51841 9.495 10.0022 9.495C10.4861 9.495 10.8783 9.89616 10.8783 10.38V13.1354C10.8783 13.6192 10.4861 14.0114 10.0022 14.0114Z", fill: "#444750", className: className }),
        React.createElement("path", { d: "M10 8C10.5523 8 11 7.55229 11 7C11 6.44771 10.5523 6 10 6C9.44772 6 9 6.44771 9 7C9 7.55229 9.44772 8 10 8Z", fill: "#444750", className: className }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0022 17.9974C14.4203 17.9974 18.0018 14.4158 18.0018 9.99779C18.0018 5.57973 14.4203 1.99818 10.0022 1.99818C5.58417 1.99818 2.00262 5.57973 2.00262 9.99779C2.00262 14.4158 5.58417 17.9974 10.0022 17.9974ZM16.3352 9.99779C16.3352 13.4954 13.4998 16.3307 10.0022 16.3307C6.50464 16.3307 3.66929 13.4954 3.66929 9.99779C3.66929 6.5002 6.50464 3.66485 10.0022 3.66485C13.4998 3.66485 16.3352 6.5002 16.3352 9.99779Z", fill: "#444750", className: className })));
};

var css$1W = ".ICircleIcon_module_fill__11143de8{fill:#6a6f82}";
window.ADS.injectStyle(css$1W,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ICircleIcon.module.scss");
var modules_35fde11b = {"fill":"ICircleIcon_module_fill__11143de8"};

const ICircleIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('ICircleIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 4C8.55228 4 9 4.44549 9 4.99502V5.00498C9 5.55451 8.55228 6 8 6C7.44772 6 7 5.55451 7 5.00498V4.99502C7 4.44549 7.44772 4 8 4Z", className: colorOverride ? fillClass : cx$1S(modules_35fde11b.fill) }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z", className: colorOverride ? fillClass : cx$1S(modules_35fde11b.fill) }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 7.5C8.55228 7.5 9 7.94772 9 8.5V10.8C9 11.3523 8.55228 11.8 8 11.8C7.44772 11.8 7 11.3523 7 10.8V8.5C7 7.94772 7.44772 7.5 8 7.5Z", className: colorOverride ? fillClass : cx$1S(modules_35fde11b.fill) })));
};

var css$1V = ".InfoIcon_module_disk__e1474d44{fill:#365ef6}";
window.ADS.injectStyle(css$1V,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/InfoIcon.module.scss");
var modules_bf959218 = {"disk":"InfoIcon_module_disk__e1474d44"};

const InfoIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('InfoIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H12.01C12.5623 9 13.01 8.55228 13.01 8C13.01 7.44772 12.5623 7 12.01 7H12Z", className: colorOverride ? fillClass : cx$1S(modules_bf959218.disk) }),
        React.createElement("path", { d: "M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V12Z", className: colorOverride ? fillClass : cx$1S(modules_bf959218.disk) }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z", className: colorOverride ? fillClass : cx$1S(modules_bf959218.disk) })));
};

var css$1U = ".InfoIconFilled_module_disk__6a006ac7{fill:#365ef6}";
window.ADS.injectStyle(css$1U,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/InfoIconFilled.module.scss");
var modules_91c00ffc = {"disk":"InfoIconFilled_module_disk__6a006ac7"};

const InfoIconFilled = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('InfoIconFilled'), xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 6.25C8.69036 6.25 9.25 5.69036 9.25 5C9.25 4.30964 8.69036 3.75 8 3.75C7.30964 3.75 6.75 4.30964 6.75 5C6.75 5.69036 7.30964 6.25 8 6.25ZM9 8.75C9 8.19772 8.55228 7.75 8 7.75C7.44772 7.75 7 8.19772 7 8.75V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V8.75Z", className: colorOverride ? fillClass : cx$1S(modules_91c00ffc.disk) })));
};

const LockIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('LockIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 5.5C4.5 3.567 6.067 2 8 2C9.933 2 11.5 3.567 11.5 5.5V7C12.3284 7 13 7.67157 13 8.5V12.5C13 13.3284 12.3284 14 11.5 14H4.5C3.67157 14 3 13.3284 3 12.5V8.5C3 7.67157 3.67157 7 4.5 7L4.5 5.5ZM6 7H10V5.5C10 4.39543 9.10457 3.5 8 3.5C6.89543 3.5 6 4.39543 6 5.5V7Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$1T = ".MeatballIcon_module_fill__e9e9a57f{fill:#444750}";
window.ADS.injectStyle(css$1T,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/MeatballIcon.module.scss");
var modules_d1d5c20a = {"fill":"MeatballIcon_module_fill__e9e9a57f"};

const cx$1F = classnames.bind(modules_d1d5c20a);
const MeatballIcon = ({ size, svgClass, fillClass = '' }) => {
    const fill = fillClass ? fillClass : cx$1F('fill');
    return (React.createElement("svg", { width: size, height: size, className: cx$1F(svgClass, fill), viewBox: viewBox('MeatballIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4.5 8.00002C4.5 8.88368 3.78366 9.60002 2.9 9.60002C2.01634 9.60002 1.3 8.88368 1.3 8.00002C1.3 7.11637 2.01634 6.40002 2.9 6.40002C3.78366 6.40002 4.5 7.11637 4.5 8.00002Z" }),
        React.createElement("path", { d: "M9.6 8.00002C9.6 8.88368 8.88366 9.60002 8 9.60002C7.11635 9.60002 6.4 8.88368 6.4 8.00002C6.4 7.11637 7.11635 6.40002 8 6.40002C8.88366 6.40002 9.6 7.11637 9.6 8.00002Z" }),
        React.createElement("path", { d: "M13.1 9.60002C13.9837 9.60002 14.7 8.88368 14.7 8.00002C14.7 7.11637 13.9837 6.40002 13.1 6.40002C12.2163 6.40002 11.5 7.11637 11.5 8.00002C11.5 8.88368 12.2163 9.60002 13.1 9.60002Z" })));
};

var css$1S = ".OpenIcon_module_fill__cec2ddf3{path-fill:#444750}.OpenIcon_module_overrideStroke__cec2ddf3{stroke:none!important}";
window.ADS.injectStyle(css$1S,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/OpenIcon.module.scss");
var modules_27e0f4da = {"fill":"OpenIcon_module_fill__cec2ddf3","overrideStroke":"OpenIcon_module_overrideStroke__cec2ddf3"};

const OpenIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: `${cx$1S(modules_27e0f4da.fill)} ${cx$1S(svgClass)}`, viewBox: viewBox('OpenIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 1.75C9.5 1.33579 9.83579 1 10.25 1H14.25C14.6642 1 15 1.33579 15 1.75V5.75C15 6.16421 14.6642 6.5 14.25 6.5C13.8358 6.5 13.5 6.16421 13.5 5.75V3.56066L7.447 9.61366C7.15411 9.90656 6.67923 9.90656 6.38634 9.61366C6.09345 9.32077 6.09345 8.8459 6.38634 8.553L12.4393 2.5H10.25C9.83579 2.5 9.5 2.16421 9.5 1.75ZM3.08334 4.5C2.92863 4.5 2.78026 4.56146 2.67086 4.67085C2.56147 4.78025 2.50001 4.92862 2.50001 5.08333V12.9167C2.50001 13.0714 2.56147 13.2197 2.67086 13.3291C2.78026 13.4385 2.92863 13.5 3.08334 13.5H10.9167C11.0714 13.5 11.2198 13.4385 11.3291 13.3291C11.4385 13.2197 11.5 13.0714 11.5 12.9167V9.25C11.5 8.83579 11.8358 8.5 12.25 8.5C12.6642 8.5 13 8.83579 13 9.25V12.9167C13 13.4692 12.7805 13.9991 12.3898 14.3898C11.9991 14.7805 11.4692 15 10.9167 15H3.08334C2.53081 15 2.0009 14.7805 1.6102 14.3898C1.2195 13.9991 1.00001 13.4692 1.00001 12.9167L1.00001 5.08333C1.00001 4.5308 1.2195 4.0009 1.6102 3.61019C2.0009 3.21949 2.53081 3 3.08334 3H6.75001C7.16422 3 7.50001 3.33579 7.50001 3.75C7.50001 4.16421 7.16422 4.5 6.75001 4.5H3.08334Z", className: `${cx$1S(strokeClass, fillClass)}`, style: { stroke: 'none' } })));
};

var css$1R = ".PencilIcon_module_fill__3350acde{path-fill:#444750}.PencilIcon_module_overrideStroke__3350acde{stroke:none!important}";
window.ADS.injectStyle(css$1R,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PencilIcon.module.scss");
var modules_7cb7e38c = {"fill":"PencilIcon_module_fill__3350acde","overrideStroke":"PencilIcon_module_overrideStroke__3350acde"};

const cx$1E = classnames.bind(modules_7cb7e38c);
const PencilIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: `${cx$1E(modules_7cb7e38c.fill)} ${svgClass}`, viewBox: viewBox('PencilIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass}`, strokeOpacity: 0, fillRule: "evenodd", clipRule: "evenodd", d: "M14.6652 3.66673C14.6652 4.28518 14.4195 4.8783 13.9822 5.31562L4.80355 14.4943C4.67884 14.619 4.50969 14.6891 4.33332 14.6891H1.99999C1.63272 14.6891 1.33499 14.3913 1.33499 14.0241V11.6427C1.33499 11.4664 1.40505 11.2972 1.52977 11.1725L10.6844 2.01783C11.1217 1.58052 11.7149 1.33484 12.3333 1.33484C12.9518 1.33484 13.5449 1.58052 13.9822 2.01783C14.4195 2.45515 14.6652 3.04827 14.6652 3.66673ZM11.6249 2.95828C11.8128 2.77039 12.0676 2.66484 12.3333 2.66484C12.599 2.66484 12.8539 2.77039 13.0418 2.95828C13.2297 3.14618 13.3352 3.40101 13.3352 3.66673C13.3352 3.93244 13.2297 4.18728 13.0418 4.37517L12.512 4.90494L11.0951 3.48806L11.6249 2.95828ZM10.1547 4.42851L11.5715 5.84539L4.05787 13.3591H2.66499V11.9182L10.1547 4.42851Z" })));
};

var css$1Q = ".PeopleIcon_module_fill__40d51310{path-fill:#444750}.PeopleIcon_module_overrideStroke__40d51310{stroke:none!important}";
window.ADS.injectStyle(css$1Q,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PeopleIcon.module.scss");
var modules_dbe5c1df = {"fill":"PeopleIcon_module_fill__40d51310","overrideStroke":"PeopleIcon_module_overrideStroke__40d51310"};

const cx$1D = classnames.bind(modules_dbe5c1df);
const PeopleIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: `${cx$1D(modules_dbe5c1df.fill)} ${cx$1D(svgClass)}`, viewBox: viewBox('PeopleIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${cx$1D(strokeClass, fillClass)}`, style: { stroke: 'none' }, fillRule: "evenodd", clipRule: "evenodd", d: "M12.4937 4C10.7626 4 9.35368 4.46672 8.3791 5.43267C7.40445 6.39869 7.00972 7.71973 7.00972 9.12799V11.1959C6.34272 12.3052 6.55364 13.7203 7.46765 14.5793C7.79449 15.6068 8.2866 16.5339 8.91642 17.2793V17.7159C8.86673 17.7822 8.76936 17.8964 8.58846 18.0567C8.29433 18.3173 7.87014 18.6211 7.32528 18.9511C6.23895 19.6091 4.76303 20.3174 3.11363 20.9514L3.10096 20.9564C2.42768 21.2258 1.99902 21.8665 1.99902 22.5922V25.2413C1.99902 26.181 2.75175 27 3.74855 27H21.2508C22.2121 27 23.0003 26.2165 23.0003 25.2413V22.5922C23.0003 21.8673 22.5488 21.2289 21.9135 20.9626C21.8755 20.9467 21.8366 20.9332 21.7972 20.9221C20.1774 20.2892 18.7303 19.5923 17.6608 18.9458C17.1157 18.6163 16.6917 18.3136 16.3978 18.054C16.2177 17.8948 16.1206 17.7814 16.0711 17.7156V17.2793C16.7008 16.534 17.1928 15.6071 17.5197 14.5798C18.4322 13.7248 18.6594 12.3162 17.9778 11.1938V9.12799C17.9778 7.72501 17.5825 6.40506 16.6092 5.43827C15.6355 4.47106 14.227 4 12.4937 4ZM9.00972 9.12799C9.00972 8.08003 9.29877 7.33708 9.78701 6.85316C10.2753 6.36916 11.1084 6 12.4937 6C13.877 6 14.7105 6.37126 15.1997 6.8572C15.6893 7.34357 15.9778 8.08761 15.9778 9.12799V11.507C15.9778 11.7365 16.0567 11.959 16.2013 12.1372C16.487 12.4892 16.3974 12.957 16.0751 13.1829C15.8861 13.3154 15.7487 13.5092 15.6863 13.7314C15.3942 14.771 14.9147 15.6189 14.3525 16.1999C14.172 16.3864 14.0711 16.6357 14.0711 16.8953V17.9498C14.0711 18.0516 14.0866 18.1528 14.1172 18.2499C14.2816 18.7724 14.6889 19.2129 15.0735 19.5528C15.4892 19.92 16.0224 20.2925 16.6262 20.6574C17.8015 21.3679 19.3312 22.102 21.0003 22.7579V25H3.99902V22.7533C5.66385 22.1043 7.18884 21.372 8.36145 20.6617C8.96571 20.2957 9.49914 19.9219 9.91482 19.5536C10.2995 19.2127 10.7062 18.7716 10.8703 18.2499C10.9009 18.1528 10.9164 18.0516 10.9164 17.9498V16.8953C10.9164 16.6357 10.8155 16.3864 10.635 16.1999C10.0728 15.6189 9.59326 14.7711 9.3012 13.7314C9.23877 13.5092 9.10141 13.3154 8.9124 13.1829C8.59756 12.9623 8.50731 12.4823 8.78749 12.1356C8.93128 11.9577 9.00972 11.7358 9.00972 11.507V9.12799Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' }, d: "M23.4391 11.2996C22.3451 11.2996 21.3881 11.5977 20.7018 12.2597C20.0118 12.9253 19.7315 13.8273 19.7315 14.7559V15.8845C19.3107 16.6708 19.4641 17.6112 20.058 18.226C20.0714 18.2654 20.0852 18.3044 20.0994 18.3432C20.2889 18.862 20.8631 19.1288 21.3818 18.9393C21.9006 18.7497 22.1674 18.1755 21.9779 17.6568C21.9465 17.571 21.9177 17.4819 21.8917 17.3896C21.829 17.1671 21.6913 16.9733 21.5019 16.8409C21.4963 16.837 21.4937 16.8327 21.4937 16.8327C21.4937 16.8327 21.4944 16.8301 21.4962 16.8266C21.498 16.8231 21.5015 16.8171 21.5082 16.8089C21.6526 16.6308 21.7315 16.4084 21.7315 16.179V14.7559C21.7315 14.2225 21.886 13.8963 22.0903 13.6992C22.2983 13.4986 22.695 13.2996 23.4391 13.2996C24.2083 13.2996 24.5998 13.5013 24.7987 13.6953C24.9951 13.8869 25.1467 14.2103 25.1467 14.7559V16.179C25.1467 16.4153 25.2303 16.6439 25.3828 16.8244L25.3845 16.8265L25.384 16.8287C25.3834 16.8311 25.3824 16.8336 25.3811 16.8358C25.3796 16.8381 25.3782 16.8396 25.3763 16.8409C25.1869 16.9733 25.0491 17.1671 24.9865 17.3896C24.829 17.9488 24.57 18.3829 24.2818 18.6808C24.1013 18.8673 24.0004 19.1166 24.0004 19.3762V20C24.0004 20.1056 24.0171 20.2105 24.0499 20.3108C24.2223 20.8379 24.7295 21.5556 25.4129 22.2003C26.0491 22.8004 26.9162 23.4131 27.9987 23.8167V24.9484H25.4987C24.9464 24.9484 24.4987 25.3961 24.4987 25.9484C24.4987 26.5007 24.9464 26.9484 25.4987 26.9484H28.5441C29.3404 26.9484 29.9987 26.3186 29.9987 25.5V23.4289C29.9987 22.7776 29.5876 22.2963 29.1037 22.0842C29.0685 22.0687 29.0325 22.0553 28.9958 22.0441C28.0674 21.759 27.3213 21.2511 26.7853 20.7454C26.518 20.4933 26.3106 20.2488 26.1649 20.0456C26.0921 19.9442 26.0377 19.8572 26.0004 19.7898V19.7505C26.3468 19.3146 26.6256 18.7981 26.8208 18.2242C27.4084 17.6109 27.5719 16.6612 27.1467 15.8783V14.7559C27.1467 13.8394 26.8832 12.9347 26.1952 12.2636C25.5097 11.595 24.5474 11.2996 23.4391 11.2996Z" })));
};

var css$1P = ".PercentIcon_module_fill__46ebd552{fill:#444750}";
window.ADS.injectStyle(css$1P,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PercentIcon.module.scss");
var modules_411b5094 = {"fill":"PercentIcon_module_fill__46ebd552"};

const PercentIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_411b5094.fill), viewBox: viewBox('PercentIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.585 5.00002C2.585 3.61437 3.5856 2.33502 5 2.33502C6.4144 2.33502 7.415 3.61437 7.415 5.00002C7.415 6.38567 6.4144 7.66502 5 7.66502C3.5856 7.66502 2.585 6.38567 2.585 5.00002ZM5 3.66502C4.4814 3.66502 3.915 4.17653 3.915 5.00002C3.915 5.82351 4.4814 6.33502 5 6.33502C5.51859 6.33502 6.085 5.82351 6.085 5.00002C6.085 4.17653 5.51859 3.66502 5 3.66502Z", className: fillClass }),
        React.createElement("path", { d: "M10.8642 2.8444C11.2263 3.04556 11.3568 3.50216 11.1556 3.86425L6.15563 12.8642C5.95447 13.2263 5.49787 13.3568 5.13578 13.1556C4.77369 12.9545 4.64324 12.4979 4.8444 12.1358L9.8444 3.13578C10.0456 2.77369 10.5022 2.64324 10.8642 2.8444Z", className: fillClass }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.33502C9.5856 8.33502 8.585 9.61437 8.585 11C8.585 12.3857 9.5856 13.665 11 13.665C12.4144 13.665 13.415 12.3857 13.415 11C13.415 9.61437 12.4144 8.33502 11 8.33502ZM9.915 11C9.915 10.1765 10.4814 9.66502 11 9.66502C11.5186 9.66502 12.085 10.1765 12.085 11C12.085 11.8235 11.5186 12.335 11 12.335C10.4814 12.335 9.915 11.8235 9.915 11Z", className: fillClass })));
};

var css$1O = ".PhoneSlashIcon_module_fill__5c6cbd92{fill:#ea0a3b}";
window.ADS.injectStyle(css$1O,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PhoneSlashIcon.module.scss");
var modules_fa6ec78f = {"fill":"PhoneSlashIcon_module_fill__5c6cbd92"};

const PhoneSlashIcon = ({ size, svgClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_fa6ec78f.fill), viewBox: viewBox('PhoneSlashIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.91257 11.369C7.24964 13.6357 10.4709 15.0052 14.1228 15L14.124 15C14.6073 15 15 14.6082 15 14.125V11.8152C15 11.3816 14.6815 11.0132 14.2526 10.9496C13.2245 10.797 12.4917 10.6342 11.5487 10.1973L11.3555 10.1078C11.0855 9.98273 10.7647 10.0675 10.5917 10.3097C10.081 11.0248 8.78489 11.1616 7.98274 10.6045C7.53388 10.2929 7.10991 9.94491 6.71587 9.56574L4.91257 11.369ZM3.55517 9.81836L5.37949 7.99404C4.83714 7.18716 4.76934 5.75441 5.47754 5.24866C5.71957 5.07582 5.80431 4.75519 5.67929 4.48534L5.58937 4.29127C5.30465 3.50344 5.222 2.93223 5.10317 2.11093C5.08643 1.9952 5.06896 1.87451 5.05011 1.74754C4.98644 1.31861 4.61807 1 4.18445 1H1.87501C1.39176 1 1.00001 1.39395 1.00001 1.8772C0.996754 4.89305 1.93589 7.63212 3.55517 9.81836Z" }),
        React.createElement("path", { d: "M12.2988 4.34729L2.29883 14.3473", stroke: "#EA0A3B", strokeWidth: "1.5", strokeLinecap: "round" })));
};

var css$1N = ".PlayIcon_module_fill__6599748d{path-fill:#444750}.PlayIcon_module_overrideStroke__6599748d{stroke:none!important}";
window.ADS.injectStyle(css$1N,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PlayIcon.module.scss");
var modules_ee1bf941 = {"fill":"PlayIcon_module_fill__6599748d","overrideStroke":"PlayIcon_module_overrideStroke__6599748d"};

const PlayIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: `${cx$1S(modules_ee1bf941.fill)} ${cx$1S(svgClass)}`, viewBox: viewBox('PlayIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M6.395 10.2417C6.395 10.6345 6.82718 10.8739 7.1602 10.6655L10.7433 8.42384C11.0563 8.22796 11.0563 7.77195 10.7433 7.57608L7.1602 5.33437C6.82718 5.12602 6.395 5.36543 6.395 5.75825V10.2417Z", className: `${cx$1S(strokeClass, fillClass)}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8Z", className: `${cx$1S(strokeClass, fillClass)}`, style: { stroke: 'none' } })));
};

var css$1M = ".PoundIcon_module_fill__23b2ce1a{fill:#444750}";
window.ADS.injectStyle(css$1M,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PoundIcon.module.scss");
var modules_145134b3 = {"fill":"PoundIcon_module_fill__23b2ce1a"};

const PoundIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_145134b3.fill), viewBox: viewBox('PoundIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 5C6.25 3.48122 7.48122 2.25 9 2.25C10.5188 2.25 11.75 3.48122 11.75 5C11.75 5.41421 11.4142 5.75 11 5.75C10.5858 5.75 10.25 5.41421 10.25 5C10.25 4.30964 9.69036 3.75 9 3.75C8.30964 3.75 7.75 4.30964 7.75 5V7.25H9C9.41421 7.25 9.75 7.58579 9.75 8C9.75 8.41421 9.41421 8.75 9 8.75H7.75V10C7.75 10.4501 7.64186 10.875 7.45015 11.25H11C11.4142 11.25 11.75 11.5858 11.75 12C11.75 12.4142 11.4142 12.75 11 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25C5.69036 11.25 6.25 10.6904 6.25 10V8.75H5C4.58579 8.75 4.25 8.41421 4.25 8C4.25 7.58579 4.58579 7.25 5 7.25H6.25V5Z", className: fillClass })));
};

var css$1L = ".PrintIcon_module_fill__8c41cb42{path-fill:#444750}.PrintIcon_module_overrideStroke__8c41cb42{stroke:none!important}";
window.ADS.injectStyle(css$1L,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/PrintIcon.module.scss");
var modules_9aa41e85 = {"fill":"PrintIcon_module_fill__8c41cb42","overrideStroke":"PrintIcon_module_overrideStroke__8c41cb42"};

// This icon is currently not intended to be used widely, and thus is hidden from Storybook.
const PrintIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: `${cx$1S(modules_9aa41e85.fill)} ${svgClass}`, viewBox: viewBox('PrintIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M10 7.75C10 7.47386 10.2239 7.25 10.5 7.25H11.5C11.7761 7.25 12 7.47386 12 7.75C12 8.02614 11.7761 8.25 11.5 8.25H10.5C10.2239 8.25 10 8.02614 10 7.75Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.333C12 1.5968 11.4032 1 10.667 1H5.333C4.5968 1 4 1.5968 4 2.333V5H3C1.89543 5 1 5.89543 1 7V11C1 12.1046 1.89543 13 3 13H4V13.667C4 14.4032 4.5968 15 5.333 15H10.667C11.4032 15 12 14.4032 12 13.667V13H13C14.1046 13 15 12.1046 15 11V7C15 5.89543 14.1046 5 13 5H12V2.333ZM2.333 11C2.333 11.2471 2.46736 11.4628 2.667 11.5781C2.76499 11.6346 2.87872 11.667 3 11.667H4V10.333C4 9.5968 4.5968 9 5.333 9H10.667C11.4032 9 12 9.5978 12 10.334V11.667H13C13.1213 11.667 13.235 11.6346 13.333 11.5781C13.5326 11.4628 13.667 11.2471 13.667 11V7C13.667 6.63163 13.3684 6.333 13 6.333H3C2.63163 6.333 2.333 6.63163 2.333 7V11ZM10.667 5V2.333H5.333V5H10.667ZM10.667 13.667H5.333V10.333H10.667V13.667Z", className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' } })));
};

var css$1K = ".QuestionCircleIcon_module_fill__df80ebb6{path-fill:#444750}.QuestionCircleIcon_module_overrideStroke__df80ebb6{stroke:none!important}";
window.ADS.injectStyle(css$1K,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/QuestionCircleIcon.module.scss");
var modules_1f24fad1 = {"fill":"QuestionCircleIcon_module_fill__df80ebb6","overrideStroke":"QuestionCircleIcon_module_overrideStroke__df80ebb6"};

const QuestionCircleIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: `${cx$1S(modules_1f24fad1.fill)} ${svgClass}`, viewBox: viewBox('QuestionCircleIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1S(modules_1f24fad1.overrideStroke)}`, d: "M9.35711 7.51313C9.14562 7.66011 8.99729 7.83461 8.94041 7.9175C8.68103 8.29545 8.16437 8.39158 7.78641 8.1322C7.40846 7.87282 7.31233 7.35616 7.57171 6.97821C7.73025 6.74718 8.01678 6.42312 8.40974 6.15001C8.80639 5.87434 9.35606 5.62073 10.0195 5.62073C11.5571 5.62073 12.7884 6.81391 12.7884 8.2234C12.7884 9.51984 11.8483 10.2547 11.4201 10.5895C11.412 10.5958 11.4041 10.602 11.3964 10.608C11.3795 10.6213 11.3634 10.6339 11.3485 10.6458C11.2836 10.6974 11.2011 10.759 11.1349 10.8085C11.1272 10.8142 11.1197 10.8198 11.1125 10.8252C11.0909 10.8414 11.0716 10.8559 11.0564 10.8675C11.0105 10.9024 10.9737 10.9318 10.9436 10.9574C10.8683 11.0216 10.8546 11.0669 10.8392 11.1642C10.7762 11.5602 10.4332 11.8629 10.0195 11.8629C9.56112 11.8629 9.18951 11.4913 9.18951 11.0329C9.18951 10.4906 9.44614 10.1052 9.70045 9.84789C9.85745 9.68906 10.0874 9.5175 10.2245 9.41526C10.2294 9.4116 10.2343 9.40792 10.239 9.40445C10.2715 9.38013 10.298 9.3603 10.3155 9.34634C10.8219 8.94387 11.1284 8.67675 11.1284 8.2234C11.1284 7.80482 10.7162 7.28073 10.0195 7.28073C9.78923 7.28073 9.56489 7.36872 9.35711 7.51313Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1S(modules_1f24fad1.overrideStroke)}`, d: "M10.8361 13.5533C10.8361 13.0949 10.4645 12.7233 10.0061 12.7233C9.54767 12.7233 9.17607 13.0949 9.17607 13.5533V13.5543C9.17607 14.0126 9.54767 14.3843 10.0061 14.3843C10.4645 14.3843 10.8361 14.0126 10.8361 13.5543V13.5533Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1S(modules_1f24fad1.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM16.34 10C16.34 13.5015 13.5015 16.34 10 16.34C6.49851 16.34 3.66 13.5015 3.66 10C3.66 6.49851 6.49851 3.66 10 3.66C13.5015 3.66 16.34 6.49851 16.34 10Z" })));
};

const RefreshIcon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('RefreshIcon'), xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M11.6565 5.00136C10.7874 3.95358 9.4721 3.28571 8 3.28571C5.60161 3.28571 3.61939 5.05848 3.30496 7.35879C3.25687 7.71059 2.9722 8 2.61534 8C2.25848 8 1.96554 7.7112 2.00328 7.35815C2.32523 4.34625 4.88721 2 8 2C9.78171 2 11.383 2.76869 12.487 3.99091V3.07279C12.487 2.71775 12.7763 2.42993 13.1331 2.42993C13.49 2.42993 13.7793 2.71775 13.7793 3.07279V5.8585C13.7793 6.0952 13.5864 6.28707 13.3485 6.28707H10.5485C10.1916 6.28707 9.90235 5.99926 9.90235 5.64422C9.90235 5.28918 10.1916 5.00136 10.5485 5.00136H11.6565Z", fillRule: "evenodd", clipRule: "evenodd", className: cx$1S(strokeClass, fillClass), style: { stroke: 'none' } }),
        React.createElement("path", { d: "M12.695 8.64121C12.7431 8.28941 13.0278 8 13.3847 8C13.7415 8 14.0345 8.2888 13.9967 8.64185C13.6748 11.6538 11.1128 14 8 14C6.21506 14 4.61123 13.2285 3.50702 12.0024V12.9212C3.50702 13.2762 3.21772 13.5641 2.86086 13.5641C2.50399 13.5641 2.2147 13.2762 2.2147 12.9212L2.2147 10.1355C2.2147 9.89879 2.40756 9.70691 2.64547 9.70691H5.44549C5.80236 9.70691 6.09165 9.99473 6.09165 10.3498C6.09165 10.7048 5.80236 10.9926 5.44549 10.9926H4.33849C5.20755 12.0439 6.52508 12.7143 8 12.7143C10.3984 12.7143 12.3806 10.9415 12.695 8.64121Z", fillRule: "evenodd", clipRule: "evenodd", className: `${cx$1S(strokeClass, fillClass)}`, style: { stroke: 'none' } })));
};

var css$1J = ".SearchIcon_module_overrideStroke__a491b335{stroke:none!important}";
window.ADS.injectStyle(css$1J,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/SearchIcon.module.scss");
var modules_69eec04f = {"overrideStroke":"SearchIcon_module_overrideStroke__a491b335"};

const SearchIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('SearchIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${fillClass} ${cx$1S(modules_69eec04f.overrideStroke)}`, fillRule: "evenodd", clipRule: "evenodd", d: "M10.5788 11.8163C9.57969 12.5599 8.34124 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 8.34124 12.5599 9.57969 11.8163 10.5788L14.7437 13.5063C15.0854 13.848 15.0854 14.402 14.7437 14.7437C14.402 15.0854 13.848 15.0854 13.5063 14.7437L10.5788 11.8163ZM11.25 7C11.25 9.34721 9.34721 11.25 7 11.25C4.65279 11.25 2.75 9.34721 2.75 7C2.75 4.65279 4.65279 2.75 7 2.75C9.34721 2.75 11.25 4.65279 11.25 7Z" })));
};

var css$1I = ".ShiftIcon_module_shiftDown__ec08002d{transform:rotate(180deg)}.ShiftIcon_module_overrideStroke__ec08002d{stroke:none!important}";
window.ADS.injectStyle(css$1I,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/ShiftIcon.module.scss");
var modules_e738b124 = {"shiftDown":"ShiftIcon_module_shiftDown__ec08002d","overrideStroke":"ShiftIcon_module_overrideStroke__ec08002d"};

const ShiftDownIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: cx$1S(svgClass, modules_e738b124.shiftDown), viewBox: viewBox('ShiftDownIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.4353 10.2094C12.6717 10.5403 12.4351 11 12.0284 11H3.97162C3.56493 11 3.32837 10.5403 3.56475 10.2094L7.59315 4.56961C7.79256 4.29044 8.20748 4.29044 8.40689 4.56961L12.4353 10.2094Z", className: `${fillClass} ${cx$1S(modules_e738b124.overrideStroke)}` })));
};

const ShiftUpIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('ShiftUpIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.4353 10.2094C12.6717 10.5403 12.4351 11 12.0284 11H3.97162C3.56493 11 3.32837 10.5403 3.56475 10.2094L7.59315 4.56961C7.79256 4.29044 8.20748 4.29044 8.40689 4.56961L12.4353 10.2094Z", className: `${fillClass} ${cx$1S(modules_e738b124.overrideStroke)}` })));
};

const SixDotsIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: viewBox('SixDotsIcon') },
        React.createElement("path", { d: "M7 3H5v2h2V3ZM7 7H5v2h2V7ZM5 11h2v2H5v-2ZM11 3H9v2h2V3ZM9 7h2v2H9V7ZM11 11H9v2h2v-2Z", className: fillClass })));
};

var css$1H = ".SmCloseIcon_module_cross__4682c6da{fill:#6a6f82}";
window.ADS.injectStyle(css$1H,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/SmCloseIcon.module.scss");
var modules_0a5b58f7 = {"cross":"SmCloseIcon_module_cross__4682c6da"};

const SmCloseIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { width: size, height: size, viewBox: viewBox('SmCloseIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg", className: svgClass },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25828 3.25823C3.59998 2.91653 4.154 2.91653 4.49571 3.25823L8.00003 6.76255L11.5043 3.25823C11.8461 2.91653 12.4001 2.91653 12.7418 3.25824C13.0835 3.59994 13.0835 4.15396 12.7418 4.49567L9.23747 7.99999L12.7418 11.5043C13.0835 11.846 13.0835 12.4 12.7418 12.7417C12.4001 13.0835 11.8461 13.0835 11.5043 12.7417L8.00003 9.23742L4.4957 12.7417C4.15399 13.0835 3.59997 13.0835 3.25826 12.7417C2.91656 12.4 2.91656 11.846 3.25827 11.5043L6.76259 7.99999L3.25828 4.49567C2.91657 4.15396 2.91657 3.59994 3.25828 3.25823Z", className: colorOverride ? fillClass : cx$1S(modules_0a5b58f7.cross) })));
};

const SortArrowIcon = ({ size, svgClass, fillClass, focused }) => {
    const styles = {};
    if (focused) {
        styles.transform = 'rotate(180deg)';
    }
    return (React__default.createElement("svg", { width: size, height: size, style: styles, className: svgClass, viewBox: viewBox('SortArrowIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.25C8.41421 2.25 8.75 2.58579 8.75 3V11.1893L11.4697 8.46967C11.7626 8.17678 12.2374 8.17678 12.5303 8.46967C12.8232 8.76256 12.8232 9.23744 12.5303 9.53033L8.53033 13.5303C8.23744 13.8232 7.76256 13.8232 7.46967 13.5303L3.46967 9.53033C3.17678 9.23744 3.17678 8.76256 3.46967 8.46967C3.76256 8.17678 4.23744 8.17678 4.53033 8.46967L7.25 11.1893V3C7.25 2.58579 7.58579 2.25 8 2.25Z", className: `${fillClass}` })));
};

var css$1G = ".SpinnerIcon_module_rotateSpinner__420529d1{animation:SpinnerIcon_module_rotation__420529d1 .75s linear infinite}@keyframes SpinnerIcon_module_rotation__420529d1{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}";
window.ADS.injectStyle(css$1G,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/SpinnerIcon.module.scss");
var modules_db06b6a6 = {"rotateSpinner":"SpinnerIcon_module_rotateSpinner__420529d1","rotation":"SpinnerIcon_module_rotation__420529d1"};

const SpinnerIcon = ({ size, svgClass, strokeClass }) => {
    return (React.createElement("svg", { height: size, width: size, viewBox: viewBox('SpinnerIcon'), className: cx$1S(svgClass, strokeClass, modules_db06b6a6.rotateSpinner) },
        React.createElement("g", null,
            React.createElement("circle", { strokeWidth: "7", strokeDasharray: "192", strokeDashoffset: "0", r: "26", cx: "32", cy: "32", fill: "none" }),
            React.createElement("circle", { strokeWidth: "7", strokeDasharray: "128", strokeDashoffset: "82", r: "26", cx: "32", cy: "32", fill: "none" }))));
};

const StarIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('StarIcon'), xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M6 8.88501L9.09 10.75L8.27 7.23501L11 4.87001L7.405 4.56501L6 1.25001L4.595 4.56501L1 4.87001L3.73 7.23501L2.91 10.75L6 8.88501Z", className: fillClass })));
};

var css$1F = ".SuccessIcon_module_fill__78c2d6b3{fill:#03866a}";
window.ADS.injectStyle(css$1F,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/SuccessIcon.module.scss");
var modules_4699208d = {"fill":"SuccessIcon_module_fill__78c2d6b3"};

const SuccessIcon$1 = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, viewBox: viewBox('SuccessIcon'), fill: "none", className: svgClass },
        React.createElement("path", { d: "M15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L11 12.5858L9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L15.7071 10.7071Z", className: colorOverride ? fillClass : cx$1S(modules_4699208d.fill) }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12Z", className: colorOverride ? fillClass : cx$1S(modules_4699208d.fill) })));
};

var css$1E = ".SuccessIconFilled_module_fill__6c11e5a0{fill:#03866a}";
window.ADS.injectStyle(css$1E,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/SuccessIconFilled.module.scss");
var modules_14207a69 = {"fill":"SuccessIconFilled_module_fill__6c11e5a0"};

const SuccessIconFilled = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, viewBox: viewBox('SuccessIconFilled'), className: svgClass },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM11.7474 6.66436C12.1143 6.25158 12.0771 5.61951 11.6644 5.25259C11.2516 4.88567 10.6195 4.92285 10.2526 5.33564L6.95718 9.04297L5.70711 7.79289C5.31658 7.40237 4.68342 7.40237 4.29289 7.79289C3.90237 8.18342 3.90237 8.81658 4.29289 9.20711L6.29289 11.2071C6.48764 11.4019 6.75408 11.5077 7.02937 11.4996C7.30467 11.4915 7.56444 11.3702 7.74741 11.1644L11.7474 6.66436Z", className: colorOverride ? fillClass : cx$1S(modules_14207a69.fill) })));
};

var css$1D = ".TextBubblesIcon_module_fill__99c67a22{fill:#03866a}";
window.ADS.injectStyle(css$1D,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/TextBubblesIcon.module.scss");
var modules_0f525d93 = {"fill":"TextBubblesIcon_module_fill__99c67a22"};

const TextBubblesIcon = ({ size, svgClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_0f525d93.fill), viewBox: viewBox('TextBubblesIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M2 1C0.895431 1 0 1.89543 0 3V7C0 8.10457 0.895431 9 2 9H4V12L7 9H9C10.1046 9 11 8.10457 11 7V3C11 1.89543 10.1046 1 9 1H2Z" }),
        React.createElement("path", { d: "M6.06152 12.7667L7.82822 11H8.9998C11.2089 11 12.9998 9.20912 12.9998 7V5H13.9998C15.1044 5 15.9998 5.89543 15.9998 7V11C15.9998 12.1046 15.1044 13 13.9998 13H11.9998V16L8.9998 13H6.9998C6.66071 13 6.34134 12.9156 6.06152 12.7667Z" })));
};

var css$1C = ".TrashCanIcon_module_fill__e4f572e3{path-fill:#444750}.TrashCanIcon_module_overrideStroke__e4f572e3{stroke:none!important}";
window.ADS.injectStyle(css$1C,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/TrashCanIcon.module.scss");
var modules_5b5b79f9 = {"fill":"TrashCanIcon_module_fill__e4f572e3","overrideStroke":"TrashCanIcon_module_overrideStroke__e4f572e3"};

const cx$1C = classnames.bind(modules_5b5b79f9);
const TrashCanIcon = ({ size, svgClass, strokeClass, fillClass = '' }) => {
    return (React.createElement("svg", { width: size, height: size, className: `${cx$1C(modules_5b5b79f9.fill)} ${svgClass}`, viewBox: viewBox('TrashCanIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' }, d: "M6.68 11.9201C7.05 11.9201 7.35 11.6201 7.35 11.2501V7.73006C7.35 7.36006 7.05 7.06006 6.68 7.06006C6.31 7.06006 6.01 7.36006 6.01 7.73006V11.2501C6.01 11.6201 6.31 11.9201 6.68 11.9201Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' }, d: "M9.31 11.9201C9.68 11.9201 9.98 11.6201 9.98 11.2501V7.73006C9.98 7.36006 9.68 7.06006 9.31 7.06006C8.94 7.06006 8.64 7.36006 8.64 7.73006V11.2501C8.64 11.6201 8.94 11.9201 9.31 11.9201Z" }),
        React.createElement("path", { className: `${strokeClass} ${fillClass}`, style: { stroke: 'none' }, fillRule: "evenodd", clipRule: "evenodd", d: "M11 4H13.33C13.7 4 14 4.3 14 4.67C14 5.04 13.7 5.33 13.33 5.33H13.22L12.69 13.05C12.66 13.57 12.43 14.07 12.08 14.42C11.69 14.81 11.21 15.02 10.72 15.02H5.28C4.8 15.02 4.31 14.8 3.92 14.42C3.57 14.07 3.35 13.57 3.31 13.04L2.78 5.33H2.67C2.3 5.33 2 5.04 2 4.67C2 4.3 2.3 4 2.67 4H4.99V2.36C4.99 2 5.12 1.67 5.36 1.41C5.61 1.15 5.96 1 6.31 1H9.67C10.03 1 10.37 1.15 10.62 1.41C10.87 1.67 11 2 11 2.36V4ZM9.67 4V2.34H6.33V4H9.67ZM11.15 13.45C11.27 13.33 11.36 13.13 11.37 12.93L11.88 5.33H4.11L4.63 12.93C4.65 13.13 4.73 13.33 4.85 13.45C4.99 13.58 5.15 13.66 5.28 13.66H10.72C10.85 13.66 11.01 13.58 11.15 13.45Z" })));
};

var css$1B = ".TriangleLeft16Icon_module_overrideStroke__dec5bf28{stroke:none!important}";
window.ADS.injectStyle(css$1B,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/TriangleLeft16Icon.module.scss");
var modules_6b57eac1 = {"overrideStroke":"TriangleLeft16Icon_module_overrideStroke__dec5bf28"};

const cx$1B = classnames.bind(modules_6b57eac1);
const TriangleLeft16Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('TriangleLeft16Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1B(modules_6b57eac1.overrideStroke)}`, d: "M11 3.97159V12.0284C11 12.4351 10.5403 12.6717 10.2094 12.4353L4.56961 8.40687C4.29044 8.20746 4.29044 7.79254 4.56961 7.59313L10.2094 3.56473C10.5403 3.32835 11 3.56491 11 3.97159Z" })));
};

var css$1A = ".TriangleRight16Icon_module_overrideStroke__9e06a076{stroke:none!important}";
window.ADS.injectStyle(css$1A,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/TriangleRight16Icon.module.scss");
var modules_11f8cc07 = {"overrideStroke":"TriangleRight16Icon_module_overrideStroke__9e06a076"};

const cx$1A = classnames.bind(modules_11f8cc07);
const TriangleRight16Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('TriangleRight16Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1A(modules_11f8cc07.overrideStroke)}`, d: "M5 3.97159L5 12.0284C5 12.4351 5.45969 12.6717 5.79062 12.4353L11.4304 8.40687C11.7096 8.20746 11.7096 7.79254 11.4304 7.59313L5.79062 3.56473C5.45968 3.32835 5 3.56491 5 3.97159Z" })));
};

var css$1z = ".Undo16Icon_module_overrideStroke__8fa496d3{stroke:none!important}";
window.ADS.injectStyle(css$1z,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/Undo16Icon.module.scss");
var modules_d33c3d17 = {"overrideStroke":"Undo16Icon_module_overrideStroke__8fa496d3"};

const cx$1z = classnames.bind(modules_d33c3d17);
const Undo16Icon = ({ size, svgClass, strokeClass, fillClass }) => {
    return (React.createElement("svg", { width: size, height: size, className: svgClass, viewBox: viewBox('Undo16Icon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${fillClass} ${cx$1z(modules_d33c3d17.overrideStroke)}`, d: "M6.58691 3.58694C6.91105 3.26281 6.91105 2.73728 6.58691 2.41315C6.26278 2.08901 5.73725 2.08901 5.41311 2.41315L2.41311 5.41315C2.08898 5.73728 2.08898 6.26281 2.41311 6.58694L5.41311 9.58694C5.73725 9.91108 6.26278 9.91108 6.58691 9.58694C6.91105 9.26281 6.91105 8.73728 6.58691 8.41315L5.00381 6.83004H9.50001C10.9746 6.83004 12.17 8.02544 12.17 9.50004C12.17 10.9746 10.9746 12.17 9.50001 12.17H7.00001C6.54162 12.17 6.17001 12.5416 6.17001 13C6.17001 13.4584 6.54162 13.83 7.00001 13.83H9.50001C11.8914 13.83 13.83 11.8914 13.83 9.50004C13.83 7.10865 11.8914 5.17004 9.50001 5.17004H5.00381L6.58691 3.58694Z" })));
};

var css$1y = ".UploadIcon_module_fill__29162730{fill:#6a6f82}";
window.ADS.injectStyle(css$1y,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/UploadIcon.module.scss");
var modules_b8eba379 = {"fill":"UploadIcon_module_fill__29162730"};

const UploadIcon = ({ size, svgClass, fillClass }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('UploadIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6667 3.66667C11.5371 3.66667 9 6.20372 9 9.33334C9 9.76183 9.04738 10.1781 9.13679 10.5775C9.2574 11.1163 8.91854 11.6509 8.37981 11.7717C6.44501 12.2057 5 13.9353 5 16C5 18.3932 6.9401 20.3333 9.33333 20.3333C9.88562 20.3333 10.3333 20.7811 10.3333 21.3333C10.3333 21.8856 9.88562 22.3333 9.33333 22.3333C5.83553 22.3333 3 19.4978 3 16C3 13.3112 4.67483 11.0154 7.03752 10.0959C7.01269 9.84488 7 9.59047 7 9.33334C7 5.09916 10.4325 1.66667 14.6667 1.66667C18.0979 1.66667 21.0009 3.91986 21.98 7.0269C25.9116 7.35527 29 10.6503 29 14.6667C29 18.3769 26.3655 21.4696 22.8656 22.18C22.3244 22.2899 21.7965 21.9402 21.6867 21.3989C21.5768 20.8577 21.9265 20.3298 22.4677 20.22C25.0539 19.695 27 17.407 27 14.6667C27 11.5371 24.4629 9.00001 21.3333 9.00001C21.2954 9.00001 21.2576 9.00038 21.2198 9.00112C20.7369 9.01057 20.3162 8.67346 20.2202 8.20005C19.6957 5.61338 17.4074 3.66667 14.6667 3.66667ZM16 12.3333C16.2652 12.3333 16.5196 12.4387 16.7071 12.6262L20.7071 16.6262C21.0976 17.0168 21.0976 17.6499 20.7071 18.0404C20.3166 18.431 19.6834 18.431 19.2929 18.0404L17 15.7476L17 27.3333C17 27.8856 16.5523 28.3333 16 28.3333C15.4477 28.3333 15 27.8856 15 27.3333L15 15.7476L12.7071 18.0404C12.3166 18.431 11.6834 18.431 11.2929 18.0404C10.9024 17.6499 10.9024 17.0168 11.2929 16.6262L15.2929 12.6262C15.4804 12.4387 15.7348 12.3333 16 12.3333Z", className: (cx$1S(modules_b8eba379.fill), fillClass) })));
};

var css$1x = ".WarningIcon_module_triangle__a687e487{fill:#f45110}";
window.ADS.injectStyle(css$1x,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/WarningIcon.module.scss");
var modules_dd05cc9f = {"triangle":"WarningIcon_module_triangle__a687e487"};

const WarningIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: size, width: size, className: svgClass, viewBox: viewBox('WarningIcon') },
        React.createElement("path", { className: colorOverride ? fillClass : cx$1S(modules_dd05cc9f.triangle), d: "M13.0001 10C13.0001 9.44771 12.5523 9 12.0001 9C11.4478 9 11.0001 9.44771 11.0001 10V12C11.0001 12.5523 11.4478 13 12.0001 13C12.5523 13 13.0001 12.5523 13.0001 12V10Z" }),
        React.createElement("path", { className: colorOverride ? fillClass : cx$1S(modules_dd05cc9f.triangle), d: "M12.0001 15C11.4478 15 11.0001 15.4477 11.0001 16C11.0001 16.5523 11.4478 17 12.0001 17H12.0101C12.5623 17 13.0101 16.5523 13.0101 16C13.0101 15.4477 12.5623 15 12.0101 15H12.0001Z" }),
        React.createElement("path", { className: colorOverride ? fillClass : cx$1S(modules_dd05cc9f.triangle), fillRule: "evenodd", clipRule: "evenodd", d: "M14.5981 4.5C13.4434 2.5 10.5567 2.5 9.40199 4.5L2.47378 16.5C1.31908 18.5 2.76246 21 5.07186 21H18.9283C21.2377 21 22.681 18.5 21.5263 16.5L14.5981 4.5ZM11.134 5.5C11.5189 4.83333 12.4812 4.83333 12.8661 5.5L19.7943 17.5C20.1792 18.1667 19.6981 19 18.9283 19H5.07186C4.30206 19 3.82093 18.1667 4.20583 17.5L11.134 5.5Z" })));
};

var css$1w = ".WarningIconFilled_module_triangle__560a4239{fill:#f45110}";
window.ADS.injectStyle(css$1w,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/WarningIconFilled.module.scss");
var modules_deae750d = {"triangle":"WarningIconFilled_module_triangle__560a4239"};

const WarningIconFilled = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: size, width: size, className: svgClass, viewBox: viewBox('WarningIconFilled') },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.095 12.8771L7.38594 1.37426C7.44818 1.26047 7.53769 1.16598 7.64548 1.10028C7.75327 1.03459 7.87554 1 8 1C8.12446 1 8.24674 1.03459 8.35453 1.10028C8.46232 1.16598 8.55183 1.26047 8.61406 1.37426L14.905 12.8771C14.9672 12.9909 15 13.12 15 13.2514C15 13.3828 14.9672 13.5119 14.905 13.6257C14.8428 13.7395 14.7533 13.834 14.6455 13.8997C14.5377 13.9654 14.4154 14 14.2909 14H1.70906C1.58459 14 1.46232 13.9654 1.35453 13.8997C1.24674 13.834 1.15723 13.7395 1.09499 13.6257C1.03276 13.5119 1 13.3828 1 13.2514C1 13.12 1.03276 12.9909 1.095 12.8771ZM8.01347 4.5C8.56576 4.5 9.01347 4.94772 9.01347 5.5V7.75C9.01347 8.30228 8.56576 8.75 8.01347 8.75C7.46119 8.75 7.01347 8.30228 7.01347 7.75V5.5C7.01347 4.94772 7.46119 4.5 8.01347 4.5ZM9.25 11.25C9.25 11.9404 8.69036 12.5 8 12.5C7.30964 12.5 6.75 11.9404 6.75 11.25C6.75 10.5596 7.30964 10 8 10C8.69036 10 9.25 10.5596 9.25 11.25Z", className: colorOverride ? fillClass : cx$1S(modules_deae750d.triangle) })));
};

var css$1v = ".CheckedCheckboxGroupIcon_module_fill__f45d5375{fill:#6a6f82}";
window.ADS.injectStyle(css$1v,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/CheckedCheckboxGroupIcon.module.scss");
var modules_48cb9b97 = {"fill":"CheckedCheckboxGroupIcon_module_fill__f45d5375"};

const CheckedCheckboxGroupIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('CheckedCheckboxGroupIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: colorOverride ? fillClass : cx$1S(modules_48cb9b97.fill), fillRule: "evenodd", clipRule: "evenodd", d: "M9 16C10.3538 16 11.4981 15.1033 11.8715 13.8715C12.8275 13.5817 13.5817 12.8275 13.8715 11.8715C15.1033 11.4981 16 10.3538 16 9V3C16 1.34315 14.6569 0 13 0H7C5.64623 0 4.5019 0.896691 4.12854 2.12854C3.17248 2.41831 2.41831 3.17248 2.12854 4.12854C0.896691 4.5019 0 5.64623 0 7V13C0 14.6569 1.34315 16 3 16H9ZM12 7C12 5.34315 10.6569 4 9 4H3.26756C3.61337 3.4022 4.25972 3 5 3H11C12.1046 3 13 3.89543 13 5V11C13 11.7403 12.5978 12.3866 12 12.7324V7ZM14 5C14 3.34315 12.6569 2 11 2H5.26756C5.61337 1.4022 6.25972 1 7 1H13C14.1046 1 15 1.89543 15 3V9C15 9.74028 14.5978 10.3866 14 10.7324V5ZM9.56016 6.9278C9.93141 7.23717 9.98157 7.78892 9.6722 8.16016L5.6722 12.9602C5.51167 13.1528 5.2762 13.2673 5.02555 13.2746C4.77491 13.2819 4.53316 13.1814 4.36166 12.9984L2.36166 10.8651C2.03114 10.5126 2.04901 9.95883 2.40155 9.62832C2.7541 9.2978 3.30783 9.31567 3.63835 9.66821L4.96142 11.0795L8.32781 7.03984C8.63718 6.66859 9.18892 6.61844 9.56016 6.9278Z" }),
        ";"));
};

var css$1u = ".DesiredIndicatorIcon_module_fill__0f6bff2f{fill:#f45110}";
window.ADS.injectStyle(css$1u,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/DesiredIndicatorIcon.module.scss");
var modules_f2008ec6 = {"fill":"DesiredIndicatorIcon_module_fill__0f6bff2f"};

const DesiredIndicatorIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_f2008ec6.fill), viewBox: viewBox('DesiredIndicatorIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.99487 7.5L2.94653 9.5L1.91669 7.73469L5.19159 6.12245L4.96503 2.5H7.02472L6.79815 6.12245L10.0834 7.73469L9.05351 9.5L5.99487 7.5Z", className: colorOverride ? fillClass : cx$1S(modules_f2008ec6.fill) })));
};

var css$1t = ".RequiredIndicatorIcon_module_fill__34e68815{fill:#ea0a3b}";
window.ADS.injectStyle(css$1t,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/RequiredIndicatorIcon.module.scss");
var modules_2c77d108 = {"fill":"RequiredIndicatorIcon_module_fill__34e68815"};

const RequiredIndicatorIcon = ({ size, svgClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: cx$1S(svgClass, modules_2c77d108.fill), viewBox: viewBox('RequiredIndicatorIcon'), fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.89508 2.2L6.5696 5.30835L9.69422 4.42141L9.93834 6.1546L7.01714 6.41499L8.91307 8.94561L7.33448 9.8L5.95932 7.07409L4.73063 9.79186L3.08694 8.94561L4.9666 6.41499L2.06168 6.14646L2.33834 4.42141L5.406 5.30835L5.08052 2.2H6.89508Z", className: colorOverride ? fillClass : cx$1S(modules_2c77d108.fill) })));
};

var css$1s = ".RightwardTriangleIcon_module_fill__0daf48a2{fill:#365ef6}";
window.ADS.injectStyle(css$1s,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Icon/icons/RightwardTriangleIcon.module.scss");
var modules_9adcf72f = {"fill":"RightwardTriangleIcon_module_fill__0daf48a2"};

const RightwardTriangleIcon = ({ size, svgClass, strokeClass, fillClass, colorOverride }) => {
    return (React.createElement("svg", { height: size, width: size, className: svgClass, viewBox: viewBox('RightwardTriangleIcon'), xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { className: `${strokeClass} ${colorOverride ? fillClass : cx$1S(modules_9adcf72f.fill)}`, d: "M5 3.97159L5 12.0284C5 12.4351 5.45969 12.6717 5.79062 12.4353L11.4304 8.40687C11.7096 8.20746 11.7096 7.79254 11.4304 7.59313L5.79062 3.56473C5.45968 3.32835 5 3.56491 5 3.97159Z" })));
};

const NotFound = ({ size }) => {
    return (React__default.createElement("div", { "data-test": "icon-not-found", style: { width: size, height: size }, className: cx$1S(modules_c4937a59.wrapper) },
        React__default.createElement("svg", { viewBox: `0 0 ${size} ${size}`, style: { width: '100%' }, className: cx$1S(modules_c4937a59.icon) },
            React__default.createElement("rect", { width: "100%", height: "100%", fill: "#858b9d", rx: "4" }),
            React__default.createElement("text", { x: "50%", y: "25%", dominantBaseline: "middle", textAnchor: "middle", fontSize: size / 3.2, fill: "white", fontVariant: "small-caps" }, "icon"),
            React__default.createElement("text", { x: "50%", y: "50%", dominantBaseline: "middle", textAnchor: "middle", fontSize: size / 3.2, fill: "white", fontVariant: "small-caps" }, "not"),
            React__default.createElement("text", { x: "50%", y: "75%", dominantBaseline: "middle", textAnchor: "middle", fontSize: size / 3.2, fill: "white", fontVariant: "small-caps" }, "found"))));
};

const cx$1y = classnames.bind(modules_c4937a59);
const IconList = {
    AddIcon,
    BackArrowIcon,
    CalendarIcon,
    CheckCircle16Icon,
    CheckedCheckboxGroupIcon,
    CheckmarkIcon,
    ChevronDoubleIcon,
    ChevronDoubleUpIcon,
    ChevronIcon,
    ChevronUpIcon,
    CloseIcon,
    ContactCard16Icon,
    ContactCardIcon,
    Copy12Icon,
    CrossCircleIcon,
    DashIcon,
    DeleteIcon,
    DesiredIndicatorIcon,
    DocumentAnyIcon,
    DocumentEmailIcon,
    DocumentExcelIcon,
    DocumentIcon,
    DocumentImageIcon,
    DocumentMultiFileIcon,
    DocumentPDFIcon,
    DocumentWordIcon,
    DollarIcon,
    DoNotIcon,
    DownloadIcon,
    EllipsisMessageBubble20Icon,
    EnvelopeLetterIcon,
    ErrorIcon: ErrorIcon$1,
    ErrorIconFilled,
    EyeIcon,
    EyeOffIcon,
    FilterIcon,
    FolderIcon,
    ForwardArrowIcon,
    Gear20Icon,
    GlobeIcon,
    HamburgerIcon,
    FrenchFriesIcon,
    ICircleIcon,
    ICircle20Icon,
    InfoIcon,
    InfoIconFilled,
    LockIcon,
    MeatballIcon,
    OpenIcon,
    PencilIcon,
    PeopleIcon,
    PercentIcon,
    PhoneSlashIcon,
    PlayIcon,
    PoundIcon,
    PrintIcon,
    QuestionCircleIcon,
    RefreshIcon,
    RequiredIndicatorIcon,
    RightwardTriangleIcon,
    SearchIcon,
    ShiftDownIcon,
    ShiftUpIcon,
    SixDotsIcon,
    SmCloseIcon,
    SortArrowIcon,
    SpinnerIcon,
    StarIcon,
    SuccessIcon: SuccessIcon$1,
    SuccessIconFilled,
    TextBubblesIcon,
    TrashCanIcon,
    TriangleLeft16Icon,
    TriangleRight16Icon,
    Undo16Icon,
    UploadIcon,
    WarningIcon,
    WarningIconFilled
};
/**
 * `Icon` is used to display an icon. It can be used inside a button or as a stand alone component.
 * If it is used as a stand alone component and is clickable, it should be used with the button component.
 */
const Icon = ({ customDataProps, icon, testId, size = 12, strokeClass, fillClass, disabled = false, colorOverride = false, focused = false, className, onClick, tooltip }) => {
    const handleClick = (e) => {
        if (!disabled) {
            onClick && onClick(e);
        }
    };
    let Comp = undefined;
    let dataIcon;
    if (typeof icon === 'string') {
        Comp = IconList[icon];
        dataIcon = icon;
    }
    else {
        Comp = icon;
        dataIcon = icon.name;
    }
    if (!Comp) {
        return React__default.createElement(NotFound, { size: size });
    }
    const iconComponent = (React__default.createElement(Comp, { size: size, svgClass: cx$1y('icon', { disabled }), strokeClass: cx$1y('stroke', strokeClass), fillClass: cx$1y('fill', fillClass), focused: focused, colorOverride: colorOverride }));
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1y('wrapper', className), onClick: handleClick, "data-icon": dataIcon }), tooltip ? (React__default.createElement(Tooltip, Object.assign({}, tooltip, { className: cx$1y('wrapper', tooltip.className) }), iconComponent)) : (iconComponent)));
};

var css$1r = ".Badge_module_badge__31db81ec{align-items:center;color:inherit;display:inline-flex;font-weight:700;justify-content:center;padding:0;white-space:nowrap}.Badge_module_badge__31db81ec.Badge_module_text__31db81ec.Badge_module_sm__31db81ec,.Badge_module_badge__31db81ec.Badge_module_text__31db81ec.Badge_module_xs__31db81ec,.Badge_module_badge__31db81ec.Badge_module_text__31db81ec.Badge_module_xxs__31db81ec{height:fit-content;padding:0}.Badge_module_badge__31db81ec.Badge_module_xxs__31db81ec{column-gap:3px;font-size:11px;height:20px;line-height:16px;padding-inline:5px 6px;text-transform:uppercase}.Badge_module_badge__31db81ec.Badge_module_xxs__31db81ec .Badge_module_icon__31db81ec{height:12px;width:12px}.Badge_module_badge__31db81ec.Badge_module_xxs__31db81ec.Badge_module_pill__31db81ec.Badge_module_noIcon__31db81ec{padding-inline:6px}.Badge_module_badge__31db81ec.Badge_module_xs__31db81ec{column-gap:3px;font-size:12px;height:24px;line-height:16px;padding-inline:7px 8px}.Badge_module_badge__31db81ec.Badge_module_xs__31db81ec .Badge_module_icon__31db81ec{height:12px;width:12px}.Badge_module_badge__31db81ec.Badge_module_xs__31db81ec.Badge_module_pill__31db81ec.Badge_module_noIcon__31db81ec{padding-inline:8px}.Badge_module_badge__31db81ec.Badge_module_sm__31db81ec{column-gap:4px;font-size:13px;height:28px;line-height:20px;padding-inline:9px 10px}.Badge_module_badge__31db81ec.Badge_module_sm__31db81ec .Badge_module_icon__31db81ec{height:14px;width:14px}.Badge_module_badge__31db81ec.Badge_module_sm__31db81ec.Badge_module_pill__31db81ec.Badge_module_noIcon__31db81ec{padding-inline:10px}.Badge_module_badge__31db81ec.Badge_module_md__31db81ec{column-gap:5px;font-size:14px;height:32px;padding-inline:11px 12px}.Badge_module_badge__31db81ec.Badge_module_md__31db81ec.Badge_module_text__31db81ec{padding-inline:6px 8px}.Badge_module_badge__31db81ec.Badge_module_md__31db81ec .Badge_module_icon__31db81ec{height:16px;width:16px}.Badge_module_badge__31db81ec.Badge_module_md__31db81ec.Badge_module_reducePadding__31db81ec,.Badge_module_badge__31db81ec.Badge_module_md__31db81ec.Badge_module_text__31db81ec.Badge_module_noIcon__31db81ec{height:fit-content;padding-inline:0}.Badge_module_badge__31db81ec.Badge_module_noIcon__31db81ec{padding-inline:12px}.Badge_module_badge__31db81ec.Badge_module_info__31db81ec{color:#365ef6}.Badge_module_badge__31db81ec.Badge_module_info__31db81ec .Badge_module_iconStroke__31db81ec{fill:#365ef6;stroke:none}.Badge_module_badge__31db81ec.Badge_module_success__31db81ec{color:#03866a}.Badge_module_badge__31db81ec.Badge_module_success__31db81ec .Badge_module_iconStroke__31db81ec{fill:#03866a;stroke:none}.Badge_module_badge__31db81ec.Badge_module_error__31db81ec{color:#ea0a3b}.Badge_module_badge__31db81ec.Badge_module_error__31db81ec .Badge_module_iconStroke__31db81ec{fill:#ea0a3b;stroke:none}.Badge_module_badge__31db81ec.Badge_module_warning__31db81ec{color:#d93f02}.Badge_module_badge__31db81ec.Badge_module_warning__31db81ec .Badge_module_iconStroke__31db81ec{fill:#d93f02;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec{background-color:#f5f5f7;border:1px solid #cbced7;border-radius:100rem;font-weight:600;white-space:nowrap}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_applied__31db81ec{background-color:#dff4fc;border-color:#8cd8f3;color:#086382}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_applied__31db81ec .Badge_module_iconStroke__31db81ec{fill:#086382;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_default__31db81ec{background-color:#f5f5f7;border-color:#cbced7;color:#6a6f82}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_default__31db81ec .Badge_module_iconStroke__31db81ec{fill:#6a6f82;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_success__31db81ec{background-color:#d9fcf5;border-color:#68eed1;color:#02785f}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_success__31db81ec .Badge_module_iconStroke__31db81ec{fill:#02785f;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_info__31db81ec{background-color:#f1f4fd;border-color:#aabff8;color:#365ef6}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_info__31db81ec .Badge_module_iconStroke__31db81ec{fill:#365ef6;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_warning__31db81ec{background-color:#fde6dd;border-color:#fab193;color:#c03802}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_warning__31db81ec .Badge_module_iconStroke__31db81ec{fill:#c03802;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_error__31db81ec{background-color:#fee2e8;border-color:#fba7ba;color:#c40831}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_error__31db81ec .Badge_module_iconStroke__31db81ec{fill:#c40831;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_accordion__31db81ec{background-color:#e4e5fb;border-color:#b1b3f1;color:#494dc1}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec.Badge_module_accordion__31db81ec .Badge_module_iconStroke__31db81ec{fill:#494dc1;stroke:none}.Badge_module_badge__31db81ec.Badge_module_pill__31db81ec .Badge_module_icon__31db81ec{background:#0000}";
window.ADS.injectStyle(css$1r,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Badge/Badge.module.scss");
var modules_c87a512f = {"badge":"Badge_module_badge__31db81ec","text":"Badge_module_text__31db81ec","xxs":"Badge_module_xxs__31db81ec","xs":"Badge_module_xs__31db81ec","sm":"Badge_module_sm__31db81ec","icon":"Badge_module_icon__31db81ec","pill":"Badge_module_pill__31db81ec","no-icon":"Badge_module_noIcon__31db81ec","md":"Badge_module_md__31db81ec","reduce-padding":"Badge_module_reducePadding__31db81ec","info":"Badge_module_info__31db81ec","iconStroke":"Badge_module_iconStroke__31db81ec","success":"Badge_module_success__31db81ec","error":"Badge_module_error__31db81ec","warning":"Badge_module_warning__31db81ec","applied":"Badge_module_applied__31db81ec","default":"Badge_module_default__31db81ec","accordion":"Badge_module_accordion__31db81ec"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1x = BindStyles(modules_c87a512f);
const TypeToIconMap = {
    [BadgeType.Info]: 'InfoIconFilled',
    [BadgeType.Success]: 'SuccessIconFilled',
    [BadgeType.Error]: 'ErrorIconFilled',
    [BadgeType.Warning]: 'WarningIconFilled',
    [BadgeType.Default]: 'DoNotIcon',
    [BadgeType.Accordion]: '',
    [BadgeType.Applied]: ''
};
const SizeToIconSizeMap = {
    xxs: 12,
    xs: 12,
    sm: 14,
    md: 16
};
var BadgeShape;
(function (BadgeShape) {
    BadgeShape["Pill"] = "pill";
    BadgeShape["Text"] = "text";
})(BadgeShape || (BadgeShape = {}));
const Badge = ({ type = BadgeType.Success, customDataProps, testId = 'badge', children, icon, shape, size = 'md', reducePadding }) => {
    const shapeToUse = React__default.useMemo(() => {
        return (shape !== null && shape !== void 0 ? shape : (type === BadgeType.Accordion ||
            type === BadgeType.Default ||
            type === BadgeType.Applied
            ? BadgeShape.Pill
            : BadgeShape.Text));
    }, [shape, type]);
    // We needed a way to override the default icon, so if the icon is 'NoIcon' we don't render the icon
    // We also don't render the icon if the type is Accordion or Applied and there is no icon
    const noIcon = React__default.useMemo(() => {
        return (icon === 'NoIcon' ||
            ((type === BadgeType.Accordion || type === BadgeType.Applied) && !icon));
    }, [icon, type]);
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1x('badge', type, shapeToUse, size, {
            ['reduce-padding']: reducePadding,
            ['no-icon']: noIcon
        }) }),
        !noIcon && (React__default.createElement("div", { className: modules_c87a512f.icon, "data-test": `${testId}-icon-container` },
            React__default.createElement(Icon, { testId: `${testId}-icon`, icon: icon || TypeToIconMap[type], size: SizeToIconSizeMap[size], className: cx$1x('iconStroke'), strokeClass: cx$1x('iconStroke'), colorOverride: true }))),
        React__default.createElement("div", { "data-test": `${testId}-text`, className: cx$1x('text') }, children)));
};

const Defaults = {
    separator: '-'
};
function composeId(parentId, childId, separator = Defaults.separator) {
    if (parentId === undefined) {
        return childId;
    }
    return `${parentId}${separator}${childId}`;
}
const TestIdUtils = {
    composeId
};

var css$1q = ".Col_module_col__3625c59c{width:100%}@media (min-width:0px){.Col_module_col__3625c59c.Col_module_xs1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_xs1__3625c59c.Col_module_xsStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_xs2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_xs2__3625c59c.Col_module_xsStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_xs3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_xs3__3625c59c.Col_module_xsStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_xs4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_xs4__3625c59c.Col_module_xsStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_xs5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_xs5__3625c59c.Col_module_xsStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_xs6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_xs6__3625c59c.Col_module_xsStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_xs7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_xs7__3625c59c.Col_module_xsStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_xs8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_xs8__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_xs8__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_xs8__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_xs8__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_xs8__3625c59c.Col_module_xsStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_xs9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_xs9__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_xs9__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_xs9__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_xs9__3625c59c.Col_module_xsStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_xs10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_xs10__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_xs10__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_xs10__3625c59c.Col_module_xsStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_xs11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_xs11__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_xs11__3625c59c.Col_module_xsStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_xs12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_xs12__3625c59c.Col_module_xsStart1__3625c59c{grid-column:1/span 12}}@media (min-width:576px){.Col_module_col__3625c59c.Col_module_sm1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_sm1__3625c59c.Col_module_smStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_sm2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_sm2__3625c59c.Col_module_smStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_sm3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_sm3__3625c59c.Col_module_smStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_sm4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_sm4__3625c59c.Col_module_smStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_sm5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_sm5__3625c59c.Col_module_smStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_sm6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_sm6__3625c59c.Col_module_smStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_sm7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_sm7__3625c59c.Col_module_smStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_sm8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_sm8__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_sm8__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_sm8__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_sm8__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_sm8__3625c59c.Col_module_smStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_sm9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_sm9__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_sm9__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_sm9__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_sm9__3625c59c.Col_module_smStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_sm10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_sm10__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_sm10__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_sm10__3625c59c.Col_module_smStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_sm11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_sm11__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_sm11__3625c59c.Col_module_smStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_sm12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_sm12__3625c59c.Col_module_smStart1__3625c59c{grid-column:1/span 12}}@media (min-width:768px){.Col_module_col__3625c59c.Col_module_md1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_md1__3625c59c.Col_module_mdStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_md2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_md2__3625c59c.Col_module_mdStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_md3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_md3__3625c59c.Col_module_mdStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_md4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_md4__3625c59c.Col_module_mdStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_md5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_md5__3625c59c.Col_module_mdStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_md6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_md6__3625c59c.Col_module_mdStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_md7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_md7__3625c59c.Col_module_mdStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_md8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_md8__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_md8__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_md8__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_md8__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_md8__3625c59c.Col_module_mdStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_md9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_md9__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_md9__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_md9__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_md9__3625c59c.Col_module_mdStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_md10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_md10__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_md10__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_md10__3625c59c.Col_module_mdStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_md11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_md11__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_md11__3625c59c.Col_module_mdStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_md12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_md12__3625c59c.Col_module_mdStart1__3625c59c{grid-column:1/span 12}}@media (min-width:992px){.Col_module_col__3625c59c.Col_module_lg1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_lg1__3625c59c.Col_module_lgStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_lg2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_lg2__3625c59c.Col_module_lgStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_lg3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_lg3__3625c59c.Col_module_lgStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_lg4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_lg4__3625c59c.Col_module_lgStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_lg5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_lg5__3625c59c.Col_module_lgStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_lg6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_lg6__3625c59c.Col_module_lgStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_lg7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_lg7__3625c59c.Col_module_lgStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_lg8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_lg8__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_lg8__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_lg8__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_lg8__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_lg8__3625c59c.Col_module_lgStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_lg9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_lg9__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_lg9__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_lg9__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_lg9__3625c59c.Col_module_lgStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_lg10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_lg10__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_lg10__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_lg10__3625c59c.Col_module_lgStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_lg11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_lg11__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_lg11__3625c59c.Col_module_lgStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_lg12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_lg12__3625c59c.Col_module_lgStart1__3625c59c{grid-column:1/span 12}}@media (min-width:1200px){.Col_module_col__3625c59c.Col_module_xl1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_xl1__3625c59c.Col_module_xlStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_xl2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_xl2__3625c59c.Col_module_xlStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_xl3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_xl3__3625c59c.Col_module_xlStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_xl4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_xl4__3625c59c.Col_module_xlStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_xl5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_xl5__3625c59c.Col_module_xlStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_xl6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_xl6__3625c59c.Col_module_xlStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_xl7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_xl7__3625c59c.Col_module_xlStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_xl8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_xl8__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_xl8__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_xl8__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_xl8__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_xl8__3625c59c.Col_module_xlStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_xl9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_xl9__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_xl9__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_xl9__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_xl9__3625c59c.Col_module_xlStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_xl10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_xl10__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_xl10__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_xl10__3625c59c.Col_module_xlStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_xl11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_xl11__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_xl11__3625c59c.Col_module_xlStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_xl12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_xl12__3625c59c.Col_module_xlStart1__3625c59c{grid-column:1/span 12}}@media (min-width:1536px){.Col_module_col__3625c59c.Col_module_xxl1__3625c59c{grid-column:span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart8__3625c59c{grid-column:8/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart9__3625c59c{grid-column:9/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart10__3625c59c{grid-column:10/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart11__3625c59c{grid-column:11/span 1}.Col_module_col__3625c59c.Col_module_xxl1__3625c59c.Col_module_xxlStart12__3625c59c{grid-column:12/span 1}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c{grid-column:span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart8__3625c59c{grid-column:8/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart9__3625c59c{grid-column:9/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart10__3625c59c{grid-column:10/span 2}.Col_module_col__3625c59c.Col_module_xxl2__3625c59c.Col_module_xxlStart11__3625c59c{grid-column:11/span 2}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c{grid-column:span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart8__3625c59c{grid-column:8/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart9__3625c59c{grid-column:9/span 3}.Col_module_col__3625c59c.Col_module_xxl3__3625c59c.Col_module_xxlStart10__3625c59c{grid-column:10/span 3}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c{grid-column:span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart8__3625c59c{grid-column:8/span 4}.Col_module_col__3625c59c.Col_module_xxl4__3625c59c.Col_module_xxlStart9__3625c59c{grid-column:9/span 4}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c{grid-column:span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 5}.Col_module_col__3625c59c.Col_module_xxl5__3625c59c.Col_module_xxlStart8__3625c59c{grid-column:8/span 5}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c{grid-column:span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 6}.Col_module_col__3625c59c.Col_module_xxl6__3625c59c.Col_module_xxlStart7__3625c59c{grid-column:7/span 6}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c{grid-column:span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 7}.Col_module_col__3625c59c.Col_module_xxl7__3625c59c.Col_module_xxlStart6__3625c59c{grid-column:6/span 7}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c{grid-column:span 8}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 8}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 8}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 8}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 8}.Col_module_col__3625c59c.Col_module_xxl8__3625c59c.Col_module_xxlStart5__3625c59c{grid-column:5/span 8}.Col_module_col__3625c59c.Col_module_xxl9__3625c59c{grid-column:span 9}.Col_module_col__3625c59c.Col_module_xxl9__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 9}.Col_module_col__3625c59c.Col_module_xxl9__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 9}.Col_module_col__3625c59c.Col_module_xxl9__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 9}.Col_module_col__3625c59c.Col_module_xxl9__3625c59c.Col_module_xxlStart4__3625c59c{grid-column:4/span 9}.Col_module_col__3625c59c.Col_module_xxl10__3625c59c{grid-column:span 10}.Col_module_col__3625c59c.Col_module_xxl10__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 10}.Col_module_col__3625c59c.Col_module_xxl10__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 10}.Col_module_col__3625c59c.Col_module_xxl10__3625c59c.Col_module_xxlStart3__3625c59c{grid-column:3/span 10}.Col_module_col__3625c59c.Col_module_xxl11__3625c59c{grid-column:span 11}.Col_module_col__3625c59c.Col_module_xxl11__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 11}.Col_module_col__3625c59c.Col_module_xxl11__3625c59c.Col_module_xxlStart2__3625c59c{grid-column:2/span 11}.Col_module_col__3625c59c.Col_module_xxl12__3625c59c{grid-column:span 12}.Col_module_col__3625c59c.Col_module_xxl12__3625c59c.Col_module_xxlStart1__3625c59c{grid-column:1/span 12}}.Col_module_debug__3625c59c{background:#f5f5f7;border:1px solid #d9dbe3;padding:4px;text-align:center}";
window.ADS.injectStyle(css$1q,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Layout/Col/Col.module.scss");
var modules_b94f2546 = {"col":"Col_module_col__3625c59c","xs-1":"Col_module_xs1__3625c59c","xs-start-1":"Col_module_xsStart1__3625c59c","xs-start-2":"Col_module_xsStart2__3625c59c","xs-start-3":"Col_module_xsStart3__3625c59c","xs-start-4":"Col_module_xsStart4__3625c59c","xs-start-5":"Col_module_xsStart5__3625c59c","xs-start-6":"Col_module_xsStart6__3625c59c","xs-start-7":"Col_module_xsStart7__3625c59c","xs-start-8":"Col_module_xsStart8__3625c59c","xs-start-9":"Col_module_xsStart9__3625c59c","xs-start-10":"Col_module_xsStart10__3625c59c","xs-start-11":"Col_module_xsStart11__3625c59c","xs-start-12":"Col_module_xsStart12__3625c59c","xs-2":"Col_module_xs2__3625c59c","xs-3":"Col_module_xs3__3625c59c","xs-4":"Col_module_xs4__3625c59c","xs-5":"Col_module_xs5__3625c59c","xs-6":"Col_module_xs6__3625c59c","xs-7":"Col_module_xs7__3625c59c","xs-8":"Col_module_xs8__3625c59c","xs-9":"Col_module_xs9__3625c59c","xs-10":"Col_module_xs10__3625c59c","xs-11":"Col_module_xs11__3625c59c","xs-12":"Col_module_xs12__3625c59c","sm-1":"Col_module_sm1__3625c59c","sm-start-1":"Col_module_smStart1__3625c59c","sm-start-2":"Col_module_smStart2__3625c59c","sm-start-3":"Col_module_smStart3__3625c59c","sm-start-4":"Col_module_smStart4__3625c59c","sm-start-5":"Col_module_smStart5__3625c59c","sm-start-6":"Col_module_smStart6__3625c59c","sm-start-7":"Col_module_smStart7__3625c59c","sm-start-8":"Col_module_smStart8__3625c59c","sm-start-9":"Col_module_smStart9__3625c59c","sm-start-10":"Col_module_smStart10__3625c59c","sm-start-11":"Col_module_smStart11__3625c59c","sm-start-12":"Col_module_smStart12__3625c59c","sm-2":"Col_module_sm2__3625c59c","sm-3":"Col_module_sm3__3625c59c","sm-4":"Col_module_sm4__3625c59c","sm-5":"Col_module_sm5__3625c59c","sm-6":"Col_module_sm6__3625c59c","sm-7":"Col_module_sm7__3625c59c","sm-8":"Col_module_sm8__3625c59c","sm-9":"Col_module_sm9__3625c59c","sm-10":"Col_module_sm10__3625c59c","sm-11":"Col_module_sm11__3625c59c","sm-12":"Col_module_sm12__3625c59c","md-1":"Col_module_md1__3625c59c","md-start-1":"Col_module_mdStart1__3625c59c","md-start-2":"Col_module_mdStart2__3625c59c","md-start-3":"Col_module_mdStart3__3625c59c","md-start-4":"Col_module_mdStart4__3625c59c","md-start-5":"Col_module_mdStart5__3625c59c","md-start-6":"Col_module_mdStart6__3625c59c","md-start-7":"Col_module_mdStart7__3625c59c","md-start-8":"Col_module_mdStart8__3625c59c","md-start-9":"Col_module_mdStart9__3625c59c","md-start-10":"Col_module_mdStart10__3625c59c","md-start-11":"Col_module_mdStart11__3625c59c","md-start-12":"Col_module_mdStart12__3625c59c","md-2":"Col_module_md2__3625c59c","md-3":"Col_module_md3__3625c59c","md-4":"Col_module_md4__3625c59c","md-5":"Col_module_md5__3625c59c","md-6":"Col_module_md6__3625c59c","md-7":"Col_module_md7__3625c59c","md-8":"Col_module_md8__3625c59c","md-9":"Col_module_md9__3625c59c","md-10":"Col_module_md10__3625c59c","md-11":"Col_module_md11__3625c59c","md-12":"Col_module_md12__3625c59c","lg-1":"Col_module_lg1__3625c59c","lg-start-1":"Col_module_lgStart1__3625c59c","lg-start-2":"Col_module_lgStart2__3625c59c","lg-start-3":"Col_module_lgStart3__3625c59c","lg-start-4":"Col_module_lgStart4__3625c59c","lg-start-5":"Col_module_lgStart5__3625c59c","lg-start-6":"Col_module_lgStart6__3625c59c","lg-start-7":"Col_module_lgStart7__3625c59c","lg-start-8":"Col_module_lgStart8__3625c59c","lg-start-9":"Col_module_lgStart9__3625c59c","lg-start-10":"Col_module_lgStart10__3625c59c","lg-start-11":"Col_module_lgStart11__3625c59c","lg-start-12":"Col_module_lgStart12__3625c59c","lg-2":"Col_module_lg2__3625c59c","lg-3":"Col_module_lg3__3625c59c","lg-4":"Col_module_lg4__3625c59c","lg-5":"Col_module_lg5__3625c59c","lg-6":"Col_module_lg6__3625c59c","lg-7":"Col_module_lg7__3625c59c","lg-8":"Col_module_lg8__3625c59c","lg-9":"Col_module_lg9__3625c59c","lg-10":"Col_module_lg10__3625c59c","lg-11":"Col_module_lg11__3625c59c","lg-12":"Col_module_lg12__3625c59c","xl-1":"Col_module_xl1__3625c59c","xl-start-1":"Col_module_xlStart1__3625c59c","xl-start-2":"Col_module_xlStart2__3625c59c","xl-start-3":"Col_module_xlStart3__3625c59c","xl-start-4":"Col_module_xlStart4__3625c59c","xl-start-5":"Col_module_xlStart5__3625c59c","xl-start-6":"Col_module_xlStart6__3625c59c","xl-start-7":"Col_module_xlStart7__3625c59c","xl-start-8":"Col_module_xlStart8__3625c59c","xl-start-9":"Col_module_xlStart9__3625c59c","xl-start-10":"Col_module_xlStart10__3625c59c","xl-start-11":"Col_module_xlStart11__3625c59c","xl-start-12":"Col_module_xlStart12__3625c59c","xl-2":"Col_module_xl2__3625c59c","xl-3":"Col_module_xl3__3625c59c","xl-4":"Col_module_xl4__3625c59c","xl-5":"Col_module_xl5__3625c59c","xl-6":"Col_module_xl6__3625c59c","xl-7":"Col_module_xl7__3625c59c","xl-8":"Col_module_xl8__3625c59c","xl-9":"Col_module_xl9__3625c59c","xl-10":"Col_module_xl10__3625c59c","xl-11":"Col_module_xl11__3625c59c","xl-12":"Col_module_xl12__3625c59c","xxl-1":"Col_module_xxl1__3625c59c","xxl-start-1":"Col_module_xxlStart1__3625c59c","xxl-start-2":"Col_module_xxlStart2__3625c59c","xxl-start-3":"Col_module_xxlStart3__3625c59c","xxl-start-4":"Col_module_xxlStart4__3625c59c","xxl-start-5":"Col_module_xxlStart5__3625c59c","xxl-start-6":"Col_module_xxlStart6__3625c59c","xxl-start-7":"Col_module_xxlStart7__3625c59c","xxl-start-8":"Col_module_xxlStart8__3625c59c","xxl-start-9":"Col_module_xxlStart9__3625c59c","xxl-start-10":"Col_module_xxlStart10__3625c59c","xxl-start-11":"Col_module_xxlStart11__3625c59c","xxl-start-12":"Col_module_xxlStart12__3625c59c","xxl-2":"Col_module_xxl2__3625c59c","xxl-3":"Col_module_xxl3__3625c59c","xxl-4":"Col_module_xxl4__3625c59c","xxl-5":"Col_module_xxl5__3625c59c","xxl-6":"Col_module_xxl6__3625c59c","xxl-7":"Col_module_xxl7__3625c59c","xxl-8":"Col_module_xxl8__3625c59c","xxl-9":"Col_module_xxl9__3625c59c","xxl-10":"Col_module_xxl10__3625c59c","xxl-11":"Col_module_xxl11__3625c59c","xxl-12":"Col_module_xxl12__3625c59c","debug":"Col_module_debug__3625c59c"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1w = classnames.bind(modules_b94f2546);
/**
 * `Col` lays it's content out in a column in the row.
 */
const Col = ({ customDataProps, testId, xs, sm, md, lg, xl, xxl, debug, className, children }) => {
    const sizeProps = { xs, sm, md, lg, xl, xxl };
    const start = {};
    for (const size in sizeProps) {
        if (typeof sizeProps[size] === 'string') {
            const [startValue, spanValue] = sizeProps[size].trim().split('/');
            start[size] = Number(startValue);
            sizeProps[size] = Number(spanValue);
        }
    }
    xs = sizeProps.xs || xs;
    sm = sizeProps.sm || sm;
    md = sizeProps.md || md;
    lg = sizeProps.lg || lg;
    xl = sizeProps.xl || xl;
    xxl = sizeProps.xxl || xxl;
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, "data-grid-col": true, className: cx$1w('col', className, {
            debug,
            // Col spans
            [`xs-${xs}`]: xs,
            [`sm-${sm}`]: sm,
            [`md-${md}`]: md,
            [`lg-${lg}`]: lg,
            [`xl-${xl}`]: xl,
            [`xxl-${xxl}`]: xxl,
            // Col starts
            [`xs-start-${start.xs}`]: start.xs,
            [`sm-start-${start.sm}`]: start.sm,
            [`md-start-${start.md}`]: start.md,
            [`lg-start-${start.lg}`]: start.lg,
            [`xl-start-${start.xl}`]: start.xl,
            [`xxl-start-${start.xxl}`]: start.xxl
        }) }), children));
};
Col.displayName = 'Col';

var css$1p = ".Container_module_container__4ad52264{overflow:auto;padding:32px;position:relative}.Container_module_container__4ad52264.Container_module_debug__4ad52264{border:1px solid #d9dbe3;position:relative}.Container_module_container__4ad52264 .Container_module_debugInfo__4ad52264{background:#f5f5f7;border:1px solid #d9dbe3;border-radius:0 0 0 4px;border-width:0 0 1px 1px;font-size:10px;padding:0 4px;position:absolute;right:0;top:0}";
window.ADS.injectStyle(css$1p,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Layout/Container/Container.module.scss");
var modules_7798f7cb = {"container":"Container_module_container__4ad52264","debug":"Container_module_debug__4ad52264","debugInfo":"Container_module_debugInfo__4ad52264"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1v = classnames.bind(modules_7798f7cb);
/**
 * `Container` is the outer most wrapper of grid rows.
 */
const Container$1 = ({ customDataProps, testId, className, colClassName, debug, height, children }) => {
    // If we find any direct Row children we pass the debug prop value
    function renderChildren() {
        return React__default.Children.map(children, (child) => {
            var _a, _b, _c, _d;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'Row') {
                return React__default.cloneElement(child, {
                    debug: (_c = (_b = child.props) === null || _b === void 0 ? void 0 : _b.debug) !== null && _c !== void 0 ? _c : debug,
                    colClassName: cx$1v(colClassName, (_d = child.props) === null || _d === void 0 ? void 0 : _d.colClassName)
                });
            }
            return child;
        });
    }
    const style = {};
    if (height) {
        style.height = height;
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { style: style, "data-test": testId, "data-grid-container": true, className: cx$1v('container', className, { debug }) }),
        debug && React__default.createElement(DebugWindow, null),
        renderChildren()));
};
const debugColors = {
    xs: '#db4325',
    sm: '#eda247',
    md: '#afa458',
    lg: '#57c4ad',
    xl: '#006164',
    xxl: '#87af08'
};
const DebugWindow = () => {
    const [breakpoint, _setBreakPoint] = React__default.useState('');
    const [color, setColor] = React__default.useState('');
    const windowSize = useWindowSize();
    const setBreakPoint = React__default.useCallback(() => {
        let bp;
        // We use window.self so that if we are in an iframe we get the
        // right window reference.
        if (window.self.matchMedia('(min-width: 1536px)').matches) {
            bp = 'xxl';
        }
        else if (window.self.matchMedia('(min-width: 1200px)').matches) {
            bp = 'xl';
        }
        else if (window.self.matchMedia('(min-width: 992px)').matches) {
            bp = 'lg';
        }
        else if (window.self.matchMedia('(min-width: 768px)').matches) {
            bp = 'md';
        }
        else if (window.self.matchMedia('(min-width: 576px)').matches) {
            bp = 'sm';
        }
        else {
            bp = 'xs';
        }
        setColor(debugColors[bp]);
        _setBreakPoint(bp);
    }, []);
    React__default.useEffect(() => setBreakPoint(), [windowSize, setBreakPoint]);
    return (React__default.createElement("div", { className: modules_7798f7cb.debugInfo, style: { color } },
        React__default.createElement("span", { className: "breakpoint" },
            "breakpoint: ",
            breakpoint),
        " |",
        ' ',
        React__default.createElement("span", { className: "width" },
            "width: ",
            windowSize.width,
            "px")));
};

const Flex = React__default.forwardRef(({ testId, className, children, customDataProps }, ref) => {
    return (React__default.createElement("div", Object.assign({ ref: ref }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1S('flex-container', className) }), children));
});
Flex.displayName = 'Flex';

var css$1o = ".Row_module_row__4ff93fa8{align-items:start;display:grid;gap:24px;grid-template-columns:repeat(12,1fr);width:100%}";
window.ADS.injectStyle(css$1o,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Layout/Row/Row.module.scss");
var modules_5b4003b7 = {"row":"Row_module_row__4ff93fa8"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1u = classnames.bind(modules_5b4003b7);
/**
 * `Row` is used house columns as a grid row
 */
const Row = ({ debug, testId, className, colClassName, children, customDataProps }) => {
    useRestrictedChildType('Row', ['Col', null], children);
    // We apply the rows's debug value to all children columns
    function renderChildren() {
        return React__default.Children.map(children, (child) => {
            var _a;
            // We can have null children
            if (!child) {
                return child;
            }
            return React__default.cloneElement(child, {
                debug: (_a = child.props.debug) !== null && _a !== void 0 ? _a : debug,
                className: cx$1u(colClassName, child.props.className)
            });
        });
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-grid-row": true, className: cx$1u('row', className), "data-test": testId }), renderChildren()));
};
Row.displayName = 'Row'; // Needed for Container to find children that are rows

var css$1n = ".Visible_module_visible__33239a1b{display:none}@media (min-width:0px) and (max-width:576px){.Visible_module_visible__33239a1b.Visible_module_xsVisible__33239a1b{display:block}}@media (min-width:576px) and (max-width:768px){.Visible_module_visible__33239a1b.Visible_module_smVisible__33239a1b{display:block}}@media (min-width:768px) and (max-width:992px){.Visible_module_visible__33239a1b.Visible_module_mdVisible__33239a1b{display:block}}@media (min-width:992px) and (max-width:1200px){.Visible_module_visible__33239a1b.Visible_module_lgVisible__33239a1b{display:block}}@media (min-width:1200px) and (max-width:1536px){.Visible_module_visible__33239a1b.Visible_module_xlVisible__33239a1b{display:block}}@media (min-width:1536px) and (max-width:2000000000px){.Visible_module_visible__33239a1b.Visible_module_xxlVisible__33239a1b{display:block}}.Visible_module_visible__33239a1b.Visible_module_allOn__33239a1b{display:block}.Visible_module_visible__33239a1b.Visible_module_allOff__33239a1b{display:none}";
window.ADS.injectStyle(css$1n,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Layout/Visible/Visible.module.scss");
var modules_0db1ef44 = {"visible":"Visible_module_visible__33239a1b","xs-visible":"Visible_module_xsVisible__33239a1b","sm-visible":"Visible_module_smVisible__33239a1b","md-visible":"Visible_module_mdVisible__33239a1b","lg-visible":"Visible_module_lgVisible__33239a1b","xl-visible":"Visible_module_xlVisible__33239a1b","xxl-visible":"Visible_module_xxlVisible__33239a1b","all-on":"Visible_module_allOn__33239a1b","all-off":"Visible_module_allOff__33239a1b"};

const cx$1t = classnames.bind(modules_0db1ef44);
/**
 * `Visible` is a utility component that will display content on certain screen break points.
 */
const Visible = ({ customDataProps, testId, xs, sm, md, lg, xl, xxl, all, children }) => {
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1t('visible', {
            'xs-visible': xs,
            'sm-visible': sm,
            'md-visible': md,
            'lg-visible': lg,
            'xl-visible': xl,
            'xxl-visible': xxl,
            'all-on': all === true,
            'all-off': all === false
        }) }), children));
};

var css$1m = ".Headers_module_badgeContainer__bd1399a8{gap:6px!important}.Headers_module_badgeContainerH1__bd1399a8{gap:8px!important}.Headers_module_title__bd1399a8{color:#262860;font-weight:700;margin:0}.Headers_module_title__bd1399a8.Headers_module_truncated__bd1399a8{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Headers_module_title__bd1399a8.Headers_module_wrapping__bd1399a8{word-wrap:break-word;max-width:100%;white-space:normal}.Headers_module_title__bd1399a8.Headers_module_h1__bd1399a8{font-size:24px;letter-spacing:-.012em;line-height:36px}.Headers_module_title__bd1399a8.Headers_module_h2__bd1399a8{font-size:20px;line-height:32px}.Headers_module_title__bd1399a8.Headers_module_h2__bd1399a8.Headers_module_underline__bd1399a8{border-bottom:1px solid #b0b4bf;padding-bottom:4px}.Headers_module_title__bd1399a8.Headers_module_h3__bd1399a8{font-size:18px;line-height:28px}.Headers_module_title__bd1399a8.Headers_module_h4__bd1399a8{font-size:16px;line-height:24px}.Headers_module_title__bd1399a8.Headers_module_h6__bd1399a8{font-size:12px;line-height:16px}.Headers_module_title__bd1399a8.Headers_module_h6__bd1399a8.Headers_module_overline__bd1399a8{color:#6a6f82;font-weight:400;letter-spacing:.01em;text-transform:uppercase}.Headers_module_title__bd1399a8 h1,.Headers_module_title__bd1399a8 h2,.Headers_module_title__bd1399a8 h3,.Headers_module_title__bd1399a8 h4,.Headers_module_title__bd1399a8 h5,.Headers_module_title__bd1399a8 h6{margin:0}.Headers_module_tooltipIcon__bd1399a8{fill:#6a6f82}.Headers_module_headerContainer__bd1399a8{width:100%}.Headers_module_headerContainer__bd1399a8.Headers_module_underline__bd1399a8{border-bottom:1px solid #b0b4bf;padding-bottom:4px}.Headers_module_titleAndTooltip__bd1399a8{align-items:center;display:flex;flex-shrink:1;max-width:100%;min-width:0}.Headers_module_titleAndTooltip__bd1399a8.Headers_module_truncated__bd1399a8{overflow:hidden}.Headers_module_titleAndTooltip__bd1399a8.Headers_module_underline__bd1399a8{border-bottom:1px solid #b0b4bf;padding-bottom:4px}.Headers_module_tooltipIconWrapper__bd1399a8{align-items:center;display:inline-flex;flex-shrink:0}.Headers_module_tooltipSpan__bd1399a8{display:inline-block;flex-wrap:nowrap;white-space:nowrap}.Headers_module_tooltipIconWrapperInline__bd1399a8{display:inline-block}.Headers_module_headerContainerWrapping__bd1399a8{width:100%}.Headers_module_headerContainerWrapping__bd1399a8.Headers_module_underline__bd1399a8{border-bottom:1px solid #b0b4bf;padding-bottom:4px}";
window.ADS.injectStyle(css$1m,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Headers/Headers.module.scss");
var modules_eb09d2bd = {"badge-container":"Headers_module_badgeContainer__bd1399a8","badge-container-h1":"Headers_module_badgeContainerH1__bd1399a8","title":"Headers_module_title__bd1399a8","truncated":"Headers_module_truncated__bd1399a8","wrapping":"Headers_module_wrapping__bd1399a8","h1":"Headers_module_h1__bd1399a8","h2":"Headers_module_h2__bd1399a8","underline":"Headers_module_underline__bd1399a8","h3":"Headers_module_h3__bd1399a8","h4":"Headers_module_h4__bd1399a8","h6":"Headers_module_h6__bd1399a8","overline":"Headers_module_overline__bd1399a8","tooltip-icon":"Headers_module_tooltipIcon__bd1399a8","header-container":"Headers_module_headerContainer__bd1399a8","title-and-tooltip":"Headers_module_titleAndTooltip__bd1399a8","tooltip-icon-wrapper":"Headers_module_tooltipIconWrapper__bd1399a8","tooltip-span":"Headers_module_tooltipSpan__bd1399a8","tooltip-icon-wrapper-inline":"Headers_module_tooltipIconWrapperInline__bd1399a8","header-container-wrapping":"Headers_module_headerContainerWrapping__bd1399a8"};

const cx$1s = BindStyles(modules_eb09d2bd);
const CONSTANTS$3 = {
    /** @see {@link trySplitLastWordsOfNLengthOrGreater} for more information. */
    minTitleCharsToWrapWithTooltip: 2,
    underlineConsoleWarningMessage: 'Cannot set underline={true} for H2 headers with badges or action content. Using false instead.'
};
// Badge configuration by header type
const BADGE_CONFIG = {
    h1: {
        containerClass: 'badge-container-h1'
    },
    h2: {
        containerClass: 'badge-container'
    },
    h3: {
        containerClass: 'badge-container'
    },
    h4: {
        containerClass: 'badge-container'
    },
    h6: {
        containerClass: 'badge-container'
    }
};
/**
 * Maps header type to appropriate badge size
 */
const getBadgeSize = (headerType) => {
    switch (headerType) {
        case 'h1':
            return 'sm';
        case 'h2':
        case 'h3':
            return 'xs';
        case 'h4':
        case 'h6':
            return 'xxs';
        default:
            return 'xs';
    }
};
/**
 * Tooltip icon configuration per header type
 */
const TOOLTIP_ICONS = {
    h1: {
        name: 'InfoIcon',
        size: 24,
        titleGap: 8,
        verticalAlign: -3
    },
    h2: {
        name: 'ICircle20Icon',
        size: 20,
        titleGap: 6,
        verticalAlign: -3
    },
    h3: {
        name: 'ICircle20Icon',
        size: 20,
        titleGap: 6,
        verticalAlign: -3
    },
    h4: {
        name: 'ICircleIcon',
        size: 16,
        titleGap: 6,
        verticalAlign: -2
    },
    h6: {
        name: 'ICircleIcon',
        size: 16,
        titleGap: 4,
        verticalAlign: -2
    }
};
/**
 * Determines if a header should have an underline based on type and props
 * Contains business logic for when underlines can be used
 */
const shouldHeaderHaveUnderline = (headerType, underline, hasBadges, hasActionContent) => {
    // If explicitly set to false, never show underline
    if (underline === false) {
        return false;
    }
    // For H2 headers
    if (headerType === 'h2') {
        // If badges or action content are present, check for compatibility
        if (hasBadges || hasActionContent) {
            // If underline is explicitly set to true, warn and return false
            if (underline === true) {
                ADSWarn('Cannot set underline={true} for H2 headers with badges or action content. Using false instead.');
                return false;
            }
            // Otherwise, no underline by default when badges/actions are present
            return false;
        }
        // Default for H2 with no badges or buttons is underline
        return underline === true || underline === undefined;
    }
    // For other header types, respect the underline prop
    return underline === true;
};
/**
 * Determines if a header should have an overline based on type and props
 */
const shouldHeaderHaveOverline = (headerType, overline) => {
    // Only H6 headers can have overline, and only when explicitly enabled
    return headerType === 'h6' && overline === true;
};
/**
 * Simple header component without tooltips or badges
 */
function SimpleHeader({ headerType, id, testId, className, underline, overline, children, customDataProps, truncateTitle, hasActionContent }) {
    const Tag = headerType;
    const shouldUnderline = shouldHeaderHaveUnderline(headerType, underline, false, hasActionContent);
    const shouldOverline = shouldHeaderHaveOverline(headerType, overline);
    return (React__default.createElement(Tag, Object.assign({ id: id, "data-test": testId, className: cx$1s(className, 'title', headerType, {
            underline: shouldUnderline,
            overline: shouldOverline,
            truncated: truncateTitle,
            wrapping: !truncateTitle
        }), "data-underline": shouldUnderline ? 'true' : 'false' }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {})), truncateTitle ? React__default.createElement(CellText, null, children) : children));
}
/**
 * Badge elements component for headers
 */
function BadgeElements({ badges, headerType, testId }) {
    if (!(badges === null || badges === void 0 ? void 0 : badges.length))
        return null;
    const badgeConfig = BADGE_CONFIG[headerType];
    return (React__default.createElement(Flex, { className: cx$1s(badgeConfig.containerClass) }, badges.map((badgeProp, index) => {
        const badgeElement = (React__default.createElement(Badge, Object.assign({ key: index }, badgeProp, { testId: TestIdUtils.composeId(testId, `header-badge-${index}`), shape: BadgeShape.Pill, size: getBadgeSize(headerType) }), badgeProp.text));
        // If tooltip text is provided, wrap in the Tooltip component
        if (badgeProp.tooltip) {
            return (React__default.createElement(Tooltip, { key: index, content: badgeProp.tooltip }, badgeElement));
        }
        return badgeElement;
    })));
}
/**
 * Tooltip element component for headers
 */
function TooltipElement({ helpText, headerType, isWrapping, testId }) {
    if (!helpText)
        return null;
    const tooltipIconConfig = TOOLTIP_ICONS[headerType];
    return (React__default.createElement("div", { 
        // Different class based on whether we're in wrapping or truncation mode
        className: cx$1s(isWrapping ? 'tooltip-icon-wrapper-inline' : 'tooltip-icon-wrapper'), "data-test": TestIdUtils.composeId(testId, 'tooltip-icon-wrapper'), style: {
            marginLeft: tooltipIconConfig.titleGap,
            verticalAlign: tooltipIconConfig.verticalAlign
        } },
        React__default.createElement(Icon, { colorOverride: true, testId: TestIdUtils.composeId(testId, 'tooltip-icon'), className: (cx$1s('tooltip-icon'), 'help-hover'), size: tooltipIconConfig.size, icon: tooltipIconConfig.name, tooltip: { content: helpText } })));
}
/**
 * Header component with title truncation mode
 */
function HeaderWithTitleTruncation({ badges, children, className, headerType, overline = false, id, testId, helpText, underline = false, truncateTitle = true, // Default to truncation in this component
customDataProps, hasActionContent }) {
    const Tag = headerType;
    const hasTooltip = !!helpText;
    const hasBadges = !!(badges === null || badges === void 0 ? void 0 : badges.length);
    // For simple cases (no tooltip or badges), use the SimpleHeader component
    if (!hasTooltip && !hasBadges) {
        return (React__default.createElement(SimpleHeader, { headerType: headerType, id: id, testId: testId, className: className, underline: underline, overline: overline, truncateTitle: truncateTitle, customDataProps: customDataProps, hasActionContent: hasActionContent }, children));
    }
    // Determine if header should have an underline
    const shouldUnderline = shouldHeaderHaveUnderline(headerType, underline, hasBadges, hasActionContent);
    const shouldOverline = shouldHeaderHaveOverline(headerType, overline);
    return (React__default.createElement("div", Object.assign({ className: cx$1s('header-container', {
            underline: shouldUnderline
        }), "data-test": TestIdUtils.composeId(testId, 'header-container') }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {})),
        React__default.createElement(Flex, { className: "flex-valign-center flex-align-start gap-h-100 gap-v-25" },
            React__default.createElement("div", { className: cx$1s('title-and-tooltip', 'truncated') },
                React__default.createElement(Tag, { id: id, className: cx$1s(className, 'title', headerType, 'truncated', {
                        overline: shouldOverline
                    }) }, truncateTitle ? React__default.createElement(CellText, null, children) : children),
                React__default.createElement(TooltipElement, { helpText: helpText, headerType: headerType, isWrapping: false, testId: testId })),
            React__default.createElement(BadgeElements, { badges: badges, headerType: headerType, testId: testId }))));
}
/**
 * Header component with title wrapping mode
 */
function HeaderWithTitleWrapping({ badges, children, className, headerType, overline = false, id, testId, helpText, underline = false, truncateTitle = false, // Default to wrapping in this component
customDataProps, hasActionContent }) {
    const Tag = headerType;
    const hasTooltip = !!helpText;
    const hasBadges = !!(badges === null || badges === void 0 ? void 0 : badges.length);
    // For simple cases (no tooltip or badges), use the SimpleHeader component
    if (!hasTooltip && !hasBadges) {
        return (React__default.createElement(SimpleHeader, { headerType: headerType, id: id, testId: testId, className: className, underline: underline, overline: overline, truncateTitle: truncateTitle, customDataProps: customDataProps, hasActionContent: hasActionContent }, children));
    }
    // Determine if header should have an underline
    const shouldUnderline = shouldHeaderHaveUnderline(headerType, underline, hasBadges, hasActionContent);
    const shouldOverline = shouldHeaderHaveOverline(headerType, overline);
    // Split the title text to keep last words with tooltip
    const [
    // most of the title
    titleMain, 
    // the last bit of the title that wraps with the tooltip
    titleWithinTooltipSpan] = helpText
        ? OptionUtils.value(trySplitLastWordsOfNLengthOrGreater(children, CONSTANTS$3.minTitleCharsToWrapWithTooltip), [children, null])
        : [children, null];
    // Create the header element with wrapping tooltip
    const headerElement = (React__default.createElement(Tag, { className: cx$1s(className, 'title', headerType, 'wrapping', {
            underline: shouldUnderline,
            overline: shouldOverline
        }), id: id },
        titleMain,
        titleWithinTooltipSpan && (React__default.createElement("span", { className: cx$1s('tooltip-span'), "data-test": TestIdUtils.composeId(testId, 'text-with-tooltip') },
            titleWithinTooltipSpan,
            React__default.createElement(TooltipElement, { helpText: helpText, headerType: headerType, isWrapping: true, testId: testId })))));
    // Always show badges when they exist
    if (hasBadges) {
        return (React__default.createElement("div", Object.assign({ className: cx$1s('header-container-wrapping', {
                underline: shouldUnderline
            }), "data-test": TestIdUtils.composeId(testId, 'header-container') }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {})),
            React__default.createElement(Flex, { className: "flex-valign-center flex-align-start gap-h-100 gap-v-25" },
                headerElement,
                React__default.createElement(BadgeElements, { badges: badges, headerType: headerType, testId: testId }))));
    }
    // For cases where we just return the header element directly (no div wrapper)
    // We need to spread customDataProps on the Tag element
    if (customDataProps) {
        return React__default.cloneElement(headerElement, Object.assign(Object.assign({}, customDataProps), { className: headerElement.props.className }));
    }
    // Otherwise just return the header element
    return headerElement;
}
/**
 * Main header component that chooses between truncation and wrapping modes
 */
function HeaderComponent(props) {
    const { truncateTitle = false } = props, headingProps = __rest(props, ["truncateTitle"]);
    // Route to the appropriate component based on truncation setting
    return truncateTitle ? (React__default.createElement(HeaderWithTitleTruncation, Object.assign({}, headingProps))) : (React__default.createElement(HeaderWithTitleWrapping, Object.assign({}, headingProps)));
}
/**
 * H1 Base Header Component - For internal use by SectionV2
 */
const H1Base = ({ badges, children, className, customDataProps, id, testId, helpText, truncateTitle = false }) => {
    return (React__default.createElement(HeaderComponent, { badges: badges, className: className, customDataProps: customDataProps, headerType: "h1", id: id, testId: testId, helpText: helpText, truncateTitle: truncateTitle }, children));
};
/**
 * H1 Header Component - Public API
 */
const H1 = ({ children, className, customDataProps, id, testId }) => {
    return (React__default.createElement(H1Base, { className: className, customDataProps: customDataProps, id: id, testId: testId }, children));
};
/**
 * H2 Base Header Component - For internal use by SectionV2
 */
const H2Base = ({ badges, children, className, customDataProps, id, testId, helpText, truncateTitle = false, underline = true, // Default to header-only underline for H2
hasActionContent }) => {
    return (React__default.createElement(HeaderComponent, { badges: badges, className: className, customDataProps: customDataProps, headerType: "h2", id: id, testId: testId, helpText: helpText, truncateTitle: truncateTitle, underline: underline, hasActionContent: hasActionContent }, children));
};
/**
 * H2 Header Component - Public API
 */
const H2 = ({ children, className, customDataProps, id, testId, underline = true // Default to header-only underline for H2
 }) => {
    return (React__default.createElement(H2Base, { className: className, customDataProps: customDataProps, id: id, testId: testId, underline: underline }, children));
};
/**
 * H3 Base Header Component - For internal use by SectionV2
 */
const H3Base = ({ badges, children, className, customDataProps, id, testId, helpText, truncateTitle = false }) => {
    return (React__default.createElement(HeaderComponent, { badges: badges, className: className, customDataProps: customDataProps, headerType: "h3", id: id, testId: testId, helpText: helpText, truncateTitle: truncateTitle }, children));
};
/**
 * H3 Header Component - Public API
 */
const H3 = ({ children, className, customDataProps, id, testId }) => {
    return (React__default.createElement(H3Base, { className: className, customDataProps: customDataProps, id: id, testId: testId }, children));
};
/**
 * H4 Base Header Component - For internal use by SectionV2
 */
const H4Base = ({ badges, children, className, customDataProps, id, testId, helpText, truncateTitle = false }) => {
    return (React__default.createElement(HeaderComponent, { badges: badges, className: className, customDataProps: customDataProps, headerType: "h4", id: id, testId: testId, helpText: helpText, truncateTitle: truncateTitle }, children));
};
/**
 * H4 Header Component - Public API
 */
const H4 = ({ children, className, customDataProps, id, testId }) => {
    return (React__default.createElement(H4Base, { className: className, customDataProps: customDataProps, id: id, testId: testId }, children));
};
/**
 * H6 Base Header Component - For internal use by SectionV2
 */
const H6Base = ({ badges, children, className, customDataProps, id, overline = false, testId, helpText, truncateTitle = false }) => {
    return (React__default.createElement(HeaderComponent, { badges: badges, className: className, customDataProps: customDataProps, headerType: "h6", id: id, overline: overline, testId: testId, helpText: helpText, truncateTitle: truncateTitle }, children));
};
/**
 * H6 Header Component - Public API
 */
const H6 = ({ children, className, customDataProps, id, overline = false, testId }) => {
    return (React__default.createElement(H6Base, { className: className, customDataProps: customDataProps, id: id, overline: overline, testId: testId }, children));
};

var css$1l = ".Accordion_module_accordion__77d2bc9d.Accordion_module_h2__77d2bc9d:not(:first-child){padding-top:48px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d{background:#f5f5f7;border-radius:5px;cursor:pointer;display:flex;flex-direction:column;outline-offset:-1px;padding:8px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d:hover{background-color:#e3eafc}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d:active:not(:focus-within){background-color:#d5e1fb}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d:focus{box-shadow:0 0 0 4px #365ef64d;outline:1px solid #365ef6}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d.Accordion_module_containsFocus__77d2bc9d{background:#f1f4fd}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_summarySub__77d2bc9d{column-gap:24px;display:flex;justify-content:center}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_chevron__77d2bc9d.Accordion_module_h2__77d2bc9d{height:32px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_chevron__77d2bc9d.Accordion_module_h3__77d2bc9d{height:28px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_chevron__77d2bc9d.Accordion_module_h4__77d2bc9d{height:24px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_validationIcon__77d2bc9d{display:flex;justify-content:center;margin-right:-16px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_validationIcon__77d2bc9d.Accordion_module_h2__77d2bc9d{height:32px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_validationIcon__77d2bc9d.Accordion_module_h3__77d2bc9d{height:28px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_validationIcon__77d2bc9d.Accordion_module_h4__77d2bc9d{height:24px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d{column-gap:16px;display:flex;flex:auto;margin-left:-24px;min-width:75px;row-gap:4px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d .Accordion_module_titleWrapper__77d2bc9d,.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d h2,.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d h3,.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d h4{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d .Accordion_module_titleWrapper__77d2bc9d.Accordion_module_iconAndTruncated__77d2bc9d{width:calc(100% - 24px)}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_title__77d2bc9d.Accordion_module_containsAdditionalContent__77d2bc9d{align-items:center;display:flex;flex-wrap:wrap}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_additionalContent__77d2bc9d{column-gap:6px;display:flex;flex-wrap:wrap;row-gap:6px}.Accordion_module_accordion__77d2bc9d .Accordion_module_summary__77d2bc9d .Accordion_module_actionContent__77d2bc9d{align-items:center;display:flex;flex:0 0 auto;white-space:nowrap}.Accordion_module_accordion__77d2bc9d .Accordion_module_subTitle__77d2bc9d p{color:#262860;font-size:14px;font-weight:400;line-height:20px;margin-bottom:0;margin-left:25px;margin-top:4px}.Accordion_module_accordion__77d2bc9d .Accordion_module_subTitle__77d2bc9d.Accordion_module_noBadges__77d2bc9d p{margin-top:0}.Accordion_module_accordion__77d2bc9d .Accordion_module_content__77d2bc9d{padding-left:32px;padding-top:24px}.Accordion_module_accordion__77d2bc9d .Accordion_module_icon__77d2bc9d{flex:none;margin-right:4px;transition:all .2s;width:0;width:20px}.Accordion_module_accordion__77d2bc9d .Accordion_module_toggleIcon__77d2bc9d{margin-right:4px;transform:rotate(-90deg);transition:all .2s;width:20px}.Accordion_module_accordion__77d2bc9d .Accordion_module_toggleIcon__77d2bc9d svg path{stroke:#0a2280;stroke-width:2px}.Accordion_module_accordion__77d2bc9d .Accordion_module_toggleIcon__77d2bc9d.Accordion_module_open__77d2bc9d{transform:rotate(0)}.Accordion_module_accordion__77d2bc9d .Accordion_module_toggleIcon__77d2bc9d .Accordion_module_toggleIconFill__77d2bc9d{fill:#0a2280;stroke:none}.Accordion_module_accordion__77d2bc9d.Accordion_module_nested__77d2bc9d{padding-top:32px}.Accordion_module_accordion__77d2bc9d .Accordion_module_errorTitle__77d2bc9d{color:#d80936}.Accordion_module_accordion__77d2bc9d .Accordion_module_successTitle__77d2bc9d{color:#02785f}";
window.ADS.injectStyle(css$1l,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Accordion/Accordion.module.scss");
var modules_0a5b548b = {"accordion":"Accordion_module_accordion__77d2bc9d","h2":"Accordion_module_h2__77d2bc9d","summary":"Accordion_module_summary__77d2bc9d","containsFocus":"Accordion_module_containsFocus__77d2bc9d","summarySub":"Accordion_module_summarySub__77d2bc9d","chevron":"Accordion_module_chevron__77d2bc9d","h3":"Accordion_module_h3__77d2bc9d","h4":"Accordion_module_h4__77d2bc9d","validationIcon":"Accordion_module_validationIcon__77d2bc9d","title":"Accordion_module_title__77d2bc9d","titleWrapper":"Accordion_module_titleWrapper__77d2bc9d","iconAndTruncated":"Accordion_module_iconAndTruncated__77d2bc9d","containsAdditionalContent":"Accordion_module_containsAdditionalContent__77d2bc9d","additionalContent":"Accordion_module_additionalContent__77d2bc9d","actionContent":"Accordion_module_actionContent__77d2bc9d","subTitle":"Accordion_module_subTitle__77d2bc9d","noBadges":"Accordion_module_noBadges__77d2bc9d","content":"Accordion_module_content__77d2bc9d","icon":"Accordion_module_icon__77d2bc9d","toggleIcon":"Accordion_module_toggleIcon__77d2bc9d","open":"Accordion_module_open__77d2bc9d","toggleIconFill":"Accordion_module_toggleIconFill__77d2bc9d","nested":"Accordion_module_nested__77d2bc9d","errorTitle":"Accordion_module_errorTitle__77d2bc9d","successTitle":"Accordion_module_successTitle__77d2bc9d"};

const cx$1r = BindStyles(modules_0a5b548b);
const ACCORDION_ADS_COMPONENT_TYPE = 'accordion';
const AccordionBase = ({ open = true, onOpenChange, animateOnRender = true, onFocus, onBlur, title, type = AccordionTypes.H2, testId, actionContent, validationState, onValidationStateChange, nested = false, children, badgeProps, subTitle, customDataProps }) => {
    const TypeMap = React__default.useMemo(() => ({
        [AccordionTypes.H2]: {
            titleComp: H2,
            buttonSize: 'md'
        },
        [AccordionTypes.H3]: {
            titleComp: H3,
            buttonSize: 'sm'
        },
        [AccordionTypes.H4]: {
            titleComp: H4,
            buttonSize: 'xs'
        }
    }), []);
    // We need a unique id for every component instance.
    const id = React__default.useMemo(() => UUIDv4(), []);
    const TitleComp = TypeMap[type].titleComp;
    const contentRef = React__default.useRef(null);
    const headerRef = React__default.useRef(null);
    const isTextTruncated = useTextTruncated(headerRef);
    const [containsFocus, setContainsFocus] = React__default.useState(false);
    const [childrenValidationState, setChildrenValidationState] = React__default.useState([]);
    // We get access to the ability to animate our exit from
    // AnimateHeightRender component (HOC). So we need to hoist
    // that up into this closure.
    const exitRef = React__default.useRef(null);
    // If there are badgeProps then we need to build those badge elements
    const badges = React__default.useMemo(() => {
        return (badgeProps &&
            badgeProps.length > 0 &&
            badgeProps.map((badgeProp, index) => (React__default.createElement(Badge, { key: index, testId: testId ? `${testId}-badge-${index}` : `badge-${index}`, icon: badgeProp.icon, type: BadgeType.Accordion, size: "xs" }, badgeProp.text))));
    }, [badgeProps, testId]);
    // If we are given the useGetFormSectionStatus hook return, we need to invoke
    // the onBlur method when our accordion loses focus to validate all the fields
    // we contain.
    let onAccordionBlur;
    if (validationState && typeof validationState !== 'string') {
        onAccordionBlur = validationState.onBlur;
        validationState = validationState.status;
    }
    // CSS focus-within is global. We only want to react to when our specific accordions
    // contains the focus.
    useEventListener(['focusin', 'focusout'], (_) => {
        var _a;
        setContainsFocus((contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) &&
            contentRef.current ===
                ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.closest(`[data-ads-component-type="${ACCORDION_ADS_COMPONENT_TYPE}"]`))
            ? true
            : false);
    }, [contentRef.current]);
    const toggleOpen = () => {
        onOpenChange && onOpenChange(!open);
    };
    const keyDownHandler = (e) => {
        // Handle the event based off which key was pressed
        const handled = KeyHandleMap(e, [
            { Enter: toggleOpen },
            { ' ': toggleOpen }, // blank space is for spacebar
            { ArrowDown: () => onOpenChange && onOpenChange(true) },
            { ArrowUp: () => onOpenChange && onOpenChange(false) }
        ]);
        // If we handled the keydown event, cancel it from propagating
        if (handled) {
            CancelReactEvent(e);
        }
    };
    const handleBlur = (e) => {
        onBlur && onBlur(e);
        if (!e.relatedTarget ||
            (contentRef.current &&
                !contentRef.current.contains(e.relatedTarget))) {
            onAccordionBlur && onAccordionBlur();
        }
    };
    // When we unmount we tell our parent our validation status is none now.
    // Otherwise we would be gone and our parent could be in error state only because
    // of our last status.
    React__default.useEffect(() => () => {
        onValidationStateChange &&
            onValidationStateChange(id, FormValidationState.None);
    }, [id, onValidationStateChange]);
    // Anytime one of our children's validation state changes, we update our list .
    const handleChildFormValidationStateChange = React__default.useCallback((childId, state) => {
        setChildrenValidationState((existingChildrenValidationState) => {
            // If we already have a validation state for this child, update it.
            if (existingChildrenValidationState.some((child) => child.id === childId)) {
                const newState = existingChildrenValidationState.filter((child) => child.id !== childId);
                return [...newState, { id: childId, state }];
            }
            // If we don't have a validation state for this child, add it.
            return [...existingChildrenValidationState, { id: childId, state }];
        });
    }, []);
    // Our final validation state none if we ourselves don't have an error and none
    // of our children do.
    const combinedValidationState = React__default.useMemo(() => {
        // If we are in an error state or any of our children is in an error state, we are in an error state.
        if (validationState === FormValidationState.Error ||
            childrenValidationState.some((child) => child.state === FormValidationState.Error)) {
            return FormValidationState.Error;
        }
        // If we are in an success state and all of our children are in a success state, we are in a success state.
        if (validationState === FormValidationState.Success &&
            childrenValidationState.every((child) => child.state === FormValidationState.Success)) {
            return FormValidationState.Success;
        }
        // Otherwise, our state is unknown
        return FormValidationState.None;
    }, [childrenValidationState, validationState]);
    // If our combined validation status changes and we have a parent, update our
    // parent with our status as our parent's status includes ours.
    React__default.useEffect(() => {
        if (nested && onValidationStateChange) {
            onValidationStateChange(id, combinedValidationState);
        }
    }, [id, nested, onValidationStateChange, combinedValidationState]);
    // Memorize context value since it's a non stable (object) value
    const contextValue = React__default.useMemo(() => ({
        type,
        setValidationStatus: handleChildFormValidationStateChange
    }), [type, handleChildFormValidationStateChange]);
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: contentRef, "data-test": testId, "data-ads-component-type": ACCORDION_ADS_COMPONENT_TYPE, onFocus: onFocus, onBlur: handleBlur, className: cx$1r('accordion', {
            [type]: type,
            nested
        }) }),
        React__default.createElement(AnimateHeightRender, { animateOnRender: animateOnRender, animationProps: {
                animateOpacity: false
            } }, ({ animateExit }) => {
            // Consuming component will need to be able to tell us when to animate
            // a removal of this component.
            exitRef.current = animateExit;
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement("div", { "data-test": "summary", className: cx$1r('summary', { containsFocus }), tabIndex: 0, onKeyDown: keyDownHandler, onClick: toggleOpen },
                    React__default.createElement("div", { className: cx$1r('summarySub') },
                        React__default.createElement("div", { className: cx$1r(`chevron`, `${type}`) },
                            React__default.createElement(Icon, { className: cx$1r('icon', 'toggleIcon', { open }), fillClass: cx$1r('toggleIconFill'), testId: testId ? `${testId}-dropdown-icon` : 'dropdown-icon', icon: "ChevronIcon", size: 16 })),
                        React__default.createElement("div", { className: cx$1r('title', { containsAction: actionContent }, { containsAdditionalContent: badges }), "data-test": "titleBadgesParentContainer", ref: (el) => {
                                const headerElement = el && el.querySelector('h2, h3, h4');
                                if (headerElement) {
                                    headerElement.setAttribute('data-test', 'accordionHeader');
                                    headerRef.current = headerElement;
                                }
                            } },
                            combinedValidationState === FormValidationState.Error && (React__default.createElement("div", { className: cx$1r(`validationIcon`, `${type}`) },
                                React__default.createElement(Icon, { className: cx$1r('icon'), icon: "ErrorIconFilled", size: 20 }))),
                            combinedValidationState ===
                                FormValidationState.Success && (React__default.createElement("div", { className: cx$1r(`validationIcon`, `${type}`) },
                                React__default.createElement(Icon, { className: cx$1r('icon'), icon: "SuccessIconFilled", size: 20 }))),
                            React__default.createElement("div", { className: cx$1r('titleWrapper', {
                                    iconAndTruncated: (combinedValidationState ===
                                        FormValidationState.Error ||
                                        combinedValidationState ===
                                            FormValidationState.Success) &&
                                        isTextTruncated
                                }) },
                                React__default.createElement(Tooltip, { disabled: !isTextTruncated, content: title, className: "" },
                                    React__default.createElement(TitleComp, { className: cx$1r({
                                            errorTitle: combinedValidationState ===
                                                FormValidationState.Error,
                                            successTitle: combinedValidationState ===
                                                FormValidationState.Success
                                        }), underline: false }, title))),
                            badges && (React__default.createElement("div", { className: cx$1r('additionalContent'), "data-test": "additionalContent" }, badges))),
                        actionContent && (React__default.createElement(ClickEventBoundary, null,
                            React__default.createElement("div", { className: cx$1r('actionContent') }, typeof actionContent === 'function'
                                ? actionContent({
                                    animateExit: exitRef.current,
                                    buttonSize: TypeMap[type].buttonSize
                                })
                                : actionContent)))),
                    subTitle && (React__default.createElement("div", { className: cx$1r('subTitle', { noBadges: !badges }) },
                        React__default.createElement("p", null, subTitle)))),
                React__default.createElement(AccordionContext.Provider, { value: contextValue },
                    React__default.createElement(AnimateHeightRender, { animationProps: {
                            height: open ? 'auto' : 0,
                            animateOpacity: false
                        } },
                        React__default.createElement("div", { className: cx$1r('content') }, children)))));
        })));
};
const getNextLevel = (parent) => {
    if (parent === null || parent === void 0 ? void 0 : parent.type) {
        const parentLevel = parseInt(parent.type.slice(-1), 10);
        return `h${Math.min(parentLevel + 1, 4)}`;
    }
};
// Nested accordions have slightly different considerations then when they are top level.
// For example they have slightly different styling, and report their validation status
// to their parent.
const NestedAccordion = (_a) => {
    var { type } = _a, props = __rest(_a, ["type"]);
    // If we are nested inside another accordion, drop our type down a level
    // (H2 -> H3 -> H4) and mark it as nested
    const parent = React__default.useContext(AccordionContext);
    // When our accordion changes validation state, we use the context
    // to rely that up to our immediate parent.
    const handleValidationStateChange = React__default.useCallback((childId, state) => {
        if (parent) {
            parent.setValidationStatus(childId, state);
        }
    }, [parent]);
    return (React__default.createElement(AccordionBase, Object.assign({ type: type !== null && type !== void 0 ? type : getNextLevel(parent), nested: !!parent, onValidationStateChange: handleValidationStateChange }, props)));
};
const UnControlledAccordion = (props) => {
    var _a;
    const [open, setOpen] = React__default.useState((_a = props.open) !== null && _a !== void 0 ? _a : true);
    return React__default.createElement(NestedAccordion, Object.assign({}, props, { open: open, onOpenChange: setOpen }));
};
const Accordion = (props) => {
    return props.onOpenChange !== undefined && props.open !== undefined ? (React__default.createElement(NestedAccordion, Object.assign({}, props))) : (React__default.createElement(UnControlledAccordion, Object.assign({}, props)));
};

const FIELD_VISIBILITY_CONFIG_DEFAULTS = {
    showStreetLineCount: 3,
    showCountry: true,
    showCounty: true
};

const toFormat = (val, oldVal, formatter) => {
    // eslint-disable-next-line no-constant-binary-expression, valid-typeof
    if (!formatter || typeof formatter.pattern === undefined) {
        return val;
    }
    if (formatter.preTransform) {
        val = formatter.preTransform(val, oldVal);
    }
    const masked = IMask.createMask({
        mask: formatter.pattern,
        lazy: !formatter.placeholder,
        placeholderChar: formatter.placeholder || '',
        unmask: true,
        prepare: formatter.prepare,
        definitions: formatter.definitions
    });
    masked.resolve(val);
    return masked.value; // iMask 7 needs this now
};
const useFormattedInput = ({ callback, formatter, name, value }) => {
    // Watch for value changes that need formatting
    // This helps with initial values and programmatic updates
    React__default.useEffect(() => {
        const formattedValue = toFormat(value, '', formatter);
        // Only update if formatting changed the value
        if (value !== formattedValue) {
            callback({ target: { name: name, value: formattedValue } }, false);
        }
    }, [callback, formatter, name, value]);
    // Main handler for input changes that preserves cursor position
    const formatWithCaretPosition = React__default.useCallback((e) => {
        const input = e.target;
        let userText = input.value;
        // Calculate cursor position before formatting
        const valueLength = input.value.length || 0;
        const caretPosition = input.selectionStart || 0;
        let charToRight = valueLength - caretPosition;
        // Apply formatting while preserving the cursor position context
        userText = formatter ? toFormat(userText, value, formatter) : userText;
        // If formatting removed characters, adjust cursor position
        const formatValueLengthDiff = valueLength - userText.length;
        if (formatValueLengthDiff > 0 && value !== userText) {
            charToRight -= formatValueLengthDiff;
        }
        e.target.value = userText;
        callback(e, true);
        window.requestAnimationFrame(() => {
            const caret = input.value.length - charToRight;
            input.selectionStart = caret;
            input.selectionEnd = caret;
        });
    }, [callback, formatter, value]);
    return {
        formatWithCaretPosition
    };
};

// withFieldSchemaSupport is a higher order component that returns one of two possible
// versions of the passed in components. If there is a parent form context, it returns
// the version of the component (schema version) that can handle being in a form. If
// there is no form context, then the base version is returned.
const withFieldSchemaSupport$1 = (FieldComponentBase, FieldComponentSchema) => (_a) => {
    var { name, label, defaultLabel, required, desired, readOnly, disabled, skipSubFormName = false } = _a, props = __rest(_a, ["name", "label", "defaultLabel", "required", "desired", "readOnly", "disabled", "skipSubFormName"]);
    const fieldSchemaName = useFieldSchemaName(name);
    // If we are nested inside a subForm, then we have a namespace
    // that we need to use to find our matching field name.
    // prepending the subForm name could happen twice with components that
    // build on already-form-capable components. It can be skipped if necessary.
    const fieldName = skipSubFormName ? name : fieldSchemaName;
    // Try and pull the field schema from the forms context. If it doesn't exist
    // this will return null values.
    const fieldSchema = useFieldSchema(fieldName);
    // We return a fragment otherwise React's reconciliation was causing a teardown
    // and remount here.
    return (React__default.createElement(React__default.Fragment, null,
        fieldSchema && fieldSchema.field && (React__default.createElement(FieldComponentSchema, Object.assign({ key: fieldName, name: fieldName, label: label || fieldSchema.field.label || defaultLabel, required: required !== undefined ? required : fieldSchema.field.required, desired: desired !== undefined ? desired : fieldSchema.field.desired, readOnly: readOnly !== undefined ? readOnly : fieldSchema.form.readOnly, disabled: disabled !== undefined ? disabled : fieldSchema.form.disabled }, props))),
        !(fieldSchema && fieldSchema.field) && (React__default.createElement(FieldComponentBase, Object.assign({ key: fieldName, name: fieldName, label: label, defaultLabel: defaultLabel, required: required, desired: desired, readOnly: readOnly, disabled: disabled }, props)))));
};

var css$1k = ".FieldMessage_module_message__191633c8{align-items:top;cursor:default;display:flex;font-weight:600;height:0;opacity:0;position:relative;top:-6px;transition:all .2s cubic-bezier(.25,.25,.25,1);z-index:1}.FieldMessage_module_message__191633c8 .FieldMessage_module_icon__191633c8{align-self:auto;display:inline-block;position:relative;top:2px;width:16px}.FieldMessage_module_message__191633c8.FieldMessage_module_error__191633c8{color:#ea0a3b}.FieldMessage_module_message__191633c8.FieldMessage_module_warning__191633c8{color:#d93f02}.FieldMessage_module_animateEnter__191633c8{height:auto;opacity:1;top:4px}.FieldMessage_module_animateExit__191633c8{top:-6px}";
window.ADS.injectStyle(css$1k,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FieldMessage/FieldMessage.module.scss");
var modules_dbd9cdc4 = {"message":"FieldMessage_module_message__191633c8","icon":"FieldMessage_module_icon__191633c8","error":"FieldMessage_module_error__191633c8","warning":"FieldMessage_module_warning__191633c8","animateEnter":"FieldMessage_module_animateEnter__191633c8","animateExit":"FieldMessage_module_animateExit__191633c8"};

const cx$1q = classnames.bind(modules_dbd9cdc4);
const FieldMessage = ({ customDataProps, testId, message, messageStyle = 'error' }) => {
    const [text, setText] = React__default.useState();
    const nodeRef = React__default.useRef(null);
    // If error changes to a truthy value (i.e. new error message), we update our
    // error message. If not, we wait till we exit to set the error to false so
    // the text remains on screen while it animates off.
    React__default.useEffect(() => {
        if (message) {
            setText(message);
        }
    }, [message]);
    // If we don't have message text that is a string, we don't have anything to display.
    if (!isString(text)) {
        return null;
    }
    return (React__default.createElement(CSSTransition, { in: !!message, timeout: 200, appear: true, unmountOnExit: true, classNames: {
            enterActive: modules_dbd9cdc4.animateEnter,
            enterDone: modules_dbd9cdc4.animateEnter,
            exitActive: modules_dbd9cdc4.animateExit
        }, nodeRef: nodeRef },
        React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'fieldMessage', "data-type": messageStyle, className: cx$1q('message', messageStyle), ref: nodeRef }),
            React__default.createElement(Icon, { icon: messageStyle === 'error' ? 'ErrorIconFilled' : 'WarningIconFilled', size: 16, className: cx$1q('icon', 'mr-25') }),
            text && text)));
};

var css$1j = ".FieldHeightText_module_fieldHeight__7905f8d1{align-items:center;display:flex;min-height:32px;text-align:left}.FieldHeightText_module_fieldHeight__7905f8d1.FieldHeightText_module_truncated__7905f8d1{min-width:56px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.FieldHeightText_module_fieldHeight__7905f8d1.FieldHeightText_module_truncated__7905f8d1 span{text-overflow:ellipsis}.FieldHeightText_module_fieldHeight__7905f8d1.FieldHeightText_module_disabled__7905f8d1{color:#b0b4bf}";
window.ADS.injectStyle(css$1j,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FieldHeightText/FieldHeightText.module.scss");
var modules_0b60535a = {"fieldHeight":"FieldHeightText_module_fieldHeight__7905f8d1","truncated":"FieldHeightText_module_truncated__7905f8d1","disabled":"FieldHeightText_module_disabled__7905f8d1"};

const cx$1p = BindStyles(modules_0b60535a);
const FieldHeightText = ({ customDataProps, testId, className, children, disabled, truncateText = false }) => {
    const childrenAreTextOrSpan = isTextOrSpan(children);
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1p('fieldHeight', className, {
            disabled: disabled && childrenAreTextOrSpan,
            truncated: truncateText && childrenAreTextOrSpan
        }) }), childrenAreTextOrSpan && truncateText ? (React__default.createElement(CellText, null, children)) : (children)));
};

var css$1i = ".Label_module_label__5243be76{align-items:center;display:flex;margin-bottom:4px;min-height:20px}.Label_module_label__5243be76 .Label_module_icon__5243be76{height:16px;margin-left:6px;width:16px}.Label_module_label__5243be76 .Label_module_requiredIcon__5243be76{display:inline-flex;left:1px;position:relative;top:-4px}.Label_module_label__5243be76 label{color:#444750;display:inline-block;font-size:14px;font-weight:600;line-height:20px}.Label_module_label__5243be76 label.Label_module_disabled__5243be76{color:#b0b4bf;cursor:default!important;pointer-events:none;user-select:none}.Label_module_spacer__5243be76{height:24px}.Label_module_linkSpacer__5243be76{height:30px}.Label_module_field__5243be76{margin:6px 0}";
window.ADS.injectStyle(css$1i,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Label/Label.module.scss");
var modules_aa63a669 = {"label":"Label_module_label__5243be76","icon":"Label_module_icon__5243be76","requiredIcon":"Label_module_requiredIcon__5243be76","disabled":"Label_module_disabled__5243be76","spacer":"Label_module_spacer__5243be76","linkSpacer":"Label_module_linkSpacer__5243be76","field":"Label_module_field__5243be76"};

const cx$1o = classnames.bind(modules_aa63a669);
const Label = ({ customDataProps, testId, forId, required, disabled, desired, className, helpText, children }) => {
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, "data-label": true, className: cx$1o('label', className) }),
        React__default.createElement("label", { htmlFor: forId, className: cx$1o({ disabled, required, desired }) },
            children,
            (required || desired) && (React__default.createElement("div", { className: cx$1o('requiredIcon') },
                React__default.createElement(Icon, { icon: required ? 'RequiredIndicatorIcon' : 'DesiredIndicatorIcon', size: 12 })))),
        helpText && (React__default.createElement("div", { className: cx$1o('icon') },
            React__default.createElement(Tooltip, { content: helpText, trigger: "mouseenter click" },
                React__default.createElement(Icon, { icon: "ICircleIcon", size: 16, onClick: (evt) => evt.stopPropagation(), className: 'help-hover' }))))));
};
// When we need to account for the space of a label
const LabelSpacer = ({ testId, customDataProps }) => (React__default.createElement("div", Object.assign({ "data-test": testId }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$1o('spacer') })));
const LinkLabelSpacer = ({ testId, customDataProps }) => (React__default.createElement("div", Object.assign({ "data-test": testId }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$1o('linkSpacer') })));
// When we want a label to be horizontally aligned with other fields. Fields are 32px
// in height, and labels are 20px. This adds margin to the label is 32px in height to
// other fields.
const FieldHeightLabel = (props) => (React__default.createElement(FieldHeightText, null,
    React__default.createElement(Label, Object.assign({ className: cx$1o('mb-0') }, props))));

var css$1h = ".ComboboxBase_module_container__bb5e9caf{display:inline-block;outline:none;position:relative}.ComboboxBase_module_inputWrapper__bb5e9caf{background-color:#fff;background:#fff;border:1px solid #b0b4bf;border-radius:2px;color:#363840;cursor:text;display:flex;font-size:14px;height:auto;line-height:20px;padding:0;position:relative;text-overflow:ellipsis;transition:all 275ms cubic-bezier(.25,.25,.25,1),background-color 0ms;z-index:10}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_error__bb5e9caf{border-color:#ea0a3b}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_warning__bb5e9caf{border-color:#f45110}.ComboboxBase_module_inputWrapper__bb5e9caf:hover{border-color:#365ef6}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_readOnly__bb5e9caf{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf;color:#363840}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_readOnly__bb5e9caf input{background-color:#f5f5f7;color:#b0b4bf;color:#363840}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_isLoading__bb5e9caf{background-color:#f1f4fd;border-color:#365ef6}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_isLoading__bb5e9caf input{background-color:#f1f4fd}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_focus__bb5e9caf,.ComboboxBase_module_inputWrapper__bb5e9caf:focus,.ComboboxBase_module_inputWrapper__bb5e9caf:focus-within{border-color:#365ef6!important;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_focus__bb5e9caf.ComboboxBase_module_readOnly__bb5e9caf,.ComboboxBase_module_inputWrapper__bb5e9caf:focus-within.ComboboxBase_module_readOnly__bb5e9caf,.ComboboxBase_module_inputWrapper__bb5e9caf:focus.ComboboxBase_module_readOnly__bb5e9caf{border-color:#cbced7!important;box-shadow:none!important}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_disabled__bb5e9caf,.ComboboxBase_module_inputWrapper__bb5e9caf:disabled{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_disabled__bb5e9caf input,.ComboboxBase_module_inputWrapper__bb5e9caf:disabled input{background-color:#f5f5f7;color:#b0b4bf}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_disabled__bb5e9caf{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf;cursor:default}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_disabled__bb5e9caf input{background-color:#f5f5f7;color:#b0b4bf}.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_disabled__bb5e9caf .ComboboxBase_module_icon__bb5e9caf,.ComboboxBase_module_inputWrapper__bb5e9caf.ComboboxBase_module_readOnly__bb5e9caf .ComboboxBase_module_icon__bb5e9caf{cursor:default}.ComboboxBase_module_inputWrapper__bb5e9caf:focus-within{border-color:#365ef6;box-shadow:0 0 0 3px #365ef64d;outline:none}.ComboboxBase_module_inputWrapper__bb5e9caf .ComboboxBase_module_selections__bb5e9caf{display:flex;flex-wrap:wrap;justify-content:left;width:calc(100% - 30px)}.ComboboxBase_module_inputWrapper__bb5e9caf .ComboboxBase_module_input__bb5e9caf{border:none;flex:1;font-size:14px;height:auto;line-height:20px;margin:0;max-height:30px;max-width:100%;min-height:30px;outline:none;padding:5px 0 5px 8px;text-overflow:ellipsis}.ComboboxBase_module_inputWrapper__bb5e9caf .ComboboxBase_module_input__bb5e9caf:disabled{background-color:#f5f5f7;border:none;color:#b0b4bf}.ComboboxBase_module_inputWrapper__bb5e9caf .ComboboxBase_module_input__bb5e9caf:disabled input{background-color:#f5f5f7;color:#b0b4bf}.ComboboxBase_module_icon__bb5e9caf{cursor:pointer;width:30px}.ComboboxBase_module_disabledIcon__bb5e9caf{fill:#b0b4bf;stroke:none;pointer-events:none}";
window.ADS.injectStyle(css$1h,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxBase.module.scss");
var modules_42e4e3a2 = {"container":"ComboboxBase_module_container__bb5e9caf","inputWrapper":"ComboboxBase_module_inputWrapper__bb5e9caf","error":"ComboboxBase_module_error__bb5e9caf","warning":"ComboboxBase_module_warning__bb5e9caf","readOnly":"ComboboxBase_module_readOnly__bb5e9caf","isLoading":"ComboboxBase_module_isLoading__bb5e9caf","focus":"ComboboxBase_module_focus__bb5e9caf","disabled":"ComboboxBase_module_disabled__bb5e9caf","icon":"ComboboxBase_module_icon__bb5e9caf","selections":"ComboboxBase_module_selections__bb5e9caf","input":"ComboboxBase_module_input__bb5e9caf","disabledIcon":"ComboboxBase_module_disabledIcon__bb5e9caf"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const Portal = ({ children, 
// render location looks to ADS global object so consumers can control where portals are injected
renderLocation = window.ADS.portalElement() }) => {
    return ReactDOM.createPortal(React__default.createElement("div", { "data-test": "ads-portal", className: "ads-theme" }, children), renderLocation);
};

var css$1g = ".Dropdown_module_wrapper__283d89ba{outline:none;position:absolute;z-index:1100}";
window.ADS.injectStyle(css$1g,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Dropdown/Dropdown.module.scss");
var modules_5709697d = {"wrapper":"Dropdown_module_wrapper__283d89ba"};

const cx$1n = classnames.bind(modules_5709697d);
const CONSTANTS$2 = {
    'animation-duration': 150,
    /**
     * @remarks Per a UX meeting on 1/10/25 during DX-337,
     * UX would like this to only apply to context menus,
     * i.e., non-anchored "context" menus as opposed to
     * anchored "dropdown" menus.
     */
    'document-padding': 8,
    'top-gap': 4
};
const DEFAULTS$6 = {
    testId: 'dropdown',
    /**
     * A "bag of nulls" is what you get when you open an
     * {@link Option<ContextMenuBag>} and find {@link None}.
     *
     * This happens when an optional context menu is not enabled.
     * See `DataGridRow` as an example..
     */
    contextMenuBag: {
        rootContext: null,
        closeMenu: null,
        getFloatingProps: null,
        getReferenceProps: null,
        setFloating: null
    },
    offsetConfig: {
        skid: undefined,
        offset: CONSTANTS$2['top-gap']
    }
};
const DEFAULT_PLACEMENT_CONFIG = {
    placement: 'bottom-start',
    fallbackPlacements: ['top-start']
};
// passed into the React.forwardRef function
const ASIInternal_Dropdown = function ({ anchorEl, children, open, contextMenuBag: _contextMenuBag, minWidthMatchAnchor = true, offsetConfig = DEFAULTS$6.offsetConfig, placementConfig = DEFAULT_PLACEMENT_CONFIG, portal = true, testId = DEFAULTS$6.testId, onAnimationEnd, onAnimationStart }, ref) {
    var _a, _b, _c, _d;
    const contextMenuBag = _contextMenuBag !== null && _contextMenuBag !== void 0 ? _contextMenuBag : DEFAULTS$6.contextMenuBag;
    const isMountedRef = useIsMountedRef();
    const [render, setRender] = React__default.useState(open);
    const [height, setHeight] = React__default.useState(0);
    // We use a container set to the height the dropdown will be so we can let Floating UI
    // detect if needs to go on top or on bottom.
    const [containerHeight, setContainerHeight] = React__default.useState(0);
    const size = useSize(anchorEl);
    const [floatingEl, setFloatingEl] = React__default.useState(null);
    const [fallbackPlacements, placement] = React__default.useMemo(() => {
        var _a, _b;
        return [
            (_a = placementConfig.fallbackPlacements) !== null && _a !== void 0 ? _a : DEFAULT_PLACEMENT_CONFIG.fallbackPlacements,
            (_b = placementConfig.placement) !== null && _b !== void 0 ? _b : DEFAULT_PLACEMENT_CONFIG.placement
        ];
    }, [placementConfig.fallbackPlacements, placementConfig.placement]);
    const [placementOffset, placementSkid] = [
        (_a = offsetConfig.offset) !== null && _a !== void 0 ? _a : DEFAULTS$6.offsetConfig.offset,
        (_b = offsetConfig.skid) !== null && _b !== void 0 ? _b : DEFAULTS$6.offsetConfig.skid
    ];
    const floatingOptions = React__default.useMemo(() => {
        const shared = {
            fallbackPlacements,
            placement,
            placementOffset,
            placementSkid
        };
        if (contextMenuBag.rootContext) {
            return buildContextOptions(Object.assign(Object.assign({}, shared), { contextMenuBag }));
        }
        return buildDropdownOptions(Object.assign(Object.assign({}, shared), { anchorEl,
            floatingEl }));
    }, [
        anchorEl,
        contextMenuBag,
        fallbackPlacements,
        floatingEl,
        placement,
        placementOffset,
        placementSkid
    ]);
    const { floatingStyles, placement: currentPlacement, isPositioned, update } = useFloating(floatingOptions);
    // Add custom attributes to the dropdown wrapper element. Popper would add the `data-popper-placement` attribute.
    // To maintain backward compatibility, include both `data-popper-placement`and `data-floating-ui-placement`.
    // Note: Remove `data-popper-placement` in the next major version.
    const customAttributes = {
        'data-floating-ui-placement': currentPlacement,
        'data-popper-placement': currentPlacement
    };
    React__default.useLayoutEffect(() => {
        if (open) {
            setRender(true);
        }
        // Immediately after rendering we need to set our height from 0 to auto
        // to animate our entrance. If we are closing, set height back to 0.
        requestAnimationFrame(() => {
            var _a;
            if (!isMountedRef.current ||
                (!((_a = contextMenuBag.rootContext) === null || _a === void 0 ? void 0 : _a.elements.reference) && !anchorEl)) {
                return;
            }
            /**
             * While migrating to React 18, we needed to ensure that the `setRender` and `setHeight` were not batched.
             * This is because it made the animation clunky when opening the drop-down (it would not show the transition and instead,
             * just appear fully opened without the animation). Wrapping `setHeight` with `flushSync`
             * will ensure that these two state updates are not batched.
             */
            flushSync(() => {
                setHeight(open ? 'auto' : 0);
            });
        });
    }, [
        anchorEl,
        (_c = contextMenuBag.rootContext) === null || _c === void 0 ? void 0 : _c.elements.reference,
        isMountedRef,
        open
    ]);
    // If the size of our anchorEl changes, we need the menu to update it's location.
    React__default.useEffect(() => {
        update && update();
    }, [size, containerHeight, update]);
    const handleAnimationStart = (newHeight) => {
        const numericValue = getHeightNumericValue(newHeight);
        if (numericValue > 0) {
            setContainerHeight(numericValue);
        }
        onAnimationStart && onAnimationStart(newHeight);
    };
    const handleAnimationEnd = (newHeight) => {
        if (getHeightNumericValue(newHeight) < 1) {
            /**
             * While migrating to React 18, we needed to ensure that the `setContainerHeight` and `setRender` were not batched.
             * This is because it made the animation clunky when opening the drop-down (it would not show the transition and instead,
             * just appear fully opened without the animation). Without this, we also saw a lot of flakey tests within
             * src/components/DataGrid/tests/feature-row-actions/multi-action-conditionable.test.tsx
             */
            flushSync(() => {
                setContainerHeight(0);
            });
        }
        flushSync(() => {
            setRender(open);
        });
        onAnimationEnd && onAnimationEnd(newHeight);
    };
    const animatedHeightStyles = {
        flexShrink: 0
    };
    const minWidth = minWidthMatchAnchor ? size.width || 0 : undefined;
    const menuStyles = Object.assign({ height: containerHeight, minWidth: minWidth }, floatingStyles // Floating-UI menu styles
    );
    // If we are positioning the dropdown on top, we need to modify the edge
    // the dropdown is pinned to so the animation of the height (slide in)
    // comes from the right direction.
    if (isPositioned && currentPlacement === 'top-start') {
        animatedHeightStyles.position = 'absolute';
        animatedHeightStyles.bottom = 0;
        animatedHeightStyles.minWidth = minWidth;
    }
    // early return if not rendering
    if (!render)
        return null;
    const dropdown = (React__default.createElement("div", Object.assign({}, customAttributes, { "data-test": testId, className: cx$1n('wrapper'), ref: MergeRefs([ref, (_d = contextMenuBag.setFloating) !== null && _d !== void 0 ? _d : setFloatingEl]), style: menuStyles }, (contextMenuBag.getFloatingProps &&
        contextMenuBag.getFloatingProps())),
        React__default.createElement("div", { style: {
                position: 'relative',
                height: containerHeight,
                width: '100%'
            } },
            React__default.createElement(AnimateHeight, { duration: CONSTANTS$2['animation-duration'], height: height, delay: 20, onHeightAnimationStart: handleAnimationStart, onHeightAnimationEnd: handleAnimationEnd, easing: "cubic-bezier(0.25, 0.25, 0.25, 1)", style: animatedHeightStyles }, children))));
    if (portal)
        return React__default.createElement(Portal, null, dropdown);
    return dropdown;
};
ASIInternal_Dropdown.displayName = 'ASIInternal_Dropdown';
const Dropdown = React__default.forwardRef(ASIInternal_Dropdown);
Dropdown.displayName = 'Dropdown';
function isNumber(n) {
    const number = parseFloat(n);
    return !isNaN(number) && isFinite(number);
}
function isPercentage(height) {
    return (typeof height === 'string' &&
        height[height.length - 1] === '%' &&
        isNumber(height.substring(0, height.length - 1)));
}
function getHeightNumericValue(height) {
    if (typeof height === 'number') {
        return height;
    }
    if (isPercentage(height)) {
        const numericValue = height.substring(0, height.length - 1);
        return parseFloat(numericValue);
    }
    // handles the 'auto' case
    return NaN;
}
const buildDropdownOptions = (config) => {
    const { anchorEl, fallbackPlacements, floatingEl, placement, placementOffset, placementSkid } = config;
    return {
        elements: {
            reference: anchorEl,
            floating: floatingEl
        },
        // We really only want this on bottom, but will fallback to top if we have to.
        middleware: [
            offset({
                mainAxis: placementOffset !== null && placementOffset !== void 0 ? placementOffset : 0,
                crossAxis: placementSkid !== null && placementSkid !== void 0 ? placementSkid : 0
            }),
            flip({
                fallbackPlacements
            }),
            shift({
                limiter: limitShift()
            })
        ],
        placement: placement,
        rootContext: undefined,
        // Automatically updates the position of the popover element when necessary to ensure it stays anchored.
        whileElementsMounted: autoUpdate
    };
};
const buildContextOptions = (config) => {
    const { contextMenuBag, fallbackPlacements, placement, placementOffset, placementSkid } = config;
    const { rootContext } = contextMenuBag;
    return {
        elements: undefined,
        // We really only want this on bottom, but will fallback to top if we have to.
        middleware: [
            offset({
                mainAxis: placementOffset !== null && placementOffset !== void 0 ? placementOffset : 0,
                crossAxis: placementSkid !== null && placementSkid !== void 0 ? placementSkid : 0
            }),
            flip({ fallbackPlacements }),
            shift({
                limiter: limitShift(),
                mainAxis: true,
                crossAxis: true,
                padding: CONSTANTS$2['document-padding']
            })
        ],
        placement: placement,
        rootContext: rootContext,
        // Automatically updates the position of the popover element when necessary to ensure it stays anchored.
        whileElementsMounted: autoUpdate
    };
};
//#endregion Floating-Menu Interfaces

var css$1f = ".DropdownContainer_module_container__3716ed31{background:#fff;border:1px solid #365ef6;border-radius:3px;box-shadow:0 3px 1px -2px #0003,0 2px 2px 0 #00000024,0 1px 5px 0 #0000001f;padding:4px 0}.DropdownContainer_module_container__3716ed31.DropdownContainer_module_autoScroll__3716ed31{overflow:auto}";
window.ADS.injectStyle(css$1f,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Dropdown/DropdownContainer.module.scss");
var modules_c1269d1c = {"container":"DropdownContainer_module_container__3716ed31","autoScroll":"DropdownContainer_module_autoScroll__3716ed31"};

const cx$1m = classnames.bind(modules_c1269d1c);
const DropdownContainer = React__default.forwardRef(({ testId, autoScroll = true, children, customDataProps, className, maxHeight = 266, maxWidth, onScroll }, ref) => (React__default.createElement("div", Object.assign({}, customDataProps, { "data-test": testId, ref: ref, onScroll: onScroll, style: { maxHeight, maxWidth }, className: cx$1m('container', { autoScroll }, className) }), children)));
DropdownContainer.displayName = 'DropdownContainer';

var css$1e = ".ComboboxDropdown_module_dropdown__94e367dc{display:flex;flex-direction:column;max-width:400px;min-width:100%}.ComboboxDropdown_module_rows__94e367dc{overflow:auto}.ComboboxDropdown_module_rows__94e367dc .ComboboxDropdown_module_listContainer__94e367dc{margin-bottom:4px}.ComboboxDropdown_module_noResults__94e367dc{color:#b0b4bf;font-style:italic;padding:15px;text-align:center}.ComboboxDropdown_module_footerLinkBox__94e367dc{border-top:1px solid #cbced7;cursor:pointer;padding-top:4px;position:relative}.ComboboxDropdown_module_footerLinkBox__94e367dc .ComboboxDropdown_module_footerLinkButton__94e367dc{color:#365ef6;min-width:150px;padding:4px 8px}.ComboboxDropdown_module_footerLinkBox__94e367dc .ComboboxDropdown_module_active__94e367dc{background:#e3eafc;transition:background-color .125s cubic-bezier(.78,.14,.15,.86)}.ComboboxDropdown_module_footerLinkBox__94e367dc:hover .ComboboxDropdown_module_footerLinkButton__94e367dc{background-color:#e3eafc}.ComboboxDropdown_module_customValueBox__94e367dc{border-top:1px solid #cbced7;cursor:pointer;padding-top:4px;position:relative}.ComboboxDropdown_module_customValueBox__94e367dc:not(.ComboboxDropdown_module_lastRow__94e367dc){padding-bottom:4px}.ComboboxDropdown_module_customValueBox__94e367dc .ComboboxDropdown_module_customValueButton__94e367dc{min-width:150px;padding:4px 8px}.ComboboxDropdown_module_customValueBox__94e367dc .ComboboxDropdown_module_active__94e367dc{background:#e3eafc;transition:background-color .125s cubic-bezier(.78,.14,.15,.86)}.ComboboxDropdown_module_customValueBox__94e367dc.ComboboxDropdown_module_disabled__94e367dc{color:#b0b4bf;cursor:default}.ComboboxDropdown_module_customValueBox__94e367dc:not(.ComboboxDropdown_module_disabled__94e367dc):hover .ComboboxDropdown_module_customValueButton__94e367dc{background:#e3eafc;transition:background-color .125s cubic-bezier(.78,.14,.15,.86)}";
window.ADS.injectStyle(css$1e,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxDropdown/ComboboxDropdown.module.scss");
var modules_a19b411f = {"dropdown":"ComboboxDropdown_module_dropdown__94e367dc","rows":"ComboboxDropdown_module_rows__94e367dc","listContainer":"ComboboxDropdown_module_listContainer__94e367dc","noResults":"ComboboxDropdown_module_noResults__94e367dc","footerLinkBox":"ComboboxDropdown_module_footerLinkBox__94e367dc","footerLinkButton":"ComboboxDropdown_module_footerLinkButton__94e367dc","active":"ComboboxDropdown_module_active__94e367dc","customValueBox":"ComboboxDropdown_module_customValueBox__94e367dc","lastRow":"ComboboxDropdown_module_lastRow__94e367dc","customValueButton":"ComboboxDropdown_module_customValueButton__94e367dc","disabled":"ComboboxDropdown_module_disabled__94e367dc"};

var css$1d = ".DropdownColumn_module_column__0428e196{background-color:#f5f5f7;border-bottom:1px solid #b0b4bf;color:#585c6a;display:flex;font-weight:600;line-height:32px;outline:none;overflow:hidden;padding:0 8px;position:relative;text-overflow:ellipsis;white-space:nowrap}.DropdownColumn_module_column__0428e196:first-child{border-radius:4px 0 0 0}.DropdownColumn_module_column__0428e196:last-child{border-radius:0 4px 0 0}.DropdownColumn_module_column__0428e196.DropdownColumn_module_isSortable__0428e196:hover{background-color:#e5e6eb;cursor:pointer}.DropdownColumn_module_column__0428e196.DropdownColumn_module_noWidth__0428e196{flex:1}.DropdownColumn_module_title__0428e196{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.DropdownColumn_module_sorted__0428e196{flex:2 1 8px;font-size:14px;margin-left:5px;position:relative;transition:all 2s cubic-bezier(.78,.14,.15,.86)}.DropdownColumn_module_asc__0428e196{top:2px;transform:rotateX(180deg)}";
window.ADS.injectStyle(css$1d,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxDropdown/DropdownColumn.module.scss");
var modules_e9c4413e = {"column":"DropdownColumn_module_column__0428e196","isSortable":"DropdownColumn_module_isSortable__0428e196","noWidth":"DropdownColumn_module_noWidth__0428e196","title":"DropdownColumn_module_title__0428e196","sorted":"DropdownColumn_module_sorted__0428e196","asc":"DropdownColumn_module_asc__0428e196"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const DropdownColumn = ({ name, title = name, index, width, sorted, isSortable = true, onClick, prePadding = 0, postPadding = 0 }) => {
    if (width) {
        width += prePadding;
    }
    const style = {
        width,
        paddingLeft: prePadding + 8,
        paddingRight: postPadding + 8
    };
    const onClickHandler = () => {
        const direction = sorted === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
        if (onClick) {
            onClick(name, direction);
        }
        return false;
    };
    return (React__default.createElement("div", { className: cx$1S(modules_e9c4413e.column, !width && modules_e9c4413e.noWidth, isSortable && modules_e9c4413e.isSortable), style: style, "data-test": "dropdown-column", "data-index": index, onClick: (e) => {
            e.nativeEvent.stopPropagation();
            if (isSortable) {
                onClickHandler();
            }
        }, tabIndex: 0 },
        React__default.createElement("div", { className: cx$1S(modules_e9c4413e.title) }, title),
        sorted && sorted === SortDirection.Asc && (React__default.createElement("div", { className: cx$1S(modules_e9c4413e.sorted, modules_e9c4413e.asc) }, String.fromCharCode(9662))),
        sorted && sorted === SortDirection.Desc && (React__default.createElement("div", { className: cx$1S(modules_e9c4413e.sorted, modules_e9c4413e.desc) }, String.fromCharCode(9662)))));
};

var css$1c = ".DropdownColumns_module_columnContainer__6d3ba0f3{align-items:center;display:flex;margin-top:-4px}";
window.ADS.injectStyle(css$1c,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxDropdown/DropdownColumns.module.scss");
var modules_0448d409 = {"columnContainer":"DropdownColumns_module_columnContainer__6d3ba0f3"};

const cx$1l = BindStyles(modules_0448d409);
const DropdownColumns = ({ preSpace = 0, postSpace = 0, columns, onClick }) => {
    return (React__default.createElement("div", { className: cx$1l('columnContainer') }, columns.map((column, i) => (React__default.createElement(DropdownColumn, Object.assign({ prePadding: i === 0 ? preSpace : 0, postPadding: i === columns.length - 1 ? postSpace : 0, key: column.name || i, onClick: onClick }, column, { index: i }))))));
};

var css$1b = ".DropdownCell_module_cell__c3a0c414{cursor:pointer;height:28px;overflow:hidden;padding:4px 8px}.DropdownCell_module_cell__c3a0c414.DropdownCell_module_noWidth__c3a0c414{flex:1}.DropdownCell_module_cell__c3a0c414.DropdownCell_module_locked__c3a0c414{cursor:default}";
window.ADS.injectStyle(css$1b,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxDropdown/DropdownCell.module.scss");
var modules_a9525fe8 = {"cell":"DropdownCell_module_cell__c3a0c414","noWidth":"DropdownCell_module_noWidth__c3a0c414","locked":"DropdownCell_module_locked__c3a0c414"};

const DropdownCell = ({ cell, width, isLocked = false, isSelected = false }) => {
    return (React__default.createElement("div", { "data-test": "dropdown-cell", className: cx$1S(modules_a9525fe8.cell, !width && modules_a9525fe8.noWidth, isLocked && modules_a9525fe8.locked), style: { width } }, cell.isJSX ? (cell.content) : (React__default.createElement(CellText, { disabled: isLocked && !isSelected }, cell.content))));
};
DropdownCell.displayName = 'DropdownCell';

var css$1a = ".DropdownRow_module_row__4b41325c{align-items:center;cursor:default;display:flex;height:32px;outline:none;transition:background-color .125s cubic-bezier(.78,.14,.15,.86)}.DropdownRow_module_row__4b41325c.DropdownRow_module_selected__4b41325c{font-weight:700}.DropdownRow_module_row__4b41325c.DropdownRow_module_isLoaded__4b41325c.DropdownRow_module_active__4b41325c{background-color:#e3eafc}.DropdownRow_module_selectedSpacerCell__4b41325c{align-items:center;display:flex;min-height:28px;text-align:center;width:25px}.DropdownRow_module_selectedSpacerCell__4b41325c .DropdownRow_module_icon__4b41325c{position:relative;top:0}.DropdownRow_module_lockedIconFill__4b41325c{fill:#444750;stroke:\"none\"}";
window.ADS.injectStyle(css$1a,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/ComboboxDropdown/DropdownRow.module.scss");
var modules_bad5dfac = {"row":"DropdownRow_module_row__4b41325c","selected":"DropdownRow_module_selected__4b41325c","isLoaded":"DropdownRow_module_isLoaded__4b41325c","active":"DropdownRow_module_active__4b41325c","selectedSpacerCell":"DropdownRow_module_selectedSpacerCell__4b41325c","icon":"DropdownRow_module_icon__4b41325c","lockedIconFill":"DropdownRow_module_lockedIconFill__4b41325c"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const DropdownRow = ({ row, columnConfig, isSelected = false, isActive = false, multiSelect = false, isLocked = false, onClick, onMouseOver }) => {
    const rowRef = React__default.useRef(null);
    const clickHandler = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick(row);
        }
    };
    // Make sure if this row is active, that it is visible by scrolling
    // it into view
    React__default.useEffect(() => {
        if (isActive) {
            ScrollIntoView(rowRef.current);
        }
    }, [isActive, rowRef]);
    return (React__default.createElement("div", { ref: rowRef, "data-test": "dropdown-row", "data-index": row.index, className: cx$1S(modules_bad5dfac.row, isActive && modules_bad5dfac.active, isSelected && modules_bad5dfac.selected, row.data && modules_bad5dfac.isLoaded), tabIndex: 0, onClick: clickHandler, onMouseOver: () => onMouseOver && onMouseOver(row) },
        multiSelect && (React__default.createElement("div", { className: modules_bad5dfac.selectedSpacerCell }, isSelected && (React__default.createElement(Icon, { icon: isLocked ? 'LockIcon' : 'CheckmarkIcon', size: isLocked ? 16 : undefined, className: modules_bad5dfac.icon, fillClass: isLocked ? modules_bad5dfac.lockedIconFill : undefined })))), columnConfig === null || columnConfig === void 0 ? void 0 :
        columnConfig.columns.map((col, i) => {
            var _a;
            const cell = (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.cells[`${i}`];
            return row.data && cell ? (React__default.createElement(DropdownCell, { key: cell.id, cell: cell, width: col.width, isLocked: isLocked, isSelected: isSelected })) : (React__default.createElement("div", { key: `${row.index}-${i}`, style: { padding: '4px 6px', width: '100%' } },
                React__default.createElement(SkeletonLoader, { height: 20 })));
        })));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1k = BindStyles(modules_a19b411f);
const NUMVISIBLEROWS = 8;
const ROWHEIGHT = 32;
const ComboboxDropdown = React__default.forwardRef(({ open, anchorEl, activeRowIndex, onAnimationEnd, onAnimationStart, rows, isLoading, columnConfig, onColumnClick, multiSelect, lockedItems, onSelection, valueRows, onEmptyRow, onCustomValueClicked, customValueActive, footerLinkActive, footerLinkConfig, noResultsText, customValueDisabled, onRowHover, maxWidth, testId }, ref) => {
    const { t } = useTranslation();
    const [hasVerticalScrollBar, setHasVerticalScrollBar] = React__default.useState(false);
    const [drawerWidth, setDrawerWidth] = React__default.useState('auto');
    const [windowListEl, setWindowListEl] = React__default.useState(null);
    const rowIndexTransition = React__default.useRef(-1);
    const shouldRenderColumns = columnConfig &&
        columnConfig.mode !== ColumnMode.Single &&
        columnConfig.columns;
    const columns = (columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.columns) || [];
    const virtualWindowHeight = Math.min(rows.length * ROWHEIGHT, NUMVISIBLEROWS * ROWHEIGHT);
    // In case there are a lot of rows to render, we don't want to render every
    // row, only those the user is viewing.
    const { virtualList } = useVirtualList({
        rows,
        windowListEl,
        windowHeight: virtualWindowHeight,
        itemHeight: ROWHEIGHT,
        bufferSize: 10
    });
    // We need our context to know what the scrollBarWidth is for this
    // user agent.
    const context = React__default.useContext(ADSContext);
    const windowElSize = useSize(windowListEl);
    const windowSize = useWindowSize();
    // Anytime our dropdown container changes size, we check if we have scrollbars
    // and check if and set the width. We do this so that rows that aren't in our
    // virtualList don't force a sudden width change. The dropdown renders with width: auto
    // at first, and then we use an inline style with to freeze it.
    React__default.useEffect(() => {
        var _a;
        // If we have a windowListEl we are in an open state and need to check some size
        // based things
        if (windowListEl) {
            // Make sure our scrollbar state is up to date
            const hasScrollBars = HasVerticalScrollBars(windowListEl);
            setHasVerticalScrollBar(hasScrollBars);
            // Freeze our width so we don't have a sudden width change. We start rendering with
            // auto, which is fine unless we have rows that aren't part of the virtualWindow
            // that then cause the width to push out to our set max width. To fix that
            // we freeze the width to whatever it is on page 1 of the virtual window.
            if (hasScrollBars && (windowElSize === null || windowElSize === void 0 ? void 0 : windowElSize.width) && drawerWidth === 'auto') {
                setDrawerWidth(windowElSize.width - ((_a = context === null || context === void 0 ? void 0 : context.env.scrollBarWidth) !== null && _a !== void 0 ? _a : 0));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [windowElSize]);
    React__default.useEffect(() => {
        // when viewport width changes, recalculate drawer width
        setDrawerWidth('auto');
    }, [windowSize]);
    const handleAnimationEnd = (newHeight) => {
        onAnimationEnd && onAnimationEnd(newHeight);
        // If the dropdown has just closed, reset the virtual list.
        // If the dropdown has just opened, do not reset it.
        if (newHeight === 0) {
            virtualList.reset();
        }
    };
    const onColumnClickHandler = (name, direction) => {
        virtualList.reset();
        if (onColumnClick) {
            onColumnClick(name, direction);
        }
    };
    // Dropdown placement configuration:
    // 1. Initially, the dropdown tries to position itself below the anchor element, aligned with the left edge.
    // 2. If there isn't enough space, it attempts to align with the right edge of the anchor.
    // 3. If that also fails, it centers the dropdown.
    // 4. When there's insufficient vertical space below the anchor, it places the dropdown above the anchor, following the same sequence as above.
    const placementConfig = {
        placement: 'bottom-start',
        fallbackPlacements: [
            'bottom-end',
            'bottom',
            'top-start',
            'top-end',
            'top'
        ]
    };
    const handleCustomValueClick = () => {
        if (!customValueDisabled && onCustomValueClicked) {
            onCustomValueClicked();
        }
    };
    const handleFooterLinkClick = () => {
        if ((footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) === true) {
            footerLinkConfig.onClick();
        }
    };
    const maxWidthStyle = React__default.useMemo(() => {
        var _a;
        if (!maxWidth)
            return undefined;
        // if maxWidth is provided, use the smaller of maxWidth of viewport width minus 32 px
        // to account for borders (2px), browser window vertical scrollbar(16px), the rest is a buffer
        const maxWidthValue = typeof maxWidth === 'number' ? maxWidth + 'px' : maxWidth;
        const widthBuffer = ((_a = context === null || context === void 0 ? void 0 : context.env.scrollBarWidth) !== null && _a !== void 0 ? _a : 16) + 16;
        return {
            maxWidth: `min(${maxWidthValue}, calc(100vw - ${widthBuffer}px))`
        };
    }, [context === null || context === void 0 ? void 0 : context.env.scrollBarWidth, maxWidth]);
    React__default.useEffect(() => {
        // handle scrolling the list when the active index is outside
        // the range of the virtual list.
        if (windowListEl &&
            activeRowIndex > 18 &&
            rowIndexTransition.current === -1) {
            windowListEl.scrollTop = activeRowIndex * ROWHEIGHT;
        }
        rowIndexTransition.current = activeRowIndex;
    }, [activeRowIndex, windowListEl]);
    return (React__default.createElement(Dropdown, { open: open, ref: ref, anchorEl: anchorEl, placementConfig: placementConfig, onAnimationEnd: handleAnimationEnd, onAnimationStart: onAnimationStart },
        React__default.createElement(DropdownContainer, { autoScroll: false },
            React__default.createElement("div", { className: cx$1k('dropdown'), style: maxWidthStyle },
                shouldRenderColumns && (React__default.createElement(DropdownColumns, { columns: columns, preSpace: multiSelect ? 25 : 0, postSpace: hasVerticalScrollBar ? context === null || context === void 0 ? void 0 : context.env.scrollBarWidth : 0, onClick: onColumnClickHandler })),
                React__default.createElement("div", { ref: setWindowListEl, className: cx$1k('rows'), style: {
                        maxHeight: 
                        // We have to subtract anything that might take up space within
                        // our dropdown container
                        NUMVISIBLEROWS * ROWHEIGHT -
                            (shouldRenderColumns ? 32 : 0) -
                            (onCustomValueClicked ? 32 : 0) -
                            (footerLinkConfig && footerLinkConfig.enabled ? 32 : 0)
                    } },
                    isLoading && (React__default.createElement("div", { className: cx$1k('noResults') }, t('LOADING'))),
                    !isLoading && rows.length < 1 && (React__default.createElement("div", { className: cx$1k('noResults') }, noResultsText !== null && noResultsText !== void 0 ? noResultsText : t('NO_ITEMS_FOUND'))),
                    !isLoading && virtualList.rows && (React__default.createElement("div", { className: cx$1k({
                            listContainer: (onCustomValueClicked || (footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled)) &&
                                rows.length
                        }), style: Object.assign(Object.assign({}, virtualList.listStyle), { width: drawerWidth }) }, virtualList.rows.map((row) => {
                        var _a;
                        if (!row.data) {
                            onEmptyRow(row.index);
                        }
                        const isLocked = ((_a = row.data) === null || _a === void 0 ? void 0 : _a.id)
                            ? lockedItems === null || lockedItems === void 0 ? void 0 : lockedItems.has(row.data.id)
                            : false;
                        return (React__default.createElement(DropdownRow, { key: row.index, isActive: activeRowIndex === row.index && !isLocked, row: row, isSelected: valueRows.some((v) => { var _a, _b; return ((_a = v.data) === null || _a === void 0 ? void 0 : _a.id) === ((_b = row.data) === null || _b === void 0 ? void 0 : _b.id); }), multiSelect: multiSelect, isLocked: isLocked, columnConfig: columnConfig, onClick: onSelection, onMouseOver: onRowHover }));
                    }))))),
            onCustomValueClicked && (React__default.createElement("div", { className: cx$1k('customValueBox', {
                    disabled: customValueDisabled,
                    lastRow: !(footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled)
                }), onClick: handleCustomValueClick, tabIndex: -1, "data-test": TestIdUtils.composeId(testId, 'custom-value-box') },
                React__default.createElement("div", { onMouseOver: () => {
                        onRowHover &&
                            onRowHover({
                                index: virtualList.rows.length,
                                data: {}
                            });
                    }, className: cx$1k('customValueButton', !customValueDisabled && customValueActive && 'active'), "data-test": TestIdUtils.composeId(testId, 'custom-value-button') }, t('USE_CUSTOM_VALUE')))),
            (footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) === true && (React__default.createElement("div", { className: cx$1k('footerLinkBox'), onClick: handleFooterLinkClick, tabIndex: -1 },
                React__default.createElement("div", { "data-test": TestIdUtils.composeId(testId, 'footer-link'), onMouseOver: () => {
                        onRowHover &&
                            onRowHover({
                                index: virtualList.rows.length,
                                data: {}
                            });
                    }, className: cx$1k('footerLinkButton', footerLinkActive && 'active') }, (footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) === true && footerLinkConfig.label))))));
});
ComboboxDropdown.displayName = 'ComboboxDropdown';

function useComboboxMultiSelect(multiSelect) {
    return React__default.useMemo(() => {
        if (multiSelect === undefined || multiSelect === null) {
            return {
                lockedItems: [],
                multiSelectMode: 'disabled'
            };
        }
        if (typeof multiSelect === 'boolean') {
            return {
                lockedItems: [],
                multiSelectMode: multiSelect === true ? 'enabled' : 'disabled'
            };
        }
        return {
            //convert locked items to an array of strings
            lockedItems: multiSelect.locked.map(String),
            multiSelectMode: 'locked'
        };
    }, [multiSelect]);
}

var css$19 = ".SelectedItem_module_selectedItem__4dee75c1{background:#e3eafc;border-radius:4px;display:flex;height:22px;margin:4px 0 0 4px;max-width:100%;padding:0 0 0 8px}.SelectedItem_module_selectedItem__4dee75c1 .SelectedItem_module_text__4dee75c1{line-height:21px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.SelectedItem_module_selectedItem__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1{border-radius:0 3px 3px 0;cursor:pointer;font-size:19px;line-height:22px;margin:0 0 0 4px;pointer-events:none;pointer-events:all;text-align:center;width:24px}.SelectedItem_module_selectedItem__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1:hover{background-color:#c3d6fd}.SelectedItem_module_selectedItem__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1:active{background-color:#aabff8}.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_disabled__4dee75c1,.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_locked__4dee75c1,.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_readOnly__4dee75c1{background-color:#e5e6eb}.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_disabled__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1,.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_locked__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1,.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_readOnly__4dee75c1 .SelectedItem_module_deleteIcon__4dee75c1{color:#b0b4bf;cursor:default;pointer-events:none}.SelectedItem_module_selectedItem__4dee75c1.SelectedItem_module_locked__4dee75c1{padding-right:8px}.SelectedItem_module_tooltipWrapper__4dee75c1{display:inline}";
window.ADS.injectStyle(css$19,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Combobox/SelectedItem/SelectedItem.module.scss");
var modules_970c52d1 = {"selectedItem":"SelectedItem_module_selectedItem__4dee75c1","text":"SelectedItem_module_text__4dee75c1","deleteIcon":"SelectedItem_module_deleteIcon__4dee75c1","disabled":"SelectedItem_module_disabled__4dee75c1","readOnly":"SelectedItem_module_readOnly__4dee75c1","locked":"SelectedItem_module_locked__4dee75c1","tooltipWrapper":"SelectedItem_module_tooltipWrapper__4dee75c1"};

const cx$1j = classnames.bind(modules_970c52d1);
const SelectedItem = ({ onDelete, disabled, readOnly, locked = false, children }) => {
    const ref = React__default.useRef(null);
    const isTextTruncated = useTextTruncated(ref);
    const onDeleteHandler = (e) => {
        if (disabled || readOnly) {
            return;
        }
        e.stopPropagation();
        onDelete && onDelete();
    };
    return (React__default.createElement("div", { "data-test": "selectedItem", className: cx$1j('selectedItem', { disabled, readOnly, locked }) },
        React__default.createElement("div", { ref: ref, className: cx$1j('text') },
            React__default.createElement(Tooltip, { content: children, className: cx$1j('tooltipWrapper'), disabled: !isTextTruncated }, children)),
        !locked && (React__default.createElement("div", { "data-test": "selectItem-delete", className: cx$1j('deleteIcon'), onClick: onDeleteHandler }, "\u00D7"))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
function getItemId(item, idField, labelExtractor) {
    if (isNil$1(item)) {
        return null;
    }
    let id = IsObject(item) ? ExtractValue(item, idField) : item;
    if (isNil$1(id) && labelExtractor) {
        id = ExtractValue(item, labelExtractor);
    }
    if (isNil$1(id)) {
        console.error('getItemId - Not able to generate id for item.', item);
        return null;
    }
    return `${id}`;
}
function convertItemToRowData(item, pageIndex, columnConfig, itemsIdField) {
    // We will have placeholder rows that haven't been loaded yet. We can skip these for now.
    if (isNil$1(item) || !columnConfig) {
        return null;
    }
    const id = getItemId(item, itemsIdField, columnConfig.labelExtractor);
    // We loop through every column in order to pre compute the cell text for searching and tooltip,
    // along with the cell content.
    const cells = columnConfig.columns.reduce((cells, column, index) => {
        cells[`${index}`] = new SearchableCell(`${id}:${index}`, () => ExtractValue(item, column.cellRenderer || column.toValue || column.name));
        return cells;
    }, {});
    const labelValue = columnConfig.labelExtractor &&
        ExtractValue(item, columnConfig.labelExtractor);
    const label = !isNil$1(labelValue) ? `${labelValue}` : undefined;
    // Whatever we return here will make up the data portion of our DataRows objects. We keep the original
    // item so we can detect when it's selected. We precompute our cell values so we can search across them.
    return { id, pageIndex, item, cells, label };
}
function convertItemsToRowData(items, startIndex, columnConfig, itemsIdField) {
    return items.map((item, idx) => convertItemToRowData(item, startIndex + idx, columnConfig, itemsIdField));
}

const cx$1i = classnames.bind(modules_42e4e3a2);
const defaultFooterLinkConfig = {
    enabled: false
};
/**
 * IMPORTANT! If you add any new props to this object, make sure to update the `ComboboxBase`,
 * `Combobox`, and `ComboboxPaginated` components to use the new props. Otherwise, they will not show
 * up in the ArgsTable of Storybook
 */
const defaultComboboxBaseProps = {
    autoComplete: 'off',
    clearable: true,
    defaultLabel: '',
    disableAutoFill: false,
    footerLinkConfig: defaultFooterLinkConfig,
    itemsIdField: 'id',
    multiSelect: false,
    tabIndex: 0,
    width: '100%',
    /**
     * These props are intentionally not used in the default props of `Combobox` and `ComboboxPaginated` because this logic: https://gitlab.com/appliedsystems/enterprise/user-interface/applied-design-system/-/blob/106b86d754397f0371320ea766d773f419fa5be8/src/components/Field/withFieldSchemaSupport.tsx#L50-55
     * is explicitly checked for `undefined`. If we default these to `false`, it will break the existing functionality.
     */
    disabled: false,
    readOnly: false
};
// If we are part of a form, you can not set the value using the value prop.
// The value we get from the schema is what will be used.
const ComboboxSchema = (_a) => {
    var { defaultLabel, desired, error, inputRef, label, name, warning, onBlur, onChange } = _a, props = __rest(_a, ["defaultLabel", "desired", "error", "inputRef", "label", "name", "warning", "onBlur", "onChange"]);
    // We need to grab values and any validation errors from the schema's context.
    // We still let any value or error props values override form schema values.
    const { field, fieldState, showMessages } = useFieldController(name);
    // Desired is a weird concept in that the form / schema is still valid
    // but we want to show a validation error. So we handle that logic here.
    // If this is a desired field, has a empty value, does not currently have
    // an error and has been touched, set the error to the desired error text.
    if (desired && showMessages && IsFalseyOrEmpty(field.value)) {
        warning = `${label || defaultLabel} is desired`;
    }
    // If they have not passed in an error and the field has been touched or form
    // submitted and the form has an error, set the message here.
    if (!error && showMessages && fieldState.error) {
        error = fieldState.error.message;
    }
    const handleChange = (e) => {
        field.onChange(e);
        onChange && onChange(e);
    };
    const handleBlur = (e) => {
        e.target.name = name;
        field.onBlur();
        onBlur && onBlur(e);
    };
    // When Combobox is part of a Form schema, the schema's value for this field
    // set the value. The value prop on the Combobox will be overridden. If a user
    // needs to set this value they should do it through the schema.
    props.value = field.value;
    return (React__default.createElement(ComboboxBase, Object.assign({ name: name, label: label, defaultLabel: defaultLabel, error: error, onChange: handleChange, onBlur: handleBlur, desired: desired, warning: warning }, props, { inputRef: MergeRefs([inputRef, field.ref]) })));
};
function allowsCustomValue(searchTerm, searchTermHasMatch) {
    // must have a search term that doesn't match any existing option
    return Boolean(searchTerm) && !searchTermHasMatch;
}
/**
 * `ComboboxBase` is base combobox component. It is controlled and requires a ComboboxDataSource to be provided.
 */
const ComboboxBase = ({ appearError, autoComplete = defaultComboboxBaseProps.autoComplete, autoFocus, className, clearable = defaultComboboxBaseProps.clearable, columnConfig, customDataProps, defaultLabel = defaultComboboxBaseProps.defaultLabel, desired, disableAutoFill = defaultComboboxBaseProps.disableAutoFill, disabled = defaultComboboxBaseProps.disabled, dropdownMaxWidth, error, fieldClassName, footerLinkConfig = defaultComboboxBaseProps.footerLinkConfig, format, helpText, inputRef, itemsIdAsValue, itemsIdField = defaultComboboxBaseProps.itemsIdField, label, multiSelect = defaultComboboxBaseProps.multiSelect, name, noResultsText, placeholder, readOnly = defaultComboboxBaseProps.readOnly, required, tabIndex = defaultComboboxBaseProps.tabIndex, testId, value, warning, width = defaultComboboxBaseProps.width, dataSource, helpers, onBlur, onChange, onCustomValue, onFocus, onContextMenu }) => {
    var _a;
    // We always want our value to be an array of items
    if (!Array.isArray(value)) {
        value = [value];
    }
    value = value.filter((element) => !IsFalseyOrEmpty(element));
    const [inputValue, setInputValue] = React__default.useState('');
    const isMountedRef = useIsMountedRef();
    const containerRef = React__default.useRef(null);
    const internalInputRef = React__default.useRef(null);
    const afterNextOpen = React__default.useRef([]);
    const afterNextClose = React__default.useRef([]);
    const [searchTerm, setSearchTerm] = React__default.useState('');
    const [isLoading, setIsLoading] = React__default.useState(false);
    const [valueRows, setValueRows] = React__default.useState([]);
    const context = React__default.useContext(ADSContext);
    const { setBatchSize, setRowIndexInFlight, isRowIndexInFlight, clearInFlightRowIndex } = useFetchingDataBlock();
    const [columnSortState, setColumnSortState] = React__default.useState(null);
    // This hook manages getting data from a data source.
    // data gets prepped into whatever object fashion we want.
    const { getData, rows } = useDataSource(dataSource);
    const sendOnChange = React__default.useCallback((value) => {
        const newValue = itemsIdAsValue && itemsIdField && value ? value[itemsIdField] : value;
        const event = { target: { name, value: newValue } };
        onChange(event);
    }, [name, onChange, itemsIdAsValue, itemsIdField]);
    const { multiSelectMode, lockedItems } = useComboboxMultiSelect(multiSelect);
    const isMultiSelect = React__default.useMemo(() => multiSelectMode === 'enabled' || multiSelectMode === 'locked', [multiSelectMode]);
    // We need to make sure as our column sort state changes,
    // we mark the column being sorted as sorted so it can give a visual
    // indicator to the user (arrow up or down).
    const syncSortedColumn = React__default.useCallback(() => {
        if ((columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.columns) && columnSortState) {
            // We need to reset each column's sort state and update the
            // currently sorted column's sorted property.
            columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.columns.forEach((col) => {
                col.sorted =
                    col.name === columnSortState.column
                        ? columnSortState.direction
                        : undefined;
            });
        }
    }, [columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.columns, columnSortState]);
    // This will make sure our input field is synced to the selected value(s).
    const syncValueToInput = React__default.useCallback((valueRows) => {
        var _a;
        if (!isMountedRef.current) {
            return;
        }
        // Single select mode we need to find our selected row and use it's
        // label as our text value. In multi select mode we clear the input
        // field since we render selected values with pill items.
        let inputValue = '';
        if (!isMultiSelect && (valueRows === null || valueRows === void 0 ? void 0 : valueRows.length)) {
            const label = (_a = valueRows[0].data) === null || _a === void 0 ? void 0 : _a.label;
            if (label) {
                inputValue = label;
            }
        }
        setInputValue(inputValue);
        if (!inputValue) {
            setSearchTerm('');
        }
    }, [isMountedRef, isMultiSelect]);
    // Anytime our data source OR our column sort state OR searchTerm changes
    // we need to ask for data from our data source. If our dataSource changes,
    // it could mean a static version of Combobox got new items / props.
    React__default.useEffect(() => {
        if (!isMountedRef.current) {
            return;
        }
        setIsLoading(true);
        getData(0, columnSortState, searchTerm, false, (pagination) => {
            syncSortedColumn();
            // Given this is our first page of data, set the batch size
            // which we use to determine which rows of data are covered by a
            // request to load an empty row (we block duplicate requests).
            setBatchSize(pagination.end - pagination.start);
            setIsLoading(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getData, searchTerm, setIsLoading, columnSortState]);
    // Whenever we render an empty row, we need to fetch more data.
    const handleEmptyRow = React__default.useCallback((index) => {
        // Before we make a request for missing data, we need to check if
        // we are in flight for this piece of data. If so ignore it, if not
        // send it through.
        if (!isRowIndexInFlight(index)) {
            setRowIndexInFlight(index);
            getData(index, columnSortState, searchTerm, true, () => {
                clearInFlightRowIndex();
            });
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [columnSortState, searchTerm]);
    const searchTermHasMatch = !!(inputValue &&
        searchTerm &&
        rows &&
        rows.find((r) => searchTerm &&
            r &&
            r.data &&
            r.data.label &&
            `${r.data.label}`.toLocaleLowerCase() ===
                `${searchTerm}`.toLocaleLowerCase()));
    const customValueDisabled = !allowsCustomValue(searchTerm, searchTermHasMatch);
    const lastComboboxRowIndex = React__default.useMemo(() => {
        return rows === null || rows === void 0 ? void 0 : rows.reduce((maxIndex, n) => {
            return maxIndex < n.index ? n.index : maxIndex;
        }, -1);
    }, [rows]);
    const customValueIndex = React__default.useMemo(() => {
        // Custom Value is not enabled so we return null
        if (!onCustomValue) {
            return null;
        }
        // There are no rows so the Custom Value button is the first index
        if (lastComboboxRowIndex === undefined || lastComboboxRowIndex === -1) {
            return 0;
        }
        // The Custom Value button should be the first after our last row
        return lastComboboxRowIndex + 1;
    }, [lastComboboxRowIndex, onCustomValue]);
    const footerLinkIndex = React__default.useMemo(() => {
        // Footer Link is not enabled so we return null
        if (!(footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled)) {
            return null;
        }
        // Custom Value is enabled and the Footer Link is the next index
        if (customValueIndex !== null) {
            return customValueIndex + 1;
        }
        // There are no rows so the Footer Link button is the first index
        if (lastComboboxRowIndex === undefined || lastComboboxRowIndex === -1) {
            return 0;
        }
        // The Footer Link button should be the first after our last row
        return lastComboboxRowIndex + 1;
    }, [customValueIndex, footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled, lastComboboxRowIndex]);
    const lockedIndexes = React__default.useMemo(() => {
        // If we don't have any locked items, we don't have any locked indexes
        if (!isMultiSelect || lockedItems.length === 0) {
            return null;
        }
        return lockedItems.map((lockedId) => {
            const lockedRow = rows === null || rows === void 0 ? void 0 : rows.find((row) => { var _a; return ((_a = row.data) === null || _a === void 0 ? void 0 : _a.id) === lockedId; });
            return lockedRow === null || lockedRow === void 0 ? void 0 : lockedRow.index;
        });
    }, [isMultiSelect, lockedItems, rows]);
    const handleKeyEnter = (activeRowIndex) => {
        if (activeRowIndex === customValueIndex && onCustomValue) {
            handleCustomValueClick();
        }
        else if ((footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) &&
            activeRowIndex === footerLinkIndex) {
            handleFooterLinkClick();
        }
        else {
            if (!isLoading) {
                const dataRow = rows === null || rows === void 0 ? void 0 : rows.find((sr) => sr.index === activeRowIndex);
                if (dataRow)
                    handleSelection(dataRow);
            }
        }
    };
    const handleKeyTab = (activeRowIndex) => {
        if (!(context === null || context === void 0 ? void 0 : context.configuration.tabSelect))
            return;
        if (!isLoading) {
            const dataRow = rows === null || rows === void 0 ? void 0 : rows.find((row) => row.index === activeRowIndex);
            if (dataRow) {
                if (!value.includes(dataRow.data.item))
                    handleSelection(dataRow);
            }
        }
    };
    const setNewActiveRowIndex = (direction) => {
        if (!rows) {
            return;
        }
        const target = direction === 'next' ? 1 : -1;
        // setActiveRowIndex uses the indexes for the items from the full list
        // the search results will have gaps or contain items out of order.
        // The order in the search results array is what is displayed, but we
        // need to get the full list index to properly select them in the dropdown.
        let newIndex = rows.findIndex((sr) => sr.index === dropdown.activeRowIndex);
        /**
         * If we didn't find the active row index amongst the "normal" rows
         * check to see if it was the custom value or footer link row.
         */
        if (newIndex === -1) {
            if (dropdown.activeRowIndex === customValueIndex ||
                dropdown.activeRowIndex === footerLinkIndex) {
                newIndex = dropdown.activeRowIndex;
            }
        }
        // if we've found the active row, we need to move to the next or previous row
        if (newIndex !== -1) {
            newIndex += target;
        }
        else if (target === 1) {
            // If we didn't find the active row index and we are trying to go to the "next" row, we need to start somewhere so let's start at the first row
            newIndex = 0;
        }
        /**
         * If our new target would be the custom value row and it is disabled,
         * we need to skip it and go to the next row.
         */
        if (customValueDisabled && newIndex === customValueIndex) {
            newIndex += target;
        }
        // If our new target would be a locked row, we need to skip it and go to the next row.
        while (lockedIndexes === null || lockedIndexes === void 0 ? void 0 : lockedIndexes.includes(newIndex)) {
            newIndex += target;
        }
        // we should not be able to go up from the first item
        if (newIndex < 0) {
            return;
        }
        const maxIndex = Math.max(lastComboboxRowIndex !== null && lastComboboxRowIndex !== void 0 ? lastComboboxRowIndex : -1, customValueIndex !== null && customValueIndex !== void 0 ? customValueIndex : -1, footerLinkIndex !== null && footerLinkIndex !== void 0 ? footerLinkIndex : -1);
        // we should not be able to go down when we are on the last row
        if (newIndex > maxIndex) {
            return;
        }
        dropdown.setActiveRowIndex(newIndex);
    };
    const handleArrowUpKey = () => {
        if (dropdown.open && rows) {
            setNewActiveRowIndex('previous');
        }
    };
    const handleArrowDownKey = () => {
        if (!dropdown.open) {
            dropdown.setOpen(true);
            afterNextOpen.current.push(() => {
                setActiveToLastSelected();
            });
        }
        else {
            setNewActiveRowIndex('next');
        }
    };
    const handleFooterLinkClick = () => {
        if ((footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) === true) {
            footerLinkConfig.onClick();
            dropdown.setOpen(false);
        }
    };
    const { dropdown, dropdownAnchorRef, dropdownProps } = useDropdown({
        numberOfItems: (_a = rows === null || rows === void 0 ? void 0 : rows.length) !== null && _a !== void 0 ? _a : 0,
        onEnterKey: () => handleKeyEnter(dropdown.activeRowIndex),
        onArrowDownKey: handleArrowDownKey,
        onArrowUpKey: handleArrowUpKey,
        onTabKey: () => handleKeyTab(dropdown.activeRowIndex),
        keyboardEnabled: !readOnly && !disabled
    });
    const isRowSelected = (value, row) => {
        var _a;
        return (getItemId(value, itemsIdField, columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.labelExtractor) ===
            ((_a = row.data) === null || _a === void 0 ? void 0 : _a.id));
    };
    const itemIdsEqual = (value1, value2) => {
        return (getItemId(value1, itemsIdField, columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.labelExtractor) ===
            getItemId(value2, itemsIdField, columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.labelExtractor));
    };
    const getLastSelectedRow = React__default.useCallback(() => {
        const lastSelected = valueRows[valueRows.length - 1];
        return (rows &&
            rows.find((sr) => { var _a, _b; return ((_a = sr === null || sr === void 0 ? void 0 : sr.data) === null || _a === void 0 ? void 0 : _a.id) === ((_b = lastSelected === null || lastSelected === void 0 ? void 0 : lastSelected.data) === null || _b === void 0 ? void 0 : _b.id); }));
    }, [rows, valueRows]);
    // Handles updating the activeRowIndex to the last selected
    const setActiveToLastSelected = React__default.useCallback(() => {
        var _a;
        let activeRowIndex = 0;
        if (valueRows === null || valueRows === void 0 ? void 0 : valueRows.length) {
            const lastSelectedRow = getLastSelectedRow();
            // If we can't find the row that matches our valueRow, then our
            // items must have been swapped out and we should clear our current value
            if (lastSelectedRow) {
                activeRowIndex = (_a = lastSelectedRow.index) !== null && _a !== void 0 ? _a : 0;
            }
        }
        dropdown.setActiveRowIndex(activeRowIndex);
    }, [dropdown, getLastSelectedRow, valueRows === null || valueRows === void 0 ? void 0 : valueRows.length]);
    // We need to make sure we sync our input field's text if our value changes.
    // We have to use a stringified version of `value` here because value is an array
    // and often an array of objects which will be references and their reference targets
    // will change with every render.
    React__default.useEffect(() => {
        // Sometimes our value contains full row objects, and sometimes it's just
        // an object with an id field (looking at your project fusion). We need to be
        // able to handle both AND when if the row data gets loaded after we have our
        // value set, handle the difference in timing.
        var _a;
        // Our first strategy is to assume we have full row objects
        let vRows = value.map((item, index) => {
            return {
                index,
                data: convertItemToRowData(item, index, columnConfig, itemsIdField)
            };
        });
        // If our vRows is missing a label, then we didn't have full objects and need
        // to fallback to cloning the row objects that match the ids we have in value.
        if (rows && (vRows === null || vRows === void 0 ? void 0 : vRows.length) && !vRows[0].data.label) {
            const valueIds = vRows.map((v) => v.data.id);
            vRows = [];
            for (const row of rows) {
                if (valueIds.includes((_a = row.data) === null || _a === void 0 ? void 0 : _a.id)) {
                    vRows.push(Object.assign({}, row));
                }
            }
        }
        if (multiSelectMode === 'locked') {
            //reorder vRows to have locked items first
            vRows = orderLockedFirst(vRows, lockedItems);
        }
        setValueRows(vRows);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(value), rows]);
    React__default.useEffect(() => {
        if (!searchTerm) {
            syncValueToInput(valueRows);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(valueRows)]);
    // We need to watch column config for sort state. If any columns come in as sorted
    // we need to set it as sorted.
    React__default.useEffect(() => {
        const sortedColumn = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.columns.find((col) => col.sorted);
        if (sortedColumn && sortedColumn.sorted) {
            setColumnSortState({
                column: sortedColumn.name,
                direction: sortedColumn.sorted
            });
        }
    }, [columnConfig]);
    // If we are doing a search set activeRow to the first row
    // otherwise put it back to last selected value.
    React__default.useEffect(() => {
        if (searchTerm) {
            if (rows === null || rows === void 0 ? void 0 : rows.length) {
                dropdown.setActiveRowIndex(0);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rows, searchTerm]);
    const selectInputText = React__default.useCallback((openDropdown) => {
        var _a;
        if (openDropdown)
            dropdown.setOpen(true);
        (_a = internalInputRef === null || internalInputRef === void 0 ? void 0 : internalInputRef.current) === null || _a === void 0 ? void 0 : _a.select();
    }, [internalInputRef, dropdown]);
    const focusInput = (select = false) => {
        var _a;
        if (internalInputRef.current) {
            (_a = internalInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (select) {
                selectInputText();
            }
        }
    };
    // If they need combobox helpers expose the helpers object
    React__default.useEffect(() => {
        if (helpers) {
            helpers({
                selectInputText
            });
        }
    }, [helpers, selectInputText]);
    // Every time the dropdown is closed we need to clear out activeRowIndex
    React__default.useEffect(() => {
        if (!dropdown.open) {
            dropdown.setActiveRowIndex(-1);
        }
    }, [dropdown, dropdown.open]);
    const handleAnimationEnd = (newHeight) => {
        // If we are closing, run any calls we had queued up.
        if (newHeight === 0) {
            // Run this on every closing of dropdown after animation is done, in case
            // the input text was modified by the user.
            syncValueToInput(valueRows);
            // Clear any search term
            if (searchTerm) {
                setSearchTerm('');
            }
            while (afterNextClose.current.length > 0) {
                const cb = afterNextClose.current.pop();
                cb && cb();
            }
        }
        else {
            while (afterNextOpen.current.length > 0) {
                const cb = afterNextOpen.current.pop();
                cb && cb();
            }
        }
    };
    const openDropdown = () => {
        if (!isMountedRef.current || disabled) {
            return;
        }
        if (!dropdown.open) {
            dropdown.setOpen(true);
            afterNextOpen.current.push(() => {
                setActiveToLastSelected();
            });
        }
        focusInput();
    };
    const formatter = format
        ? typeof format === 'string'
            ? getFormatter(format)
            : format
        : null;
    // Callback that handles formatted value updates
    const formattedCallback = React__default.useCallback((e, userInitiatedChange) => {
        if (!isMountedRef.current)
            return;
        const formattedValue = e.target.value;
        if (userInitiatedChange) {
            dropdown.setOpen(true);
        }
        // Update both input value and search term to stay in sync
        setInputValue(formattedValue);
        setSearchTerm(formattedValue);
        // If we've deleted all of the text, we need to clear the selected row
        if (!formattedValue) {
            dropdown.setActiveRowIndex(-1);
        }
        // Handle clearing for single select mode
        if (!formattedValue && !isMultiSelect && clearable) {
            sendOnChange(null);
        }
    }, [isMountedRef, isMultiSelect, clearable, dropdown, sendOnChange]);
    const { formatWithCaretPosition } = useFormattedInput({
        name,
        value: inputValue,
        formatter,
        callback: formattedCallback
    });
    const inputChangeHandler = (e) => {
        if (!isMountedRef.current) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        formatWithCaretPosition(e);
    };
    // Removes the passed selected item when in multi-select mode
    const removeSelection = (item) => {
        sendOnChange(value.filter((selectedItem) => !itemIdsEqual(selectedItem, item)));
        focusInput();
    };
    const handleSelection = (row) => {
        // We need to focus the input and select text if we are in single select
        // mode AND are selecting an already selected row.
        var _a;
        focusInput(!isMultiSelect && isRowSelected(value[0], row));
        // Single select mode
        if (!isMultiSelect) {
            // Don't reprocess if selecting same item
            if (row.index === ((_a = getLastSelectedRow()) === null || _a === void 0 ? void 0 : _a.index)) {
                dropdown.setOpen(false);
                return;
            }
            // Queue updates for after dropdown closes
            afterNextClose.current.push(() => {
                // Update the form/parent with selected value
                sendOnChange(row.data.item);
                // Handle reselection cleanup if needed
                if (isRowSelected(value[0], row)) {
                    syncValueToInput(valueRows);
                }
            });
            dropdown.setOpen(false);
        }
        else {
            const canRowBeSelected = multiSelectMode !== 'locked' ||
                row.data.id === null ||
                !lockedItems.includes(row.data.id);
            // If the row is locked, do not allow it to be selected or unselected
            if (!canRowBeSelected) {
                return;
            }
            if (value.some((v) => isRowSelected(v, row))) {
                removeSelection(row.data.item);
            }
            else {
                sendOnChange(!value ? [row.data.item] : value.concat(row.data.item));
            }
        }
    };
    const onIconClickHandler = (e) => {
        e.stopPropagation();
        if (disabled || readOnly) {
            return;
        }
        if (!dropdown.open) {
            openDropdown();
        }
        else {
            dropdown.setOpen(false);
        }
    };
    // Handle when our input get focused
    const handleFocus = (e) => {
        // We want the text of our input to be selected when this gains focus.
        onFocus && onFocus(e);
    };
    // Handle when focus leaves this comp
    const handleBlur = (e) => {
        e.persist();
        OnFocusOutside(e, [containerRef.current, dropdown.el], () => {
            dropdown.blurred(e);
            onBlur && onBlur(e);
        });
    };
    const columnClickHandler = (columnName, direction) => {
        setColumnSortState({
            column: columnName,
            direction
        });
    };
    const onInputKeyDown = (e) => {
        if (readOnly || disabled) {
            return;
        }
        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
            return;
        }
        // In multi select if user is hitting backspace with no search delete last
        // selected
        if (['Backspace', 'ArrowDown'].includes(e.key) &&
            isMultiSelect &&
            !searchTerm &&
            valueRows.length > 0) {
            e.preventDefault();
            const lastSelectedItem = valueRows[valueRows.length - 1];
            // do not remove a locked item
            if (lastSelectedItem.data.id === null ||
                !lockedItems.includes(lastSelectedItem.data.id)) {
                removeSelection(lastSelectedItem.data.item);
            }
        }
    };
    const handleRowHover = (hoverRow) => {
        // We need to find the index this row is in the searchResults
        // and set that as the new activeIndex
        dropdown.setActiveRowIndex(hoverRow.index);
    };
    const handleCustomValueClick = () => {
        afterNextClose.current.push(() => {
            onCustomValue && onCustomValue(searchTerm.trim());
            setSearchTerm('');
        });
        dropdown.setOpen(false);
    };
    const placeholderText = isMultiSelect && (value === null || value === void 0 ? void 0 : value.length) > 0 ? undefined : placeholder;
    const currentLabel = label !== null && label !== void 0 ? label : defaultLabel;
    // If we are readOnly or disabled we can't also be required or desired
    if (readOnly || disabled) {
        required = false;
        desired = false;
        placeholder = '';
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, style: { width }, className: cx$1i('container', className), ref: containerRef, onBlur: handleBlur }),
        currentLabel && (React__default.createElement(Label, { forId: name, required: required, desired: desired, disabled: disabled, helpText: helpText }, currentLabel)),
        React__default.createElement("div", { ref: dropdownAnchorRef, "data-test": testId ? `${testId}-combobox-input-wrapper` : 'combobox-input-wrapper', className: cx$1i('inputWrapper', { disabled, readOnly, error: error || appearError, warning }, fieldClassName), onClick: () => !disabled && !readOnly && openDropdown(), onDoubleClick: () => focusInput(true), tabIndex: disabled ? undefined : -1, onContextMenu: onContextMenu },
            React__default.createElement("div", { "data-test": testId ? `${testId}-combobox-selections` : 'combobox-selections', className: cx$1i('selections') },
                value &&
                    isMultiSelect &&
                    valueRows.map((selectedItem) => {
                        var _a;
                        return (selectedItem.data && (React__default.createElement(SelectedItem, { key: selectedItem.data.id, readOnly: readOnly, locked: selectedItem.data.id !== null &&
                                lockedItems.includes(selectedItem.data.id), disabled: disabled, onDelete: () => removeSelection(selectedItem.data.item) }, (_a = selectedItem.data.label) !== null && _a !== void 0 ? _a : '')));
                    }),
                React__default.createElement("input", { type: "text", role: disableAutoFill ? 'presentation' : 'input', autoComplete: autoComplete, autoFocus: autoFocus, readOnly: readOnly, onFocus: handleFocus, placeholder: placeholderText, spellCheck: "false", tabIndex: tabIndex, name: name, ref: MergeRefs([inputRef, internalInputRef]), id: name, onKeyDown: onInputKeyDown, className: cx$1i('input'), disabled: disabled, size: (searchTerm || inputValue).length + 1, value: searchTerm || inputValue, onChange: inputChangeHandler })),
            React__default.createElement("div", { className: cx$1i('icon') },
                isLoading && (React__default.createElement(Icon, { testId: testId ? `${testId}-loading-icon` : 'loading-icon', icon: "SpinnerIcon", size: 18, disabled: disabled, strokeClass: cx$1i('spinnerIcon') })),
                !isLoading && (React__default.createElement(Icon, { testId: testId ? `${testId}-dropdown-icon` : 'dropdown-icon', icon: "ChevronIcon", size: 16, onClick: onIconClickHandler, fillClass: cx$1i({ disabledIcon: disabled || readOnly }), focused: dropdown.open })))),
        columnConfig && (React__default.createElement(ComboboxDropdown, Object.assign({}, dropdownProps, { testId: testId, activeRowIndex: dropdown.activeRowIndex, valueRows: valueRows, columnConfig: columnConfig, multiSelect: isMultiSelect, lockedItems: new Set(lockedItems), isLoading: !rows, rows: rows !== null && rows !== void 0 ? rows : [], onAnimationEnd: handleAnimationEnd, onColumnClick: columnClickHandler, onSelection: handleSelection, onEmptyRow: handleEmptyRow, noResultsText: noResultsText, customValueDisabled: customValueDisabled, onRowHover: handleRowHover, onCustomValueClicked: onCustomValue ? handleCustomValueClick : undefined, customValueActive: customValueIndex === dropdown.activeRowIndex, maxWidth: dropdownMaxWidth, footerLinkConfig: {
                enabled: (footerLinkConfig && footerLinkConfig.enabled) || false,
                onClick: handleFooterLinkClick,
                label: (footerLinkConfig &&
                    (footerLinkConfig === null || footerLinkConfig === void 0 ? void 0 : footerLinkConfig.enabled) === true &&
                    footerLinkConfig.label) ||
                    ''
            }, footerLinkActive: footerLinkIndex === dropdown.activeRowIndex }))),
        !disabled && !readOnly && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FieldMessage, { message: error }),
            React__default.createElement(FieldMessage, { message: warning, messageStyle: "warning" })))));
};
const ComboboxField = withFieldSchemaSupport$1(ComboboxBase, ComboboxSchema);
// locked items cannot be removed from the multiselect combobox
// and are always displayed on the left side of the combobox
function orderLockedFirst(rows, lockedItems) {
    const sortedItems = rows.sort((a, b) => {
        const aIsLocked = a.data.id !== null && lockedItems.includes(a.data.id);
        const bIsLocked = b.data.id !== null && lockedItems.includes(b.data.id);
        if (aIsLocked && !bIsLocked)
            return -1;
        if (!aIsLocked && bIsLocked)
            return 1;
        return 0;
    });
    return sortedItems;
}

// Depending on if we were given a value and onChange prop, we need to switch between
// being a controlled vs uncontrolled comp.
const ComboboxPaginatedBase = (_a) => {
    var { value, onChange } = _a, props = __rest(_a, ["value", "onChange"]);
    return onChange === undefined ? (React__default.createElement(UncontrolledCombobox, Object.assign({ value: value }, props))) : (React__default.createElement(ComboboxField, Object.assign({ value: value, onChange: onChange }, props)));
};
const ComboboxPaginated = (_a) => {
    var { autoComplete = defaultComboboxBaseProps.autoComplete, clearable = defaultComboboxBaseProps.clearable, columns, defaultLabel = defaultComboboxBaseProps.defaultLabel, disableAutoFill = defaultComboboxBaseProps.disableAutoFill, highlightSearchMatches = true, itemsIdField = defaultComboboxBaseProps.itemsIdField, multiSelect = defaultComboboxBaseProps.multiSelect, tabIndex = defaultComboboxBaseProps.tabIndex, width = defaultComboboxBaseProps.width, dataSource } = _a, props = __rest(_a, ["autoComplete", "clearable", "columns", "defaultLabel", "disableAutoFill", "highlightSearchMatches", "itemsIdField", "multiSelect", "tabIndex", "width", "dataSource"]);
    const columnConfig = useColumns(columns);
    // We need to convert all incoming rows of data to be our SearchableRows
    // which is what the base components expects.
    const paginatedDataSource = React__default.useCallback((_setItems, startIndex, sort, searchTerm) => {
        const setItems = (rawItems, pagination) => {
            // Convert all rows into Searchable rows
            const items = rawItems
                ? convertItemsToRowData(rawItems, startIndex, columnConfig, itemsIdField)
                : rawItems;
            if (items && highlightSearchMatches && searchTerm) {
                // In some cases we want to highlight the rows but not sort or filter the rows.
                // This is used in the DataGridPaginated case. This would probably be cleaner
                // if done in the DataGridPaginated component but would require some hoops to hijack
                // the setItems function of dataSource.
                const searchKeys = columnConfig.columns.map((_c, i) => `cells.${i}.text`);
                HighlightOnly(searchTerm, searchKeys, items);
            }
            _setItems(items, pagination);
        };
        dataSource(setItems, startIndex, sort, searchTerm);
    }, [columnConfig, dataSource, highlightSearchMatches, itemsIdField]);
    return (React__default.createElement(ComboboxPaginatedBase, Object.assign({ autoComplete: autoComplete, clearable: clearable, columnConfig: columnConfig, defaultLabel: defaultLabel, disableAutoFill: disableAutoFill, itemsIdField: itemsIdField, multiSelect: multiSelect, tabIndex: tabIndex, width: width, dataSource: paginatedDataSource }, props)));
};
// This is internal use only, but if we need to manage our own state, this
// will be used.
const UncontrolledCombobox = (props) => {
    var _a;
    const [value, setValue] = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : []);
    return (React__default.createElement(ComboboxField, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};

// A data source that never loads. Used for the loading-state of the `Combobox`
const LOADING_DATA_SOURCE = () => {
    new Promise(() => { });
};
function sortItems$1(items, columns, sort) {
    const sortColumn = columns.find((col) => col.name === sort.column);
    if (!sortColumn) {
        console.error('could not find sortColumn', sort.column, 'in', columns);
        return items;
    }
    // We have to make a copy of items before we sort it so React detects it's a
    // new version of items and it triggers a re-render.
    return [...items].sort((itemA, itemB) => {
        const extractor = sortColumn.sortValue && isFunction(sortColumn.sortValue)
            ? sortColumn.sortValue
            : (item) => ExtractValue(item.item, CellTextExtractor(sortColumn) || sortColumn.name);
        const valueA = extractor(itemA);
        const valueB = extractor(itemB);
        const direction = sort.direction === SortDirection.Asc ? 1 : -1;
        // Depending on data type compare the two values.
        return typeof valueA === 'number'
            ? (valueA - valueB) * direction
            : valueA.localeCompare(valueB) * direction;
    });
}
const Combobox = (_a) => {
    var { autoComplete = defaultComboboxBaseProps.autoComplete, clearable = defaultComboboxBaseProps.clearable, columns, defaultLabel = defaultComboboxBaseProps.defaultLabel, disableAutoFill = defaultComboboxBaseProps.disableAutoFill, items, itemsIdField = defaultComboboxBaseProps.itemsIdField, multiSelect = defaultComboboxBaseProps.multiSelect, tabIndex = defaultComboboxBaseProps.tabIndex, width = defaultComboboxBaseProps.width } = _a, props = __rest(_a, ["autoComplete", "clearable", "columns", "defaultLabel", "disableAutoFill", "items", "itemsIdField", "multiSelect", "tabIndex", "width"]);
    const dataSourceRef = React__default.useRef(null);
    const columnConfig = useColumns(columns);
    const setData = React__default.useCallback(() => {
        var _a, _b, _c;
        if (!(dataSourceRef === null || dataSourceRef === void 0 ? void 0 : dataSourceRef.current)) {
            return;
        }
        const { setItems, sort, searchTerm } = dataSourceRef.current;
        let newItems = items
            ? convertItemsToRowData(items, 0, columnConfig, itemsIdField)
            : items;
        if (searchTerm) {
            const searchKeys = columnConfig.columns
                .map((column, i) => column.isSearchable !== false ? `cells.${i}.text` : null)
                .filter((key) => key !== null); // Remove null values from array
            newItems = FuzzSearch(newItems, searchKeys, searchTerm, (_a = props.searchConfig) === null || _a === void 0 ? void 0 : _a.exactMatch);
        }
        if (sort && columns) {
            newItems = sortItems$1(newItems, columns, sort);
        }
        setItems(newItems, {
            total: (_b = newItems === null || newItems === void 0 ? void 0 : newItems.length) !== null && _b !== void 0 ? _b : 0,
            start: 0,
            end: (_c = newItems === null || newItems === void 0 ? void 0 : newItems.length) !== null && _c !== void 0 ? _c : 0
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);
    // Anytime items change, we push our items through the DataSource setItems function.
    // This will catch the case of items being set after the last request for data.
    React__default.useEffect(() => {
        setData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items]);
    const dataSource = React__default.useMemo(() => {
        // We store the args we get from a dataSource call, and anytime items change we
        // push them through the dataSource's setItems function.
        const dataSource_notLoading = (setItems, startIndex, sort, searchTerm) => {
            // We store setItems in case items change, we can push up the new items data.
            dataSourceRef.current = { setItems, startIndex, sort, searchTerm };
            // Need to set what items we have now. This will catch the case of items being set
            // before the dataSource is called, and any sorting or search requests.
            setData();
        };
        return items ? dataSource_notLoading : LOADING_DATA_SOURCE;
    }, [items, setData]);
    return (React__default.createElement(ComboboxPaginatedBase, Object.assign({ autoComplete: autoComplete, clearable: clearable, columnConfig: columnConfig, dataSource: dataSource, defaultLabel: defaultLabel, disableAutoFill: disableAutoFill, itemsIdField: itemsIdField, multiSelect: multiSelect, tabIndex: tabIndex, width: width }, props)));
};

// Higher order component that provides the base / generic template for every
// field component.
const withField = (FieldComponent, options = {
    labelId: (id) => `${id}`
}) => (_a) => {
    var { customDataProps, id, testId, name, label, defaultLabel, placeholder, disabled, onChange, className, onBlur, error, warning, readOnly, required, desired, value, helpText, hideLabel = false } = _a, props = __rest(_a, ["customDataProps", "id", "testId", "name", "label", "defaultLabel", "placeholder", "disabled", "onChange", "className", "onBlur", "error", "warning", "readOnly", "required", "desired", "value", "helpText", "hideLabel"]);
    id = id || name;
    const labelId = options.labelId(id);
    const handleChange = (e) => {
        e.persist && e.persist();
        onChange && onChange(e);
    };
    const handleBlur = (e) => {
        e.persist && e.persist();
        onBlur && onBlur(e);
    };
    const currentLabel = label || defaultLabel;
    // If we are readOnly or disabled we can't also be required or desired
    // note: placeholder was also hidden previously but is now shown again for readOnly fields.
    if (readOnly || disabled) {
        required = false;
        desired = false;
        if (disabled) {
            placeholder = '';
        }
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: className }),
        currentLabel && !hideLabel && (React__default.createElement(Label, { disabled: disabled, required: required, desired: desired, forId: labelId, helpText: helpText }, currentLabel)),
        React__default.createElement(FieldComponent, Object.assign({ id: id, testId: testId, name: name, placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, readOnly: readOnly, disabled: disabled, error: error, warning: warning, desired: desired, value: value, customDataProps: customDataProps }, props)),
        !disabled && !readOnly && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FieldMessage, { message: error }),
            React__default.createElement(FieldMessage, { message: warning, messageStyle: "warning" })))));
};

// withFieldSchema is a higher order component that wraps the passed in
// component. Pulling from the parent form schema context, it provides fallback
// values for certain props (like value and error).  It also taps into certain
// props like onChange and onBlur so the parent form is notified when the
// passed in component's value or touched status changes.
const withFieldSchema = (FieldComponent) => 
// eslint-disable-next-line react/display-name
(_a) => {
    var { name, error, label, onChange, onBlur, desired, warning } = _a, props = __rest(_a, ["name", "error", "label", "onChange", "onBlur", "desired", "warning"]);
    // We need to grab values and any validation errors from form context.
    // We still let any value or error props values override form values.
    const { field, fieldState, showMessages } = useFieldController(name);
    // Desired is a weird concept in that the form / schema is still valid
    // but we want to show a validation error. So we handle that logic here.
    // If this is a desired field, has a empty value, does not currently have
    // an error and has been touched, set the warning to the desired warning text.
    if (desired && showMessages && IsFalseyOrEmpty(field.value)) {
        warning = `${label} is desired`;
    }
    // If they have not passed in an error and the field has been touched or form
    // submitted and the form has an error, set the message here.
    if (!error && showMessages && fieldState.error) {
        error = fieldState.error.message;
    }
    const handleChange = (e) => {
        field.onChange(e.target.value);
        onChange && onChange(e);
    };
    const handleBlur = (e) => {
        field.onBlur();
        onBlur && onBlur(e);
    };
    return (React__default.createElement(FieldComponent, Object.assign({}, props, { inputRef: field.ref, name: name, label: label, value: field.value, error: error, onChange: handleChange, onBlur: handleBlur, desired: desired, warning: warning })));
};

var css$18 = ".TextField_module_wrapper__29f1920e{position:relative}.TextField_module_innerWrapper__29f1920e{background-color:#fff;background:#fff;border:1px solid #b0b4bf;border-radius:2px;color:#363840;cursor:text;font-size:14px;line-height:20px;min-height:32px;padding:0;position:relative;text-overflow:ellipsis;transition:all 275ms cubic-bezier(.25,.25,.25,1),background-color 0ms;z-index:10}.TextField_module_innerWrapper__29f1920e.TextField_module_error__29f1920e{border-color:#ea0a3b}.TextField_module_innerWrapper__29f1920e.TextField_module_warning__29f1920e{border-color:#f45110}.TextField_module_innerWrapper__29f1920e:hover{border-color:#365ef6}.TextField_module_innerWrapper__29f1920e.TextField_module_readOnly__29f1920e{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf;color:#363840}.TextField_module_innerWrapper__29f1920e.TextField_module_readOnly__29f1920e input{background-color:#f5f5f7;color:#b0b4bf;color:#363840}.TextField_module_innerWrapper__29f1920e.TextField_module_isLoading__29f1920e{background-color:#f1f4fd;border-color:#365ef6}.TextField_module_innerWrapper__29f1920e.TextField_module_isLoading__29f1920e input{background-color:#f1f4fd}.TextField_module_innerWrapper__29f1920e.TextField_module_focus__29f1920e,.TextField_module_innerWrapper__29f1920e:focus,.TextField_module_innerWrapper__29f1920e:focus-within{border-color:#365ef6!important;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.TextField_module_innerWrapper__29f1920e.TextField_module_focus__29f1920e.TextField_module_readOnly__29f1920e,.TextField_module_innerWrapper__29f1920e:focus-within.TextField_module_readOnly__29f1920e,.TextField_module_innerWrapper__29f1920e:focus.TextField_module_readOnly__29f1920e{border-color:#cbced7!important;box-shadow:none!important}.TextField_module_innerWrapper__29f1920e.TextField_module_disabled__29f1920e,.TextField_module_innerWrapper__29f1920e:disabled{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf}.TextField_module_innerWrapper__29f1920e.TextField_module_disabled__29f1920e input,.TextField_module_innerWrapper__29f1920e:disabled input{background-color:#f5f5f7;color:#b0b4bf}.TextField_module_input__29f1920e{border:none;border-radius:2px;font-size:14px;line-height:20px;margin:0;outline:none;padding:5px 8px;text-overflow:ellipsis;width:100%;z-index:1}.TextField_module_endingIcon__29f1920e{padding-right:32px}.TextField_module_startingIcon__29f1920e{padding-left:32px}.TextField_module_tightGroup__29f1920e{border-radius:0 2px 2px 0!important}.TextField_module_input__29f1920e.TextField_module_mimicPassword__29f1920e{-webkit-text-security:disc}";
window.ADS.injectStyle(css$18,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/TextField/TextField.module.scss");
var modules_555c3abf = {"wrapper":"TextField_module_wrapper__29f1920e","innerWrapper":"TextField_module_innerWrapper__29f1920e","error":"TextField_module_error__29f1920e","warning":"TextField_module_warning__29f1920e","readOnly":"TextField_module_readOnly__29f1920e","isLoading":"TextField_module_isLoading__29f1920e","focus":"TextField_module_focus__29f1920e","disabled":"TextField_module_disabled__29f1920e","input":"TextField_module_input__29f1920e","endingIcon":"TextField_module_endingIcon__29f1920e","startingIcon":"TextField_module_startingIcon__29f1920e","tightGroup":"TextField_module_tightGroup__29f1920e","mimicPassword":"TextField_module_mimicPassword__29f1920e"};

var css$17 = ".TextFieldIcon_module_iconWrapper__ace56211{border:1px solid #0000;height:32px;position:absolute;top:0;width:32px;z-index:20}.TextFieldIcon_module_iconWrapper__ace56211 svg,.TextFieldIcon_module_iconWrapper__ace56211 svg path{fill:#444750}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211{cursor:pointer;pointer-events:all}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:hover{background-color:#e3eafc;border-color:#365ef6}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:focus{border-color:#365ef6;box-shadow:0 0 0 3px #365ef64d;outline:none}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:active{background:#d5e1fb}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:active svg,.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:active svg path,.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:focus svg,.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:focus svg path,.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:hover svg,.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_clickable__ace56211:hover svg path{fill:#365ef6}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_nonClickable__ace56211{cursor:text}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_disabled__ace56211{cursor:default}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_disabled__ace56211 svg path{fill:#b0b4bf}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_SearchIcon__ace56211:not(.TextFieldIcon_module_clickable__ace56211):not(.TextFieldIcon_module_disabled__ace56211) svg path{fill:#6a6f82}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_start__ace56211{left:0}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_start__ace56211.TextFieldIcon_module_clickable__ace56211{border-radius:2px 0 0 2px}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_end__ace56211{right:0}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_end__ace56211.TextFieldIcon_module_clickable__ace56211{border-radius:0 2px 2px 0}.TextFieldIcon_module_iconWrapper__ace56211.TextFieldIcon_module_end__ace56211.TextFieldIcon_module_isLoading__ace56211 svg{stroke:#365ef6}";
window.ADS.injectStyle(css$17,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/TextField/TextFieldIcon.module.scss");
var modules_b3d20393 = {"iconWrapper":"TextFieldIcon_module_iconWrapper__ace56211","clickable":"TextFieldIcon_module_clickable__ace56211","nonClickable":"TextFieldIcon_module_nonClickable__ace56211","disabled":"TextFieldIcon_module_disabled__ace56211","SearchIcon":"TextFieldIcon_module_SearchIcon__ace56211","start":"TextFieldIcon_module_start__ace56211","end":"TextFieldIcon_module_end__ace56211","isLoading":"TextFieldIcon_module_isLoading__ace56211"};

const cx$1h = classnames.bind(modules_b3d20393);
const TextFieldIcon = ({ disabled, iconConfig, isLoading, readOnly, position, testId, handleBlur }) => {
    const formattedIconConfig = useStandardIconConfig({
        iconConfig,
        isLoading,
        position
    });
    const { isClickable, onClick, onKeyDown, tabIndex } = useClickableConditionalProps({
        disabled,
        iconConfig: formattedIconConfig,
        isLoading,
        readOnly
    });
    if (!formattedIconConfig) {
        return null;
    }
    return (React__default.createElement("div", { 
        // When in ADS 7, use this id instead. See issues.mdx.
        // id={`textInput-icon-${formattedIconConfig.name}`}
        id: (iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.name) ? `textInput-icon-${iconConfig.name}` : undefined, "data-test": TestIdUtils.composeId(testId, `${position}-icon-wrapper`), tabIndex: tabIndex, onKeyDown: onKeyDown, onBlur: handleBlur, className: cx$1h('iconWrapper', position, formattedIconConfig.cssWrapperClass, formattedIconConfig.name, {
            clickable: isClickable,
            disabled: disabled,
            isLoading,
            nonClickable: !isClickable
        }) },
        React__default.createElement(Icon, { icon: formattedIconConfig.name, size: 16, onClick: onClick, disabled: disabled, tooltip: formattedIconConfig.tooltip })));
};
/**
 * We want more contrast for Read Only mode.
 * Icon colors are applied via css classes using order of precedence.
 *
 * Note - "SearchIcon" still has a lighter color when not disabled and not clickable.
 */
const isIconClickable = (iconConfig, textFieldConfig) => {
    return (match([iconConfig, textFieldConfig])
        // if iconConfig is not defined OR onClick is not defined, return false
        .with([P.union(undefined, { onClick: P.optional(undefined) }), P.any], () => false)
        // if the TextField is disabled or loading, return false
        .with([P.any, P.union({ disabled: true }, { isLoading: true })], () => false)
        // if readOnly is true and readOnlyEnabled is not true, return false
        .with([{ readOnlyEnabled: P.optional(false) }, { readOnly: true }], () => false)
        .otherwise(() => true));
};
const useStandardIconConfig = ({ iconConfig, isLoading, position }) => {
    // if we are not in the end icon, we don't need to add any special cases
    if (position !== 'end') {
        return iconConfig;
    }
    // when we are the end icon, we want to show the spinner icon while loading
    if (isLoading) {
        return Object.assign(Object.assign({}, iconConfig), { name: 'SpinnerIcon' });
    }
    return iconConfig;
};
const useClickableConditionalProps = ({ disabled, iconConfig, isLoading, readOnly }) => {
    const isClickable = isIconClickable(iconConfig, {
        disabled,
        isLoading,
        readOnly
    });
    if (isClickable) {
        return {
            isClickable,
            tabIndex: 0,
            onClick: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.onClick,
            onKeyDown: iconConfig === null || iconConfig === void 0 ? void 0 : iconConfig.onKeyDown
        };
    }
    return {
        isClickable,
        tabIndex: -1,
        onClick: undefined,
        onKeyDown: undefined
    };
};

const cx$1g = classnames.bind(modules_555c3abf);
/**
 * `TextField` allows the user to enter free form text. It can act as a stand alone
 * component or be part of a `<Form>` with a validation schema.
 */
const TextFieldCore = ({ appearError, appearWarning, autoComplete = 'off', autoFocus = false, customDataProps, disableAutoFill = false, disabled, endIcon, error, format, inputClassName, inputRef, isLoading, labelledBy, maxLength, name, password, placeholder, readOnly, spellCheck = false, startIcon, style, tabIndex = 0, testId, textAlign = TextAlign.Left, tightGroup, value = '', warning, width = '100%', wrapperRef, onBlur, onChange, onDrop, onFocus, onKeyDown, onPaste, onContextMenu }) => {
    const innerWrapperRef = React__default.useRef(null);
    const formatter = format
        ? typeof format === 'string'
            ? getFormatter(format)
            : format
        : null;
    // eslint-disable-next-line no-constant-binary-expression, valid-typeof
    if (formatter && typeof formatter.pattern === undefined) {
        ADSError('FormattedTextField has invalid format prop. ', format);
    }
    if (typeof value !== 'string') {
        if (value === null || value !== undefined) {
            value = '';
        }
        else {
            ADSError(`TextField with name of ${name} was given an invalid value type of ${typeof value} and value of ${JSON.stringify(value)}.`);
        }
    }
    const localInputRef = React__default.useRef(null);
    const formattedCallback = React__default.useCallback((e) => {
        onChange && onChange(e);
    }, [onChange]);
    const { formatWithCaretPosition } = useFormattedInput({
        name,
        value,
        formatter,
        callback: formattedCallback
    });
    const handleChange = (e) => {
        e.persist && e.persist();
        // Because React re-renders the actual <input> element, the caret position
        // will often be reset to the end if the value is transformed / changed.
        // So the code below is to retain the relative caret position after the state
        // has been updated.
        formatWithCaretPosition(e);
    };
    const handleWrapperClick = () => {
        var _a;
        (_a = localInputRef === null || localInputRef === void 0 ? void 0 : localInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const handleBlur = (e) => {
        if (onBlur) {
            // Only fire onBlur if focus is leaving this TextField's outer wrapper.
            // If focus is lost to a clickable icon, we don't consider that blurring.
            OnFocusOutside(e, [innerWrapperRef === null || innerWrapperRef === void 0 ? void 0 : innerWrapperRef.current], () => {
                if (localInputRef === null || localInputRef === void 0 ? void 0 : localInputRef.current)
                    e.target = localInputRef === null || localInputRef === void 0 ? void 0 : localInputRef.current;
                onBlur(e);
            });
        }
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { onClick: handleWrapperClick, className: `${cx$1g('wrapper')} ${inputClassName}`, style: { width }, ref: MergeRefs([innerWrapperRef, wrapperRef]), "data-test": TestIdUtils.composeId(testId, 'textField-wrapper') }),
        React__default.createElement(TextFieldIcon, { disabled: disabled, iconConfig: startIcon, isLoading: isLoading, position: "start", readOnly: readOnly, testId: testId, handleBlur: handleBlur }),
        React__default.createElement("div", { className: cx$1g('innerWrapper', {
                error: error || appearError,
                warning: warning || appearWarning,
                disabled,
                readOnly,
                isLoading,
                tightGroup
            }) },
            React__default.createElement("input", { id: name, "aria-labelledby": labelledBy, role: disableAutoFill ? 'presentation' : 'input', ref: MergeRefs([localInputRef, inputRef]), autoFocus: autoFocus, autoComplete: autoComplete, className: cx$1g('input', {
                    endingIcon: endIcon === null || endIcon === void 0 ? void 0 : endIcon.name,
                    startingIcon: startIcon === null || startIcon === void 0 ? void 0 : startIcon.name,
                    mimicPassword: password && disableAutoFill
                }), disabled: isLoading || disabled, key: name, onKeyDown: onKeyDown, name: name, readOnly: readOnly, onChange: handleChange, onBlur: handleBlur, onFocus: onFocus, placeholder: placeholder, spellCheck: spellCheck, style: Object.assign({ textAlign: textAlign }, style), maxLength: maxLength, type: password && !disableAutoFill ? 'password' : 'text', value: value, tabIndex: tabIndex, onDrop: onDrop, onPaste: onPaste, onContextMenu: onContextMenu })),
        React__default.createElement(TextFieldIcon, { disabled: disabled, iconConfig: endIcon, isLoading: isLoading, position: "end", readOnly: readOnly, testId: testId, handleBlur: handleBlur })));
};
const TextFieldBase = withField(TextFieldCore);
// Version of component that is not controlled. Meaning it will
// keep it's own state. This is the version used if value
// and onChange is not used directly OR by a form. Maybe they are
// only grabbing the value on blur?
const UnControlledTextField = (props) => {
    const [value, setValue] = React__default.useState(props.value || '');
    return (React__default.createElement(TextFieldBase, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneTextField = withStandAlone(UnControlledTextField, TextFieldBase);
const TextFieldDefault = withFieldSchemaSupport$1(StandAloneTextField, withFieldSchema(TextFieldBase));
const TextField = React__default.forwardRef((props, ref) => {
    /*
     * Would have liked to memoize `MergeRefs`; but the references could be
     * callback functions, which could be different on each render.
     * [See](https://react.dev/reference/react-dom/components/common#ref-callback).
     */
    return (React__default.createElement(TextFieldDefault, Object.assign({}, props, { inputRef: MergeRefs([ref, props.inputRef]) })));
});
TextField.displayName = 'TextField';

const FIVE_DIGIT_ZIP_FORMATTER = { pattern: '00000' };
const AddressFieldName = (field, addressName, fieldNames) => {
    const customFieldName = fieldNames && fieldNames[field] && `${fieldNames[field]}`;
    return customFieldName !== null && customFieldName !== void 0 ? customFieldName : `${addressName}-${field}`;
};
const AddressFieldLabels = {
    [AddressFields.Street]: 'Street Address',
    [AddressFields.Address2]: 'Street Address - Line 2',
    [AddressFields.Address3]: 'Street Address - Line 3',
    [AddressFields.City]: 'City',
    [AddressFields.Country]: 'Country',
    [AddressFields.County]: 'County',
    [AddressFields.Province]: 'Province',
    [AddressFields.State]: 'State',
    [AddressFields.ZipCode]: 'Zip Code',
    [AddressFields.PostalCode]: 'Postal Code',
    [AddressFields.Verified]: 'Verified' // Won't be used to display for user
};
const StreetLine = React__default.forwardRef(({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, required, desired, onChange, helpText, onBlur, onFocus, label, defaultLabel, tabIndex, testId, maxLength, onContextMenu }, ref) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, ref: ref, name: AddressFieldName(AddressFields.Street, name, fieldNames), disabled: disabled, readOnly: readOnly, required: required, desired: desired, helpText: helpText, label: label, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.Street])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('STREET'), value: value.streetLine, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
});
StreetLine.displayName = 'StreetLine';
const StreetLine2 = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, testId, onChange, onBlur, helpText, onFocus, label, defaultLabel, maxLength, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.Address2, name, fieldNames), disabled: disabled, readOnly: readOnly, helpText: helpText, label: label, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.Address2])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('STREET2'), value: value.address2, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
};
const StreetLine3 = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, testId, onChange, helpText, onBlur, onFocus, label, defaultLabel, maxLength, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.Address3, name, fieldNames), disabled: disabled, readOnly: readOnly, helpText: helpText, label: label, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.Address3])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('STREET3'), value: value.address3, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
};
const StreetLine4 = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, testId, onChange, helpText, onBlur, onFocus, label, defaultLabel, maxLength, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.Address4, name, fieldNames), disabled: disabled, readOnly: readOnly, helpText: helpText, label: label, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.Address4])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('STREET4'), value: value.address4, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
};
const City = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, onChange, onBlur, onFocus, helpText, label, defaultLabel, testId, maxLength, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.City, name, fieldNames), disabled: disabled, readOnly: readOnly, label: label, helpText: helpText, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.City])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('CITY'), value: value.city, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
};
const State = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, testId, onChange, onBlur, onFocus, helpText, label, defaultLabel, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    const stateCols = React__default.useMemo(() => {
        return [
            { name: 'code', title: t('CODE'), width: 80 },
            { name: 'name', title: t('NAME') }
        ];
    }, [t]);
    return (React__default.createElement(Combobox, { testId: testId, disabled: disabled, readOnly: readOnly, label: label, helpText: helpText, name: AddressFieldName(AddressFields.State, name, fieldNames), defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.City])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('STATE'), columns: stateCols, items: USStatesFull, itemsIdAsValue: true, itemsIdField: "code", value: value.state, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill }));
};
const ZipCode = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, testId, onChange, onBlur, onFocus, helpText, label, zipPlus4 = true, onContextMenu }) => {
    var _a;
    const zipFormat = zipPlus4
        ? TextFieldFormats.ZIPCODE // Allows 5 + 4 digits (e.g., "12345-6789")
        : FIVE_DIGIT_ZIP_FORMATTER; // Restrict to only 5 digits (e.g., "12345")
    return (React__default.createElement(TextField, { testId: testId, format: zipFormat, disabled: disabled, readOnly: readOnly, label: label, helpText: helpText, name: AddressFieldName(AddressFields.ZipCode, name, fieldNames), defaultLabel: (_a = (defaultLabels && defaultLabels[AddressFields.ZipCode])) !== null && _a !== void 0 ? _a : AddressFieldLabels[AddressFields.ZipCode], value: value.zipCode, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill }));
};
const PostalCode = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, testId, onChange, onBlur, helpText, label, onFocus, defaultLabel, format, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.PostalCode, name, fieldNames), disabled: disabled, readOnly: readOnly, helpText: helpText, label: label, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.PostalCode])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('POSTAL'), value: value.postalCode, onBlur: onBlur, onChange: onChange, format: format, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex }));
};
const County = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, testId, onChange, onBlur, helpText, onFocus, label, defaultLabel, maxLength, onContextMenu }) => {
    var _a, _b;
    const { t } = useTranslation();
    return (React__default.createElement(TextField, { testId: testId, name: AddressFieldName(AddressFields.County, name, fieldNames), disabled: disabled, readOnly: readOnly, label: label, helpText: helpText, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.County])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('COUNTY'), value: value.county, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex, maxLength: maxLength }));
};
const Country = ({ name, fieldNames, defaultLabels, disableAutoFill, value, disabled, readOnly, tabIndex, onChange, helpText, onBlur, onFocus, label, testId, defaultLabel, onContextMenu }) => {
    var _a, _b;
    const [countryList, setCountryList] = React__default.useState([]);
    const { t } = useTranslation();
    const context = React__default.useContext(ADSContext);
    React__default.useEffect(() => {
        var _a;
        const getCountryNames = () => CountryData.map((a) => t(`COUNTRY_${a.code}`)).sort((a, b) => a.localeCompare(b));
        if (context && context.i18next) {
            if ((_a = context === null || context === void 0 ? void 0 : context.i18next) === null || _a === void 0 ? void 0 : _a.isInitialized) {
                setCountryList(getCountryNames());
            }
            context === null || context === void 0 ? void 0 : context.i18next.on('languageChanged', () => {
                setCountryList(getCountryNames());
            });
        }
    }, [context, context === null || context === void 0 ? void 0 : context.i18next, t]);
    return (React__default.createElement(Combobox, { testId: testId, name: AddressFieldName(AddressFields.Country, name, fieldNames), disabled: disabled, readOnly: readOnly, label: label, helpText: helpText, defaultLabel: (_b = (_a = (defaultLabels && defaultLabels[AddressFields.Country])) !== null && _a !== void 0 ? _a : defaultLabel) !== null && _b !== void 0 ? _b : t('COUNTRY'), items: countryList, value: value.country, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onContextMenu: onContextMenu, disableAutoFill: disableAutoFill, tabIndex: tabIndex }));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Custom hook for throttling a function.
 *
 * In functional components, we can't just use lodash's throttle directly on the function we want to throttle,
 * because a new throttled version of the function would be created on every render, defeating the purpose of throttling.
 *
 * Instead, we use a ref to hold the throttled version of the function. This ensures that the same throttled function
 * is used across re-renders. We also use an effect to cancel any pending executions of the throttled function when the
 * component is unmounted, to prevent memory leaks and potential errors.
 */
function useThrottledFunction(fn, delay) {
    const throttledFnRef = React__default.useRef(throttle$1(fn, delay));
    React__default.useEffect(() => {
        const throttledFn = throttledFnRef.current;
        return () => {
            throttledFn.cancel();
        };
    }, []);
    const throttledFn = React__default.useCallback((...args) => {
        throttledFnRef.current(...args);
    }, []);
    return throttledFn;
}

var css$16 = ".SuggestionField_module_suggestionField__8c5eaf76{position:relative}.SuggestionField_module_error__8c5eaf76{border-color:#ea0a3b}.SuggestionField_module_warning__8c5eaf76{border-color:#f45110}.SuggestionField_module_readOnlyIcon__8c5eaf76 path{fill:#b0b4bf}";
window.ADS.injectStyle(css$16,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/SuggestionField/SuggestionField.module.scss");
var modules_6addb0d0 = {"suggestionField":"SuggestionField_module_suggestionField__8c5eaf76","error":"SuggestionField_module_error__8c5eaf76","warning":"SuggestionField_module_warning__8c5eaf76","readOnlyIcon":"SuggestionField_module_readOnlyIcon__8c5eaf76"};

var css$15 = ".SuggestionFieldResults_module_noResults__d8e3be64{color:#585c6a;font-style:italic;padding:15px;text-align:center}.SuggestionFieldResults_module_result__d8e3be64{cursor:pointer;display:flex;outline:none;padding:6px}.SuggestionFieldResults_module_result__d8e3be64.SuggestionFieldResults_module_badgeExists__d8e3be64 .SuggestionFieldResults_module_label__d8e3be64{margin-right:8px}.SuggestionFieldResults_module_result__d8e3be64.SuggestionFieldResults_module_active__d8e3be64,.SuggestionFieldResults_module_result__d8e3be64:hover{background:#e3eafc}.SuggestionFieldResults_module_label__d8e3be64{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.SuggestionFieldResults_module_badge__d8e3be64{margin-right:8px}.SuggestionFieldResults_module_badge__d8e3be64:last-child{margin-right:0}";
window.ADS.injectStyle(css$15,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/SuggestionField/SuggestionFieldResults/SuggestionFieldResults.module.scss");
var modules_0dfbbf13 = {"noResults":"SuggestionFieldResults_module_noResults__d8e3be64","result":"SuggestionFieldResults_module_result__d8e3be64","badgeExists":"SuggestionFieldResults_module_badgeExists__d8e3be64","label":"SuggestionFieldResults_module_label__d8e3be64","active":"SuggestionFieldResults_module_active__d8e3be64","badge":"SuggestionFieldResults_module_badge__d8e3be64"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1f = BindStyles(modules_0dfbbf13);
const SuggestionFieldResults = ({ results = [], activeRowIndex, noResultsText = 'No results found', onSelection, onRowHover }) => {
    const renderNoResults = () => (React__default.createElement("div", { className: modules_0dfbbf13.noResults }, noResultsText));
    const renderResults = () => {
        return results.map((result) => (React__default.createElement("div", { key: result.index, tabIndex: 0, "data-test": "dropdown-row", className: cx$1f('result', {
                active: result.index === activeRowIndex,
                badgeExists: result.badges && result.badges.length > 0
            }), onClick: () => {
                onSelection && onSelection(result.index);
            }, onMouseEnter: () => onRowHover && onRowHover(result.index) },
            React__default.createElement("div", { className: modules_0dfbbf13.label }, result.label),
            result.badges && result.badges.length > 0
                ? result.badges.map((badge, index) => (React__default.createElement("div", { key: index, className: cx$1f('badge') },
                    React__default.createElement(Badge, { size: "xxs", icon: badge.icon || 'NoIcon', type: badge.type || BadgeType.Default, shape: BadgeShape.Pill }, badge.text))))
                : null)));
    };
    return (React__default.createElement("div", { className: cx$1f('p-1') }, results.length < 1 ? renderNoResults() : renderResults()));
};

const cx$1e = BindStyles(modules_6addb0d0);
const SuggestionFieldBase = ({ customDataProps, autoComplete, autoFocus, className, defaultLabel, desired, disableAutoFill, disabled, error, helpText, inputRef, isLoading, items, label, name, noResultsText, placeholder, readOnly, required, testId, value, warning, width, toLabel = 'name', onBlur, onChange, onFocus, onSelection, onClear, onContextMenu, maxLength }) => {
    const context = React__default.useContext(ADSContext);
    const { t } = useTranslation();
    const dropdownContainerRef = React__default.useRef(null);
    const textFieldInputRef = React__default.useRef(null);
    const results = React__default.useMemo(() => items &&
        items.map((item, index) => ({
            item,
            label: isString(item) ? item : ExtractValue(item, toLabel),
            selectable: item.isSelectable === false ? false : true,
            badges: item.badges,
            index
        })), [items, toLabel]);
    const handleSelection = (index, dropdown, fromTabSelect) => {
        var _a;
        if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id.includes('CloseIcon')) && !fromTabSelect) {
            clear();
        }
        else {
            const selectedResult = results[index];
            if (selectedResult) {
                if (selectedResult.selectable)
                    dropdown.setOpen(false);
                onSelection && onSelection(selectedResult.item);
            }
        }
    };
    const { dropdown, dropdownProps, dropdownAnchorRef } = useDropdown({
        numberOfItems: (items === null || items === void 0 ? void 0 : items.length) || 0,
        keyboardEnabled: !(disabled || readOnly),
        onEnterKey: () => handleSelection(dropdown.activeRowIndex, dropdown, false),
        onTabKey: () => {
            if (context === null || context === void 0 ? void 0 : context.configuration.tabSelect)
                handleSelection(dropdown.activeRowIndex, dropdown, true);
        }
    });
    const onChangeHandler = React__default.useCallback((e) => {
        if (!dropdown.open) {
            dropdown.setOpen(true);
        }
        onChange && onChange(e);
    }, [dropdown, onChange]);
    const handleBlur = (e) => {
        onBlur && onBlur({ target: { name, value } });
        dropdown.blurred(e);
    };
    const handleTextFieldFocused = (e) => {
        if (disabled) {
            return;
        }
        onFocus && onFocus(e);
        if (!readOnly && !(context === null || context === void 0 ? void 0 : context.configuration.tabSelect) && value) {
            dropdown.setOpen(true);
        }
    };
    const clear = React__default.useCallback(() => {
        var _a;
        onChangeHandler({
            target: { name, value: '' }
        });
        onClear && onClear();
        (_a = textFieldInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [onChangeHandler, onClear, name, textFieldInputRef]);
    // Any time results change we should reset our active index.
    React__default.useEffect(() => {
        const el = dropdownContainerRef.current;
        if (el) {
            el.scrollTop = 0;
        }
    }, [results, dropdownContainerRef]);
    // When hovering over a row, update the active index
    const handleRowHover = (index) => {
        dropdown.setActiveRowIndex(index);
    };
    const currentLabel = label || defaultLabel;
    const closeIcon = React__default.useMemo(() => ({
        name: 'SmCloseIcon',
        onClick: clear
    }), [clear]);
    if (readOnly || disabled) {
        required = false;
        desired = false;
        placeholder = '';
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$1e('suggestionField', className), onBlur: handleBlur, style: { width } }),
        currentLabel && (React__default.createElement(Label, { required: required, desired: desired, disabled: disabled, forId: name, helpText: helpText }, currentLabel)),
        React__default.createElement("div", { ref: dropdownAnchorRef },
            React__default.createElement(TextFieldCore, { inputRef: MergeRefs([textFieldInputRef, inputRef]), className: className, autoComplete: autoComplete, autoFocus: autoFocus, disableAutoFill: disableAutoFill, disabled: disabled, error: error, startIcon: {
                    name: 'SearchIcon',
                    cssWrapperClass: cx$1e({ readOnlyIcon: readOnly })
                }, endIcon: !readOnly && !disabled && value ? closeIcon : undefined, isLoading: isLoading, name: name, onChange: onChangeHandler, onFocus: handleTextFieldFocused, placeholder: placeholder || t('SEARCH'), readOnly: readOnly, value: value, warning: warning, maxLength: maxLength, onContextMenu: onContextMenu })),
        React__default.createElement(FieldMessage, { message: error }),
        React__default.createElement(FieldMessage, { message: warning, messageStyle: "warning" }),
        React__default.createElement(Dropdown, Object.assign({}, dropdownProps),
            React__default.createElement(DropdownContainer, { ref: dropdownContainerRef },
                React__default.createElement(SuggestionFieldResults, { results: results, noResultsText: noResultsText, activeRowIndex: dropdown.activeRowIndex, onSelection: (index) => handleSelection(index, dropdown, false), onRowHover: handleRowHover })))));
};
const SuggestionFieldSchema = (_a) => {
    var { desired, error, label, name, warning, onChange, onBlur } = _a, props = __rest(_a, ["desired", "error", "label", "name", "warning", "onChange", "onBlur"]);
    // We need to grab values and any validation errors from Formik's context.
    // We still let any value or error props values override Formik's values.
    const { field, fieldState, showMessages } = useFieldController(name);
    // Desired is a weird concept in that the form / schema is still valid
    // but we want to show a validation error. So we handle that logic here.
    // If this is a desired field, has a empty value, does not currently have
    // an error and has been touched, set the error to the desired error text.
    if (desired && showMessages && IsFalseyOrEmpty(field.value)) {
        warning = `${label} is desired`;
    }
    // If they have not passed in an error and the field has been touched or form
    // submitted and the form has an error, set the message here.
    if (!error && showMessages && fieldState.error) {
        error = fieldState.error.message;
    }
    const handleChange = (e) => {
        field.onChange(e);
        onChange && onChange(e);
    };
    const handleBlur = (e) => {
        e.persist && e.persist();
        e.target.name = name;
        field.onBlur();
        onBlur && onBlur(e);
    };
    // When we are part of a Form schema, the schema's value for this field
    // set the value.
    props.value = field.value;
    return (React__default.createElement(SuggestionFieldBase, Object.assign({ name: name, label: label, error: error, onChange: handleChange, onBlur: handleBlur, desired: desired, warning: warning }, props, { inputRef: MergeRefs([field.ref, props.inputRef]) })));
};
const UncontrolledSuggestionField = (props) => {
    const [value, setValue] = React__default.useState(props.value || '');
    const handleOnSelection = (selectionText) => {
        setValue(selectionText);
    };
    const handleChange = (e) => {
        setValue(e.target.value);
    };
    return (React__default.createElement(SuggestionFieldBase, Object.assign({}, props, { value: value, onChange: handleChange, onSelection: handleOnSelection })));
};
const StandaloneSuggestionField = (props) => {
    return props.onChange !== undefined && props.onSelection !== undefined ? (React__default.createElement(SuggestionFieldBase, Object.assign({}, props))) : (React__default.createElement(UncontrolledSuggestionField, Object.assign({}, props)));
};
const SuggestionFieldDefault = withFieldSchemaSupport$1(StandaloneSuggestionField, SuggestionFieldSchema);
const SuggestionField = React__default.forwardRef((props, ref) => {
    /*
     * Would have liked to memoize `MergeRefs`; but the references could be
     * callback functions, which could be different on each render.
     * [See](https://react.dev/reference/react-dom/components/common#ref-callback).
     */
    return (React__default.createElement(SuggestionFieldDefault, Object.assign({}, props, { inputRef: MergeRefs([ref, props.inputRef]) })));
});
SuggestionField.displayName = 'SuggestionField';

var css$14 = ".Address_module_input__88f76705{background-color:#fff;background:#fff;border:1px solid #b0b4bf;border-radius:2px;color:#363840;cursor:text;font-size:14px;line-height:20px;padding:5px 8px;position:relative;text-overflow:ellipsis;transition:all 275ms cubic-bezier(.25,.25,.25,1),background-color 0ms;z-index:10}.Address_module_input__88f76705.Address_module_error__88f76705{border-color:#ea0a3b}.Address_module_input__88f76705.Address_module_warning__88f76705{border-color:#f45110}.Address_module_input__88f76705:hover{border-color:#365ef6}.Address_module_input__88f76705.Address_module_readOnly__88f76705{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf;color:#363840}.Address_module_input__88f76705.Address_module_readOnly__88f76705 input{background-color:#f5f5f7;color:#b0b4bf;color:#363840}.Address_module_input__88f76705.Address_module_isLoading__88f76705{background-color:#f1f4fd;border-color:#365ef6}.Address_module_input__88f76705.Address_module_isLoading__88f76705 input{background-color:#f1f4fd}.Address_module_input__88f76705.Address_module_focus__88f76705,.Address_module_input__88f76705:focus,.Address_module_input__88f76705:focus-within{border-color:#365ef6!important;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.Address_module_input__88f76705.Address_module_focus__88f76705.Address_module_readOnly__88f76705,.Address_module_input__88f76705:focus-within.Address_module_readOnly__88f76705,.Address_module_input__88f76705:focus.Address_module_readOnly__88f76705{border-color:#cbced7!important;box-shadow:none!important}.Address_module_input__88f76705.Address_module_disabled__88f76705,.Address_module_input__88f76705:disabled{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf}.Address_module_input__88f76705.Address_module_disabled__88f76705 input,.Address_module_input__88f76705:disabled input{background-color:#f5f5f7;color:#b0b4bf}.Address_module_mainLabel__88f76705{font-weight:700}input,label{display:block}.Address_module_spinnerIcon__88f76705{stroke:#1a46ef}.Address_module_streetColumn__88f76705{position:relative}.Address_module_verifiedContainer__88f76705{position:absolute;right:-8px;top:-5px;z-index:2}.Address_module_noResults__88f76705{height:32px;line-height:32px;min-width:100%}.Address_module_keyCapture__88f76705{display:contents}";
window.ADS.injectStyle(css$14,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Address/Address.module.scss");
var modules_0a537303 = {"input":"Address_module_input__88f76705","error":"Address_module_error__88f76705","warning":"Address_module_warning__88f76705","readOnly":"Address_module_readOnly__88f76705","isLoading":"Address_module_isLoading__88f76705","focus":"Address_module_focus__88f76705","disabled":"Address_module_disabled__88f76705","mainLabel":"Address_module_mainLabel__88f76705","spinnerIcon":"Address_module_spinnerIcon__88f76705","streetColumn":"Address_module_streetColumn__88f76705","verifiedContainer":"Address_module_verifiedContainer__88f76705","noResults":"Address_module_noResults__88f76705","keyCapture":"Address_module_keyCapture__88f76705"};

// production environment
const ADDRESSPROXYURL = 'https://api.myappliedproducts.com/applied-address/v2';
//for review environment
//const ADDRESSPROXYURL = 'https://api-review.apigee.appliedcloudservices.com/applied-address/v2';
const ADDRESSAPIURL = `${ADDRESSPROXYURL}/addresses`;
const LOCATIONAPIURL = `${ADDRESSPROXYURL}/location`;
const VERIFICATIONAPIURL = `${ADDRESSPROXYURL}/verify`;
const buildCommonRequestHeaders$1 = (token) => {
    const clientVersion = `ADS ${window.ADS.version}`;
    const header = new Headers();
    header.append('apikey', token || '');
    header.append('asi-client-version', clientVersion);
    return header;
};
const buildPostRequestOptions = (token, body) => {
    const myHeaders = buildCommonRequestHeaders$1(token);
    myHeaders.append('Content-Type', 'application/json');
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        body: JSON.stringify(body)
    };
    return requestOptions;
};
const getAddressSuggestions = (country, token, search, address_id) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!token || !search || !country) {
        return { data: [] };
    }
    else {
        const countryCode3 = (_a = GetCountryByName(country !== null && country !== void 0 ? country : 'United States')) === null || _a === void 0 ? void 0 : _a.code3;
        const requestBody = Object.assign(Object.assign({ search: search }, (address_id && { id: address_id })), { country: countryCode3 });
        const requestOptions = buildPostRequestOptions(token, requestBody);
        const response = yield fetch(ADDRESSAPIURL, requestOptions);
        const data = yield response.json();
        return data;
    }
});
const getSecondaryAddressSuggestions = (country, token, search, selected) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!token || !search || !country || !selected) {
        return { data: [] };
    }
    else {
        const countryCode3 = (_a = GetCountryByName(country !== null && country !== void 0 ? country : 'United States')) === null || _a === void 0 ? void 0 : _a.code3;
        const requestBody = {
            search: search,
            selected: selected,
            country: countryCode3
        };
        const requestOptions = buildPostRequestOptions(token, requestBody);
        const response = yield fetch(ADDRESSAPIURL, requestOptions);
        const data = yield response.json();
        return data;
    }
});
const getAddressLocation = (country, token, postalcode, city, stateOrProvince, address_id) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!token) {
        return { data: [] };
    }
    const myHeaders = buildCommonRequestHeaders$1(token);
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    const countryCode3 = (_a = GetCountryByName(country !== null && country !== void 0 ? country : 'United States')) === null || _a === void 0 ? void 0 : _a.code3;
    if (countryCode3 && city && stateOrProvince) {
        let params = `?country=${country}&city=${city}&stateOrProvince=${stateOrProvince}`;
        if (address_id) {
            params += `&id=${address_id}`;
        }
        const response = yield fetch(LOCATIONAPIURL + params, requestOptions);
        const data = yield response.json();
        return data;
    }
    if (countryCode3 && postalcode) {
        let params = `?country=${countryCode3}&postalcode=${postalcode}`;
        if (address_id) {
            params += `&id=${address_id}`;
        }
        const response = yield fetch(LOCATIONAPIURL + params, requestOptions);
        const data = yield response.json();
        return data;
    }
    return { data: [] };
});
const verifyAddress = (address, token) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!token) {
        return { data: [] };
    }
    let stateProvince = '';
    let postCode = '';
    const countryCode3 = (_b = GetCountryByName((_a = address.country) !== null && _a !== void 0 ? _a : 'United States')) === null || _b === void 0 ? void 0 : _b.code3;
    if (countryCode3 === 'USA') {
        stateProvince = address.state || '';
        postCode = address.zipCode || '';
    }
    else {
        stateProvince = address.province || '';
        postCode = address.postalCode || '';
    }
    if ((address.streetLine && address.city && stateProvince) ||
        (address.streetLine && postCode)) {
        const requestBody = {
            streetLine: address.streetLine,
            address2: address.address2,
            address3: address.address3,
            city: address.city,
            stateOrProvince: stateProvince,
            postalCode: postCode,
            county: address.county,
            country: countryCode3
        };
        const requestOptions = buildPostRequestOptions(token, requestBody);
        const response = yield fetch(VERIFICATIONAPIURL, requestOptions);
        const data = yield response.json();
        return data;
    }
    else {
        return { data: [] };
    }
});

// Proxy API key
const TOKEN$1 = 'PJTTmGSFBMBGR0pNlRuDfFdGEIU6rRkF';
class SmartyStreetClient {
    constructor() {
        this.isVerifying = false;
        this.sourceOfVerification = '';
        this.buildCommonAddress = (lookup, country) => {
            const address = {};
            if (lookup) {
                address.city = lookup.city;
                address.county = lookup.county;
                if (country === 'United States') {
                    address.state = lookup.stateOrProvince;
                    address.zipCode = lookup.postalCode;
                }
                else {
                    address.province = lookup.stateOrProvince;
                    address.postalCode = lookup.postalCode;
                }
            }
            return address;
        };
        this.queryByZipCode = (postalcode, country, zipPlus4 = true) => {
            return new Promise((resolve, reject) => {
                getAddressLocation(country, TOKEN$1, postalcode)
                    .then((response) => {
                    var _a;
                    const lookup = response.data[0] || {};
                    const address = this.buildCommonAddress(lookup, country);
                    if (zipPlus4 === false &&
                        address.zipCode &&
                        ((_a = address.zipCode) === null || _a === void 0 ? void 0 : _a.length) > 5) {
                        address.zipCode = address.zipCode.slice(0, 5); // Use only 5 digits if zipPlus4 is false
                    }
                    resolve(address);
                })
                    .catch((err) => {
                    console.error(err);
                    reject(err);
                });
            });
        };
        // Query smarty streets for location suggestions (SmartyStreets V2)
        this.queryByPostalCode = (postalcode, country) => {
            return new Promise((resolve, reject) => {
                // There is a chance that the user entered postal code is only a partial code
                // In that case, we need to fill in the missing parts with assumed values
                // This is CANADA specific
                const fullPostalCode = this.getFullPostalCode(postalcode);
                getAddressLocation(country, TOKEN$1, fullPostalCode)
                    .then((response) => this.filterLocationByPostalCode(response.data, postalcode, country))
                    .then((finalLocation) => {
                    const address = this.buildCommonAddress(finalLocation, country);
                    resolve(address);
                })
                    .catch((err) => {
                    console.error(err);
                    reject(err);
                });
            });
        };
        /* Function for filtering out the location by postal code */
        this.filterLocationByPostalCode = (addresses, postalCode, country) => __awaiter(this, void 0, void 0, function* () {
            // If no addresses were found, return an empty object
            if (!addresses || addresses.length === 0) {
                return Promise.resolve({});
            }
            // Step 1: Filter addresses by postal code
            const filteredAddresses = addresses
                .filter((address) => {
                const addressParts = address.text.split(' ');
                // Check if the last two parts form a postal code
                if (addressParts[addressParts.length - 2].length === 3 &&
                    addressParts[addressParts.length - 1].length === 3) {
                    const addressPostalCode = addressParts[addressParts.length - 2] +
                        ' ' +
                        addressParts[addressParts.length - 1];
                    return addressPostalCode.startsWith(postalCode);
                }
                // If the last two parts do not form a postal code, check the last part
                return addressParts[addressParts.length - 1].startsWith(postalCode);
            })
                // sort the list by entries in ascending order so the address with the least entries is first
                .sort((a, b) => a.entries - b.entries);
            // Step 2: Find the first address with entries equal to 1
            for (const address of filteredAddresses) {
                if (address.entries === 1) {
                    const addressDetails = yield getAddressLocation(country, TOKEN$1, postalCode, '', '', address.id);
                    return addressDetails.data[0];
                }
            }
            // Step 3: If no address with entries equal to 1 was found, use the first address to refine the search and repeat the process
            if (filteredAddresses.length > 0) {
                const refinedAddresses = yield getAddressLocation(country, TOKEN$1, postalCode, '', '', filteredAddresses[0].id);
                return this.filterLocationByPostalCode(refinedAddresses.data, postalCode, country);
            }
            // If no addresses were found, return the original postal code
            return Promise.resolve({ postalCode: postalCode });
        });
    }
    // Query smarty streets for suggestions
    queryAutocompleteForSuggestions(query, country) {
        return new Promise((resolve, reject) => {
            getAddressSuggestions(country, TOKEN$1, query)
                .then((response) => {
                resolve(response.data);
            })
                .catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }
    // Query smarty streets for suggestions summary (SmartyStreets V2)
    queryAutocompleteForSuggestionsSummary(query, country, address_id) {
        return new Promise((resolve, reject) => {
            getAddressSuggestions(country, TOKEN$1, query, address_id)
                .then((response) => {
                resolve(response.data);
            })
                .catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }
    // Query smarty streets for suggestion details (SmartyStreets V2)
    queryAutocompleteForSuggestionDetails(query, country, address_id) {
        return new Promise((resolve, reject) => {
            getAddressSuggestions(country, TOKEN$1, query, address_id)
                .then((response) => {
                resolve(response.data[0]);
            })
                .catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }
    queryAutocompleteForSecondarySuggestions(query, secondary, country) {
        return new Promise((resolve, reject) => {
            getSecondaryAddressSuggestions(country, TOKEN$1, query, secondary)
                .then((response) => {
                resolve(response.data);
            })
                .catch((err) => {
                console.error(err);
                reject(err);
            });
        });
    }
    buildAddress(suggestion) {
        let whiteSpace = '';
        if (suggestion.address2) {
            whiteSpace = ' ';
        }
        return (suggestion.streetLine +
            whiteSpace +
            suggestion.address2 +
            ', ' +
            suggestion.city +
            ' ' +
            suggestion.stateOrProvince);
    }
    buildCAAddress(suggestion) {
        // Split the address into parts
        const addressParts = suggestion.text.split(' ');
        // Remove the postal code
        while (addressParts[addressParts.length - 1].length === 3) {
            addressParts.pop();
        }
        return addressParts.join(' ');
    }
    buildForSecondaryAddress(suggestion) {
        let whiteSpace = '';
        let newString = '';
        if (suggestion.address2) {
            if (suggestion.entries > 1) {
                newString = suggestion.address2 += ' (' + suggestion.entries + ')';
            }
            whiteSpace = ' ';
        }
        return (suggestion.streetLine +
            whiteSpace +
            newString +
            ' ' +
            suggestion.city +
            ' ' +
            suggestion.stateOrProvince +
            ' ' +
            suggestion.postalCode);
    }
    /* Function for building up the full postal code */
    getFullPostalCode(postalcode) {
        const isPartialPostalCode = !/^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/.test(postalcode);
        if (isPartialPostalCode) {
            // Users can enter a partial postal code, e.g. 'A', 'A1', 'A1A', 'A1A 1', 'A1A 1A'
            // So we need to fill in the missing parts with assumed values in order to get somewhat accurate results
            return postalcode.padEnd(7, 'A1A 1A1'.substring(postalcode.length));
        }
        // If it's not a partial postal code, return the original postal code
        return postalcode;
    }
    validateUsAddress(address, zipPlus4 = true) {
        return new Promise((resolve, reject) => {
            if (address.streetLine) {
                this.isVerifying = true;
                verifyAddress(address, TOKEN$1)
                    .then((response) => {
                    this.isVerifying = false;
                    const resp = response.data[0] || {};
                    const isValid = !!response.data[0];
                    if (!isValid) {
                        resolve(Object.assign(Object.assign({}, address), { verified: false }));
                    }
                    else {
                        const postalCode = zipPlus4 && resp.postalCode.length > 5
                            ? resp.postalCode
                            : resp.postalCode.slice(0, 5); // Use only 5 digits if zipPlus4 is false
                        resolve({
                            verified: true,
                            streetLine: resp.streetLine,
                            address2: resp.address2,
                            address3: resp.address3, // This will always be empty; set to maintain consistency with the CA address
                            city: resp.city,
                            state: resp.stateOrProvince,
                            zipCode: postalCode,
                            county: resp.county
                        });
                    }
                })
                    .catch((err) => {
                    this.isVerifying = false;
                    console.error(err);
                    reject(err);
                });
            }
            else {
                resolve(Object.assign(Object.assign({}, address), { verified: false }));
            }
        });
    }
    validateCaAddress(address, source) {
        return new Promise((resolve, reject) => {
            if (address.streetLine) {
                this.sourceOfVerification = source;
                this.isVerifying = true;
                verifyAddress(address, TOKEN$1)
                    .then((response) => {
                    // If the source of validation changes (e.g., 'blur' to 'selection') during a request,
                    // we ignore the results of the outdated request. This ensures that the most recent request always takes precedence.
                    // For example, if a 'selection' request is triggered after a 'blur' request, and the 'blur' request finishes first,
                    // the 'blur' request's results will be ignored in favor of the 'selection' request.
                    if (this.sourceOfVerification !== source) {
                        return;
                    }
                    this.sourceOfVerification = '';
                    this.isVerifying = false;
                    const resp = response.data[0] || {};
                    const isValid = resp.verified;
                    if (!isValid) {
                        resolve(Object.assign(Object.assign({}, address), { verified: false }));
                    }
                    else if (isValid) {
                        resolve({
                            verified: true,
                            streetLine: resp.streetLine,
                            address2: resp.address2,
                            address3: resp.address3,
                            city: resp.city,
                            province: resp.stateOrProvince,
                            postalCode: resp.postalCode
                        });
                    }
                })
                    .catch((err) => {
                    // If the source of validation changes (e.g., 'blur' to 'selection') while this request was in progress,
                    // we ignore the error from this request. This ensures that 'selection' requests always take precedence,
                    // and any errors from 'blur' requests are ignored if a 'selection' request has been triggered.
                    if (this.sourceOfVerification !== source) {
                        return;
                    }
                    this.sourceOfVerification = '';
                    this.isVerifying = false;
                    console.error(err);
                    reject(err);
                });
            }
            else {
                resolve(Object.assign(Object.assign({}, address), { verified: false }));
            }
        });
    }
    validateCaAddress2Blur(address) {
        return new Promise((resolve, reject) => {
            if (address.streetLine) {
                this.isVerifying = true;
                verifyAddress(address, TOKEN$1)
                    .then((response) => {
                    this.isVerifying = false;
                    const resp = response.data[0] || {};
                    const isValid = resp.verified;
                    if (!isValid) {
                        resolve(Object.assign(Object.assign({}, address), { verified: false }));
                    }
                    else if (isValid) {
                        const fields = ['streetLine', 'address3', 'city', 'postalCode'];
                        const r = pick(resp, fields);
                        r.province = resp.stateOrProvince;
                        const currentAddress = pick(address, [...fields, 'province']);
                        if (isEqual(r, currentAddress)) {
                            resolve(Object.assign(Object.assign({}, r), { address2: resp.address2, verified: true }));
                        }
                    }
                })
                    .catch((err) => {
                    this.isVerifying = false;
                    console.error(err);
                    reject(err);
                });
            }
            else {
                resolve(Object.assign(Object.assign({}, address), { verified: false }));
            }
        });
    }
}

/** Array containing all of the fields eligible for max length that can be trimmed */
const addressFieldsWithMaxCharLength = [
    AddressFields.Street,
    AddressFields.Address2,
    AddressFields.Address3,
    AddressFields.Address4,
    AddressFields.City,
    AddressFields.County,
    AddressFields.Province
];
/**
 * Returns a copy of the address provided, trimmed to match the provided fieldMaxLengths
 *
 * @param verifiedAddress - The verified Address to trim
 * @param fieldMaxLengths - The field max lengths
 * @returns A modified copy of the address provided, with verified set to false if any fields were trimmed
 */
const trimAddress = (verifiedAddress, fieldMaxLengths) => {
    // Create a new object to avoid modifying the original address
    const adjustedAddress = cloneDeep(verifiedAddress);
    addressFieldsWithMaxCharLength.forEach((key) => {
        const maxLength = fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths[key];
        const fieldValue = adjustedAddress[key];
        if (maxLength && fieldValue && fieldValue.length > maxLength) {
            adjustedAddress[key] = fieldValue.substring(0, maxLength);
            if ('verified' in adjustedAddress) {
                adjustedAddress.verified = false;
            }
        }
    });
    return adjustedAddress;
};

const defaultValue$4 = {
    streetLine: '',
    address2: '',
    address3: '',
    city: '',
    province: '',
    postalCode: '',
    country: 'Canada'
};
const CaAddress = ({ addressWidth, disabled, disableAutoFill, disableLookup, readOnly, required, desired, name, subFormName, onChange, value = defaultValue$4, updateFormValues, fieldNames, defaultLabels, fieldVisibilityConfig, helpText, onFieldBlur, onFieldFocus, onSuggestionSelected, onContextMenu, fieldMaxLengths, testId }) => {
    var _a, _b, _c, _d;
    const smartyStreets = React__default.useRef(new SmartyStreetClient());
    const { t } = useTranslation();
    const [suggestions, setSuggestions] = React__default.useState([]);
    const [verifiedPrev, setVerifiedPrev] = React__default.useState(false);
    // We have a race condition where both blur and selecting suggestion
    const blurTimerRef = React__default.useRef(null);
    // No ideal but for some reason some of our methods like onBlur will have a
    // stale version of the value prop unless we use a ref.
    const valueRef = React__default.useRef(value);
    React__default.useEffect(() => {
        valueRef.current = value;
    }, [value]);
    // If we are mounted and address line 1 has a value, we need to load
    // suggestions to show in the auto complete dropdown.
    React__default.useEffect(() => {
        // If we have a value for street address 1 and suggestions are empty, re-fill them
        if (!disableLookup && value.streetLine && !suggestions.length) {
            smartyStreets.current
                .queryAutocompleteForSuggestionsSummary(value.streetLine, value.country || '')
                .then((suggestions) => buildSuggestion(suggestions));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Whenever our value changes, we need to invoke onChange
    // and notify our parent.
    const sendOnChange = React__default.useCallback((address) => {
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onChange && onChange(event);
    }, [onChange, value, name]);
    // Whenever an address suggestion is selected, we need to invoke onSuggestionSelected
    // and notify our parent.
    const sendSuggestionSelected = React__default.useCallback((address) => {
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onSuggestionSelected && onSuggestionSelected(event);
    }, [onSuggestionSelected, value, name]);
    const buildSuggestion = (suggestions) => {
        if (!suggestions) {
            console.warn('ADS: Address not able to build suggestions. Lookup failed.');
            return;
        }
        for (const suggestion of suggestions) {
            const builtAddress = smartyStreets.current.buildCAAddress(suggestion);
            suggestion.displayText = builtAddress;
            suggestion.isSelectable = suggestion.entries > 1 ? false : true;
            // build badges for suggestions based on entries
            if (suggestion.entries && suggestion.entries > 1) {
                suggestion.badges = [
                    {
                        text: `${suggestion.entries} ${t('ENTRIES')}`
                    }
                ];
            }
        }
        setSuggestions(suggestions);
    };
    const queryAutocompleteForSuggestionsSummaryThrottled = useThrottledFunction((search, country) => {
        smartyStreets.current
            .queryAutocompleteForSuggestionsSummary(search, country)
            .then((suggestions) => buildSuggestion(suggestions));
    }, 500);
    // Whenever our search detects a value change, we query
    // smarty streets for suggestions.
    const handleChangeSearch = (e) => {
        const search = e.target.value;
        sendOnChange(Object.assign(Object.assign({}, value), { streetLine: search, verified: false }));
        updateFormValues && updateFormValues({ verified: false });
        if (!disableLookup && search) {
            queryAutocompleteForSuggestionsSummaryThrottled(search, value.country || '');
        }
        else {
            //set an empty suggestion[] if street is blank
            setSuggestions([]);
        }
    };
    const handleChange = (e) => {
        // This the input's name is going to be prefixed with the address comp's
        // name, and if it's in a subForm, also have the subForm name prefixed in front
        // of that.
        const addressCompName = subFormName
            ? `${subFormName}.${name}-`
            : `${name}-`;
        const targetName = e.target.name.replace(addressCompName, '');
        sendOnChange(Object.assign(Object.assign({}, value), { [targetName]: e.target.value, verified: false }));
        updateFormValues && updateFormValues({ verified: false });
    };
    const handleSelectionSearch = (e) => {
        setVerifiedPrev(false);
        // if we have more than 1 entry we know we need to make a call to get more addresses
        if (e.entries > 1) {
            smartyStreets.current
                .queryAutocompleteForSuggestionsSummary(e.text, value.country || '', e.id)
                .then((suggestions) => {
                buildSuggestion(suggestions);
            });
            // if we have 1 entry then we can make a request to get the details and set the fields
        }
        else {
            smartyStreets.current
                .queryAutocompleteForSuggestionDetails(e.text, value.country || '', e.id)
                .then((suggestion) => {
                const currentState = Object.assign(Object.assign({}, value), { streetLine: suggestion.streetLine, address2: suggestion.address2, city: suggestion.city, province: suggestion.stateOrProvince, postalCode: suggestion.postalCode });
                if (blurTimerRef.current) {
                    clearTimeout(blurTimerRef.current);
                }
                smartyStreets.current
                    .validateCaAddress(currentState, 'selection')
                    .then((verifiedAddress) => {
                    if (fieldMaxLengths) {
                        verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                    }
                    updateFormValues && updateFormValues(verifiedAddress);
                    if (verifiedAddress.verified) {
                        setVerifiedPrev(true);
                    }
                    sendOnChange(verifiedAddress);
                    sendSuggestionSelected(verifiedAddress);
                });
            });
        }
    };
    const handleBlur = (event) => {
        if (!disableLookup && !verifiedPrev) {
            if (!smartyStreets.current.isVerifying && !value.verified) {
                smartyStreets.current
                    .validateCaAddress(valueRef.current, 'blur')
                    .then((verifiedAddress) => {
                    if (fieldMaxLengths) {
                        verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                    }
                    setVerifiedPrev(verifiedAddress.verified);
                    updateFormValues && updateFormValues(verifiedAddress);
                    sendOnChange(verifiedAddress);
                });
            }
        }
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    const handleFocus = (event) => {
        // Whenever an AddressField gains focus, we need to invoke onFieldFocus
        // and notify the parent.
        onFieldFocus && onFieldFocus(event);
    };
    const handleContextMenu = (event) => {
        // Whenever an AddressField context menu is opened, we need to invoke onContextMenu
        // and notify the parent.
        onContextMenu && onContextMenu(event);
    };
    const handleStreetLine2Blur = (event) => {
        // On blur if we are not verified and are not currently verifying
        // an address, attempt to verify our current value. This isn't ideal
        // using a setTimeout, but there isn't a better way right now.
        blurTimerRef.current = setTimeout(() => {
            if (!disableLookup &&
                !smartyStreets.current.isVerifying &&
                !value.verified) {
                smartyStreets.current
                    .validateCaAddress2Blur(valueRef.current)
                    .then((verifiedAddress) => {
                    if (fieldMaxLengths) {
                        verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                    }
                    setVerifiedPrev(verifiedAddress.verified);
                    updateFormValues && updateFormValues(verifiedAddress);
                    sendOnChange(verifiedAddress);
                });
            }
        }, 150);
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    const handlePostalBlur = (event) => {
        if (!disableLookup && !verifiedPrev && event.target.value) {
            if (!value.verified) {
                (() => __awaiter(void 0, void 0, void 0, function* () {
                    let postalCodeResults = {};
                    yield smartyStreets.current
                        .queryByPostalCode(event.target.value, value.country || '')
                        .then((address) => {
                        postalCodeResults = address;
                    });
                    smartyStreets.current
                        .validateCaAddress(Object.assign(Object.assign({}, value), postalCodeResults), 'blur')
                        .then((verifiedAddress) => {
                        if (fieldMaxLengths) {
                            verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                        }
                        setVerifiedPrev(verifiedAddress.verified);
                        updateFormValues && updateFormValues(verifiedAddress);
                        sendOnChange(verifiedAddress);
                    });
                }))();
            }
        }
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    const renderVerifyBadge = () => {
        if (value.verified) {
            return (React__default.createElement(Tooltip, { content: `${t('THIS_ADDRESS_VERIFIED')}` },
                React__default.createElement(Badge, { testId: "verifiedAddressBadge", type: "success" }, t('VERIFIED_ADDR'))));
        }
        else {
            if (smartyStreets.current.isVerifying) {
                return (React__default.createElement(Icon, { icon: "SpinnerIcon", size: 18, disabled: disabled, strokeClass: modules_0a537303.spinnerIcon }));
            }
            else {
                return null;
            }
        }
    };
    // CA address Postal code label gets misaligned when the screen is compact. This
    // variable is used to determine if the screen is compact (the ADS recommended min width is 400px).
    // If the components width is less than or equal to 400px, the Postal code is wrapped to the next row.
    // Otherwise, the Postal code is displayed on the same row as the Province.
    const isCompact = addressWidth !== null ? addressWidth <= 400 : false;
    return (React__default.createElement(Row, null,
        !disableLookup ? (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement("div", { className: modules_0a537303.verifiedContainer }, renderVerifyBadge()),
            React__default.createElement(SuggestionField, { testId: TestIdUtils.composeId(testId, AddressFields.Street), name: AddressFieldName(AddressFields.Street, name, fieldNames), value: value.streetLine, defaultLabel: (_a = (defaultLabels && defaultLabels[AddressFields.Street])) !== null && _a !== void 0 ? _a : t('STREET'), disabled: disabled, helpText: helpText && helpText[AddressFields.Street], noResultsText: t('NO_MATCHES_DATABASE_ADDR'), items: suggestions, toLabel: "displayText", readOnly: readOnly, required: required, desired: desired, onBlur: handleBlur, onChange: handleChangeSearch, onSelection: handleSelectionSearch, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine }))) : (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement(StreetLine, { testId: TestIdUtils.composeId(testId, AddressFields.Street), name: name, fieldNames: fieldNames, defaultLabel: (_b = (defaultLabels && defaultLabels[AddressFields.Street])) !== null && _b !== void 0 ? _b : t('STREET'), helpText: helpText && helpText[AddressFields.Street], disabled: disabled, readOnly: readOnly, required: required, desired: desired, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine }))),
        React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine2, { testId: TestIdUtils.composeId(testId, AddressFields.Address2), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address2], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleStreetLine2Blur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address2 })),
        fieldVisibilityConfig.showStreetLineCount >= 3 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine3, { testId: TestIdUtils.composeId(testId, AddressFields.Address3), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address3], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address3 }))) : null,
        fieldVisibilityConfig.showStreetLineCount >= 4 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine4, { testId: TestIdUtils.composeId(testId, AddressFields.Address4), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address4], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address4 }))) : null,
        React__default.createElement(Col, { xs: 12, sm: 6 },
            React__default.createElement(City, { testId: TestIdUtils.composeId(testId, AddressFields.City), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.City], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.city })),
        React__default.createElement(Col, { xs: 6, sm: isCompact ? 6 : 3 },
            React__default.createElement(Combobox, { testId: TestIdUtils.composeId(testId, AddressFields.Province), disabled: disabled, name: AddressFieldName(AddressFields.Province, name, fieldNames), helpText: helpText && helpText[AddressFields.Province], readOnly: readOnly, defaultLabel: (_c = defaultLabels === null || defaultLabels === void 0 ? void 0 : defaultLabels.province) !== null && _c !== void 0 ? _c : t('PROVINCE'), items: CAProvinces, value: value.province, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill })),
        React__default.createElement(Col, { xs: 6, sm: isCompact ? 6 : 3 },
            React__default.createElement(TextField, { testId: TestIdUtils.composeId(testId, AddressFields.PostalCode), format: "can-post", disabled: disabled, name: AddressFieldName(AddressFields.PostalCode, name, fieldNames), helpText: helpText && helpText[AddressFields.PostalCode], defaultLabel: (_d = (defaultLabels && defaultLabels[AddressFields.PostalCode])) !== null && _d !== void 0 ? _d : t('POSTAL'), readOnly: readOnly, value: value.postalCode, onChange: handleChange, onBlur: handlePostalBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill })),
        fieldVisibilityConfig.showCountry ? (React__default.createElement(Col, { xs: 12, md: 6 },
            React__default.createElement(Country, { testId: TestIdUtils.composeId(testId, AddressFields.Country), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Country], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill }))) : null));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const defaultValue$3 = {
    streetLine: '',
    address2: '',
    address3: '',
    city: '',
    province: '',
    postalCode: '',
    country: ''
};
const ForeignAddress = ({ addressWidth, customDataProps, disabled, testId, disableAutoFill, readOnly, required, desired, name, subFormName, onChange, helpText, value = defaultValue$3, fieldNames, defaultLabels, onFieldBlur, onFieldFocus, onContextMenu, fieldVisibilityConfig, fieldMaxLengths }) => {
    var _a, _b;
    // No ideal but for some reason some of our methods like onBlur will have a
    // stale version of the value prop unless we use a ref.
    const valueRef = React__default.useRef(value);
    React__default.useEffect(() => {
        valueRef.current = value;
    }, [value]);
    // Whenever our value changes, we need to invoke onChange
    // and notify our parent.
    const sendOnChange = React__default.useCallback((address) => {
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onChange && onChange(event);
    }, [onChange, value, name]);
    const handleChange = (e) => {
        // This the input's name is going to be prefixed with the address comp's
        // name, and if it's in a subForm, also have the subForm name prefixed in front
        // of that.
        const addressCompName = subFormName
            ? `${subFormName}.${name}-`
            : `${name}-`;
        const targetName = e.target.name.replace(addressCompName, '');
        sendOnChange(Object.assign(Object.assign({}, value), { [targetName]: e.target.value }));
    };
    // Whenever an AddressField blurs, we need to invoke onFieldBlur
    // and notify the parent.
    const handleBlur = (event) => {
        onFieldBlur && onFieldBlur(event);
    };
    // Whenever an AddressField gains focus, we need to invoke onFieldFocus
    // and notify the parent.
    const handleFocus = (event) => {
        onFieldFocus && onFieldFocus(event);
    };
    const handleContextMenu = (event) => {
        // Whenever an AddressField context menu is opened, we need to invoke onContextMenu
        // and notify the parent.
        onContextMenu && onContextMenu(event);
    };
    const isCompact = addressWidth !== null ? addressWidth <= 545 : false;
    return (React__default.createElement(Row, { customDataProps: customDataProps, testId: testId },
        React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine, { testId: TestIdUtils.composeId(testId, AddressFields.Street), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Street], disabled: disabled, readOnly: readOnly, required: required, desired: desired, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine })),
        React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine2, { testId: TestIdUtils.composeId(testId, AddressFields.Address2), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address2], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address2 })),
        fieldVisibilityConfig.showStreetLineCount >= 3 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine3, { testId: TestIdUtils.composeId(testId, AddressFields.Address3), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address3], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address3 }))) : null,
        fieldVisibilityConfig.showStreetLineCount >= 4 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine4, { testId: TestIdUtils.composeId(testId, AddressFields.Address4), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address4], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address4 }))) : null,
        React__default.createElement(Col, { xs: 12, sm: 6, lg: 6 },
            React__default.createElement(City, { testId: TestIdUtils.composeId(testId, AddressFields.City), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.City], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.city })),
        React__default.createElement(Col, { xs: 12, sm: isCompact ? 6 : 3 },
            React__default.createElement(TextField, { testId: TestIdUtils.composeId(testId, AddressFields.Province), disabled: disabled, readOnly: readOnly, name: (_a = fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.province) !== null && _a !== void 0 ? _a : `${name}-province`, defaultLabel: (_b = defaultLabels === null || defaultLabels === void 0 ? void 0 : defaultLabels.province) !== null && _b !== void 0 ? _b : 'Region / Province', helpText: helpText && helpText[AddressFields.Province], value: value.province, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.province })),
        React__default.createElement(Col, { xs: 12, sm: isCompact ? 6 : 3 },
            React__default.createElement(PostalCode, { testId: TestIdUtils.composeId(testId, AddressFields.PostalCode), format: "uppercase", name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.PostalCode], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill })),
        fieldVisibilityConfig.showCountry ? (React__default.createElement(Col, { xs: 12, sm: 6, lg: 6 },
            React__default.createElement(Country, { testId: TestIdUtils.composeId(testId, AddressFields.Country), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Country], disabled: disabled, readOnly: readOnly, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill }))) : null));
};

//REVERT TO PRODUCTION BEFORE MERGING
// const TOKEN = 'HTA5VdkNij4V0dm3uAULnqh15OOHKH4p'; //use in review environment
// const ADDRESS_API_SERVER_URL =
//   'https://api-review.apigee.appliedcloudservices.co.uk/applied-address/v2';
const TOKEN = 'PJTTmGSFBMBGR0pNlRuDfFdGEIU6rRkF'; //use in production environment
const ADDRESS_API_SERVER_URL = 'https://api.myappliedproducts.co.uk/applied-address/v2';
const ADDRESS_API_FIND_URL = `${ADDRESS_API_SERVER_URL}/find`;
const ADDRESS_API_RETRIEVE_URL = `${ADDRESS_API_SERVER_URL}/retrieve`;
const buildCommonRequestHeaders = (token) => {
    const clientVersion = `ADS ${window.ADS.version}`;
    return {
        apikey: token || '',
        'asi-client-version': clientVersion
    };
};
const toCleanCommonAddress = (addr) => {
    // removes duplicates in address data that is already captured
    // as postal code, city, etc.
    const nonStreetValues = [addr.postalCode, addr.city, addr.administrativeArea];
    return Object.assign(Object.assign({}, addr), { streetLine: nonStreetValues.includes(addr.address1) ? '' : addr.address1, address2: nonStreetValues.includes(addr.address2) ? '' : addr.address2, address3: nonStreetValues.includes(addr.address3) ? '' : addr.address3, address4: nonStreetValues.includes(addr.address4) ? '' : addr.address4, county: addr.administrativeArea });
};
const formatFindResult = (result) => {
    return [result.text.trim(), result.description.trim()]
        .filter((v) => v)
        .join(', ');
};
function useUKAddressLookup(query) {
    const cache = React__default.useRef([]);
    const [loading, setLoading] = React__default.useState(false);
    const [suggestions, setSuggestions] = React__default.useState();
    const retrieveAddress = React__default.useCallback((id) => {
        return new Promise((resolve, reject) => {
            var _a;
            const cached = (_a = cache.current.find((d) => d.id === id)) === null || _a === void 0 ? void 0 : _a.address;
            if (cached) {
                resolve(toCleanCommonAddress(cached));
            }
            else {
                // hit the retrieve API to get data.
                // note - $$$ happens when we do this.
                setLoading(true);
                let result;
                axios
                    .get(ADDRESS_API_RETRIEVE_URL, {
                    headers: buildCommonRequestHeaders(TOKEN),
                    params: { id }
                })
                    .then((response) => {
                    const retrieved = response.data.data &&
                        response.data.data.length > 0 &&
                        response.data.data[0];
                    if (retrieved) {
                        result = toCleanCommonAddress(retrieved);
                        cache.current = [
                            ...cache.current.filter((d) => d.id !== id),
                            { id: id, address: retrieved }
                        ];
                    }
                })
                    .catch((error) => {
                    ADSError('An error occurred retrieving address data', error);
                    reject();
                })
                    .finally(() => {
                    setLoading(false);
                    resolve(result);
                });
            }
        });
    }, [cache]);
    React__default.useEffect(() => {
        if (query) {
            setLoading(true);
            const headers = buildCommonRequestHeaders(TOKEN);
            // street lookup - potentially a batch of lookups
            const results = [];
            // Address lookups are complex, have multiple scenarios to consider.
            //   Results can come back as "address" or "container" type (e.g. container, street, etc.).
            //   "address" type points to a specific, single address, with an ID.
            //   "container" types are a group match, and require another query to resolve exact IDs for every item in group.
            //   There is also a "limit" param that apigee provides that we are not, but could if needed.
            axios
                .post(ADDRESS_API_FIND_URL, { text: query }, {
                headers: headers
            })
                .then((response) => {
                const findAgain = [];
                if (response.data.data) {
                    response.data.data.forEach((result) => {
                        if (result.type === 'Address') {
                            const description = formatFindResult(result);
                            if (!results.map((r) => r.description).includes(description)) {
                                results.push({ id: result.id, description });
                            }
                        }
                        else {
                            // type is container, need to find again using container ID
                            findAgain.push(result.id);
                        }
                    });
                    // requery all the container results in parallel
                    return axios.all(findAgain.map((id) => axios.post(ADDRESS_API_FIND_URL, { text: query, container: id }, {
                        headers: headers
                    })));
                }
            })
                // requery results from container queries, done in parallel.
                // response should include array of arrays of results, but they _should_ all be of type "address".
                .then((response) => {
                response === null || response === void 0 ? void 0 : response.forEach((requeryResponse) => {
                    // each query response should be an array of results like the first query
                    requeryResponse.data.data.forEach((result) => {
                        if (result.type === 'Address') {
                            const description = formatFindResult(result);
                            if (!results.map((r) => r.description).includes(description)) {
                                results.push({ id: result.id, description });
                            }
                        } // there should not be non-address results at this point.
                    });
                });
            })
                .catch((error) => {
                ADSError('Error occurred searching address info!', error);
            })
                .finally(() => {
                // data is:
                // address ID value
                // a text description for display purposes
                // text description formatting is wholly controlled by GBLoqate.
                // BIG NOTE - GBLoqate API key has a "DataSet" version.
                // -- V3 contains comma delimited text/description fields that we can sort.
                // -- V4 use spaces for delimiting, it's not possible to distinguish address line data, so no sorting.
                // ---- Their workaround for V4 is to do retrieve on every single address up front,
                // ---- which is rather obnoxiously slow and can multiply cost 100x.
                // we want to try to sort these based on the first piece of "description"
                // try to determine a unit number, and sort those numerically.
                const numOnly = /\d+/;
                results.sort((a, b) => {
                    var _a, _b, _c, _d;
                    const aDesc = (_a = a.description.split(',')[0]) !== null && _a !== void 0 ? _a : '';
                    const bDesc = (_b = b.description.split(',')[0]) !== null && _b !== void 0 ? _b : '';
                    const aVal = numOnly.exec(aDesc);
                    const bVal = numOnly.exec(bDesc);
                    return ((_c = (aVal && +aVal[0])) !== null && _c !== void 0 ? _c : 0) - ((_d = (bVal && +bVal[0])) !== null && _d !== void 0 ? _d : 0);
                });
                // resort all the results based on their second description part too
                // this will typically result in all the "Flat" or "Unit" items being pushed
                // together after they were sorted numerically above.
                results.sort((a, b) => {
                    var _a, _b;
                    const aBld = (_a = a.description.split(',')[1]) !== null && _a !== void 0 ? _a : a.description.replace(/\d+/g, '');
                    const bBld = (_b = b.description.split(',')[1]) !== null && _b !== void 0 ? _b : b.description.replace(/\d+/g, '');
                    return aBld.localeCompare(bBld);
                });
                setLoading(false);
                setSuggestions(results);
            });
        }
    }, [query]);
    return { loading, suggestions, retrieveAddress };
}

function useFadingLoader(isLoading, timeout = 500) {
    const [renderLoader, setRender] = React__default.useState(false);
    const [visibleLoader, setVisible] = React__default.useState(false);
    const loaderTimer = React__default.useRef(null);
    React__default.useEffect(() => {
        if (isLoading === undefined) {
            // if the prop is missing, never render.
            setRender(false);
        }
        if (isLoading) {
            // render as soon as loading becomes true.
            // remove any existing render timer
            setRender(true);
            if (loaderTimer.current) {
                clearTimeout(loaderTimer.current);
            }
            // opacity will be handled on the next tick.
            // otherwise it will not animate correctly.
        }
        else {
            // not loading anymore
            // set opacity to 0 as soon as loading is false
            setVisible(false);
            if (!loaderTimer.current) {
                loaderTimer.current = setTimeout(() => {
                    setRender(!!isLoading);
                }, timeout);
            }
            else {
                clearTimeout(loaderTimer.current);
                loaderTimer.current = setTimeout(() => {
                    setRender(!!isLoading);
                }, timeout);
            }
        }
        // cleanup: don't leak timers!
        return function () {
            if (!loaderTimer.current) {
                return;
            }
            clearTimeout(loaderTimer.current);
        };
    }, [isLoading, timeout]);
    React__default.useLayoutEffect(() => {
        // we want to wait a tick before setting opacity to 1 from 0.
        // only do this is the isloading prop is defined.
        if (isLoading !== undefined) {
            setVisible(true);
        }
    }, [isLoading]);
    return { renderLoader, visibleLoader };
}

var css$13 = ".Button_module_grow__c8b790a7{flex:1}.Button_module_button__c8b790a7{align-items:center;background-color:initial;border:1px solid #0000;border-radius:3px;cursor:pointer;display:inline-flex;font-size:14px;font-weight:600;justify-content:center;line-height:20px;max-height:32px;min-height:32px;min-width:80px;outline:none;padding:5px 16px;position:relative;transition:border-color .15s,background-color .15s,color .15s;vertical-align:middle;white-space:nowrap}.Button_module_button__c8b790a7:focus{outline:none}.Button_module_button__c8b790a7:active{box-shadow:none!important}.Button_module_button__c8b790a7.Button_module_appearDisabled__c8b790a7,.Button_module_button__c8b790a7:disabled,.Button_module_button__c8b790a7[disabled]{cursor:default;pointer-events:none}.Button_module_button__c8b790a7 .Button_module_iconLeft__c8b790a7{margin-left:-2px;margin-right:.375rem}.Button_module_button__c8b790a7 .Button_module_iconRight__c8b790a7{margin-left:.375rem;margin-right:-2px}.Button_module_noMinWidth__c8b790a7{min-width:auto}.Button_module_primary__c8b790a7{background-color:#365ef6;color:#fff;font-weight:700}.Button_module_primary__c8b790a7.Button_module_focus__c8b790a7,.Button_module_primary__c8b790a7:focus{background-color:#365ef6;box-shadow:0 0 0 4px #365ef64d}.Button_module_primary__c8b790a7:active:not(.Button_module_loading__c8b790a7):not(.Button_module_appearDisabled__c8b790a7){background-color:#0c2ca6!important}.Button_module_primary__c8b790a7:hover{background-color:#0e36cd}.Button_module_primary__c8b790a7.Button_module_appearDisabled__c8b790a7,.Button_module_primary__c8b790a7:disabled{background-color:#aabff8;color:#fff}.Button_module_primaryIconStroke_Disabled__c8b790a7,.Button_module_primaryIconStroke__c8b790a7{stroke:#fff;fill:#fff}.Button_module_secondary__c8b790a7{background-color:#fff;border:1px solid #365ef6;color:#365ef6}.Button_module_secondary__c8b790a7.Button_module_focus__c8b790a7,.Button_module_secondary__c8b790a7:focus{box-shadow:0 0 0 4px #365ef64d}.Button_module_secondary__c8b790a7:active:not(.Button_module_loading__c8b790a7):not(.Button_module_appearDisabled__c8b790a7){background-color:#d5e1fb!important}.Button_module_secondary__c8b790a7:hover{background-color:#e3eafc}.Button_module_secondary__c8b790a7.Button_module_appearDisabled__c8b790a7,.Button_module_secondary__c8b790a7:disabled{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf}.Button_module_secondaryIconStroke__c8b790a7{stroke:#365ef6;fill:#365ef6}.Button_module_secondaryIconStroke_Disabled__c8b790a7{stroke:#b0b4bf;fill:#b0b4bf}.Button_module_tertiary__c8b790a7{color:#365ef6}.Button_module_tertiary__c8b790a7.Button_module_focus__c8b790a7,.Button_module_tertiary__c8b790a7:focus{box-shadow:0 0 0 4px #365ef64d}.Button_module_tertiary__c8b790a7:active:not(.Button_module_loading__c8b790a7):not(.Button_module_appearDisabled__c8b790a7){background-color:#d5e1fb!important}.Button_module_tertiary__c8b790a7:active:not(.Button_module_loading__c8b790a7):not(.Button_module_appearDisabled__c8b790a7)[data-is-row-actions-button=true]{background-color:#0e36cd!important}.Button_module_tertiary__c8b790a7:hover{background-color:#e3eafc}.Button_module_tertiary__c8b790a7.Button_module_appearDisabled__c8b790a7,.Button_module_tertiary__c8b790a7:disabled{color:#b0b4bf}.Button_module_tertiaryIconStroke__c8b790a7{stroke:#365ef6;fill:#365ef6}.Button_module_tertiaryIconStroke_Disabled__c8b790a7{stroke:#b0b4bf}.Button_module_iconLeft__c8b790a7.Button_module_empty__c8b790a7,.Button_module_iconRight__c8b790a7.Button_module_empty__c8b790a7{padding:7px}.Button_module_iconLeft__c8b790a7.Button_module_empty__c8b790a7 .Button_module_iconLeft__c8b790a7,.Button_module_iconLeft__c8b790a7.Button_module_empty__c8b790a7 .Button_module_iconRight__c8b790a7,.Button_module_iconRight__c8b790a7.Button_module_empty__c8b790a7 .Button_module_iconLeft__c8b790a7,.Button_module_iconRight__c8b790a7.Button_module_empty__c8b790a7 .Button_module_iconRight__c8b790a7{margin:0}.Button_module_iconLeft__c8b790a7.Button_module_empty__c8b790a7.Button_module_sm__c8b790a7,.Button_module_iconRight__c8b790a7.Button_module_empty__c8b790a7.Button_module_sm__c8b790a7{padding:0 6px}.Button_module_iconLeft__c8b790a7.Button_module_empty__c8b790a7.Button_module_xs__c8b790a7,.Button_module_iconRight__c8b790a7.Button_module_empty__c8b790a7.Button_module_xs__c8b790a7{padding:0 5px}.Button_module_sm__c8b790a7{font-size:13px;height:28px;max-height:28px;min-height:28px}.Button_module_sm__c8b790a7 .Button_module_iconLeft__c8b790a7{height:14px;margin-right:4px;width:14px}.Button_module_sm__c8b790a7 .Button_module_iconRight__c8b790a7{height:14px;margin-left:4px;width:14px}.Button_module_xs__c8b790a7{font-size:12px;height:24px;max-height:24px;min-height:24px;padding:4px 12px}.Button_module_xs__c8b790a7 .Button_module_iconLeft__c8b790a7{height:12px;margin-right:4px;width:12px}.Button_module_xs__c8b790a7 .Button_module_iconRight__c8b790a7{height:12px;margin-left:4px;width:12px}.Button_module_link__c8b790a7{background:#0000;border:none;color:#365ef6;font-weight:400;height:fit-content;line-height:20px;margin:-1px -2px;min-height:auto;min-width:auto;padding:1px 2px;text-decoration:underline;vertical-align:initial;width:fit-content}.Button_module_link__c8b790a7.Button_module_focus__c8b790a7,.Button_module_link__c8b790a7:focus{box-shadow:0 0 0 4px #365ef64d}.Button_module_link__c8b790a7.Button_module_appearDisabled__c8b790a7,.Button_module_link__c8b790a7:disabled{color:#b0b4bf}.Button_module_link__c8b790a7.Button_module_xs__c8b790a7{line-height:16px}.Button_module_groupButton__c8b790a7{min-width:48px;position:relative;vertical-align:top;z-index:1}.Button_module_groupButton__c8b790a7:focus{z-index:3}.Button_module_groupButton__c8b790a7:hover{z-index:2}.Button_module_groupButton__c8b790a7.Button_module_first__c8b790a7{border-bottom-right-radius:0;border-top-right-radius:0}.Button_module_groupButton__c8b790a7.Button_module_middle__c8b790a7{border-radius:0;margin-left:-1px}.Button_module_groupButton__c8b790a7.Button_module_last__c8b790a7{border-bottom-left-radius:0;border-bottom-right-radius:3px;border-top-left-radius:0;border-top-right-radius:3px;margin-left:-1px}.Button_module_buttonContents__c8b790a7{display:inline-flex;opacity:1;transition:opacity .5s ease-in-out}.Button_module_textHidden__c8b790a7{opacity:0}.Button_module_icon_Enabled__c8b790a7{pointer-events:auto}.Button_module_loadingIcon__c8b790a7{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.Button_module_loadingIcon__c8b790a7 circle:first-child{stroke:#fff3}.Button_module_loadingIcon__c8b790a7.Button_module_secondary__c8b790a7,.Button_module_secondary__c8b790a7>.Button_module_loadingIcon__c8b790a7 circle:first-child{stroke:#365ef633}.Button_module_loading__c8b790a7{cursor:default;pointer-events:none}.Button_module_loading__c8b790a7:focus{box-shadow:none}.Button_module_skeleButton__c8b790a7{height:auto!important;inset:6px 12px;position:absolute;width:auto!important}.Button_module_skeleButton__c8b790a7 .Button_module_most__c8b790a7{width:75%}.Button_module_skeleButton__c8b790a7 .Button_module_half__c8b790a7{width:50%}";
window.ADS.injectStyle(css$13,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/Button.module.scss");
var modules_79b43374 = {"grow":"Button_module_grow__c8b790a7","button":"Button_module_button__c8b790a7","appear-disabled":"Button_module_appearDisabled__c8b790a7","iconLeft":"Button_module_iconLeft__c8b790a7","iconRight":"Button_module_iconRight__c8b790a7","noMinWidth":"Button_module_noMinWidth__c8b790a7","primary":"Button_module_primary__c8b790a7","focus":"Button_module_focus__c8b790a7","loading":"Button_module_loading__c8b790a7","primary-icon-stroke":"Button_module_primaryIconStroke__c8b790a7","primary-icon-stroke--disabled":"Button_module_primaryIconStroke_Disabled__c8b790a7","secondary":"Button_module_secondary__c8b790a7","secondary-icon-stroke":"Button_module_secondaryIconStroke__c8b790a7","secondary-icon-stroke--disabled":"Button_module_secondaryIconStroke_Disabled__c8b790a7","tertiary":"Button_module_tertiary__c8b790a7","tertiary-icon-stroke":"Button_module_tertiaryIconStroke__c8b790a7","tertiary-icon-stroke--disabled":"Button_module_tertiaryIconStroke_Disabled__c8b790a7","empty":"Button_module_empty__c8b790a7","sm":"Button_module_sm__c8b790a7","xs":"Button_module_xs__c8b790a7","link":"Button_module_link__c8b790a7","groupButton":"Button_module_groupButton__c8b790a7","first":"Button_module_first__c8b790a7","middle":"Button_module_middle__c8b790a7","last":"Button_module_last__c8b790a7","buttonContents":"Button_module_buttonContents__c8b790a7","textHidden":"Button_module_textHidden__c8b790a7","icon--enabled":"Button_module_icon_Enabled__c8b790a7","loadingIcon":"Button_module_loadingIcon__c8b790a7","skeleButton":"Button_module_skeleButton__c8b790a7","most":"Button_module_most__c8b790a7","half":"Button_module_half__c8b790a7"};

const TestIds = {
    icon: {
        left: 'button-left-icon',
        loading: 'button-loading-icon',
        right: (index) => `button-right-icon-${index}`
    }
};
/**
 * `Button` can be used as a standalone, clickable action button.
 */
const Button = React__default.forwardRef((_a, ref) => {
    var { autoFocus = false, children, disabled = false, icon = '', size = 'md', type = 'secondary' } = _a, props = __rest(_a, ["autoFocus", "children", "disabled", "icon", "size", "type"]);
    return (React__default.createElement(ButtonBase, Object.assign({ autoFocus: autoFocus, disabled: disabled, icon: icon, size: size, type: type }, props, { ref: ref }), children));
});
Button.displayName = 'Button'; //used for type validation in SplitButton
const IconPositionStyleMap = {
    left: modules_79b43374.iconLeft,
    center: modules_79b43374.loadingIcon,
    right: modules_79b43374.iconRight
};
const defaultFillClassIcons = [
    'AddIcon',
    'BackArrowIcon',
    'ChevronDoubleIcon',
    'ChevronDoubleUpIcon',
    'ChevronIcon',
    'ChevronUpIcon',
    'DownloadIcon',
    'FilterIcon',
    'FolderIcon',
    'SearchIcon',
    'ShiftDownIcon',
    'ShiftUpIcon'
];
// this is exported for use in SplitButton, but should still be internal only.
// DO NOT export in index.ts file.
const ButtonBase = React__default.forwardRef(({ type = 'secondary', size = 'md', autoFocus, appearDisabled = false, appearFocused = false, appearSkeleton = false, ariaLabel, children, className = '', customDataProps, disabled, groupChildType, icon, iconFillClass, iconFocused, iconSize, isClickableWhileLoading = false, isFocused, isLoading, loadingFadeTimeout = 500, overrideMinWidth = false, reset, rightIconsConfig, submit, tabIndex, testId, tooltip, onClick, onContextMenu, onFocus, onKeyDown, onMouseEnter, onMouseLeave }, ref) => {
    var _a;
    const { renderLoader, visibleLoader } = useFadingLoader(isLoading, loadingFadeTimeout);
    const isLoadingAsSkeleton = useIsLoadingAsSkeleton(isLoading !== null && isLoading !== void 0 ? isLoading : false, renderLoader, appearSkeleton);
    const sharedIconProps = React__default.useMemo(() => {
        return {
            ariaLabel,
            iconFocused,
            iconFillClass,
            iconSize,
            size,
            type
        };
    }, [ariaLabel, iconFocused, iconFillClass, iconSize, size, type]);
    const clickHandler = appearDisabled || disabled || (isLoading && !isClickableWhileLoading)
        ? undefined
        : onClick;
    const contextMenuHandler = React__default.useCallback((mouseEvent) => {
        if (!onContextMenu)
            return;
        if (appearDisabled ||
            disabled ||
            (isLoading && !isClickableWhileLoading))
            return;
        onContextMenu(mouseEvent);
    }, [
        appearDisabled,
        disabled,
        isClickableWhileLoading,
        isLoading,
        onContextMenu
    ]);
    const buttonElement = (React__default.createElement("button", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { type: submit ? 'submit' : reset ? 'reset' : 'button', disabled: disabled, autoFocus: autoFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: clickHandler, onContextMenu: contextMenuHandler, onFocus: onFocus, "data-test": testId, tabIndex: !isLoading || isClickableWhileLoading ? tabIndex : -1, onKeyDown: !isLoading || isClickableWhileLoading ? onKeyDown : undefined, className: cx$1S(isLoadingAsSkeleton && modules_79b43374['skeletonized'], appearDisabled && modules_79b43374['appear-disabled'], appearFocused && modules_79b43374.focus, modules_79b43374.button, modules_79b43374[type], modules_79b43374[size], icon ? modules_79b43374.iconLeft : '', 
        // dx-156: per UX, all buttons that are not solely displaying an icon get this minimum width
        icon && !children && modules_79b43374.noMinWidth, children ? '' : modules_79b43374.empty, groupChildType && modules_79b43374.groupButton, groupChildType && modules_79b43374[groupChildType], isLoading && !isClickableWhileLoading && modules_79b43374.loading, overrideMinWidth && modules_79b43374.noMinWidth, className), ref: MergeRefs([
            ref,
            (el) => {
                if (isFocused && el) {
                    // We use requestAnimationFrame because without it we were seeing an issue
                    // of the focus being lost if multiple buttons tried focusing themselves
                    // at the same time.
                    window.requestAnimationFrame(() => el.focus());
                }
            }
        ]) }),
        icon && (React__default.createElement(ButtonBaseIcon, Object.assign({}, sharedIconProps, { disabled: disabled, icon: icon, renderPosition: "left", testId: TestIdUtils.composeId(testId, TestIds.icon.left), visible: !isLoading }))),
        React__default.createElement("div", { className: cx$1S(modules_79b43374.buttonContents, isLoading ? modules_79b43374.textHidden : '', !renderLoader &&
                rightIconsConfig &&
                rightIconsConfig.some((config) => true === config.visible)
                ? modules_79b43374.grow
                : '') }, children),
        !renderLoader &&
            rightIconsConfig &&
            rightIconsConfig.map((config, index) => {
                let isDisabled;
                if (!disabled && !appearDisabled)
                    isDisabled = false;
                else if (appearDisabled && config.allowHover)
                    isDisabled = false;
                else if (appearDisabled && !config.allowHover)
                    isDisabled = true;
                else
                    isDisabled = disabled;
                return (React__default.createElement(ButtonBaseIcon, Object.assign({ key: index }, sharedIconProps, { allowHover: config.allowHover, disabled: isDisabled, icon: config.icon, renderPosition: "right", testId: TestIdUtils.composeId(testId, TestIds.icon.right(index)), tooltip: config.tooltip, visible: config.visible })));
            }),
        renderLoader && !isLoadingAsSkeleton && (React__default.createElement(ButtonBaseIcon, Object.assign({}, sharedIconProps, { disabled: disabled, icon: 'SpinnerIcon', renderPosition: "center", testId: TestIdUtils.composeId(testId, TestIds.icon.loading), visible: visibleLoader }))),
        renderLoader && isLoadingAsSkeleton && (React__default.createElement(SkeletonLoader, { className: cx$1S(modules_79b43374['skeleButton'], !renderLoader && modules_79b43374['textHidden']), testId: TestIdUtils.composeId(testId, 'skeleton-loader') }))));
    return (React__default.createElement(React__default.Fragment, null, tooltip ? (React__default.createElement(Tooltip, Object.assign({}, tooltip, { trigger: (_a = tooltip.trigger) !== null && _a !== void 0 ? _a : 'mouseenter focusin' }), buttonElement)) : (buttonElement)));
});
ButtonBase.displayName = 'ButtonBase';
/**
 * This component was originally a `renderIcon` function that was declared
 * within {@link ButtonBase} (on each render).
 *
 * Here, we have pulled this component out into its own function.
 *
 * Also see {@link ButtonBaseIconProps} & {@link PropsNeededFromButtonBase}.
 */
function ButtonBaseIcon({ allowHover, renderPosition, tooltip, visible, 
// inherited
ariaLabel, disabled, icon, iconFocused, iconFillClass, iconSize, size, testId, type }) {
    const defaultFill = typeof icon === 'string' && defaultFillClassIcons.includes(icon);
    const strokeFill = cx$1S(modules_79b43374[disabled ? `${type}-icon-stroke--disabled` : `${type}-icon-stroke`]);
    const eventHandler = allowHover ? CancelReactEvent : undefined;
    // always: add the icon
    let jsxContent = (React__default.createElement(Icon, { fillClass: iconFillClass || (defaultFill ? strokeFill : ''), focused: iconFocused, icon: icon, onClick: eventHandler, size: iconSize !== null && iconSize !== void 0 ? iconSize : { md: 16, sm: 14, xs: 12 }[size], strokeClass: strokeFill, testId: testId }));
    // optional: add a tooltip
    if (tooltip) {
        jsxContent = React__default.createElement(Tooltip, { content: tooltip }, jsxContent);
    }
    // always: add a div wrapper
    return (React__default.createElement("div", { "aria-expanded": iconFocused, "aria-label": ariaLabel, "data-button-icon": renderPosition, className: cx$1S(allowHover && modules_79b43374['icon--enabled'], IconPositionStyleMap[renderPosition], modules_79b43374.buttonContents, !visible && modules_79b43374.textHidden), onClick: eventHandler, onMouseDown: eventHandler, onMouseUp: eventHandler }, jsxContent));
}
//#endregion Button Icon
//#region hook for placeholder-loading state
/**
 * Added in DX-1091 (03/2025) to allow for the button to appear loading
 * but with a skeleton style instead of the spinner.
 *
 * @param isLoading
 * @param renderLoader
 * @param appearSkeleton
 * @returns - whether the button should appear at this moment as a skeleton or not
 */
function useIsLoadingAsSkeleton(isLoading, renderLoader, appearSkeleton) {
    // we need an always-fresh reference to the appearSkeleton value
    const freshRef = React__default.useRef(appearSkeleton);
    React__default.useEffect(() => {
        freshRef.current = appearSkeleton;
    });
    // we need to cache the value of appearSkeleton when `isLoading` changes
    const cachedRef = React__default.useRef({
        appearSkeleton
    });
    React__default.useEffect(() => {
        cachedRef.current = {
            appearSkeleton: freshRef.current
        };
    }, [isLoading]);
    const isLoadingAsSkeleton = React__default.useMemo(() => {
        /**
         * We are loading as a skeleton if:
         * - 1) we were told to `appearSkeleton` on the same render that `isLoading` changed
         * - 2) we are still loaded per `renderLoader`
         */
        return renderLoader && cachedRef.current.appearSkeleton;
    }, [renderLoader]);
    return isLoadingAsSkeleton;
}
//#endregion hook for placeholder-loading state

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$1d = classnames.bind(modules_0a537303);
const ASIInternal_UKSearchField = ({ name, fieldNames, country, helpText, disabled = false, required = false, desired = false, manualMode = false, disableAutofill = false, testId, onSelection, onClear, onManualMode }, ref) => {
    var _a;
    const { t } = useTranslation();
    const localSearchFieldRef = React__default.useRef(null);
    const comboHelpersRef = React__default.useRef(null);
    const comboHelpers = (helpers) => {
        comboHelpersRef.current = helpers;
    };
    const [searchText, setSearchText] = React__default.useState(''); // search box text
    const [query, setQuery] = React__default.useState(''); // current query
    const [selected, setSelected] = React__default.useState(); // selected suggestion
    const { loading, suggestions, retrieveAddress } = useUKAddressLookup(query);
    const suggestionDescriptions = React__default.useMemo(() => suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((s) => s.description), [suggestions]);
    const handleFindClick = () => {
        if (searchText) {
            setQuery(searchText);
            setSelected(null);
        }
        else {
            onClear();
        }
    };
    const handleKeyDown = (e) => {
        // If the search field is focused, enter causes a query to happen.
        if (ElementIsOrChildOf(document.activeElement, [localSearchFieldRef.current])) {
            KeyHandleMap(e, [{ Enter: handleFindClick }]);
        }
    };
    React__default.useEffect(() => {
        var _a;
        if (suggestions && suggestions.length > 0) {
            // Open the suggestions dropdown when they are refreshed.
            (_a = comboHelpersRef === null || comboHelpersRef === void 0 ? void 0 : comboHelpersRef.current) === null || _a === void 0 ? void 0 : _a.selectInputText(true);
        }
    }, [suggestions]);
    const handleSelection = (e) => {
        const picked = suggestions === null || suggestions === void 0 ? void 0 : suggestions.find((s) => s.description === e);
        setSelected(picked);
        if (picked) {
            retrieveAddress(picked.id).then((address) => {
                if (address) {
                    const currentState = Object.assign(Object.assign({}, address), { country: country });
                    const event = {
                        target: { name: 'suggestion', value: Object.assign({}, currentState) }
                    };
                    onSelection(event);
                }
            });
        }
    };
    const preventLookup = (!searchText || searchText === query) && !loading;
    return (React__default.createElement(Flex, { className: "gap-h-200 gap-v-100" },
        React__default.createElement(Flex, { className: "flex-no-wrap gap-h-100 flex-align-space-between" },
            React__default.createElement("div", { onKeyDown: handleKeyDown, className: cx$1d('keyCapture', 'flex-item') },
                React__default.createElement(TextField, { testId: TestIdUtils.composeId(testId, 'search-field'), ref: MergeRefs([localSearchFieldRef, ref]), className: "flex-item minw-320", name: AddressFieldName(AddressFields.AddressSearch, name, fieldNames), value: manualMode ? '' : searchText, defaultLabel: t('ADDRESS_SEARCH'), placeholder: t('SEARCH_BY_POSTCODE'), disabled: disabled || manualMode, required: required, desired: desired, helpText: helpText, onChange: (e) => setSearchText(e.target.value), disableAutoFill: disableAutofill, startIcon: { name: 'SearchIcon' } })),
            React__default.createElement("div", { "data-test": TestIdUtils.composeId(testId, 'find-address-btn-wrapper'), className: "flex-item mt-150" },
                React__default.createElement(Button, { testId: `addr-find-${name}`, disabled: disabled || manualMode || preventLookup, onClick: handleFindClick, type: "primary", isLoading: !disabled && loading }, t('FIND_ADDRESS')))),
        !disabled && (React__default.createElement(Flex, { className: 'flex-d-column gap-0' },
            React__default.createElement(LabelSpacer, null),
            React__default.createElement(FieldHeightText, { className: "flex-grow-0" },
                React__default.createElement(Button, { testId: `addr-edit-${name}`, disabled: disabled || loading, type: "link", onClick: () => {
                        setSelected(null);
                        onManualMode();
                    } }, !manualMode
                    ? t('EDIT_ADDRESS_MANUALLY')
                    : t('USE_ADDRESS_SEARCH'))))),
        query && suggestions && suggestions.length > 0 && (React__default.createElement(Combobox, { testId: `addr-find-options-${name}`, helpers: comboHelpers, placeholder: loading ? t('LOCATING') : t('PLEASE_SELECT'), disabled: disabled || manualMode || loading, items: suggestionDescriptions, name: AddressFieldName(AddressFields.AddressSearchOptions, name, fieldNames), onChange: (e) => handleSelection(e.target.value), value: (_a = selected === null || selected === void 0 ? void 0 : selected.description) !== null && _a !== void 0 ? _a : '' })),
        !disabled &&
            !manualMode &&
            query &&
            suggestions &&
            suggestions.length === 0 && (React__default.createElement("div", { className: cx$1d('noResults') },
            t('NO_ADDRESS_RESULTS_FOUND'),
            ' ',
            React__default.createElement(Button, { testId: `addr-no-items-edit-${name}`, disabled: disabled, type: "link", onClick: () => {
                    onManualMode();
                } }, t('EDIT_ADDRESS_MANUALLY'))))));
};
const UKSearchField = React__default.forwardRef(ASIInternal_UKSearchField);
UKSearchField.displayName = 'UKSearchField';

/* eslint-disable @typescript-eslint/no-explicit-any */
const defaultValue$2 = {
    streetLine: '',
    address2: '',
    address3: '',
    city: '',
    postalCode: '',
    county: '',
    country: 'United Kingdom'
};
const UkAddress = ({ addressWidth, disabled, readOnly, required, desired, disableAutoFill, disableLookup, name, subFormName, onChange, value = defaultValue$2, updateFormValues, helpText, fieldNames, defaultLabels, fieldVisibilityConfig, onFieldBlur, onFieldFocus, onSuggestionSelected, onContextMenu, fieldMaxLengths, testId }) => {
    var _a, _b;
    const { t } = useTranslation();
    const [counties, setCounties] = React__default.useState(UKCounties);
    const [manualMode, setManualMode] = React__default.useState(false);
    const searchFieldRef = React__default.useRef(null);
    const streetLineRef = React__default.useRef(null);
    const isReadOnly = React__default.useMemo(() => readOnly || !manualMode, [readOnly, manualMode]);
    const tabStop = React__default.useMemo(() => (manualMode ? 0 : -1), [manualMode]);
    //disable lookup forces manual mode
    React__default.useEffect(() => {
        if (disableLookup)
            setManualMode(true);
    }, [disableLookup]);
    // Whenever our value changes, we need to invoke onChange
    // and notify our parent.
    const sendOnChange = React__default.useCallback((address) => {
        if (fieldMaxLengths) {
            address = trimAddress(address, fieldMaxLengths);
        }
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onChange && onChange(event);
    }, [onChange, value, name, fieldMaxLengths]);
    // Whenever an address suggestion is selected, we need to invoke onSuggestionSelected
    // and notify our parent.
    const sendSuggestionSelected = React__default.useCallback((address) => {
        if (fieldMaxLengths) {
            address = trimAddress(address, fieldMaxLengths);
        }
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onSuggestionSelected && onSuggestionSelected(event);
    }, [onSuggestionSelected, value, name, fieldMaxLengths]);
    const handleChange = React__default.useCallback((e) => {
        // This the input's name is going to be prefixed with the address comp's
        // name, and if it's in a subForm, also have the subForm name prefixed in front
        // of that.
        const addressCompName = subFormName
            ? `${subFormName}.${name}-`
            : `${name}-`;
        const targetName = e.target.name.replace(addressCompName, '');
        sendOnChange(Object.assign(Object.assign({}, value), { [targetName]: e.target.value, verified: false }));
        updateFormValues && updateFormValues({ verified: false });
    }, [value, name, subFormName, sendOnChange, updateFormValues]);
    const handleClear = React__default.useCallback(() => {
        updateFormValues && updateFormValues(defaultValue$2);
        sendOnChange(defaultValue$2);
    }, [updateFormValues, sendOnChange]);
    const handleSelection = React__default.useCallback((e) => {
        updateFormValues && updateFormValues(e.target.value);
        sendOnChange(e.target.value);
        sendSuggestionSelected(e.target.value);
    }, [sendOnChange, updateFormValues, sendSuggestionSelected]);
    const handleBlur = (event) => {
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    // Whenever an AddressField gains focus, we need to invoke onFieldFocus
    // and notify the parent.
    const handleFocus = React__default.useCallback((event) => {
        onFieldFocus && onFieldFocus(event);
    }, [onFieldFocus]);
    const handleContextMenu = (event) => {
        // Whenever an AddressField context menu is opened, we need to invoke onContextMenu
        // and notify the parent.
        onContextMenu && onContextMenu(event);
    };
    const handleCustomCounty = React__default.useCallback((newCounty) => {
        if (!newCounty) {
            return;
        }
        if (!counties.includes(newCounty)) {
            setCounties([...counties, newCounty]);
        }
        handleChange({ target: { name: `${name}-county`, value: newCounty } });
    }, [handleChange, counties, name]);
    // Can't just use en-GB to apply these US-based apps can still display the UK controls
    // when the country value is swapped - so we have a separate UK list.
    const defaultStreetLabelsUK = Object.assign({ streetLine: t('STREET_UK'), address2: t('STREET2_UK'), address3: t('STREET3_UK'), address4: t('STREET4_UK') }, defaultLabels);
    const isCompact = addressWidth !== null ? addressWidth <= 480 : false;
    return (React__default.createElement(Row, null,
        !disableLookup && (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement(UKSearchField, { ref: searchFieldRef, name: name, fieldNames: fieldNames, country: (_a = value.country) !== null && _a !== void 0 ? _a : 'United Kingdom', helpText: helpText && helpText[AddressFields.AddressSearch], disabled: disabled || readOnly, required: required, desired: desired, manualMode: manualMode, onManualMode: () => {
                    var _a;
                    const newManualMode = !manualMode;
                    setManualMode(newManualMode);
                    if (newManualMode) {
                        (_a = streetLineRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    else {
                        /**
                         * Without this, the search field will not be focused. This is a similar
                         * pattern we follow with the Button component.
                         */
                        window.requestAnimationFrame(() => {
                            var _a;
                            (_a = searchFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        });
                    }
                }, onSelection: handleSelection, onClear: handleClear }))),
        React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement(StreetLine, { testId: TestIdUtils.composeId(testId, AddressFields.Street), ref: streetLineRef, name: name, fieldNames: fieldNames, defaultLabels: defaultStreetLabelsUK, disabled: disabled, readOnly: isReadOnly, required: required, desired: desired, tabIndex: tabStop, helpText: helpText && helpText[AddressFields.Street], value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine })),
        React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine2, { testId: TestIdUtils.composeId(testId, AddressFields.Address2), name: name, fieldNames: fieldNames, defaultLabels: defaultStreetLabelsUK, helpText: helpText && helpText[AddressFields.Address2], disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address2 })),
        fieldVisibilityConfig.showStreetLineCount >= 3 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine3, { testId: TestIdUtils.composeId(testId, AddressFields.Address3), name: name, fieldNames: fieldNames, defaultLabels: defaultStreetLabelsUK, helpText: helpText && helpText[AddressFields.Address3], disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address3 }))) : null,
        fieldVisibilityConfig.showStreetLineCount >= 4 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine4, { testId: TestIdUtils.composeId(testId, AddressFields.Address4), name: name, fieldNames: fieldNames, defaultLabels: defaultStreetLabelsUK, helpText: helpText && helpText[AddressFields.Address4], disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address4 }))) : null,
        React__default.createElement(Col, { xs: 12, sm: isCompact ? 6 : 5 },
            React__default.createElement(City, { testId: TestIdUtils.composeId(testId, AddressFields.City), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.City], disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.city })),
        fieldVisibilityConfig.showCounty ? (React__default.createElement(Col, { xs: 12, sm: isCompact ? 6 : 4 },
            React__default.createElement(Combobox, { testId: TestIdUtils.composeId(testId, AddressFields.County), disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, helpText: helpText && helpText[AddressFields.State], name: AddressFieldName(AddressFields.County, name, fieldNames), defaultLabel: (_b = (defaultLabels && defaultLabels[AddressFields.State])) !== null && _b !== void 0 ? _b : t('COUNTY_UK'), items: counties, value: value.county, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onCustomValue: handleCustomCounty, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill }))) : null,
        React__default.createElement(Col, { xs: isCompact ? 6 : 3 },
            React__default.createElement(PostalCode, { testId: TestIdUtils.composeId(testId, AddressFields.PostalCode), format: "uk-post", name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.PostalCode], defaultLabel: t('POSTAL_UK'), disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill })),
        fieldVisibilityConfig.showCountry ? (React__default.createElement(Col, { xs: 12, sm: 6 },
            React__default.createElement(Country, { testId: TestIdUtils.composeId(testId, AddressFields.Country), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Country], disabled: disabled, readOnly: isReadOnly, tabIndex: tabStop, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill }))) : null));
};

var css$12 = ".CloseButton_module_closeIcon__26f31cd3{background:#0000;border:none;border-radius:4px;cursor:pointer;display:inline-block;outline:none;padding:2px;transition:border-color .15s,background-color .15s,color .15s}.CloseButton_module_closeIcon__26f31cd3 svg path{fill:#858b9d}.CloseButton_module_closeIcon__26f31cd3.CloseButton_module_md__26f31cd3{padding:6px}.CloseButton_module_closeIcon__26f31cd3.CloseButton_module_disabled__26f31cd3{cursor:default}.CloseButton_module_closeIcon__26f31cd3.CloseButton_module_disabled__26f31cd3 svg path{fill:#cbced7;cursor:default}.CloseButton_module_closeIcon__26f31cd3:not(.CloseButton_module_disabled__26f31cd3):hover{background:#e5e6eb}.CloseButton_module_closeIcon__26f31cd3:not(.CloseButton_module_disabled__26f31cd3):active{background:#d9dbe3;box-shadow:none}.CloseButton_module_closeIcon__26f31cd3:not(.CloseButton_module_disabled__26f31cd3):focus{box-shadow:0 0 0 4px #365ef64d}.CloseButton_module_closeIcon__26f31cd3:not(.CloseButton_module_disabled__26f31cd3):focus:active{box-shadow:none}";
window.ADS.injectStyle(css$12,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/CloseButton.module.scss");
var modules_0ddd42df = {"closeIcon":"CloseButton_module_closeIcon__26f31cd3","md":"CloseButton_module_md__26f31cd3","disabled":"CloseButton_module_disabled__26f31cd3"};

const cx$1c = classnames.bind(modules_0ddd42df);
const CloseButton = React__default.forwardRef(({ customDataProps, testId, className, autoFocus = false, disabled = false, size = 'md', v2Spacing, onClick }, ref) => {
    useADSWarnOnce('CloseButton sizes will be changing in the future. Please use the v2Spacing prop to opt into the new sizing.', !v2Spacing);
    const iconSizeMap = { xs: 16, sm: 18, md: 20 };
    const iconSizeMapV2 = { xs: 12, sm: 16, md: 20 };
    const handleKeyDown = (e) => {
        const handled = KeyHandleMap(e, [{ Enter: () => onClick && onClick(e) }]);
        if (handled) {
            CancelReactEvent(e);
        }
    };
    const handleOnClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };
    return (React__default.createElement("button", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, autoFocus: autoFocus, ref: ref, onKeyDown: handleKeyDown, onClick: handleOnClick, className: cx$1c('closeIcon', className, size, { disabled }) }),
        React__default.createElement(Icon, { icon: "CloseIcon", strokeClass: cx$1c('closeIcon'), size: v2Spacing ? iconSizeMapV2[size] : iconSizeMap[size] })));
});
CloseButton.displayName = 'CloseButton';

var css$11 = ".InlineAlert_module_alert__fffbf240{border-radius:5px;display:flex;flex-direction:row-reverse;padding:12px 12px 12px 16px}.InlineAlert_module_alert__fffbf240 .InlineAlert_module_icon__fffbf240{height:20px;width:20px}.InlineAlert_module_alert__fffbf240 .InlineAlert_module_content__fffbf240{color:#363840;flex:1;font-size:14px;font-weight:400;line-height:20px;padding-left:8px}.InlineAlert_module_alert__fffbf240 .InlineAlert_module_closeButtonWrapper__fffbf240{padding-left:16px}.InlineAlert_module_alert__fffbf240 .InlineAlert_module_closeButton__fffbf240 svg path{stroke:#444750}.InlineAlert_module_alert__fffbf240.InlineAlert_module_info__fffbf240{background-color:#f1f4fd;border:1px solid #aabff8}.InlineAlert_module_alert__fffbf240.InlineAlert_module_info__fffbf240 .InlineAlert_module_closeButton__fffbf240:hover{background-color:#365ef626}.InlineAlert_module_alert__fffbf240.InlineAlert_module_info__fffbf240 .InlineAlert_module_closeButton__fffbf240:focus{box-shadow:0 0 0 4px #365ef64d}.InlineAlert_module_alert__fffbf240.InlineAlert_module_info__fffbf240 .InlineAlert_module_closeButton__fffbf240:active{background:#365ef640;box-shadow:none}.InlineAlert_module_alert__fffbf240.InlineAlert_module_error__fffbf240{background-color:#fff5f7;border:1px solid #fba7ba}.InlineAlert_module_alert__fffbf240.InlineAlert_module_error__fffbf240 .InlineAlert_module_closeButton__fffbf240:hover{background-color:#ea0a3b26}.InlineAlert_module_alert__fffbf240.InlineAlert_module_error__fffbf240 .InlineAlert_module_closeButton__fffbf240:focus{box-shadow:0 0 0 4px #ea0a3b4d}.InlineAlert_module_alert__fffbf240.InlineAlert_module_error__fffbf240 .InlineAlert_module_closeButton__fffbf240:active{background:#ea0a3b40;box-shadow:none}.InlineAlert_module_alert__fffbf240.InlineAlert_module_warning__fffbf240{background-color:#fff8f5;border:1px solid #fab193}.InlineAlert_module_alert__fffbf240.InlineAlert_module_warning__fffbf240 .InlineAlert_module_closeButton__fffbf240:hover{background-color:#f4511026}.InlineAlert_module_alert__fffbf240.InlineAlert_module_warning__fffbf240 .InlineAlert_module_closeButton__fffbf240:focus{box-shadow:0 0 0 4px #f451104d}.InlineAlert_module_alert__fffbf240.InlineAlert_module_warning__fffbf240 .InlineAlert_module_closeButton__fffbf240:active{background:#f4511040;box-shadow:none}.InlineAlert_module_alert__fffbf240.InlineAlert_module_success__fffbf240{background-color:#f1fefb;border:1px solid #68eed1}.InlineAlert_module_alert__fffbf240.InlineAlert_module_success__fffbf240 .InlineAlert_module_closeButton__fffbf240:hover{background-color:#03866a26}.InlineAlert_module_alert__fffbf240.InlineAlert_module_success__fffbf240 .InlineAlert_module_closeButton__fffbf240:focus{box-shadow:0 0 0 4px #03866a4d}.InlineAlert_module_alert__fffbf240.InlineAlert_module_success__fffbf240 .InlineAlert_module_closeButton__fffbf240:active{background:#03866a40;box-shadow:none}";
window.ADS.injectStyle(css$11,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/InlineAlert/InlineAlert.module.scss");
var modules_13a6380f = {"alert":"InlineAlert_module_alert__fffbf240","icon":"InlineAlert_module_icon__fffbf240","content":"InlineAlert_module_content__fffbf240","closeButtonWrapper":"InlineAlert_module_closeButtonWrapper__fffbf240","closeButton":"InlineAlert_module_closeButton__fffbf240","info":"InlineAlert_module_info__fffbf240","error":"InlineAlert_module_error__fffbf240","warning":"InlineAlert_module_warning__fffbf240","success":"InlineAlert_module_success__fffbf240"};

const cx$1b = classnames.bind(modules_13a6380f);
const InlineAlert = ({ customDataProps, id, testId, type = BrandType.Info, onClose, closeable = true, children }) => {
    const [show, setShow] = React__default.useState(true);
    const icon = `${capitalize(type)}IconFilled`;
    const ref = React__default.useRef(null);
    const closeButtonRef = React__default.useRef(null);
    const handleOnClose = () => {
        setShow(false);
        onClose && onClose({ id });
    };
    const handleKeyDown = (e) => {
        const handled = KeyHandleMap(e, [
            {
                Escape: handleOnClose
            }
        ]);
        if (handled) {
            CancelReactEvent(e);
        }
    };
    const focusCloseButton = () => {
        var _a;
        (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
            preventScroll: false
        });
    };
    const focusHandler = (e) => {
        // React <17 uses focusin (not focus) which
        // will fire when a focus event happens whithin
        // it's container (bubble). So we only want to do this
        // if the parent was focused, or the related target isn't the close button.
        // This handles both tabbing in, and tabbing out (shift + tab)
        if (e.target === ref.current &&
            e.relatedTarget !== closeButtonRef.current) {
            focusCloseButton();
        }
    };
    return show ? (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: ref, onFocus: focusHandler, tabIndex: -1, "data-test": testId || id, onKeyDown: handleKeyDown, className: cx$1b('alert', type) }),
        closeable && (React__default.createElement("div", { className: cx$1b('closeButtonWrapper') },
            React__default.createElement(CloseButton, { size: "xs", v2Spacing: true, ref: closeButtonRef, onClick: () => handleOnClose(), className: cx$1b('closeButton') }))),
        React__default.createElement("div", { className: cx$1b('content') }, children),
        React__default.createElement("div", null,
            React__default.createElement(Icon, { icon: icon, size: 20, strokeClass: cx$1b('iconStroke'), className: cx$1b('icon') })))) : null;
};

const DEFAULT_COUNTRY = 'United States';
const defaultValue$1 = {
    streetLine: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    county: '',
    country: DEFAULT_COUNTRY
};
const UsAddress = ({ addressWidth, defaultLabels, disableAutoFill, disabled, disableLookup, disableStrict, fieldNames, fieldVisibilityConfig, helpText, manualModeConfig, name, readOnly, required, desired, subFormName, unverifiedMessage, validateOnLoad, validateOnMountConfig, value = defaultValue$1, zipPlus4, onChange, onFieldBlur, onFieldFocus, onSuggestionSelected, onContextMenu, updateFormValues, fieldMaxLengths, testId }) => {
    var _a, _b, _c, _d;
    const smartyStreets = React__default.useRef(new SmartyStreetClient());
    const { t } = useTranslation();
    const [manualMode, setManualMode] = React__default.useState(undefined);
    const [suggestions, setSuggestions] = React__default.useState([]);
    const [verifiedPrev, setVerifiedPrev] = React__default.useState(false);
    const [hasAttemptedMountValidation, setHasAttemptedMountValidation] = React__default.useState(false);
    const streetLineRef = React__default.useRef(null);
    const searchFieldRef = React__default.useRef(null);
    const isManualMode = React__default.useMemo(() => {
        if (manualModeConfig === null || manualModeConfig === void 0 ? void 0 : manualModeConfig.onManualMode) {
            return manualModeConfig.manualMode;
        }
        return manualMode;
    }, [
        manualMode,
        manualModeConfig === null || manualModeConfig === void 0 ? void 0 : manualModeConfig.manualMode,
        manualModeConfig === null || manualModeConfig === void 0 ? void 0 : manualModeConfig.onManualMode
    ]);
    const handleOnManualMode = React__default.useCallback((manualMode) => {
        var _a;
        if (manualModeConfig === null || manualModeConfig === void 0 ? void 0 : manualModeConfig.onManualMode) {
            manualModeConfig === null || manualModeConfig === void 0 ? void 0 : manualModeConfig.onManualMode(manualMode);
        }
        else {
            setManualMode(manualMode);
        }
        // toggle focus between the street line 1 field in manual mode and the search field when not in manual mode
        if (manualMode) {
            (_a = streetLineRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            /**
             * Without this, the search field will not be focused. This is a similar
             * pattern we follow with the Button component.
             */
            window.requestAnimationFrame(() => {
                var _a;
                (_a = searchFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
    }, [manualModeConfig]);
    const mode = React__default.useMemo(() => !disableStrict
        ? AddressMode.Strict
        : disableLookup
            ? AddressMode.Default
            : AddressMode.Lookup, [disableLookup, disableStrict]);
    const isReadOnly = React__default.useMemo(() => readOnly || (mode === AddressMode.Strict && !isManualMode), [readOnly, mode, isManualMode]);
    // We have a race condition where both blur and selecting suggestion
    const blurTimerRef = React__default.useRef(null);
    // No ideal but for some reason some of our methods like onBlur will have a
    // stale version of the value prop unless we use a ref.
    const valueRef = React__default.useRef(value);
    React__default.useEffect(() => {
        valueRef.current = value;
    }, [value]);
    const addressSearch = React__default.useMemo(() => {
        return mode === AddressMode.Lookup ? value.streetLine : value.addressSearch;
    }, [mode, value.addressSearch, value.streetLine]);
    // If we are mounted and address line 1 has a value, we need to load
    // suggestions to show in the auto complete dropdown.
    React__default.useEffect(() => {
        // If we have a value for street address 1 and suggestions are empty, re-fill them
        if (mode !== AddressMode.Default && addressSearch && !suggestions.length) {
            smartyStreets.current
                .queryAutocompleteForSuggestions(addressSearch, DEFAULT_COUNTRY)
                .then((suggestions) => buildSuggestion(suggestions));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Whenever our value changes, we need to invoke onChange
    // and notify our parent.
    const sendOnChange = React__default.useCallback((address) => {
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onChange && onChange(event);
    }, [onChange, value, name]);
    // If we have validateOnMountConfig.validateOnMount or validateOnLoad (deprecated),
    // and we are not mounting directly into manual mode, validate the address.
    React__default.useEffect(() => {
        if ((validateOnLoad || (validateOnMountConfig === null || validateOnMountConfig === void 0 ? void 0 : validateOnMountConfig.validateOnMount)) &&
            !value.verified &&
            !hasAttemptedMountValidation &&
            !isManualMode) {
            smartyStreets.current
                .validateUsAddress(value, zipPlus4)
                .then((verifiedAddress) => {
                updateFormValues && updateFormValues(verifiedAddress);
                if (fieldMaxLengths) {
                    verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                }
                if (verifiedAddress.verified) {
                    setVerifiedPrev(true);
                }
                else {
                    if (validateOnMountConfig === null || validateOnMountConfig === void 0 ? void 0 : validateOnMountConfig.validateOnMount)
                        validateOnMountConfig.onFailedValidation &&
                            validateOnMountConfig.onFailedValidation();
                }
                sendOnChange(verifiedAddress);
            });
        }
        // We need to assure this effect only runs once
        // whether validation is successful, unsuccessful, or skipped
        setHasAttemptedMountValidation(true);
    }, [
        validateOnMountConfig,
        value,
        updateFormValues,
        hasAttemptedMountValidation,
        sendOnChange,
        isManualMode,
        validateOnLoad,
        zipPlus4,
        fieldMaxLengths
    ]);
    // Whenever an address suggestion is selected, we need to invoke onSuggestionSelected
    // and notify our parent.
    const sendSuggestionSelected = React__default.useCallback((address) => {
        const event = {
            target: { name, value: Object.assign(Object.assign({}, value), address) }
        };
        onSuggestionSelected && onSuggestionSelected(event);
    }, [onSuggestionSelected, value, name]);
    const buildSuggestion = (suggestions) => {
        if (!suggestions) {
            console.warn('ADS: Address not able to build suggestions. Lookup failed.');
            return;
        }
        for (const suggestion of suggestions) {
            const builtAddress = smartyStreets.current.buildAddress(suggestion);
            suggestion.text = builtAddress;
            suggestion.isSelectable = suggestion.entries > 1 ? false : true;
            if (suggestion.entries && suggestion.entries > 1) {
                suggestion.badges = [
                    {
                        text: `${suggestion.entries} ${t('ENTRIES')}`
                    }
                ];
            }
        }
        setSuggestions(suggestions);
    };
    const queryAutocompleteForSuggestionsThrottled = useThrottledFunction((search, _) => {
        smartyStreets.current
            .queryAutocompleteForSuggestions(search, DEFAULT_COUNTRY)
            .then((suggestions) => buildSuggestion(suggestions));
    }, 500);
    // Whenever our search detects a value change, we query
    // smarty streets for suggestions.
    const handleChangeSearch = throttle$1((e) => {
        const search = e.target.value;
        sendOnChange(Object.assign(Object.assign({}, value), { [mode === AddressMode.Lookup ? 'streetLine' : 'addressSearch']: search, verified: false }));
        updateFormValues && updateFormValues({ verified: false });
        if (mode !== AddressMode.Default && search) {
            queryAutocompleteForSuggestionsThrottled(search, value.country || '');
        }
        else {
            //set an empty suggestion[] if street is blank
            setSuggestions([]);
        }
    }, 500);
    const handleChange = (e) => {
        // This the input's name is going to be prefixed with the address comp's
        // name, and if it's in a subForm, also have the subForm name prefixed in front
        // of that.
        const addressCompName = subFormName
            ? `${subFormName}.${name}-`
            : `${name}-`;
        const targetName = e.target.name.replace(addressCompName, '');
        sendOnChange(Object.assign(Object.assign({}, value), { [targetName]: e.target.value, verified: false }));
        updateFormValues && updateFormValues({ verified: false });
    };
    const handleSelectionSearch = (e) => {
        setVerifiedPrev(false);
        if (e.entries <= 1) {
            const currentState = Object.assign(Object.assign({}, value), { streetLine: e.streetLine, address2: e.address2, city: e.city, state: e.stateOrProvince, zipCode: e.postalCode });
            if (mode !== AddressMode.Default && !smartyStreets.current.isVerifying) {
                if (blurTimerRef.current) {
                    clearTimeout(blurTimerRef.current);
                }
                smartyStreets.current
                    .validateUsAddress(currentState, zipPlus4)
                    .then((verifiedAddress) => {
                    if (fieldMaxLengths) {
                        verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                    }
                    updateFormValues && updateFormValues(verifiedAddress);
                    if (verifiedAddress.verified) {
                        setVerifiedPrev(true);
                    }
                    sendOnChange(verifiedAddress);
                    sendSuggestionSelected(verifiedAddress);
                });
            }
        }
        else {
            const selected = smartyStreets.current.buildForSecondaryAddress(e);
            smartyStreets.current
                .queryAutocompleteForSecondarySuggestions(e.streetLine, selected, value.country || '')
                .then((suggestions) => {
                buildSuggestion(suggestions);
                sendOnChange(Object.assign(Object.assign({}, e), { verified: false }));
            });
        }
    };
    const handleBlur = (event) => {
        // On blur if we are not verified and are not currently verifying
        // an address, attempt to verify our current value. This isn't ideal
        // using a setTimeout, but there isn't a better way right now.
        blurTimerRef.current = setTimeout(() => {
            if (mode === AddressMode.Lookup && !verifiedPrev) {
                if (!smartyStreets.current.isVerifying && !value.verified) {
                    smartyStreets.current
                        .validateUsAddress(valueRef.current, zipPlus4)
                        .then((verifiedAddress) => {
                        if (fieldMaxLengths) {
                            verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                        }
                        setVerifiedPrev(verifiedAddress.verified);
                        updateFormValues && updateFormValues(verifiedAddress);
                        sendOnChange(verifiedAddress);
                    });
                }
            }
        }, 150);
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    const handleFocus = (event) => {
        // Whenever an AddressField gains focus, we need to invoke onFieldFocus
        // and notify the parent.
        onFieldFocus && onFieldFocus(event);
    };
    const handleContextMenu = (event) => {
        // Whenever an AddressField context menu is opened, we need to invoke onContextMenu
        // and notify the parent.
        onContextMenu && onContextMenu(event);
    };
    const handleZipBlur = (event) => {
        if (mode === AddressMode.Lookup && !verifiedPrev) {
            if (!value.verified) {
                (() => __awaiter(void 0, void 0, void 0, function* () {
                    let zipCodeResults = {};
                    yield smartyStreets.current
                        .queryByZipCode(event.target.value || '', value.country || '', zipPlus4)
                        .then((address) => {
                        zipCodeResults = address;
                    });
                    smartyStreets.current
                        .validateUsAddress(Object.assign(Object.assign({}, value), zipCodeResults), zipPlus4)
                        .then((verifiedAddress) => {
                        if (fieldMaxLengths) {
                            verifiedAddress = trimAddress(verifiedAddress, fieldMaxLengths);
                        }
                        setVerifiedPrev(verifiedAddress.verified);
                        updateFormValues && updateFormValues(verifiedAddress);
                        sendOnChange(verifiedAddress);
                    });
                }))();
            }
        }
        // Whenever an AddressField blurs, we need to invoke onFieldBlur
        // and notify the parent.
        onFieldBlur && onFieldBlur(event);
    };
    const renderVerifyBadge = () => {
        if (value.verified) {
            return (React__default.createElement(Tooltip, { content: `${t('THIS_ADDRESS_VERIFIED_USPS')}` },
                React__default.createElement(Badge, { testId: "verifiedAddressBadge", type: "success" }, t('VERIFIED_ADDR'))));
        }
        else {
            if (smartyStreets.current.isVerifying) {
                return (React__default.createElement(Icon, { icon: "SpinnerIcon", size: 18, disabled: disabled, strokeClass: modules_0a537303.spinnerIcon }));
            }
            else {
                return null;
            }
        }
    };
    const isCompact = addressWidth !== null ? addressWidth <= 400 : false;
    return (React__default.createElement(Row, null,
        mode === AddressMode.Lookup && (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement("div", { className: modules_0a537303.verifiedContainer }, renderVerifyBadge()),
            React__default.createElement(SuggestionField, { testId: TestIdUtils.composeId(testId, AddressFields.Street), name: AddressFieldName(AddressFields.Street, name, fieldNames), helpText: helpText && helpText[AddressFields.Street], value: value.streetLine, defaultLabel: (_a = (defaultLabels && defaultLabels[AddressFields.Street])) !== null && _a !== void 0 ? _a : t('STREET'), disabled: disabled, readOnly: readOnly, required: required, desired: desired, noResultsText: t('NO_MATCHES_DATABASE_ADDR'), items: suggestions, toLabel: "text", onBlur: handleBlur, onChange: handleChangeSearch, onSelection: handleSelectionSearch, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine }))),
        mode === AddressMode.Strict && (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            React__default.createElement(Flex, { className: "gap-h-200" },
                React__default.createElement("div", { className: "flex-item" },
                    React__default.createElement(SuggestionField, { testId: TestIdUtils.composeId(testId, AddressFields.AddressSearch), ref: searchFieldRef, name: AddressFieldName(AddressFields.AddressSearch, name, fieldNames), helpText: helpText && helpText[AddressFields.AddressSearch], value: isManualMode ? undefined : value.addressSearch, defaultLabel: (_b = (defaultLabels &&
                            defaultLabels[AddressFields.AddressSearch])) !== null && _b !== void 0 ? _b : t('ADDRESS_SEARCH'), disabled: disabled || isManualMode, readOnly: readOnly, required: required, desired: desired, noResultsText: t('NO_MATCHES_DATABASE_ADDR'), items: suggestions, toLabel: "text", onBlur: handleBlur, onChange: handleChangeSearch, onSelection: handleSelectionSearch, onFocus: handleFocus, disableAutoFill: disableAutoFill })),
                React__default.createElement(Flex, { className: 'flex-d-column gap-0' },
                    React__default.createElement(LabelSpacer, null),
                    React__default.createElement(FieldHeightText, { className: "flex-grow-0" },
                        React__default.createElement(Button, { testId: `addr-edit-${name}`, disabled: disabled, type: "link", onClick: () => handleOnManualMode(!isManualMode) }, isManualMode
                            ? t('USE_ADDRESS_SEARCH')
                            : t('EDIT_ADDRESS_MANUALLY'))))))),
        mode === AddressMode.Strict && isManualMode && unverifiedMessage && (React__default.createElement(Col, { xs: 12, testId: "unverifiedMessage" },
            React__default.createElement(InlineAlert, { type: BrandType.Warning, closeable: false }, unverifiedMessage))),
        (mode === AddressMode.Default || mode === AddressMode.Strict) && (React__default.createElement(Col, { xs: 12, className: modules_0a537303.streetColumn },
            mode === AddressMode.Strict && (React__default.createElement("div", { className: modules_0a537303.verifiedContainer }, renderVerifyBadge())),
            React__default.createElement(StreetLine, { testId: TestIdUtils.composeId(testId, AddressFields.Street), ref: streetLineRef, name: name, fieldNames: fieldNames, defaultLabel: (_c = (defaultLabels && defaultLabels[AddressFields.Street])) !== null && _c !== void 0 ? _c : t('STREET'), helpText: helpText && helpText[AddressFields.Street], disabled: disabled, readOnly: isReadOnly, required: required, desired: desired, value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.streetLine }))),
        React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine2, { testId: TestIdUtils.composeId(testId, AddressFields.Address2), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address2], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address2 })),
        fieldVisibilityConfig.showStreetLineCount >= 3 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine3, { testId: TestIdUtils.composeId(testId, AddressFields.Address3), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address3], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address3 }))) : null,
        fieldVisibilityConfig.showStreetLineCount >= 4 ? (React__default.createElement(Col, { xs: 12 },
            React__default.createElement(StreetLine4, { testId: TestIdUtils.composeId(testId, AddressFields.Address4), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Address4], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.address4 }))) : null,
        React__default.createElement(Col, { xs: 12, sm: 6 },
            React__default.createElement(City, { testId: TestIdUtils.composeId(testId, AddressFields.City), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.City], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.city })),
        React__default.createElement(Col, { xs: 6, sm: isCompact ? 6 : 3 },
            React__default.createElement(State, { testId: TestIdUtils.composeId(testId, AddressFields.State), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.State], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill })),
        React__default.createElement(Col, { xs: 6, sm: isCompact ? 6 : 3 },
            React__default.createElement(ZipCode, { testId: TestIdUtils.composeId(testId, AddressFields.ZipCode), zipPlus4: zipPlus4, defaultLabels: defaultLabels, disableAutoFill: disableAutoFill, disabled: disabled, fieldNames: fieldNames, helpText: helpText && helpText[AddressFields.ZipCode], name: name, onBlur: handleZipBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, readOnly: isReadOnly, value: value })),
        fieldVisibilityConfig.showCounty ? (React__default.createElement(Col, { xs: 12, sm: 6 },
            React__default.createElement(County, { testId: TestIdUtils.composeId(testId, AddressFields.County), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.County], disabled: disabled, readOnly: isReadOnly, defaultLabel: (_d = (defaultLabels && defaultLabels[AddressFields.County])) !== null && _d !== void 0 ? _d : 'County/Parish', value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill, maxLength: fieldMaxLengths === null || fieldMaxLengths === void 0 ? void 0 : fieldMaxLengths.county }))) : null,
        fieldVisibilityConfig.showCountry ? (React__default.createElement(Col, { xs: 12, sm: 6 },
            React__default.createElement(Country, { testId: TestIdUtils.composeId(testId, AddressFields.Country), name: name, fieldNames: fieldNames, defaultLabels: defaultLabels, helpText: helpText && helpText[AddressFields.Country], disabled: disabled, readOnly: isReadOnly, value: value, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, onContextMenu: handleContextMenu, disableAutoFill: disableAutoFill }))) : null));
};

const SHOW_FIELDS_DEP_MSG = 'The `showFields` prop. is deprecated. Use the replacement `fieldVisibilityConfig` prop.';
const HIDE_FIELDS_DEP_MSG = 'The `hideFields` prop. is deprecated. Use the replacement `fieldVisibilityConfig` prop.';
const MIX_DEPRECATED_PROPS_MSG = 'Do not use the deprecated `hideFields` and `showFields` props simultaneously with their replacement `fieldVisibilityConfig` prop.';
function useAddressFieldVisibilityConfig(hideFields, showFields, 
// not nullable due to default prop. value
fieldVisibilityConfig) {
    useDeprecationWarnings$1(hideFields, showFields, fieldVisibilityConfig);
    return React__default.useMemo(() => assertVisibilityConfig(hideFields, showFields, fieldVisibilityConfig), [hideFields, showFields, fieldVisibilityConfig]);
}
/**
 * Will assert all the properties of the address-field visibility configuration are set.
 * Prioritizes (most to least):
 * - 1st) `fieldVisibilityConfig`
 * - 2nd) deprecated: `hideFields` or `showFields`
 * - 3rd) default values
 *
 * Note: The deprecated `hideFields` entry for 'AddressFields.Address4` was never taken
 * into regard previously; so here, too, that behavior is reflected.
 *
 * Note: The deprecated `hideFields` property previously allowed a "4th" address line
 * even when a "3rd" address line was not shown, which is absurd. We will handle this
 * case by adding a properly titled "3rd" line in this edge case.
 *
 * @param hideFields
 * @param showFields
 * @param fieldVisibilityConfig
 * @returns
 */
function assertVisibilityConfig(hideFields, showFields, 
// not nullable due to default prop. value
fieldVisibilityConfig) {
    /*
     * If the user has set the config prop explicitly, always prefer it over the deprecated props.
     *
     * Note: Even if an object equivalent to `FIELD_VISIBILITY_CONFIG_DEFAULTS` is passed in,
     * the referential equality will not be the same since we do not export `FIELD_VISIBILITY_CONFIG_DEFAULTS`
     * to our JS bundle.
     */
    const useConfigProp = fieldVisibilityConfig !== FIELD_VISIBILITY_CONFIG_DEFAULTS;
    // If the user has **not** set the config prop explicitly, check if the deprecated props are set.
    const useDeprecatedProps = !useConfigProp && (hideFields !== undefined || showFields !== undefined);
    // prefer new `fieldVisibilityConfig` over the deprecated props, viz., `hideFields`, and `showFields`
    if (useConfigProp) {
        const [showStreetLineCount, showCounty, showCountry] = [
            fieldVisibilityConfig === null || fieldVisibilityConfig === void 0 ? void 0 : fieldVisibilityConfig.showStreetLineCount,
            fieldVisibilityConfig === null || fieldVisibilityConfig === void 0 ? void 0 : fieldVisibilityConfig.showCounty,
            fieldVisibilityConfig === null || fieldVisibilityConfig === void 0 ? void 0 : fieldVisibilityConfig.showCountry
        ];
        const { showStreetLineCount: showStreetLineCountDefault, showCountry: showCountryDefault, showCounty: showCountyDefault } = FIELD_VISIBILITY_CONFIG_DEFAULTS;
        return {
            showStreetLineCount: showStreetLineCount !== null && showStreetLineCount !== void 0 ? showStreetLineCount : showStreetLineCountDefault,
            showCountry: showCountry !== null && showCountry !== void 0 ? showCountry : showCountryDefault,
            showCounty: showCounty !== null && showCounty !== void 0 ? showCounty : showCountyDefault
        };
    }
    // fall back to the deprecated props, viz., `hideFields`, and `showFields`
    else if (useDeprecatedProps) {
        const showAddress3Deprecated = hideFields === null || hideFields === void 0 ? void 0 : hideFields.every((f) => f !== AddressFields.Address3);
        const showAddress4Deprecated = showFields === null || showFields === void 0 ? void 0 : showFields.some((f) => f === AddressFields.Address4);
        const showCountryDeprecated = hideFields === null || hideFields === void 0 ? void 0 : hideFields.every((f) => f !== AddressFields.Country);
        const showCountyDeprecated = hideFields === null || hideFields === void 0 ? void 0 : hideFields.every((f) => f !== AddressFields.County);
        const { showCountry: showCountryDefault, showCounty: showCountyDefault } = FIELD_VISIBILITY_CONFIG_DEFAULTS;
        // not the simplest visually; but this allowed for strong typing.
        const showStreetLineCount = 
        // if both, we show (4) address lines
        (showAddress3Deprecated !== null && showAddress3Deprecated !== void 0 ? showAddress3Deprecated : true) && (showAddress4Deprecated !== null && showAddress4Deprecated !== void 0 ? showAddress4Deprecated : false)
            ? 4
            : // if only one or the other, show (3) address lines
                (showAddress3Deprecated !== null && showAddress3Deprecated !== void 0 ? showAddress3Deprecated : true) || (showAddress4Deprecated !== null && showAddress4Deprecated !== void 0 ? showAddress4Deprecated : false)
                    ? 3
                    : // if neither, show (2) address lines
                        2;
        return {
            showStreetLineCount: showStreetLineCount,
            showCountry: showCountryDeprecated !== null && showCountryDeprecated !== void 0 ? showCountryDeprecated : showCountryDefault,
            showCounty: showCountyDeprecated !== null && showCountyDeprecated !== void 0 ? showCountyDeprecated : showCountyDefault
        };
    }
    // If the user has set neither the config prop nor the deprecated props, use the defaults.
    // const useDefaults = !useConfigProp && !useDeprecatedProps;
    else {
        return FIELD_VISIBILITY_CONFIG_DEFAULTS;
    }
}
// A simple wrapper to shift focus away from this tedious logic
function useDeprecationWarnings$1(hideFields, showFields, 
// not nullable due to default prop. value
fieldVisibilityConfig) {
    // warn if using a deprecated prop
    useADSWarnOnce(SHOW_FIELDS_DEP_MSG, showFields !== undefined);
    // warn if using a deprecated prop
    useADSWarnOnce(HIDE_FIELDS_DEP_MSG, hideFields !== undefined);
    // warn if mixing deprecated and replacement props simultaneously
    useADSWarnOnce(MIX_DEPRECATED_PROPS_MSG, fieldVisibilityConfig !== FIELD_VISIBILITY_CONFIG_DEFAULTS &&
        (showFields !== undefined || hideFields !== undefined));
}

const defaultValue = {
    streetLine: '',
    address2: '',
    address3: '',
    address4: '',
    city: '',
    province: '',
    postalCode: '',
    zipCode: '',
    state: '',
    country: '',
    verified: false
};
// Note: If any of these fields are updated/changed in the future, please make sure to update the "Custom Width Sandbox" story in the address docs.
const DEFAULT_WIDTH = undefined;
const DEFAULT_MIN_WIDTH = '640px';
const DEFAULT_MAX_WIDTH = undefined;
/**
 * Retrieves the custom width configuration based on the provided country code and address config.
 * It first checks for country-specific custom width settings (US, CA, GB), then falls back to allLocales,
 * and defaults to predefined values if no configuration is found.
 *
 * @param {CountryCode | undefined} countryCode - The country code to determine the specific custom width settings.
 *        It could be 'US', 'CA', 'GB', or undefined for a general fallback.
 * @param {AddressBaseProps['addressConfig']} [addressConfig] - Optional configuration object containing custom widths
 *        for different countries and locales.
 *
 * @returns {CustomWidthProps} - The width configuration with the properties:
 *   - `width` (string | undefined): The custom width value.
 *   - `minWidth` (string): The minimum width value, defaults to '640px' if not specified.
 *   - `maxWidth` (string | undefined): The maximum width value.
 *
 * The function prioritizes country-specific settings, then allLocales, and defaults to predefined values if needed.
 */
const getCustomWidthWithDefaults = (countryCode, addressConfig) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    // Get country-specific config first
    const countrySpecificWidth = countryCode === 'US'
        ? (_a = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.us) === null || _a === void 0 ? void 0 : _a.customWidth
        : countryCode === 'CA'
            ? (_b = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.ca) === null || _b === void 0 ? void 0 : _b.customWidth
            : countryCode === 'GB'
                ? (_c = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.uk) === null || _c === void 0 ? void 0 : _c.customWidth
                : (_d = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.other) === null || _d === void 0 ? void 0 : _d.customWidth;
    const width = (_e = countrySpecificWidth === null || countrySpecificWidth === void 0 ? void 0 : countrySpecificWidth.width) !== null && _e !== void 0 ? _e : (_g = (_f = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.allLocales) === null || _f === void 0 ? void 0 : _f.customWidth) === null || _g === void 0 ? void 0 : _g.width;
    const minWidth = (_h = countrySpecificWidth === null || countrySpecificWidth === void 0 ? void 0 : countrySpecificWidth.minWidth) !== null && _h !== void 0 ? _h : (_k = (_j = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.allLocales) === null || _j === void 0 ? void 0 : _j.customWidth) === null || _k === void 0 ? void 0 : _k.minWidth;
    const maxWidth = (_l = countrySpecificWidth === null || countrySpecificWidth === void 0 ? void 0 : countrySpecificWidth.maxWidth) !== null && _l !== void 0 ? _l : (_o = (_m = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.allLocales) === null || _m === void 0 ? void 0 : _m.customWidth) === null || _o === void 0 ? void 0 : _o.maxWidth;
    // If only width is provided then we don't need to fallback to allLocales for any of the other widths
    if (width !== undefined && minWidth === undefined && maxWidth === undefined) {
        return { width };
    }
    // Fallback to allLocales if country-specific not found, then to defaults
    return {
        width: width !== null && width !== void 0 ? width : DEFAULT_WIDTH,
        minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : DEFAULT_MIN_WIDTH,
        maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : DEFAULT_MAX_WIDTH
    };
};
const AddressBase = ({ addressConfig, customDataProps, defaultLabels, disableAutoFill = true, disabled, disableLookup = false, disableStrict = true, fieldNames, fieldVisibilityConfig = FIELD_VISIBILITY_CONFIG_DEFAULTS, helpText, hideFields, manualModeConfig, name, readOnly, required, desired, showFields, subFormName, testId, unverifiedMessage, validateOnLoad, validateOnMountConfig, value, onChange, onFieldBlur, onFieldFocus, onSuggestionSelected, updateFormValues, onContextMenu, fieldMaxLengths }) => {
    var _a;
    const assertedFieldVisibilityConfig = useAddressFieldVisibilityConfig(hideFields, showFields, fieldVisibilityConfig);
    const ref = React__default.useRef(null);
    const { width } = useSize(ref.current);
    const { getCountryByTranslatedName } = useGetCountryByTranslatedName();
    const countryCode = (_a = getCountryByTranslatedName((value === null || value === void 0 ? void 0 : value.country) || '')) === null || _a === void 0 ? void 0 : _a.code;
    const customWidth = getCustomWidthWithDefaults(countryCode, addressConfig);
    const renderAddress = () => {
        var _a;
        switch (countryCode) {
            case 'US': {
                return (React__default.createElement(UsAddress, { addressWidth: width, defaultLabels: defaultLabels, desired: desired, disableAutoFill: disableAutoFill, disabled: disabled, disableLookup: disableLookup, disableStrict: disableStrict, fieldNames: fieldNames, fieldVisibilityConfig: assertedFieldVisibilityConfig, helpText: helpText, manualModeConfig: manualModeConfig, name: name, readOnly: readOnly, required: required, subFormName: subFormName, unverifiedMessage: unverifiedMessage, validateOnLoad: validateOnLoad, validateOnMountConfig: validateOnMountConfig, value: value, zipPlus4: (_a = addressConfig === null || addressConfig === void 0 ? void 0 : addressConfig.us) === null || _a === void 0 ? void 0 : _a.zipPlus4, onChange: onChange, onFieldBlur: onFieldBlur, onFieldFocus: onFieldFocus, onSuggestionSelected: onSuggestionSelected, onContextMenu: onContextMenu, updateFormValues: updateFormValues, fieldMaxLengths: fieldMaxLengths, testId: testId }));
            }
            case 'CA': {
                return (React__default.createElement(CaAddress, { addressWidth: width, disabled: disabled, disableAutoFill: disableAutoFill, disableLookup: disableLookup, readOnly: readOnly, required: required, desired: desired, name: name, subFormName: subFormName, value: value, helpText: helpText, updateFormValues: updateFormValues, onChange: onChange, fieldNames: fieldNames, defaultLabels: defaultLabels, fieldVisibilityConfig: assertedFieldVisibilityConfig, onFieldBlur: onFieldBlur, onFieldFocus: onFieldFocus, onSuggestionSelected: onSuggestionSelected, onContextMenu: onContextMenu, fieldMaxLengths: fieldMaxLengths, testId: testId }));
            }
            case 'GB': {
                return (React__default.createElement(UkAddress, { addressWidth: width, disabled: disabled, disableAutoFill: disableAutoFill, disableLookup: disableLookup, readOnly: readOnly, required: required, desired: desired, name: name, subFormName: subFormName, value: value, onChange: onChange, helpText: helpText, updateFormValues: updateFormValues, fieldNames: fieldNames, defaultLabels: defaultLabels, fieldVisibilityConfig: assertedFieldVisibilityConfig, onFieldBlur: onFieldBlur, onFieldFocus: onFieldFocus, onSuggestionSelected: onSuggestionSelected, onContextMenu: onContextMenu, fieldMaxLengths: fieldMaxLengths, testId: testId }));
            }
            default: {
                return (React__default.createElement(ForeignAddress, { addressWidth: width, disabled: disabled, disableAutoFill: disableAutoFill, readOnly: readOnly, required: required, desired: desired, name: name, subFormName: subFormName, value: value, helpText: helpText, onChange: onChange, fieldNames: fieldNames, defaultLabels: defaultLabels, onFieldBlur: onFieldBlur, onFieldFocus: onFieldFocus, onContextMenu: onContextMenu, fieldVisibilityConfig: assertedFieldVisibilityConfig, fieldMaxLengths: fieldMaxLengths, testId: testId }));
            }
        }
    };
    return (React__default.createElement("div", Object.assign({}, customDataProps, { "data-test": testId, style: customWidth, ref: ref }), renderAddress()));
};
// We need a version that is standalone if
const UnControlledAddressField = (props) => {
    const [value, setValue] = React__default.useState(Object.assign({}, defaultValue));
    return (React__default.createElement(AddressWithoutForm, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value), onInitialChange: (e) => setValue(e.target.value) })));
};
const AddressWithoutForm = (props) => {
    const { country } = useDefaultCountry();
    React__default.useEffect(() => {
        var _a;
        if (!((_a = props.value) === null || _a === void 0 ? void 0 : _a.country)) {
            props.updateFormValues && props.updateFormValues({ country });
            const event = {
                target: { name: props.name, value: Object.assign(Object.assign({}, props.value), { country }) }
            };
            props.onInitialChange && props.onInitialChange(event);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return React__default.createElement(AddressBase, Object.assign({}, props));
};
// We have to handle address in form differently because we programmatically
// set field values.
const AddressInForm = (props) => {
    const subFormContext = useInternalSubFormContext();
    const formPathName = useFieldSchemaName(props.name);
    const { control, getValues, setValue: setFieldValue, trigger, useWatch } = useFormContext();
    // Get address field names in a way that handles custom field names, forms, and subForms.
    const formFieldNames = Object.values(AddressFields).map((field) => 
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useFieldSchemaName(AddressFieldName(field, props.name, props.fieldNames)));
    // get address field values with the help of the field names
    // pass the field names as array and receive the values array in the same order as the field names
    // using a directed useWatch should keep the component from rendering every time other non-address values are updated
    const formFieldValues = useWatch({
        name: formFieldNames,
        control
    });
    const value = React__default.useMemo(() => {
        const formattedValue = {};
        Object.values(AddressFields).forEach((fieldName, index) => {
            formattedValue[fieldName] = formFieldValues[index];
        });
        return formattedValue;
    }, [formFieldValues]);
    const updateFormValues = (address) => {
        const updatedFieldsNames = Object.keys(address)
            .map((key) => {
            const fieldName = AddressFieldName(key, formPathName, props.fieldNames);
            const newValue = address[key];
            // only set the value if the value has changed
            if (getValues(fieldName) !== newValue) {
                setFieldValue(fieldName, address[key], {
                    shouldDirty: true
                });
                return fieldName;
            }
            return undefined;
        })
            .filter((fieldName) => Boolean(fieldName));
        // only call validate if some address fields have changed
        if (updatedFieldsNames.length) {
            // validate all address fields at once
            trigger(updatedFieldsNames);
        }
    };
    return (React__default.createElement(AddressBase, Object.assign({}, props, { updateFormValues: updateFormValues, subFormName: subFormContext === null || subFormContext === void 0 ? void 0 : subFormContext.name, value: value, onChange: props.onChange })));
};
const StandAlone$1 = withStandAlone(UnControlledAddressField, AddressWithoutForm);
const Address = (props) => {
    const form = useInternalFormContext();
    return form.inForm && !props.noForm ? (React__default.createElement(AddressInForm, Object.assign({}, props, { readOnly: props.readOnly || form.readOnly, disabled: props.disabled || form.disabled }))) : (React__default.createElement(StandAlone$1, Object.assign({}, props)));
};

/**
 * A component that listens for resize events on the window to call an event handler.
 *
 * Hack: This component keeps `useEventListener`-induced re-renders local to itself.
 */
function ResizeListenerManager({ onResize }) {
    useEventListener('resize', onResize, [window]);
    return null;
}

var css$10 = ".DropdownMenu_module_dropdownMenu__container__8db38398{min-width:100%}.DropdownMenu_module_dropdownMenu__container__8db38398 .DropdownMenu_module_dropdownMenu__button__8db38398{min-width:128px!important}.DropdownMenu_module_dropdownMenu__container_level0__8db38398{box-shadow:0 2px 4px -1px #0003,0 4px 5px 0 #00000024,0 1px 10px 0 #0000001f;width:fit-content}.DropdownMenu_module_dropdownMenu__container_level1__8db38398{box-shadow:0 3px 5px -1px #0003,0 6px 10px 0 #00000024,0 1px 18px 0 #0000001f}.DropdownMenu_module_dropdownMenu__container_level2__8db38398{box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.DropdownMenu_module_dropdownMenu__container_level3__8db38398{box-shadow:0 6px 6px -3px #0003,0 10px 14px 1px #00000024,0 4px 18px 3px #0000001f}.DropdownMenu_module_dropdownMenu__container_buttons__8db38398,.DropdownMenu_module_dropdownMenu__container_submenuButton__8db38398{display:flex;flex-direction:column}.DropdownMenu_module_dropdownMenu__button__8db38398{align-items:center;background-color:#fff!important;border-radius:0;border-width:0;height:32px;justify-content:left;padding-left:16px;padding-right:16px;user-select:none;z-index:1}.DropdownMenu_module_dropdownMenu__button__8db38398:active:not(.DropdownMenu_module_dropdownMenu__button_AppearDisabled__8db38398){background-color:#d5e1fb}.DropdownMenu_module_dropdownMenu__button__8db38398:hover{background-color:#fff;border-left:#0000;border-right:#0000;z-index:2}.DropdownMenu_module_dropdownMenu__button__8db38398:focus{background-color:#e3eafc;border-left:#0000;border-right:#0000;box-shadow:none;z-index:3}.DropdownMenu_module_dropdownMenu__button__8db38398 [data-button-icon=left]{margin-left:0;margin-right:8px}.DropdownMenu_module_dropdownMenu__button__8db38398 [data-button-icon=right]{margin-left:16px;margin-right:0}.DropdownMenu_module_dropdownMenu__button__8db38398 [data-button-icon=right]~[data-button-icon=right]{margin-left:8px;margin-right:0}.DropdownMenu_module_dropdownMenu__button_Disabled__8db38398{background-color:#fff!important}.DropdownMenu_module_dropdownMenu__button_Focused__8db38398{background-color:#e3eafc!important}";
window.ADS.injectStyle(css$10,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Internal_DropdownMenu/DropdownMenu.module.scss");
var modules_d66ec679 = {"dropdown-menu__container":"DropdownMenu_module_dropdownMenu__container__8db38398","dropdown-menu__button":"DropdownMenu_module_dropdownMenu__button__8db38398","dropdown-menu__container_level-0":"DropdownMenu_module_dropdownMenu__container_level0__8db38398","dropdown-menu__container_level-1":"DropdownMenu_module_dropdownMenu__container_level1__8db38398","dropdown-menu__container_level-2":"DropdownMenu_module_dropdownMenu__container_level2__8db38398","dropdown-menu__container_level-3":"DropdownMenu_module_dropdownMenu__container_level3__8db38398","dropdown-menu__container_buttons":"DropdownMenu_module_dropdownMenu__container_buttons__8db38398","dropdown-menu__container_submenu-button":"DropdownMenu_module_dropdownMenu__container_submenuButton__8db38398","dropdown-menu__button--appear-disabled":"DropdownMenu_module_dropdownMenu__button_AppearDisabled__8db38398","dropdown-menu__button--disabled":"DropdownMenu_module_dropdownMenu__button_Disabled__8db38398","dropdown-menu__button--focused":"DropdownMenu_module_dropdownMenu__button_Focused__8db38398"};

var css$$ = ".Separators_module_separator__687bc514{background-color:#d9dbe3;border:none;height:1px;margin:4px 0;width:100%}";
window.ADS.injectStyle(css$$,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/common/atoms/Separators/Separators.module.scss");
var modules_42c22979 = {"separator":"Separators_module_separator__687bc514"};

function Separator({ testId }) {
    return React__default.createElement("div", { "data-test": testId, className: modules_42c22979.separator });
}
/**
 * Internal as of DX-234 (Q4 2023).
 */
function Separators({ children, bottom = true, testId, top = true }) {
    const prefix = testId ? `${testId}-` : '';
    const [testId_bottom, testId_top] = [
        `${prefix}separator-bottom`,
        `${prefix}separator-top`
    ];
    return (React__default.createElement(React__default.Fragment, null,
        Boolean(top) && React__default.createElement(Separator, { testId: testId_top }),
        children,
        Boolean(bottom) && React__default.createElement(Separator, { testId: testId_bottom })));
}

var css$_ = ".DropdownMenuTitle_module_container__3993303f{align-items:center;color:#6a6f82;display:flex;flex-direction:row;height:32px;min-width:0;padding-left:16px;padding-right:16px}.DropdownMenuTitle_module_divIconRight__3993303f{flex:0;margin-left:8px}.DropdownMenuTitle_module_iconLeft__3993303f{flex:0;margin-right:8px}.DropdownMenuTitle_module_iconRight__3993303f{flex:0}.DropdownMenuTitle_module_title__3993303f{flex:1;font-family:Open Sans,sans-serif;font-size:13px;font-weight:700;letter-spacing:0;line-height:20px;overflow:hidden;text-align:left;text-overflow:ellipsis;text-transform:uppercase;user-select:none;white-space:nowrap}.DropdownMenuTitle_module_tooltipIconRight__3993303f{align-self:center}";
window.ADS.injectStyle(css$_,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Internal_DropdownMenu/DropdownMenuTitle.module.scss");
var modules_3c561de4 = {"container":"DropdownMenuTitle_module_container__3993303f","div-icon-right":"DropdownMenuTitle_module_divIconRight__3993303f","icon-left":"DropdownMenuTitle_module_iconLeft__3993303f","icon-right":"DropdownMenuTitle_module_iconRight__3993303f","title":"DropdownMenuTitle_module_title__3993303f","tooltip-icon-right":"DropdownMenuTitle_module_tooltipIconRight__3993303f"};

const cx$1a = classnames.bind(modules_3c561de4);
const TEST_IDS$g = {
    title: (sectionIndex) => `dropdown-menu-title-for-section-${sectionIndex}`
};
const DropdownMenuTitle = React__default.memo(function DropdownMenuTitle({ children, icon: _icon, sectionIndex, tooltipText }) {
    const icon = match(_icon)
        .with(undefined, () => undefined)
        .with(P.string, (s) => s)
        .with({ type: 'named' }, (icon) => icon.name)
        .with({ type: 'component' }, (icon) => icon.component)
        .exhaustive();
    return (React__default.createElement("div", { "data-test": TEST_IDS$g.title(sectionIndex), className: cx$1a('container') },
        icon !== undefined && (React__default.createElement(Icon, { className: cx$1a('icon-left'), size: 16, icon: icon })),
        React__default.createElement("div", { "data-test": 'title', className: cx$1a('title') }, children),
        !!tooltipText && (React__default.createElement("div", { className: cx$1a('div-icon-right') },
            React__default.createElement(Tooltip, { className: cx$1a('tooltip-icon-right'), content: tooltipText, trigger: "mouseenter click" },
                React__default.createElement(Icon, { className: (cx$1a('icon-right'), 'help-hover'), icon: "ICircleIcon", size: 16 }))))));
});

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$19 = BindStyles(modules_d66ec679);
const TEST_IDS$f = {
    dropdownMenuButton: (index) => `dropdown-menu-button-${index}`,
    dropdownMenuButton_prefix: 'dropdown-menu-button-'
};
const NO_DELAY = 0; // ms
/**
 * Caution: Do not change this without changing the SCSS file.
 *
 * We assume the button type will remain the same; so any changes to this value
 * will require a change to the SCSS values.
 */
const BUTTON_TYPE = 'secondary';
function DropdownMenuSection({ activeRowIndex, buttonSize, submenuAnchorRef, hasTopSeparator, hasRightIconColumn, hasTooltipColumn, section, sectionIndex, onCloseAllDropdowns, onSelected_default, onHover_withSubmenu, onFocus_withSubmenu, onRightArrow_withSubmenu, onLeftArrow_withSubmenu, onSpacebar_withSubmenu, onEnter_withSubmenu }) {
    // unwrap
    const { buttons, titleConfig } = section;
    const onKeyDownHandler = (e, submenu) => {
        KeyHandleMap(e, [
            { Tab: onCloseAllDropdowns },
            {
                ArrowRight: () => onRightArrow_withSubmenu(submenu)
            },
            { ArrowLeft: () => onLeftArrow_withSubmenu() },
            {
                ' ': () => onSpacebar_withSubmenu(submenu)
            },
            {
                Enter: () => onEnter_withSubmenu(submenu)
            },
            // Since we are using the up/down arrow key handlers from the base useDropdown hook,
            // we need to cancel the event(s) here to prevent the default behavior.
            {
                ArrowUp: (e) => CancelReactEvent(e)
            },
            {
                ArrowDown: (e) => CancelReactEvent(e)
            }
        ]);
    };
    const buttonsJSX = buttons.map((button) => {
        var _a;
        const currentIndex = button.index;
        const isLoading = (_a = button.loading) !== null && _a !== void 0 ? _a : false;
        // can't be considered active if it's shown as placeholder skeletons
        const isActiveRow = activeRowIndex === currentIndex && !isLoading;
        const icon = match(button.icon)
            .with(undefined, () => undefined)
            .with({ type: 'named' }, (icon) => icon.name)
            .with({ type: 'component' }, (icon) => icon.component)
            .exhaustive();
        switch (button.type) {
            case 'default': {
                return (React__default.createElement(DropdownMenuDefaultButton, { key: currentIndex, buttonIndex: currentIndex, buttonSize: buttonSize, disabled: button.disabled, hasRightIconColumn: hasRightIconColumn, hasTooltipColumn: hasTooltipColumn, isActiveRow: isActiveRow, label: button.label, leftIcon: icon, loading: isLoading, tooltip: button.tooltip, onClick: () => {
                        button.onClick();
                        onCloseAllDropdowns();
                    }, onFocus: (e) => onSelected_default(e, currentIndex), onKeyDown: (e) => {
                        onKeyDownHandler(e);
                    }, onMouseEnter: (e) => onSelected_default(e, currentIndex) }));
            }
            case 'with-submenu': {
                return (React__default.createElement(DropdownMenuSubmenuButton, { key: currentIndex, buttonIndex: currentIndex, buttonSize: buttonSize, disabled: button.disabled, divRef: isActiveRow ? submenuAnchorRef : null, hasTooltipColumn: hasTooltipColumn, isActiveRow: isActiveRow, label: button.label, leftIcon: icon, loading: isLoading, tooltip: button.tooltip, onFocus: (e) => {
                        if (button.submenu === null)
                            return;
                        onFocus_withSubmenu(e, currentIndex, button.submenu);
                    }, onKeyDown: (e) => {
                        if (button.submenu === null)
                            return;
                        onKeyDownHandler(e, button.submenu);
                    }, onMouseEnter: (e) => {
                        if (button.submenu === null)
                            return;
                        onHover_withSubmenu(e, currentIndex, button.submenu);
                    } }));
            }
        }
    });
    return (React__default.createElement(Separators, { top: hasTopSeparator, bottom: false },
        titleConfig && (React__default.createElement(DropdownMenuTitle, { icon: titleConfig.icon, sectionIndex: sectionIndex, tooltipText: titleConfig.tooltip }, titleConfig.title)),
        React__default.createElement("div", { className: cx$19('dropdown-menu__container_buttons') }, buttonsJSX)));
}
const RightIcon = {
    rightTriangleIcon: (visible) => ({
        icon: 'RightwardTriangleIcon',
        visible
    }),
    tooltipIcon: (tooltip) => ({
        allowHover: true,
        icon: 'InfoIconFilled',
        tooltip,
        visible: true
    }),
    tooltipIcon_invisible: {
        icon: 'InfoIconFilled',
        visible: false
    }
};
function DropdownMenuDefaultButton({ buttonIndex, buttonSize, loading, disabled, leftIcon, hasRightIconColumn, hasTooltipColumn, isActiveRow, label, tooltip, onClick, onMouseEnter, onFocus, onKeyDown }) {
    const tooltipIcon = tooltip ? RightIcon.tooltipIcon(tooltip) : null;
    const rightIconsConfig = [];
    // first, push the tooltip-column icon if applicable
    if (tooltipIcon) {
        rightIconsConfig.push(tooltipIcon);
    }
    else if (hasTooltipColumn) {
        rightIconsConfig.push(RightIcon.tooltipIcon_invisible);
    }
    // second, push the right-icon column if applicable
    if (hasRightIconColumn) {
        rightIconsConfig.push(RightIcon.rightTriangleIcon(false));
    }
    let [buttonDisabled, buttonAppearsDisabled] = [false, false];
    if (tooltip && disabled) {
        [buttonDisabled, buttonAppearsDisabled] = [false, true];
    }
    else if (disabled) {
        [buttonDisabled, buttonAppearsDisabled] = [true, false];
    }
    return (React__default.createElement(ButtonBase, { testId: TEST_IDS$f.dropdownMenuButton(buttonIndex), className: cx$19('dropdown-menu__button', {
            'dropdown-menu__button--disabled': disabled,
            'dropdown-menu__button--focused': isActiveRow,
            'dropdown-menu__button--appear-disabled': buttonAppearsDisabled
        }), icon: leftIcon, appearDisabled: buttonAppearsDisabled, appearSkeleton: loading, disabled: buttonDisabled, isLoading: loading, isFocused: isActiveRow, 
        // UX would like this to appear as though there is a column for the `RightwardTriangleIcon` whenever it exists.
        rightIconsConfig: rightIconsConfig, size: buttonSize, type: BUTTON_TYPE, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: buttonAppearsDisabled ? undefined : onMouseEnter, loadingFadeTimeout: NO_DELAY }, label));
}
function DropdownMenuSubmenuButton({ buttonIndex, buttonSize, loading, disabled, divRef, hasTooltipColumn, isActiveRow, label, leftIcon, tooltip, onFocus, onKeyDown, onMouseEnter }) {
    const tooltipIcon = tooltip ? RightIcon.tooltipIcon(tooltip) : null;
    const rightIconsConfig = [];
    // first, push the tooltip-column icon if applicable
    if (tooltipIcon) {
        rightIconsConfig.push(tooltipIcon);
    }
    else if (hasTooltipColumn) {
        rightIconsConfig.push(RightIcon.tooltipIcon_invisible);
    }
    // second, always push the right-icon column
    rightIconsConfig.push(RightIcon.rightTriangleIcon(true));
    let [buttonDisabled, buttonAppearsDisabled] = [false, false];
    if (tooltip && disabled) {
        [buttonDisabled, buttonAppearsDisabled] = [false, true];
    }
    else if (disabled) {
        [buttonDisabled, buttonAppearsDisabled] = [true, false];
    }
    return (React__default.createElement("div", { className: cx$19('dropdown-menu__container_submenu-button'), ref: divRef },
        React__default.createElement(ButtonBase, { testId: TEST_IDS$f.dropdownMenuButton(buttonIndex), className: cx$19('dropdown-menu__button', {
                'dropdown-menu__button--disabled': disabled,
                'dropdown-menu__button--focused': isActiveRow,
                'dropdown-menu__button--appear-disabled': buttonAppearsDisabled
            }), appearDisabled: buttonAppearsDisabled, appearSkeleton: loading, disabled: buttonDisabled, icon: leftIcon, isLoading: loading, isFocused: isActiveRow, rightIconsConfig: rightIconsConfig, size: buttonSize, type: BUTTON_TYPE, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: buttonAppearsDisabled ? undefined : onMouseEnter, loadingFadeTimeout: NO_DELAY }, label)));
}

const DEFAULT_BUTTON_COUNT = 0;
function useDropdownForDropdownMenu({ currentMenuTree, openOnArrowDown = false, openOnSpace = false, keydownConfig = {
    listenTo: 'dropdown'
}, onEscapeKey }) {
    var _a;
    // unwrap
    const [buttonCount, disabledButtonIndices] = [
        (_a = currentMenuTree === null || currentMenuTree === void 0 ? void 0 : currentMenuTree.buttonCount) !== null && _a !== void 0 ? _a : DEFAULT_BUTTON_COUNT,
        currentMenuTree === null || currentMenuTree === void 0 ? void 0 : currentMenuTree.disabledButtonIndices
    ];
    const dropdownBag = useDropdown({
        disabledIndices: disabledButtonIndices,
        keydownConfig,
        numberOfItems: buttonCount,
        openOnArrowDown,
        openOnSpace,
        onEscapeKey
    });
    // unwrap
    const { dropdown } = dropdownBag;
    // unwrap
    const { setActiveRowIndex, setOpen } = dropdown;
    // dropdown event handlers:
    const handleActiveIndexChange = React__default.useCallback((index) => {
        /*
         * While migrating to React 18, we needed to ensure that the `setActiveRowIndex` calls were not batched.
         * When they were, we saw an issue when opening a nested dropdown item then hovering a top level item. It caused the submenu that opened from the top level item
         * to not match the items for that parent.
         */
        flushSync(() => setActiveRowIndex(index));
    }, [setActiveRowIndex]);
    const handleClose = React__default.useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    const dropdownHandlers = React__default.useMemo(() => {
        return {
            handleActiveIndexChange,
            handleClose
        };
    }, [handleActiveIndexChange, handleClose]);
    return [dropdownBag, dropdownHandlers];
}

// TODO: fix the issue with parent -> sub -> action not working
const cx$18 = BindStyles(modules_d66ec679);
const TEST_IDS$e = {
    dropdownMenuContainer: (menuModality, depth) => `${menuModality}-menu__container-${depth}`
};
// TODO: We will update this in DX-317 to allow the menu to grow past twelve items.
// (fragile, temporary) formula: [height of each item] * [number of items]
const DROPDOWN_MENU_MAX_HEIGHT = 32 * 12;
const OFFSET_CONFIG$1 = {
    skid: -5,
    offset: -4
};
const PLACEMENT_CONFIG = {
    placement: 'right-start',
    fallbackPlacements: [
        'right-start',
        'right',
        'right-end',
        'left-start',
        'left',
        'left-end'
    ]
};
const DropdownMenu = ({ activeRowIndex, buttonSize = 'md', currentDropdownFunctions, currentDropdownProps, depth, menuModality, menuTree, minWidthMatchAnchor, offsetConfig, parentButton, placementConfig, testId, menuWidth = 'regular', onCloseAllDropdowns, onCloseThisDropdown }) => {
    const [buttonWithSubmenu, setButtonWithSubmenu] = React__default.useState(null);
    const [submenuTree, submenuFunctions, nestedDropdownBag] = useSubmenu(onCloseAllDropdowns);
    // unwrap
    const { dropdown: nestedDropdown, dropdownAnchorRef: nestedDropdownAnchorRef, dropdownProps: nestedDropdownProps } = nestedDropdownBag;
    // close the submenu if the menu is loading
    useHandleMenuLoading(menuTree, submenuFunctions.closeSubmenu);
    const dropdownContainerRef = React__default.useRef(null);
    useEventListener(['scroll', 'wheel'], submenuFunctions.closeSubmenu, [
        dropdownContainerRef.current
    ]);
    const [, updateLastSelectedRef] = useLastSelectedRef();
    const handleDefaultButtonSelected = useDefaultButtonSelectedHandler(currentDropdownFunctions, submenuFunctions, updateLastSelectedRef);
    const handleSubmenuButtonHover = useSubmenuButtonSelectedHandler(currentDropdownFunctions, submenuFunctions, updateLastSelectedRef);
    // Focusing a section/button behaves differently than hovering over it.
    const handleSubmenuButtonFocus = useSubmenuButtonSelectedHandler(currentDropdownFunctions, submenuFunctions, updateLastSelectedRef, true, setButtonWithSubmenu);
    const { handleRightArrowKey, handleLeftArrowKey, handleSpacebarKey, handleEnterKey } = useKeyboardHandlers(submenuFunctions, parentButton, onCloseThisDropdown);
    // unwrap
    const { sections: menuSections } = menuTree;
    // Metadata we need to know about the layout of the various sections.
    const menuMetadata = React__default.useMemo(() => {
        return menuSections.reduce((acc, section) => {
            if (section.buttons.some((button) => button.tooltip)) {
                acc.hasTooltip = true;
            }
            if (section.buttons.some((button) => button.type === 'with-submenu')) {
                acc.hasRightIcon = true;
            }
            return acc;
        }, { hasTooltip: false, hasRightIcon: false });
    }, [menuSections]);
    const sectionsJSX = React__default.useMemo(() => {
        return menuSections.map((section, index) => {
            const hasTopSeparator = index !== 0;
            return (React__default.createElement(React__default.Fragment, { key: index },
                React__default.createElement(DropdownMenuSection, { activeRowIndex: activeRowIndex, buttonSize: buttonSize, submenuAnchorRef: nestedDropdownAnchorRef, hasRightIconColumn: menuMetadata.hasRightIcon, hasTooltipColumn: menuMetadata.hasTooltip, hasTopSeparator: hasTopSeparator, section: section, sectionIndex: index, onSelected_default: handleDefaultButtonSelected, onHover_withSubmenu: handleSubmenuButtonHover, onFocus_withSubmenu: handleSubmenuButtonFocus, onRightArrow_withSubmenu: handleRightArrowKey, onLeftArrow_withSubmenu: handleLeftArrowKey, onSpacebar_withSubmenu: handleSpacebarKey, onEnter_withSubmenu: handleEnterKey, onCloseAllDropdowns: onCloseAllDropdowns })));
        });
    }, [
        activeRowIndex,
        buttonSize,
        menuSections,
        menuMetadata,
        nestedDropdownAnchorRef,
        handleDefaultButtonSelected,
        handleSubmenuButtonHover,
        handleSubmenuButtonFocus,
        handleRightArrowKey,
        handleLeftArrowKey,
        handleSpacebarKey,
        handleEnterKey,
        onCloseAllDropdowns
    ]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Dropdown, Object.assign({}, currentDropdownProps, { minWidthMatchAnchor: minWidthMatchAnchor, offsetConfig: offsetConfig, placementConfig: placementConfig, portal: false, testId: testId }),
            React__default.createElement(DropdownContainer, { customDataProps: {
                    'data-menu-width': menuWidth
                }, testId: TEST_IDS$e.dropdownMenuContainer(menuModality, depth), ref: dropdownContainerRef, className: cx$18('dropdown-menu__container', `dropdown-menu__container_level-${depth}`), maxHeight: DROPDOWN_MENU_MAX_HEIGHT }, sectionsJSX),
            nestedDropdown.open && submenuTree !== null && (React__default.createElement(DropdownMenu, { activeRowIndex: nestedDropdown.activeRowIndex, buttonSize: buttonSize, currentDropdownFunctions: submenuFunctions, currentDropdownProps: nestedDropdownProps, depth: depth + 1, menuModality: menuModality, menuTree: submenuTree, 
                // don't ever match anchor for sub-menus since this menu is the "anchor"
                minWidthMatchAnchor: false, offsetConfig: OFFSET_CONFIG$1, placementConfig: PLACEMENT_CONFIG, onCloseAllDropdowns: onCloseAllDropdowns, parentButton: buttonWithSubmenu, testId: testId, menuWidth: menuWidth, onCloseThisDropdown: nestedDropdown.toggle })))));
};
//#region simple hooks internal to this component
/**
 * If the menu begins to load, we want to close its submenu.
 *
 * @param menuTree
 * @param closeMenu
 */
function useHandleMenuLoading(menuTree, closeSubmenu) {
    const allLoading = React__default.useMemo(() => menuTree.sections.every((section) => section.buttons.every((button) => button.loading)), [menuTree]);
    const effectRef = React__default.useRef({
        allPreviouslyLoading: false,
        closeSubmenu
    });
    React__default.useEffect(() => {
        effectRef.current = {
            allPreviouslyLoading: effectRef.current.allPreviouslyLoading,
            closeSubmenu: closeSubmenu
        };
    });
    React__default.useEffect(() => {
        const { allPreviouslyLoading, closeSubmenu } = effectRef.current;
        const menuLoadingHasChanged = allLoading !== allPreviouslyLoading;
        if (menuLoadingHasChanged && allLoading === true) {
            closeSubmenu();
        }
        effectRef.current.allPreviouslyLoading = allLoading;
    }, [allLoading]);
}
function useLastSelectedRef() {
    const lastSelectedRef = React__default.useRef(null);
    const updateLastSelectedRef = React__default.useCallback((e) => {
        if (!(e.target instanceof HTMLElement))
            return;
        lastSelectedRef.current = e.target;
    }, []);
    return [lastSelectedRef, updateLastSelectedRef];
}
function useDefaultButtonSelectedHandler(currentDropdownFunctions, submenuFunctions, updateLastSelectedRef) {
    const { handleActiveIndexChange } = currentDropdownFunctions;
    const { closeSubmenu } = submenuFunctions;
    const handleActiveDefault = React__default.useCallback((e, index) => {
        handleActiveIndexChange(index);
        closeSubmenu();
        updateLastSelectedRef(e);
    }, [closeSubmenu, handleActiveIndexChange, updateLastSelectedRef]);
    return handleActiveDefault;
}
function useSubmenuButtonSelectedHandler(currentDropdownFunctions, submenuFunctions, updateLastSelectedRef, fromKeyPress, setSubmenuParentButton) {
    const { handleActiveIndexChange: handleCurrentActiveIndexChange } = currentDropdownFunctions;
    const { openSubmenu } = submenuFunctions;
    const handleActiveSubmenu = React__default.useCallback((e, index, submenu) => {
        handleCurrentActiveIndexChange(index);
        // If the event was triggered by a key press, we don't want to open the submenu
        if (!fromKeyPress) {
            openSubmenu(submenu, 'clear');
        }
        updateLastSelectedRef(e);
        // We use this to track the parent button of the submenu
        // So we can focus it when the submenu is closed
        setSubmenuParentButton && setSubmenuParentButton(e.target);
    }, [
        handleCurrentActiveIndexChange,
        fromKeyPress,
        updateLastSelectedRef,
        setSubmenuParentButton,
        openSubmenu
    ]);
    return handleActiveSubmenu;
}
// expose the submenu as a `useState` state with some callback functions to
// manipulate it
function useSubmenu(onCloseAllDropdowns) {
    const [submenu, setSubmenu] = React__default.useState(null);
    // Escape key press is handled by the useDropdown hook
    // So we need to override it here
    // I feel like there might be a better way
    const [nestedDropdownBag, nestedDropdownFunctions] = useDropdownForDropdownMenu({
        currentMenuTree: submenu,
        onEscapeKey: onCloseAllDropdowns
    });
    // unwrap
    const { open, resetActiveRowIndex, setOpen, setActiveRowIndex } = nestedDropdownBag.dropdown;
    // unwrap
    const { handleActiveIndexChange } = nestedDropdownFunctions;
    const indexResetTrigger = useTrigger();
    const clearTrigger = useTrigger();
    // locality: variables in this block do not need to leave
    {
        // use a ref to avoid triggering the `useEffect` hook as dependencies
        const effectRef = React__default.useRef({
            resetActiveRowIndex,
            submenu,
            setActiveRowIndex
        });
        effectRef.current = { resetActiveRowIndex, submenu, setActiveRowIndex };
        // effect: reset the active-row index when the submenu changes
        React__default.useEffect(() => {
            if (effectRef.current.submenu === null) {
                return;
            }
            effectRef.current.resetActiveRowIndex();
        }, [indexResetTrigger]);
        React__default.useEffect(() => {
            if (effectRef.current.submenu === null) {
                return;
            }
            effectRef.current.setActiveRowIndex(-1);
        }, [clearTrigger]);
    }
    const closeSubmenu = React__default.useCallback(() => {
        setOpen(false);
        setSubmenu(null);
    }, [setOpen, setSubmenu]);
    const openSubmenu = React__default.useCallback((submenu, indexAction) => {
        let sameMenuAsLastRender = false;
        setSubmenu((prev) => {
            if (prev === submenu) {
                sameMenuAsLastRender = true;
                return prev;
            }
            sameMenuAsLastRender = false;
            return submenu;
        });
        // case: rendering a new submenu
        if (open && !sameMenuAsLastRender) {
            /*
             * In this case we must not render the child dropdown menu (just for a render)
             * to close (unmount) any nested dropdown menus to avoid them dangling.
             *
             * While migrating to React 18, we needed to ensure that the `setOpen` calls were not batched.
             * When they were, we saw an issue when opening a nested item then hovering a top level item. It caused an infinite loop and focus
             * was placed on the first item in the list. In order to preserve the above logic of maintaining two separate renders, we need to use `flushSync`.
             */
            flushSync(() => {
                setOpen(false);
            });
            /*
             * Queue the opening of the new submenu for a future render.
             * Otherwise, this would overwrite the previous `setOpen` assignment.
             */
            setTimeout(() => setOpen(true), 0);
        }
        // case: rendering the same submenu
        else {
            setOpen(true);
            // We do not want to select the first item in the submenu
            handleActiveIndexChange(-1);
        }
        if (indexAction === 'reset') {
            indexResetTrigger();
        }
        else if (indexAction === 'clear') {
            clearTrigger();
        }
    }, [open, setOpen, handleActiveIndexChange, indexResetTrigger, clearTrigger]);
    const functions = React__default.useMemo(() => {
        return {
            handleActiveIndexChange,
            closeSubmenu,
            openSubmenu
        };
    }, [closeSubmenu, openSubmenu, handleActiveIndexChange]);
    return [submenu, functions, nestedDropdownBag];
}
function useKeyboardHandlers(submenuFunctions, parentButton, onCloseThisDropdown) {
    const { openSubmenu } = submenuFunctions;
    const handleOpenSubMenuForKeyPress = React__default.useCallback((submenu) => {
        if (submenu) {
            openSubmenu(submenu, 'reset');
        }
    }, [openSubmenu]);
    const handleLeftArrowKey = React__default.useCallback(() => {
        // Close this menu and its sub menus
        if (onCloseThisDropdown) {
            onCloseThisDropdown();
        }
        // Focus the parent section that opened the submenu
        if (parentButton) {
            parentButton.focus();
        }
    }, [parentButton, onCloseThisDropdown]);
    return {
        handleRightArrowKey: handleOpenSubMenuForKeyPress,
        handleLeftArrowKey,
        handleSpacebarKey: handleOpenSubMenuForKeyPress,
        handleEnterKey: handleOpenSubMenuForKeyPress
    };
}
//#endregion composited hooks internal to this component

var css$Z = ".DocumentPortal_module_wrapper__961093cb{opacity:0;position:fixed;transition:all .4s cubic-bezier(.25,.25,.25,1);z-index:1000}.DocumentPortal_module_wrapper__961093cb.DocumentPortal_module_right__961093cb{transform:translateX(calc(100% + 40px)) scale(.8)}.DocumentPortal_module_wrapper__961093cb.DocumentPortal_module_left__961093cb{transform:translateX(calc(-100% - 40px)) scale(.8)}.DocumentPortal_module_wrapper__961093cb.DocumentPortal_module_animateEnter__961093cb{opacity:1;transform:none}";
window.ADS.injectStyle(css$Z,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Portal/DocumentPortal/DocumentPortal.module.scss");
var modules_33e68d59 = {"wrapper":"DocumentPortal_module_wrapper__961093cb","right":"DocumentPortal_module_right__961093cb","left":"DocumentPortal_module_left__961093cb","animate-enter":"DocumentPortal_module_animateEnter__961093cb"};

/* eslint-disable @typescript-eslint/no-explicit-any */
classnames.bind(modules_33e68d59);

var css$Y = ".Shroud_module_shroud__wrapper__0ee8c42a{align-items:center;background:#0009;display:grid;height:100vh;justify-content:center;position:fixed;right:0;top:0;width:100vw}.Shroud_module_shroud__wrapper_tinted__0ee8c42a{background:#0009}.Shroud_module_shroud__wrapper_transparent__0ee8c42a{background:#0000}.Shroud_module_alert__0ee8c42a .ads-modal-footer{background:#fff;border-top:none;padding-bottom:24px;padding-top:0}.Shroud_module_alert__0ee8c42a .ads-modal-body{padding-top:0}";
window.ADS.injectStyle(css$Y,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Shroud/Shroud.module.scss");
var modules_629f17d5 = {"shroud__wrapper":"Shroud_module_shroud__wrapper__0ee8c42a","shroud__wrapper_tinted":"Shroud_module_shroud__wrapper_tinted__0ee8c42a","shroud__wrapper_transparent":"Shroud_module_shroud__wrapper_transparent__0ee8c42a","alert":"Shroud_module_alert__0ee8c42a"};

const cx$17 = classnames.bind(modules_629f17d5);
const DEFAULT_Z_INDEX = 900;
function Shroud({ children, containsAlert, customDataProps, lockFocus = true, renderLocation, testId, zIndex = DEFAULT_Z_INDEX, onClick, returnFocusEl }) {
    const alertClass = containsAlert ? 'alert' : undefined;
    // Assumes that a tinted background is not clickable and a transparent background is.
    const shroudColorClass = onClick === undefined
        ? 'shroud__wrapper_tinted'
        : 'shroud__wrapper_transparent';
    const onShroudClick = React__default.useCallback((e) => {
        // Clicks to the shroud's children should not trigger this event.
        // That would be unintuitive. Only handle direct clicks.
        if (e.target !== e.currentTarget)
            return;
        onClick && onClick(e);
    }, [onClick]);
    const handleReturnFocus = React__default.useCallback(() => {
        if (returnFocusEl) {
            returnFocusEl.focus();
            return false;
        }
        return true;
    }, [returnFocusEl]);
    return (React__default.createElement(Portal, { renderLocation: renderLocation },
        React__default.createElement(FocusLock, { returnFocus: handleReturnFocus, disabled: !lockFocus },
            React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$17('shroud__wrapper', alertClass, shroudColorClass), style: { zIndex }, "data-test": testId, onClick: onShroudClick }), children))));
}

var css$X = ".ActionsMenu_module_actionsMenu_anchorWrapper__3930ef93{display:inline-block}";
window.ADS.injectStyle(css$X,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/ActionsMenu/ActionsMenu.module.scss");
var modules_0a439a9f = {"actions-menu_anchor-wrapper":"ActionsMenu_module_actionsMenu_anchorWrapper__3930ef93"};

const DEFAULTS$5 = {
    visibility: 'ready'
};
function mapToMenuTree(menu) {
    const { sections: _sections, visibility } = menu;
    const menuVisibility = visibility !== null && visibility !== void 0 ? visibility : DEFAULTS$5.visibility;
    const isMenuLoading = menuVisibility === 'loading';
    const state = {
        index: 0,
        disabledIndexes: []
    };
    const NO_SECTIONS = [];
    const sections = _sections.flatMap((section) => {
        // edge case: remove the section completely if none of its options are visible
        const noVisibleOptions = section.options.every((option) => option.visibilityConfig === 'hidden');
        if (noVisibleOptions) {
            return NO_SECTIONS;
        }
        const { options } = section;
        const NO_BUTTONS = [];
        const buttons = options.flatMap((option) => {
            // edge case: remove the option completely if it is not visible
            if (option.visibilityConfig === 'hidden') {
                return NO_BUTTONS;
            }
            const index = state.index;
            state.index++;
            const disabledByVis = option.visibilityConfig === 'disabled';
            // Right now, the only way for a row to appear to be loading is if the menu is loading.
            const loading = isMenuLoading;
            switch (option.type) {
                case 'action': {
                    const { icon, label, onClick } = option;
                    const disabled = disabledByVis;
                    if (disabled)
                        state.disabledIndexes.push(index);
                    return {
                        type: 'default',
                        disabled,
                        icon,
                        index,
                        label,
                        loading,
                        onClick
                    };
                }
                case 'parent': {
                    const { icon, label, submenu } = option;
                    const submenuTree = submenu ? mapToMenuTree(submenu) : null;
                    const disabled = submenuTree === null || disabledByVis;
                    if (disabled)
                        state.disabledIndexes.push(index);
                    if (disabled) {
                        return {
                            type: 'with-submenu',
                            disabled: true,
                            icon,
                            index,
                            label,
                            loading,
                            submenu: null
                        };
                    }
                    else {
                        return {
                            type: 'with-submenu',
                            disabled: false,
                            icon,
                            index,
                            label,
                            loading,
                            submenu: submenuTree
                        };
                    }
                }
            }
        });
        const { titleConfig } = section;
        return {
            titleConfig,
            buttons: [buttons[0], ...buttons.slice(1)]
        };
    });
    const oneOrMoreSections = [sections[0], ...sections.slice(1)];
    const menuTree = {
        sections: oneOrMoreSections,
        buttonCount: 
        // zero-based index
        state.index +
            // to one-based count
            1 -
            // minus the last incrementation applied in the `Array.prototype.flatMap` loop imperatively
            1,
        disabledButtonIndices: state.disabledIndexes
    };
    if (menuIsDisabledByOptions(menuTree)) {
        return null;
    }
    return menuTree;
}
function menuIsDisabledByOptions(menuTree) {
    if (menuTree.buttonCount === 0) {
        return true;
    }
    if (menuTree.buttonCount === menuTree.disabledButtonIndices.length) {
        return true;
    }
    // all actions disabled and all parents have disabled submenus (either directly or indirectly)
    return menuTree.sections.every((section) => {
        return section.buttons.every((button) => {
            return match(button)
                .with({ type: 'default' }, (action) => { var _a; return (_a = action.disabled) !== null && _a !== void 0 ? _a : false; })
                .with({ type: 'with-submenu' }, (parent) => {
                var _a;
                // parent is disabled (directly)
                if (((_a = parent.disabled) !== null && _a !== void 0 ? _a : false) || isNil$1(parent.submenu)) {
                    return true;
                }
                // parent is disabled (indirectly by its submenu)
                if (menuIsDisabledByOptions(parent.submenu)) {
                    return true;
                }
                return false;
            })
                .exhaustive();
        });
    });
}

const cx$16 = BindStyles(modules_0a439a9f);
const DEFAULTS$4 = {
    anchorEnabled: true,
    anchorLoading: false,
    dropdownPlacementConfig: {
        placement: 'bottom-start',
        fallbackPlacements: ['bottom-start', 'top-start']
    },
    openOnSpace: true
};
const TEST_IDS$d = {
    anchorWrapper: 'action-menu-anchor-wrapper',
    dropdown: 'action-menu-dropdown',
    shroud: 'action-menu-shroud'
};
/**
 * A component that allows a dropdown menu to open off of an anchoring element, which
 * is defined by the {@link renderAnchor} prop.
 *
 * @typeParam TAnchor - For regular use cases: Only use {@link HTMLButtonElement}. For Chimera's parity requirements, any of the following elements are allowed.
 * @param props - {@link ActionsMenuProps}
 * @returns the tree of elements
 */
function ActionsMenu({ anchorEnabled: _anchorEnabled = DEFAULTS$4.anchorEnabled, anchorLoading = DEFAULTS$4.anchorLoading, dropdownPlacementConfig = DEFAULTS$4.dropdownPlacementConfig, dropdownTestId = TEST_IDS$d.dropdown, menu, openOnSpace = DEFAULTS$4.openOnSpace, shroudTestId = TEST_IDS$d.shroud, renderAnchor }) {
    const menuTree = React__default.useMemo(() => mapToMenuTree(menu), [menu]);
    const [dropdownBag, dropdownFunctions] = useDropdownForDropdownMenu({
        currentMenuTree: menuTree,
        keydownConfig: {
            listenTo: 'anchor-and-dropdown'
        },
        openOnArrowDown: true,
        openOnSpace: openOnSpace
    });
    const { dropdown, dropdownAnchorRef, dropdownProps } = dropdownBag;
    const { activeRowIndex, open, setOpen: _setOpen, toggle } = dropdown;
    const { anchorEl } = dropdownProps;
    const [{ setOpen, setClosed }] = React__default.useState({
        setOpen: () => void _setOpen(true),
        setClosed: () => void _setOpen(false)
    });
    const anchorEnabled = match([_anchorEnabled, menuTree])
        // coerce to disabled if the menu tree is fully non-enabled
        .with([P._, P.nullish], () => false)
        .otherwise(([anchorEnabled]) => anchorEnabled);
    const anchor = renderAnchor({
        enabled: anchorEnabled,
        loading: anchorLoading,
        focusableRef: dropdownAnchorRef,
        open,
        onMenuToggle: toggle,
        onMenuOpen: setOpen,
        onMenuClose: setClosed
    });
    // This is the dropdown menu, which is only displayed when open and at least partially enabled.
    const sometimesDropdownJsx = (function () {
        // case: menu is not open             -> hidden (nothing to display)
        if (!open)
            return null;
        // case: menu is fully non-enabled    -> hidden (nothing to display)
        if (!menuTree)
            return null;
        return (React__default.createElement(Shroud, { containsAlert: false, returnFocusEl: anchorEl, testId: shroudTestId, onClick: dropdownFunctions.handleClose },
            React__default.createElement(DropdownMenu, { activeRowIndex: activeRowIndex, buttonSize: "md", currentDropdownFunctions: dropdownFunctions, currentDropdownProps: dropdownProps, depth: 0, menuModality: "dropdown", menuTree: menuTree, menuWidth: "regular", minWidthMatchAnchor: true, placementConfig: dropdownPlacementConfig, testId: dropdownTestId, 
                // Closing the top-level dropdown menu closes all nested, too.
                onCloseAllDropdowns: dropdownFunctions.handleClose })));
    })();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ResizeListenerManager, { onResize: dropdownFunctions.handleClose }),
        React__default.createElement("div", { className: cx$16('actions-menu_anchor-wrapper'), "data-test": TEST_IDS$d.anchorWrapper, onBlur: (e) => {
                dropdown.blurred(e);
                e.stopPropagation();
            }, onClick: CancelReactEvent }, anchor),
        sometimesDropdownJsx));
}

var css$W = ".ActionsMenuButton_module_actionsMenuButton_wrapper__21ad010c{display:inline-block}.ActionsMenuButton_module_dropdownIcon__21ad010c{margin-left:6px}.ActionsMenuButton_module_dropdownIconFill__21ad010c{fill:#365ef6;stroke:none}.ActionsMenuButton_module_dropdownIconFill__21ad010c.ActionsMenuButton_module_disabled__21ad010c{fill:#b0b4bf;stroke:none}.ActionsMenuButton_module_dropdownIconFill__21ad010c.ActionsMenuButton_module_isPrimary__21ad010c{fill:#fff}";
window.ADS.injectStyle(css$W,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/ActionsMenuButton/ActionsMenuButton.module.scss");
var modules_b786038b = {"actions-menu-button_wrapper":"ActionsMenuButton_module_actionsMenuButton_wrapper__21ad010c","dropdownIcon":"ActionsMenuButton_module_dropdownIcon__21ad010c","dropdownIconFill":"ActionsMenuButton_module_dropdownIconFill__21ad010c","disabled":"ActionsMenuButton_module_disabled__21ad010c","isPrimary":"ActionsMenuButton_module_isPrimary__21ad010c"};

const cx$15 = BindStyles(modules_b786038b);
const DEFAULTS$3 = {
    disabled: false,
    dropdownPlacementConfig: {
        placement: 'bottom-start',
        fallbackPlacements: ['bottom-start', 'top-start']
    },
    isLoading: false
};
const TEST_IDS$c = {
    button: 'action-menu-button',
    dropdown: 'action-menu-button-dropdown',
    shroud: 'action-menu-button-shroud'
};
const ActionsMenuButton = ({ 
// from button props
ariaLabel, customDataProps, disabled = DEFAULTS$3.disabled, icon, isLoading = DEFAULTS$3.isLoading, tabIndex, testId = TEST_IDS$c.button, tooltip, 
// our unique props
actionsMenuConfig, buttonText, dropdownPlacementConfig = DEFAULTS$3.dropdownPlacementConfig }) => {
    const anchorEnabled = !disabled;
    const anchorLoading = isLoading;
    const renderAnchor = React__default.useMemo(() => {
        return function AnchoringButton({ enabled, loading, focusableRef, open, onMenuToggle }) {
            const buttonIsDisabled = !enabled;
            const buttonIsLoading = loading;
            const menuIsOpen = open;
            return (React__default.createElement(ButtonBase, { ref: focusableRef, ariaLabel: ariaLabel, customDataProps: customDataProps, disabled: buttonIsDisabled, icon: icon, isLoading: buttonIsLoading, isClickableWhileLoading: true, tabIndex: tabIndex, testId: testId, tooltip: tooltip, onClick: onMenuToggle }, buttonText && (React__default.createElement(React__default.Fragment, null,
                buttonText,
                React__default.createElement(Icon, { className: cx$15('dropdownIcon', { disabled: buttonIsDisabled }), disabled: buttonIsDisabled, fillClass: cx$15('dropdownIconFill', {
                        disabled: buttonIsDisabled
                    }), focused: menuIsOpen, icon: "ChevronIcon", size: 16 })))));
        };
    }, [
        ariaLabel,
        buttonText,
        customDataProps,
        icon,
        tabIndex,
        testId,
        tooltip
    ]);
    return (React__default.createElement("div", { onClick: stopMouseEventPropagation },
        React__default.createElement(ActionsMenu, { anchorEnabled: anchorEnabled, anchorLoading: anchorLoading, dropdownPlacementConfig: dropdownPlacementConfig, dropdownTestId: TEST_IDS$c.dropdown, menu: actionsMenuConfig.menu, openOnSpace: true, shroudTestId: TEST_IDS$c.shroud, renderAnchor: renderAnchor })));
};
/**
 * This is a rare exception where clicks and context-menu clicks should not
 * bubble to their parents.
 *
 * Given this, we use `stopPropagation` on those events from `RowActionsButton`
 * to avoid it traveling higher since a `DataGridRow` handles both events in
 * inapplicable ways.
 */
function stopMouseEventPropagation(e) {
    e.stopPropagation();
}

var css$V = ".ButtonGroup_module_group__02095650{position:relative;white-space:nowrap;z-index:0}.ButtonGroup_module_group__02095650 button:enabled{z-index:1}.ButtonGroup_module_group__02095650 button:disabled{z-index:0}.ButtonGroup_module_group__02095650 button:focus{z-index:2}";
window.ADS.injectStyle(css$V,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/ButtonGroup/ButtonGroup.module.scss");
var modules_06b04e86 = {"group":"ButtonGroup_module_group__02095650"};

/**
 * `ButtonGroup` is used to when multiple actions are possible. `Button` children will inherit the size of the `ButtonGroup` parent, but will have the `type` overriden even if set (always 'secondary').
 */
const ButtonGroup = ({ size, disabled = false, customDataProps, children, testId }) => {
    useRestrictedChildType('ButtonGroup', ['Button', 'SplitButton', 'DropdownButton'], children);
    const getChildType = (index, numChildren) => {
        if (index === 0) {
            return 'first';
        }
        else if (index < numChildren - 1) {
            return 'middle';
        }
        else {
            return 'last';
        }
    };
    const renderChildren = () => {
        const actualChildren = React__default.Children.toArray(children).filter(React__default.isValidElement);
        return actualChildren.map((button, index) => {
            return React__default.cloneElement(button, {
                disabled: disabled || button.props.disabled, // Respect both group and individual button disabled state
                type: 'secondary',
                size: size || button.props.size,
                groupChildType: getChildType(index, actualChildren.length)
            });
        });
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'button-group', className: cx$1S(modules_06b04e86.group) }), renderChildren()));
};

const ButtonContainer = ({ customDataProps, testId, align = Align.Right, children }) => (React__default.createElement(Flex, { customDataProps: customDataProps, testId: testId, className: cx$1S('w-100p', 'gap-100', {
        'flex-align-end': align === Align.Right,
        'flex-align-center': align === Align.Center
    }) }, children));

var css$U = ".ButtonDropdown_module_dropdown__4f0f7a89{display:flex;flex-direction:column}.ButtonDropdown_module_button__4f0f7a89{border-color:#0000;border-left:#0000;border-radius:0;border-right:#0000;justify-content:left;z-index:1}.ButtonDropdown_module_button__4f0f7a89.ButtonDropdown_module_tooltip__4f0f7a89{width:100%}.ButtonDropdown_module_button__4f0f7a89:hover{background-color:#fff;border-left:#0000;border-right:#0000;z-index:2}.ButtonDropdown_module_button__4f0f7a89:focus{background-color:#e3eafc;border-left:#0000;border-right:#0000;box-shadow:none;z-index:3}.ButtonDropdown_module_button__4f0f7a89:active{background-color:#d5e1fb}.ButtonDropdown_module_button__4f0f7a89:first-child{border-top:#0000}.ButtonDropdown_module_button__4f0f7a89:not(:first-child):not(:last-child){position:relative;top:-1px}.ButtonDropdown_module_button__4f0f7a89:last-child{border-bottom:#0000;margin-top:-1px}";
window.ADS.injectStyle(css$U,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/ButtonDropdown.module.scss");
var modules_4a3a1682 = {"dropdown":"ButtonDropdown_module_dropdown__4f0f7a89","button":"ButtonDropdown_module_button__4f0f7a89","tooltip":"ButtonDropdown_module_tooltip__4f0f7a89"};

const cx$14 = BindStyles(modules_4a3a1682);
const ButtonDropdown = ({ activeRowIndex = 0, children, open, size = 'md', onRowHover, onSelected }) => {
    const handleClick = (child, e, index) => {
        onSelected && onSelected(child, index);
        child.props.onClick && child.props.onClick(e);
    };
    const handleMouseEnter = (index) => {
        onRowHover && onRowHover(index);
    };
    function renderChildren() {
        return React__default.Children.map(children, (child, idx) => {
            if (React__default.isValidElement(child)) {
                return React__default.cloneElement(child, {
                    className: cx$14('button', {
                        tooltip: child.props.tooltip
                    }),
                    isFocused: activeRowIndex === idx && open, // do not focus when the dropdown is closed
                    size,
                    type: 'secondary',
                    onClick: (e) => handleClick(child, e, idx),
                    onMouseEnter: () => handleMouseEnter(idx)
                });
            }
        });
    }
    return React__default.createElement("div", { className: modules_4a3a1682.dropdown }, renderChildren());
};

var css$T = ".DropdownButton_module_container__b6f2d305{align-self:start;display:inline-block;position:relative}.DropdownButton_module_buttonWrapper__b6f2d305{position:relative;white-space:nowrap}.DropdownButton_module_baseButton__b6f2d305{padding-right:14px;position:relative;vertical-align:top;z-index:1}.DropdownButton_module_baseButton__b6f2d305:focus{z-index:3}.DropdownButton_module_baseButton__b6f2d305:hover{z-index:2}.DropdownButton_module_baseButton__b6f2d305.DropdownButton_module_withIcon__b6f2d305{border-bottom-right-radius:0;border-top-right-radius:0;padding-right:16px}.DropdownButton_module_dropdownIcon__b6f2d305{margin-left:6px}.DropdownButton_module_dropdownIconFill__b6f2d305{fill:#365ef6;stroke:none}.DropdownButton_module_dropdownIconFill__b6f2d305.DropdownButton_module_disabled__b6f2d305{fill:#b0b4bf;stroke:none}.DropdownButton_module_dropdownIconFill__b6f2d305.DropdownButton_module_isPrimary__b6f2d305{fill:#fff}.DropdownButton_module_iconButton__b6f2d305{border-bottom-left-radius:0;border-bottom-right-radius:3px;border-top-left-radius:0;border-top-right-radius:3px}.DropdownButton_module_iconButton__b6f2d305:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.DropdownButton_module_iconButton__b6f2d305:not(:first-child):not(:last-child){border-radius:0;margin-left:-1px}.DropdownButton_module_iconButton__b6f2d305:last-child{border-bottom-left-radius:0;border-bottom-right-radius:3px;border-top-left-radius:0;border-top-right-radius:3px;margin-left:-1px}.DropdownButton_module_iconButton__b6f2d305:last-child.DropdownButton_module_isPrimary__b6f2d305{margin-left:1px}";
window.ADS.injectStyle(css$T,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/DropdownButton/DropdownButton.module.scss");
var modules_f09916c2 = {"container":"DropdownButton_module_container__b6f2d305","buttonWrapper":"DropdownButton_module_buttonWrapper__b6f2d305","baseButton":"DropdownButton_module_baseButton__b6f2d305","withIcon":"DropdownButton_module_withIcon__b6f2d305","dropdownIcon":"DropdownButton_module_dropdownIcon__b6f2d305","dropdownIconFill":"DropdownButton_module_dropdownIconFill__b6f2d305","disabled":"DropdownButton_module_disabled__b6f2d305","isPrimary":"DropdownButton_module_isPrimary__b6f2d305","iconButton":"DropdownButton_module_iconButton__b6f2d305"};

const cx$13 = classnames.bind(modules_f09916c2);
/**
 * `DropdownButton` is used to present the user with multiple actions where the main button opens a dropdown containing child Buttons.
 */
const DropdownButton = (_a) => {
    var { children, disabled = false, label, size = 'md' } = _a, props = __rest(_a, ["children", "disabled", "label", "size"]);
    const childCount = React__default.Children.count(children);
    const { dropdown, dropdownProps, dropdownAnchorRef } = useDropdown({
        numberOfItems: childCount
    });
    const handleSelected = (_button, index) => {
        dropdown.setOpen(false);
        dropdown.setActiveRowIndex(index);
    };
    const handleRowHover = (index) => {
        dropdown.setActiveRowIndex(index);
    };
    return (React__default.createElement("div", { className: cx$13('container'), ref: dropdownAnchorRef, onBlur: dropdown.blurred },
        React__default.createElement("div", { className: cx$13('buttonWrapper'), onClick: () => !disabled && dropdown.toggle() },
            React__default.createElement(ButtonBase, Object.assign({ disabled: disabled, size: size }, props, { onClick: undefined, className: cx$13('baseButton') }),
                label,
                React__default.createElement(Icon, { icon: "ChevronIcon", className: cx$13('dropdownIcon', { disabled: disabled }), focused: dropdown.open, fillClass: cx$13('dropdownIconFill', { disabled: disabled }), size: 16 }))),
        React__default.createElement(Dropdown, Object.assign({}, dropdownProps),
            React__default.createElement(DropdownContainer, null,
                React__default.createElement(ButtonDropdown, { activeRowIndex: dropdown.activeRowIndex, open: dropdownProps.open, size: size, onRowHover: handleRowHover, onSelected: handleSelected }, children ? children : React__default.createElement(React__default.Fragment, null))))));
};

var css$S = ".HelpButton_module_helpIcon__6ea8f5cb{fill:#858b9d;background:#0000;border:none;border-radius:4px;cursor:pointer;display:inline-block;outline:none;padding:5px;transition:border-color .15s,background-color .15s,color .15s}.HelpButton_module_helpIcon__6ea8f5cb.HelpButton_module_md__6ea8f5cb{padding:5px}.HelpButton_module_helpIcon__6ea8f5cb.HelpButton_module_sm__6ea8f5cb,.HelpButton_module_helpIcon__6ea8f5cb.HelpButton_module_xs__6ea8f5cb{padding:2px}.HelpButton_module_helpIcon__6ea8f5cb.HelpButton_module_disabled__6ea8f5cb{cursor:default}.HelpButton_module_helpIcon__6ea8f5cb.HelpButton_module_disabled__6ea8f5cb svg path{fill:#cbced7;cursor:default}.HelpButton_module_helpIcon__6ea8f5cb:not(.HelpButton_module_disabled__6ea8f5cb):hover{background:#e5e6eb}.HelpButton_module_helpIcon__6ea8f5cb:not(.HelpButton_module_disabled__6ea8f5cb):active{background:#d9dbe3;box-shadow:none}.HelpButton_module_helpIcon__6ea8f5cb:not(.HelpButton_module_disabled__6ea8f5cb):focus{box-shadow:0 0 0 4px #365ef64d}.HelpButton_module_helpIcon__6ea8f5cb:not(.HelpButton_module_disabled__6ea8f5cb):focus:active{box-shadow:none}";
window.ADS.injectStyle(css$S,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Button/HelpButton.module.scss");
var modules_d91adacb = {"helpIcon":"HelpButton_module_helpIcon__6ea8f5cb","md":"HelpButton_module_md__6ea8f5cb","sm":"HelpButton_module_sm__6ea8f5cb","xs":"HelpButton_module_xs__6ea8f5cb","disabled":"HelpButton_module_disabled__6ea8f5cb"};

const cx$12 = classnames.bind(modules_d91adacb);
const HelpButton = React__default.forwardRef(({ customDataProps, testId, className, disabled = false, size = 'md', onClick }, ref) => {
    const iconSizeMap = { xs: 16, sm: 18, md: 22 };
    const handleKeyDown = (e) => {
        const handled = KeyHandleMap(e, [{ Enter: () => onClick && onClick(e) }]);
        if (handled) {
            CancelReactEvent(e);
        }
    };
    const handleOnClick = (e) => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };
    return (React__default.createElement("button", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, ref: ref, onKeyDown: handleKeyDown, onClick: handleOnClick, className: cx$12('helpIcon', className, size, { disabled }) }),
        React__default.createElement(Icon, { icon: "QuestionCircleIcon", strokeClass: cx$12('helpIcon'), size: iconSizeMap[size] })));
});
HelpButton.displayName = 'HelpButton';

const cx$11 = classnames.bind(modules_f09916c2);
const TEST_IDS$b = {
    dropdownToggle: 'dropdownToggle'
};
/**
 * `SplitButton` is used where multiple actions are possible and space is limited (example: data grid row actions). Useful when there is one most common/applicable action, but 2+ additional less-frequently used actions.
 */
const SplitButton = (_a) => {
    var { children, disabled = false, label, size = 'md', type = 'secondary' } = _a, props = __rest(_a, ["children", "disabled", "label", "size", "type"]);
    const childCount = React__default.Children.count(children);
    const isPrimary = type === 'primary';
    const { dropdown, dropdownProps, dropdownAnchorRef } = useDropdown({
        numberOfItems: childCount
    });
    const onIconClickHandler = () => {
        dropdown.toggle();
    };
    const handleBaseClick = (e) => {
        dropdown.setOpen(false);
        props.onClick && props.onClick(e);
    };
    const handleSelected = (_button, index) => {
        dropdown.setOpen(false);
        dropdown.setActiveRowIndex(index);
    };
    const handleRowHover = (index) => {
        dropdown.setActiveRowIndex(index);
    };
    useRestrictedChildType('SplitButton', ['Button'], children);
    return (React__default.createElement("div", { className: cx$11('container'), ref: dropdownAnchorRef, onBlur: dropdown.blurred },
        React__default.createElement("div", { className: cx$11('buttonWrapper') },
            React__default.createElement(ButtonBase, Object.assign({ disabled: disabled, size: size, type: type }, props, { onClick: handleBaseClick, className: cx$11('baseButton', 'withIcon', props.className) }), label),
            React__default.createElement(ButtonBase, { testId: TEST_IDS$b.dropdownToggle, className: cx$11('baseButton', 'iconButton', {
                    isPrimary
                }), type: type, icon: "MeatballIcon", ariaLabel: "Dropdown toggle button", onClick: onIconClickHandler, size: size, disabled: disabled, iconFocused: dropdown.open, iconFillClass: cx$11('dropdownIconFill', {
                    disabled: disabled,
                    isPrimary
                }), iconSize: 16, isFocused: dropdown.activeRowIndex === -1 })),
        React__default.createElement(Dropdown, Object.assign({}, dropdownProps),
            React__default.createElement(DropdownContainer, null,
                React__default.createElement(ButtonDropdown, { activeRowIndex: dropdown.activeRowIndex, open: dropdownProps.open, size: size, onRowHover: handleRowHover, onSelected: handleSelected }, children)))));
};
SplitButton.displayName = 'SplitButton';

var css$R = ".Card_module_card__fdd0168b{background:#fff;border:1px solid #b0b4bf;border-radius:5px;box-shadow:0 2px 1px -1px #0003,0 1px 1px 0 #00000024,0 1px 3px 0 #0000001f;padding:24px}";
window.ADS.injectStyle(css$R,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Card/Card.module.scss");
var modules_cf3bd172 = {"card":"Card_module_card__fdd0168b"};

const cx$10 = BindStyles(modules_cf3bd172);
const Card = ({ testId, className, children, customDataProps }) => (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$10('card', className), "data-test": testId }), children));

var css$Q = ".Checkbox_module_checkbox__144e338b{display:inline-flex;gap:0;margin:6px 0;position:relative}.Checkbox_module_checkbox__144e338b label{align-items:center;color:#363840;font-weight:400;line-height:20px}.Checkbox_module_checkbox__144e338b label:hover{cursor:pointer}.Checkbox_module_checkbox__144e338b label:hover:before{border-color:#365ef6}.Checkbox_module_checkbox__144e338b label:after,.Checkbox_module_checkbox__144e338b label:before{height:18px;left:0;margin:1px 0;position:absolute;top:0;width:18px}.Checkbox_module_checkbox__144e338b label:before{background-color:#fff;border:1px solid #b0b4bf;border-radius:3px;content:\"\";display:inline-block;transition:all .26s cubic-bezier(.78,.14,.15,.86)}.Checkbox_module_checkbox__144e338b label:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23444750'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat}.Checkbox_module_checkbox__144e338b.Checkbox_module_error__144e338b label:before{border-color:#ea0a3b}.Checkbox_module_checkbox__144e338b.Checkbox_module_warning__144e338b label:before{border-color:#f45110}.Checkbox_module_checkbox__144e338b.Checkbox_module_disabled__144e338b label:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23b0b4bf'/%3E%3C/svg%3E\")}.Checkbox_module_input__144e338b{margin:0;min-height:18px;min-width:18px;opacity:0}.Checkbox_module_input__144e338b+label:after{content:none}.Checkbox_module_input__144e338b:checked+label:after{content:\"\"}.Checkbox_module_input__144e338b:focus+label:before{border-color:#365ef6;box-shadow:0 0 0 3px #365ef666}.Checkbox_module_input__144e338b:checked+label:before{background-color:#fff}.Checkbox_module_input__144e338b:checked:focus+label:before{box-shadow:0 0 0 3px #365ef64d}.Checkbox_module_input__144e338b:disabled{cursor:default!important;pointer-events:none;user-select:none}.Checkbox_module_input__144e338b:disabled+label{color:#b0b4bf;cursor:default!important;user-select:none}.Checkbox_module_input__144e338b:disabled+label:before{background-color:#e5e6eb;border-color:#cbced7;cursor:default!important}.Checkbox_module_readOnly__144e338b label{color:#363840!important;user-select:auto!important}.Checkbox_module_readOnly__144e338b label:before{background-color:#e5e6eb;border-color:#cbced7;cursor:default!important}.Checkbox_module_reverse__144e338b label:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23fff'/%3E%3C/svg%3E\")}.Checkbox_module_reverse__144e338b .Checkbox_module_input__144e338b:checked+label:before{background-color:#365ef6;border-color:#365ef6}.Checkbox_module_reverse__144e338b .Checkbox_module_input__144e338b:checked:focus+label:before{box-shadow:0 0 0 3px #365ef666}.Checkbox_module_reverse__144e338b.Checkbox_module_disabled__144e338b label:before{background-color:#e5e6eb!important;border-color:#cbced7!important}.Checkbox_module_ghost__144e338b .Checkbox_module_input__144e338b:checked+label:before,.Checkbox_module_ghost__144e338b .Checkbox_module_input__144e338b:not(:checked)+label:before{background-color:#aabff8;border-color:#aabff8}";
window.ADS.injectStyle(css$Q,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Checkbox/Checkbox.module.scss");
var modules_6238daf1 = {"checkbox":"Checkbox_module_checkbox__144e338b","error":"Checkbox_module_error__144e338b","warning":"Checkbox_module_warning__144e338b","disabled":"Checkbox_module_disabled__144e338b","input":"Checkbox_module_input__144e338b","readOnly":"Checkbox_module_readOnly__144e338b","reverse":"Checkbox_module_reverse__144e338b","ghost":"Checkbox_module_ghost__144e338b"};

const cx$$ = BindStyles(modules_6238daf1);
// Base Checkbox component
const CheckboxBase = ({ autoFocus, children, className, customDataProps, disabled, error, ghost, inputRef, name, preventClickPropagation = false, readOnly, testId, tooltip = '', type = 'default', value = false, warning, onBlur, onChange, onFocus }) => {
    const labelIdRef = React__default.useRef(UUIDv4());
    const handleChange = (e) => {
        onChange && onChange({ target: { name, value: e.target.checked } });
    };
    const handleFocus = (e) => {
        e.persist();
        onFocus && onFocus(e);
    };
    const handleBlur = (e) => {
        e.persist();
        onBlur && onBlur(e);
    };
    // Stop event propagation for checkbox clicks
    const handleClick = React__default.useCallback((e) => {
        if (preventClickPropagation) {
            e.stopPropagation(); // Prevent the event from bubbling up to parent components
        }
    }, [preventClickPropagation]);
    return (React__default.createElement(Tooltip, { disabled: !tooltip, content: tooltip },
        React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$$('checkbox', type, className, {
                error,
                warning,
                disabled,
                readOnly,
                ghost
            }) }),
            React__default.createElement("input", { autoFocus: autoFocus, checked: value, className: cx$$(modules_6238daf1.input), disabled: disabled || readOnly, id: labelIdRef.current, name: name, ref: inputRef, type: "checkbox", onBlur: handleBlur, onChange: handleChange, onClick: handleClick, onFocus: handleFocus }),
            React__default.createElement("label", { className: cx$$({ 'pl-50': children }), htmlFor: labelIdRef.current, onClick: handleClick }, children))));
};
// Version that is a child of a CheckboxList
/** @deprecated Use CheckboxItemV2 instead as that will allow you to properly render content within the checkbox. This will be removed in ADS V8. */
const CheckboxItem = (_a) => {
    var { customDataProps, testId } = _a, props = __rest(_a, ["customDataProps", "testId"]);
    return (React__default.createElement(CheckboxBase, Object.assign({ customDataProps: customDataProps, testId: testId }, props)));
};
CheckboxItem.displayName = 'CheckboxItem'; // used for type validation in CheckboxList
const CheckboxBaseField = withField(CheckboxBase);
const UnControlledCheckbox = (props) => {
    var _a;
    const [value, setValue] = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : false);
    return (React__default.createElement(CheckboxBaseField, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneCheckbox = withStandAlone(UnControlledCheckbox, CheckboxBase);
// Standalone version of Checkbox that supports be part of a field schema
const Checkbox = withFieldSchemaSupport$1(StandAloneCheckbox, withFieldSchema(CheckboxBaseField));

var css$P = ".CheckboxBaseV2_module_checkbox__04dd7bdd{align-items:start;display:inline-flex;gap:0;margin:6px 0;position:relative}.CheckboxBaseV2_module_checkbox__04dd7bdd.CheckboxBaseV2_module_hasRenderContent__04dd7bdd:not(.CheckboxBaseV2_module_wrapped__04dd7bdd){margin-bottom:14px;margin-top:14px}.CheckboxBaseV2_module_checkbox__04dd7bdd label{align-items:center;color:#363840;cursor:pointer;font-weight:400;line-height:20px;padding-left:8px}.CheckboxBaseV2_module_checkbox__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd{display:inline-block;flex:0 0 18px;height:18px;position:relative;width:18px}.CheckboxBaseV2_module_checkbox__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after,.CheckboxBaseV2_module_checkbox__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{height:18px;left:0;margin:1px 0;position:absolute;top:0;width:18px}.CheckboxBaseV2_module_checkbox__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#fff;border:1px solid #b0b4bf;border-radius:3px;content:\"\";display:inline-block;transition:all .26s cubic-bezier(.78,.14,.15,.86)}.CheckboxBaseV2_module_checkbox__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23444750'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat}.CheckboxBaseV2_module_checkbox__04dd7bdd.CheckboxBaseV2_module_wrapped__04dd7bdd{flex:1 1}.CheckboxBaseV2_module_checkbox__04dd7bdd.CheckboxBaseV2_module_error__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{border-color:#ea0a3b}.CheckboxBaseV2_module_checkbox__04dd7bdd.CheckboxBaseV2_module_warning__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{border-color:#f45110}.CheckboxBaseV2_module_checkbox__04dd7bdd.CheckboxBaseV2_module_disabled__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23b0b4bf'/%3E%3C/svg%3E\")}.CheckboxBaseV2_module_renderContent__04dd7bdd{padding-bottom:8px;padding-top:8px}.CheckboxBaseV2_module_renderContent__04dd7bdd.CheckboxBaseV2_module_wrapped__04dd7bdd{padding-bottom:12px;padding-left:26px;padding-top:0}.CheckboxBaseV2_module_renderContent__04dd7bdd.CheckboxBaseV2_module_isLastChild__04dd7bdd{padding-bottom:0}.CheckboxBaseV2_module_input__04dd7bdd{cursor:pointer;height:18px;left:0;margin:0;opacity:0;position:absolute;top:0;width:18px;z-index:1}.CheckboxBaseV2_module_input__04dd7bdd+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after{content:none}.CheckboxBaseV2_module_input__04dd7bdd:hover+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{border-color:#365ef6}.CheckboxBaseV2_module_input__04dd7bdd:checked+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after{content:\"\"}.CheckboxBaseV2_module_input__04dd7bdd:focus+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{border-color:#365ef6;box-shadow:0 0 0 3px #365ef666}.CheckboxBaseV2_module_input__04dd7bdd:checked+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#fff}.CheckboxBaseV2_module_input__04dd7bdd:checked:focus+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{box-shadow:0 0 0 3px #365ef64d}.CheckboxBaseV2_module_input__04dd7bdd:disabled{cursor:default!important;pointer-events:none;user-select:none}.CheckboxBaseV2_module_input__04dd7bdd:disabled+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#e5e6eb;border-color:#cbced7;cursor:default!important}.CheckboxBaseV2_module_disabled__04dd7bdd label{color:#b0b4bf;cursor:default!important;user-select:none}.CheckboxBaseV2_module_readOnly__04dd7bdd label{color:#363840!important;cursor:default!important;user-select:auto!important}.CheckboxBaseV2_module_readOnly__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#e5e6eb;border-color:#cbced7;cursor:default!important}.CheckboxBaseV2_module_reverse__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.64 4.232a1 1 0 0 1 .128 1.408l-5 6a1 1 0 0 1-1.475.067l-3-3a1 1 0 0 1 1.414-1.414l2.226 2.226 4.299-5.16a1 1 0 0 1 1.408-.127Z' fill='%23fff'/%3E%3C/svg%3E\")}.CheckboxBaseV2_module_reverse__04dd7bdd .CheckboxBaseV2_module_input__04dd7bdd:checked+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#365ef6;border-color:#365ef6}.CheckboxBaseV2_module_reverse__04dd7bdd .CheckboxBaseV2_module_input__04dd7bdd:checked:focus+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{box-shadow:0 0 0 3px #365ef666}.CheckboxBaseV2_module_reverse__04dd7bdd.CheckboxBaseV2_module_disabled__04dd7bdd .CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#e5e6eb!important;border-color:#cbced7!important}.CheckboxBaseV2_module_ghost__04dd7bdd .CheckboxBaseV2_module_input__04dd7bdd:checked+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before,.CheckboxBaseV2_module_ghost__04dd7bdd .CheckboxBaseV2_module_input__04dd7bdd:not(:checked)+.CheckboxBaseV2_module_inputStyleMask__04dd7bdd:before{background-color:#aabff8;border-color:#aabff8}";
window.ADS.injectStyle(css$P,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Checkbox/CheckboxBaseV2.module.scss");
var modules_1d8cf406 = {"checkbox":"CheckboxBaseV2_module_checkbox__04dd7bdd","hasRenderContent":"CheckboxBaseV2_module_hasRenderContent__04dd7bdd","wrapped":"CheckboxBaseV2_module_wrapped__04dd7bdd","input-style-mask":"CheckboxBaseV2_module_inputStyleMask__04dd7bdd","error":"CheckboxBaseV2_module_error__04dd7bdd","warning":"CheckboxBaseV2_module_warning__04dd7bdd","disabled":"CheckboxBaseV2_module_disabled__04dd7bdd","renderContent":"CheckboxBaseV2_module_renderContent__04dd7bdd","isLastChild":"CheckboxBaseV2_module_isLastChild__04dd7bdd","input":"CheckboxBaseV2_module_input__04dd7bdd","readOnly":"CheckboxBaseV2_module_readOnly__04dd7bdd","reverse":"CheckboxBaseV2_module_reverse__04dd7bdd","ghost":"CheckboxBaseV2_module_ghost__04dd7bdd"};

const cx$_ = BindStyles(modules_1d8cf406);
// Base Checkbox component
const CheckboxBaseV2 = ({ autoFocus, className, contentConfig, customDataProps, disabled, error, ghost, inputRef, isLastChild, label, name, preventClickPropagation = false, readOnly, renderContent, testId, tooltip = '', type = 'default', value = false, warning, onBlur, onChange, onFocus }) => {
    const labelIdRef = React__default.useRef(UUIDv4());
    const handleChange = (e) => {
        onChange && onChange({ target: { name, value: e.target.checked } });
    };
    const handleFocus = (e) => {
        e.persist();
        onFocus && onFocus(e);
    };
    const handleBlur = (e) => {
        e.persist();
        onBlur && onBlur(e);
    };
    // Stop event propagation for checkbox clicks
    const handleClick = React__default.useCallback((e) => {
        if (preventClickPropagation) {
            e.stopPropagation(); // Prevent the event from bubbling up to parent components
        }
    }, [preventClickPropagation]);
    return (React__default.createElement(Flex, { testId: TestIdUtils.composeId(testId, 'container'), className: cx$_('gap-v-0', 'flex-no-wrap', {
            'flex-d-column': contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
            'flex-d-row': !(contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped),
            'gap-h-50': !label
        }) },
        React__default.createElement(Tooltip, { disabled: !tooltip, content: tooltip },
            React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, style: {
                    width: !(contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped)
                        ? contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.controlColumnWidth
                        : '100%'
                }, className: cx$_('checkbox', type, className, {
                    error,
                    warning,
                    disabled,
                    readOnly,
                    ghost,
                    wrapped: contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
                    hasRenderContent: renderContent
                }) }),
                React__default.createElement("input", { "data-test": TestIdUtils.composeId(testId, 'input'), autoFocus: autoFocus, checked: value, className: cx$_(modules_1d8cf406.input), disabled: disabled || readOnly, id: labelIdRef.current, name: name, ref: inputRef, type: "checkbox", onBlur: handleBlur, onChange: handleChange, onClick: handleClick, onFocus: handleFocus }),
                React__default.createElement("span", { "data-test": TestIdUtils.composeId(testId, 'style-mask'), className: cx$_('input-style-mask') }),
                label && (React__default.createElement("label", { "data-test": TestIdUtils.composeId(testId, 'label'), htmlFor: labelIdRef.current, onClick: handleClick }, label)))),
        renderContent && (React__default.createElement("div", { "data-test": TestIdUtils.composeId(testId, 'render-content'), className: cx$_('renderContent', 'flex-item', {
                wrapped: contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
                isLastChild
            }) }, renderContent({ disabled: disabled || !value })))));
};
// Version that is a child of a CheckboxList
const CheckboxItemV2 = (_a) => {
    var { customDataProps, testId } = _a, props = __rest(_a, ["customDataProps", "testId"]);
    return (React__default.createElement(CheckboxBaseV2, Object.assign({ customDataProps: customDataProps, testId: testId }, props)));
};
CheckboxItemV2.displayName = 'CheckboxItemV2'; // used for type validation in CheckboxList

var css$O = ".CheckboxList_module_list__547a2718{border-radius:3px;display:inline-flex;flex-wrap:wrap;gap:0 16px;width:100%}.CheckboxList_module_vertical__547a2718{flex-direction:column;row-gap:0}";
window.ADS.injectStyle(css$O,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/CheckboxList/CheckboxList.module.scss");
var modules_843fcb1a = {"list":"CheckboxList_module_list__547a2718","vertical":"CheckboxList_module_vertical__547a2718"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$Z = classnames.bind(modules_843fcb1a);
/**
 * `CheckboxList` displays checkboxes in a group. Children of CheckboxList should
 *  be `CheckboxItem` and not `Checkbox`. CheckboxList acts as a single form
 *  element even though it contains several child CheckboxItem components. Its
 *  value is an array of the children that are currently checked.
 *
 * CheckboxList extends the `FieldProps`, and will have all the props of a `Field`
 * component.
 */
const CheckboxListBase = ({ autoFocus, singleSelectValueType = 'array', childClassName = '', children, contentLayoutConfig, customDataProps, direction = 'horizontal', disabled = false, error, inputRef, items, name, numVerticalColumns = 0, readOnly = false, testId, type, value = [], warning, onBlur, onChange, onFocus }) => {
    useRestrictedChildType('CheckboxList', ['CheckboxItem', 'CheckboxItemV2'], children);
    const ref = React__default.useRef(null);
    const { width } = useSize(ref.current);
    const contentConfig = React__default.useCallback((contentLayoutOverride) => {
        var _a, _b;
        // Use the controlColumnWidth override if provided, otherwise use the list layout controlColumnWidth config
        const columnWidth = (_a = contentLayoutOverride === null || contentLayoutOverride === void 0 ? void 0 : contentLayoutOverride.controlColumnWidth) !== null && _a !== void 0 ? _a : contentLayoutConfig === null || contentLayoutConfig === void 0 ? void 0 : contentLayoutConfig.controlColumnWidth;
        // Use the wrapBreakpoint override if provided, otherwise use the list layout wrapBreakpoint config
        const wrapBreakpoint = (_b = contentLayoutOverride === null || contentLayoutOverride === void 0 ? void 0 : contentLayoutOverride.contentWrapBreakpoint) !== null && _b !== void 0 ? _b : contentLayoutConfig === null || contentLayoutConfig === void 0 ? void 0 : contentLayoutConfig.contentWrapBreakpoint;
        return {
            controlColumnWidth: columnWidth,
            wrapped: wrapBreakpoint && width ? width <= wrapBreakpoint : false
        };
    }, [contentLayoutConfig, width]);
    useADSWarnOnce('CheckboxList: `direction` prop should be set to `vertical` when rendering `CheckboxItem` components with both `label` and `renderContent` props.', direction === 'horizontal' && children
        ? React__default.Children.toArray(children).some((child) => React__default.isValidElement(child) &&
            child.props.renderContent &&
            child.props.label)
        : false);
    if (!isArray(value) && singleSelectValueType === 'array') {
        ADSError(`CheckboxList detected invalid value type. Checkboxlist values must be an
      array of strings. Current value is ${value}`);
        return React__default.createElement(React__default.Fragment, null);
    }
    // When any of our children fire a change handler, we update our
    // value and fire that off as our new value.
    const handleChange = (e) => {
        let v;
        if (singleSelectValueType === 'boolean') {
            v = e.target.value;
        }
        else {
            v = [...value];
            // Either add or remove the child's name from the value array
            if (e.target.value)
                v.push(e.target.name);
            else
                v = v.filter((item) => item !== e.target.name);
        }
        onChange && onChange({ target: { name, value: v } });
    };
    const handleFocus = () => {
        // The event is firing from our child checkbox. We want the name
        // to be the name of our list.
        const event = { target: { name, value } };
        onFocus && onFocus(event);
    };
    const handleBlur = () => {
        // The event is firing from our child checkbox. We want the name
        // to be the name of our list.
        const event = { target: { name, value } };
        onBlur && onBlur(event);
    };
    function renderChildren() {
        return React__default.Children.map(children, (child, index) => {
            var _a, _b;
            const item = child;
            const childAutoFocus = match([
                autoFocus,
                index,
                child.props.autoFocus
            ])
                // if the list has autoFocus set, then the first child should have autoFocus
                .with([true, 0, P.any], () => true)
                // if the list has autoFocus set, then all other children should not have autoFocus
                .with([true, P.any, P.any], () => undefined)
                // if the list does not have autoFocus set, then use the child's autoFocus
                .with([P.not(true), P.any, P.any], () => child.props.autoFocus)
                .exhaustive();
            return React__default.cloneElement(item, {
                autoFocus: childAutoFocus,
                className: cx$Z(childClassName, child.props.className),
                disabled: (_a = item.props.disabled) !== null && _a !== void 0 ? _a : disabled,
                error,
                inputRef: index === 0 ? inputRef : undefined,
                readOnly: (_b = item.props.readOnly) !== null && _b !== void 0 ? _b : readOnly,
                testId: testId ? `${testId}-${child.props.name}` : undefined,
                type: type || child.props.type,
                value: singleSelectValueType === 'boolean'
                    ? Boolean(value)
                    : value.includes(child.props.name),
                warning,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                contentConfig: contentConfig(child.props.contentLayoutOverride),
                isLastChild: index === React__default.Children.count(children) - 1
            });
        });
    }
    if (items) {
        if (isArray(items)) {
            children = items.map((item, index) => (React__default.createElement(CheckboxItemV2, { label: item, autoFocus: index === 0 ? autoFocus : undefined, inputRef: index === 0 ? inputRef : undefined, key: item, name: item })));
        }
        else {
            children = Object.entries(items).map(([name, label], index) => (React__default.createElement(CheckboxItemV2, { label: label, autoFocus: index === 0 ? autoFocus : undefined, inputRef: index === 0 ? inputRef : undefined, key: name, name: name })));
        }
    }
    // If we are having to render a certain number of vertical columns
    // calculate our column height based off number of children items.
    const verticalColumnHeight = direction === 'vertical' &&
        numVerticalColumns > 0 &&
        (React__default.Children.count(children) * 40) / numVerticalColumns;
    // Check what happens when focus hits checkboxlist, do we need to forward to first child?
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { style: verticalColumnHeight ? { height: `${verticalColumnHeight}px` } : {}, "data-test": `${testId}List`, ref: ref, className: cx$Z('list', direction) }), renderChildren()));
};
const CheckboxListBaseField = withField(CheckboxListBase);
const UnControlledCheckboxList = (props) => {
    var _a;
    const [value, setValue] = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : (props.singleSelectValueType === 'boolean' ? false : []));
    return (React__default.createElement(CheckboxListBaseField, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneCheckboxList = withStandAlone(UnControlledCheckboxList, CheckboxListBaseField);
const CheckboxList = withFieldSchemaSupport$1(StandAloneCheckboxList, withFieldSchema(CheckboxListBaseField));

/** Renders a checkbox */
const CheckboxV2 = (props) => {
    return (
    // At its core, the Checkbox is essentially a list of one checkbox.
    // The CheckboxList component is responsible for handling all the field related logic.
    // This includes error messages, field labels, validation, etc.
    React__default.createElement(CheckboxList, { testId: `${props.testId}`, name: props.name, label: props.fieldLabel, error: props.error, warning: props.warning, required: props.required, desired: props.desired, value: props.value, hideLabel: props.hideFieldLabel, contentConfig: props.contentConfig, singleSelectValueType: "boolean", onBlur: props.onBlur, onFocus: props.onFocus, onChange: props.onChange, direction: "vertical", childClassName: props.className, autoFocus: props.autoFocus, customDataProps: props.customDataProps },
        React__default.createElement(CheckboxItemV2, { name: `${props.name}-checkbox`, label: props.label, renderContent: props.renderContent, type: props.type, disabled: props.disabled, tooltip: props.tooltip, readOnly: props.readOnly, ghost: props.ghost, preventClickPropagation: props.preventClickPropagation, isLastChild: props.isLastChild })));
};

function allowedHandler() {
    /* allow the event */
}
const allowedKeyMap = [
    {
        ArrowLeft: allowedHandler,
        ArrowRight: allowedHandler,
        Home: allowedHandler,
        End: allowedHandler,
        Tab: allowedHandler
    }
];
function handleBackspace(event, { fractionDelimiter }) {
    const eventProperties = getTypedEventProperties(event);
    if (!eventProperties) {
        return;
    }
    const { selectionStart, value } = eventProperties;
    // Prevent delete of 0 in front of negative decimal
    if (selectionStart === 2 &&
        value.charAt(0) === '-' &&
        value.charAt(1) === '0' &&
        value.charAt(2) === fractionDelimiter) {
        event.preventDefault();
        return;
    }
    // Prevent delete of 0 in front of decimal
    if (selectionStart === 1 &&
        value.charAt(0) === '0' &&
        value.charAt(1) === fractionDelimiter) {
        event.preventDefault();
        return;
    }
}
function handleDelete(event, { fractionDelimiter }) {
    const eventProperties = getTypedEventProperties(event);
    if (!eventProperties) {
        return;
    }
    const { selectionStart, value } = eventProperties;
    // Prevent delete of 0 in front of negative decimal
    if (selectionStart === 1 &&
        value.charAt(0) === '-' &&
        value.charAt(1) === '0' &&
        value.charAt(2) === fractionDelimiter) {
        event.preventDefault();
        return;
    }
    // Prevent delete of 0 in front of decimal
    if (selectionStart === 0 &&
        value.charAt(0) === '0' &&
        value.charAt(1) === fractionDelimiter) {
        event.preventDefault();
        return;
    }
}
function handleDelimiter(event, { numberDelimiter, fractionDelimiter }) {
    const eventProperties = getTypedEventProperties(event);
    if (!eventProperties) {
        return;
    }
    const { selectionEnd, selectionStart, value } = eventProperties;
    // Can't add a comma after a decimal point
    if (value.slice(0, selectionStart).includes(fractionDelimiter)) {
        event.preventDefault();
        return;
    }
    else if (selectionStart === selectionEnd) {
        // Can't add a delimiter before or after a delimiter
        if (value.charAt(selectionStart - 1) === numberDelimiter ||
            value.charAt(selectionStart) === numberDelimiter) {
            event.preventDefault();
            return;
        }
    }
}
function handleFractionDelimiter(event, { fractionDelimiter }) {
    const eventProperties = getTypedEventProperties(event);
    if (!eventProperties) {
        return;
    }
    const { selectionEnd, selectionStart, value } = eventProperties;
    // Can't add a second fraction delimiter
    if (value.slice(0, selectionStart).includes(fractionDelimiter)) {
        event.preventDefault();
        return;
    }
    // The first number is a dash so we should format to get a leading 0
    if (value.length === 1 && value.charAt(0) === '-') {
        return true;
    }
    // There is no value for the field yet so we should format and add a leading 0
    if (value.length === 0) {
        return true;
    }
    // We are replacing the entire value with the numerical delimiter so we should add a leading 0
    if (value.length && selectionEnd - selectionStart === value.length) {
        return true;
    }
}
function getTypedEventProperties(event) {
    if (!event.target || !(event.target instanceof HTMLInputElement)) {
        return;
    }
    const { selectionEnd, selectionStart, value } = event.target;
    if (selectionStart === null || selectionEnd === null) {
        return;
    }
    return { selectionEnd, selectionStart, value };
}

// Class that handles the details of transforming a string formatted version of a number
// from one version to the next. This is used to format string numbers as the user types
// each character.
class NumberFormat {
    constructor() {
        this.getLocaleInteger = (locale, val, options) => {
            const numberFormatParts = new Intl.NumberFormat(locale, options).formatToParts(val);
            let formatInteger = '';
            for (const index in numberFormatParts) {
                if (numberFormatParts[index].type === 'minusSign' ||
                    numberFormatParts[index].type === 'integer' ||
                    numberFormatParts[index].type === 'group') {
                    formatInteger += numberFormatParts[index].value;
                }
            }
            return formatInteger;
        };
        this.transform = (value, oldValue, locale, options, fractionDelimiter, altDelimiter, allowNegative, maximumIntegers, shouldTruncate) => {
            let nextVal = value;
            let isTruncated = false;
            if (altDelimiter && value.includes(altDelimiter)) {
                nextVal = value.replaceAll(altDelimiter, fractionDelimiter);
            }
            if (nextVal === fractionDelimiter) {
                if (this.shouldAllowDecimals()) {
                    return { value: `0${nextVal}`, isTruncated };
                }
                else {
                    return { value: '', isTruncated };
                }
            }
            else {
                let negativeCount = 0;
                if (allowNegative && nextVal.includes('-')) {
                    negativeCount = (nextVal.match(/-/g) || []).length;
                }
                const missingZeroDecimalRegex = new RegExp(`^-?\\${fractionDelimiter}.*$`, 'g');
                // we want to ensure that we never send a string forward with the negative sign immediately next to the fraction delimiter (decimal): -.
                // instead inserting a 0, so that there aren't breakages in attempting to parse the string as a number
                // this regular expression tests for an optional -, so we don't care if it's positive or negative, followed by the delimiter which is required,
                // followed by anything.
                if (this.shouldAllowDecimals() &&
                    nextVal.match(missingZeroDecimalRegex)) {
                    if (nextVal.charAt(0) === '-') {
                        nextVal = `-0${nextVal}`;
                    }
                    else {
                        nextVal = `0${nextVal}`;
                    }
                }
                const decRegex = new RegExp('\\' + fractionDelimiter, 'g');
                const fractionCount = (nextVal.match(decRegex) || []).length;
                if (fractionCount > 1) {
                    // We need to do this again here for an extremely niche situation wherein a second delimiter is being inserted
                    // to a string that already matches the regex, meaning it needs to have failed detection the first time.
                    // This should not be possible as this transform is called per single character entered, but the function input
                    // technically allows for it. For completeness' sake, this is included.
                    if (this.shouldAllowDecimals() &&
                        oldValue.match(missingZeroDecimalRegex)) {
                        if (oldValue.charAt(0) === '-') {
                            oldValue = `-0${oldValue}`;
                        }
                        else {
                            oldValue = `0${oldValue}`;
                        }
                    }
                    return { value: oldValue, isTruncated };
                }
                const hasFraction = nextVal.includes(fractionDelimiter);
                const isEndingFraction = `${nextVal}`.slice(-1) === fractionDelimiter;
                const isStartingFraction = nextVal.charAt(0) === fractionDelimiter;
                const regex = new RegExp(`[^0-9${fractionDelimiter}]`, 'g');
                let newValue = `${nextVal}`.replace(regex, '');
                const [int, fraction] = newValue.split(fractionDelimiter);
                if (int && int !== '-') {
                    let integer = parseInt(int, 10);
                    if (maximumIntegers !== undefined &&
                        Math.abs(integer).toString().length > maximumIntegers) {
                        // handles when a user tries to type a number larger than the maximum integral length
                        if (!shouldTruncate) {
                            return { value: oldValue, isTruncated };
                        }
                        else {
                            integer = parseInt(int.slice(0, maximumIntegers), 10);
                            isTruncated = true;
                        }
                    }
                    newValue = this.getLocaleInteger(locale, integer, options);
                }
                if (this.shouldAllowDecimals()) {
                    if (isStartingFraction) {
                        newValue = newValue.replace(fractionDelimiter, '');
                    }
                    newValue = isEndingFraction
                        ? `${newValue}${fractionDelimiter}`
                        : newValue;
                    if (fraction) {
                        if (isStartingFraction) {
                            newValue = `${fractionDelimiter}${fraction.substring(0, this.maximumDecimals)}`;
                        }
                        else {
                            newValue += `${fractionDelimiter}${fraction.substring(0, this.maximumDecimals)}`;
                        }
                    }
                    else if (hasFraction && !newValue.includes(fractionDelimiter)) {
                        newValue += fractionDelimiter;
                    }
                }
                // tries to remove characters that may be problematic
                newValue = newValue.replace(/[\u00A0\u1680\u180e\u2000-\u2009\u200a\u200b\u202f\u205f\u3000]/g, ' ');
                // if (allowNegative && negativeFound) {
                //   newValue = `-${newValue}`;
                // }
                if (negativeCount === 1) {
                    newValue = `-${newValue}`;
                }
                return { value: newValue, isTruncated };
            }
        };
    }
    setMaximumDecimals(dec) {
        this.maximumDecimals = dec;
        return this;
    }
    setMinimumDecimals(dec) {
        this.minimumDecimals = dec;
        return this;
    }
    shouldAllowDecimals() {
        return this.maximumDecimals !== 0 || this.minimumDecimals !== 0;
    }
}

/**
 * This hook is used to help manage the configuration of the formatConfig for the NumberField component.
 * We currently have quite a few deprecated props that also affect the formatConfig. This hook takes in the deprecated props,
 * the props that the consumer specifies, and the default props for the components and merges them together to create the final formatConfig.
 * This helps simplify the logic throughout the NumberField component by being able to solely rely on the shape of the formatConfig,
 * instead of needing to also account for the deprecated props.
 *
 * See the `number-field-format.shared.mdx` file for consumer-facing documentation of this hook.
 */
const useDefaultFormatConfiguration = ({ consumerDefined, defaultConfig, deprecatedProps }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    useADSWarnOnce('allowNegative is deprecated, use formatConfig.allowNegative instead', (deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.allowNegative) !== (defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.allowNegative));
    useADSWarnOnce('maximumDecimals is deprecated, use formatConfig.decimal.maxLength instead', (deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.maximumDecimals) !== ((_a = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _a === void 0 ? void 0 : _a.maxLength));
    useADSWarnOnce('maxLength is deprecated, use formatConfig.decimal and formatConfig.integral instead', (deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.maxLength) !== undefined);
    useADSWarnOnce('decimalAutoCompleteConfig is deprecated, use formatConfig.decimal.minLength instead', ((_b = deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.decimalAutoCompleteConfig) === null || _b === void 0 ? void 0 : _b.enabled) === true);
    const deprecatedEnforceDecimalPlaces = ((_c = deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.decimalAutoCompleteConfig) === null || _c === void 0 ? void 0 : _c.enabled) === true &&
        deprecatedProps.decimalAutoCompleteConfig.enforceDecimalPlaces === true;
    /**
     * Note: We give greatest to least preference to:
     * 1st) new "consumer defined" props
     * 2nd) deprecated props
     * 3rd) default prop values
     */
    return React__default.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        let decimal = {
            maxLength: undefined,
            minLength: undefined
        };
        let integral = {
            maxLength: undefined
        };
        // decimal configuration
        if (((_a = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _a === void 0 ? void 0 : _a.maxLength) !== undefined ||
            ((_b = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _b === void 0 ? void 0 : _b.minLength) !== undefined) {
            // Note: If either maxLength or minLength is defined, then neither will receive their default value.
            decimal = {
                maxLength: (_c = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _c === void 0 ? void 0 : _c.maxLength,
                minLength: (_d = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _d === void 0 ? void 0 : _d.minLength
            };
        }
        else if ((deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.maximumDecimals) !== undefined) {
            const defaultMinIsTooLarge = ((_e = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _e === void 0 ? void 0 : _e.minLength) !== undefined &&
                ((_f = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _f === void 0 ? void 0 : _f.minLength) > deprecatedProps.maximumDecimals;
            decimal = {
                maxLength: deprecatedProps.maximumDecimals,
                minLength: defaultMinIsTooLarge
                    ? undefined
                    : (_g = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _g === void 0 ? void 0 : _g.minLength
            };
        }
        else {
            decimal = {
                maxLength: (_h = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _h === void 0 ? void 0 : _h.maxLength,
                minLength: (_j = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _j === void 0 ? void 0 : _j.minLength
            };
        }
        // integral configuration
        integral = {
            maxLength: (_l = (_k = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.integral) === null || _k === void 0 ? void 0 : _k.maxLength) !== null && _l !== void 0 ? _l : (_m = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.integral) === null || _m === void 0 ? void 0 : _m.maxLength
        };
        if (((_o = deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.decimalAutoCompleteConfig) === null || _o === void 0 ? void 0 : _o.enabled) === true) {
            decimal.minLength =
                deprecatedEnforceDecimalPlaces === true
                    ? (_p = decimal.minLength) !== null && _p !== void 0 ? _p : decimal.maxLength
                    : undefined;
            if (((_q = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _q === void 0 ? void 0 : _q.minLength) !== undefined) {
                ADSWarn(`updating formatConfig.decimal.minLength to be equal to ${decimal.minLength}`);
            }
        }
        if (decimal.minLength !== undefined && decimal.minLength < 0) {
            throw new Error('value for formatConfig.decimal.minLength must be greater or equal to 0.');
        }
        if (decimal.maxLength !== undefined && decimal.maxLength < 0) {
            throw new Error('value for formatConfig.decimal.maxLength must be greater or equal to 0.');
        }
        if (decimal.maxLength !== undefined &&
            decimal.minLength !== undefined &&
            decimal.maxLength < decimal.minLength) {
            throw new Error('value for formatConfig.decimal.maxLength is less than formatConfig.decimal.minLength.');
        }
        if (integral.maxLength !== undefined && integral.maxLength <= 0) {
            throw new Error('value for formatConfig.integral.maxLength must be greater than 0.');
        }
        return {
            allowNegative: (_s = (_r = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.allowNegative) !== null && _r !== void 0 ? _r : deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.allowNegative) !== null && _s !== void 0 ? _s : defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.allowNegative,
            decimal: decimal,
            integral: integral,
            hasThousandsSeparator: (_t = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.hasThousandsSeparator) !== null && _t !== void 0 ? _t : defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.hasThousandsSeparator
        };
    }, [
        consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.allowNegative,
        consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.hasThousandsSeparator,
        (_d = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _d === void 0 ? void 0 : _d.maxLength,
        (_e = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.decimal) === null || _e === void 0 ? void 0 : _e.minLength,
        (_f = consumerDefined === null || consumerDefined === void 0 ? void 0 : consumerDefined.integral) === null || _f === void 0 ? void 0 : _f.maxLength,
        defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.allowNegative,
        (_g = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _g === void 0 ? void 0 : _g.maxLength,
        (_h = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.decimal) === null || _h === void 0 ? void 0 : _h.minLength,
        (_j = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.integral) === null || _j === void 0 ? void 0 : _j.maxLength,
        defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.hasThousandsSeparator,
        deprecatedEnforceDecimalPlaces,
        deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.allowNegative,
        (_k = deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.decimalAutoCompleteConfig) === null || _k === void 0 ? void 0 : _k.enabled,
        deprecatedProps === null || deprecatedProps === void 0 ? void 0 : deprecatedProps.maximumDecimals
    ]);
};

var FormatStyleTypes;
(function (FormatStyleTypes) {
    FormatStyleTypes["CURRENCY"] = "currency";
    FormatStyleTypes["DECIMAL"] = "decimal";
})(FormatStyleTypes || (FormatStyleTypes = {}));
const decimalPropsDefaults = {
    enabled: false
};
const NumberFieldBase = (_a) => {
    var { allowNegative, maximumDecimals = 0, formatStyle = FormatStyleTypes.DECIMAL, name, value = null, onChange, onBlur, locale = 'en-US', onKeyRejected, decimalAutoCompleteConfig = decimalPropsDefaults, formatConfig, defaultFormatConfig, onContextMenu } = _a, props = __rest(_a, ["allowNegative", "maximumDecimals", "formatStyle", "name", "value", "onChange", "onBlur", "locale", "onKeyRejected", "decimalAutoCompleteConfig", "formatConfig", "defaultFormatConfig", "onContextMenu"]);
    const shouldFormatValue = React__default.useRef(null);
    const ref = React__default.useRef(null);
    const { addToast } = useToast();
    const { t } = useTranslation();
    const [selectionRange, setSelectionRange] = React__default.useState();
    const deprecatedProps = React__default.useMemo(() => ({
        allowNegative: allowNegative,
        maximumDecimals: maximumDecimals,
        maxLength: props.maxLength,
        decimalAutoCompleteConfig: formatStyle === FormatStyleTypes.CURRENCY
            ? decimalAutoCompleteConfig
            : undefined
    }), [
        allowNegative,
        decimalAutoCompleteConfig,
        formatStyle,
        maximumDecimals,
        props.maxLength
    ]);
    const formattedFormatConfig = useDefaultFormatConfiguration({
        consumerDefined: formatConfig,
        defaultConfig: defaultFormatConfig,
        deprecatedProps: deprecatedProps
    });
    const options = React__default.useMemo(() => formatStyle === FormatStyleTypes.CURRENCY
        ? {
            style: 'currency',
            currency: LocaleDataMap[locale].currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: formattedFormatConfig.hasThousandsSeparator
        }
        : { useGrouping: formattedFormatConfig.hasThousandsSeparator }, [formatStyle, formattedFormatConfig.hasThousandsSeparator, locale]);
    const fractionDelimiter = LocaleDataMap[locale].fractionDelimiter || '.';
    const altDelimiter = LocaleDataMap[locale].alternateDelimiters || '';
    const numberDelimiter = LocaleDataMap[locale].numberDelimiter;
    const formatValue = React__default.useCallback((value, oldValue) => {
        const shouldAlert = shouldFormatValue.current === 'FORMAT_AND_ALERT';
        const nf = new NumberFormat();
        shouldFormatValue.current = null;
        nf.setMaximumDecimals(formattedFormatConfig.decimal.maxLength);
        nf.setMinimumDecimals(formattedFormatConfig.decimal.minLength);
        const result = nf.transform(value, oldValue, locale, options, fractionDelimiter, altDelimiter, formattedFormatConfig.allowNegative, formattedFormatConfig.integral.maxLength, shouldAlert);
        if (shouldAlert && result.isTruncated) {
            addToast({
                content: t('NUMBER_TRUNCATED_ALERT'),
                onRemoved: (dismissedBy, notification) => {
                    var _a, _b;
                    // if focus is on the close button, move focus back to the input
                    if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.getAttribute('data-test')) ===
                        `alertMessage-close-${notification.id}`) {
                        (_b = ref.current) === null || _b === void 0 ? void 0 : _b.focus();
                    }
                },
                type: BrandType.Warning,
                autoDismissConfig: {
                    enabled: true
                }
            });
        }
        return result.value;
    }, [
        addToast,
        altDelimiter,
        formattedFormatConfig.allowNegative,
        formattedFormatConfig.decimal.maxLength,
        formattedFormatConfig.decimal.minLength,
        formattedFormatConfig.integral.maxLength,
        fractionDelimiter,
        locale,
        options,
        t
    ]);
    const formatter = React__default.useMemo(() => {
        return { pattern: String };
    }, []);
    const convertValueToString = React__default.useCallback(() => {
        return typeof value === 'number' && isFinite(value)
            ? FormatNumber(value, Object.assign({ maximumDecimals: formattedFormatConfig.decimal.maxLength, minimumDecimals: formattedFormatConfig.decimal.minLength, locale }, options))
            : '';
    }, [
        value,
        formattedFormatConfig.decimal.maxLength,
        formattedFormatConfig.decimal.minLength,
        locale,
        options
    ]);
    const [textValue, setTextValue] = React__default.useState();
    const convertEvent = React__default.useCallback((value) => {
        const eValue = value && value !== fractionDelimiter
            ? ToLocaleNumber(value, locale)
            : null;
        return {
            target: {
                name,
                value: eValue
            }
        };
    }, [fractionDelimiter, locale, name]);
    const handleChange = React__default.useCallback((e, previousTextValue) => {
        let newTextValue = e.target.value;
        if (shouldFormatValue.current === 'FORMAT' ||
            shouldFormatValue.current === 'FORMAT_AND_ALERT') {
            newTextValue = formatValue(e.target.value, previousTextValue !== null && previousTextValue !== void 0 ? previousTextValue : '');
        }
        else if (shouldFormatValue.current === 'ENSURE_LENGTH' ||
            shouldFormatValue.current === 'ENSURE_LENGTH_AND_SELECTION') {
            const ensureSelection = shouldFormatValue.current === 'ENSURE_LENGTH_AND_SELECTION';
            shouldFormatValue.current = null;
            /**
             * We don't want to format our value when a user presses the backspace or delete keys
             * but we do want to ensure that the number still meets the formatting requirements.
             * For example, if we are allowed 1 integral and 1 decimal, trying to delete the decimal
             * from "1.1" would result in "11" which is outside our max integral range.
             */
            const newFormattedNumericValue = convertEvent(formatValue(newTextValue, previousTextValue !== null && previousTextValue !== void 0 ? previousTextValue : '')).target.value;
            const newNumericValue = convertEvent(newTextValue).target.value;
            /**
             * If our newly formatted numeric value does not match our new numeric value,
             * that means it did not satisfy our formatting requirements and we should revert to the previous value.
             */
            if (newNumericValue !== newFormattedNumericValue) {
                newTextValue = previousTextValue;
                /**
                 * We don't want the selectionRange to be updated since it will cause the cursor to move one place to the right when pressing the
                 * delete key when our value hasn't actually updated. This happens when we try to delete the decimal but the max integral of the new number
                 * would exceed the max integral. Using backspace does not shift the selection range so we only need to do this for the delete key.
                 */
                if (ensureSelection) {
                    setSelectionRange(getTypedEventProperties(e));
                }
            }
        }
        setTextValue(newTextValue);
        onChange && onChange(convertEvent(newTextValue));
    }, [onChange, convertEvent, formatValue]);
    /**
     * We need this to happen a render cycle after we call setTextValue within handleChange.
     * We attempted to make this work by using a `setTimeout` with a delay of 0 directly within the handleChange, but that was not reliable,
     * did not work while holding the delete key, and is generally recommended against with React. While this solution is a little harder to follow
     * since we are jumping from logic from the callback to this useEffect and adding an extra render cycle, it is the most reliable solution that we saw with testing.
     */
    React__default.useEffect(() => {
        if (selectionRange) {
            setSelectionRange(undefined);
            window.requestAnimationFrame(() => {
                var _a;
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setSelectionRange(selectionRange.selectionEnd, selectionRange.selectionEnd);
            });
        }
    }, [selectionRange]);
    const handleBlur = (e) => {
        var _a, _b, _c, _d, _e;
        let newTextValue = e.target.value;
        // When the user blurs with just a negative sign, we want to treat it as 0 before we format like other values
        if (newTextValue === '-') {
            newTextValue = '0';
        }
        // If we are dealing with a currency and a decimal is present,
        // ensure it has appropriate number of decimal places
        if (newTextValue && ((_a = formattedFormatConfig.decimal.minLength) !== null && _a !== void 0 ? _a : 0) > 0) {
            const includesDecimal = newTextValue.includes(fractionDelimiter) ||
                (decimalAutoCompleteConfig.enabled &&
                    decimalAutoCompleteConfig.enforceDecimalPlaces === true) ||
                (((_b = formatConfig === null || formatConfig === void 0 ? void 0 : formatConfig.decimal) === null || _b === void 0 ? void 0 : _b.minLength) &&
                    ((_c = formatConfig === null || formatConfig === void 0 ? void 0 : formatConfig.decimal) === null || _c === void 0 ? void 0 : _c.minLength) > 0);
            if ((includesDecimal && formatStyle === FormatStyleTypes.CURRENCY) ||
                formatStyle !== FormatStyleTypes.CURRENCY) {
                const minDecimalLength = (_e = (_d = formattedFormatConfig === null || formattedFormatConfig === void 0 ? void 0 : formattedFormatConfig.decimal) === null || _d === void 0 ? void 0 : _d.minLength) !== null && _e !== void 0 ? _e : 0;
                const [integerPart, decimalPart = ''] = newTextValue.split(fractionDelimiter);
                if (minDecimalLength > decimalPart.length) {
                    newTextValue = `${integerPart}${fractionDelimiter}${decimalPart.padEnd(minDecimalLength, '0')}`;
                }
            }
            // remove trailing decimals
        }
        else if ((textValue === null || textValue === void 0 ? void 0 : textValue.charAt(textValue.length - 1)) === fractionDelimiter) {
            newTextValue = textValue.substring(0, textValue.length - 1);
        }
        const formattedValue = formatValue(newTextValue, textValue !== null && textValue !== void 0 ? textValue : '');
        setTextValue(formattedValue);
        // Combining formatted value with native focus event
        onBlur && onBlur(Object.assign(Object.assign({}, e), convertEvent(formattedValue)));
    };
    // We have to watch for when our value changes, and see if we need to update
    // text value if it's not a match.
    // This is needed to set the initial text value for Number fields in a form that have default values.
    React__default.useEffect(() => {
        // If textValue is empty OR converting our current textValue to a number and
        // it doesn't match our current value (which is a number), update our textValue
        if (!textValue || ToLocaleNumber(textValue, locale) !== value) {
            // Do a one time conversation of our value (type number) to the formatted
            // string.
            let localizedValue = convertValueToString();
            const containsDecimalSymbol = value === null || value === void 0 ? void 0 : value.toString().includes(fractionDelimiter);
            if (formatStyle === FormatStyleTypes.CURRENCY &&
                decimalAutoCompleteConfig.enabled &&
                decimalAutoCompleteConfig.enforceDecimalPlaces === false &&
                !containsDecimalSymbol) {
                localizedValue = localizedValue.split(fractionDelimiter)[0];
            }
            setTextValue(formatValue(localizedValue, ''));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const handleKeyDown = React__default.useCallback((event) => {
        // Allow all ctrl and meta actions
        if (event.ctrlKey || event.metaKey) {
            return;
        }
        const handledKeyMap = [
            {
                Backspace: (event) => {
                    handleBackspace(event, {
                        fractionDelimiter
                    });
                    shouldFormatValue.current = 'ENSURE_LENGTH';
                },
                Delete: (event) => {
                    handleDelete(event, {
                        fractionDelimiter
                    });
                    shouldFormatValue.current = 'ENSURE_LENGTH_AND_SELECTION';
                },
                [numberDelimiter]: (event) => handleDelimiter(event, {
                    numberDelimiter,
                    fractionDelimiter
                }),
                '-': () => (shouldFormatValue.current = 'FORMAT')
            }
        ];
        // If we support decimals, add decimal support handler
        if ((formattedFormatConfig.decimal.maxLength &&
            formattedFormatConfig.decimal.maxLength > 0) ||
            (formattedFormatConfig.decimal.minLength &&
                formattedFormatConfig.decimal.minLength > 0)) {
            handledKeyMap.push({
                [fractionDelimiter]: (event) => {
                    const needsToFormat = handleFractionDelimiter(event, {
                        fractionDelimiter
                    });
                    if (needsToFormat) {
                        shouldFormatValue.current = 'FORMAT';
                    }
                }
            });
            // French supports both , and . for the fraction delimiter on input but formats to ,
            if (locale === 'fr-CA') {
                handledKeyMap.push({
                    '.': (event) => {
                        const needsToFormat = handleFractionDelimiter(event, {
                            fractionDelimiter: '.'
                        });
                        if (needsToFormat) {
                            shouldFormatValue.current = 'FORMAT';
                        }
                    }
                });
            }
        }
        for (let i = 0; i <= 9; i++) {
            // We should run the formatter after the user types a number
            handledKeyMap.push({
                [i]: () => {
                    shouldFormatValue.current = 'FORMAT';
                }
            });
        }
        // Handle the event based off which key was pressed
        const handled = KeyHandleMap(event, handledKeyMap);
        // If we've handled the event, early return
        if (handled) {
            return;
        }
        const allowed = KeyHandleMap(event, allowedKeyMap);
        // If we haven't allowed the key, cancel the event
        if (!allowed) {
            CancelReactEvent(event);
            onKeyRejected && onKeyRejected(event);
            return;
        }
    }, [
        formattedFormatConfig.decimal.maxLength,
        formattedFormatConfig.decimal.minLength,
        fractionDelimiter,
        locale,
        numberDelimiter,
        onKeyRejected
    ]);
    return (React__default.createElement(TextField, Object.assign({}, props, { ref: ref, name: `${name}__textField`, format: formatter, value: textValue, onBlur: handleBlur, onChange: (e) => handleChange(e, textValue), onDrop: () => (shouldFormatValue.current = 'FORMAT_AND_ALERT'), onKeyDown: (e) => {
            handleKeyDown(e);
            props.onKeyDown && props.onKeyDown(e);
        }, onPaste: () => (shouldFormatValue.current = 'FORMAT_AND_ALERT'), onContextMenu: onContextMenu, skipSubFormName: true })));
};
// Version of component that is not controlled. Meaning it will
// keep it's own state. This is the version used if value
// and onChange is not used directly OR by a form. Maybe they are
// only grabbing the value on blur?
const UnControlledNumberFieldBase = (props) => {
    const [value, setValue] = React__default.useState(props.value);
    return (React__default.createElement(NumberFieldBase, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneNumberField = withStandAlone(UnControlledNumberFieldBase, NumberFieldBase);
const NumberFieldDefault = withFieldSchemaSupport$1(StandAloneNumberField, withFieldSchema(NumberFieldBase));
const NumberField = React__default.forwardRef((props, ref) => React__default.createElement(NumberFieldDefault, Object.assign({}, props, { inputRef: ref })));
NumberField.displayName = 'NumberField';

const DEFAULT_ICON = 'DollarIcon';
const defaultFormatConfig$2 = {
    allowNegative: undefined,
    decimal: {
        maxLength: 2,
        minLength: 2
    },
    hasThousandsSeparator: true,
    integral: {
        maxLength: undefined
    }
};
const CurrencyField = (_a) => {
    var { locale, maximumDecimals = defaultFormatConfig$2.decimal.maxLength, decimalAutoCompleteConfig } = _a, props = __rest(_a, ["locale", "maximumDecimals", "decimalAutoCompleteConfig"]);
    const { locale: detectedLocale, localeData } = useLocale(locale);
    let startIcon = undefined;
    let endIcon = undefined;
    if (localeData.currencyIconPlacement === IconPlacement.End) {
        endIcon = {
            name: localeData.currencyIcon || DEFAULT_ICON
        };
    }
    else {
        startIcon = {
            name: localeData.currencyIcon || DEFAULT_ICON
        };
    }
    return (React__default.createElement(NumberField, Object.assign({}, props, { locale: detectedLocale, startIcon: startIcon, endIcon: endIcon, formatStyle: FormatStyleTypes.CURRENCY, maximumDecimals: maximumDecimals, decimalAutoCompleteConfig: decimalAutoCompleteConfig, defaultFormatConfig: defaultFormatConfig$2 })));
};

/**
 * Use this within a component to trigger a re-render on mount.
 *
 * This is useful when a component **exclusively** accepts props that are:
 * - 1.) referentially stable
 * - 2.) will not cause React to re-render, e.g., `React.useRef().current`
 *
 *
 * Imagine we have a parent and child component.
 * The parent passes a `ref` and a `React.useState`'s setter to the child.
 *
 * However, the parent will never cause a re-render, nor will the child; so
 * the parent's `ref` is `null` when the child mounts; and the child
 * never  has a chance to re-render to perform any needed effects or JSX rendering.
 *
 * By calling {@link useRerenderOnMount} in the child component, we can resolve the issue
 * by guaranteeing a second render of the child component after its initial mount.
 */
function useRerenderOnMount() {
    const trigger = useTrigger();
    const effectRef = React__default.useRef({ trigger });
    React__default.useEffect(() => {
        effectRef.current = { trigger };
    });
    React__default.useEffect(() => {
        /*
         * On mount, the `elemRef` can only be expected to still be `null`; so this
         * component should wait one render after the first (mount) render to have access
         * to the now-set element reference *without* relying on the parent re-rendering.
         */
        effectRef.current.trigger();
    }, []);
}

/*
 * Used to formulate if an 'element has been totally scrolled' per MDN documentation:
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#determine_if_an_element_has_been_totally_scrolled
 *
 * Note: `getBoundingClientRect()` was not found to have a smaller error delta than the formula:
 *  element.scrollHeight - element.clientHeight - element.scrollTop
 *
 * This error delta has never been found to be more than 2.0, so we use that as the threshold.
 */
const ERROR_DELTA = 2.0;
// We could expose this in the hook parameters, but opting to tightly control.
const MUTATION_OBSERVER_CONFIG = {
    attributes: true,
    childList: true,
    subtree: true
};
const DEFAULT_POSITION = {
    hasScroll: undefined,
    isAtBottom: undefined,
    isAtTop: undefined
};
function getPosition(element) {
    if (element === null)
        return DEFAULT_POSITION;
    const { clientHeight, scrollHeight, scrollTop } = element;
    return {
        hasScroll: scrollHeight > clientHeight,
        // See the documentation atop this file on `ERROR_DELTA` for explanation of formula
        isAtBottom: Math.abs(scrollHeight - (clientHeight + scrollTop)) < ERROR_DELTA,
        isAtTop: scrollTop === 0
    };
}
// runs a function exactly once at the first occasion when value is not null
function useRunOnceOnFirstNonNullValue(value, fn) {
    const { current: hasRun } = React__default.useRef(false);
    const valueIsNull = React__default.useMemo(() => value === null, [value]);
    React__default.useEffect(() => {
        if (hasRun || valueIsNull) {
            return;
        }
        // only run the function when [it's not run yet] and [value is not null]
        else
            fn();
    }, [fn, hasRun, valueIsNull]);
}
// Given a scrollable Element, returns metadata about the scroll position.
function useScrollPosition(elem) {
    const [scrollPosition, setPosition] = React__default.useState(getPosition(elem));
    const handleChange = React__default.useCallback(() => {
        setPosition(getPosition(elem));
    }, [setPosition, elem]);
    // calculate position *once* for initial accuracy (before any events occur)
    useRunOnceOnFirstNonNullValue(elem, handleChange);
    // scroll handling
    React__default.useEffect(() => {
        // Store a reference so cleanup references same target
        const theElement = elem;
        theElement === null || theElement === void 0 ? void 0 : theElement.addEventListener('scroll', handleChange, { passive: true });
        return () => theElement === null || theElement === void 0 ? void 0 : theElement.removeEventListener('scroll', handleChange);
    }, [handleChange, elem]);
    // window-resize handling
    React__default.useEffect(() => {
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', handleChange, { passive: true });
        return () => window === null || window === void 0 ? void 0 : window.removeEventListener('resize', handleChange);
    }, [handleChange]);
    // changes to the scrollable DOM Node or its children
    // e.g.: height of scroll changes when children change
    React__default.useEffect(() => {
        if (!elem)
            return;
        const observer = new MutationObserver(handleChange);
        observer.observe(elem, MUTATION_OBSERVER_CONFIG);
        // cleanup
        return () => observer.disconnect();
    }, [elem, handleChange]);
    return scrollPosition;
}

function ScrollPositionManager({ elemRef, setPosition }) {
    // caveat: need to cause a second render to ensure the element reference is set
    useRerenderOnMount();
    const { hasScroll, isAtBottom, isAtTop } = useScrollPosition(elemRef.current);
    // tunnel into effect(s) without being a dependency
    const effectRef = React__default.useRef({ setPosition });
    // keep fresh
    React__default.useEffect(() => {
        effectRef.current = { setPosition };
    });
    React__default.useEffect(() => {
        // edge case: there is no scrollbar
        if (!hasScroll) {
            effectRef.current.setPosition(None);
            return;
        }
        const state = [isAtTop !== null && isAtTop !== void 0 ? isAtTop : false, isAtBottom !== null && isAtBottom !== void 0 ? isAtBottom : false];
        const position = match(state)
            .with([true, P._], () => 'top')
            .with([P._, true], () => 'bottom')
            .with([false, false], () => 'middle')
            .exhaustive();
        const option = OptionUtils.some(position);
        effectRef.current.setPosition(option);
    }, [hasScroll, isAtBottom, isAtTop]);
    return null;
}

function useDelayedFalse(timeout = 500) {
    const [state, setState] = React__default.useState(false);
    const animateTimer = React__default.useRef(null);
    const start = (cb) => {
        if (!state) {
            setState(true);
        }
        if (animateTimer.current) {
            clearTimeout(animateTimer.current);
        }
        animateTimer.current = setTimeout(() => {
            setState(false);
            cb && cb(); // run the callback if one was passed in
        }, timeout);
    };
    // clear the timeout if the hook unmounts prematurely
    React__default.useEffect(() => {
        return () => {
            if (animateTimer.current) {
                clearTimeout(animateTimer.current);
            }
        };
    }, []);
    return { state, start };
}

var css$N = ".DialogBox_module_box__9b08b2bb{background-color:#fff;outline:none}.DialogBox_module_header__9b08b2bb{align-items:flex-start;background:#fff;display:flex;padding:16px 24px;position:relative}.DialogBox_module_header__9b08b2bb.DialogBox_module_hasBorder__9b08b2bb{border-bottom:1px solid #cbced7}.DialogBox_module_header__9b08b2bb .DialogBox_module_icon__9b08b2bb{flex-grow:0;margin-right:8px}.DialogBox_module_header__9b08b2bb .DialogBox_module_title__9b08b2bb{flex-grow:1;font-size:20px;font-weight:600;line-height:32px}.DialogBox_module_header__9b08b2bb .DialogBox_module_closeButton__9b08b2bb,.DialogBox_module_header__9b08b2bb .DialogBox_module_helpButton__9b08b2bb{justify-self:flex-end}.DialogBox_module_header__9b08b2bb .DialogBox_module_buttonGroup__9b08b2bb{flex-wrap:nowrap;justify-self:flex-end;margin-left:24px;margin-right:-8px}";
window.ADS.injectStyle(css$N,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DialogBox/DialogBox.module.scss");
var modules_bc7c44f4 = {"box":"DialogBox_module_box__9b08b2bb","header":"DialogBox_module_header__9b08b2bb","hasBorder":"DialogBox_module_hasBorder__9b08b2bb","icon":"DialogBox_module_icon__9b08b2bb","title":"DialogBox_module_title__9b08b2bb","closeButton":"DialogBox_module_closeButton__9b08b2bb","helpButton":"DialogBox_module_helpButton__9b08b2bb","buttonGroup":"DialogBox_module_buttonGroup__9b08b2bb"};

const cx$Y = classnames.bind(modules_bc7c44f4);
const DialogBox = ({ title, testId, stripeColor = BrandTypeColorMap[BrandType.Info], icon, showHelpButton = false, onHelp, isClosable = true, onClose, contentClassName, children }) => {
    const handleKeyDown = (e) => {
        const handled = KeyHandleMap(e, [
            {
                Escape: () => onClose && onClose()
            }
        ]);
        if (handled) {
            CancelReactEvent(e);
        }
    };
    if (!title) {
        title = { color: BrandTypeColorMap[BrandType.Info] };
    }
    if (typeof title === 'string') {
        title = { text: title, color: BrandTypeColorMap[BrandType.Info] };
    }
    return (React__default.createElement("div", { onKeyDown: handleKeyDown, tabIndex: 0, className: cx$Y('box') },
        React__default.createElement(Stripe, { color: stripeColor }),
        React__default.createElement("div", { className: cx$Y('header', { hasBorder: title.border }) },
            icon && React__default.createElement("div", { className: cx$Y('icon') }, icon),
            React__default.createElement("h1", { className: cx$Y('title'), style: { color: title.color } }, title.text),
            React__default.createElement("div", { className: cx$Y('buttonGroup', 'flex-container', 'gap-50') },
                showHelpButton && showHelpButton === true && (React__default.createElement(HelpButton, { testId: testId ? `${testId}-help-button` : undefined, className: cx$Y('helpButton'), onClick: () => onHelp && onHelp() })),
                React__default.createElement(CloseButton, { testId: testId ? `${testId}-close-button` : undefined, v2Spacing: true, className: cx$Y('closeButton'), onClick: () => onClose && onClose(), disabled: !isClosable }))),
        contentClassName ? (React__default.createElement("div", { className: contentClassName }, children)) : (children)));
};

var css$M = ".ModalBase_module_content__5b6fdd5d{box-shadow:0 3px 5px -1px #0003,0 6px 10px 0 #00000024,0 1px 18px 0 #0000001f;min-width:300px;pointer-events:auto}";
window.ADS.injectStyle(css$M,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Modal/ModalBase.module.scss");
var modules_ac89eb1a = {"content":"ModalBase_module_content__5b6fdd5d"};

const cx$X = classnames.bind(modules_ac89eb1a);
// This is exported for use in Alert or Modal, but should still be internal only.
// DO NOT export in index.ts file.
const ModalBase = ({ alert = false, children, customDataProps, focusLock = true, icon, isClosable, maxWidth, open, showHelpButton = false, stripeColor, testId, title, titleColor, type = BrandType.Info, zIndex, onClose, onHelp }) => {
    const context = React__default.useContext(ADSContext);
    // Unique identifier for tracking whether a modal is opened or not
    const uniqueId = React__default.useRef(UUIDv4());
    // If they didn't provide a title color, and the type is one of the following
    // default to the type's color.
    if (!titleColor &&
        [
            BrandType.Info,
            BrandType.Success,
            BrandType.Warning,
            BrandType.Error
        ].includes(type)) {
        titleColor = BrandTypeColorMap[type];
    }
    const dialogTitle = {
        text: title,
        color: titleColor,
        border: !alert
    };
    // If they didn't provide an icon and it's a warning type, use the warning icon.
    if (!icon && type === BrandType.Warning) {
        icon = React__default.createElement(Icon, { icon: "WarningIcon", size: 32 });
    }
    stripeColor = stripeColor !== null && stripeColor !== void 0 ? stripeColor : BrandTypeColorMap[type];
    // On modal open / close we update the context keeping track of how many are open
    // at a time.
    const onModalOpen = React__default.useCallback(() => {
        context === null || context === void 0 ? void 0 : context.setModalOpenCount((modalIds) => {
            if (modalIds.includes(uniqueId.current)) {
                return modalIds;
            }
            return modalIds.concat(uniqueId.current);
        });
    }, [context]);
    const onModalClose = React__default.useCallback(() => {
        context === null || context === void 0 ? void 0 : context.setModalOpenCount((modalIds) => {
            return modalIds === null || modalIds === void 0 ? void 0 : modalIds.filter((id) => id !== uniqueId.current);
        });
    }, [context]);
    // tunnel into effect(s) without being a dependency
    const effectRef = React__default.useRef({ onModalClose, onModalOpen });
    // keep fresh
    React__default.useEffect(() => {
        effectRef.current = { onModalClose, onModalOpen };
    });
    // Anytime our open / close state changes, we need to notify the context
    React__default.useEffect(() => {
        if (open) {
            effectRef.current.onModalOpen();
        }
        else {
            effectRef.current.onModalClose();
        }
    }, [open]);
    // If we are unmounted we need to make sure the context is updated.
    React__default.useEffect(() => {
        return function cleanup() {
            effectRef.current.onModalClose();
        };
    }, []);
    return open ? (React__default.createElement(Shroud, { containsAlert: alert, customDataProps: customDataProps, lockFocus: focusLock, testId: testId, zIndex: zIndex },
        React__default.createElement("div", { className: cx$X('content'), style: { maxWidth: maxWidth }, "data-test": TestIdUtils.composeId(testId, 'wrapper') },
            React__default.createElement(DialogBox, { icon: icon, isClosable: isClosable, onClose: onClose, onHelp: onHelp, showHelpButton: showHelpButton, stripeColor: stripeColor, testId: testId, title: dialogTitle }, children)))) : null;
};

const Modal = ({ children, customDataProps, focusLock = true, icon, isClosable, maxWidth, open, showHelpButton, stripeColor, testId, title, titleColor, type = BrandType.Info, zIndex, onClose, onHelp }) => {
    return (React__default.createElement(ModalBase, { alert: false, customDataProps: customDataProps, focusLock: focusLock, icon: icon, isClosable: isClosable, maxWidth: maxWidth, onClose: onClose, onHelp: onHelp, open: open, showHelpButton: showHelpButton, stripeColor: stripeColor, testId: testId, title: title, titleColor: titleColor, type: type, zIndex: zIndex }, children));
};

var css$L = ".ScrollShadow_module_scrollShadow__63a1d96d{height:40px;left:0;pointer-events:none;position:absolute;transition:opacity .15s;width:100%;z-index:300}.ScrollShadow_module_scrollShadow__63a1d96d.ScrollShadow_module_top__63a1d96d{background:linear-gradient(180deg,#3638402e,#a7a8ab0d 33%,#fff0);top:0}.ScrollShadow_module_scrollShadow__63a1d96d.ScrollShadow_module_bottom__63a1d96d{background:linear-gradient(0deg,#3638401a,#a7a8ab0d 33%,#fff0);bottom:0}";
window.ADS.injectStyle(css$L,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/common/atoms/ScrollShadow/ScrollShadow.module.scss");
var modules_016d8408 = {"scrollShadow":"ScrollShadow_module_scrollShadow__63a1d96d","top":"ScrollShadow_module_top__63a1d96d","bottom":"ScrollShadow_module_bottom__63a1d96d"};

const cx$W = BindStyles(modules_016d8408);
const ScrollShadow = ({ position, testId, visible = false }) => {
    if (!visible)
        return null;
    return (React__default.createElement("div", { "data-test": testId !== null && testId !== void 0 ? testId : `scrollShadow_${position}`, className: cx$W('scrollShadow', {
            top: position === 'top',
            bottom: position === 'bottom'
        }) }));
};

var css$K = ".ModalBody_module_adsModalBody__a2db98b4{position:relative}.ModalBody_module_body__a2db98b4{display:flex;flex-direction:column;max-height:calc(100vh - 206px);max-width:calc(100vw - 48px);overflow:auto;padding:24px}.ModalBody_module_body__a2db98b4 .ads-wizard-stepper{margin:-24px}.ModalBody_module_body__a2db98b4 .ads-wizard-stepper .ads-wizard-steps-container{padding-left:24px!important}.ModalBody_module_body__a2db98b4 .ads-wizard-stepper .ads-wizard-content-container{padding-right:32px}.ModalBody_module_alertBody__a2db98b4{justify-content:center;min-height:64px;padding-bottom:28px;padding-top:4px}.ModalBody_module_alertBody__a2db98b4 ol:first-child,.ModalBody_module_alertBody__a2db98b4 p:first-child,.ModalBody_module_alertBody__a2db98b4 ul:first-child{margin-top:0}.ModalBody_module_alertBody__a2db98b4 ol,.ModalBody_module_alertBody__a2db98b4 p,.ModalBody_module_alertBody__a2db98b4 ul{margin-bottom:0}";
window.ADS.injectStyle(css$K,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Modal/ModalBody.module.scss");
var modules_9b469231 = {"ads-modal-body":"ModalBody_module_adsModalBody__a2db98b4","body":"ModalBody_module_body__a2db98b4","alert-body":"ModalBody_module_alertBody__a2db98b4"};

const cx$V = classnames.bind(modules_9b469231);
const ModalBodyBase = ({ alert = false, customDataProps, children, testId }) => {
    const [divElem, setDivElem] = React__default.useState(null);
    const { hasScroll, isAtBottom, isAtTop } = useScrollPosition(divElem);
    return (React__default.createElement("div", { className: cx$V('ads-modal-body') },
        React__default.createElement(ScrollShadow, { position: "top", visible: hasScroll && !isAtTop, testId: `${testId !== null && testId !== void 0 ? testId : 'modalBody'}_scrollShadow_top` }),
        React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: setDivElem, "data-test": testId !== null && testId !== void 0 ? testId : 'modalBody', className: cx$V('body', {
                hasVerticalScrollBar: hasScroll,
                'alert-body': alert
            }) }), children),
        React__default.createElement(ScrollShadow, { position: "bottom", visible: hasScroll && !isAtBottom, testId: `${testId !== null && testId !== void 0 ? testId : 'modalBody'}_scrollShadow_bottom` })));
};
const ModalBody = ({ customDataProps, children, testId }) => {
    return (React__default.createElement(ModalBodyBase, { customDataProps: customDataProps, testId: testId }, children));
};

var css$J = ".ModalFooter_module_footer__5ae6381d{background:#f5f5f7;border-top:1px solid #cbced7;padding:16px 24px;text-align:right}";
window.ADS.injectStyle(css$J,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Modal/ModalFooter.module.scss");
var modules_5b783e10 = {"footer":"ModalFooter_module_footer__5ae6381d"};

const cx$U = classnames.bind(modules_5b783e10);
const ModalFooter = ({ customDataProps, testId, children }) => {
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'modalFooter', className: cx$U('footer', 'ads-modal-footer') }), children));
};

var css$I = ".ColumnResizeHandle_module_resizeHandleWrapper__6ca851ed{align-items:center;background-color:\"transparent\";display:flex;flex-direction:column;gap:0;justify-content:center;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity .1s ease-in-out}.ColumnResizeHandle_module_resizeHandleWrapper__6ca851ed.ColumnResizeHandle_module_dragging__6ca851ed,.ColumnResizeHandle_module_resizeHandleWrapper__6ca851ed.ColumnResizeHandle_module_isVisible__6ca851ed{opacity:1}.ColumnResizeHandle_module_resizeHandle__6ca851ed{align-items:center;background-color:\"transparent\";cursor:col-resize;display:flex;flex-direction:column;height:auto;justify-content:center;pointer-events:auto;width:14px}.ColumnResizeHandle_module_demarcation__6ca851ed{background-color:#e3eafc;border:2px solid #567bf6;border-radius:2px;pointer-events:none;width:6px}.ColumnResizeHandle_module_demarcation__6ca851ed.ColumnResizeHandle_module_dragging__6ca851ed{background-color:#365ef6;border:2px solid #365ef6;width:4px}.ColumnResizeHandle_module_divider__6ca851ed{background-color:#365ef6;width:2px}";
window.ADS.injectStyle(css$I,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/columns/ColumnResizer/ColumnResizeHandle.module.scss");
var modules_cf25ad48 = {"resizeHandleWrapper":"ColumnResizeHandle_module_resizeHandleWrapper__6ca851ed","isVisible":"ColumnResizeHandle_module_isVisible__6ca851ed","dragging":"ColumnResizeHandle_module_dragging__6ca851ed","resizeHandle":"ColumnResizeHandle_module_resizeHandle__6ca851ed","demarcation":"ColumnResizeHandle_module_demarcation__6ca851ed","divider":"ColumnResizeHandle_module_divider__6ca851ed"};

const cx$T = BindStyles(modules_cf25ad48);
// Used to properly align the column resize handle with the column (should slightly overlap the column to the right)
const COLUMN_RESIZE_BUFFER = 7.5;
const ColumnResizeHandle = ({ columnToResize, onShow, dataGridHeight, handleResizeInProgress, onColumnResized }) => {
    const [dragging, setDragging] = React__default.useState(false);
    const [position, setPosition] = React__default.useState({ x: 0, y: 0 });
    const startXRef = React__default.useRef(0);
    const startWidthRef = React__default.useRef(0);
    const [showingResizeHandle, setShowingResizeHandle] = React__default.useState(false);
    const handleRef = React__default.useRef(null);
    // Calculate the height of the divider
    // This is the height of the data grid - the height of the column being resized - 1px to account for handle border
    const dividerHeight = React__default.useMemo(() => {
        return (dataGridHeight - columnToResize.element.getBoundingClientRect().height - 1);
    }, [dataGridHeight, columnToResize]);
    // Set the initial position of the resize handle
    React__default.useEffect(() => {
        const columnRect = columnToResize.element.getBoundingClientRect();
        setPosition({
            x: window.scrollX + COLUMN_RESIZE_BUFFER,
            y: columnRect.top + window.scrollY
        });
    }, [columnToResize.element]);
    // Handles the mouse move event during column resizing.
    // Calculates the new width and updates the position state.
    const handleMouseMove = React__default.useCallback((e) => {
        // Take the starting width and add the difference between the starting x position and the current x position
        const potentialNewWidth = startWidthRef.current + (e.clientX - startXRef.current);
        // We need to make sure that the resize handle never goes below the min width.
        // Once we reach the min width, we need to lock the handle in place.
        if (potentialNewWidth <= columnToResize.minWidth) {
            // Take the starting x position and add the difference between the min width and the starting width
            const minWidthPosition = startXRef.current + (columnToResize.minWidth - startWidthRef.current);
            /**
             * While migrating to React 18, we needed to ensure that the `setPosition` calls were not batched.
             *
             * When they are batched, dragging the resize handle to the left or right would cause the handle to lag behind the mouse. With this,
             * the resize handle is now positioned directly under the mouse, even when the mouse is moving quickly.
             */
            flushSync(() => {
                setPosition((prev) => ({
                    x: minWidthPosition -
                        startXRef.current +
                        window.scrollX +
                        COLUMN_RESIZE_BUFFER,
                    y: prev.y
                }));
            });
            return;
        }
        flushSync(() => {
            setPosition((prev) => ({
                x: e.clientX -
                    startXRef.current +
                    window.scrollX +
                    COLUMN_RESIZE_BUFFER,
                y: prev.y
            }));
        });
    }, [columnToResize.minWidth]);
    // Handles the mouse up event to finalize column resizing.
    // Sets the final width and updates the state accordingly.
    const handleMouseUp = React__default.useCallback((e) => {
        // Prevent right-click from triggering the drop
        if (e.button === 2) {
            e.preventDefault();
            return;
        }
        setDragging(false);
        const proposedWidth = startWidthRef.current + (e.clientX - startXRef.current);
        // If the proposed width is less than the min width, use the min width
        // Note: ^^^ This shouldn't happen because we prevent the handle from going below the min width.
        const finalWidth = proposedWidth <= columnToResize.minWidth
            ? columnToResize.minWidth
            : proposedWidth;
        onColumnResized(`${Math.round(finalWidth)}px`, columnToResize.index);
        // Reset the position and cleanup
        // Use the new width to calculate the new position
        setPosition((prev) => ({
            x: window.scrollX + COLUMN_RESIZE_BUFFER,
            y: prev.y
        }));
        startXRef.current = 0;
        startWidthRef.current = 0;
        handleResizeInProgress({ resizing: false });
    }, [
        columnToResize.index,
        columnToResize.minWidth,
        handleResizeInProgress,
        onColumnResized
    ]);
    // Handles the mouse down event to initiate column resizing.
    const handleMouseDown = React__default.useCallback((e) => {
        // Prevent right-click from triggering the resize
        if (e.button === 2) {
            e.preventDefault();
            return;
        }
        CancelReactEvent(e);
        setDragging(true);
        // We need to relay the resize in progress to the DataGrid so that it can properly lock the other columns
        handleResizeInProgress({ resizing: true, index: columnToResize.index });
        startXRef.current = e.clientX;
        // Calculate the column's starting width
        startWidthRef.current =
            columnToResize.element.getBoundingClientRect().width;
    }, [columnToResize.element, columnToResize.index, handleResizeInProgress]);
    // Handles the mouse hover event to show or hide the resize handle.
    const handleMouseHover = React__default.useCallback((show) => {
        /**
         * While migrating to React 18, we needed to ensure that the `onShow` and `setShowingResizeHandle` calls were not batched.
         * `onShow` is a prop that is passed in from the DataGrid and is used to disable the hover state of the columns.
         * `setShowingResizeHandle` is used to show or hide the resize handle.
         *
         * This fixes an issue when we highlight over the divider on a datagrid column
         * causing a flicker because the column hover state is used.
         * We keep these state updates in separate renders to keep the same behavior as before React 18.
         */
        flushSync(() => {
            onShow && onShow();
        });
        flushSync(() => {
            setShowingResizeHandle(show);
        });
    }, [onShow]);
    // Function to handle the contextmenu event
    const handleContextMenu = (e) => {
        e.preventDefault();
    };
    // Effect hook to add or remove event listeners based on the dragging state.
    React__default.useEffect(() => {
        if (dragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.addEventListener('contextmenu', handleContextMenu);
        }
        else {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('contextmenu', handleContextMenu);
        }
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, [dragging, handleMouseMove, handleMouseUp]);
    return (React__default.createElement("div", { className: cx$T('resizeHandleWrapper', {
            isVisible: showingResizeHandle,
            dragging
        }), style: {
            transform: `translateX(${position.x}px)`
        } },
        React__default.createElement("div", { "data-test": `columnResizeHandle${columnToResize.index}`, ref: handleRef, className: cx$T('resizeHandle', {
                isVisible: showingResizeHandle,
                dragging
            }), onMouseOver: () => handleMouseHover(true), onMouseLeave: () => handleMouseHover(false), onMouseDown: handleMouseDown },
            React__default.createElement("div", { className: cx$T('demarcation', { dragging }), style: {
                    height: columnToResize.element.getBoundingClientRect().height
                } })),
        React__default.createElement("div", { className: cx$T('divider'), style: { height: dividerHeight } })));
};

const defaultState = {
    onColumnResized: () => { },
    dataGridHeight: 0,
    isResizing: false,
    isResizable: () => false,
    handleResizeInProgress: () => { },
    currentResizingColumnIndex: null,
    visibleColumns: [],
    columnResizeConfig: { enabled: false },
    allColumns: []
};
function reducer$1(state, action) {
    switch (action.type) {
        case 'handleResizeInProgress': {
            return Object.assign(Object.assign({}, state), { isResizing: action.params.resizing, currentResizingColumnIndex: action.params.resizing
                    ? action.params.index
                    : null });
        }
        default:
            throw new Error(`unknown action ${String(action)}`);
    }
}
const ColResizeContext = React__default.createContext(None);
const ColumnResizeProvider = ({ allColumns, visibleColumns, columnResizeConfig, dataGridHeight, children, initialState = {} }) => {
    const [state, dispatch] = React__default.useReducer(reducer$1, Object.assign(Object.assign({}, defaultState), initialState));
    const contextValue = React__default.useMemo(() => {
        const newState = Object.assign(Object.assign({}, state), { allColumns: allColumns, columnResizeConfig: columnResizeConfig, dataGridHeight: dataGridHeight, visibleColumns: visibleColumns, handleResizeInProgress: function (params) {
                dispatch &&
                    dispatch({
                        type: 'handleResizeInProgress',
                        params
                    });
            }, isResizable: function (index) {
                var _a;
                if (!columnResizeConfig.enabled) {
                    return false;
                }
                return (_a = visibleColumns[index]) === null || _a === void 0 ? void 0 : _a.isResizable;
            }, onColumnResized: function (width, index) {
                if (columnResizeConfig === null || allColumns === null) {
                    return;
                }
                onColumnResized(width, index, columnResizeConfig, allColumns);
            } });
        return OptionUtils.some(newState);
    }, [allColumns, columnResizeConfig, dataGridHeight, state, visibleColumns]);
    React__default.useEffect(() => {
        // Right now we only override the last column to `auto` if the column resize feature is enabled.
        // Should this adjustment be made for all datagrids though? Could that be a breaking change?
        if (!columnResizeConfig.enabled ||
            contextValue.value.visibleColumns.length <= 0) {
            return;
        }
        const hasAutoWidth = contextValue.value.visibleColumns.some((col) => col.width === 'auto' || col.width === 'minmax(auto, auto)' // Do we need to account for any other auto values?
        );
        // If none of the columns have a width of `auto` or `minmax('auto', `auto`)`, set the last column to `auto`.
        if (!hasAutoWidth) {
            onColumnResized('auto', contextValue.value.visibleColumns.length - 1, contextValue.value.columnResizeConfig, contextValue.value.allColumns);
        }
    }, [columnResizeConfig.enabled, contextValue.value]);
    const value = columnResizeConfig.enabled
        ? contextValue
        : None;
    return (React__default.createElement(ColResizeContext.Provider, { value: value }, children));
};
const onColumnResized = (width, index, columnResizeConfig, allColumns) => {
    if (allColumns.length > 0) {
        const newColumns = cloneDeep(allColumns);
        newColumns[index] = Object.assign(Object.assign({}, newColumns[index]), { width });
        (columnResizeConfig === null || columnResizeConfig === void 0 ? void 0 : columnResizeConfig.onColumnResize) &&
            (columnResizeConfig === null || columnResizeConfig === void 0 ? void 0 : columnResizeConfig.onColumnResize(newColumns));
    }
};
const useColumnResizeContext = () => {
    return React__default.useContext(ColResizeContext);
};

var css$H = ".DataGridColumn_module_column__af84defe{align-items:center;background-color:#f5f5f7;border:1px solid #b0b4bf;border-left-width:0;color:#585c6a;display:flex;font-weight:600;height:auto;min-height:40px;padding:8px 12px;position:sticky;top:0;z-index:100}.DataGridColumn_module_column__af84defe.DataGridColumn_module_isLast__af84defe{border-right-width:0}.DataGridColumn_module_column__af84defe.DataGridColumn_module_isClickable__af84defe{cursor:pointer}.DataGridColumn_module_column__af84defe.DataGridColumn_module_isClickable__af84defe:hover{background-color:#e5e6eb}.DataGridColumn_module_column__af84defe.DataGridColumn_module_isClickable__af84defe.DataGridColumn_module_locked__af84defe{pointer-events:none}.DataGridColumn_module_column__af84defe.DataGridColumn_module_isClickable__af84defe.DataGridColumn_module_locked__af84defe:hover{background-color:#f5f5f7}.DataGridColumn_module_column__af84defe:focus{outline:none}[class*=rowChildContainer] .DataGridColumn_module_column__af84defe{z-index:99}.DataGridColumn_module_text__af84defe{align-items:center;display:flex;flex:1;justify-content:left;min-width:0}.DataGridColumn_module_text__af84defe.DataGridColumn_module_right__af84defe{justify-content:right}.DataGridColumn_module_text__af84defe.DataGridColumn_module_center__af84defe{justify-content:center}.DataGridColumn_module_sortIcon__af84defe{height:auto;width:18px}.DataGridColumn_module_helpIcon__af84defe,.DataGridColumn_module_iconOnlyHeader__af84defe{height:16px}";
window.ADS.injectStyle(css$H,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/components/DataGridColumn.module.scss");
var modules_f78886b8 = {"column":"DataGridColumn_module_column__af84defe","isLast":"DataGridColumn_module_isLast__af84defe","isClickable":"DataGridColumn_module_isClickable__af84defe","locked":"DataGridColumn_module_locked__af84defe","text":"DataGridColumn_module_text__af84defe","right":"DataGridColumn_module_right__af84defe","center":"DataGridColumn_module_center__af84defe","sortIcon":"DataGridColumn_module_sortIcon__af84defe","helpIcon":"DataGridColumn_module_helpIcon__af84defe","iconOnlyHeader":"DataGridColumn_module_iconOnlyHeader__af84defe"};

const TEST_IDS$a = {
    column: 'column'
};
const cx$S = BindStylesV2(modules_f78886b8);
// Using a class here because columns are used to both render the column header
// AND column cells which is spread across multiple React components.
class DataColumnModel {
    constructor(_a) {
        var { width } = _a, fields = __rest(_a, ["width"]);
        this.width = 'minmax(auto, auto)';
        Object.assign(this, fields);
        this.width = width || this.width;
        if (!this.name) {
            ADSError('DataGridColumn missing name property. The following DataGridColum config object is missing a unique name property which is required.', fields);
        }
        // We default to be sortable
        if (this.isSortable === undefined) {
            this.isSortable = true;
        }
        // If they did not provide a cell renderer, we try and look
        // up the data using the name property.
        if (!this.cellRenderer || !isFunction(this.cellRenderer)) {
            this.cellRenderer = (row) => row[this.name];
        }
        // If they did not provide a sort value, we try and look
        // up the data using the name property.
        if (!this.sortValue || !isFunction(this.sortValue)) {
            this.sortValue = (row) => row[this.name];
        }
        // If they don't provide a title, we will fallback to using the name.
        if (!isString(this.title)) {
            this.title = this.name;
        }
        // We default to be visible
        if (this.isVisible === undefined) {
            this.isVisible = true;
        }
        // We default to be resizable
        if (this.isResizable === undefined) {
            this.isResizable = true;
        }
        // we don't want the last column to be resizable
        if (this.isLastVisible) {
            this.isResizable = false;
        }
        // We default to be unlocked
        if (typeof this.isLocked === 'boolean') {
            this.locked = this.isLocked;
        }
        else if (this.isLocked === undefined) {
            this.locked = false;
            this.lockedEnd = false;
        }
        else {
            this.locked = true;
            this.lockedEnd = this.isLocked.positionEnd;
        }
        if (!this.isVisible) {
            this.locked = false;
            this.lockedEnd = false;
        }
        // default to alignment to be left if not provided
        if (!this.alignText) {
            this.alignText = 'left';
        }
    }
}
class SpecialDataColumnModel extends DataColumnModel {
    constructor(fields) {
        super(Object.assign(Object.assign({}, fields), { isResizable: false }));
    }
}
const formatVisibleColumns = (columns) => {
    const visibleColumns = columns.filter((column) => column.isVisible);
    // grab the last column and set it to be the last visible column
    const lastColumn = visibleColumns.at(-1);
    if (lastColumn) {
        return [
            ...visibleColumns.slice(0, -1),
            new DataColumnModel(Object.assign(Object.assign({}, lastColumn), { isLastVisible: true }))
        ];
    }
    return visibleColumns;
};
const isValidResizableWidth = (width) => {
    return width === 'auto' || /^\d+px$/.test(width);
};
const calculateTitleContentWidth = (titleContent, titleContentWidth) => {
    if (typeof titleContent !== 'string') {
        return titleContentWidth !== null && titleContentWidth !== void 0 ? titleContentWidth : 0;
    }
    else {
        // Calculate the width of the title content if it is a string
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            const fontSize = '14px';
            const fontFamily = 'Open Sans';
            const fontWeight = '600';
            context.font = `${fontWeight} ${fontSize} ${fontFamily}`;
            // Determine the width of the longest word in the title content
            const words = titleContent.split(' ');
            const longestWordWidth = Math.max(...words.map((word) => context.measureText(word).width));
            return Math.round(longestWordWidth);
        }
    }
    return 0;
};
const calculateHelpIconWidth = (helpIconWidth) => {
    if (helpIconWidth === null) {
        return 0;
    }
    return helpIconWidth + 8; // 8px for margin
};
const TitleContent = ({ testId, shouldTruncateTitle = false, titleContent, titleContentRef, isIconOnly = false }) => {
    return shouldTruncateTitle ? (React__default.createElement(CellText, { testId: testId },
        React__default.createElement("span", null, titleContent))) : (React__default.createElement("div", { "data-test": testId, ref: titleContentRef, className: cx$S([{ iconOnlyHeader: isIconOnly }]) || undefined }, titleContent));
};
const BASE_Z_INDEX = 100;
const DataGridColumn = ({ column, index, sorted, isSorting, onSort, onHover, dataColumnIndex = -1, initialRender, zIndexOffset }) => {
    const [columnResizeHandleVisible, setColumnResizeHandleVisible] = React__default.useState(false);
    const maybeColumnResizeContext = useColumnResizeContext();
    const columnResizeContext = OptionUtils.value(
    // case: the column-resizing feature is currently [enabled]
    maybeColumnResizeContext, 
    // case: the column-resizing feature is currently [disabled]
    {
        currentResizingColumnIndex: null,
        dataGridHeight: 0,
        isResizing: false,
        handleResizeInProgress: noop$1,
        isResizable: () => false,
        onColumnResized: noop$1
    });
    const { currentResizingColumnIndex, isResizing, isResizable: isResizableFn, dataGridHeight, handleResizeInProgress, onColumnResized } = columnResizeContext;
    // When a column is resizable, we set a special z-index to ensure the column resize handle is visible and not overlapped by the column to the right.
    // The supplied zIndexOffset value is simply determined by the columns index in the columns array. Which, in most cases, is something like 0, 1, 2, 3, etc.
    // Since the cells rendered via the cellRenderer have a z-index of 99, we need to ensure the column header cell has a z-index of 100 or higher.
    const zIndexOverride = zIndexOffset === undefined ? undefined : zIndexOffset + BASE_Z_INDEX;
    const isResizable = React__default.useMemo(() => {
        return isResizableFn(dataColumnIndex);
    }, [isResizableFn, dataColumnIndex]);
    const columnRef = React__default.useRef(null);
    const titleContentRef = React__default.useRef(null);
    const helpIconRef = React__default.useRef(null);
    const titleContentSize = useSize(titleContentRef.current);
    const helpIconSize = useSize(helpIconRef.current);
    const handleClick = () => {
        if (columnResizeHandleVisible)
            return; // Prevent column click when resizing
        if (column.isSortable && onSort) {
            const direction = sorted === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc;
            return onSort(column.name, direction);
        }
        if (column.onColumnClick) {
            column.onColumnClick();
        }
    };
    const titleContent = column.columnRenderer
        ? column.columnRenderer()
        : column.title;
    const isTruncatable = React__default.useMemo(() => {
        var _a, _b;
        const shouldTruncate = (_b = (_a = column.shouldTruncateTitle) !== null && _a !== void 0 ? _a : isResizable) !== null && _b !== void 0 ? _b : false;
        return shouldTruncate && typeof titleContent === 'string';
    }, [column.shouldTruncateTitle, isResizable, titleContent]);
    const isClickable = column.isSortable || column.onColumnClick;
    isSorting = column.isSortable && isSorting;
    const isSorted = !isSorting && column.isSortable && sorted;
    const onColumnResizeHandleShow = React__default.useCallback(() => {
        setColumnResizeHandleVisible((previous) => !previous);
    }, []);
    const resizeHandleDragging = React__default.useMemo(() => {
        return currentResizingColumnIndex === dataColumnIndex;
    }, [currentResizingColumnIndex, dataColumnIndex]);
    // Used to calculate the width of the content in the column
    const minWidth = React__default.useMemo(() => {
        let width = 0;
        // Determine the width of the column content.
        // This includes the title content, help icon, and sort arrow icon. (eventually the filter icon)
        if (titleContent) {
            if (isTruncatable) {
                width += 42;
            }
            else {
                width += calculateTitleContentWidth(titleContent, titleContentSize.width);
            }
        }
        width += calculateHelpIconWidth(helpIconSize.width);
        // If the column is sorting or sorted, add the width to account for the sort arrow/spinner icon
        if (isSorting || isSorted) {
            width += 26;
        }
        return width + 24; // 24px for padding;
    }, [
        isTruncatable,
        helpIconSize.width,
        isSorted,
        isSorting,
        titleContent,
        titleContentSize.width
    ]);
    const adjustForMinWidth = React__default.useCallback((minWidthOverride) => {
        // If the current width is set to `auto` just return
        if (column.width === 'auto')
            return;
        // If the current width is less than the calculated min width, update the column width to the calculated min width
        if (parseFloat(column.width) < minWidthOverride) {
            onColumnResized(`${minWidthOverride}px`, dataColumnIndex);
        }
    }, [column.width, dataColumnIndex, onColumnResized]);
    React__default.useEffect(() => {
        if (!isResizable || initialRender)
            return;
        // If the column width is not a valid resizable width (i.e. not a set pixel width or "auto") then reset the width to "auto"
        if (!isValidResizableWidth(column.width)) {
            ADSWarn(`Column ${column.name}'s width has been overridden to 'auto': A column must have a set width (in pixels) or "auto" when the column resizing feature is enabled.`);
            onColumnResized('auto', dataColumnIndex);
            return;
        }
        if (minWidth > 0) {
            adjustForMinWidth(minWidth);
        }
    }, [
        column.name,
        column.isResizable,
        column.width,
        dataColumnIndex,
        adjustForMinWidth,
        initialRender,
        onColumnResized,
        isResizable,
        minWidth
    ]);
    return (React__default.createElement("div", { "data-test": TEST_IDS$a.column, "data-column": index, ref: columnRef, onClick: handleClick, className: cx$S([
            'column',
            {
                isLast: column.isLastVisible,
                isClickable,
                // we need to lock the column when the datagrid is in the middle of resizing any column.
                // OR when the column resize handle for this column is visible
                locked: isResizing || columnResizeHandleVisible
            }
        ]), style: { zIndex: zIndexOverride }, onMouseEnter: () => onHover(true), onMouseLeave: () => onHover(false), tabIndex: -1, "data-ads-component-type": "dataGridColumnHeader" },
        isResizable &&
            (columnRef === null || columnRef === void 0 ? void 0 : columnRef.current) &&
            !(isResizing && !resizeHandleDragging) && (React__default.createElement(ColumnResizeHandle, { columnToResize: {
                element: columnRef === null || columnRef === void 0 ? void 0 : columnRef.current,
                index: dataColumnIndex,
                minWidth: minWidth
            }, dataGridHeight: dataGridHeight, handleResizeInProgress: handleResizeInProgress, onColumnResized: onColumnResized, onShow: onColumnResizeHandleShow })),
        React__default.createElement("div", { className: cx$S(['text', column.alignText]) },
            React__default.createElement(TitleContent, { testId: `${column.name}-column-title`, shouldTruncateTitle: isTruncatable, titleContent: titleContent, titleContentRef: titleContentRef, isIconOnly: column.isIconOnly }),
            column.helpText && (React__default.createElement("div", { className: cx$S(['helpIcon', 'mx-50']), ref: helpIconRef },
                React__default.createElement(Tooltip, { content: column.helpText, trigger: "mouseenter click" },
                    React__default.createElement(Icon, { icon: "ICircleIcon", size: 16, onClick: (evt) => evt.stopPropagation(), className: 'help-hover' }))))),
        isSorting && (React__default.createElement("div", { className: cx$S(['sortIcon']) },
            React__default.createElement(Icon, { icon: "SpinnerIcon", size: 16 }))),
        isSorted && (React__default.createElement("div", { className: cx$S(['sortIcon']) },
            React__default.createElement(Icon, { icon: "SortArrowIcon", size: 16, focused: sorted === SortDirection.Asc })))));
};

var css$G = ".ColumnPreferences_module_ColumnPreferencesBody__78b3a035{height:50vh}.ColumnPreferences_module_ColumnPreferencesBody__78b3a035 .ColumnPreferences_module_directionalText__78b3a035{display:block;max-width:612px}.ColumnPreferences_module_ColumnPreferencesBody__78b3a035 .ColumnPreferences_module_columnSelect__78b3a035{color:#363840;display:flex;flex-direction:row;height:calc(100% - 84px);justify-content:space-between;margin-top:24px}";
window.ADS.injectStyle(css$G,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/columns/ColumnPreferences/ColumnPreferences.module.scss");
var modules_6cedd100 = {"ColumnPreferencesBody":"ColumnPreferences_module_ColumnPreferencesBody__78b3a035","directionalText":"ColumnPreferences_module_directionalText__78b3a035","columnSelect":"ColumnPreferences_module_columnSelect__78b3a035"};

var css$F = ".DragAndDropList_module_dragAndDropListWrapper__67ce1703{border:none;display:flex;flex:1 1 0;flex-direction:column;gap:0;height:100%;min-width:300px}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_hidden__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703{border:1px solid #b0b4bf;border-radius:4px;color:#585c6a;display:flex;flex:1;flex-direction:column;height:100%;margin-top:8px;overflow-y:scroll;padding:8px;width:300px}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_hidden__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703.DragAndDropList_module_isDragging__67ce1703{background-color:#f1f4fd;border:1px dashed #365ef6!important}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_hidden__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703::-webkit-scrollbar{background-color:#f5f5f7;border-left:1px solid #e5e6eb;border-radius:0 3px 3px 0}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_display__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703,.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_reorderableRowsDisplay__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703{border:1px solid #b0b4bf;border-radius:4px;display:flex;flex:1;flex-direction:column;height:100%;margin-top:8px;overflow-y:scroll;padding:8px}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_display__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703.DragAndDropList_module_isDragging__67ce1703,.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_reorderableRowsDisplay__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703.DragAndDropList_module_isDragging__67ce1703{background-color:#f1f4fd;border:1px dashed #365ef6!important}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_display__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703::-webkit-scrollbar,.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_reorderableRowsDisplay__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703::-webkit-scrollbar{background-color:#f5f5f7;border-left:1px solid #e5e6eb;border-radius:0 3px 3px 0}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_display__67ce1703{margin-right:24px}.DragAndDropList_module_dragAndDropListWrapper__67ce1703.DragAndDropList_module_display__67ce1703 .DragAndDropList_module_dragAndDropList__67ce1703{width:300px}.DragAndDropList_module_dragAndDropListWrapper__67ce1703 .DragAndDropList_module_minColumnRequired__67ce1703{color:#6a6f82;font-style:italic;text-align:center}.DragAndDropList_module_dragAndDropListWrapper__67ce1703 .DragAndDropList_module_minColumnRequired__67ce1703.DragAndDropList_module_visible__67ce1703{height:auto;opacity:1;padding:16px 24px;transition:opacity 275ms cubic-bezier(.25,.25,.25,1),height 275ms cubic-bezier(.25,.25,.25,1),padding 0ms}.DragAndDropList_module_dragAndDropListWrapper__67ce1703 .DragAndDropList_module_minColumnRequired__67ce1703.DragAndDropList_module_hidden__67ce1703{height:0;opacity:0;padding:0;transition:opacity 275ms cubic-bezier(.25,.25,.25,1),height 275ms cubic-bezier(.25,.25,.25,1),padding 0ms 275ms}.DragAndDropList_module_dragAndDropListWrapper__67ce1703 .DragAndDropList_module_smoothDrop__67ce1703{max-height:0;transition:max-height .2s cubic-bezier(.2,0,0,1) 0s}.DragAndDropList_module_dragAndDropListWrapper__67ce1703 .DragAndDropList_module_smoothDrop__67ce1703.DragAndDropList_module_isDragging__67ce1703{max-height:38px}";
window.ADS.injectStyle(css$F,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/dragAndDropComponents/DragAndDropList.module.scss");
var modules_917f9566 = {"dragAndDropListWrapper":"DragAndDropList_module_dragAndDropListWrapper__67ce1703","hidden":"DragAndDropList_module_hidden__67ce1703","dragAndDropList":"DragAndDropList_module_dragAndDropList__67ce1703","isDragging":"DragAndDropList_module_isDragging__67ce1703","display":"DragAndDropList_module_display__67ce1703","reorderableRowsDisplay":"DragAndDropList_module_reorderableRowsDisplay__67ce1703","minColumnRequired":"DragAndDropList_module_minColumnRequired__67ce1703","visible":"DragAndDropList_module_visible__67ce1703","smoothDrop":"DragAndDropList_module_smoothDrop__67ce1703"};

var css$E = ".DraggableListItem_module_dragAndDropItem__f57004ff{background:#0000;margin:2px 3px;padding:6px 8px 6px 6px}.DraggableListItem_module_dragAndDropItem__f57004ff.DraggableListItem_module_isDragging__f57004ff{pointer-events:none}.DraggableListItem_module_dragAndDropItem__f57004ff .DraggableListItem_module_widthWrap__f57004ff{width:auto}.DraggableListItem_module_dragAndDropItem__f57004ff.DraggableListItem_module_focus__f57004ff,.DraggableListItem_module_dragAndDropItem__f57004ff:focus,.DraggableListItem_module_dragAndDropItem__f57004ff:focus-within{border:1px solid #365ef6!important;border-radius:3px;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.DraggableListItem_module_dragAndDropItem__f57004ff:hover{background:#f1f4fd;border-radius:3px;cursor:grab}.DraggableListItem_module_dragAndDropItem__f57004ff.DraggableListItem_module_locked__f57004ff{border:1px solid #0000;color:#b0b4bf;user-select:none;width:100%}.DraggableListItem_module_dragAndDropItem__f57004ff.DraggableListItem_module_locked__f57004ff:hover{background:#0000;cursor:not-allowed}.DraggableListItem_module_dragAndDropItem__f57004ff.DraggableListItem_module_locked__f57004ff svg{fill:#b0b4bf}.DraggableListItem_module_draggable__f57004ff{align-items:center;display:flex}.DraggableListItem_module_draggable__f57004ff .DraggableListItem_module_draggableSpan__f57004ff{padding-left:12px}";
window.ADS.injectStyle(css$E,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/dragAndDropComponents/DraggableListItem.module.scss");
var modules_51d4dd95 = {"dragAndDropItem":"DraggableListItem_module_dragAndDropItem__f57004ff","isDragging":"DraggableListItem_module_isDragging__f57004ff","widthWrap":"DraggableListItem_module_widthWrap__f57004ff","focus":"DraggableListItem_module_focus__f57004ff","locked":"DraggableListItem_module_locked__f57004ff","draggable":"DraggableListItem_module_draggable__f57004ff","draggableSpan":"DraggableListItem_module_draggableSpan__f57004ff"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$R = BindStyles(modules_51d4dd95);
const getItemStyle = (draggableStyle, isDragging) => (Object.assign(Object.assign(Object.assign({ 
    // some basic styles to make the items look a bit nicer
    userSelect: 'none' }, draggableStyle), { display: 'flex', alignItems: 'center', fontWeight: '600', border: '1px solid transparent' }), (isDragging
    ? {
        background: `rgba(${213}, ${225}, ${251}, ${0.8})`,
        border: '1px solid #AABFF8',
        borderRadius: '3px'
    }
    : {})));
const DraggableListItem = ({ item, index }) => {
    return (React__default.createElement(Draggable, { key: item.name, draggableId: item.key, index: index }, (provided, snapshot) => (React__default.createElement("div", Object.assign({ className: cx$R('dragAndDropItem', {
            locked: item.locked
        }) +
            ' ' +
            cx$R('draggable'), ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getItemStyle(provided.draggableProps.style, snapshot.isDragging) }),
        React__default.createElement(Icon, { icon: "SixDotsIcon", className: modules_51d4dd95.widthWrap, size: 16 }),
        React__default.createElement("span", { className: cx$R('draggableSpan') }, item.name)))));
};

const cx$Q = classnames.bind(modules_51d4dd95);
const LockedItem = ({ item, isDragging }) => {
    return (React__default.createElement("div", { className: cx$Q('dragAndDropItem', {
            locked: item.locked,
            isDragging: isDragging
        }) +
            ' ' +
            cx$Q('draggable') },
        React__default.createElement(Icon, { className: modules_51d4dd95.widthWrap, icon: "LockIcon", size: 16 }),
        React__default.createElement("span", { className: cx$Q('draggableSpan') }, item.name)));
};

const cx$P = BindStyles(modules_917f9566);
const RequiredMessage = ({ show, testId = 'min-column-required' }) => {
    const { t } = useTranslation();
    return (React__default.createElement("span", { "data-test": testId, className: cx$P('minColumnRequired', {
            visible: show,
            hidden: !show
        }) }, t('MIN_VISIBLE_COLUMN_REQUIRED')));
};
const DragAndDropList = ({ items, id, title, isDragging, oneColumnRequired, testId = 'drag-and-drop-list' }) => {
    /** Function to determine if the required columns message should be shown */
    const showRequiredMessage = React__default.useCallback((isDraggingOver, isDraggingFrom) => {
        const isEmpty = items.length === 0;
        const isSingleItem = items.length === 1;
        const isDraggingAndNotOver = isDragging && !isDraggingOver;
        const isNotDraggingAndEmpty = !isDragging && isEmpty;
        // Return TRUE if:
        // - Not dragging and the list is empty
        //    - Example: Visible Columns list is empty and the user is not dragging an item
        // - Dragging, not dragging over this list, has a single item in the list, and dragging from the same list
        //    - Example: The only item in the Visible Columns list is being dragged to the Hidden Columns list, but the item is not hovering the Visible Columns list
        // - Dragging, not dragging over this list, the list is empty, and not dragging from the same list
        //    - Example: There are no items in the Visible Columns list, and the user is dragging an item from the Hidden Columns list, but the item is not hovering the Visible Columns list
        return (isNotDraggingAndEmpty ||
            (isDraggingAndNotOver &&
                ((isSingleItem && isDraggingFrom) || (isEmpty && !isDraggingFrom))));
    }, [items, isDragging]);
    return (React__default.createElement("div", { id: `${id}List`, "data-test": testId, className: cx$P('dragAndDropListWrapper', id) },
        React__default.createElement("h4", { style: { fontWeight: 600 } }, title),
        React__default.createElement(Droppable, { droppableId: id, key: id }, (provided, snapshot) => (React__default.createElement("div", { ref: provided.innerRef, className: cx$P('dragAndDropList', {
                isDragging: snapshot.isDraggingOver
            }) },
            React__default.createElement("div", null, items === null || items === void 0 ? void 0 : items.filter((i) => i.locked && !i.lockedEnd).map((item, index) => (React__default.createElement(LockedItem, { item: item, key: index, isDragging: isDragging })))), items === null || items === void 0 ? void 0 :
            items.filter((i) => !i.locked).map((item, index) => (React__default.createElement(DraggableListItem, { item: item, index: index, key: item.key }))),
            React__default.createElement("span", { className: cx$P('smoothDrop', {
                    isDragging: snapshot.isDraggingOver || !isDragging
                }) }, snapshot.isUsingPlaceholder || isDragging
                ? provided.placeholder
                : ''),
            React__default.createElement("div", null, items === null || items === void 0 ? void 0 : items.filter((i) => i.locked && i.lockedEnd).map((item, index) => (React__default.createElement(LockedItem, { item: item, key: index, isDragging: isDragging })))),
            oneColumnRequired && (React__default.createElement(RequiredMessage, { testId: `${testId}-min-column-required`, show: showRequiredMessage(snapshot.isDraggingOver, !!snapshot.draggingFromThisWith) })))))));
};

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(addOffset(list, startIndex), 1);
    result.splice(addOffset(list, endIndex), 0, removed);
    return result;
};
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(addOffset(sourceClone, droppableSource.index), 1);
    destClone.splice(addOffset(destClone, droppableDestination.index), 0, removed);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;
    return result;
};
function addOffset(list, index) {
    return (index +
        list.filter((column) => {
            return column.locked && !column.lockedEnd;
        }).length);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const Container = ({ items, updateList }) => {
    const [preferences, setPreferences] = React__default.useState();
    const { t } = useTranslation();
    React__default.useEffect(() => {
        setPreferences({
            display: cloneDeep(Array.from(items.filter((i) => i.isVisible))),
            hidden: cloneDeep(Array.from(items.filter((i) => !i.isVisible)))
        });
    }, [items]);
    const getList = (id) => {
        switch (id) {
            case 'display':
                return (preferences === null || preferences === void 0 ? void 0 : preferences.display) || [];
            case 'hidden':
                return (preferences === null || preferences === void 0 ? void 0 : preferences.hidden) || [];
            default:
                return [];
        }
    };
    const [isDragging, setIsDragging] = React__default.useState(false);
    const handleOnDragEnd = (result) => {
        setIsDragging(false);
        const { source, destination } = result;
        // dropped outside the list
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {
            const newItems = reorder(getList(source.droppableId), source.index, destination.index);
            const updatedState = {};
            updatedState[source.droppableId] = newItems;
            setPreferences((prevState) => {
                return Object.assign(Object.assign({}, prevState), updatedState);
            });
            if (destination.droppableId === 'display') {
                updateList(newItems.concat(getList('hidden')));
            }
            else {
                updateList(getList('display').concat(newItems));
            }
        }
        else {
            const result = move(getList(source.droppableId), getList(destination.droppableId), source, destination);
            result.display.forEach((item, index) => {
                item.hidden = false;
                item.sortOrder = index;
                item.isVisible = true;
            });
            result.hidden.forEach((item) => {
                item.hidden = true;
                item.isVisible = false;
            });
            setPreferences({
                display: result.display,
                hidden: result.hidden
            });
            updateList(result.display.concat(result.hidden));
        }
    };
    const handleDragStart = () => {
        setIsDragging(true);
    };
    const displayDraggableItems = React__default.useMemo(() => {
        return ((preferences === null || preferences === void 0 ? void 0 : preferences.display.map((item) => {
            return {
                key: item.title,
                name: item.title,
                locked: typeof item.isLocked === 'boolean' ? item.isLocked : false,
                lockedEnd: item.isLocked !== undefined && typeof item.isLocked !== 'boolean'
                    ? item.isLocked.positionEnd
                    : false
            };
        })) || []);
    }, [preferences === null || preferences === void 0 ? void 0 : preferences.display]);
    const hiddenDraggableItems = React__default.useMemo(() => {
        return ((preferences === null || preferences === void 0 ? void 0 : preferences.hidden.map((item) => {
            return {
                key: item.title,
                name: item.title,
                locked: false,
                lockedEnd: false
            };
        })) || []);
    }, [preferences === null || preferences === void 0 ? void 0 : preferences.hidden]);
    return (React__default.createElement(React__default.Fragment, null, ((preferences === null || preferences === void 0 ? void 0 : preferences.display) || (preferences === null || preferences === void 0 ? void 0 : preferences.hidden)) && (React__default.createElement(DragDropContext, { onDragEnd: handleOnDragEnd, onDragStart: handleDragStart },
        React__default.createElement(DragAndDropList, { id: "display", testId: 'display-dnd-list', oneColumnRequired: true, items: displayDraggableItems, title: t('VISIBLE_COLUMNS'), isDragging: isDragging }),
        React__default.createElement(DragAndDropList, { id: "hidden", testId: 'hidden-dnd-list', items: hiddenDraggableItems, title: t('HIDDEN_COLUMNS'), isDragging: isDragging })))));
};

const cx$O = BindStyles(modules_6cedd100);
const TEST_IDS$9 = {
    columnPreferences: 'columnPreferences',
    submitButton: (rest) => `columnPreferencesSubmit${rest !== null && rest !== void 0 ? rest : ''}`
};
const ColumnPreferences = ({ title, onClose, columns, testId }) => {
    const [displayColumns, setDisplayColumns] = React__default.useState([...columns].map((c) => new DataColumnModel(c)) || []);
    const { t } = useTranslation();
    const handleUpdateList = React__default.useCallback((updatedColumns) => {
        if (updatedColumns) {
            setDisplayColumns(updatedColumns.map((c) => new DataColumnModel(c)));
        }
    }, []);
    const isSaveEnabled = () => {
        return displayColumns.some((column) => column.isVisible);
    };
    return (React__default.createElement(Modal, { open: true, title: title, testId: TEST_IDS$9.columnPreferences, onClose: () => onClose(false, displayColumns) },
        React__default.createElement(ModalBody, null,
            React__default.createElement("div", { className: cx$O('ColumnPreferencesBody') },
                React__default.createElement("span", { className: cx$O('directionalText') },
                    React__default.createElement(Trans, { t: t, i18nKey: 'CUSTOMIZE_COLUMNS_MICROCOPY' })),
                React__default.createElement("div", { className: cx$O('columnSelect') },
                    React__default.createElement(Container, { items: displayColumns, updateList: handleUpdateList })))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(Button, { testId: testId
                    ? `columnPreferencesCancel${testId}`
                    : 'columnPreferencesCancel', type: "tertiary", onClick: () => {
                    onClose(false, displayColumns);
                }, className: "mr-100" }, t('CANCEL')),
            React__default.createElement(Button, { disabled: !isSaveEnabled(), testId: TEST_IDS$9.submitButton(testId), type: "primary", submit: true, onClick: () => {
                    onClose(true, displayColumns);
                } }, t('SAVE')))));
};

const TEST_IDS$8 = {
    triggerButton: 'col-prefs-trigger'
};
const I18N_KEYS$2 = {
    'column-preferences': 'CUSTOMIZE_COLUMNS_TOOLTIP',
    'actions-menu': 'MORE_ACTIONS_TOOLTIP',
    'column-preferences-and-actions-menu': 'CUSTOMIZE_COLUMNS_OR_MORE_ACTIONS_TOOLTIP'
};
const PreferencesTrigger = ({ actionsMenuConfig, columns, columnPreferencesDisabled = false, hasColumnPreferences, testId, title, onColumnsChange, unfreezeColumns }) => {
    var _a;
    const { t } = useTranslation();
    const [columnPreferencesOpen, setColumnPreferencesOpen] = React__default.useState(false);
    const { menuConfig, actionsMenuVisible, columnPreferencesVisibility } = useActionsMenuConfigAndVisibilities(actionsMenuConfig, hasColumnPreferences, columnPreferencesDisabled, title, setColumnPreferencesOpen);
    const buttonTooltipFn = (_a = actionsMenuConfig === null || actionsMenuConfig === void 0 ? void 0 : actionsMenuConfig.buttonTooltip) !== null && _a !== void 0 ? _a : null;
    /**
     * We will have a tooltip unless both the actions menu and the column-preferences modal
     * are hidden.
     *
     * In the case they are both hidden, we will not render this "button" component at all
     * (since there is nothing to do). We handle all cases as a safeguard; but we don't expect
     * to reach this point.
     */
    const tooltip = React__default.useMemo(() => {
        // Case (1) [Custom Tooltip]
        if (actionsMenuVisible && buttonTooltipFn) {
            const customTooltip = buttonTooltipFn({
                selectableColumnsActionVisibility: columnPreferencesVisibility
            });
            return { content: customTooltip };
        }
        // Case (2) [Default Tooltip]
        const maybeDefaultTooltip = match([
            actionsMenuVisible,
            columnPreferencesVisibility
        ])
            // both AM & CP are visible
            .with([true, P.union('enabled', 'disabled')], () => t(I18N_KEYS$2['column-preferences-and-actions-menu']))
            // only AM is visible
            .with([true, 'hidden'], () => t(I18N_KEYS$2['actions-menu']))
            // only CP is visible
            .with([false, P.union('enabled', 'disabled')], () => t(I18N_KEYS$2['column-preferences']))
            // edge case: both AM & CP are hidden - this case is handled in the parent component
            .with([false, 'hidden'], () => null)
            .exhaustive();
        if (!maybeDefaultTooltip) {
            // edge case: both AM & CP are hidden - this case is handled in the parent component
            return null;
        }
        else {
            const defaultTooltip = maybeDefaultTooltip;
            return { content: defaultTooltip };
        }
    }, [actionsMenuVisible, columnPreferencesVisibility, buttonTooltipFn, t]);
    if (!tooltip ||
        (!actionsMenuVisible && columnPreferencesVisibility === 'hidden')) {
        // edge case: both AM & CP are hidden - this case is handled in the parent component
        return null;
    }
    // [else] render cases: (1) through (5)
    return (React__default.createElement(React__default.Fragment, null,
        menuConfig ? (
        // case: render a dropdown menu
        React__default.createElement(ActionsMenuButton, { testId: TEST_IDS$8.triggerButton, actionsMenuConfig: menuConfig, dropdownPlacementConfig: {
                placement: 'bottom-end',
                fallbackPlacements: ['top-end']
            }, icon: "HamburgerIcon", tooltip: tooltip })) : (
        // case: render the column-preferences modal
        React__default.createElement(Button, { disabled: columnPreferencesDisabled, icon: "FrenchFriesIcon", size: "md", testId: TEST_IDS$8.triggerButton, tooltip: tooltip, type: "secondary", onClick: () => setColumnPreferencesOpen(true) })),
        columnPreferencesOpen && (React__default.createElement(ColumnPreferences, { columns: columns, testId: testId, title: title, onClose: (updated, cols) => {
                if (updated) {
                    unfreezeColumns();
                    onColumnsChange && onColumnsChange(cols);
                }
                setColumnPreferencesOpen(false);
            } }))));
};
/**
 * This React Hook will let you know if the actions menu or the column-preferences modal are available (or if both are).
 * This React Hook also returns the actions menu config that should be used to render the dropdown menu or `null` if no dropdown menu is available.
 *
 * @description
 * terms:
 *   button                   - the preferences-trigger button
 *   AM = actions menu        - a menu to perform actions globally on the grid
 *   CP = column preference   - a modal to customize the grid's column order
 *   (e) = enabled            - visible and enabled
 *   (d) = disabled           - visible but disabled
 *   (h) = hidden             - hidden
 *
 * expectations on "button" click
 *   1) AM(e) & CP(e) → show a dropdown menu with [initial section CP] followed by [any AM section(s)]
 *   2) AM(e) & CP(d) → show a dropdown menu with [disabled initial section for CP] followed by [any AM section(s)]
 *   3) AM(e) & CP(h) → show a dropdown menu with [any AM section(s)]
 *
 *   4) AM(h) & CP(e) → show the column-preferences workflow
 *   5) AM(h) & CP(d) → show the button as disabled
 *   6) AM(h) & CP(h) → show no button at all as there is nothing to do!
 *
 * @remarks
 * - The actions menu itself is not "disabled" as a feature; so it's either enabled or hidden.
 * - The (6th) case is handled when the parent component conditionally does NOT render this component at all.
 *
 * @param actionsMenuConfig
 * @param hasColumnPreferences
 * @param columnPreferencesDisabled
 * @param title
 * @param setColumnPreferencesOpen
 * @returns - described already
 */
function useActionsMenuConfigAndVisibilities(actionsMenuConfig, hasColumnPreferences, columnPreferencesDisabled, title, setColumnPreferencesOpen) {
    const actionsMenuVisible = !!actionsMenuConfig;
    const columnPreferencesVisibility = React__default.useMemo(() => {
        return match([hasColumnPreferences, columnPreferencesDisabled])
            .with([true, false], () => 'enabled')
            .with([true, true], () => 'disabled')
            .with([false, P.any], () => 'hidden')
            .exhaustive();
    }, [columnPreferencesDisabled, hasColumnPreferences]);
    const menuConfig = React__default.useMemo(() => {
        var _a;
        // case (6): AM(h) & CP(h)
        if (!actionsMenuVisible && columnPreferencesVisibility === 'hidden') {
            return null;
        }
        // case (4): AM(h) & CP(e)
        // or   (5): AM(h) & CP(d)
        if (!actionsMenuVisible) {
            return null;
        }
        // case (3): AM(e) & CP(h)
        if (columnPreferencesVisibility === 'hidden') {
            return actionsMenuConfig;
        }
        // [else]
        // case (1): AM(e) & CP(e)
        // or   (2): AM(e) & CP(d)
        const openColumnPreferences = {
            type: 'action',
            label: title,
            visibilityConfig: columnPreferencesDisabled ? 'disabled' : 'enabled',
            onClick: () => void setColumnPreferencesOpen(true)
        };
        const menuConfigWithColumnPreferences = Object.assign(Object.assign({}, actionsMenuConfig), { menu: Object.assign(Object.assign({}, actionsMenuConfig === null || actionsMenuConfig === void 0 ? void 0 : actionsMenuConfig.menu), { sections: [
                    // Prepend the open-column-preferences action to a standalone (first) section of the menu.
                    { options: [openColumnPreferences] },
                    // And keep the rest of the menu as was configured.
                    ...((_a = actionsMenuConfig === null || actionsMenuConfig === void 0 ? void 0 : actionsMenuConfig.menu.sections) !== null && _a !== void 0 ? _a : [])
                ] }) });
        return menuConfigWithColumnPreferences;
    }, [
        actionsMenuConfig,
        actionsMenuVisible,
        columnPreferencesDisabled,
        columnPreferencesVisibility,
        title,
        setColumnPreferencesOpen
    ]);
    return {
        menuConfig,
        actionsMenuVisible,
        columnPreferencesVisibility
    };
}

function useRenderTextWidth(calc, items, font = '14px "Open Sans", sans-serif') {
    const renderLength = React__default.useMemo(() => {
        let maxLength = 0;
        if (items && calc) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            if (context) {
                context.font = font;
                const lengths = items.map((item) => {
                    return context.measureText(item.text).width;
                });
                maxLength =
                    Math.floor(lengths.reduce((p, c) => {
                        return c > p ? c : p;
                    }, 0)) + 1;
            }
            canvas.remove();
        }
        return maxLength;
    }, [items, font, calc]);
    return renderLength;
}

function useSelectKeystrokeSearch(delay) {
    const [keys, setKeys] = React__default.useState('');
    const timer = React__default.useRef(null);
    const addKey = (key) => {
        setKeys(`${keys}${key}`);
        return `${keys}${key}`;
    };
    const dropKey = () => {
        setKeys(keys.slice(0, -1));
        return keys.slice(0, -1);
    };
    React__default.useEffect(() => {
        if (keys) {
            if (timer.current) {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(() => {
                setKeys('');
            }, delay);
        }
    }, [delay, keys]);
    return { keys, addKey, dropKey };
}

var css$D = ".Select_module_container__7c9e4617{display:inline-block;position:relative}.Select_module_buttonWrapper__7c9e4617{position:relative;white-space:nowrap}.Select_module_dropdown__7c9e4617{display:flex;flex-direction:column;max-width:400px;min-width:100%}.Select_module_rows__7c9e4617{font-weight:400;max-height:256px;overflow-x:hidden}.Select_module_baseButton__7c9e4617{position:relative;vertical-align:top;z-index:1}.Select_module_baseButton__7c9e4617:focus{z-index:3}.Select_module_baseButton__7c9e4617:hover{z-index:2}.Select_module_baseButton__7c9e4617.Select_module_withIcon__7c9e4617{border-bottom-right-radius:0;border-top-right-radius:0}.Select_module_selectButton__7c9e4617{overflow-x:hidden;width:42px}.Select_module_readOnly__7c9e4617{cursor:default;pointer-events:none}.Select_module_embeddedButton__7c9e4617{text-align:left}.Select_module_truncate__7c9e4617{overflow:hidden;white-space:nowrap}.Select_module_dropdownIcon__7c9e4617{margin-left:0;max-width:32px}.Select_module_dropdownIcon__7c9e4617 svg path{fill:#365ef6;stroke:none}.Select_module_dropdownIcon__7c9e4617.Select_module_disabled__7c9e4617 svg path{fill:#b0b4bf;stroke:none}.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617{background-color:#f5f5f7;border-color:#b0b4bf;border-radius:2px 0 0 2px;color:#444750;padding-left:8px;padding-right:0}.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617:focus,.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617:hover{border-color:#365ef6;z-index:99}.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617:active{background-color:#fff}.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617 .Select_module_buttonContents__7c9e4617{min-width:61px}.Select_module_select__7c9e4617 .Select_module_baseButton__7c9e4617[disabled]{border-color:#cbced7;color:#b0b4bf;cursor:default!important;user-select:none}.Select_module_select__7c9e4617 .Select_module_dropdownIcon__7c9e4617 svg path{fill:#444750;stroke:none}.Select_module_select__7c9e4617 .Select_module_dropdownIcon__7c9e4617.Select_module_disabled__7c9e4617 svg path,.Select_module_select__7c9e4617 .Select_module_dropdownIcon__7c9e4617.Select_module_readOnly__7c9e4617 svg path{fill:#b0b4bf;stroke:none}.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617{background-color:#fff;border-color:#b0b4bf;border-radius:0 2px 2px 0;color:#363840;font-weight:400;padding-left:8px;padding-right:0}.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617:focus,.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617:hover{border-color:#365ef6;z-index:99}.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617:active{background-color:#fff}.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617 .Select_module_buttonContents__7c9e4617{min-width:61px}.Select_module_embedded__7c9e4617 .Select_module_baseButton__7c9e4617[disabled]{border-color:#cbced7;color:#b0b4bf;cursor:default!important;user-select:none}.Select_module_embedded__7c9e4617 .Select_module_dropdownIcon__7c9e4617{width:32px}.Select_module_embedded__7c9e4617 .Select_module_dropdownIcon__7c9e4617 svg path{fill:#444750;stroke:none}.Select_module_embedded__7c9e4617 .Select_module_dropdownIcon__7c9e4617.Select_module_disabled__7c9e4617 svg path,.Select_module_embedded__7c9e4617 .Select_module_dropdownIcon__7c9e4617.Select_module_readOnly__7c9e4617 svg path{fill:#b0b4bf;stroke:none}";
window.ADS.injectStyle(css$D,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Select/Select.module.scss");
var modules_7db85bb8 = {"container":"Select_module_container__7c9e4617","buttonWrapper":"Select_module_buttonWrapper__7c9e4617","dropdown":"Select_module_dropdown__7c9e4617","rows":"Select_module_rows__7c9e4617","baseButton":"Select_module_baseButton__7c9e4617","withIcon":"Select_module_withIcon__7c9e4617","selectButton":"Select_module_selectButton__7c9e4617","readOnly":"Select_module_readOnly__7c9e4617","embeddedButton":"Select_module_embeddedButton__7c9e4617","truncate":"Select_module_truncate__7c9e4617","dropdownIcon":"Select_module_dropdownIcon__7c9e4617","disabled":"Select_module_disabled__7c9e4617","select":"Select_module_select__7c9e4617","buttonContents":"Select_module_buttonContents__7c9e4617","embedded":"Select_module_embedded__7c9e4617"};

var css$C = ".SelectDropdown_module_dropdown__1f640412{display:flex;flex-direction:column;min-width:96px}.SelectDropdown_module_selected__1f640412{box-shadow:none;font-weight:700;z-index:3}.SelectDropdown_module_active__1f640412{background-color:#e3eafc}.SelectDropdown_module_item__1f640412{border:none;color:#444750;height:32px;justify-content:left;padding:6px 8px;white-space:nowrap;z-index:1}.SelectDropdown_module_item__1f640412:hover{cursor:pointer;z-index:2}.SelectDropdown_module_item__1f640412:active{background-color:#d5e1fb}";
window.ADS.injectStyle(css$C,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Select/SelectDropdown.module.scss");
var modules_338af4fb = {"dropdown":"SelectDropdown_module_dropdown__1f640412","selected":"SelectDropdown_module_selected__1f640412","active":"SelectDropdown_module_active__1f640412","item":"SelectDropdown_module_item__1f640412"};

const cx$N = BindStyles(modules_338af4fb);
const SelectDropdown = ({ type, activeRowIndex = 0, selectedIndex = 0, onSelected, onRowHover, setInputMode, children }) => {
    const handleClick = (index) => {
        onSelected && onSelected(index);
    };
    function renderChildren() {
        return React__default.Children.map(children, (child, idx) => {
            if (React__default.isValidElement(child)) {
                return React__default.cloneElement(child, {
                    className: cx$N('item', `${type}`, { selected: selectedIndex === idx }, { active: activeRowIndex === idx }),
                    onClick: () => handleClick(idx),
                    onMouseEnter: () => onRowHover && onRowHover(idx),
                    onMouseMove: () => setInputMode && setInputMode()
                });
            }
        });
    }
    return React__default.createElement("div", { className: cx$N('dropdown') }, renderChildren());
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$M = BindStyles(modules_7db85bb8);
const changeEvent = (newSelection) => {
    return {
        target: {
            name: (newSelection === null || newSelection === void 0 ? void 0 : newSelection.text) || '',
            value: newSelection,
            isValid: true
        }
    };
};
const getValueIndex = (value, listKeys) => {
    const valueKey = listKeys.indexOf(value === null || value === void 0 ? void 0 : value.text);
    if (valueKey < 0) {
        ADSWarn('Value not found in provided list of options.');
    }
    return valueKey >= 0 ? valueKey : 0;
};
const Select = React__default.forwardRef(({ customDataProps, testId, name, className, type = SelectType.Select, width, options, value, disabled = false, readOnly, onChange, tabIndex = -1, helpers, onFocus, onBlur }, ref) => {
    const embedType = type === SelectType.Embedded;
    const [selection, setSelection] = React__default.useState(0);
    const defaultWidth = useRenderTextWidth(embedType && !width, options);
    const { addKey, dropKey } = useSelectKeystrokeSearch(500);
    const { refs, list, listKeys } = React__default.useMemo(() => {
        const refs = [];
        const list = new Map();
        options === null || options === void 0 ? void 0 : options.forEach((o) => {
            list.set(o.text, o);
            refs.push(React__default.createRef());
        });
        return { refs, list, listKeys: Array.from(list.keys()) };
    }, [options]);
    const clickable = !disabled && !readOnly;
    const listDefined = listKeys && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && refs && refs.length > 0;
    const setWidth = width
        ? { width }
        : embedType
            ? { width: defaultWidth }
            : {};
    const [inputMode, setInputMode] = React__default.useState(undefined);
    const buttonRef = React__default.useRef(null);
    const doSelection = (idx) => {
        if (embedType) {
            dropdown.setActiveRowIndex(idx);
            ScrollIntoView(refs[idx].current);
        }
        else {
            onChange && onChange(changeEvent(list.get(listKeys[idx])));
        }
    };
    const handleEnterKeypress = () => {
        if (embedType) {
            // when in embedded mode, do the value change on enter press
            onChange &&
                onChange(changeEvent(list.get(listKeys[dropdown.activeRowIndex])));
        }
        dropdown.setOpen(false);
    };
    const handleArrowKeypress = (direction) => {
        setInputMode('keyboard');
        if (list) {
            const sel = embedType ? dropdown.activeRowIndex : selection;
            if (direction < 0 && sel < -(direction - 1)) {
                if (sel !== 0) {
                    // outside of range going up, pick the first item
                    doSelection(0);
                }
            }
            else if (direction > 0 && sel + direction > list.size - 1) {
                if (sel !== list.size - 1) {
                    // outside of range going down, pick last item
                    doSelection(list.size - 1);
                }
            }
            else {
                // inside range, pick the item based on travel
                doSelection(sel + direction);
            }
        }
        else {
            // nothing was previously selected, so just pick the first
            doSelection(0);
        }
    };
    const handleLetterKeyPress = (key) => {
        setInputMode('keyboard');
        const typed = addKey(key);
        if (typed && listKeys) {
            const sel = embedType ? dropdown.activeRowIndex : selection;
            let matchKeys = [];
            // if the same character was typed multiple times - when doing this,
            // cycle through entries that start with that character.
            if (typed.length === 2 &&
                typed[typed.length - 1] === typed[typed.length - 2]) {
                dropKey();
                matchKeys = listKeys.filter((o) => o.toLowerCase().startsWith(typed.slice(0, -1).toLowerCase()));
            }
            else {
                // normal simple search behavior.
                matchKeys = listKeys.filter((o) => o.toLowerCase().startsWith(typed.toLowerCase()));
            }
            if (matchKeys.length > 0) {
                // if multiple matches were found, and the current selection is in the
                // match group, advance to the next in the match group.
                if (matchKeys.indexOf(listKeys[sel]) >= 0) {
                    doSelection(listKeys.indexOf(matchKeys[(matchKeys.indexOf(listKeys[sel]) + 1) % matchKeys.length]));
                }
                else {
                    //if the selection is not in the match group, pick the first.
                    doSelection(listKeys.indexOf(matchKeys[0]));
                }
            }
        }
    };
    const { dropdown, dropdownProps, dropdownAnchorRef } = useDropdown({
        numberOfItems: (options === null || options === void 0 ? void 0 : options.length) || 0,
        onEnterKey: () => {
            handleEnterKeypress();
        },
        onArrowUpKey: () => {
            handleArrowKeypress(-1);
        },
        onArrowDownKey: () => {
            handleArrowKeypress(1);
            if (embedType)
                dropdown.setOpen(true);
        },
        onPageUpKey: () => {
            handleArrowKeypress(-8);
        },
        onPageDownKey: () => {
            handleArrowKeypress(8);
        },
        onLetterKey: (e) => {
            dropdown.setOpen(true);
            handleLetterKeyPress(e);
        }
    });
    // handling "update value when arrow keys used to select"
    React__default.useEffect(() => {
        if (!embedType && listDefined && value) {
            const index = getValueIndex(value, listKeys);
            setSelection(index);
            if (inputMode === 'keyboard') {
                ScrollIntoView(refs[index].current);
                dropdown.setActiveRowIndex(index);
            }
        }
    }, [value, listKeys, refs, embedType, dropdown, listDefined, inputMode]);
    // handling embed mode - arrow keys "highlight", enter "selects".
    React__default.useEffect(() => {
        if (embedType && listDefined && value) {
            const index = getValueIndex(value, listKeys);
            setSelection(index);
            if (!dropdown.open) {
                setTimeout(() => {
                    ScrollIntoView(refs[index].current);
                }, 40);
            }
            if (!dropdown.open)
                dropdown.setActiveRowIndex(index);
        }
    }, [value, listKeys, refs, embedType, dropdown, listDefined]);
    React__default.useEffect(() => {
        if (!dropdown.open)
            setInputMode(undefined);
    }, [dropdown]);
    const handleSelected = (index) => {
        // create our own change event here since clicking a div isn't a "change."
        onChange && onChange(changeEvent(list.get(listKeys[index])));
        dropdown.setOpen(false);
    };
    const handleRowHover = (index) => {
        if (embedType) {
            dropdown.setActiveRowIndex(index);
        }
        else {
            // we only want to update the active row index on hover when we are in mouse mode
            // or when we are opening the dropdown for the first time and the input has not yet been set
            if (inputMode === 'mouse' || inputMode === undefined)
                dropdown.setActiveRowIndex(index);
        }
    };
    const handleMouseMove = () => {
        if (!embedType) {
            setInputMode('mouse');
        }
    };
    const handleButtonClick = () => {
        if (listKeys) {
            setTimeout(() => {
                dropdown.setActiveRowIndex(selection);
                ScrollIntoView(refs[selection].current);
            }, 40);
        }
    };
    // helpers that the parent can invoke
    const openDropdown = React__default.useCallback(() => {
        var _a;
        if (clickable)
            dropdown.toggle();
        (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (listKeys) {
            setTimeout(() => {
                dropdown.setActiveRowIndex(selection);
                ScrollIntoView(refs[selection].current);
            }, 40);
        }
    }, [clickable, dropdown, listKeys, refs, selection]);
    const isDropdownOpen = React__default.useCallback(() => {
        return dropdown.open;
    }, [dropdown]);
    React__default.useEffect(() => {
        if (helpers) {
            helpers({
                openDropdown,
                isDropdownOpen
            });
        }
    }, [helpers, isDropdownOpen, openDropdown]);
    // end helpers
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-name": name, "data-test": name + '_dropdown', className: cx$M('container', type, className), ref: MergeRefs([ref, dropdownAnchorRef]), onBlur: (event) => {
            onBlur && onBlur(event);
            dropdown.blurred(event);
        }, tabIndex: tabIndex, onFocus: onFocus }),
        React__default.createElement("div", { className: cx$M('buttonWrapper'), onClick: () => clickable && dropdown.toggle() },
            React__default.createElement(ButtonBase, { ref: buttonRef, onClick: handleButtonClick, className: cx$M('baseButton', { readOnly }), disabled: disabled, overrideMinWidth: true },
                React__default.createElement("div", { "data-test": testId, className: cx$M(`${type}Button`, { truncate: !!setWidth }), style: setWidth },
                    React__default.createElement(CellText, null, listKeys[selection])),
                React__default.createElement(Icon, { icon: "ChevronIcon", className: cx$M('dropdownIcon', { disabled }, { readOnly }), focused: dropdown.open, size: 16 }))),
        React__default.createElement(Dropdown, Object.assign({}, dropdownProps),
            React__default.createElement(DropdownContainer, null,
                React__default.createElement("div", { className: cx$M('dropdown') },
                    React__default.createElement("div", { className: cx$M('rows') },
                        React__default.createElement(SelectDropdown, { activeRowIndex: dropdown.activeRowIndex, selectedIndex: selection, onRowHover: handleRowHover, onSelected: handleSelected, setInputMode: handleMouseMove, type: type }, options &&
                            options.map((o, idx) => {
                                var _a;
                                return (React__default.createElement("div", { key: `${idx}`, "data-test": testId && `${testId}-opt-${idx}`, ref: refs[idx], tabIndex: -1 }, `${o.text} ${(_a = o.description) !== null && _a !== void 0 ? _a : ''}`.trimEnd()));
                            }))))))));
});
Select.displayName = 'Select';

var css$B = ".EmbeddedLabelSelect_module_embeddedlabel__4bff808f .EmbeddedLabelSelect_module_label__4bff808f{background-color:#f5f5f7;border:1px solid #b0b4bf;border-radius:2px 0 0 2px;border-right:0;line-height:20px;margin-bottom:0;min-width:33px;padding:5px 12px}.EmbeddedLabelSelect_module_embeddedlabel__4bff808f .EmbeddedLabelSelect_module_label__4bff808f label{color:#585c6a}.EmbeddedLabelSelect_module_embeddedlabel__4bff808f .EmbeddedLabelSelect_module_label__4bff808f.EmbeddedLabelSelect_module_disabled__4bff808f{border-color:#cbced7}.EmbeddedLabelSelect_module_embeddedlabel__4bff808f .EmbeddedLabelSelect_module_label__4bff808f.EmbeddedLabelSelect_module_disabled__4bff808f label{color:#b0b4bf}.EmbeddedLabelSelect_module_embed__4bff808f{cursor:pointer;display:flex}.EmbeddedLabelSelect_module_embed__4bff808f label{cursor:pointer}.EmbeddedLabelSelect_module_embed__4bff808f.EmbeddedLabelSelect_module_disabled__4bff808f,.EmbeddedLabelSelect_module_embed__4bff808f.EmbeddedLabelSelect_module_disabled__4bff808f label,.EmbeddedLabelSelect_module_embed__4bff808f.EmbeddedLabelSelect_module_readOnly__4bff808f,.EmbeddedLabelSelect_module_embed__4bff808f.EmbeddedLabelSelect_module_readOnly__4bff808f label{cursor:default}";
window.ADS.injectStyle(css$B,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/EmbeddedLabel/Select/EmbeddedLabelSelect.module.scss");
var modules_2aac9238 = {"embeddedlabel":"EmbeddedLabelSelect_module_embeddedlabel__4bff808f","label":"EmbeddedLabelSelect_module_label__4bff808f","disabled":"EmbeddedLabelSelect_module_disabled__4bff808f","embed":"EmbeddedLabelSelect_module_embed__4bff808f","readOnly":"EmbeddedLabelSelect_module_readOnly__4bff808f"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$L = BindStyles(modules_2aac9238);
const EmbeddedLabelSelectBase = ({ testId = 'embedded-label-select', className, text, options, value, disabled, readOnly, onChange, width }) => {
    const { t } = useTranslation();
    const helpersRef = React__default.useRef(null);
    const getHelpers = (helpers) => {
        helpersRef.current = helpers;
    };
    const isDropdownOpen = React__default.useRef(undefined);
    return (React__default.createElement("div", { "data-test": testId, className: cx$L('embeddedlabel', className) },
        React__default.createElement("div", { className: "d-flex" },
            React__default.createElement("div", { className: cx$L('embed', { disabled }, { readOnly }), onMouseDown: () => {
                    var _a, _b;
                    // check if dropdown is open at this point as onClick event it is too late in the chain.
                    isDropdownOpen.current =
                        (_b = (_a = helpersRef === null || helpersRef === void 0 ? void 0 : helpersRef.current) === null || _a === void 0 ? void 0 : _a.isDropdownOpen()) !== null && _b !== void 0 ? _b : false;
                }, onClick: () => {
                    var _a;
                    if (isDropdownOpen.current === false) {
                        (_a = helpersRef === null || helpersRef === void 0 ? void 0 : helpersRef.current) === null || _a === void 0 ? void 0 : _a.openDropdown();
                    }
                } },
                React__default.createElement(Label, { testId: `${testId}-label`, className: cx$L('label', { disabled }, { readOnly }), disabled: disabled }, text || t('VIEW')),
                React__default.createElement(Select, { testId: `${testId}-select`, type: SelectType.Embedded, options: options, value: value, onChange: onChange, disabled: disabled, readOnly: readOnly, helpers: getHelpers, width: width })))));
};
const EmbeddedLabelSelectCore = withField(EmbeddedLabelSelectBase);
// Standalone version
const UncontrolledEmbeddedLabelSelect = (props) => {
    var _a;
    const [value, setValue] = React__default.useState(((_a = props.value) === null || _a === void 0 ? void 0 : _a.text) || '');
    return (React__default.createElement(EmbeddedLabelSelectCore, Object.assign({}, props, { value: { text: value }, onChange: (e) => setValue(e.target.value) })));
};
const StandAlone = withStandAlone(UncontrolledEmbeddedLabelSelect, EmbeddedLabelSelectBase);
const EmbeddedLabelDefault = withFieldSchemaSupport$1(StandAlone, withFieldSchema(EmbeddedLabelSelectCore));
const EmbeddedLabelSelect = (props) => {
    return React__default.createElement(EmbeddedLabelDefault, Object.assign({}, props));
};
EmbeddedLabelSelect.displayName = 'EmbeddedLabelSelect';

const SearchBoxBase = ({ customDataProps, testId, name, value, onChange, placeholder, className, isLoading = false, disabled = false }) => {
    const ref = React__default.useRef(null);
    const clear = () => {
        var _a;
        onChange('');
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    const handleClearKeyDown = (e) => {
        KeyHandleMap(e, [
            {
                Enter: clear
            }
        ]);
    };
    return (React__default.createElement(TextField, { customDataProps: customDataProps, ref: ref, testId: testId, className: className, name: name, value: value, placeholder: placeholder, disabled: disabled, onChange: (e) => onChange(e.target.value), startIcon: { name: isLoading ? 'SpinnerIcon' : 'SearchIcon' }, endIcon: value
            ? {
                name: 'SmCloseIcon',
                onKeyDown: handleClearKeyDown,
                onClick: clear
            }
            : undefined }));
};
const UncontrolledSearchBox = (props) => {
    const [value, setValue] = React__default.useState(props.value || '');
    return (React__default.createElement(SearchBoxBase, Object.assign({}, props, { value: value, onChange: (v) => {
            setValue(v);
            props.onChange && props.onChange(v);
        } })));
};
const SearchBox = withStandAlone(UncontrolledSearchBox, SearchBoxBase);

/**
 * In computer science, a NOP, no-op, or NOOP (pronounced "no op";
 * short for no operation) is a machine language instruction and
 * its assembly language mnemonic, programming language statement,
 * or computer protocol command that does nothing.
 *
 * @see {@link https://en.wikipedia.org/wiki/NOP_(code)}
 */
const noop = () => { };

/* eslint-disable @typescript-eslint/no-explicit-any */
// Converts raw row data into searchable cells for searching or highlighting. DataGrid's internal
// cell rendering expects cells to be an instance of SearchableCell.  When rows are converted depends
// on who is performing the search (DataGrid or DataGridPaginated).
function createSearchableCellRow({ item, index, pageIndex, visibleColumns, parentsIndices, parentIds }) {
    if (isNil$1(item)) {
        return item;
    }
    const cells = createSearchableCells(item, index, visibleColumns);
    return {
        item,
        pageIndex,
        cells,
        parents: parentsIndices || [],
        parentIds: parentIds || []
    };
}
function createSearchableCells(item, rowIndex, visibleColumns) {
    return visibleColumns.reduce((cells, column, cellIndex) => {
        cells[`${cellIndex}`] = new SearchableCell(`${rowIndex}.${cellIndex}`, () => column.cellRenderer(item, rowIndex, cellIndex));
        return cells;
    }, {});
}
function convertToSearchableRows(rows, visibleColumns, idField = 'id', pageLevel = -1, startIndex = 0, startPageIndex = 0) {
    let fullIndex = startIndex - 1;
    let pageIndex = startPageIndex - 1;
    const searchable = rows
        ? rows.flatMap((row) => {
            var _a;
            fullIndex = fullIndex + 1;
            pageIndex = ([-1, 0].includes(pageLevel) ? 1 : 0) + pageIndex; //increment paginationIndex
            const grandparentIndex = fullIndex;
            return [
                createSearchableCellRow({
                    item: row,
                    index: fullIndex,
                    pageIndex: pageIndex,
                    visibleColumns: visibleColumns !== null && visibleColumns !== void 0 ? visibleColumns : []
                }),
                ...(row && row.children
                    ? // eslint-disable-next-line no-unsafe-optional-chaining
                        (_a = row.children) === null || _a === void 0 ? void 0 : _a.flatMap((child) => {
                            var _a;
                            fullIndex = fullIndex + 1;
                            pageIndex = ([-1, 1].includes(pageLevel) ? 1 : 0) + pageIndex;
                            const parentIndex = fullIndex;
                            return [
                                createSearchableCellRow({
                                    item: child,
                                    index: fullIndex,
                                    pageIndex: pageIndex,
                                    visibleColumns: visibleColumns !== null && visibleColumns !== void 0 ? visibleColumns : [],
                                    parentsIndices: [grandparentIndex],
                                    parentIds: [row[idField]]
                                }),
                                ...(child && child.children
                                    ? // eslint-disable-next-line no-unsafe-optional-chaining
                                        (_a = child.children) === null || _a === void 0 ? void 0 : _a.map((gchild) => {
                                            fullIndex = fullIndex + 1;
                                            pageIndex =
                                                ([-1, 2].includes(pageLevel) ? 1 : 0) + pageIndex;
                                            return createSearchableCellRow({
                                                item: gchild,
                                                index: fullIndex,
                                                pageIndex: pageIndex,
                                                visibleColumns: visibleColumns !== null && visibleColumns !== void 0 ? visibleColumns : [],
                                                parentsIndices: [grandparentIndex, parentIndex],
                                                parentIds: [row[idField], child[idField]]
                                            });
                                        })
                                    : [])
                            ];
                        })
                    : [])
            ];
        })
        : rows;
    if (searchable &&
        searchable.findIndex((r) => { var _a; return ((_a = r === null || r === void 0 ? void 0 : r.parentIds) === null || _a === void 0 ? void 0 : _a.length) > 0; }) > 0 &&
        searchable.filter((r) => { var _a; return ((_a = r === null || r === void 0 ? void 0 : r.item[idField]) !== null && _a !== void 0 ? _a : 'missing') === 'missing'; })
            .length > 0) {
        ADSWarn('ID property missing from some rows in Nested DataGrid.');
    }
    return searchable;
}
const sortRow = (rows, r, offsets, idField = 'id') => {
    var _a, _b, _c;
    if (r.parentIds && offsets) {
        const idx = rows.findIndex((c) => c.item[idField] === r.item[idField]);
        const parentId = r.parentIds[r.parentIds.length - 1];
        const parentIndex = rows.findIndex((p) => p.item[idField] === parentId);
        if (parentIndex !== idx - 1) {
            // row was not under its parent, move it into the parent spot
            offsets.set(parentId, ((_a = offsets.get(parentId)) !== null && _a !== void 0 ? _a : 0) + 1);
            rows.splice(idx, 1);
            // parent index is now wrong, recalc
            const newPIndex = rows.findIndex((p) => p.item[idField] === parentId);
            rows.splice(newPIndex + ((_b = offsets.get(parentId)) !== null && _b !== void 0 ? _b : 0), 0, r);
        }
        else {
            // row was exactly where it should have been
            offsets.set(parentId, ((_c = offsets.get(parentId)) !== null && _c !== void 0 ? _c : 0) + 1);
        }
    }
};
// reorder the rows so the parents are together with the children
// Note- this updates the passed in array.
function sortFlatNested(rows, idField = 'id') {
    const offsets = new Map();
    const children = rows.filter((r) => { var _a; return ((_a = r.parents) === null || _a === void 0 ? void 0 : _a.length) === 1; });
    const grandchildren = rows.filter((r) => { var _a; return ((_a = r.parents) === null || _a === void 0 ? void 0 : _a.length) === 2; });
    // assume everything is in the correct order per nest level.
    // sort the children rows first, then grandchildren.
    // doing it in this order means we don't need to worry about
    // moving multiple rows at the same time.
    children.forEach((c) => sortRow(rows, c, offsets, idField));
    grandchildren.forEach((c) => sortRow(rows, c, offsets, idField));
}
function getNestedVisibleRows(hasNesting, rows, virtualRange, openCloseCache) {
    var _a;
    const rowVisibleState = hasNesting && rows && rows.length > 0
        ? (_a = rows === null || rows === void 0 ? void 0 : rows.slice(virtualRange.start, virtualRange.end).map((_, idx) => {
            return openCloseCache.parentsOpen(virtualRange.start + idx);
        })) !== null && _a !== void 0 ? _a : []
        : [];
    const prevVisibleIndex = (idx) => {
        var _a;
        return ((_a = rowVisibleState === null || rowVisibleState === void 0 ? void 0 : rowVisibleState.reduce((p, n, i) => (n && i < idx ? i : p), -1)) !== null && _a !== void 0 ? _a : -1);
    };
    const nextVisibleIndex = (idx) => {
        var _a;
        return (_a = rowVisibleState === null || rowVisibleState === void 0 ? void 0 : rowVisibleState.findIndex((v, i) => i > idx && v)) !== null && _a !== void 0 ? _a : -1;
    };
    return { rowVisibleState, prevVisibleIndex, nextVisibleIndex };
}
const getNestedStyles = (idx, row, rows) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    if (!row.data || !row.data.parents) {
        return '';
    }
    let nestedStyles = '';
    if (idx.current > 0 &&
        idx.previous > -1 &&
        ((_b = (_a = row.data.parents) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) -
            ((_e = (_d = (_c = rows[idx.previous].data) === null || _c === void 0 ? void 0 : _c.parents) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0) >
            0) {
        nestedStyles = `${nestedStyles} topInset`;
    }
    if (idx.current > 0 &&
        idx.previous > -1 &&
        ((_g = (_f = row.data.parents) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) -
            ((_k = (_j = (_h = rows[idx.previous].data) === null || _h === void 0 ? void 0 : _h.parents) === null || _j === void 0 ? void 0 : _j.length) !== null && _k !== void 0 ? _k : 0) ===
            -2) {
        nestedStyles = `${nestedStyles} topBorderDouble`;
    }
    else if (idx.current > 0 &&
        idx.previous > -1 &&
        ((_m = (_l = row.data.parents) === null || _l === void 0 ? void 0 : _l.length) !== null && _m !== void 0 ? _m : 0) -
            ((_q = (_p = (_o = rows[idx.previous].data) === null || _o === void 0 ? void 0 : _o.parents) === null || _p === void 0 ? void 0 : _p.length) !== null && _q !== void 0 ? _q : 0) <
            0) {
        nestedStyles = `${nestedStyles} topBorder`;
    }
    if (idx.current < rows.length - 1 &&
        idx.next > -1 &&
        ((_s = (_r = row.data.parents) === null || _r === void 0 ? void 0 : _r.length) !== null && _s !== void 0 ? _s : 0) -
            ((_v = (_u = (_t = rows[idx.next].data) === null || _t === void 0 ? void 0 : _t.parents) === null || _u === void 0 ? void 0 : _u.length) !== null && _v !== void 0 ? _v : 0) >
            0) {
        nestedStyles = `${nestedStyles} botInset`;
    }
    return nestedStyles;
};
/**
 * Added in DX-338 to wrap utilities related to the
 * {@link RowId} type used in the data-grid components.
 */
const RowIdUtils = {
    getId: function getId(row, rowIdField, fallbackTo = 'id-then-negative') {
        return match(fallbackTo)
            .with('none', () => { var _a; return (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item[rowIdField]; })
            .with('id', () => { var _a, _b, _c; return (_b = (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item[rowIdField]) !== null && _b !== void 0 ? _b : (_c = row === null || row === void 0 ? void 0 : row.data) === null || _c === void 0 ? void 0 : _c.item.id; })
            .with('id-then-negative', () => { var _a, _b, _c, _d; return (_d = (_b = (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item[rowIdField]) !== null && _b !== void 0 ? _b : (_c = row === null || row === void 0 ? void 0 : row.data) === null || _c === void 0 ? void 0 : _c.item.id) !== null && _d !== void 0 ? _d : -1; })
            .exhaustive();
    }
};
const RowsUtils = {
    allRowsAppearLoading: function allRowsAppearLoading(rows) {
        if (rows === undefined)
            return false;
        if (rows.length === 0)
            return false;
        return rows.every((row) => {
            var _a;
            const item = (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item;
            return item === undefined || item === null;
        });
    },
    anyRowsAppearLoading: function anyRowsAppearLoading(rows) {
        if (rows === undefined)
            return true;
        if (rows.length === 0)
            return true;
        return rows.some((row) => {
            var _a;
            const item = (_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item;
            return item === undefined || item === null;
        });
    }
};

const Message = {
    rowsAndIdsNoncorrespondent: function (ids, rows) {
        return `The number of row IDs (${ids}) do not correspond to the number of rows (${rows}). Ensure all rows have a properly set, unique ID. Once unique IDs are asserted, please report this to the ADS maintainers if the issue persists.`;
    },
    internalRowCalculationsWrong: function (ids, rows) {
        return `There was an internal error while enabling conditionable row actions for data-grid rows. Mismatch: ${ids} IDs & ${rows} rows. Ensure all rows have a properly set, unique ID. Once unique IDs are asserted, please report this to the ADS maintainers if the issue persists.`;
    },
    visibilitiesNotFoundForVisibilityFunctionId: function (visibilityFnId, rowId) {
        return `The "${visibilityFnId}" visibility-function visibilities were not found for row, ${rowId}, where they must be found for the conditional-row-actions feature. Please report this to the ADS maintainers.`;
    },
    visibilitiesNotFoundForRowId: function (rowId) {
        return `The "${rowId}" row visibilities were not found where they must be found for the conditional-row-actions feature. Please report this to the ADS maintainers.`;
    }
};
/**
 * Calculates [per row] [per conditional action] the visibility of that action.
 *
 * This function does not transform the row-actions configuration by
 * replacing conditional visibilities with their calculations.
 *
 * Instead, these calculations are stored in the
 * {@link ConditionalRowActionsState}, which is returned and used per
 * row later, where such effort can easily be memoized per row.
 *
 * Doing such calculations at this level would require the
 * {@link actionsConfig} to be transformed and mapped not once, but for every
 * row, which is already being done within the `RowActionsButton` component,
 * which is likely more maintainable and allows for the easier use of hooks per
 * each row.
 *
 * The downside to this function is, by using a reducer,
 * {@link useStateReducer}, the state will not be updated until the next render
 * due to how dispatching works in React. This divergence is noted; but it has
 * not caused any known issue. However, this reducer is mainly needed due to the
 * open-close cache, which itself does not cause any re-renders. So this is the
 * best we can do at this time given the imperative, non-reactive nature of
 * some of the data-grid code.
 *
 * @param actionsConfig
 * @param actionableRowIds Must correspond 1:1 with `actionableRows`
 * @param actionableRows Must correspond 1:1 with `actionableRowIds`
 * @param rowIdField
 * @param rowsLastChanged The unix timestamp when the visible rows in the grid changed.
 * @param dataGridIsPaginated
 * @returns
 */
function useConditionalRowActionsState(actionsConfig, actionableRowIds, actionableRows, rowIdField, rowsLastChanged, dataGridAppearsLoading, dataGridIsPaginated, showConditionableRowActionsConsoleLogs) {
    // Debugging
    // console.log('actionsConfig:', actionsConfig);
    // console.log('actionableRowIds:', actionableRowIds?.length ?? 'none');
    // console.log('actionableRows:', actionableRows?.length ?? 'none');
    // console.log('rowIdField:', rowIdField);
    // console.log('rowsLastChanged:', rowsLastChanged);
    const [state, actions] = useStateReducer();
    const actionsRef = React__default.useRef(actions);
    actionsRef.current = actions;
    //#region Referential Equality Changes
    // Referential Equality Changes
    const actionsConfigChangedRef = React__default.useRef(false);
    const rowsChangedRef = React__default.useRef(false);
    // reset our ledger each render
    React__default.useEffect(() => {
        actionsConfigChangedRef.current = false;
        rowsChangedRef.current = false;
    });
    React__default.useEffect(() => {
        // Debugging
        // console.log('actions changed');
        actionsConfigChangedRef.current = true;
    }, [actionsConfig]);
    React__default.useEffect(() => {
        // Debugging
        // console.log('rows changed');
        rowsChangedRef.current = true;
    }, [rowsLastChanged]);
    React__default.useEffect(() => {
        // Debugging
        // console.log('actions changed:', actionsConfigChangedRef.current);
        // console.log('rows changed:', rowsChangedRef.current);
        match([actionsConfigChangedRef.current, rowsChangedRef.current])
            .with([true, true], actionsRef.current.resetBothMaps)
            .with([true, false], actionsRef.current.resetBothMaps)
            .with([false, true], actionsRef.current.resetVisibilityCalculationsMap)
            .with([false, false], noop)
            .exhaustive();
    }, [actionsConfig, rowsLastChanged]);
    //#endregion Referential Equality Changes
    //#region Calculating Row-Action Visibilities
    /**
     * Calculated Row IDs
     * Row IDs that have already been calculated; and, therefore, are cache hits in our maps.
     */
    const calculatedRowIdsRef = React__default.useRef(new Set());
    React__default.useEffect(() => {
        // Debugging
        // console.log('reset calculated-row-IDs cache');
        /**
         * Here, we clear the cache of row IDs that have been calculated.
         *
         * To avoid doing this in the future, we will need to have a better
         * mechanism to signify when rows or row actions have changed meaningfully.
         * By relying on referential equality, we are forced to clear the cache
         * with each inequality.
         */
        calculatedRowIdsRef.current = new Set([]);
    }, [actionsConfig, rowsLastChanged]);
    // to avoid being dependency-array elements of React.useEffect
    const effectRef = React__default.useRef({
        actionsConfig,
        rowIdField,
        showConditionableRowActionsConsoleLogs,
        state
    });
    React__default.useEffect(() => {
        effectRef.current = {
            actionsConfig,
            rowIdField,
            showConditionableRowActionsConsoleLogs,
            state
        };
    });
    React__default.useEffect(() => {
        var _a, _b, _c;
        /**
         * Inapplicable Case(Appears Loading): When the data grid appears loading with
         * skeleton-placeholder rows, there are no rows, nor row IDs.
         *
         * Therefore, bail out of this effect.
         */
        if (dataGridAppearsLoading) {
            if (effectRef.current.state.type !== 'none') {
                actionsRef.current.noState();
            }
            return;
        }
        /**
         * Inapplicable Case(Data Grid Paginated): Data grids with pagination *cannot have*
         * conditional row actions as well.
         *
         * This case is different than the ones below in that it *could* work in
         * the future; but, currently, it does not.
         *
         * Conditionally visible actions require the row's data to invoke a
         * visibility function. However, `useDataSource` only includes the row IDs
         * for all rows of paginated data grids while the data of these rows is
         * partially available, based on the current scroll position.
         */
        if (dataGridIsPaginated) {
            if (effectRef.current.state.type !== 'none') {
                actionsRef.current.noState();
            }
            return;
        }
        // Inapplicable Cases(Configuration Type): we do not have conditional row actions in these states
        if (effectRef.current.actionsConfig.type === 'feature-disabled' ||
            effectRef.current.actionsConfig.type === 'no-actions' ||
            effectRef.current.actionsConfig.type === 'multi-action' ||
            effectRef.current.actionsConfig.type === 'single-action' ||
            effectRef.current.actionsConfig.type === 'multi-action-context-menu') {
            if (effectRef.current.state.type !== 'none') {
                actionsRef.current.noState();
            }
            return;
        }
        if ((actionableRowIds === null || actionableRowIds === void 0 ? void 0 : actionableRowIds.length) === undefined || actionableRowIds.length < 1) {
            return;
        }
        /**
         * error case: As called out in the TSDoc for this hook, there must be a 1:1
         * correspondence between the actionable row IDs and the actionable rows.
         *
         * If this is not the case, the algorithm is failing.
         *
         * We log an ADS error and bail.
         */
        if (actionableRowIds.length !== (actionableRows === null || actionableRows === void 0 ? void 0 : actionableRows.length)) {
            if (effectRef.current.showConditionableRowActionsConsoleLogs) {
                ADSError(Message.rowsAndIdsNoncorrespondent(actionableRowIds.length, (_a = actionableRows === null || actionableRows === void 0 ? void 0 : actionableRows.length) !== null && _a !== void 0 ? _a : 0));
            }
            return;
        }
        const incomingRowIds = new Set(actionableRowIds);
        // 💀 dangerous code: see Issue: "Set Shims" in issues.mdx
        const uncalculatedRowIds = difference(incomingRowIds, calculatedRowIdsRef.current);
        const uncalculatedRows = actionableRows === null || actionableRows === void 0 ? void 0 : actionableRows.filter((row) => uncalculatedRowIds.has(RowIdUtils.getId(row, effectRef.current.rowIdField)));
        const haveRowsToCalculate = uncalculatedRows !== undefined && uncalculatedRows.length > 0;
        // Debugging
        // console.log(
        //   'Calculation Status:',
        //   uncalculatedRows === undefined || uncalculatedRows.length <= 0
        //     ? 'No new rows that are uncalculated.'
        //     : 'Some new row(s) need calculated.',
        //   '\n\t\t'
        // );
        const rowsToCalculateFoundForEachRowId = ((_b = uncalculatedRows === null || uncalculatedRows === void 0 ? void 0 : uncalculatedRows.length) !== null && _b !== void 0 ? _b : 0) === uncalculatedRowIds.size;
        // error case: The algorithm would be failing if we cannot find a row's data for each ID.
        if (!rowsToCalculateFoundForEachRowId) {
            if (effectRef.current.showConditionableRowActionsConsoleLogs &&
                (actionableRows === null || actionableRows === void 0 ? void 0 : actionableRows.some((row) => { var _a; return ((_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a.item) !== undefined; }))) {
                ADSError(Message.internalRowCalculationsWrong(uncalculatedRowIds.size, (_c = uncalculatedRows === null || uncalculatedRows === void 0 ? void 0 : uncalculatedRows.length) !== null && _c !== void 0 ? _c : 0));
            }
            return;
        }
        if (haveRowsToCalculate && rowsToCalculateFoundForEachRowId) {
            // Debugging
            // console.log('cached calculations', calculatedRowIdsRef.current.size);
            // console.log('incoming calculation requests', incomingRowIds.size);
            // console.log('net-new calculations needed', uncalculatedRowIds.size);
            // console.log('\n');
            match(effectRef.current.actionsConfig)
                .with({ type: 'multi-action-conditionable' }, (actionsConfig) => void actionsRef.current.multiAction_conditionable(uncalculatedRows, actionsConfig, effectRef.current.rowIdField))
                .with({ type: 'single-action-conditionable' }, (actionsConfig) => void actionsRef.current.singleAction_conditionable(uncalculatedRows, actionsConfig, effectRef.current.rowIdField))
                .exhaustive();
        }
        if (haveRowsToCalculate) {
            // Think of this as "incrementing" our set of IDs of calculated rows.
            // ⚓ Keep this assignment after any uses of this reference within the effect.
            calculatedRowIdsRef.current = union(uncalculatedRowIds, calculatedRowIdsRef.current); // 💀 dangerous code: see Issue: "Set Shims" in issues.mdx
        }
    }, [
        /*
         * As of DX-338 (Q2 2024), `actionableRowIds` & `actionableRows` are always new
         * arrays in `DataGridBase`; but this is future proofing if memoized.
         */
        actionableRowIds,
        actionableRows,
        dataGridAppearsLoading,
        dataGridIsPaginated
    ]);
    //#endregion Calculating Row-Action Visibilities
    // Debugging
    // console.log(
    //   'State:',
    //   React.useMemo<string>(
    //     () =>
    //       match(state)
    //         .returnType<string>()
    //         .with({ type: 'none' }, () => 'No state')
    //         .with(
    //           { type: 'some' },
    //           (some) =>
    //             `Conditional Actions: ${
    //               some.value.sets.conditionalActions?.size ?? 0
    //             }\nRows Calculated: ${
    //               some.value.sets.rowsCalculated?.size ?? 0
    //             }\nActionable Rows: ${actionableRowIds?.length}`
    //         )
    //         .exhaustive(),
    //     [state, actionableRowIds?.length]
    //   )
    // );
    // console.log('row-actions-configuration type:', actionsConfig.type);
    // console.log('\n');
    return state;
}
/**
 * Traverses to find all conditional action visibilities
 *
 * @param actions
 * @param visibilityFnMap - side effect: this map is mutated
 * @param conditionalActions - sideEffect: this set is mutated
 * @returns
 */
function traverseForVisibilityFunctions(actions, visibilityFnMap, conditionalActions) {
    var _a;
    // the actions we're currently looking at to filter, etc.
    let currentActions = actions;
    while (currentActions.length > 0) {
        currentActions
            .map((action) => match(action)
            .with({ visibilityConfig: { type: 'conditional' } }, (action) => action.visibilityConfig)
            .otherwise(() => null))
            .forEach(
        // only add conditional visibilities
        (conditionalVisibility) => {
            if (conditionalVisibility === null)
                return;
            visibilityFnMap.set(conditionalVisibility.id, conditionalVisibility.fn);
            conditionalActions.add(conditionalVisibility.id);
        });
        const nextLayer = (_a = currentActions.flatMap((action) => {
            return match(action)
                .returnType()
                .with({ type: 'nestable' }, (action) => { var _a, _b; return (_b = (_a = action.submenu) === null || _a === void 0 ? void 0 : _a.actions) !== null && _b !== void 0 ? _b : []; })
                .with({ type: 'with-submenu' }, (action) => action.submenu.actions)
                .with({ type: 'default' }, () => [])
                .with({ type: 'non-nested' }, () => [])
                .with({ type: P.optional(undefined) }, () => []) // actions not nested by default
                .exhaustive();
        })) !== null && _a !== void 0 ? _a : [];
        currentActions = nextLayer;
    }
    return visibilityFnMap;
}
/**
 * Per row, per (conditionally visible) action, calculate the visibility.
 *
 * @param actionableRows
 * @param rowIdField
 * @param visibilityFnMap
 * @param visibilityCalculations - side effect: this map is mutated
 * @param rowsCalculated - side effect: this set is mutated
 * @returns
 */
function calculateVisibilities(actionableRows, rowIdField, visibilityFnMap, visibilityCalculations, rowsCalculated) {
    // set per-action map
    visibilityFnMap.forEach((fn, visibilityFnId) => {
        let actionVisibilities = visibilityCalculations.get(visibilityFnId);
        // case: visibilities are not found (not created yet)
        if (actionVisibilities === undefined) {
            actionVisibilities = {
                bulk: StateUtilities.createNewBulkRowVisibilities(),
                single: StateUtilities.createNewSingleRowVisibilities()
            };
            visibilityCalculations.set(visibilityFnId, actionVisibilities);
        }
        const assertedVisibilities = actionVisibilities;
        actionableRows.forEach((row) => {
            var _a;
            const rowId = RowIdUtils.getId(row, rowIdField);
            const visibilityConfig = fn((_a = row.data) === null || _a === void 0 ? void 0 : _a.item);
            // mutates `actionVisibilities`
            StateUtilities.updatedVisibilities('bulk', rowId, assertedVisibilities.bulk, visibilityConfig);
            // mutates `actionVisibilities`
            StateUtilities.updatedVisibilities('singleItem', rowId, assertedVisibilities.single, visibilityConfig);
            rowsCalculated.add(rowId);
        });
    });
    // return mutated state
    return visibilityCalculations;
}
/**
 * Returns a new state object with a new payload object within it.
 * @param actionableRows
 * @param rowActionsConfig
 * @param rowIdField
 * @param cachedMaps
 * @param cachedSets
 * @returns
 */
function calculateForMultipleActions(actionableRows, rowActionsConfig, rowIdField, cachedMaps, cachedSets) {
    const visibilityFunctions = traverseForVisibilityFunctions(rowActionsConfig.actions, cachedMaps.visibilityFunctions, cachedSets.conditionalActions);
    const visibilityCalculations = calculateVisibilities(actionableRows, rowIdField, visibilityFunctions, cachedMaps.visibilityCalculations, cachedSets.rowsCalculated);
    return OptionUtils.some({
        maps: {
            visibilityFunctions,
            visibilityCalculations
        },
        // these sets have been mutated in place
        sets: cachedSets
    });
}
/**
 * Returns a new state object with a new payload object within it.
 * @param actionableRows
 * @param rowActionsConfig
 * @param rowIdField
 * @param cachedMaps
 * @param cachedSets
 * @returns
 */
function calculateForSingleAction(actionableRows, rowActionsConfig, rowIdField, cachedMaps, cachedSets) {
    const visibilityFunctions = traverseForVisibilityFunctions([rowActionsConfig.action], cachedMaps.visibilityFunctions, cachedSets.conditionalActions);
    const visibilityCalculations = calculateVisibilities(actionableRows, rowIdField, cachedMaps.visibilityFunctions, cachedMaps.visibilityCalculations, cachedSets.rowsCalculated);
    return OptionUtils.some({
        maps: { visibilityFunctions, visibilityCalculations },
        // these sets have been mutated in place
        sets: cachedSets
    });
}
const StateUtilities = {
    createNewMaps: () => ({
        visibilityFunctions: new Map(),
        visibilityCalculations: new Map()
    }),
    createNewVisibilityFunctionsMap: () => new Map(),
    createNewSets: () => ({
        conditionalActions: new Set(),
        rowsCalculated: new Set()
    }),
    createNewRowsCalculatedSet: () => new Set(),
    createNewBulkRowVisibilities: () => ({
        enabled: new Set(),
        disabled: new Set(),
        hidden: new Set()
    }),
    createNewSingleRowVisibilities: () => ({
        enabled: new Set(),
        disabled: new Set(),
        hidden: new Set()
    }),
    /** Mutates state: visibilitiesSet */
    updatedVisibilities: (forMenu, rowId, visibilitiesSet, visibilityConfig) => {
        match(visibilityConfig[forMenu])
            .returnType()
            .with('enabled', () => void visibilitiesSet.enabled.add(rowId))
            .with('disabled', () => void visibilitiesSet.disabled.add(rowId))
            .with('hidden', () => void visibilitiesSet.hidden.add(rowId))
            .exhaustive();
    },
    getVisibilityForRow(visibilities, forMenu, rowId) {
        // Debugging
        // if (forMenu === 'bulk') {
        // if (forMenu === 'single') {
        //   console.log(
        //     'forMenu:',
        //     forMenu,
        //     '\n\t',
        //     'enabled:',
        //     visibilities[forMenu].enabled.has(rowId),
        //     '\n\t',
        //     'disabled:',
        //     visibilities[forMenu].disabled.has(rowId),
        //     '\n\t',
        //     'hidden:',
        //     visibilities[forMenu].hidden.has(rowId)
        //   );
        // }
        if (visibilities[forMenu].enabled.has(rowId))
            return 'enabled';
        if (visibilities[forMenu].disabled.has(rowId))
            return 'disabled';
        if (visibilities[forMenu].hidden.has(rowId))
            return 'hidden';
        // Debugging
        // ADSError(ErrorStrings.visibilitiesNotFoundForRowId(rowId));
        /**
         * undesirable case: Stale state - brought on by two factors:
         * 1) After searching and then *clearing* that search, our rows will
         *    change, but our state will lag behind until the next render due to
         *    our use of a reducer in {@link useConditionalRowActionsState}.
         *
         * 2) By using three sets for enabled, disabled, and hidden, we are exposed
         *    to this case where the row is not found in any of the sets.
         *
         * @see{@link useConditionalRowActionsState} for further documentation.
         *
         * This issue is only known to happen when we have a search that
         * is then cleared. For one render, the rows will have changed but the
         * {@link ConditionalRowActionsState} state will reflect the previous
         * state. However, this is not a problem as React batches renders and
         * the DOM will reflect the correct state in its next update as another
         * render is queued with no discrepancies between the
         * {@link ConditionalRowActionsState} state and the rows.
         */
        return 'hidden';
    },
    getVisibilityForActionAndRow(visibilityCalculations, forMenu, actionVisibilityFnId, rowId) {
        const visibilities = visibilityCalculations.get(actionVisibilityFnId);
        // error case: unexpected to occur, but sets and maps offer no type safety
        if (visibilities === undefined) {
            ADSError(Message.visibilitiesNotFoundForVisibilityFunctionId(actionVisibilityFnId, rowId));
            return 'hidden';
        }
        return StateUtilities.getVisibilityForRow(visibilities, forMenu, rowId);
    }
};
const ConditionalRowActionStateUtilities = {
    createBulkVisibilitiesSets: StateUtilities.createNewBulkRowVisibilities,
    getVisibilityForRow: StateUtilities.getVisibilityForRow,
    getVisibilityForActionAndRow: StateUtilities.getVisibilityForActionAndRow
};
//#endregion State Types & Utilities
//#region State Hook
/**
 * @see {@link https://react.dev/reference/react/useReducer#ive-dispatched-an-action-but-the-screen-doesnt-update}
 * React will skip re-rendering if the reducer's new state is
 * equal (via Object.is) to the previous state.
 */
function reducer(previous, action) {
    // Debugging
    // console.log('Action:\n\t', action.type);
    return match(action)
        .returnType()
        .with({ type: 'calculate-for-multiple-actions' }, (action) => {
        var _a;
        const { maps, sets } = (_a = OptionUtils.value(previous, null)) !== null && _a !== void 0 ? _a : {
            maps: StateUtilities.createNewMaps(),
            sets: StateUtilities.createNewSets()
        };
        // creates a new object to break referential equality
        return calculateForMultipleActions(action.actionableRows, action.rowActionsConfig, action.rowIdField, maps, sets);
    })
        .with({ type: 'calculate-for-single-action' }, (action) => {
        var _a;
        const { maps, sets } = (_a = OptionUtils.value(previous, null)) !== null && _a !== void 0 ? _a : {
            maps: StateUtilities.createNewMaps(),
            sets: StateUtilities.createNewSets()
        };
        // creates a new object to break referential equality
        return calculateForSingleAction(action.actionableRows, action.rowActionsConfig, action.rowIdField, maps, sets);
    })
        .with({ type: 'no-state' }, () => None)
        .with({ type: 'reset-visibility-calculations-map' }, () => {
        // case: inapplicable
        if (previous.type === 'none') {
            return previous;
        }
        // clearing is more performant than creating a new map or set
        previous.value.maps.visibilityCalculations.clear();
        previous.value.sets.rowsCalculated.clear();
        // create a new object to break referential equality
        return Object.assign(Object.assign({}, previous), { value: Object.assign({}, previous.value) });
    })
        .with({ type: 'reset-both-maps' }, () => {
        // case: inapplicable
        if (previous.type === 'none') {
            return previous;
        }
        // clearing is more performant than creating a new map or set
        // - pertaining to the visibility functions found on conditional actions:
        previous.value.maps.visibilityFunctions.clear();
        previous.value.sets.conditionalActions.clear();
        // - pertaining to the calculated visibilities for each pair of actionable rows and conditional actions:
        previous.value.maps.visibilityCalculations.clear();
        previous.value.sets.rowsCalculated.clear();
        // create a new object to break referential equality
        return Object.assign(Object.assign({}, previous), { value: Object.assign({}, previous.value) });
    })
        .exhaustive();
}
const REDUCER_INITIAL_STATE = None;
function useStateReducer() {
    const [state, dispatch] = React__default.useReducer(reducer, REDUCER_INITIAL_STATE);
    const actionsRef = React__default.useRef({
        noState: () => void dispatch({ type: 'no-state' }),
        resetBothMaps: () => void dispatch({ type: 'reset-both-maps' }),
        resetVisibilityCalculationsMap: () => void dispatch({ type: 'reset-visibility-calculations-map' }),
        multiAction_conditionable: (actionableRows, rowActionsConfig, rowIdField) => void dispatch({
            type: 'calculate-for-multiple-actions',
            actionableRows,
            rowActionsConfig,
            rowIdField
        }),
        singleAction_conditionable: (actionableRows, rowActionsConfig, rowIdField) => void dispatch({
            type: 'calculate-for-single-action',
            actionableRows,
            rowActionsConfig,
            rowIdField
        })
    });
    return [state, actionsRef.current];
}
//#endregion State Hook

/**
 * A development-only utility component that displays the current state of the
 * conditional row actions.
 */
function ConditionalRowActionsFooter({ conditionalRowActionsState, bulkActionIds }) {
    const handleButtonClick = React__default.useCallback(() => {
        if (conditionalRowActionsState.type === 'none') {
            console.log('No state');
            return;
        }
        const allRowIds = Array.from(conditionalRowActionsState.value.sets.rowsCalculated);
        const sortedStringRowIds = allRowIds
            .filter((id) => typeof id === 'string')
            .sort();
        const sortedNumericRowIds = allRowIds
            .filter((id) => typeof id === 'number')
            .sort(function (a, b) {
            return Number(a) - Number(b);
        })
            .map(String);
        const sortedRowIds = sortedStringRowIds.concat(sortedNumericRowIds);
        let output = '';
        const longestActionVisibilityFunctionId = Array.from(conditionalRowActionsState.value.maps.visibilityCalculations.keys()).reduce((longest, visibilityFnId) => {
            return visibilityFnId.toString().length > longest
                ? visibilityFnId.toString().length
                : longest;
        }, 0);
        sortedRowIds.forEach((rowId) => {
            output += `Row ${rowId}:\n`;
            conditionalRowActionsState.value.maps.visibilityCalculations.forEach((visibilities, actionId) => {
                const [single, bulk] = [
                    ConditionalRowActionStateUtilities.getVisibilityForRow(visibilities, 'single', rowId),
                    ConditionalRowActionStateUtilities.getVisibilityForRow(visibilities, 'bulk', rowId)
                ];
                output += `\t${(actionId + ':').padEnd(longestActionVisibilityFunctionId + 2 /* looks nicely */, ' ')} single - ${single.padEnd(8, ' ')} bulk - ${bulk.padEnd(8, ' ')}\n`;
            });
        });
        console.log(output || 'Empty state: Either no conditional actions or no checked rows.');
    }, [conditionalRowActionsState]);
    return (React__default.createElement(Card, null,
        React__default.createElement("h2", null, "Conditional Row Actions"),
        React__default.createElement("br", null),
        React__default.createElement(OnScreenSummary, { bulkActionIds: bulkActionIds, conditionalRowActionsState: conditionalRowActionsState }),
        React__default.createElement("br", null),
        React__default.createElement(Button, { type: "primary", onClick: handleButtonClick }, "Log State to Console")));
}
function OnScreenSummary({ bulkActionIds, conditionalRowActionsState }) {
    return match(conditionalRowActionsState)
        .with({ type: 'none' }, () => React__default.createElement("p", null, "No state"))
        .with({ type: 'some' }, (some) => {
        var _a;
        return (React__default.createElement("div", null,
            "Bulk-Actionable Rows: ", (_a = bulkActionIds === null || bulkActionIds === void 0 ? void 0 : bulkActionIds.length) !== null && _a !== void 0 ? _a : 0,
            React__default.createElement("br", null),
            "Conditional Actions: ",
            some.value.sets.conditionalActions.size,
            React__default.createElement("br", null),
            "Conditional Row Visibilities Calculated:",
            ' ',
            some.value.sets.rowsCalculated.size));
    })
        .exhaustive();
}

function useRACWidthConfig() {
    const [actionsColumnWidth, setActionsColumnWidth] = React__default.useState('40px');
    const updateWidth = React__default.useCallback((width) => {
        setActionsColumnWidth(`${width}px`);
    }, []);
    return [actionsColumnWidth, updateWidth];
}

const CONSTANTS$1 = {
    'default-generation': 'parent',
    'minimum-rows-for-bulk-action': 2
};

/**
 * If enabled, returns everything other than some helper-utility functions and
 * the mode property, which is calculated *per row*.
 *
 * If disabled, forwards the disabled config.
 *
 * Checks for error states, logging them to the console.
 */
function useSharedInternalRowActionsConfig(conditionalState, config, dataGridIsPaginated, updateWidth) {
    //#region Runtime checks to ensure correct usage of the row-actions feature.
    const rowActionsAreConditionable = config.type === 'single-action-conditionable' ||
        config.type === 'multi-action-conditionable';
    useADSErrorOnce('Data-Grid Misconfiguration: Paginated data grids cannot also enable conditionally visible row actions. Please read the documentation.', dataGridIsPaginated && rowActionsAreConditionable);
    //#endregion Runtime checks to ensure correct usage of the row-actions feature.
    return React__default.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (config.type === 'feature-disabled') {
            return config;
        }
        if (config.type === 'multi-action-context-menu') {
            return config;
        }
        switch (config.type) {
            case 'no-actions': {
                return Object.assign(Object.assign({}, config), { buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { generation: (_a = config.buttonConfig.generation) !== null && _a !== void 0 ? _a : CONSTANTS$1['default-generation'], updateWidth: updateWidth }) });
            }
            // file deepcode ignore DuplicateCaseBody: more maintainable to keep the cases separate
            case 'single-action': {
                return Object.assign(Object.assign({}, config), { buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { generation: (_b = config.buttonConfig.generation) !== null && _b !== void 0 ? _b : CONSTANTS$1['default-generation'], updateWidth: updateWidth }) });
            }
            case 'single-action-conditionable': {
                if (conditionalState.type === 'none') {
                    return Object.assign(Object.assign({}, config), { type: 'no-actions', buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { enabled: false, generation: (_c = config.buttonConfig.generation) !== null && _c !== void 0 ? _c : CONSTANTS$1['default-generation'], updateWidth: updateWidth }) });
                }
                return Object.assign(Object.assign({}, config), { buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { generation: (_d = config.buttonConfig.generation) !== null && _d !== void 0 ? _d : CONSTANTS$1['default-generation'], updateWidth: updateWidth }), conditionalActionsVisibilitiesMetadata: conditionalState.value });
            }
            case 'multi-action': {
                return Object.assign(Object.assign({}, config), { buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { generation: (_e = config.buttonConfig.generation) !== null && _e !== void 0 ? _e : CONSTANTS$1['default-generation'], updateWidth: updateWidth }) });
            }
            case 'multi-action-conditionable': {
                if (conditionalState.type === 'none') {
                    return Object.assign(Object.assign({}, config), { type: 'no-actions', buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { enabled: false, generation: (_f = config.buttonConfig.generation) !== null && _f !== void 0 ? _f : CONSTANTS$1['default-generation'], updateWidth: updateWidth }) });
                }
                return Object.assign(Object.assign({}, config), { buttonConfig: Object.assign(Object.assign({}, config.buttonConfig), { generation: (_g = config.buttonConfig.generation) !== null && _g !== void 0 ? _g : CONSTANTS$1['default-generation'], updateWidth: updateWidth }), conditionalActionsVisibilitiesMetadata: conditionalState.value });
            }
        }
    }, [conditionalState, config, updateWidth]);
}

const DEFAULTS$2 = {
    contextMenuEnabled: false
};
/**
 * Builds the context menu metadata for a row based on the currently visible index and the last visible index.
 *
 * @remarks - "How does this work with both non-paginated & paginated grids?"
 *
 * Applies to **both paginated and non-paginated grids**:
 *   - As the user scrolls up and down, more rows will be added to the top and
 *     bottom.
 *   - Handled by {@link useVariableVirtualList}.
 *   - Only once the "actual" top and bottom are reached, the current {@link index} will
 *     be at the top or bottom.
 *
 * Applies to **just paginated grids**:
 *   - Edge Case Covered: If the rows never load, the row will remain a "skeleton"
 *                        placeholder row, which cannot accept a row-actions context-menu
 *                        click.
 *
 *
 * The {@link useVariableVirtualList} has the concept of "buffer" rows before and after
 * the actual rows, so these "buffers" are only exhausted once the starting or ending bounds are reached.
 *
 * @param index - The index of the currently rendered row.
 * @param lastIndex - The index of the last rendered row.
 * @param maybeDataGridScrollPosition - The current scroll position of the data grid
 * unless there is no scroll bar.
 * @returns
 */
function buildContextMenuMetadata(index, lastIndex, maybeDataGridScrollPosition) {
    return {
        /*
         * Should work for both paginated and non-paginated grids:
         * - If paginated, will add "skeleton" loading rows on top until the true top is reached.
         * - If non-paginated, will add previous rows until the true top is reached.
         */
        isCurrentRowFirst: index === 0,
        /*
         * Should work for both paginated and non-paginated grids:
         * - If paginated, will have "skeleton" loading rows on bottom until the true bottom is reached.
         * - If non-paginated, will add next rows until the true bottom is reached.
         */
        isCurrentRowLast: index === lastIndex,
        showingTopOfGrid: 
        // if no scroll bar, then, yes, always shows top
        OptionUtils.value(maybeDataGridScrollPosition, 'top') === 'top',
        showingBottomOfGrid: 
        // if no scroll bar, then, yes, always shows bottom
        OptionUtils.value(maybeDataGridScrollPosition, 'bottom') === 'bottom'
    };
}
/**
 * Sometimes a specific row's button might be rendered as disabled when the overall
 * row-actions feature is enabled.
 *
 * @param config
 * @param rowData
 * @returns
 */
function checkButtonRendererForDisablement(config, rowData) {
    // short circuit: this row is always disabled if all rows are disabled
    if (config.type === 'no-actions') {
        return [true, config.buttonConfig.disabledTooltip];
    }
    // short circuit: this type never has a row-actions button, so a button renderer
    // does not affect enablement and tooltips are irrelevant
    if (config.type === 'multi-action-context-menu') {
        return [false, undefined];
    }
    const { buttonConfig } = config;
    // case: enabled without a `renderer`
    // -> definitely enabled
    if (!buttonConfig.renderer) {
        return [false, undefined];
    }
    // short circuit: the row has no data
    if (!rowData.item) {
        return [true, undefined];
    }
    // case: enabled with a `renderer`
    // -> unknown enablement: depends on the `renderer`
    const renderResult = buttonConfig.renderer(rowData.item);
    const tooltip = renderResult.disabled && !renderResult.hidden
        ? renderResult.tooltip
        : undefined;
    return [renderResult.disabled, tooltip];
}
/**
 * This function vets if the row-actions configuration supports row actions at all.
 *
 * If this function changes. Please ensure `getActionableRowIdsOption` is still exhaustive.
 *
 * @param rowActionsConfig
 * @returns true if supported; false otherwise
 */
function configSupportsRowActions(rowActionsConfig) {
    return match(rowActionsConfig)
        .with({ type: P.union('feature-disabled', 'no-actions') }, () => false)
        .with({
        type: P.union('multi-action', 'single-action', 'multi-action-conditionable', 'single-action-conditionable', 'multi-action-context-menu')
    }, () => true)
        .exhaustive();
}
/**
 * This function vets if the row-actions configuration supports row-actions context menus.
 *
 * @param rowActionsConfig
 * @returns true if supported; false otherwise
 */
function configSupportsRowActionsContextMenus(rowActionsConfig) {
    return match(rowActionsConfig)
        .with({ type: P.union('feature-disabled', 'no-actions') }, () => false)
        .with({
        type: P.union('multi-action', 'single-action')
    }, (config) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = config.menuConfig) === null || _a === void 0 ? void 0 : _a.contextMenuConfig) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : DEFAULTS$2.contextMenuEnabled;
    })
        .with({
        type: P.union('multi-action-conditionable', 'single-action-conditionable')
    }, () => false)
        .with({ type: 'multi-action-context-menu' }, () => true)
        .exhaustive();
}
function getContextMenuMetadataOption(config) {
    return match(config)
        .with({ type: 'feature-disabled' }, () => None)
        .with({ type: 'no-actions' }, () => None)
        .with({ type: 'multi-action' }, (config) => config.contextMenuMetadata)
        .with({ type: 'multi-action-conditionable' }, () => None)
        .with({ type: 'single-action' }, (config) => config.contextMenuMetadata)
        .with({ type: 'single-action-conditionable' }, () => None)
        .with({ type: 'multi-action-context-menu' }, (config) => OptionUtils.some(config.contextMenuMetadata))
        .exhaustive();
}
function getGeneration(config) {
    return match(config)
        .with({ type: 'multi-action-context-menu' }, (config) => config.generation)
        .with({
        type: P.union('no-actions', 'single-action', 'single-action-conditionable', 'multi-action', 'multi-action-conditionable')
    }, (config) => config.buttonConfig.generation)
        .exhaustive();
}
/**
 * The context menu left click should be treated as right click to the row-actions button in some cases:
 *
 * [based on if the configuration supports multiple actions]:
 * - `'multi-action'`: always
 * - `'multi-action-conditionable'`: always
 * - `'single-action'`: only when `mode` is `'bulk-and-single'`
 * - otherwise: never
 *
 * [based on the presence of context menus]:
 * - `'multi-action-context-menu'`: always
 * - `'single-action'`: with `mode === 'single'` _cannot_ treat context menus as clicks
 *    (since there is no menu - would *do* the action) if not `'bulk-and-single'`, which
 *    is already handled
 * - `'multi-action'`: only when `menuConfig.contextMenuConfig.enabled` is `true`
 *
 * - `'single-action-conditionable'`, `'multi-action-conditionable'`: do not support context menus at this time
 * - `'feature-disabled'`, `'no-actions'` do not have any menus to show
 * - '`multi-action'` with `menuConfig.contextMenuConfig.enabled !== true` has no context menus
 */
function rowActionsButtonShouldTreatContextMenuAsClick(config) {
    const forMultiActionConfigs = match(config)
        .with({ type: 'multi-action' }, () => true)
        .with({ type: 'multi-action-conditionable' }, () => true)
        .with({ type: 'single-action', modeConfig: { mode: P.select() } }, (mode) => mode === 'bulk-and-single')
        .with({
        type: P.union('no-actions', 'single-action-conditionable')
    }, () => false)
        .exhaustive();
    if (forMultiActionConfigs)
        return true;
    const forContextMenus = match(config)
        .with({ type: 'no-actions' }, () => false)
        .with({ type: 'multi-action' }, (config) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = config.menuConfig) === null || _a === void 0 ? void 0 : _a.contextMenuConfig) === null || _b === void 0 ? void 0 : _b.enabled) !== null && _c !== void 0 ? _c : DEFAULTS$2.contextMenuEnabled;
    })
        .with({
        type: P.union('single-action', 'multi-action-conditionable', 'single-action-conditionable')
    }, () => false)
        .exhaustive();
    return forContextMenus;
}
/**
 * This function does not guarantee a specific row will have actions.
 *
 * This function **does** ensure that the current data-grid row's:
 * - 1) not loading
 * - 2) row-actions configuration allows for row actions to appear in a context menu
 * - 3) row generation allows for row actions at this row's generation
 *
 * @param generation
 * @param rowActionsConfig
 * @param rowSearchableData
 * @returns
 */
function rowSupportsRowActionsContextMenus(generation, rowActionsConfig, rowSearchableData) {
    return (
    // 1) true if the row is not currently loading (null or undefined)
    !isNil$1(rowSearchableData) &&
        // 2) true if the row-actions configuration supports row-actions context menus
        configSupportsRowActionsContextMenus(rowActionsConfig) &&
        // 3) true if the generation supports row-actions context menus
        match(rowActionsConfig)
            .with({
            type: P.union('feature-disabled', 'no-actions', 'single-action-conditionable', 'multi-action-conditionable')
        }, () => false)
            .with({
            type: P.union('multi-action', 'single-action', 'multi-action-context-menu')
        }, (config) => {
            var _a;
            return generation ===
                ((_a = getGeneration(config)) !== null && _a !== void 0 ? _a : CONSTANTS$1['default-generation']);
        })
            .exhaustive());
}

/**
 * Returns a bag of data relating to what rows & row IDs can perform row actions.
 *
 * @see {@link RowActionability}
 */
function getActionableRowIdsOption(allRows, rowIdField, checkedCache, rowActionsConfig, hasCheckboxes, hasNesting, dataGridAppearsLoading) {
    if (dataGridAppearsLoading) {
        return None;
    }
    /**
     * possible:
     * (2) [has row actions, no row actions]
     * (2) [checkboxes, no checkboxes]
     * (2) [nesting, no nesting]
     */
    // this uses ts-pattern to exhaustively check the rowActionsConfig type
    const supportsActions = configSupportsRowActions(rowActionsConfig);
    if (!supportsActions ||
        // (2x) needed to keep TS happy without using a fragile type predicate function. (already proven in configSupportsRowActions)
        rowActionsConfig.type === 'feature-disabled' ||
        rowActionsConfig.type === 'no-actions') {
        // no actions can be performed
        return None;
    }
    /**
     * Remaining possibilities:
     * (1) [has row actions]
     * (2) [checkboxes, no checkboxes]
     * (2) [nesting, no nesting]
     *
     * Combinations:
     * 1. [checkboxes & nesting]
     * 2. [checkboxes & no nesting]
     * 3. [no checkboxes & nesting]
     * 4. [no checkboxes & no nesting] -> the trivial case
     */
    let singlyActionableRowIds;
    let singlyActionableRows;
    let bulkActionableRowIds;
    // case 1: [checkboxes & nesting]
    if (hasCheckboxes && hasNesting) {
        // has nesting, so only rows at the correct generation are singly actionable
        [singlyActionableRowIds, singlyActionableRows] = allRows.reduce((acc, row) => {
            var _a;
            const currentGeneration = checkedCache.getRowGeneration(row.index);
            const correctGeneration = (_a = getGeneration(rowActionsConfig)) !== null && _a !== void 0 ? _a : CONSTANTS$1['default-generation'];
            if (currentGeneration === correctGeneration) {
                acc[0].push(RowIdUtils.getId(row, rowIdField));
                acc[1].push(row);
            }
            return acc;
        }, [[], []]);
        // has nesting and checkboxes, so only checked rows at the correct
        // generation are bulk actionable
        bulkActionableRowIds = allRows.reduce((acc, row) => {
            var _a;
            const currentGeneration = checkedCache.getRowGeneration(row.index);
            const correctGeneration = (_a = getGeneration(rowActionsConfig)) !== null && _a !== void 0 ? _a : CONSTANTS$1['default-generation'];
            if (
            // has checkboxes, so only checked rows are bulk actionable
            checkedCache.isOpen(row.index) &&
                // has nesting, so only rows at the correct generation are actionable
                currentGeneration === correctGeneration) {
                const rowId = RowIdUtils.getId(row, rowIdField);
                acc.push(rowId);
            }
            return acc;
        }, []);
    }
    // case 2: [checkboxes & no nesting]
    else if (hasCheckboxes && !hasNesting) {
        // no nesting, so all rows are singly actionable
        [singlyActionableRowIds, singlyActionableRows] = allRows.reduce((acc, row) => {
            acc[0].push(RowIdUtils.getId(row, rowIdField));
            acc[1].push(row);
            return acc;
        }, [[], []]);
        // has checkboxes, so only checked rows are bulk actionable
        bulkActionableRowIds = allRows.reduce((acc, row) => {
            if (checkedCache.isOpen(row.index)) {
                const rowId = RowIdUtils.getId(row, rowIdField);
                acc.push(rowId);
            }
            return acc;
        }, []);
    }
    // case 3: [no checkboxes & nesting]
    else if (!hasCheckboxes && hasNesting) {
        // has nesting, so only rows at the correct generation are singly actionable
        [singlyActionableRowIds, singlyActionableRows] = allRows.reduce((acc, row) => {
            var _a;
            const currentGeneration = checkedCache.getRowGeneration(row.index);
            const correctGeneration = (_a = getGeneration(rowActionsConfig)) !== null && _a !== void 0 ? _a : CONSTANTS$1['default-generation'];
            if (currentGeneration === correctGeneration) {
                acc[0].push(RowIdUtils.getId(row, rowIdField));
                acc[1].push(row);
            }
            return acc;
        }, [[], []]);
        // no checkboxes, so no rows are bulk-actionable
        bulkActionableRowIds = null;
    }
    // case 4: [no checkboxes & no nesting] (the trivial case)
    else {
        // no nesting, so all rows are singly actionable
        [singlyActionableRowIds, singlyActionableRows] = allRows.reduce((acc, row) => {
            acc[0].push(RowIdUtils.getId(row, rowIdField));
            acc[1].push(row);
            return acc;
        }, [[], []]);
        // no checkboxes, so no rows are bulk-actionable
        bulkActionableRowIds = null;
    }
    /*
     * The above 'Combinations' will include the "hidden-exception IDs" only
     * when the row actions are not conditionable. This is because the hidden
     * exception IDs are not associated with any row data in the data source;
     * and row data is required to invoke the conditional-row-action-visibility
     * function per each conditionally visible action per each row.
     *
     * Also, checkboxes are necessary to have bulk actions in the first place, so
     * if they are missing, these hidden-exception IDS are not relevant.
     */
    if (
    // has checkboxes for bulk actions
    hasCheckboxes &&
        // non-conditionable row-action visibilities
        (rowActionsConfig.type === 'multi-action' ||
            rowActionsConfig.type === 'single-action' ||
            rowActionsConfig.type === 'multi-action-context-menu')) {
        const hiddenExceptionIds = checkedCache.hiddenExceptionIds();
        // no need to add add the hidden-exception IDs if their array is empty
        if (hiddenExceptionIds.length > 0) {
            bulkActionableRowIds =
                bulkActionableRowIds === null
                    ? hiddenExceptionIds
                    : bulkActionableRowIds.concat(hiddenExceptionIds);
        }
    }
    return OptionUtils.some({
        singlyActionableRowIds,
        singlyActionableRows,
        bulkActionableRowIds: 
        // available ony if there are multiple bulk-actionable rows
        bulkActionableRowIds !== null &&
            bulkActionableRowIds.length >= CONSTANTS$1['minimum-rows-for-bulk-action']
            ? OptionUtils.some(bulkActionableRowIds)
            : None
    });
}
function getSinglyActionableRowIds(rowActionability) {
    var _a, _b;
    const singlyActionableRowIds = (_b = (_a = OptionUtils.value(rowActionability, null)) === null || _a === void 0 ? void 0 : _a.singlyActionableRowIds) !== null && _b !== void 0 ? _b : null;
    return singlyActionableRowIds;
}
function getSinglyActionableRows(rowActionability) {
    var _a, _b;
    const singlyActionableRows = (_b = (_a = OptionUtils.value(rowActionability, null)) === null || _a === void 0 ? void 0 : _a.singlyActionableRows) !== null && _b !== void 0 ? _b : null;
    return singlyActionableRows;
}
function getBulkActionableRowIds(rowActionability) {
    var _a, _b;
    const bulkActionableRowIds = (_b = (_a = OptionUtils.value(rowActionability, null)) === null || _a === void 0 ? void 0 : _a.bulkActionableRowIds) !== null && _b !== void 0 ? _b : None;
    return OptionUtils.value(bulkActionableRowIds, null);
}
const Internal = {
    getActionableRowIdsOption,
    getSinglyActionableRowIds,
    getSinglyActionableRows,
    getBulkActionableRowIds
};
function getActionableRowsAndIds(rows = [], rowIdField, checkedCache, rowActionsConfig, checkboxesEnabled, nestingEnabled, dataGridAppearsLoading) {
    var _a, _b;
    const actionableRowIdsOption = Internal.getActionableRowIdsOption(rows !== null && rows !== void 0 ? rows : [], rowIdField, checkedCache, rowActionsConfig, checkboxesEnabled, nestingEnabled, dataGridAppearsLoading);
    const singlyActionableRowIds = (_a = Internal.getSinglyActionableRowIds(actionableRowIdsOption)) !== null && _a !== void 0 ? _a : [];
    const singlyActionableRows = (_b = Internal.getSinglyActionableRows(actionableRowIdsOption)) !== null && _b !== void 0 ? _b : [];
    const bulkActionableRowIds = Internal.getBulkActionableRowIds(actionableRowIdsOption);
    return {
        singlyActionableRowIds,
        singlyActionableRows,
        bulkActionableRowIds
    };
}
//#endregion Public API

const RowActionsConfigUtils = {
    buildContextMenuMetadata,
    checkButtonRendererForDisablement,
    configSupportsRowActions,
    configSupportsRowActionsContextMenus,
    getActionableRowsAndIds,
    getContextMenuMetadataOption,
    getGeneration,
    rowActionsButtonShouldTreatContextMenuAsClick,
    rowSupportsRowActionsContextMenus
};

var css$A = ".DataGrid_module_grid__dd4882c0 .DataGrid_module_row__dd4882c0 .DataGrid_module_cell__dd4882c0{cursor:default}.DataGrid_module_grid__dd4882c0 .DataGrid_module_row__dd4882c0 .DataGrid_module_cell__dd4882c0.DataGrid_module_isClickable__dd4882c0,.DataGrid_module_grid__dd4882c0 .DataGrid_module_row__dd4882c0.DataGrid_module_isSelectable__dd4882c0 .DataGrid_module_cell__dd4882c0{cursor:pointer}.DataGrid_module_grid__dd4882c0.DataGrid_module_alt__dd4882c0 .DataGrid_module_row__dd4882c0:is(.DataGrid_module_rowHasChildRows__dd4882c0,.DataGrid_module_rowHasChildContainer__dd4882c0) .DataGrid_module_cell__dd4882c0{cursor:pointer!important}.DataGrid_module_vibrant__dd4882c0:not(.DataGrid_module_disabled__dd4882c0):not(.DataGrid_module_readOnly__dd4882c0) input:checked+label:before{background-color:#365ef6}.DataGrid_module_vibrant__dd4882c0:not(.DataGrid_module_disabled__dd4882c0):not(.DataGrid_module_readOnly__dd4882c0) input:checked+label:after{background-color:#fff}.DataGrid_module_container__dd4882c0{background-color:#fff;color:#363840;display:flex;flex-direction:column;position:relative;width:100%}.DataGrid_module_searchBox__dd4882c0{max-width:320px;min-width:160px}.DataGrid_module_title__dd4882c0{font-size:24px;font-weight:600;line-height:32px}.DataGrid_module_grid__dd4882c0{display:grid;flex-grow:1;grid-auto-rows:min-content;margin:-4px;margin-block:0;overflow:auto;padding:4px;padding-block:0;position:relative}.DataGrid_module_grid__dd4882c0[data-overlaps-footer=true]{margin-bottom:-4px;padding-bottom:4px;z-index:2}.DataGrid_module_rowChildContainer__dd4882c0{background-color:#fff;border:1px solid #b0b4bf8c;border-bottom:none;grid-column:1/-1}.DataGrid_module_row__dd4882c0{border-bottom:1px solid #b0b4bf8c;border-right:1px solid #0000;display:grid;grid-column:1/-1;grid-template-columns:subgrid;min-height:40px;position:relative;z-index:2}.DataGrid_module_row__dd4882c0.DataGrid_module_selected__dd4882c0:not(.DataGrid_module_empty__dd4882c0) .DataGrid_module_vibrant__dd4882c0:not(.DataGrid_module_disabled__dd4882c0):not(.DataGrid_module_readOnly__dd4882c0) input+label:before,.DataGrid_module_row__dd4882c0:hover:not(.DataGrid_module_empty__dd4882c0) .DataGrid_module_vibrant__dd4882c0:not(.DataGrid_module_disabled__dd4882c0):not(.DataGrid_module_readOnly__dd4882c0) input+label:before{border-color:#365ef6}.DataGrid_module_row__dd4882c0.DataGrid_module_lastRow__dd4882c0{border-bottom:none;min-height:39px}.DataGrid_module_row__dd4882c0.DataGrid_module_botInset__dd4882c0{box-shadow:inset 0 -8px 8px -8px #0000001f}.DataGrid_module_row__dd4882c0.DataGrid_module_topInset__dd4882c0{box-shadow:inset 0 12px 12px -12px #00000040}.DataGrid_module_row__dd4882c0.DataGrid_module_topInset__dd4882c0.DataGrid_module_botInset__dd4882c0{box-shadow:inset 0 12px 12px -12px #00000040,inset 0 -8px 8px -8px #0000001f}.DataGrid_module_focusableRowEl__dd4882c0{height:0;opacity:0;overflow:hidden;position:absolute;width:0}.DataGrid_module_hideFooter__dd4882c0 .DataGrid_module_row__dd4882c0.DataGrid_module_lastRow__dd4882c0{border-bottom:1px solid #b0b4bf8c}.DataGrid_module_cell__dd4882c0{align-items:center;display:flex;font-weight:400;justify-content:center;min-height:39px;padding:8px 12px}.DataGrid_module_cell__dd4882c0.DataGrid_module_isClickable__dd4882c0{height:100%}.DataGrid_module_cell__dd4882c0.DataGrid_module_rowActions__dd4882c0{height:auto;padding-left:8px;padding-right:8px;width:auto}.DataGrid_module_cell__dd4882c0 .DataGrid_module_innerCell__dd4882c0{align-items:center;width:100%}.DataGrid_module_footer__dd4882c0{background-color:initial;border-bottom:1px solid #b0b4bf;border-top:1px solid #b0b4bf;color:#585c6a;font-weight:400;position:relative;text-align:right;z-index:1}.DataGrid_module_noResults__dd4882c0{color:#6a6f82;font-style:italic;grid-column:1/-1;height:50px;padding:15px;text-align:center}.DataGrid_module_toggleDash__dd4882c0{color:#585c6a;width:16px}.DataGrid_module_nest0__dd4882c0.DataGrid_module_topBorderDouble__dd4882c0 .DataGrid_module_nest__dd4882c0{position:relative}.DataGrid_module_nest0__dd4882c0.DataGrid_module_topBorderDouble__dd4882c0 .DataGrid_module_nest__dd4882c0:after{border-top:1px solid #b0b4bf8c;content:\"\";display:block;height:1px;left:0;position:absolute;top:-1px;width:40px}.DataGrid_module_nest0__dd4882c0.DataGrid_module_topBorder__dd4882c0 .DataGrid_module_nest__dd4882c0{position:relative}.DataGrid_module_nest0__dd4882c0.DataGrid_module_topBorder__dd4882c0 .DataGrid_module_nest__dd4882c0:after{border-top:1px solid #b0b4bf8c;content:\"\";display:block;height:1px;left:0;position:absolute;top:-1px;width:20px}.DataGrid_module_nest1__dd4882c0.DataGrid_module_topBorder__dd4882c0 .DataGrid_module_nest__dd4882c0{position:relative}.DataGrid_module_nest1__dd4882c0.DataGrid_module_topBorder__dd4882c0 .DataGrid_module_nest__dd4882c0:after{border-top:1px solid #b0b4bf8c;content:\"\";display:block;height:1px;left:-1px;position:absolute;top:-1px;width:20px}.DataGrid_module_nest0__dd4882c0{background-color:#fff0;margin-left:0}.DataGrid_module_nest0__dd4882c0 .DataGrid_module_nest__dd4882c0{border-left:none}.DataGrid_module_nest0__dd4882c0:hover:not(.DataGrid_module_empty__dd4882c0){background-color:#4369f40f}.DataGrid_module_nest0__dd4882c0.DataGrid_module_selected__dd4882c0:not(.DataGrid_module_empty__dd4882c0){background-color:#4578ed47}.DataGrid_module_nest0__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0){border:1px solid #365ef6;box-shadow:0 0 0 3px #365ef64d;margin-left:-1px;margin-top:-1px;overflow:clip;position:relative;transition:box-shadow .15s ease-in-out;z-index:99}.DataGrid_module_nest0__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0).DataGrid_module_lastRow__dd4882c0{margin-bottom:-1px}.DataGrid_module_nest0__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0)[data-overlaps-header=true]{z-index:200}.DataGrid_module_nest1__dd4882c0{background-color:#8089a314;margin-left:20px}.DataGrid_module_nest1__dd4882c0 .DataGrid_module_nest__dd4882c0{border-left:1px solid #b0b4bf8c}.DataGrid_module_nest1__dd4882c0:hover:not(.DataGrid_module_empty__dd4882c0){background-color:#4272f51f}.DataGrid_module_nest1__dd4882c0.DataGrid_module_selected__dd4882c0:not(.DataGrid_module_empty__dd4882c0){background-color:#4578ed47}.DataGrid_module_nest1__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0){border:1px solid #365ef6;box-shadow:0 0 0 3px #365ef64d;margin-left:19px;margin-top:-1px;overflow:clip;position:relative;transition:box-shadow .15s ease-in-out;z-index:99}.DataGrid_module_nest1__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0).DataGrid_module_lastRow__dd4882c0{margin-bottom:-1px}.DataGrid_module_nest1__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0)[data-overlaps-header=true]{z-index:200}.DataGrid_module_nest2__dd4882c0{background-color:#979fb433;margin-left:40px}.DataGrid_module_nest2__dd4882c0 .DataGrid_module_nest__dd4882c0{border-left:1px solid #b0b4bf8c}.DataGrid_module_nest2__dd4882c0:hover:not(.DataGrid_module_empty__dd4882c0){background-color:#3d71f52e}.DataGrid_module_nest2__dd4882c0.DataGrid_module_selected__dd4882c0:not(.DataGrid_module_empty__dd4882c0){background-color:#4578ed47}.DataGrid_module_nest2__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0){border:1px solid #365ef6;box-shadow:0 0 0 3px #365ef64d;margin-left:39px;margin-top:-1px;overflow:clip;position:relative;transition:box-shadow .15s ease-in-out;z-index:99}.DataGrid_module_nest2__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0).DataGrid_module_lastRow__dd4882c0{margin-bottom:-1px}.DataGrid_module_nest2__dd4882c0.DataGrid_module_isFocused__dd4882c0:not(.DataGrid_module_empty__dd4882c0)[data-overlaps-header=true]{z-index:200}.DataGrid_module_collapse__dd4882c0 .DataGrid_module_cell__dd4882c0{height:1px;min-height:1px}.DataGrid_module_checkboxHeader__dd4882c0{height:18px;margin:3px 0 1px;user-select:none}.DataGrid_module_checkbox__dd4882c0{margin:3px 0;user-select:none}.DataGrid_module_indeterminate__dd4882c0 label:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='16' height='16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.5 8c0-.552.403-1 .9-1h7.2c.497 0 .9.448.9 1s-.403 1-.9 1H4.4c-.497 0-.9-.448-.9-1Z' fill='%23fff'/%3E%3C/svg%3E\")!important}.DataGrid_module_lastChecked__dd4882c0:after{border:2px solid #365ef680;border-radius:2px;content:\"\";height:16px;left:-9px;margin:2px 0;position:absolute;top:0;width:4px}.DataGrid_module_noSelect__dd4882c0{user-select:none}.DataGrid_module_validationAlert__dd4882c0{padding-top:16px}";
window.ADS.injectStyle(css$A,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/DataGrid.module.scss");
var modules_b8d590e8 = {"grid":"DataGrid_module_grid__dd4882c0","row":"DataGrid_module_row__dd4882c0","cell":"DataGrid_module_cell__dd4882c0","isClickable":"DataGrid_module_isClickable__dd4882c0","isSelectable":"DataGrid_module_isSelectable__dd4882c0","alt":"DataGrid_module_alt__dd4882c0","rowHasChildRows":"DataGrid_module_rowHasChildRows__dd4882c0","rowHasChildContainer":"DataGrid_module_rowHasChildContainer__dd4882c0","vibrant":"DataGrid_module_vibrant__dd4882c0","disabled":"DataGrid_module_disabled__dd4882c0","readOnly":"DataGrid_module_readOnly__dd4882c0","container":"DataGrid_module_container__dd4882c0","searchBox":"DataGrid_module_searchBox__dd4882c0","title":"DataGrid_module_title__dd4882c0","rowChildContainer":"DataGrid_module_rowChildContainer__dd4882c0","empty":"DataGrid_module_empty__dd4882c0","selected":"DataGrid_module_selected__dd4882c0","lastRow":"DataGrid_module_lastRow__dd4882c0","botInset":"DataGrid_module_botInset__dd4882c0","topInset":"DataGrid_module_topInset__dd4882c0","focusableRowEl":"DataGrid_module_focusableRowEl__dd4882c0","hideFooter":"DataGrid_module_hideFooter__dd4882c0","rowActions":"DataGrid_module_rowActions__dd4882c0","innerCell":"DataGrid_module_innerCell__dd4882c0","footer":"DataGrid_module_footer__dd4882c0","noResults":"DataGrid_module_noResults__dd4882c0","toggleDash":"DataGrid_module_toggleDash__dd4882c0","nest-0":"DataGrid_module_nest0__dd4882c0","topBorderDouble":"DataGrid_module_topBorderDouble__dd4882c0","nest":"DataGrid_module_nest__dd4882c0","topBorder":"DataGrid_module_topBorder__dd4882c0","nest-1":"DataGrid_module_nest1__dd4882c0","isFocused":"DataGrid_module_isFocused__dd4882c0","nest-2":"DataGrid_module_nest2__dd4882c0","collapse":"DataGrid_module_collapse__dd4882c0","checkboxHeader":"DataGrid_module_checkboxHeader__dd4882c0","checkbox":"DataGrid_module_checkbox__dd4882c0","indeterminate":"DataGrid_module_indeterminate__dd4882c0","lastChecked":"DataGrid_module_lastChecked__dd4882c0","noSelect":"DataGrid_module_noSelect__dd4882c0","validationAlert":"DataGrid_module_validationAlert__dd4882c0"};

const CheckedResults = ({ searching, checkbox, checkedTotal, checkedSearchHidden, checkedConditionalVerbiage }) => {
    var _a, _b, _c, _d, _e, _f;
    const { t } = useTranslation();
    return (React__default.createElement(React__default.Fragment, null,
        !searching &&
            (checkbox === null || checkbox === void 0 ? void 0 : checkbox.enabled) &&
            ((_a = checkbox.text) === null || _a === void 0 ? void 0 : _a.selectedResultsText) && (React__default.createElement(React__default.Fragment, null, t(`${(_b = checkbox === null || checkbox === void 0 ? void 0 : checkbox.text) === null || _b === void 0 ? void 0 : _b.selectedResultsText}`, {
            count: checkedTotal,
            hidden: checkedSearchHidden
        }))),
        searching &&
            (checkbox === null || checkbox === void 0 ? void 0 : checkbox.enabled) &&
            ((_c = checkbox.text) === null || _c === void 0 ? void 0 : _c.selectedSearchResultsText) && (React__default.createElement(React__default.Fragment, null, t(`${(_d = checkbox === null || checkbox === void 0 ? void 0 : checkbox.text) === null || _d === void 0 ? void 0 : _d.selectedSearchResultsText}`, {
            count: checkedTotal,
            hidden: checkedSearchHidden
        }))),
        !searching &&
            (checkbox === null || checkbox === void 0 ? void 0 : checkbox.enabled) &&
            !((_e = checkbox.text) === null || _e === void 0 ? void 0 : _e.selectedResultsText) && (React__default.createElement(React__default.Fragment, null, t('CHECKED_ITEMS', { count: checkedTotal }))),
        searching &&
            (checkbox === null || checkbox === void 0 ? void 0 : checkbox.enabled) &&
            !((_f = checkbox.text) === null || _f === void 0 ? void 0 : _f.selectedResultsText) && (React__default.createElement(React__default.Fragment, null, `${t('CHECKED_ITEMS', { count: checkedTotal })} (${t(checkedConditionalVerbiage ? 'CHECK_EXCLUDED' : 'CHECK_HIDDEN', { count: checkedSearchHidden })})`))));
};

const useTotals = (total = 0) => {
    return React__default.useMemo(() => {
        return getTotalsAndType(total);
    }, [total]);
};
const useNestedResults = (resultsText) => {
    return React__default.useMemo(() => {
        return match(resultsText)
            .returnType()
            .when((resultsText) => typeof resultsText === 'object', (resultsText) => ({
            type: 'record',
            resultsText
        }))
            .when((resultsText) => typeof resultsText === 'function', (resultsText) => ({
            type: 'fn',
            resultsText
        }))
            .otherwise(() => ({
            type: 'empty',
            resultsText: null
        }));
    }, [resultsText]);
};

const cx$K = BindStyles(modules_b8d590e8);
const FOOTER_WARN_SEARCH_RESULTS_TEXT_WITHOUT_DATASET_TOTALS = "The search resultsText prop is NOT supported unless the 'total' prop is an object of type 'DatasetTotals'";
const FOOTER_TOTALS_TEXT_WITHOUT_NESTED_OR_DATASET_TOTALS = 'The resultsText function prop is ONLY supported when the following props are supplied: nestedConfig, total (must also be a DatasetTotals object).';
const TEST_IDS$7 = {
    footer: (dataGridTestID) => `${dataGridTestID}-footer`
};
const DataGridFooter = ({ testId, nested, total, resultsText, checkbox, checkedTotal, checkedSearchHidden, checkedConditionalVerbiage, nestedTotals, search }) => {
    const { t, i18n } = useTranslation();
    const totalsType = useTotals(total);
    const nestedType = useNestedResults(nested.resultsText);
    // display console warning when 'search.text.resultsText' is a function but 'total' is not a DatasetTotals object
    useADSWarnOnce(FOOTER_WARN_SEARCH_RESULTS_TEXT_WITHOUT_DATASET_TOTALS, total !== undefined &&
        search.resultsText !== undefined &&
        totalsType.type !== 'record');
    // display console warning when nested.resultsText is a FooterTotalsTextCallback function
    // but the 'nested' prop is undefined OR 'total' is not a DatasetTotals object
    useADSWarnOnce(FOOTER_TOTALS_TEXT_WITHOUT_NESTED_OR_DATASET_TOTALS, (nested === null || nested === void 0 ? void 0 : nested.enabled) &&
        nestedType.type === 'fn' &&
        total !== undefined &&
        (!nested || totalsType.type !== 'record'));
    const totals = React__default.useMemo(() => {
        var _a, _b, _c;
        if (search.searching) {
            // [SEARCH] sub-cases:
            // 1) Prefer the with-search resultsText as a function when applicable
            if (search.resultsText && !isNil(total) && totalsType.type === 'record') {
                const totalsObject = calculateDatasetTotals(nested, nestedTotals, search.total);
                const totalsText = search.resultsText(totalsType.totals, totalsObject);
                return totalsText;
            }
            else {
                // 2) Otherwise, fall back to the default with-search resultsText
                const totalsText = t('SEARCH_RESULTS', {
                    count: search.total,
                    total: (_a = totalsType.total) !== null && _a !== void 0 ? _a : '--'
                });
                return totalsText;
            }
        }
        // [NON-SEARCH] cases:
        // Prefer nesting-specific totals texts if nesting is enabled
        if (nested.enabled && nestedType.type !== 'empty') {
            // [NON-SEARCH] & [NESTING] cases:
            // 1) Prefer the nested resultsText as a function when applicable
            if (nestedType.type === 'fn' && totalsType.type === 'record') {
                const totalsText = nestedType.resultsText(totalsType.totals);
                return totalsText;
            }
            // 2) fall back to the nested resultsText as a record when applicable
            else if (nestedType.type === 'record' && nested && nestedTotals) {
                const { parents, children, grandChildren } = nestedType.resultsText;
                const entities = [
                    {
                        entity: parents,
                        total: nestedTotals[0],
                        fallbackText: resultsText
                    },
                    { entity: children, total: nestedTotals[1], fallbackText: '' },
                    { entity: grandChildren, total: nestedTotals[2], fallbackText: '' }
                ];
                const visibleTextParts = entities
                    .filter(({ entity }) => entity && !entity.hide)
                    .map(({ entity, total, fallbackText }) => {
                    const label = (entity === null || entity === void 0 ? void 0 : entity.text) || fallbackText;
                    return `${total} ${label}`.trim();
                });
                // only return if there are visible text parts, otherwise fall through to default
                if (visibleTextParts.length)
                    return visibleTextParts.join(', ');
            }
        }
        // 3) Otherwise, use the default without-search resultsText
        let totalsText;
        const key = typeof resultsText === 'string' ? resultsText : '';
        const keyExists = i18n.exists && i18n.exists(key, { count: totalsType.total });
        // 1. resultsText is a function -> call it with the totalsType.totals
        if (typeof resultsText === 'function') {
            totalsText = resultsText(totalsType.total);
        }
        // 2. Valid Translation key provided -> translate for consumer
        else if (resultsText !== 'ITEMS' && keyExists) {
            const translation = t(key, {
                count: totalsType.total
            });
            totalsText = translation;
        }
        // 3. Invalid Translation key provided -> display consumer provided string as-is prepended by total
        else if (resultsText && !keyExists) {
            totalsText = `${(_b = totalsType.total) !== null && _b !== void 0 ? _b : '--'} ${resultsText}`;
        }
        // 4. Default -> return string 'x Items'
        else {
            // falls back to the user supplied resultsText prop ie. '{{totalsType.total}} Items'
            totalsText = `${(_c = totalsType.total) !== null && _c !== void 0 ? _c : '--'} ${t('ITEMS', {
                count: totalsType.total
            })}`;
        }
        const totalsTextJsx = (React__default.createElement("div", { "data-test": "total-rows" }, totalsText));
        return totalsTextJsx;
    }, [
        i18n,
        nested,
        nestedTotals,
        nestedType,
        resultsText,
        search,
        total,
        totalsType.total,
        totalsType.totals,
        totalsType.type,
        t
    ]);
    return (React__default.createElement("div", { "data-test": TEST_IDS$7.footer(testId), className: cx$K('footer', 'py-50', 'pr-100', 'pl-100', 'd-flex', 'flex-align-space-between', 'gap-h-200', 'flex-no-wrap') },
        React__default.createElement("div", { "data-test": "total-rows-checked", className: cx$K('d-flex', 'minw-96', 'flex-align-start', 'text-left') },
            React__default.createElement(CheckedResults, { searching: search.searching, checkbox: checkbox, checkedTotal: checkedTotal, checkedSearchHidden: checkedSearchHidden, checkedConditionalVerbiage: checkedConditionalVerbiage })),
        React__default.createElement("div", { className: cx$K('d-flex', 'minw-96', 'flex-align-end', 'text-right') }, totals)));
};

const CONSTANTS = {
    /** in milliseconds */
    defaultWait: 30
};
/**
 * A component that listens for changes to an element's size.
 *
 * Hack: This component keeps `useSize`-induced re-renders local to itself.
 */
function SizeManager({ elemRef: { current: element }, ignore, wait = CONSTANTS.defaultWait, onSizeChange }) {
    // caveat: need to cause a second render to ensure the element reference is set
    useRerenderOnMount();
    // console.log('elem:', element);
    // console.log('ignore:', ignore);
    const { height, width } = useSizeV2(element, wait);
    // tunnel the values into effect(s) through a ref to avoid re-renders
    const effectRef = React__default.useRef({
        height,
        ignore,
        isFirstRender: true,
        sendUpdate: false,
        width,
        previousHeight: null,
        previousWidth: null,
        onSizeChange
    });
    React__default.useEffect(() => {
        effectRef.current = Object.assign(Object.assign({}, effectRef.current), { height,
            ignore, sendUpdate: false, width,
            onSizeChange });
    });
    /*
     * Algorithm:
     * 1. Determine if any non-ignored dimension(s) have changed.
     * 2. If so, set `sendUpdate` to `true`.
     * 3. If `sendUpdate` is `true`, call `onSizeChange` with the current dimensions.
     */
    // 1 & 2 [for height]
    React__default.useEffect(() => {
        const { ignore, previousHeight } = effectRef.current;
        if (ignore === 'height')
            return;
        if (previousHeight === height)
            return; // no change
        effectRef.current.sendUpdate = true;
        // console.log('height changed'); // debugging
    }, [height]);
    // 1 & 2 [for width]
    React__default.useEffect(() => {
        const { ignore, previousWidth } = effectRef.current;
        if (ignore === 'width')
            return;
        if (previousWidth === width)
            return; // no change
        effectRef.current.sendUpdate = true;
        // console.log('width changed'); // debugging
    }, [width]);
    // 3
    React__default.useEffect(() => {
        const { sendUpdate } = effectRef.current;
        if (!sendUpdate)
            return;
        const { height, width } = effectRef.current;
        // edge case: this effect runs on mount no matter what
        if (effectRef.current.isFirstRender) {
            effectRef.current.isFirstRender = false;
            return;
        }
        // console.log('invoking on-size event handler'); // debugging
        effectRef.current.onSizeChange({
            height,
            width
        });
    });
    React__default.useEffect(() => {
        effectRef.current = Object.assign(Object.assign({}, effectRef.current), { isFirstRender: false, previousHeight: effectRef.current.previousHeight, previousWidth: effectRef.current.previousWidth });
    });
    return null;
}

var css$z = ".Radio_module_radio__db71d4ea{display:inline-flex;gap:0;margin:6px 0;position:relative}.Radio_module_radio__db71d4ea label{align-items:center;cursor:pointer;font-weight:400;line-height:20px;padding-left:8px}.Radio_module_radio__db71d4ea label:after,.Radio_module_radio__db71d4ea label:before{height:18px;left:0;margin:1px 0;position:absolute;top:0;width:18px}.Radio_module_radio__db71d4ea label:before{background-color:#fff;border:1px solid #b0b4bf;border-radius:50%;content:\"\";display:inline-block;transition:all .2s cubic-bezier(.78,.14,.15,.86)}.Radio_module_radio__db71d4ea label:after{background-color:#444750;border-radius:50%;display:inline-block;height:6px;left:6px;top:6px;width:6px}.Radio_module_radio__db71d4ea.Radio_module_disabled__db71d4ea,.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea{pointer-events:none}.Radio_module_radio__db71d4ea.Radio_module_disabled__db71d4ea label,.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea label{color:#b0b4bf;cursor:default!important}.Radio_module_radio__db71d4ea.Radio_module_disabled__db71d4ea label:before,.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea label:before{background-color:#f5f5f7!important;border-color:#cbced7}.Radio_module_radio__db71d4ea.Radio_module_disabled__db71d4ea label:after,.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea label:after{background-color:#b0b4bf}.Radio_module_radio__db71d4ea.Radio_module_disabled__db71d4ea{user-select:none}.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea label{color:#363840}.Radio_module_radio__db71d4ea.Radio_module_readOnly__db71d4ea label:after{background-color:#444750}.Radio_module_input__db71d4ea{cursor:pointer;height:18px;margin:0;opacity:0;width:18px}.Radio_module_input__db71d4ea+label:after{content:none}.Radio_module_input__db71d4ea:hover+label:before{border-color:#365ef6}.Radio_module_input__db71d4ea:checked+label:after{content:\"\"}.Radio_module_input__db71d4ea:focus+label:before{border-color:#365ef6;box-shadow:0 0 0 3px #365ef64d}.Radio_module_input__db71d4ea:checked+label:before{background-color:#fff}.Radio_module_input__db71d4ea:checked:focus+label:before{box-shadow:0 0 0 3px #365ef64d}.Radio_module_input__db71d4ea.Radio_module_disabled__db71d4ea,.Radio_module_input__db71d4ea.Radio_module_readOnly__db71d4ea{cursor:default!important;pointer-events:none;user-select:none}.Radio_module_input__db71d4ea.Radio_module_disabled__db71d4ea+label:before,.Radio_module_input__db71d4ea.Radio_module_readOnly__db71d4ea+label:before{background-color:#f5f5f7;border-color:#cbced7;cursor:default!important}.Radio_module_input__db71d4ea.Radio_module_disabled__db71d4ea+label:after,.Radio_module_input__db71d4ea.Radio_module_readOnly__db71d4ea+label:after{background-color:#b0b4bf}.Radio_module_error__db71d4ea label:before{border-color:#ea0a3b}.Radio_module_desired__db71d4ea label:before{border-color:#f45110}";
window.ADS.injectStyle(css$z,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Radio/Radio.module.scss");
var modules_8fc278f9 = {"radio":"Radio_module_radio__db71d4ea","disabled":"Radio_module_disabled__db71d4ea","readOnly":"Radio_module_readOnly__db71d4ea","input":"Radio_module_input__db71d4ea","error":"Radio_module_error__db71d4ea","desired":"Radio_module_desired__db71d4ea"};

const cx$J = classnames.bind(modules_8fc278f9);
/** @deprecated Use RadioV2 instead as that will allow you to properly render content within the radio button. This will be removed in ADS V8. */
const Radio = (props) => React__default.createElement(BaseRadio, Object.assign({}, props));
Radio.displayName = 'Radio'; // used for type validation in RadioGroup
const BaseRadio = ({ autoFocus, checked, children, className, customDataProps, desired, disabled, error, inputRef, id, name, readOnly, testId, value, onBlur, onChange, onClick }) => {
    const _id = id !== null && id !== void 0 ? id : `${name}-${value}`;
    const handleChange = (e) => {
        e.persist();
        onChange && onChange(e);
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$J('radio', className, { error, desired, disabled, readOnly }) }),
        React__default.createElement("input", { autoFocus: autoFocus, checked: checked, className: cx$J('input'), disabled: disabled || readOnly, id: _id, name: name, ref: inputRef, type: "radio", value: `${value}`, onBlur: onBlur, onChange: handleChange, onClick: onClick }),
        React__default.createElement("label", { htmlFor: _id }, children)));
};

const SPECIAL_COLUMN_TYPES = {
    rowChildContainer: 'inner__rowChildContainerColumnHeader',
    nestedToggle: 'inner__rowNestedToggleHeader',
    checkbox: 'inner__rowCheckboxHeader',
    rowActions: 'inner__rowActionsCheckboxHeader',
    radio: 'inner__rowRadioHeader'
};
const SPECIAL_COLUMN_INDEX = {
    rowChildContainer: -1,
    nestedToggle: -2,
    checkbox: -3,
    rowActions: -4,
    radio: -5
};

var css$y = "@keyframes ClickDot_module_outerDotAnimation__0c2f25e1{0%{opacity:.6;transform:translate(-50%,-50%) scale(.2)}90%{opacity:1;transform:translate(-50%,-50%) scale(1.05)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}.ClickDot_module_innerDot__0c2f25e1{background-color:#365ef6;border-radius:50%;height:8px;pointer-events:none;position:absolute;transform:translate(-50%,-50%);width:8px}.ClickDot_module_outerDot__0c2f25e1{background-color:#365ef64d}.ClickDot_module_opaqueWhiteBackdrop__0c2f25e1,.ClickDot_module_outerDot__0c2f25e1{animation:ClickDot_module_outerDotAnimation__0c2f25e1 .15s ease-in-out 1;border-radius:50%;height:24px;pointer-events:none;position:absolute;transform:translate(-50%,-50%);width:24px}.ClickDot_module_opaqueWhiteBackdrop__0c2f25e1{background:radial-gradient(#fffc 0,#fff3 90%)}";
window.ADS.injectStyle(css$y,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/components/bulk-actions/ClickDot.module.scss");
var modules_f5f1c915 = {"inner-dot":"ClickDot_module_innerDot__0c2f25e1","outer-dot":"ClickDot_module_outerDot__0c2f25e1","outer-dot-animation":"ClickDot_module_outerDotAnimation__0c2f25e1","opaque-white-backdrop":"ClickDot_module_opaqueWhiteBackdrop__0c2f25e1"};

const cx$I = BindStyles(modules_f5f1c915);
const TEST_IDS$6 = {
    clickDot: 'click-dot'
};
const ClickDot = React__default.memo(function ClickDot({ x, y }) {
    const style = { left: x, top: y };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: cx$I('opaque-white-backdrop'), style: style, onClick: CancelReactEvent, onContextMenu: CancelReactEvent }),
        React__default.createElement("div", { "data-test": TEST_IDS$6.clickDot, className: cx$I('outer-dot'), style: style, onClick: CancelReactEvent, onContextMenu: CancelReactEvent }),
        React__default.createElement("div", { className: cx$I('inner-dot'), style: style, onClick: CancelReactEvent, onContextMenu: CancelReactEvent })));
});

var css$x = ".RowActionsButton_module_rowAction__container__a6b2aba9{display:inline-block;position:relative}.RowActionsButton_module_rowAction__button__a6b2aba9{height:24px;min-height:24px;width:24px}.RowActionsButton_module_rowAction__button__a6b2aba9.RowActionsButton_module_singleTextMode__a6b2aba9{width:auto}.RowActionsButton_module_rowAction__button__a6b2aba9.RowActionsButton_module_singleTextMode__a6b2aba9:active:not(.RowActionsButton_module_loading__a6b2aba9){background-color:#d5e1fb!important}.RowActionsButton_module_rowAction__button__a6b2aba9:not(.RowActionsButton_module_singleTextMode__a6b2aba9){padding:0!important}.RowActionsButton_module_rowAction__button__a6b2aba9:not(.RowActionsButton_module_singleTextMode__a6b2aba9):hover{background-color:#365ef6}.RowActionsButton_module_rowAction__button__a6b2aba9.RowActionsButton_module_focus__a6b2aba9,.RowActionsButton_module_rowAction__button__a6b2aba9:focus{border-color:#365ef6}.RowActionsButton_module_rowAction__button__a6b2aba9:active:not(.RowActionsButton_module_loading__a6b2aba9){background-color:#0e36cd!important;border-color:#0e36cd}.RowActionsButton_module_rowAction__button_focused__a6b2aba9{border-color:#365ef6;box-shadow:0 0 0 4px #365ef64d}.RowActionsButton_module_rowAction__icon__a6b2aba9{fill:#365ef6}.RowActionsButton_module_rowAction__icon__a6b2aba9.RowActionsButton_module_disabled__a6b2aba9{fill:#b0b4bf}.RowActionsButton_module_rowAction__button__a6b2aba9:active:not(.RowActionsButton_module_loading__a6b2aba9) .RowActionsButton_module_rowAction__icon__a6b2aba9,.RowActionsButton_module_rowAction__button__a6b2aba9:hover .RowActionsButton_module_rowAction__icon__a6b2aba9{fill:#fff}";
window.ADS.injectStyle(css$x,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/components/bulk-actions/RowActionsButton.module.scss");
var modules_549b9de8 = {"row-action__container":"RowActionsButton_module_rowAction__container__a6b2aba9","row-action__button":"RowActionsButton_module_rowAction__button__a6b2aba9","singleTextMode":"RowActionsButton_module_singleTextMode__a6b2aba9","loading":"RowActionsButton_module_loading__a6b2aba9","focus":"RowActionsButton_module_focus__a6b2aba9","row-action__button_focused":"RowActionsButton_module_rowAction__button_focused__a6b2aba9","row-action__icon":"RowActionsButton_module_rowAction__icon__a6b2aba9","disabled":"RowActionsButton_module_disabled__a6b2aba9"};

const DEFAULT_BULK_ACTIONS_ICON = 'CheckedCheckboxGroupIcon';
const DEFAULT_BULK_ACTIONS_TITLE = 'BULK_ACTIONS_MENU_TITLE';
function useBulkMenuTitle(checkedCount, titleConfig) {
    const { t } = useTranslation();
    return React__default.useMemo(() => {
        if (titleConfig === undefined) {
            return {
                icon: { type: 'named', name: DEFAULT_BULK_ACTIONS_ICON },
                title: t(DEFAULT_BULK_ACTIONS_TITLE, { count: checkedCount }),
                tooltip: undefined
            };
        }
        // unwrap
        const { title, tooltip } = titleConfig;
        return {
            icon: { type: 'named', name: DEFAULT_BULK_ACTIONS_ICON },
            title: title !== null && title !== void 0 ? title : t(DEFAULT_BULK_ACTIONS_TITLE, { count: checkedCount }),
            tooltip: tooltip !== null && tooltip !== void 0 ? tooltip : undefined
        };
    }, [checkedCount, titleConfig, t]);
}
function addition(x, y) {
    return x + y;
}
// Returns how many buttons are in the top-level menu's section(s) of the input menu tree.
function buttonCount(tree) {
    /*
     * We reduce (to add up) the button counts of each section of our menu.
     *
     * An example of using a reducer for you:
     * console.log([1, 1, 1].reduce((p, c) => p + c, 0));
     * > [LOG]: 3
     */
    return tree.sections
        .map((section) => section.buttons.length)
        .reduce(addition, 0);
}
// Returns how many buttons are in the top-level menu's section(s) of the input menu tree.
function useButtonCount(tree) {
    return React__default.useMemo(() => buttonCount(tree), [tree]);
}
/**
 * The offset of a section is the sum of the previous sections' button counts.
 *
 * @example A Menu Tree with (3) Sections with (1) Button Each
 * ``` ts
 * const offsets = getMenuSectionOffsets(menuTree);
 * console.log(offsets);
 * // Prints [0, 1, 2]
 * ```
 * # Observations
 * The section offsets are:
 * - for the first section:   0
 * - for the second section:  1
 * - for the third section:   2
 * # Summary
 * As we see above, the sections all have one button each; therefore, each
 * section's offset is the sum of *all* previous sections' button counts,
 * and so the offset ascends by '1' for each section in this example.
 *
 * @param tree
 * @returns
 */
function getMenuSectionOffsets(tree) {
    const { sections } = tree;
    return (sections
        // get the button count for each section
        .map((section) => {
        return section.buttons.length;
    })
        // add the previous sections' button counts to get the index offset
        .map((_, index, all) => {
        return all.slice(0, index).reduce(addition, 0);
    }));
}
function disabledIndices(tree) {
    const { sections } = tree;
    // the offset of a section is the sum of the previous sections' button counts
    const sectionIndexOffsets = getMenuSectionOffsets(tree);
    // get the indices of disabled buttons, where each index is absolute
    // across all sections' buttons
    const disabledIndices = sections
        .map((section, sectionIndex) => section.buttons
        .map((button, relativeIndex) => {
        // [absolute button index] = [relative index] + [section offset]
        const absoluteIndex = sectionIndexOffsets[sectionIndex] + relativeIndex;
        return [button, absoluteIndex];
    })
        // filter out enabled buttons
        .filter(([button]) => button === null || button === void 0 ? void 0 : button.disabled)
        // return absolute indices
        .map(([, absoluteIndex]) => absoluteIndex))
        // reduce & concat is over 5x faster than `.flat` as of DX-234 (Q4 2023).
        .reduce((acc, curr) => acc.concat(curr), []);
    return disabledIndices;
}
function useDisabledIndices(tree) {
    return React__default.useMemo(() => disabledIndices(tree), [tree]);
}
// no memoization needed: primitive return & computationally inexpensive
function isMenuHidden(disabledButtonCount, totalButtonCount) {
    // case(no actions): would be covered by the default return; but this is more explicit
    if (totalButtonCount === 0) {
        return true;
    }
    return disabledButtonCount === totalButtonCount;
}
// no memoization needed: primitive return & computationally inexpensive
function useIsMenuHidden(disabledButtonCount, totalButtonCount) {
    // case (no actions): would be covered by the default return; but this is more explicit
    if (totalButtonCount === 0) {
        return true;
    }
    return disabledButtonCount === totalButtonCount;
}
/**
 * The `callbackFn` of `Array.prototype.filter` returns:
 * - `true` to keep an element
 * - `false` to remove an element
 * @param visibility
 * @returns
 */
function filterHidden(visibility) {
    // defaults to being visible
    if (visibility === undefined) {
        return true; // keep
    }
    switch (visibility) {
        case 'hidden': {
            return false; // remove
        }
        case 'disabled': {
            return true; // keep
        }
        case 'enabled': {
            return true; // keep
        }
    }
}
/**
 * Based on the input visibility, is this button disabled?
 * @param visibility
 * @returns
 */
function isDisabledByVisibility(visibility) {
    // defaults to being enabled
    if (visibility === undefined) {
        return undefined; // enabled
    }
    switch (visibility) {
        case 'hidden': {
            return true; // disabled
        }
        case 'disabled': {
            return true; // disabled
        }
        case 'enabled': {
            return false; // enabled
        }
    }
}
function getVisibility_multiRow_conditional(checkedRowIds, conditionalVisibilityConfig, currentRowId, visibilityCalculations) {
    // Debugging
    // console.log('row ID', rowId);
    var _a, _b;
    const checkedCalculations = ConditionalRowActionStateUtilities.createBulkVisibilitiesSets();
    {
        const cachedCalculations = (_b = (_a = visibilityCalculations.get(conditionalVisibilityConfig.id)) === null || _a === void 0 ? void 0 : _a.bulk) !== null && _b !== void 0 ? _b : ConditionalRowActionStateUtilities.createBulkVisibilitiesSets();
        // 💀 dangerous code: see Issue: "Set Shims" in issues.mdx
        checkedCalculations.enabled = intersection(cachedCalculations.enabled, checkedRowIds);
        // 💀 dangerous code: see Issue: "Set Shims" in issues.mdx
        checkedCalculations.disabled = intersection(cachedCalculations.disabled, checkedRowIds);
        // 💀 dangerous code: see Issue: "Set Shims" in issues.mdx
        checkedCalculations.hidden = intersection(cachedCalculations.hidden, checkedRowIds);
    }
    /*
     * special case: Even if the action is disabled or hidden for the
     * current row, any row that enables the bulk action would enable this
     * action on all checked rows.
     */
    if (checkedCalculations.enabled.size > 0) {
        // Debugging
        // console.log(
        //   conditionalVisibilityConfig.id,
        //   'is enabled due to the fact that at least one checked row enables this action:',
        //   checkedEnabledRowIds
        // );
        return ['enabled', checkedCalculations];
    }
    return [
        ConditionalRowActionStateUtilities.getVisibilityForActionAndRow(visibilityCalculations, 'bulk', conditionalVisibilityConfig.id, currentRowId),
        checkedCalculations
    ];
}
function getVisibility_singleRow_conditional(conditionalVisibilityConfig, currentRowId, visibilityCalculations) {
    return ConditionalRowActionStateUtilities.getVisibilityForActionAndRow(visibilityCalculations, 'single', conditionalVisibilityConfig.id, currentRowId);
}
function getLabel(labelConfig, forMenu) {
    if (typeof labelConfig === 'string') {
        return labelConfig;
    }
    return labelConfig[forMenu];
}
/**
 * Can be used when the action is disabled and, thus, impossible to be clicked.
 */
const uselessOnClick = (() => void undefined);
//#region predicate functions
// a predicate function to determine if the input tree is not nested, i.e., one level only
function submenuIsNotNested(submenu) {
    return submenu.actions.every((action) => {
        return action.type !== 'with-submenu';
    });
}
// a predicate function to determine if the input conditionable tree is not nested, i.e., one level only
function submenuIsNotNested_conditionable(submenu) {
    return submenu.actions.every((action) => {
        return action.type !== 'with-submenu';
    });
}
// a predicate function to determine if the input tree is not nested, i.e., one level only
function menuTreeIsNotNested(menuTree) {
    return menuTree.sections.every((section) => {
        return section.buttons.every((button) => {
            return button.type !== 'with-submenu';
        });
    });
}
//#endregion predicate functions
const ItemActionsHelpers = {
    // functions
    buttonCount,
    disabledIndices,
    filterHidden,
    getLabel,
    getMenuSectionOffsets,
    getVisibility_multiRow_conditional,
    getVisibility_singleRow_conditional,
    isDisabledByVisibility,
    isMenuHidden,
    uselessOnClick,
    // hooks
    useBulkMenuTitle,
    useButtonCount,
    useDisabledIndices,
    useIsMenuHidden,
    // predicates
    menuTreeIsNotNested,
    submenuIsNotNested,
    submenuIsNotNested_conditionable
};

//#region to menu tree - non-nested
/**
 * Maps a non-nested submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree}
 * @see{@link MenuTree}
 *
 * @param ids
 * @param forMenu - determines which menu's visibility to heed, i.e., bulk or single
 * @param submenuTree
 * @returns
 */
function toMenuTree_nonNested(ids, forMenu, submenuTree) {
    const buttons = submenuTree.actions
        .filter((action) => { var _a; return ItemActionsHelpers.filterHidden((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a[forMenu]); })
        .map((action) => {
        var _a;
        const disabled = ItemActionsHelpers.isDisabledByVisibility((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a[forMenu]);
        return Object.assign(Object.assign({}, action), { label: ItemActionsHelpers.getLabel(action.label, forMenu === 'bulk' ? 'bulk' : 'single'), disabled, onClick: () => void action.onClick(ids) });
    });
    const { titleConfig } = submenuTree;
    const menuTree = {
        sections: [
            {
                titleConfig,
                buttons
            }
        ]
    };
    return menuTree;
}
/**
 * Maps a non-nested, conditionable, single-row submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree}
 *
 * @param currentId
 * @param conditionalActionsVisibilitiesMetadata
 * @param submenuTree
 * @returns
 */
function toMenuTree_nonNested_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, submenuTree) {
    const buttons = submenuTree.actions.reduce((acc, action) => {
        /*
         * Algorithm as of DX-338 (Q2 2024:
         *
         * 1. Determine the visibility of the action.
         *   a. If the visibility is conditional, retrieve the calculated result then proceed as if it were not conditional.
         *   b. If the visibility is conditional, produce the tooltip.
         *
         * 2. With the action's visibilities present, filter out hidden actions.
         *
         * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
         *    handling the non-nested and nestable cases of the action,
         *    handling the nestable case's sub-cases of having and not having a submenu.
         */
        var _a, _b;
        const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
        // Step 1
        let singleVisibility;
        let tooltip;
        // Step 1.A
        if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
            singleVisibility = ItemActionsHelpers.getVisibility_singleRow_conditional(action.visibilityConfig, currentId, visibilityCalculations);
            // Step 1.B
            // case: tooltip is applicable
            if (singleVisibility !== 'enabled') {
                switch (typeof action.visibilityConfig.singleRowTooltip) {
                    case 'function': {
                        tooltip = action.visibilityConfig.singleRowTooltip({
                            currentRowId: currentId,
                            visibility: singleVisibility
                        });
                        break;
                    }
                    case 'string': {
                        tooltip = action.visibilityConfig.singleRowTooltip;
                        break;
                    }
                    default: {
                        tooltip = undefined;
                        break;
                    }
                }
            }
            else {
                // case: tooltip is inapplicable
                tooltip = undefined;
            }
        }
        else {
            singleVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.singleItem;
            tooltip = undefined;
        }
        // Step 2
        if (!ItemActionsHelpers.filterHidden(singleVisibility)) {
            // do not add hidden actions
            return acc;
        }
        // Step 3
        const disabled = ItemActionsHelpers.isDisabledByVisibility(singleVisibility);
        return [
            ...acc,
            {
                type: 'default',
                disabled,
                label: ItemActionsHelpers.getLabel(action.label, 'single'),
                tooltip,
                onClick: () => action.onClick([currentId])
            }
        ];
    }, []);
    const { titleConfig } = submenuTree;
    const menuTree = {
        sections: [
            {
                titleConfig,
                buttons
            }
        ]
    };
    return menuTree;
}
/**
 * Maps a non-nested, conditionable, multi-row submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree}
 *
 * @param checkedIds
 * @param checkedIdsSet
 * @param conditionalActionsVisibilitiesMetadata
 * @param currentId
 * @param submenuTree
 * @returns
 */
function toMenuTree_nonNested_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, submenuTree) {
    const buttons = submenuTree.actions.reduce((acc, action) => {
        /*
         * Algorithm as of DX-338 (Q2 2024:
         *
         * 1. Determine the visibility of the action.
         *   a. If the visibility is conditional, retrieve the calculated result then proceed as if it were not conditional.
         *   b. If the visibility is conditional, produce the tooltip.
         *
         * 2. With the action's visibilities present, filter out hidden actions.
         *
         * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
         *    handling the non-nested and nestable cases of the action,
         *    handling the nestable case's sub-cases of having and not having a submenu.
         */
        var _a, _b, _c, _d;
        const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
        // Step 1
        let bulkVisibility;
        let calculationsForCheckedRows = undefined;
        let checkedEnabledRowIds = undefined;
        let tooltip;
        // Step 1.A
        if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
            [bulkVisibility, calculationsForCheckedRows] =
                ItemActionsHelpers.getVisibility_multiRow_conditional(checkedIdsSet, action.visibilityConfig, currentId, visibilityCalculations);
            const enabledArray = [...calculationsForCheckedRows.enabled];
            if (OneOrMoreUtils.isOneOrMore(enabledArray)) {
                checkedEnabledRowIds = enabledArray;
            }
            else {
                checkedEnabledRowIds = undefined;
            }
            // Debugging
            // console.log('Current Action:', action.visibilityConfig?.id);
            // console.log('\tChecked Rows', Array.from(checkedIdsSet));
            // console.log('\tVisibility Calculations:');
            // console.log(
            //   '\t\tenabled',
            //   Array.from(calculationsForCheckedRows.enabled)
            // );
            // console.log(
            //   '\t\tdisabled',
            //   Array.from(calculationsForCheckedRows.disabled)
            // );
            // console.log(
            //   '\t\thidden',
            //   Array.from(calculationsForCheckedRows.hidden)
            // );
            // console.log(
            //   '\tConditional-Vis. State',
            //   conditionalActionsVisibilitiesMetadata
            // );
            // console.log('\n');
            // Step 1.B
            // case: tooltip is applicable
            if (calculationsForCheckedRows.enabled.size !== checkedIdsSet.size) {
                switch (typeof action.visibilityConfig.bulkTooltip) {
                    case 'function': {
                        tooltip = action.visibilityConfig.bulkTooltip(Object.assign({ currentRowId: currentId, checkedRowIds: checkedIds }, calculationsForCheckedRows));
                        break;
                    }
                    case 'string': {
                        tooltip = action.visibilityConfig.bulkTooltip;
                        break;
                    }
                    default: {
                        tooltip = undefined;
                        break;
                    }
                }
            }
            else {
                // case: tooltip is inapplicable
                tooltip = undefined;
            }
        }
        else {
            bulkVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.bulk;
            checkedEnabledRowIds = checkedIds;
            tooltip = undefined;
        }
        // Step 2
        if (!ItemActionsHelpers.filterHidden(bulkVisibility)) {
            // do not add hidden actions
            return acc;
        }
        const labelCount = ((_c = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _c !== void 0 ? _c : 0) === checkedIds.length
            ? ''
            : ` (${(_d = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _d !== void 0 ? _d : 0})`;
        // Step 3
        const disabled = ItemActionsHelpers.isDisabledByVisibility(bulkVisibility);
        /**
         * See {@link ItemActionsHelpers.getVisibility_multiRow_conditional}.
         * When an action is not enabled for any checked row ID, then the
         * visibility will not be enabled. Thus, this onClick will not be
         * used and can be a no-op to appease the type system.
         */
        const onClick = match(checkedEnabledRowIds)
            .returnType()
            .with(undefined, () => ItemActionsHelpers.uselessOnClick)
            .otherwise((ids) => function () {
            action.onClick(ids);
        });
        return [
            ...acc,
            {
                type: 'default',
                disabled,
                index: acc.length, // "however many buttons we have so far is our index"
                label: ItemActionsHelpers.getLabel(action.label, 'bulk') + labelCount,
                tooltip,
                onClick
            }
        ];
    }, []);
    const { titleConfig } = submenuTree;
    const menuTree = {
        sections: [
            {
                titleConfig,
                buttons
            }
        ]
    };
    return menuTree;
}
//#endregion to menu tree - non-nested
//#region to menu tree - nestable
/**
 * Maps a nestable submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree}
 * @see{@link MenuTree}
 *
 * @param forMenu - determines which menu's visibility to heed, i.e., bulk or single
 * @param submenuTree
 * @returns
 */
function toMenuTree_nestable(ids, forMenu, submenuTree) {
    if (ItemActionsHelpers.submenuIsNotNested(submenuTree)) {
        // not nested
        return toMenuTree_nonNested(ids, forMenu, submenuTree);
    }
    else {
        // nestable
        const buttons = submenuTree.actions
            .filter((action) => { var _a; return ItemActionsHelpers.filterHidden((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a[forMenu]); })
            .map((action) => {
            var _a, _b;
            switch (action.type) {
                case 'with-submenu': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a[forMenu]);
                    if (disabled) {
                        return Object.assign(Object.assign({}, action), { label: ItemActionsHelpers.getLabel(action.label, forMenu === 'bulk' ? 'bulk' : 'single'), type: 'with-submenu', disabled: true, submenu: null });
                    }
                    else {
                        const submenu = toMenuTree_nonNested(ids, forMenu, action.submenu);
                        return Object.assign(Object.assign({}, action), { label: ItemActionsHelpers.getLabel(action.label, forMenu === 'bulk' ? 'bulk' : 'single'), type: 'with-submenu', disabled,
                            submenu });
                    }
                }
                case 'default': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility((_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b[forMenu]);
                    return Object.assign(Object.assign({}, action), { label: ItemActionsHelpers.getLabel(action.label, forMenu === 'bulk' ? 'bulk' : 'single'), disabled, onClick: () => void action.onClick(ids) });
                }
            }
        });
        const { titleConfig } = submenuTree;
        const menuTree = {
            sections: [
                {
                    titleConfig,
                    buttons: buttons
                }
            ]
        };
        return menuTree;
    }
}
/**
 * Maps a nestable, conditionable, single-row submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree}
 *
 * @param currentId
 * @param conditionalActionsVisibilitiesMetadata
 * @param submenuTree
 * @returns
 */
function toMenuTree_nestable_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, submenuTree) {
    if (ItemActionsHelpers.submenuIsNotNested_conditionable(submenuTree)) {
        // not nested
        return toMenuTree_nonNested_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, submenuTree);
    }
    else {
        // nestable
        const buttons = submenuTree.actions.reduce((acc, action) => {
            /*
             * Algorithm as of DX-338 (Q2 2024:
             *
             * 1. Determine the visibility of the action.
             *   a. If the visibility is conditional, retrieve the calculated result then proceed as if it were not conditional.
             *   b. If the visibility is conditional, produce the tooltip.
             *
             * 2. With the action's visibilities present, filter out hidden actions.
             *
             * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
             *    handling the non-nested and nestable cases of the action,
             *    handling the nestable case's sub-cases of having and not having a submenu.
             */
            var _a, _b;
            const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
            // Step 1
            let singleVisibility;
            let tooltip;
            // Step 1.A
            if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
                singleVisibility =
                    ItemActionsHelpers.getVisibility_singleRow_conditional(action.visibilityConfig, currentId, visibilityCalculations);
                // Step 1.B
                // case: tooltip is applicable
                if (singleVisibility !== 'enabled') {
                    switch (typeof action.visibilityConfig.singleRowTooltip) {
                        case 'function': {
                            tooltip = action.visibilityConfig.singleRowTooltip({
                                currentRowId: currentId,
                                visibility: singleVisibility
                            });
                            break;
                        }
                        case 'string': {
                            tooltip = action.visibilityConfig.singleRowTooltip;
                            break;
                        }
                        default: {
                            tooltip = undefined;
                            break;
                        }
                    }
                }
                else {
                    // case: tooltip is inapplicable
                    tooltip = undefined;
                }
            }
            else {
                singleVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.singleItem;
                tooltip = undefined;
            }
            // Step 2
            if (!ItemActionsHelpers.filterHidden(singleVisibility)) {
                // do not add hidden actions
                return acc;
            }
            // Step 3
            switch (action.type) {
                // 'non-nested` is the default (`undefined`)
                case 'default': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility(singleVisibility);
                    return [
                        ...acc,
                        {
                            type: 'default',
                            disabled,
                            label: ItemActionsHelpers.getLabel(action.label, 'single'),
                            tooltip,
                            onClick: () => action.onClick([currentId])
                        }
                    ];
                }
                case 'with-submenu': {
                    const submenuTree = action.submenu === null
                        ? null
                        : toMenuTree_nonNested_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility(singleVisibility);
                    if (disabled) {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: true,
                                label: ItemActionsHelpers.getLabel(action.label, 'single'),
                                tooltip,
                                submenu: null
                            }
                        ];
                    }
                    else {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: false,
                                label: ItemActionsHelpers.getLabel(action.label, 'single'),
                                tooltip,
                                submenu: submenuTree
                            }
                        ];
                    }
                }
            }
        }, []);
        const { titleConfig } = submenuTree;
        const menuTree = {
            sections: [
                {
                    titleConfig,
                    buttons
                }
            ]
        };
        return menuTree;
    }
}
/**
 * Maps a nestable, conditionable, multi-row submenu tree into a `MenuTree`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree}
 *
 * @param currentId
 * @param conditionalActionsVisibilitiesMetadata
 * @param submenuTree
 * @returns
 */
function toMenuTree_nestable_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, submenuTree) {
    if (ItemActionsHelpers.submenuIsNotNested_conditionable(submenuTree)) {
        // not nested
        return toMenuTree_nonNested_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, submenuTree);
    }
    else {
        // nestable
        const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
        const buttons = submenuTree.actions.reduce((acc, action) => {
            /*
             * Algorithm as of DX-338 (Q2 2024:
             *
             * 1. Determine the visibility of the action.
             *   a. If the visibility is conditional, retrieve the calculated result then proceed as if it were not conditional.
             *   b. If the visibility is conditional, produce the tooltip.
             *
             * 2. With the action's visibilities present, filter out hidden actions.
             *
             * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
             *    handling the non-nested and nestable cases of the action,
             *    handling the nestable case's sub-cases of having and not having a submenu.
             */
            var _a, _b, _c, _d;
            // Step 1
            let bulkVisibility;
            let calculationsForCheckedRows = undefined;
            let checkedEnabledRowIds = undefined;
            let tooltip;
            // Step 1.A
            if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
                [bulkVisibility, calculationsForCheckedRows] =
                    ItemActionsHelpers.getVisibility_multiRow_conditional(checkedIdsSet, action.visibilityConfig, currentId, visibilityCalculations);
                const enabledArray = [...calculationsForCheckedRows.enabled];
                if (OneOrMoreUtils.isOneOrMore(enabledArray)) {
                    checkedEnabledRowIds = enabledArray;
                }
                else {
                    checkedEnabledRowIds = undefined;
                }
                // Debugging
                // console.log('Current Action:', action.visibilityConfig?.id);
                // console.log('\tChecked Rows', Array.from(checkedIdsSet));
                // console.log('\tVisibility Calculations:');
                // console.log(
                //   '\t\tenabled',
                //   Array.from(calculationsForCheckedRows.enabled)
                // );
                // console.log(
                //   '\t\tdisabled',
                //   Array.from(calculationsForCheckedRows.disabled)
                // );
                // console.log(
                //   '\t\thidden',
                //   Array.from(calculationsForCheckedRows.hidden)
                // );
                // console.log(
                //   '\tConditional-Vis. State',
                //   conditionalActionsVisibilitiesMetadata
                // );
                // console.log('\n');
                // Step 1.B
                // case: tooltip is applicable
                if (calculationsForCheckedRows.enabled.size !== checkedIdsSet.size) {
                    switch (typeof action.visibilityConfig.bulkTooltip) {
                        case 'function': {
                            tooltip = action.visibilityConfig.bulkTooltip(Object.assign({ currentRowId: currentId, checkedRowIds: checkedIds }, calculationsForCheckedRows));
                            break;
                        }
                        case 'string': {
                            tooltip = action.visibilityConfig.bulkTooltip;
                            break;
                        }
                        default: {
                            tooltip = undefined;
                            break;
                        }
                    }
                }
                else {
                    // case: tooltip is inapplicable
                    tooltip = undefined;
                }
            }
            else {
                bulkVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.bulk;
                checkedEnabledRowIds = checkedIds;
                tooltip = undefined;
            }
            // Step 2
            if (!ItemActionsHelpers.filterHidden(bulkVisibility)) {
                // do not add hidden actions
                return acc;
            }
            const labelCount = ((_c = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _c !== void 0 ? _c : 0) === checkedIds.length
                ? ''
                : ` (${(_d = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _d !== void 0 ? _d : 0})`;
            // Step 3
            switch (action.type) {
                // 'non-nested` is the default (`undefined`)
                case 'default': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility(bulkVisibility);
                    /**
                     * See {@link ItemActionsHelpers.getVisibility_multiRow_conditional}.
                     * When an action is not enabled for any checked row ID, then the
                     * visibility will not be enabled. Thus, this onClick will not be
                     * used and can be a no-op to appease the type system.
                     */
                    const onClick = match(checkedEnabledRowIds)
                        .returnType()
                        .with(undefined, () => ItemActionsHelpers.uselessOnClick)
                        .otherwise((ids) => function () {
                        action.onClick(ids);
                    });
                    return [
                        ...acc,
                        {
                            type: 'default',
                            disabled,
                            index: acc.length, // "however many buttons we have so far is our index"
                            label: ItemActionsHelpers.getLabel(action.label, 'bulk') + labelCount,
                            tooltip,
                            onClick
                        }
                    ];
                }
                case 'with-submenu': {
                    const submenuTree = action.submenu === null
                        ? null
                        : toMenuTree_nonNested_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility(bulkVisibility);
                    if (disabled) {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: true,
                                index: acc.length, // "however many buttons we have so far is our index"
                                label: ItemActionsHelpers.getLabel(action.label, 'bulk') +
                                    labelCount,
                                tooltip,
                                submenu: null
                            }
                        ];
                    }
                    else {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: false,
                                index: acc.length, // "however many buttons we have so far is our index"
                                label: ItemActionsHelpers.getLabel(action.label, 'bulk') +
                                    labelCount,
                                tooltip,
                                submenu: submenuTree
                            }
                        ];
                    }
                }
            }
        }, []);
        const { titleConfig } = submenuTree;
        const menuTree = {
            sections: [
                {
                    titleConfig,
                    buttons
                }
            ]
        };
        return menuTree;
    }
}
//#endregion to menu tree - nestable
//#region to indexed menu tree - non-nested
/**
 * Maps a non-nested menu tree into its internal, indexed representation.
 * @see{@link MenuTree}
 * @see{@link MenuTree_Indexed}
 *
 * @param menuTree
 * @returns
 */
function toIndexedMenuTree_nonNested(menuTree) {
    const buttonCount = ItemActionsHelpers.buttonCount(menuTree);
    const disabledButtonIndices = ItemActionsHelpers.disabledIndices(menuTree);
    const isMenuHidden = ItemActionsHelpers.isMenuHidden(disabledButtonIndices.length, buttonCount);
    if (isMenuHidden)
        return null;
    const sectionIndexOffsets = ItemActionsHelpers.getMenuSectionOffsets(menuTree);
    const sectionsArray = menuTree.sections.map((section, sectionIndex) => {
        const buttons = section.buttons.map((button, relativeIndex) => {
            // [absolute button index] = [relative index] + [section offset]
            const absoluteIndex = sectionIndexOffsets[sectionIndex] + relativeIndex;
            return Object.assign(Object.assign({}, button), { index: absoluteIndex });
        });
        return Object.assign(Object.assign({}, section), { buttons });
    });
    /*
     * 💀 dangerous code: Converting Array<T> to OneOrMore<T>
     * 1) We know we have at least one item before `.map` (as sections is `OneOrMore`)
     * 2) We know each iteration of `.map` corresponds 1:1 with a new item
     * 3) We know we have an array of the correct data type after `.map`
     * Therefore, we still have at least one item after `.map`, i.e., `MenuTree_Indexed<0>['sections']`
     */
    const sections = sectionsArray;
    return {
        sections,
        buttonCount,
        disabledButtonIndices
    };
}
//#endregion to indexed menu tree - non-nested
//#region to indexed menu tree - nestable
/**
 * Maps a nestable menu tree into its internal, indexed representation.
 * @see{@link MenuTree}
 * @see{@link MenuTree_Indexed}
 *
 * @param menuTree
 * @returns
 */
function toIndexedMenuTree_nestable(menuTree) {
    if (ItemActionsHelpers.menuTreeIsNotNested(menuTree)) {
        // non-nested
        return toIndexedMenuTree_nonNested(menuTree);
    }
    else {
        // nested
        const buttonCount = ItemActionsHelpers.buttonCount(menuTree);
        // before recursion
        const disabledButtonIndices_before = ItemActionsHelpers.disabledIndices(menuTree);
        const isMenuHidden_before = ItemActionsHelpers.isMenuHidden(disabledButtonIndices_before.length, buttonCount);
        if (isMenuHidden_before)
            return null;
        const sectionIndexOffsets = ItemActionsHelpers.getMenuSectionOffsets(menuTree);
        const sectionsArray = menuTree.sections.map((section, sectionIndex) => {
            const buttons = section.buttons.map((button, relativeIndex) => {
                // [absolute button index] = [relative index] + [section offset]
                const absoluteIndex = sectionIndexOffsets[sectionIndex] + relativeIndex;
                switch (button.type) {
                    case 'default': {
                        return Object.assign(Object.assign({}, button), { index: absoluteIndex });
                    }
                    case 'with-submenu': {
                        if (button.submenu === null) {
                            return Object.assign(Object.assign({}, button), { index: absoluteIndex, disabled: true, submenu: null });
                        }
                        const submenu = toIndexedMenuTree_nonNested(button.submenu);
                        if (submenu === null) {
                            return Object.assign(Object.assign({}, button), { index: absoluteIndex, disabled: true, submenu: null });
                        }
                        return Object.assign(Object.assign({}, button), { index: absoluteIndex, submenu });
                    }
                }
            });
            return Object.assign(Object.assign({}, section), { buttons });
        });
        /*
         * 💀 dangerous code: Converting Array<T> to OneOrMore<T>
         * 1) We know we have at least one item before `.map` (as sections is `OneOrMore`)
         * 2) We know each iteration of `.map` corresponds 1:1 with a new item
         * 3) We know we have an array of the correct data type after `.map`
         * Therefore, we still have at least one item after `.map`, i.e., `MenuTree_Indexed<1>['sections']`
         */
        const sections = sectionsArray;
        // after recursion (buttons may be disabled now due to submenus)
        const disabledButtonIndices = ItemActionsHelpers.disabledIndices(menuTree);
        const isMenuHidden = ItemActionsHelpers.isMenuHidden(disabledButtonIndices.length, buttonCount);
        if (isMenuHidden)
            return null;
        return {
            sections,
            buttonCount,
            disabledButtonIndices
        };
    }
}
//#endregion to indexed menu tree - nestable
//#region map from submenu to menu tree
/**
 * Maps a nestable submenu tree into a `MenuTree_Indexed`.
 * @see{@link RowAction_SubmenuTree}
 * @see{@link MenuTree_Indexed}
 *
 * @param ids
 * @param forMenu
 * @param submenuTree
 * @returns
 */
function mapFromSubmenuToMenuTree(ids, forMenu, submenuTree) {
    const menuTree = toMenuTree_nestable(ids, forMenu, submenuTree);
    const indexedMenuTree = toIndexedMenuTree_nestable(menuTree);
    return indexedMenuTree;
}
/**
 * Maps a conditionable, nestable, single-row submenu tree into a `MenuTree_Indexed`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree_Indexed}
 *
 * @param conditionalActionsVisibilitiesMetadata
 * @param currentId
 * @param submenuTree
 * @returns
 */
function mapFromSubmenuToMenuTree_singleRow_conditionable(conditionalActionsVisibilitiesMetadata, currentId, submenuTree) {
    const menuTree = toMenuTree_nestable_singleRow_conditionable(currentId, conditionalActionsVisibilitiesMetadata, submenuTree);
    const indexedMenuTree = toIndexedMenuTree_nestable(menuTree);
    return indexedMenuTree;
}
/**
 * Maps a conditionable, nestable, multi-row submenu tree into a `MenuTree_Indexed`.
 * @see{@link RowAction_SubmenuTree_Conditionable}
 * @see{@link MenuTree_Indexed}
 *
 * @param checkedIds
 * @param checkedIdsSet
 * @param conditionalActionsVisibilitiesMetadata
 * @param currentId
 * @param submenuTree
 * @returns
 */
function mapFromSubmenuToMenuTree_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, submenuTree) {
    const menuTree = toMenuTree_nestable_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, submenuTree);
    const indexedMenuTree = toIndexedMenuTree_nestable(menuTree);
    return indexedMenuTree;
}
//#endregion map from submenu to menu tree
const RowActionsSubmenuTrees = {
    mapFromSubmenuToMenuTree,
    mapFromSubmenuToMenuTree_singleRow_conditionable,
    mapFromSubmenuToMenuTree_multiRow_conditionable
};

const SINGLE_ACTIONS_LABEL = 'SINGLE_ROW_ACTIONS';
function useSingleTree({ actions, currentId, singleTitleConfig = undefined, showDisabledRootMenu = false }) {
    const buttons = React__default.useMemo(() => {
        return actions
            .filter((action) => { var _a; return ItemActionsHelpers.filterHidden((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.singleItem); })
            .map((action, index) => {
            var _a, _b;
            switch (action.type) {
                // 'non-nested` is the default (`undefined`)
                case undefined:
                case 'non-nested': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.singleItem);
                    return {
                        type: 'default',
                        disabled,
                        index,
                        label: ItemActionsHelpers.getLabel(action.label, 'single'),
                        onClick: () => action.onClick([currentId])
                    };
                }
                case 'nestable': {
                    const submenuTree = action.submenu === null
                        ? null
                        : RowActionsSubmenuTrees.mapFromSubmenuToMenuTree([currentId], 'singleItem', action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility((_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.singleItem);
                    if (disabled) {
                        return {
                            type: 'with-submenu',
                            disabled: true,
                            index,
                            label: ItemActionsHelpers.getLabel(action.label, 'single'),
                            submenu: null
                        };
                    }
                    else {
                        return {
                            type: 'with-submenu',
                            disabled: false,
                            index,
                            label: ItemActionsHelpers.getLabel(action.label, 'single'),
                            submenu: submenuTree
                        };
                    }
                }
            }
        });
    }, [actions, currentId]);
    return useIndexedSingleMenuTree(buttons, singleTitleConfig, showDisabledRootMenu);
}
function useSingleTree_Conditionable({ actions, conditionalActionsVisibilitiesMetadata, currentId, singleTitleConfig = undefined, showDisabledRootMenu = false }) {
    const buttons = React__default.useMemo(() => {
        return actions.reduce((acc, action, index) => {
            /*
             * Algorithm as of DX-338 (Q2 2024):
             *
             * 1. Determine the visibility of the action.
             *   a. If the visibility is conditional, retrieve the calculated
             *      result then proceed as if it were not conditional.
             *   b. If the visibility is conditional, produce the tooltip.
             *
             * 2. With the action's visibilities present, filter out hidden actions.
             *
             * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
             *    handling the non-nested and nestable cases of the action,
             *    handling the nestable case's sub-cases of having and not having a submenu.
             */
            var _a, _b;
            const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
            // Step 1
            let singleVisibility;
            let tooltip;
            // Step 1.A
            if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
                singleVisibility =
                    ItemActionsHelpers.getVisibility_singleRow_conditional(action.visibilityConfig, currentId, visibilityCalculations);
                // Step 1.B
                // case: tooltip is applicable
                if (singleVisibility !== 'enabled') {
                    switch (typeof action.visibilityConfig.singleRowTooltip) {
                        case 'function': {
                            tooltip = action.visibilityConfig.singleRowTooltip({
                                currentRowId: currentId,
                                visibility: singleVisibility
                            });
                            break;
                        }
                        case 'string': {
                            tooltip = action.visibilityConfig.singleRowTooltip;
                            break;
                        }
                        default: {
                            tooltip = undefined;
                            break;
                        }
                    }
                }
                else {
                    // case: tooltip is inapplicable
                    tooltip = undefined;
                }
            }
            else {
                singleVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.singleItem;
                tooltip = undefined;
            }
            // Step 2
            if (!ItemActionsHelpers.filterHidden(singleVisibility)) {
                // do not add hidden actions
                return acc;
            }
            // Step 3
            switch (action.type) {
                // 'non-nested` is the default (`undefined`)
                case undefined:
                case 'non-nested': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility(singleVisibility);
                    return [
                        ...acc,
                        {
                            type: 'default',
                            disabled,
                            index,
                            label: ItemActionsHelpers.getLabel(action.label, 'single'),
                            tooltip,
                            onClick: () => action.onClick([currentId])
                        }
                    ];
                }
                case 'nestable': {
                    const submenuTree = action.submenu === null
                        ? null
                        : RowActionsSubmenuTrees.mapFromSubmenuToMenuTree_singleRow_conditionable(conditionalActionsVisibilitiesMetadata, currentId, action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility(singleVisibility);
                    if (disabled) {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: true,
                                index,
                                label: ItemActionsHelpers.getLabel(action.label, 'single'),
                                tooltip,
                                submenu: null
                            }
                        ];
                    }
                    else {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: false,
                                index,
                                label: ItemActionsHelpers.getLabel(action.label, 'single'),
                                tooltip,
                                submenu: submenuTree
                            }
                        ];
                    }
                }
            }
        }, []);
    }, [actions, currentId, conditionalActionsVisibilitiesMetadata]);
    return useIndexedSingleMenuTree(buttons, singleTitleConfig, showDisabledRootMenu);
}
//#endregion Single Tree - Conditionable Action Visibility
//#region Utilities for Single Trees
function useIndexedSingleMenuTree(buttons, singleTitleConfig, 
/** only true for context menus, which lack tooltips or indicators as to why the menu cannot open */
showDisabledRootMenu) {
    // the menu tree without indexes
    const menuTree = React__default.useMemo(() => {
        return {
            sections: [
                {
                    titleConfig: singleTitleConfig,
                    buttons: buttons
                }
            ]
        };
    }, [buttons, singleTitleConfig]);
    const buttonCount = ItemActionsHelpers.buttonCount(menuTree);
    const disabledButtonIndices = ItemActionsHelpers.disabledIndices(menuTree);
    const isMenuHidden = !showDisabledRootMenu &&
        ItemActionsHelpers.isMenuHidden(disabledButtonIndices.length, buttonCount);
    const menuTree_internal = React__default.useMemo(() => {
        if (isMenuHidden)
            return null;
        return Object.assign(Object.assign({}, menuTree), { buttonCount,
            disabledButtonIndices });
    }, [buttonCount, disabledButtonIndices, isMenuHidden, menuTree]);
    return menuTree_internal;
}
function useBulkAndSingleTree({ actions, checkedIds, currentId, bulkTitleConfig = undefined, singleTitleConfig = undefined, showDisabledRootMenu = false }) {
    const submenu_single = useSingleTree({
        actions,
        currentId,
        singleTitleConfig
    });
    const buttons = React__default.useMemo(() => {
        return actions
            .filter((action) => { var _a; return ItemActionsHelpers.filterHidden((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.bulk); })
            .map((action, index) => {
            var _a, _b;
            switch (action.type) {
                // 'non-nested` is the default, i.e., `undefined`
                case undefined:
                case 'non-nested': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.bulk);
                    return {
                        type: 'default',
                        disabled,
                        index,
                        label: ItemActionsHelpers.getLabel(action.label, 'bulk'),
                        onClick: () => action.onClick(checkedIds)
                    };
                }
                case 'nestable': {
                    const submenuTree = action.submenu === null
                        ? null
                        : RowActionsSubmenuTrees.mapFromSubmenuToMenuTree(checkedIds, 'bulk', action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility((_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.bulk);
                    if (disabled) {
                        return {
                            type: 'with-submenu',
                            disabled: true,
                            index,
                            label: ItemActionsHelpers.getLabel(action.label, 'bulk'),
                            submenu: null
                        };
                    }
                    else {
                        return {
                            type: 'with-submenu',
                            disabled: false,
                            index,
                            label: ItemActionsHelpers.getLabel(action.label, 'bulk'),
                            submenu: submenuTree
                        };
                    }
                }
            }
        });
    }, [actions, checkedIds]);
    const titleConfig = ItemActionsHelpers.useBulkMenuTitle(checkedIds.length, bulkTitleConfig);
    return useIndexedBulkAndSingleMenuTree(buttons, titleConfig, submenu_single, showDisabledRootMenu);
}
function useBulkAndSingleTree_Conditionable({ actions, checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, bulkTitleConfig = undefined, singleTitleConfig = undefined, showDisabledRootMenu = false }) {
    const submenu_single = useSingleTree_Conditionable({
        actions,
        conditionalActionsVisibilitiesMetadata,
        currentId,
        singleTitleConfig
    });
    const buttons = React__default.useMemo(() => {
        const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
        return actions.reduce((acc, action) => {
            /*
             * Algorithm as of DX-338 (Q2 2024:
             *
             * 1. Determine the visibility of the action.
             *   a. If the visibility is conditional, retrieve the calculated result then proceed as if it were not conditional.
             *   b. If the visibility is conditional, produce the tooltip.
             *
             * 2. With the action's visibilities present, filter out hidden actions.
             *
             * 3. Map each displayed (enabled or disabled) action to a menu-tree button,
             *    handling the non-nested and nestable cases of the action,
             *    handling the nestable case's sub-cases of having and not having a submenu.
             */
            var _a, _b, _c, _d;
            // Step 1
            let bulkVisibility;
            let calculationsForCheckedRows = undefined;
            let checkedEnabledRowIds = undefined;
            let tooltip;
            // Step 1.A
            if (((_a = action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.type) === 'conditional') {
                [bulkVisibility, calculationsForCheckedRows] =
                    ItemActionsHelpers.getVisibility_multiRow_conditional(checkedIdsSet, action.visibilityConfig, currentId, visibilityCalculations);
                const enabledArray = [...calculationsForCheckedRows.enabled];
                if (OneOrMoreUtils.isOneOrMore(enabledArray)) {
                    checkedEnabledRowIds = enabledArray;
                }
                else {
                    checkedEnabledRowIds = undefined;
                }
                // Debugging
                // console.log('Current Action:', action.visibilityConfig?.id);
                // console.log('\tChecked Rows', Array.from(checkedIdsSet));
                // console.log('\tVisibility Calculations:');
                // console.log(
                //   '\t\tenabled',
                //   Array.from(calculationsForCheckedRows.enabled)
                // );
                // console.log(
                //   '\t\tdisabled',
                //   Array.from(calculationsForCheckedRows.disabled)
                // );
                // console.log(
                //   '\t\thidden',
                //   Array.from(calculationsForCheckedRows.hidden)
                // );
                // console.log(
                //   '\tConditional-Vis. State',
                //   conditionalActionsVisibilitiesMetadata
                // );
                // console.log('\n');
                // Step 1.B
                // case: tooltip is applicable
                if (calculationsForCheckedRows.enabled.size !== checkedIdsSet.size) {
                    switch (typeof action.visibilityConfig.bulkTooltip) {
                        case 'function': {
                            tooltip = action.visibilityConfig.bulkTooltip(Object.assign({ currentRowId: currentId, checkedRowIds: checkedIds }, calculationsForCheckedRows));
                            break;
                        }
                        case 'string': {
                            tooltip = action.visibilityConfig.bulkTooltip;
                            break;
                        }
                        default: {
                            tooltip = undefined;
                            break;
                        }
                    }
                }
                else {
                    // case: tooltip is inapplicable
                    tooltip = undefined;
                }
            }
            else {
                bulkVisibility = (_b = action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.bulk;
                checkedEnabledRowIds = checkedIds;
                tooltip = undefined;
            }
            // Step 2
            if (!ItemActionsHelpers.filterHidden(bulkVisibility)) {
                // do not add hidden actions
                return acc;
            }
            const labelCount = ((_c = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _c !== void 0 ? _c : 0) === checkedIds.length
                ? ''
                : ` (${(_d = checkedEnabledRowIds === null || checkedEnabledRowIds === void 0 ? void 0 : checkedEnabledRowIds.length) !== null && _d !== void 0 ? _d : 0})`;
            // Step 3
            switch (action.type) {
                // 'non-nested` is the default (`undefined`)
                case undefined:
                case 'non-nested': {
                    const disabled = ItemActionsHelpers.isDisabledByVisibility(bulkVisibility);
                    /**
                     * See {@link ItemActionsHelpers.getVisibility_multiRow_conditional}.
                     * When an action is not enabled for any checked row ID, then the
                     * visibility will not be enabled. Thus, this onClick will not be
                     * used and can be a no-op to appease the type system.
                     */
                    const onClick = match(checkedEnabledRowIds)
                        .returnType()
                        .with(undefined, () => ItemActionsHelpers.uselessOnClick)
                        .otherwise((ids) => function () {
                        action.onClick(ids);
                    });
                    return [
                        ...acc,
                        {
                            type: 'default',
                            disabled,
                            index: acc.length, // "however many buttons we have so far is our index"
                            label: ItemActionsHelpers.getLabel(action.label, 'bulk') +
                                labelCount,
                            tooltip,
                            onClick
                        }
                    ];
                }
                case 'nestable': {
                    const submenuTree = action.submenu === null
                        ? null
                        : RowActionsSubmenuTrees.mapFromSubmenuToMenuTree_multiRow_conditionable(checkedIds, checkedIdsSet, conditionalActionsVisibilitiesMetadata, currentId, action.submenu);
                    const disabled = submenuTree === null ||
                        ItemActionsHelpers.isDisabledByVisibility(bulkVisibility);
                    if (disabled) {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: true,
                                index: acc.length, // "however many buttons we have so far is our index"
                                label: ItemActionsHelpers.getLabel(action.label, 'bulk') +
                                    labelCount,
                                submenu: null,
                                tooltip
                            }
                        ];
                    }
                    else {
                        return [
                            ...acc,
                            {
                                type: 'with-submenu',
                                disabled: false,
                                index: acc.length, // "however many buttons we have so far is our index"
                                label: ItemActionsHelpers.getLabel(action.label, 'bulk') +
                                    labelCount,
                                submenu: submenuTree,
                                tooltip
                            }
                        ];
                    }
                }
            }
        }, []);
    }, [
        actions,
        currentId,
        checkedIds,
        checkedIdsSet,
        conditionalActionsVisibilitiesMetadata
    ]);
    const titleConfig = ItemActionsHelpers.useBulkMenuTitle(checkedIdsSet.size, bulkTitleConfig);
    return useIndexedBulkAndSingleMenuTree(buttons, titleConfig, submenu_single, showDisabledRootMenu);
}
//#endregion Bulk & Single Tree - Conditionable Action Visibility
//#region Utilities for Bulk & Single Trees
function useIndexedBulkAndSingleMenuTree(bulkButtons, bulkTitleConfig, submenu_single, 
/** only true for context menus, which lack tooltips or indicators as to why the menu cannot open */
showDisabledRootMenu) {
    const { t } = useTranslation();
    const menuSection_bulkActions = React__default.useMemo(() => {
        return {
            buttons: bulkButtons,
            titleConfig: bulkTitleConfig
        };
    }, [bulkButtons, bulkTitleConfig]);
    const menuSection_singleItemActions = React__default.useMemo(() => {
        const submenuButtonDisabled = submenu_single === null;
        const singleItemActionsButtonLabel = submenuButtonDisabled
            ? t(SINGLE_ACTIONS_LABEL, {
                count: 0
            })
            : t(SINGLE_ACTIONS_LABEL, {
                count: submenu_single === null || submenu_single === void 0 ? void 0 : submenu_single.buttonCount
            });
        return {
            titleConfig: undefined,
            buttons: submenuButtonDisabled
                ? [
                    {
                        type: 'with-submenu',
                        disabled: true,
                        // Worth your careful attention:
                        // Notice index is offset by summing the previous section's buttons.
                        index: bulkButtons.length,
                        label: singleItemActionsButtonLabel,
                        submenu: null
                    }
                ]
                : [
                    {
                        type: 'with-submenu',
                        disabled: false,
                        // Worth your careful attention:
                        // Notice index is offset by summing the previous section's buttons.
                        index: bulkButtons.length,
                        label: singleItemActionsButtonLabel,
                        submenu: submenu_single
                    }
                ]
        };
    }, [bulkButtons.length, submenu_single, t]);
    const menuTree = React__default.useMemo(() => {
        return {
            sections: [
                menuSection_bulkActions,
                menuSection_singleItemActions
            ]
        };
    }, [menuSection_bulkActions, menuSection_singleItemActions]);
    const buttonCount = ItemActionsHelpers.useButtonCount(menuTree);
    const disabledButtonIndices = ItemActionsHelpers.useDisabledIndices(menuTree);
    const isMenuHidden = ItemActionsHelpers.useIsMenuHidden(disabledButtonIndices.length, buttonCount) && !showDisabledRootMenu;
    const menuTree_internal = React__default.useMemo(() => {
        if (isMenuHidden)
            return null;
        return Object.assign(Object.assign({}, menuTree), { buttonCount,
            disabledButtonIndices });
    }, [buttonCount, disabledButtonIndices, isMenuHidden, menuTree]);
    return menuTree_internal;
}
//#endregion Utilities for Bulk & Single Trees
const RowActionsMenuTrees = {
    useBulkAndSingleTree,
    useBulkAndSingleTree_Conditionable,
    useSingleTree,
    useSingleTree_Conditionable
};

/*
 * Hierarchy of components in this file:
 *  - Notice the hierarchy of components has diamond pattern, starting in
 *    'Default' and fanning out based on (2) considerations:
 *    - 1) The number of top-level menus:
 *        [bulk & single], [single], [none]
 *    - 2) If the actions' visibilities are able to be conditioned:
 *        [yes], [no]
 *
 *  - This "fan" structure allows us to choose what hooks we call in each case.
 *
 *  - Happily, we do not violate the rules of hooks though as each variant
 *    component is called from a different component. This allows for each case
 *    to only calculate proportional to its needs. Some cases are more
 *    expensive; so this lightens the load on the more trivial cases.
 *
 *  - The 'With Menus' component handles some shared logic for any buttons that
 *    do have dropdown menus.
 *
 *  - The 'Disabled' component handles some shared logic for buttons that are
 *    disabled and not clickable.
 *
 *  - The 'Shared' component handles some shared logic for the button itself,
 *    e.g., styling.
 *
 *  - Notice many components point at 'With Menus' and 'Disabled'.
 *
 *  - Notice particularly that very many components point at 'Disabled' This is
 *    because a button is disabled when its dropdown menus are themselves in a
 *    disabled state, which is only know after calling a relevant hook that
 *    determines the dropdown menus' state(s).
 *
 *  Diagram 1: "The Row-Actions-Button Composition Diagram":
 *
 *                     ┌───────────────┐
 *                     │    Default    │
 *                     └───────┬───────┘
 *                             │
 *         ┌─────────┬─────────┼─────────┬─────────┬─────────┐
 *         │         │         │         │         │         │
 *         │ ┌───────▼───────┐ │ ┌───────┴───────┐ │ ┌───────▼───────┐
 *         │ │ Bulk & Single │ │ │ Single Only   │ │ │ No Menus      │
 *         │ └───────┬───────┘ │ └───────┬───────┘ │ └───────┬───────┘
 *         │         │         │         │         │         │
 * ┌───────▼───────┐ │ ┌───────▼───────┐ │ ┌───────▼───────┐ │
 * │ Bulk & Single │ │ │ Single Only   │ │ │ No Menus      │ │
 * │ Conditionable │ │ │ Conditionable │ │ │ Conditionable │ │
 * └───────┬───────┘ │ └───────┬───────┘ │ └───────┬───────┘ │
 *         │         │         │         │         │         │
 *         └─────────┼─────────┴─────────┤         │         │
 *                   │                   │         │         │
 *           ┌───────▼───────┐   ┌───────▼───────┐ │         │
 *           │ With Menus    │   │ Disabled      ◄─┴─────────┤
 *           └───────┬───────┘   └───────┬───────┘           │
 *                   │                   │                   │
 *                   ├───────────────────┴───────────────────┘
 *                   │
 *           ┌───────▼───────┐
 *           │ Shared        │
 *           └───────────────┘
 *
 * Note: Made with asciiflow
 */
const cx$H = BindStyles(modules_549b9de8);
const DROPDOWN_MENU_PLACEMENT_CONFIG$1 = {
    placement: 'bottom-start',
    fallbackPlacements: ['bottom-start', 'top-start']
};
const TEST_IDS$5 = {
    /**
     * We want to remove `-enabled` in V7 as it is legacy code.
     * Previously, this test ID was different for enabled and disabled actions.
     *
     * We want to make the test ID uniform; but one of our consumers references this directly.
     *
     * Leaving as is for now. See the related issues.mdx entry.
     */
    rowActionsButton: `row-actions-button-enabled`,
    dropdown: `row-actions-dropdown`,
    shroud: `row-actions-button-shroud`,
    tooltip: `row-actions-button-tooltip`
};
const I18N_KEYS$1 = {
    defaultTooltip_singular: 'ACTION_NOT_AVAILABLE_FOR_ROW',
    defaultTooltip_plural: 'ACTION_NOT_AVAILABLE_FOR_ROW_plural'
};
function RowActionsButton(props) {
    // unwrap
    const { rowActionsConfig, rowId } = props, restOfProps = __rest(props, ["rowActionsConfig", "rowId"]);
    const { buttonConfig } = rowActionsConfig;
    const singleIcon = buttonConfig.type === 'with-custom-icon' ? buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.icon : undefined;
    const singleLabel = buttonConfig.type === 'with-label' ? buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.label : undefined;
    // determine the button style - this will be used regardless which button type is used
    const buttonStyle = React__default.useMemo(() => {
        switch (buttonConfig.type) {
            case 'meatball': {
                return {
                    type: buttonConfig.type,
                    updateWidth: buttonConfig.updateWidth,
                    icon: 'MeatballIcon',
                    className: cx$H('row-action__button'),
                    buttonType: 'tertiary'
                };
            }
            case 'with-custom-icon': {
                return {
                    type: buttonConfig.type,
                    updateWidth: buttonConfig.updateWidth,
                    icon: singleIcon,
                    className: cx$H('row-action__button'),
                    buttonType: 'tertiary'
                };
            }
            case 'with-label': {
                return {
                    type: buttonConfig.type,
                    updateWidth: buttonConfig.updateWidth,
                    label: singleLabel,
                    className: cx$H('row-action__button', { singleTextMode: true }),
                    buttonType: 'secondary'
                };
            }
        }
    }, [singleIcon, singleLabel, buttonConfig.type, buttonConfig.updateWidth]);
    // sometimes the row's button itself might be rendered as disabled when the overall
    // feature is enabled
    const [rowButtonIsDisabled, disabledTooltip] = React__default.useMemo(() => RowActionsConfigUtils.checkButtonRendererForDisablement(rowActionsConfig, props.rowData), [props.rowData, rowActionsConfig]);
    // if our row actions are disabled, render the memoized disabled button
    if ((rowButtonIsDisabled &&
        /*
         * If disabled and single-action-conditionable, render the
         * `RowActionsButton_Enabled_SingleItemActions_Conditional`
         * component instead.
         *
         * This is because the row action has conditional visibility, which
         * may provide a tooltip, which (if provided) should have pride of place
         * over the `renderer` or the default row-actions button tooltip.
         */
        rowActionsConfig.type !== 'single-action-conditionable') ||
        // need this (duplicate) logic for TypeScript to type `modeConfig` later
        rowActionsConfig.type === 'no-actions') {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: disabledTooltip, treatContextMenuAsClick: props.treatContextMenuAsClick }));
    }
    switch (rowActionsConfig.modeConfig.mode) {
        // if - we have multi-row and single-row actions, let's go build *both* of them
        case 'bulk-and-single': {
            switch (rowActionsConfig.type) {
                case 'single-action':
                case 'multi-action': {
                    return (React__default.createElement(RowActionsButton_Enabled_BulkAndSingleItemActions, Object.assign({}, restOfProps, { buttonStyle: buttonStyle, disabledTooltip: disabledTooltip, modeConfig: rowActionsConfig.modeConfig, rowActionsConfig: rowActionsConfig, rowId: rowId })));
                }
                case 'single-action-conditionable':
                case 'multi-action-conditionable': {
                    return (React__default.createElement(RowActionsButton_Enabled_BulkAndSingleItemActions_Conditionable, Object.assign({}, restOfProps, { buttonStyle: buttonStyle, disabledTooltip: disabledTooltip, modeConfig: rowActionsConfig.modeConfig, rowActionsConfig: rowActionsConfig, rowId: rowId })));
                }
            }
        }
        // else - we have just single-row actions, let's go build *only* them
        // eslint-disable-next-line no-fallthrough
        case 'single': {
            // differs for [single & multi-row] & [conditional & not]
            switch (rowActionsConfig.type) {
                case 'single-action': {
                    return (React__default.createElement(RowActionsButton_NoMenus, { buttonStyle: buttonStyle, disabledTooltip: disabledTooltip, rowActionsConfig: rowActionsConfig, rowId: rowId, treatContextMenuAsClick: props.treatContextMenuAsClick }));
                }
                case 'single-action-conditionable': {
                    return (React__default.createElement(RowActionsButton_NoMenus_Conditional, { buttonStyle: buttonStyle, isDisabledByRenderer: rowButtonIsDisabled, disabledTooltip: disabledTooltip, rowActionsConfig: rowActionsConfig, rowId: rowId, treatContextMenuAsClick: props.treatContextMenuAsClick }));
                }
                case 'multi-action': {
                    return (React__default.createElement(RowActionsButton_Enabled_SingleItemActions, Object.assign({}, restOfProps, { buttonStyle: buttonStyle, disabledTooltip: disabledTooltip, modeConfig: rowActionsConfig.modeConfig, rowActionsConfig: rowActionsConfig, rowId: rowId })));
                }
                case 'multi-action-conditionable': {
                    return (React__default.createElement(RowActionsButton_Enabled_SingleItemActions_Conditional, Object.assign({}, restOfProps, { buttonStyle: buttonStyle, disabledTooltip: disabledTooltip, modeConfig: rowActionsConfig.modeConfig, rowActionsConfig: rowActionsConfig, rowId: rowId })));
                }
            } // end of nested switch
        }
    }
}
function RowActionsButton_Enabled_BulkAndSingleItemActions(props) {
    var _a, _b;
    // unwrap
    const { modeConfig, rowActionsConfig, treatContextMenuAsClick } = props;
    const { checkedIds, currentId } = modeConfig;
    const { menuConfig } = rowActionsConfig;
    const actions = match(rowActionsConfig)
        .with({ type: 'multi-action' }, (config) => config.actions)
        .with({ type: 'single-action' }, (config) => [config.action])
        .exhaustive();
    const currentMenuTree = RowActionsMenuTrees.useBulkAndSingleTree({
        actions,
        checkedIds,
        currentId,
        bulkTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.bulk,
        singleTitleConfig: (_b = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _b === void 0 ? void 0 : _b.single
    });
    if (currentMenuTree === null) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: props.buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: props.disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return React__default.createElement(RowActionsButton_WithMenus, Object.assign({}, props, { menuTree: currentMenuTree }));
}
function RowActionsButton_Enabled_BulkAndSingleItemActions_Conditionable(props) {
    var _a, _b;
    // unwrap
    const { modeConfig, rowActionsConfig, treatContextMenuAsClick } = props;
    const { checkedIds, checkedIdsSet, currentId } = modeConfig;
    const { menuConfig, conditionalActionsVisibilitiesMetadata } = rowActionsConfig;
    const actions = match(rowActionsConfig)
        .with({ type: 'multi-action-conditionable' }, (config) => config.actions)
        .with({ type: 'single-action-conditionable' }, (config) => [config.action])
        .exhaustive();
    const currentMenuTree = RowActionsMenuTrees.useBulkAndSingleTree_Conditionable({
        actions,
        checkedIds,
        checkedIdsSet,
        conditionalActionsVisibilitiesMetadata,
        currentId,
        bulkTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.bulk,
        singleTitleConfig: (_b = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _b === void 0 ? void 0 : _b.single
    });
    if (currentMenuTree === null) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: props.buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: props.disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return React__default.createElement(RowActionsButton_WithMenus, Object.assign({}, props, { menuTree: currentMenuTree }));
}
function RowActionsButton_Enabled_SingleItemActions(props) {
    var _a;
    // unwrap
    const { modeConfig, rowActionsConfig, treatContextMenuAsClick } = props;
    const { currentId } = modeConfig;
    const { actions, menuConfig } = rowActionsConfig;
    const currentMenuTree = RowActionsMenuTrees.useSingleTree({
        actions,
        currentId,
        singleTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.single
    });
    if (currentMenuTree === null) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: props.buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: props.disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return React__default.createElement(RowActionsButton_WithMenus, Object.assign({}, props, { menuTree: currentMenuTree }));
}
function RowActionsButton_Enabled_SingleItemActions_Conditional(props) {
    var _a;
    // unwrap
    const { modeConfig, rowActionsConfig, treatContextMenuAsClick } = props;
    const { currentId } = modeConfig;
    const { actions, conditionalActionsVisibilitiesMetadata, menuConfig } = rowActionsConfig;
    const currentMenuTree = RowActionsMenuTrees.useSingleTree_Conditionable({
        actions,
        conditionalActionsVisibilitiesMetadata,
        currentId,
        singleTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.single
    });
    if (currentMenuTree === null) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: props.buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: props.disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return React__default.createElement(RowActionsButton_WithMenus, Object.assign({}, props, { menuTree: currentMenuTree }));
}
function RowActionsButton_NoMenus({ rowActionsConfig, buttonStyle, disabledTooltip, rowId, treatContextMenuAsClick }) {
    var _a, _b, _c, _d;
    const onClick = () => {
        rowActionsConfig.action.onClick([rowActionsConfig.modeConfig.currentId]);
    };
    const isDisabled = ((_a = rowActionsConfig.action.visibilityConfig) === null || _a === void 0 ? void 0 : _a.singleItem) === 'hidden' ||
        ((_b = rowActionsConfig.action.visibilityConfig) === null || _b === void 0 ? void 0 : _b.singleItem) === 'disabled';
    if (isDisabled) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return (React__default.createElement(RowActionsButton_Shared, { buttonStyle: buttonStyle, isLoading: (_d = (_c = rowActionsConfig.buttonConfig.loadingRowIds) === null || _c === void 0 ? void 0 : _c.has(rowId)) !== null && _d !== void 0 ? _d : false, onClick: onClick, treatContextMenuAsClick: treatContextMenuAsClick }));
}
function RowActionsButton_NoMenus_Conditional({ rowActionsConfig, buttonStyle, disabledTooltip, isDisabledByRenderer, rowId, treatContextMenuAsClick }) {
    var _a, _b;
    const { action, conditionalActionsVisibilitiesMetadata, modeConfig } = rowActionsConfig;
    const { visibilityConfig } = action;
    const { currentId } = modeConfig;
    const { visibilityCalculations } = conditionalActionsVisibilitiesMetadata.maps;
    const onClick = () => {
        action.onClick([rowActionsConfig.modeConfig.currentId]);
    };
    let singleVisibility;
    if ((visibilityConfig === null || visibilityConfig === void 0 ? void 0 : visibilityConfig.type) === 'conditional') {
        singleVisibility =
            ConditionalRowActionStateUtilities.getVisibilityForActionAndRow(visibilityCalculations, 'single', visibilityConfig.id, currentId);
    }
    else {
        singleVisibility = visibilityConfig === null || visibilityConfig === void 0 ? void 0 : visibilityConfig.singleItem;
    }
    // case: the row-actions button is disabled by the conditional visibility
    if (singleVisibility === 'hidden' || singleVisibility === 'disabled') {
        /*
         * Algorithm to set the tooltip in order of preference:
         * 1. Optional: Use the conditional-visibility tooltip if it exists.
         * 2. Otherwise, use the tooltip on the row-actions-button renderer if it
         *    exists.
         */
        let assertedTooltip;
        // case one: prefer the conditional-visibility tooltip
        if ((visibilityConfig === null || visibilityConfig === void 0 ? void 0 : visibilityConfig.type) === 'conditional' &&
            visibilityConfig.singleRowTooltip !== undefined) {
            if (typeof visibilityConfig.singleRowTooltip === 'function') {
                assertedTooltip = visibilityConfig.singleRowTooltip({
                    visibility: singleVisibility,
                    currentRowId: currentId
                });
            }
            else {
                assertedTooltip = visibilityConfig.singleRowTooltip;
            }
        } // case two: otherwise, use the tooltip from the row-actions button
        else {
            assertedTooltip = disabledTooltip;
        }
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: assertedTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    // case: the row-actions button is disabled by the row-actions button renderer
    if (isDisabledByRenderer) {
        return (React__default.createElement(RowActionsButton_Disabled, { buttonStyle: buttonStyle, buttonType: rowActionsConfig.buttonConfig.type, tooltip: disabledTooltip, treatContextMenuAsClick: treatContextMenuAsClick }));
    }
    return (React__default.createElement(RowActionsButton_Shared, { buttonStyle: buttonStyle, isLoading: (_b = (_a = rowActionsConfig.buttonConfig.loadingRowIds) === null || _a === void 0 ? void 0 : _a.has(rowId)) !== null && _b !== void 0 ? _b : false, treatContextMenuAsClick: treatContextMenuAsClick, onClick: onClick }));
}
function RowActionsButton_WithMenus({ buttonStyle, menuTree, rowActionsConfig, rowId, treatContextMenuAsClick }) {
    var _a, _b;
    // unwrap
    const { menuConfig } = rowActionsConfig;
    // setup all the intricate dropdown-menu logic
    const [dropdownBag, dropdownFunctions] = useDropdownForDropdownMenu({
        currentMenuTree: menuTree,
        keydownConfig: {
            listenTo: 'anchor-and-dropdown'
        },
        openOnArrowDown: true,
        openOnSpace: true
    });
    // unwrap
    const { dropdown, dropdownAnchorRef, dropdownProps } = dropdownBag;
    // unwrap
    const { activeRowIndex, open, toggle } = dropdown;
    const { anchorEl } = dropdownProps;
    return (React__default.createElement("div", { className: cx$H('row-action__container'), ref: dropdownAnchorRef, onClick: CancelReactEvent, onContextMenu: CancelReactEvent },
        React__default.createElement(ResizeListenerManager, { onResize: dropdownFunctions.handleClose }),
        React__default.createElement(RowActionsButton_Shared, { buttonStyle: buttonStyle, dropdownsOpen: open, isLoading: (_b = (_a = rowActionsConfig.buttonConfig.loadingRowIds) === null || _a === void 0 ? void 0 : _a.has(rowId)) !== null && _b !== void 0 ? _b : false, treatContextMenuAsClick: treatContextMenuAsClick, onClick: toggle }),
        open && (React__default.createElement(Shroud, { containsAlert: false, onClick: dropdownFunctions.handleClose, testId: TEST_IDS$5.shroud, 
            // Using a ref here would be ideal, but it would require significant prop drilling and ref merging in ButtonBase.
            // Given an anticipated refactor of ButtonBase's focus handling, we're using querySelector for now.
            returnFocusEl: anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.querySelector('button') },
            React__default.createElement(DropdownMenu, { activeRowIndex: activeRowIndex, buttonSize: menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.menuButtonSize, currentDropdownFunctions: dropdownFunctions, currentDropdownProps: dropdownProps, depth: 0, menuTree: menuTree, menuModality: "dropdown", menuWidth: "narrow", 
                // This component is recursive; and we do not want each dropdown's minimum width to depend on its parent.
                minWidthMatchAnchor: false, placementConfig: DROPDOWN_MENU_PLACEMENT_CONFIG$1, testId: TEST_IDS$5.dropdown, 
                // Closing the top-level dropdown menu closes all nested, too.
                onCloseAllDropdowns: dropdownFunctions.handleClose })))));
}
// memoized for *blazingly fast* performance
const RowActionsButton_Disabled = React__default.memo(function RowActionsButton_Disabled({ buttonStyle, buttonType, tooltip, treatContextMenuAsClick }) {
    const { t } = useTranslation();
    const expectMultipleActions = React__default.useMemo(() => {
        switch (buttonType) {
            case 'meatball': {
                return true;
            }
            case 'with-custom-icon':
            case 'with-label': {
                return false;
            }
        }
    }, [buttonType]);
    const assertedTooltip = React__default.useMemo(() => {
        if (tooltip !== undefined) {
            // preferred case: configured tooltip
            return tooltip;
        }
        // fallback case: default tooltip
        return expectMultipleActions
            ? t(I18N_KEYS$1.defaultTooltip_plural)
            : t(I18N_KEYS$1.defaultTooltip_singular);
    }, [expectMultipleActions, tooltip, t]);
    return (React__default.createElement(Tooltip, { content: assertedTooltip, testId: TEST_IDS$5.tooltip },
        React__default.createElement("div", { className: cx$H('row-action__container') },
            React__default.createElement(RowActionsButton_Shared, { buttonStyle: buttonStyle, disabled: true, isLoading: false, treatContextMenuAsClick: treatContextMenuAsClick }))));
});
const RowActionsButton_Shared = React__default.memo(function RowActionsButton_Shared({ buttonStyle, disabled = false, dropdownsOpen = false, isLoading = false, treatContextMenuAsClick, onClick }) {
    var _a;
    const buttonRef = React__default.useRef(null);
    const handleWidthChange = (size) => {
        var _a;
        const width = (_a = size.width) !== null && _a !== void 0 ? _a : 0;
        buttonStyle.updateWidth(width + 16); //account for padding - to do: revisit this
    };
    return (React__default.createElement("div", { className: cx$H('row-action__container'), "data-test": TEST_IDS$5.rowActionsButton },
        React__default.createElement(SizeManager, { elemRef: buttonRef, ignore: "height" // only listen for width changes
            , onSizeChange: handleWidthChange }),
        React__default.createElement("div", { ref: buttonRef },
            React__default.createElement(ButtonBase, { customDataProps: {
                    // edge case: the row-actions button should has a customized (UX) active color.
                    // Caveat: This is only applied to tertiary buttons. The with-label variant is secondary.
                    'data-is-row-actions-button': true
                }, className: cx$H(buttonStyle.className, {
                    focus: dropdownsOpen
                }), disabled: disabled || isLoading, icon: buttonStyle.icon, iconFillClass: cx$H('row-action__icon', { disabled }), iconSize: 16, isLoading: isLoading, size: "md", type: buttonStyle.buttonType, onClick: onClick, onContextMenu: (e) => {
                    // case: normal context-menu events
                    if (!treatContextMenuAsClick)
                        return;
                    // case: treating context-menu events as clicks
                    CancelReactEvent(e);
                    // don't allow click of disabled or loading buttons
                    if (disabled || isLoading)
                        return;
                    // treat context-menu events as clicks
                    onClick && onClick();
                }, appearFocused: dropdownsOpen }, (_a = buttonStyle.label) !== null && _a !== void 0 ? _a : ''))));
});
//#endregion "Shared" in the diagram

const DROPDOWN_MENU_PLACEMENT_CONFIG = {
    placement: 'right-start',
    fallbackPlacements: [
        'left-start',
        'right-end',
        'left-end'
    ]
};
const OFFSET_CONFIG = {
    offset: -1, // set by eye in DX-337
    skid: 0
};
const TEST_IDS$4 = {
    dropdown: `row-actions-dropdown`,
    shroud: `row-actions-button-shroud`
};
function RowActionsContextMenu({ bag, rowActionsConfig: config }) {
    // the button-renderer logic would go here; but it is irrelevant
    return (match(config)
        .with({
        type: P.union('multi-action', 'single-action', 'multi-action-context-menu')
    }, (config) => match(config.modeConfig)
        .with({ mode: 'single' }, function (modeConfig) {
        return (React__default.createElement(RowActionsContextMenu_ForSingleRow, { bag: bag, modeConfig: modeConfig, rowActionsConfig: config }));
    })
        .with({ mode: 'bulk-and-single' }, function (modeConfig) {
        return (React__default.createElement(RowActionsContextMenu_BulkAndSingleRow, { bag: bag, modeConfig: modeConfig, rowActionsConfig: config }));
    })
        .exhaustive())
        /*
      .with(
        {
          type: P.union(
            'multi-action-conditionable',
            'single-action-conditionable'
          )
        },
        (config) =>
          match(config.modeConfig)
            .with({ mode: 'single' }, function (modeConfig): JSX.Element {
              return (
                <RowActionsContextMenu_ForSingleRow_Conditionable
                  bag={bag}
                  modeConfig={modeConfig}
                  rowActionsConfig={config}
                />
              );
            })
            .with(
              { mode: 'bulk-and-single' },
              function (modeConfig): JSX.Element {
                return (
                  <RowActionsContextMenu_BulkAndSingleRow_Conditionable
                    bag={bag}
                    modeConfig={modeConfig}
                    rowActionsConfig={config}
                  />
                );
              }
            )
            .exhaustive()
      )
      */
        .exhaustive());
}
function RowActionsContextMenu_ForSingleRow({ bag, modeConfig, rowActionsConfig }) {
    var _a;
    const actions = rowActionsConfig.type === 'single-action'
        ? [rowActionsConfig.action]
        : rowActionsConfig.actions;
    const { menuConfig } = rowActionsConfig;
    const { currentId } = modeConfig;
    const menuTree = RowActionsMenuTrees.useSingleTree({
        actions,
        currentId,
        singleTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.single,
        showDisabledRootMenu: true
    });
    if (menuTree === null)
        return null;
    return (React__default.createElement(RowActionsContextMenu_WithMenuTree, { bag: bag, menuTree: menuTree, rowActionsConfig: rowActionsConfig }));
}
/*
function RowActionsContextMenu_ForSingleRow_Conditionable({
  bag,
  modeConfig,
  rowActionsConfig
}: Readonly<{
  bag: ContextMenuBag;
  modeConfig: ADSInternal_RAC_Menu_ModeConfig_Single_Conditionable;
  rowActionsConfig:
    | ADSInternal_RowActionsConfig_MultiAction_Conditionable
    | ADSInternal_RowActionsConfig_SingleAction_Conditionable;
}>): null | JSX.Element {
  const actions =
    rowActionsConfig.type === 'single-action-conditionable'
      ? ([rowActionsConfig.action] as const)
      : rowActionsConfig.actions;
  const { currentId } = modeConfig;
  const { conditionalActionsVisibilitiesMetadata, menuConfig } =
    rowActionsConfig;

  const menuTree = RowActionsMenuTrees.useSingleTree_Conditionable({
    actions,
    conditionalActionsVisibilitiesMetadata,
    currentId,
    singleTitleConfig: menuConfig?.titleConfig?.single,
    showDisabledRootMenu: true
  });

  if (menuTree === null) return null;

  return (
    <RowActionsContextMenu_WithMenuTree
      bag={bag}
      menuTree={menuTree}
      rowActionsConfig={rowActionsConfig}
    />
  );
}
*/
function RowActionsContextMenu_BulkAndSingleRow({ bag, modeConfig, rowActionsConfig }) {
    var _a, _b;
    const actions = rowActionsConfig.type === 'single-action'
        ? [rowActionsConfig.action]
        : rowActionsConfig.actions;
    const { menuConfig } = rowActionsConfig;
    const { checkedIds, currentId } = modeConfig;
    const menuTree = RowActionsMenuTrees.useBulkAndSingleTree({
        actions,
        checkedIds,
        currentId,
        bulkTitleConfig: (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _a === void 0 ? void 0 : _a.bulk,
        singleTitleConfig: (_b = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.titleConfig) === null || _b === void 0 ? void 0 : _b.single,
        showDisabledRootMenu: true
    });
    if (menuTree === null)
        return null;
    return (React__default.createElement(RowActionsContextMenu_WithMenuTree, { bag: bag, menuTree: menuTree, rowActionsConfig: rowActionsConfig }));
}
/*
function RowActionsContextMenu_BulkAndSingleRow_Conditionable({
  bag,
  modeConfig,
  rowActionsConfig
}: Readonly<{
  bag: ContextMenuBag;
  modeConfig: ADSInternal_RAC_Menu_ModeConfig_BulkAndSingle_Conditionable;
  rowActionsConfig:
    | ADSInternal_RowActionsConfig_MultiAction_Conditionable
    | ADSInternal_RowActionsConfig_SingleAction_Conditionable;
}>): null | JSX.Element {
  const actions =
    rowActionsConfig.type === 'single-action-conditionable'
      ? ([rowActionsConfig.action] as const)
      : rowActionsConfig.actions;
  const { checkedIds, checkedIdsSet, currentId } = modeConfig;
  const { menuConfig, conditionalActionsVisibilitiesMetadata } =
    rowActionsConfig;

  const menuTree = RowActionsMenuTrees.useBulkAndSingleTree_Conditionable({
    actions,
    checkedIds,
    checkedIdsSet,
    conditionalActionsVisibilitiesMetadata,
    currentId,
    bulkTitleConfig: menuConfig?.titleConfig?.bulk,
    singleTitleConfig: menuConfig?.titleConfig?.single,
    showDisabledRootMenu: true
  });

  if (menuTree === null) return null;

  return (
    <RowActionsContextMenu_WithMenuTree
      bag={bag}
      menuTree={menuTree}
      rowActionsConfig={rowActionsConfig}
    />
  );
}
*/
function RowActionsContextMenu_WithMenuTree({ bag: contextMenuBag, menuTree, rowActionsConfig }) {
    const { closeMenu: onCloseAllDropdowns } = contextMenuBag;
    const [dropdownBag, dropdownFunctions] = useDropdownForDropdownMenu({
        currentMenuTree: menuTree,
        openOnArrowDown: false,
        keydownConfig: {
            listenTo: 'anchor-and-dropdown'
        },
        openOnSpace: false,
        onEscapeKey: onCloseAllDropdowns
        // not using the dropdown bag as the source of truth for the anchor ref
    });
    // 📦 unwrap
    const { menuConfig } = rowActionsConfig;
    const { dropdown, dropdownProps: _dropdownProps
    // dropdownAnchorRef - not using use the dropdown bag as the source of truth for the anchor ref
     } = dropdownBag;
    const { activeRowIndex } = dropdown;
    const dropdownProps = Object.assign(Object.assign({}, _dropdownProps), { anchorEl: null, open: contextMenuBag.rootContext.open, contextMenuBag: contextMenuBag });
    // block scope: propagate from the source of truth to the use-dropdown hook
    {
        const effectRef = React__default.useRef({ setOpen: dropdown.setOpen });
        React__default.useEffect(() => {
            effectRef.current = { setOpen: dropdown.setOpen };
        });
        React__default.useEffect(() => {
            effectRef.current.setOpen(contextMenuBag.rootContext.open);
        }, [contextMenuBag.rootContext.open]);
    }
    if (!contextMenuBag.rootContext.open) {
        return null;
    }
    return (React__default.createElement("div", { onClick: CancelReactEvent, onContextMenu: CancelReactEvent },
        React__default.createElement(Shroud, { containsAlert: false, onClick: onCloseAllDropdowns, testId: TEST_IDS$4.shroud },
            React__default.createElement(ResizeListenerManager, { onResize: onCloseAllDropdowns }),
            React__default.createElement(DropdownMenu, { activeRowIndex: activeRowIndex, buttonSize: menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.menuButtonSize, currentDropdownFunctions: dropdownFunctions, currentDropdownProps: dropdownProps, depth: 0, menuModality: "context", menuTree: menuTree, 
                // TODO - Is this right?
                menuWidth: "regular", 
                // This component is recursive; and we do not want each dropdown's minimum width to depend on its parent.
                minWidthMatchAnchor: false, offsetConfig: OFFSET_CONFIG, placementConfig: DROPDOWN_MENU_PLACEMENT_CONFIG, testId: TEST_IDS$4.dropdown, 
                // Closing the top-level dropdown menu closes all nested, too.
                onCloseAllDropdowns: onCloseAllDropdowns }))));
}

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$G = BindStyles(modules_b8d590e8);
const DataGridCell = ({ alignText, cell, colIndex, columnName, isClickable = false, row, testId, onClick, onHover }) => {
    var _a, _b, _c;
    const cellContent = row && cell ? (cell.isJSX ? (cell.content) : (React__default.createElement(CellText, { alignText: alignText }, cell.content))) : (React__default.createElement(SkeletonLoader, { height: 20 }));
    return (React__default.createElement(ClickEventBoundary, { allowPropagate: !((_a = cell === null || cell === void 0 ? void 0 : cell.id) === null || _a === void 0 ? void 0 : _a.includes(SPECIAL_COLUMN_TYPES.nestedToggle)) || !isClickable },
        React__default.createElement("div", { "data-column-name": columnName, "data-test": testId, onMouseEnter: () => onHover(colIndex), className: cx$G('cell', { isClickable }, ((_b = cell === null || cell === void 0 ? void 0 : cell.id) === null || _b === void 0 ? void 0 : _b.includes(SPECIAL_COLUMN_TYPES.rowActions)) && 'rowActions', ((_c = cell === null || cell === void 0 ? void 0 : cell.id) === null || _c === void 0 ? void 0 : _c.includes(SPECIAL_COLUMN_TYPES.nestedToggle)) && 'nest'), onClick: (e) => onClick && onClick(e.altKey) },
            React__default.createElement("div", { className: cx$G('innerCell') }, cellContent))));
};

const cx$F = BindStyles(modules_b8d590e8);
function DataGridRowChildContainer({ animateOnRender = true, containerRef, rowDataItem, testId, wantToUnmount, childContent, unMount }) {
    // We get access to the ability to animate our exit from
    // AnimateHeightRender component (HOC). So we need to hoist
    // that up into this closure.
    let exit = () => null;
    React__default.useEffect(() => {
        if (wantToUnmount) {
            exit(unMount);
        }
    }, [wantToUnmount, unMount]);
    const content = React__default.useMemo(() => match(childContent)
        .with({ type: 'component' }, (config) => {
        return (React__default.createElement(config.component, { row: rowDataItem }));
    })
        .otherwise((fn) => {
        return fn(rowDataItem);
    }), [childContent, rowDataItem]);
    return (React__default.createElement("div", { "data-test": testId, ref: containerRef, className: cx$F('rowChildContainer') },
        React__default.createElement(AnimateHeightRender, { animateOnRender: animateOnRender, animationProps: {
                animateOpacity: false
            } }, ({ animateExit }) => {
            exit = animateExit;
            return React__default.createElement("div", { className: "px-200 py-100" }, content);
        })));
}

var css$w = ".DataGridToggleIcon_module_toggleIcon__66ec7534{cursor:pointer;width:18px}.DataGridToggleIcon_module_toggleIcon__66ec7534 svg{transform:rotate(-90deg);transition:none}.DataGridToggleIcon_module_toggleIcon__66ec7534.DataGridToggleIcon_module_open__66ec7534 svg{transform:rotate(0)}.DataGridToggleIcon_module_animate__66ec7534 svg{transition:all .2s cubic-bezier(.78,.14,.15,.86)}.DataGridToggleIcon_module_nested__66ec7534{color:#585c6a;width:16px}.DataGridToggleIcon_module_nest1__66ec7534{margin-left:-1px}";
window.ADS.injectStyle(css$w,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/components/DataGridToggleIcon.module.scss");
var modules_6157e202 = {"toggleIcon":"DataGridToggleIcon_module_toggleIcon__66ec7534","open":"DataGridToggleIcon_module_open__66ec7534","animate":"DataGridToggleIcon_module_animate__66ec7534","nested":"DataGridToggleIcon_module_nested__66ec7534","nest-1":"DataGridToggleIcon_module_nest1__66ec7534"};

const cx$E = BindStyles(modules_6157e202);
const DataGridToggleIcon = ({ onClick, open, animate = false, nested, nestLevel }) => {
    return (React__default.createElement(Icon, { customDataProps: {
            'data-is-open': open
        }, size: 16, icon: "ChevronIcon", className: cx$E('toggleIcon', { open }, { animate }, { nested }, nested && `nest-${nestLevel}`), onClick: onClick }));
};
DataGridToggleIcon.displayName = 'DataGridToggleIcon';

const DEFAULTS$1 = {
    contextMenuBag: DEFAULTS$6.contextMenuBag,
    contextMenuMetadata: {
        isCurrentRowFirst: null,
        isCurrentRowLast: null,
        showingTopOfGrid: null,
        showingBottomOfGrid: null
    },
    /**
     * We default to *not* having a row-actions context menu:
     * - computationally expensive
     * - not always needed (exists as a Chimera-only feature to keep parity with Epic
     *   Classic as of DX-337)
     *
     * This way, we only "pay for" the row-actions context menu's CPU cost when actually in use.
     */
    contextMenuProp: {
        contextMenuBagOption: None
    }
};

const TEST_IDS$3 = {
    childContainerToggleCell: (rowIndex) => `row-${rowIndex}-child-container-toggle-cell`,
    nestedRowsToggleCell: (rowIndex) => `row-${rowIndex}-nested-rows-toggle-cell`,
    rowChildContainer: (gridTestId, rowIndex) => `${gridTestId}-row-${rowIndex}-child-container`
};
const cx$D = BindStyles(modules_b8d590e8);
const EMPTY_CELL = new SearchableCell('empty-cell', () => '');
const ADSInternal_DataGridRow = ({ animateToggle = false, columns, commonId, contextMenuBagOption, generation, gridTestId, insetClass = '', isCheckboxDisabled = false, isChecked = 'close', isSelectable, isSelected = false, lastChecked = false, lastRow = false, rowActionsConfig, rowData, rowId, rowIndex, showChildContainer, specialColumns, checkboxRenderer, childContainerContent, hideChildContainer, onChecked, onContextMenu, onDoubleClicked, onRowHeightChange, onRowHover, onSelected, refresh, toggleNested, toggleShowChildContainer }) => {
    var _a, _b, _c, _d, _e, _f;
    const contextMenuBag = OptionUtils.value(contextMenuBagOption, DEFAULTS$1.contextMenuBag);
    const childContainerRef = React__default.useRef(null);
    const isMountedRef = useIsMountedRef();
    const [showChildren, setShowChildren] = React__default.useState(false);
    const rowRef = React__default.useRef(null);
    const focusableRowRef = React__default.useRef(null);
    // This is weird but if the user closes or opens the child container, then we want
    // to animate. If not (i.e. being rendered / unmounted via scrolling) we do not
    // want to animate. Default is not to animate (scrolling). Only when users toggles
    // do we flip the animate flag on. When it's unmounted via scrolling it will be reset
    // back to false.
    const [animate, setAnimate] = React__default.useState(false);
    // If we are animating our child row opening / closing, then we need to track
    // internally if our child container is going to be rendered or not. If we are not animating
    // then we can match the `showChildContainer` prop passed in. In order for the
    // animation to work, we need to leave it run it's course, and then unmount
    // the child container.
    const [_showChildContainer, _setShowChildContainer] = React__default.useState(!animate ? showChildContainer : false);
    React__default.useEffect(() => {
        if (!isMountedRef.current) {
            return;
        }
        if (showChildContainer) {
            _setShowChildContainer(true);
        }
    }, [isMountedRef, showChildContainer]);
    const handleRowHeightChange = React__default.useCallback(function ({ height }) {
        if (!onRowHeightChange)
            return;
        if (height === null || height <= 0)
            return;
        onRowHeightChange(height);
    }, [onRowHeightChange]);
    // If we animate the closing of a child container, when it's done animating
    // it will call this function so we can actually hide it
    const unMountContainer = React__default.useCallback(() => {
        _setShowChildContainer(false);
    }, [_setShowChildContainer]);
    const handleChildContainerToggle = () => {
        setAnimate(true);
        toggleShowChildContainer();
    };
    const handleNestedToggle = (family) => {
        setAnimate(true);
        toggleNested(family);
    };
    const handleCellClick = (column, alt = false) => {
        switch (column.name) {
            case SPECIAL_COLUMN_TYPES.rowChildContainer:
                handleChildContainerToggle();
                break;
            case SPECIAL_COLUMN_TYPES.nestedToggle:
                handleNestedToggle(alt);
                break;
        }
    };
    const handleOnClick = (e) => {
        onSelected(e.altKey, e.ctrlKey, e.shiftKey, e.metaKey, rowRef.current, focusableRowRef.current, e);
    };
    const handleHover = (column) => {
        let special;
        switch (column) {
            case SPECIAL_COLUMN_INDEX.rowChildContainer:
                special = 'childContainer';
                break;
            case SPECIAL_COLUMN_INDEX.nestedToggle:
                special = 'nestedToggle';
                break;
            case SPECIAL_COLUMN_INDEX.checkbox:
                special = 'checkbox';
                break;
        }
        onRowHover({ row: rowIndex, col: column, special });
    };
    React__default.useEffect(() => {
        let timeOutId;
        if (showChildContainer && isMountedRef.current) {
            timeOutId = window.setTimeout(() => {
                setShowChildren(true);
            }, 5);
        }
        else if (!showChildContainer) {
            setShowChildren(false);
        }
        return () => {
            // Cleanup function to cancel the setTimeout if component is unmounted
            clearTimeout(timeOutId);
        };
    }, [isMountedRef, showChildContainer]);
    const rowIsLoading = rowData === null || rowData === undefined;
    const rowHasChildRows = !rowIsLoading && dataItemHasChildRows(rowData === null || rowData === void 0 ? void 0 : rowData.item);
    const hasChildContainerContent = !isNil$1(childContainerContent);
    const hideChildContainerContent = !isNil$1(hideChildContainer) && hideChildContainer(rowId);
    const rowHasChildContainer = !rowIsLoading && hasChildContainerContent && !hideChildContainerContent;
    const [checkBoxDisabled, checkBoxTooltip, checkboxHidden] = React__default.useMemo(() => {
        var _a, _b, _c;
        if (rowIsLoading) {
            return [true, '', true];
        }
        const renderer = checkboxRenderer && checkboxRenderer(rowData === null || rowData === void 0 ? void 0 : rowData.item);
        return [
            (_a = renderer === null || renderer === void 0 ? void 0 : renderer.disabled) !== null && _a !== void 0 ? _a : false,
            (renderer === null || renderer === void 0 ? void 0 : renderer.disabled) ? (_b = renderer.tooltip) !== null && _b !== void 0 ? _b : '' : '',
            (renderer === null || renderer === void 0 ? void 0 : renderer.disabled) ? (_c = renderer.hidden) !== null && _c !== void 0 ? _c : false : false
        ];
    }, [checkboxRenderer, refresh, rowData === null || rowData === void 0 ? void 0 : rowData.item, rowIsLoading]);
    const supportsRowActionsContextMenu = React__default.useMemo(() => RowActionsConfigUtils.rowSupportsRowActionsContextMenus(generation, rowActionsConfig, rowData), [generation, rowActionsConfig, rowData]);
    const handleContextMenuClick = React__default.useCallback((mouseEvent) => {
        var _a, _b, _c;
        onContextMenu && onContextMenu(rowId);
        if (
        // [exit] Inapplicable Case: this row does not support the row-actions context menu
        !supportsRowActionsContextMenu) {
            return;
        }
        if (
        // pre-condition: needed for calling Node.contains() see: https://github.com/facebook/flow/issues/4799#issuecomment-326992974
        !(mouseEvent.target instanceof Node) ||
            (
            // [exit] Inapplicable Case: this row's child container cannot open the row-actions context menu
            (_a = childContainerRef.current) === null || _a === void 0 ? void 0 : _a.contains(mouseEvent.target))) {
            return;
        }
        /*
         * We are now in the following case and expect the following behavior(s):
         *
         * [Applicable] Case: Right clicked on a row that has row actions
         *
         * Behavior(s):
         * 1) Hide the browser's default context menu.
         * 2) Prevent the context-menu event from propagation its the parent container.
         * 3) Show ADS' custom context menu.
         */
        // 1) Hide the browser's default context menu.
        mouseEvent.preventDefault();
        // 2) Prevent the context-menu event from propagation its the parent container.
        mouseEvent.stopPropagation();
        // 3) Show ADS' custom context menu.
        mouseEvent.persist();
        (_b = contextMenuBag.rootContext) === null || _b === void 0 ? void 0 : _b.refs.setPositionReference({
            getBoundingClientRect: function () {
                return {
                    // virtual element without height or width
                    height: 0,
                    width: 0,
                    x: mouseEvent.clientX,
                    y: mouseEvent.clientY,
                    left: mouseEvent.clientX,
                    right: mouseEvent.clientX,
                    top: mouseEvent.clientY,
                    bottom: mouseEvent.clientY
                };
            }
        });
        (_c = contextMenuBag.rootContext) === null || _c === void 0 ? void 0 : _c.onOpenChange(true, mouseEvent.nativeEvent, 'click');
    }, [
        contextMenuBag.rootContext,
        supportsRowActionsContextMenu,
        rowId,
        onContextMenu
    ]);
    const clickPoint = useClickPoint(rowRef.current, (_a = contextMenuBag.rootContext) === null || _a === void 0 ? void 0 : _a.elements.reference, (_b = contextMenuBag.rootContext) === null || _b === void 0 ? void 0 : _b.open);
    useRowPosition(rowRef.current, (_d = (_c = contextMenuBag.rootContext) === null || _c === void 0 ? void 0 : _c.open) !== null && _d !== void 0 ? _d : false, contextMenuBag.closeMenu);
    const { isCurrentRowFirst, showingTopOfGrid } = OptionUtils.value(RowActionsConfigUtils.getContextMenuMetadataOption(rowActionsConfig), DEFAULTS$1.contextMenuMetadata);
    return (React__default.createElement("div", Object.assign({ "data-test": "row", "data-overlaps-header": isCurrentRowFirst && showingTopOfGrid, "data-row-number": rowIndex, onClick: handleOnClick, onContextMenu: handleContextMenuClick, onDoubleClick: onDoubleClicked, className: cx$D('row', insetClass.trim().split(' '), rowData && rowData.parents && `nest-${rowData.parents.length}`, {
            isFocused: (_e = contextMenuBag.rootContext) === null || _e === void 0 ? void 0 : _e.open,
            rowHasChildRows,
            rowHasChildContainer,
            lastRow,
            empty: !rowData,
            childContainerOpen: showChildContainer,
            selected: isSelected,
            isSelectable
        }) }, (contextMenuBag.getReferenceProps &&
        contextMenuBag.getReferenceProps()), { ref: rowRef }),
        React__default.createElement("div", { id: `${commonId}-focusable-row-${rowIndex}`, "data-ads-component-type": "dataGridRow", ref: focusableRowRef, tabIndex: -1, className: cx$D('focusableRowEl'), "data-focusable-row-number": rowIndex, "data-test": `${gridTestId}-focusable-row-${rowIndex}` }),
        specialColumns.map((c, index) => {
            switch (c.name) {
                case SPECIAL_COLUMN_TYPES.rowChildContainer: {
                    const rowChildContent = new SearchableCell(`${c.name}-${index}`, () => rowHasChildContainer ? (React__default.createElement(DataGridToggleIcon, { open: showChildContainer })) : (React__default.createElement(React__default.Fragment, null)));
                    return (React__default.createElement(DataGridCell, { cell: rowChildContent, colIndex: SPECIAL_COLUMN_INDEX.rowChildContainer, columnName: c.name, isClickable: c.cellIsClickable && rowHasChildContainer, key: c.name, row: rowData, rowIndex: rowIndex, testId: TEST_IDS$3.childContainerToggleCell(rowIndex), onClick: () => handleCellClick(c), onHover: (col) => handleHover(col) }));
                }
                case SPECIAL_COLUMN_TYPES.nestedToggle: {
                    const nestedToggleContent = new SearchableCell(`${c.name}-${index}`, () => {
                        var _a;
                        return rowHasChildRows ? (React__default.createElement(DataGridToggleIcon, { open: showChildren, nested: true, nestLevel: (_a = rowData.parents) === null || _a === void 0 ? void 0 : _a.length, animate: animateToggle })) : (React__default.createElement(React__default.Fragment, null));
                    });
                    return (React__default.createElement(DataGridCell, { cell: nestedToggleContent, colIndex: SPECIAL_COLUMN_INDEX.nestedToggle, columnName: c.name, isClickable: c.cellIsClickable && rowHasChildRows, key: c.name, row: rowData, rowIndex: rowIndex, testId: TEST_IDS$3.nestedRowsToggleCell(rowIndex), onClick: (alt) => handleCellClick(c, alt), onHover: (col) => handleHover(col) }));
                }
                case SPECIAL_COLUMN_TYPES.checkbox: {
                    const checkboxContent = new SearchableCell(`${c.name}-${index}`, () => checkboxHidden ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(StandAloneCheckbox, { preventClickPropagation: true, disabled: isCheckboxDisabled || checkBoxDisabled, tooltip: checkBoxDisabled ? checkBoxTooltip : '', name: `${rowId}`, testId: `row-${rowIndex}-checkbox`, className: cx$D('checkbox', isChecked.includes('mix') && 'indeterminate', lastChecked && 'lastChecked'), type: "reverse", ghost: isChecked.includes('ghost'), value: ['open', 'ghost-open', 'mix', 'ghost-mix'].includes(isChecked), onChange: (e) => {
                            onChecked && onChecked(e);
                        } })));
                    return (React__default.createElement(DataGridCell, { key: c.name, columnName: c.name, row: rowData, cell: checkboxContent, rowIndex: rowIndex, colIndex: SPECIAL_COLUMN_INDEX.checkbox, onHover: (col) => handleHover(col), isClickable: c.cellIsClickable }));
                }
                case SPECIAL_COLUMN_TYPES.rowActions: {
                    const rowActionsContent = new SearchableCell(`${c.name}-${index}`, () => {
                        // if the row is loading, short circuit and don't waste time rendering the row-actions button
                        if (rowIsLoading) {
                            return React__default.createElement(React__default.Fragment, null);
                        }
                        // This case should never happen due to how the special columns are added in the data-grid-base-core component.
                        if (rowActionsConfig.type === 'feature-disabled') {
                            return React__default.createElement(React__default.Fragment, null);
                        }
                        // This case should never happen due to how the special columns are added in the data-grid-base-core component.
                        if (rowActionsConfig.type === 'multi-action-context-menu') {
                            return React__default.createElement(React__default.Fragment, null);
                        }
                        // if the row action is not for this generation
                        // don't render it.
                        if (rowActionsConfig.buttonConfig.generation !== generation) {
                            return React__default.createElement(React__default.Fragment, null);
                        }
                        // OR if the rowActionsButton is "super-disabled" (hidden),
                        // don't render it.
                        if ((rowActionsConfig.type === 'multi-action' ||
                            rowActionsConfig.type === 'multi-action-conditionable' ||
                            rowActionsConfig.type === 'single-action' ||
                            rowActionsConfig.type === 'single-action-conditionable') &&
                            rowActionsConfig.buttonConfig.renderer) {
                            const rendererResult = rowData.item &&
                                rowActionsConfig.buttonConfig.renderer(rowData.item);
                            if (!rendererResult ||
                                ((rendererResult === null || rendererResult === void 0 ? void 0 : rendererResult.disabled) && (rendererResult === null || rendererResult === void 0 ? void 0 : rendererResult.hidden))) {
                                return React__default.createElement(React__default.Fragment, null);
                            }
                        }
                        return (React__default.createElement(RowActionsButton, { rowActionsConfig: rowActionsConfig, rowData: rowData, rowId: rowId, treatContextMenuAsClick: RowActionsConfigUtils.rowActionsButtonShouldTreatContextMenuAsClick(rowActionsConfig) }));
                    });
                    return (React__default.createElement(DataGridCell, { key: c.name, columnName: c.name, row: rowData, cell: rowActionsContent, rowIndex: rowIndex, colIndex: SPECIAL_COLUMN_INDEX.rowActions, onHover: (col) => handleHover(col) }));
                }
                case SPECIAL_COLUMN_TYPES.radio: {
                    const radioContent = new SearchableCell(`${c.name}-${index}`, () => (React__default.createElement(BaseRadio, { name: `single-select-radio-${commonId}`, testId: `row-${rowIndex}-radio`, className: cx$D('vibrant', {
                            disabled: c.isDisabled,
                            readOnly: c.isReadOnly
                        }), checked: isSelected, disabled: c.isDisabled, readOnly: c.isReadOnly, value: rowId, onClick: (event) => event.stopPropagation(), inputRef: rowIndex === 0 ? c.inputRef : undefined },
                        React__default.createElement(React__default.Fragment, null))));
                    return (React__default.createElement(DataGridCell, { key: c.name, columnName: c.name, row: rowData, cell: radioContent, rowIndex: rowIndex, colIndex: SPECIAL_COLUMN_INDEX.radio, onHover: (col) => handleHover(col), isClickable: c.cellIsClickable }));
                }
            }
            ADSWarn('Have a special column with no cell content', c);
            return null;
        }),
        columns.map((c, index) => {
            var _a;
            return (React__default.createElement(DataGridCell, { key: c.name, columnName: c.name, alignText: c.alignText, row: rowData, cell: (_a = rowData === null || rowData === void 0 ? void 0 : rowData.cells[`${index}`]) !== null && _a !== void 0 ? _a : EMPTY_CELL, rowIndex: rowIndex, colIndex: index, onClick: () => handleCellClick(c), onHover: (col) => handleHover(col), isClickable: c.cellIsClickable }));
        }),
        !rowIsLoading &&
            _showChildContainer &&
            rowHasChildContainer &&
            childContainerContent && (React__default.createElement(DataGridRowChildContainer, { animateOnRender: animate, containerRef: childContainerRef, rowDataItem: rowData.item, testId: TEST_IDS$3.rowChildContainer(gridTestId, rowIndex), wantToUnmount: !showChildContainer, unMount: unMountContainer, childContent: childContainerContent })),
        clickPoint &&
            ((_f = contextMenuBag.rootContext) === null || _f === void 0 ? void 0 : _f.open) &&
            /*
             * If the context menu open, we have already narrowed the row-actions config
             * type via `useSupportsRowActionsContextMenu` but needed to keep TS compiler
             * happy and re-narrow types.
             */
            rowActionsConfig.type !== 'feature-disabled' &&
            rowActionsConfig.type !== 'no-actions' &&
            rowActionsConfig.type !== 'single-action-conditionable' &&
            rowActionsConfig.type !== 'multi-action-conditionable' && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ClickDot, { x: clickPoint.x, y: clickPoint.y }),
            React__default.createElement(RowActionsContextMenu, { bag: contextMenuBag, rowActionsConfig: rowActionsConfig }))),
        React__default.createElement(SizeManager, { elemRef: rowRef, ignore: "width", onSizeChange: handleRowHeightChange })));
};
//#region utilities
const itemSchema = object({
    children: array().nonNullable().required().min(1)
}).required();
function dataItemHasChildRows(item) {
    return itemSchema.isValidSync(item);
}
const DEFAULT_XY = { x: null, y: null };
/**
 * Given a {@link rowRect} and a {@link clickedPointRect}, returns the 2D point
 * where the user clicked relative to the row's origin point.
 *
 * @param rowRect
 * @param clickedPointRect
 * @param open
 * @returns
 */
function useClickPoint(row = null, clickedPoint = null, open = false) {
    return React__default.useMemo(() => {
        var _a, _b;
        const { x: x1, y: y1 } = (_a = clickedPoint === null || clickedPoint === void 0 ? void 0 : clickedPoint.getBoundingClientRect()) !== null && _a !== void 0 ? _a : DEFAULT_XY;
        const { x: x2, y: y2 } = (_b = row === null || row === void 0 ? void 0 : row.getBoundingClientRect()) !== null && _b !== void 0 ? _b : DEFAULT_XY;
        if (!open)
            return null;
        if (x1 === null || y1 === null)
            return null;
        if (x2 === null || y2 === null)
            return null;
        const x = x1 - x2;
        const y = y1 - y2;
        return { x, y };
    }, [open, clickedPoint, row]);
}
/** See `ERROR_DELTA` in `useScrollPosition.ts` for information on this magic number. */
const ROW_POS_ERROR_DELTA = 2.0;
/** Closes context menu(s) if row's position changes, e.g., due to scrolling. */
function useRowPosition(row = null, contextMenuOpen, closeContextMenu) {
    const maybeInitialPosWhenOpenRef = React__default.useRef(None);
    // tunnel into effect(s) without being a dependency
    const effectRef = React__default.useRef({ closeContextMenu, row });
    // keep fresh
    React__default.useEffect(() => {
        effectRef.current = { closeContextMenu, row };
    });
    React__default.useEffect(() => {
        const { row } = effectRef.current;
        if (!contextMenuOpen || !row) {
            maybeInitialPosWhenOpenRef.current = None;
            return;
        }
        const { x, y } = row.getBoundingClientRect();
        maybeInitialPosWhenOpenRef.current = OptionUtils.some({ x, y });
    }, [contextMenuOpen]);
    React__default.useEffect(() => {
        const { row, closeContextMenu } = effectRef.current;
        if (!closeContextMenu)
            return;
        if (!contextMenuOpen)
            return;
        if (row === null)
            return;
        if (maybeInitialPosWhenOpenRef.current.type === 'none')
            return;
        const { x: xCurr, y: yCurr } = row.getBoundingClientRect();
        const { x: xInit, y: yInit } = maybeInitialPosWhenOpenRef.current.value;
        if (Math.abs(xCurr - xInit) < ROW_POS_ERROR_DELTA &&
            Math.abs(yCurr - yInit) < ROW_POS_ERROR_DELTA) {
            // the row has not moved within an error margin, so don't close
            return;
        }
        closeContextMenu();
        return;
    });
}
//#endregion utilities

/**
 * Allows the end user to call a hook conditionally without breaking React's 📏 rules of 🪝 hooks.
 *
 * If {@link useCondition} returns `true`, the {@link useHook} is called and the return value is passed to the component.
 * If {@link useCondition} returns `false`, the {@link defaultInternalProps} are passed to the component.
 *
 * @see {@link https://react.dev/warnings/invalid-hook-call-warning}
 *
 * @typeParam TPublicProps - the prop(s) accepted either the public component or the internal component
 * @typeParam TInternalProps - the prop(s) accepted by only the internal component from either {@link defaultInternalProps} or {@link useHook}
 *
 * @param Component - the component
 * @param useCondition - return `true` if you want to call {@link useHook}; `false` otherwise
 * @param useHook - accepts a readonly copy of the {@link TPublicProps} and returns the {@link TInternalProps} when the condition is true
 * @param defaultInternalProps - the default {@link TInternalProps} to pass to {@link Component} when the condition is false
 * @returns the {@link Component} in 1-or-2 HOC wrappers with either the {@link defaultInternalProps} or the return of {@link useHook} passed in for the internal prop(s)
 */
const withConditionalHook = (Component, useCondition, useHook, defaultInternalProps) => {
    /**
     * The component that calls {@link useHook} when the {@link useCondition} function returns `true`.
     *
     * @param props
     * @returns JSX
     */
    const HookComponent = (props) => {
        const internalProps = useHook(props);
        // ⚠️ Caveat: internal props will override public props with the same key
        return React__default.createElement(Component, Object.assign({}, props, internalProps));
    };
    /**
     * The component that conditionally calls one of two components based on the return of {@link useCondition}:
     * 1. when {@link useCondition} returns `false`, calls {@link Component} with {@link defaultInternalProps}
     * 2. when {@link useCondition} returns `true`, calls {@link HookComponent} with the return of {@link useHook}
     *
     * @param props
     * @returns the {@link Component} with either the {@link defaultInternalProps} or the return of {@link useHook} passed in for the internal prop(s)
     */
    const WithConditionalHook = (props) => {
        // 1) check the condition
        const shouldUseHook = useCondition(props);
        // 2) route to the appropriate component accordingly:
        // 2.A) route: with hook
        if (shouldUseHook) {
            return React__default.createElement(HookComponent, Object.assign({}, props));
        }
        // 2.B) route: without hook
        // ⚠️ Caveat: default, internal props will override public props with the same key
        return React__default.createElement(Component, Object.assign({}, props, defaultInternalProps));
    };
    return WithConditionalHook;
};

//#region 🪝 withConditionalHook - for row-actions context menus
function useRowActionsContextMenuHooks() {
    const [open, setOpen] = React__default.useState(false);
    const [contextMenu, setContextMenu] = React__default.useState(null);
    // https://github.com/floating-ui/floating-ui/blob/%40floating-ui/react%400.26.23/packages/react/src/hooks/useFloatingRootContext.ts#L24
    const rootContext = useFloatingRootContext({
        open,
        onOpenChange: setOpen,
        elements: {
            floating: contextMenu,
            reference: null // set via rootContext.refs.setPositionReference()
        }
    });
    // Note: `useDismiss` allows us to re-click outside to change the location of the context menu
    // https://github.com/floating-ui/floating-ui/blob/%40floating-ui/react%400.26.23/packages/react/src/hooks/useDismiss.ts#L123
    const dismiss = useDismiss(rootContext, { enabled: open, escapeKey: true });
    // https://github.com/floating-ui/floating-ui/blob/%40floating-ui/react%400.26.23/packages/react/src/hooks/useFocus.ts#L41
    const focus = useFocus(rootContext, { enabled: open });
    // https://github.com/floating-ui/floating-ui/blob/%40floating-ui/react%400.26.23/packages/react/src/hooks/useRole.ts#L46
    const role = useRole(rootContext, { enabled: open, role: 'menu' });
    // https://github.com/floating-ui/floating-ui/blob/%40floating-ui/react%400.26.23/packages/react/src/hooks/useInteractions.ts#L97
    const { getFloatingProps, getReferenceProps } = useInteractions([
        dismiss,
        focus,
        role
    ]);
    const { onOpenChange, refs: { setPositionReference } } = rootContext;
    // Custom: DRY up the logic to close the context menu
    const closeMenu = React__default.useCallback(function () {
        onOpenChange(false);
        setContextMenu(() => null);
        setPositionReference(null);
    }, [onOpenChange, setContextMenu, setPositionReference]);
    return {
        contextMenuBagOption: OptionUtils.some({
            rootContext,
            closeMenu,
            getFloatingProps,
            getReferenceProps,
            setFloating: setContextMenu
        })
    };
}
// the condition for when to use the row-actions-context-menu hooks
function useSupportsRowActionsContextMenu({ generation, rowActionsConfig, rowData }) {
    return React__default.useMemo(() => RowActionsConfigUtils.rowSupportsRowActionsContextMenus(generation, rowActionsConfig, rowData), [generation, rowActionsConfig, rowData]);
}
function withConditionalRowActionsContextMenu(ADSInternal_DataGridRow) {
    return withConditionalHook(ADSInternal_DataGridRow, useSupportsRowActionsContextMenu, useRowActionsContextMenuHooks, DEFAULTS$1.contextMenuProp);
}
//#endregion 🪝 withConditionalHook - for row-actions context menus

const DataGridRow = withConditionalRowActionsContextMenu(ADSInternal_DataGridRow);

const cx$C = BindStyles(modules_b8d590e8);
const DataGridValidationAlert = ({ error, warning }) => {
    const alert = React__default.useMemo(() => {
        if (error) {
            return (React__default.createElement(InlineAlert, { closeable: false, type: BrandType.Error }, error));
        }
        if (warning) {
            return (React__default.createElement(InlineAlert, { closeable: false, type: BrandType.Warning }, warning));
        }
        return null;
    }, [error, warning]);
    return alert ? React__default.createElement("div", { className: cx$C('validationAlert') }, alert) : null;
};

/**
 * Will call the {@link handler} function when the 1) order, 2) number, or 3) names of the visible columns change.
 *
 * This calculation only occurs when the data grid is {@link isPaginated}. Will short circuit if not paginated.
 *
 * @param isPaginated
 * @param visibleColumns
 * @param handler
 * @param isFirstRun
 * @param registerRun
 */
function useHandleColumnOrderChanged(isPaginated, visibleColumns, handler, isFirstRun, registerRun) {
    const refsBag = React__default.useRef({
        shouldShortCircuit: !isPaginated,
        previouslyVisible: null,
        handler,
        isFirstRun,
        registerRun
    });
    React__default.useEffect(() => {
        // init: previously visible columns
        if (refsBag.current.previouslyVisible === null) {
            refsBag.current.previouslyVisible = visibleColumns.map((c) => c.name);
        }
    });
    // update: references to 1) is-paginated boolean, 2) handler function, and 3) first-run-logic
    React__default.useEffect(() => {
        refsBag.current.shouldShortCircuit = !isPaginated;
        refsBag.current.handler = handler;
        refsBag.current.isFirstRun = isFirstRun;
        refsBag.current.registerRun = registerRun;
    });
    // Calls handler function if the order, number, or names of the visible columns changes.
    React__default.useEffect(() => {
        // case: short circuit
        if (refsBag.current.shouldShortCircuit) {
            return;
        }
        const { handler, isFirstRun, registerRun } = refsBag.current;
        if (!isFirstRun('columnOrderAndVisibility')) {
            const columnNames = visibleColumns.map((c) => c.name);
            const haveChanged = !isEqual(refsBag.current.previouslyVisible, columnNames);
            if (!haveChanged) {
                return;
            }
            // update the previously visible columns
            refsBag.current.previouslyVisible = columnNames;
            // call the handler function
            handler();
        }
        registerRun('columnOrderAndVisibility');
    }, [visibleColumns]);
}

/**
 * A development-only utility component that displays the current state of an
 * open-close cache.
 */
function OpenCloseCacheFooter({ allRowsCount, cache, generation, type, visibleRowsCount }) {
    const hiddenExceptionsCount = cache.hiddenExceptionCount(visibleRowsCount);
    const relevantIdsListCount = cache.relevantIdListCount();
    const totalOpenCount = cache.totalOpen(visibleRowsCount, generation);
    const hiddenExceptionIds = cache.hiddenExceptionIds();
    const areIdsMixedType = hiddenExceptionIds.some((id) => typeof id === 'string') &&
        hiddenExceptionIds.some((id) => typeof id === 'number');
    const mode = cache.status();
    const disabled = cache.getDisabledList();
    return (React__default.createElement(Card, null,
        React__default.createElement("h2", null,
            type === 'check' ? 'Checkbox' : 'Open-Close',
            " Cache"),
        React__default.createElement("br", null),
        React__default.createElement(Separators, { top: false },
            "Mode: ",
            React__default.createElement("code", null, mode),
            React__default.createElement("br", null),
            "Type: ",
            React__default.createElement("code", null, type),
            React__default.createElement("br", null)),
        "N\u00BA of Rows: ",
        React__default.createElement("code", null, allRowsCount),
        React__default.createElement("br", null),
        "N\u00BA of Visible Rows: ",
        React__default.createElement("code", null, visibleRowsCount),
        React__default.createElement("br", null),
        "Total ",
        type === 'check' ? 'Checked' : 'Open',
        " Count:",
        ' ',
        React__default.createElement("code", null, totalOpenCount),
        React__default.createElement("br", null),
        "Relevant IDs Count: ",
        React__default.createElement("code", null, relevantIdsListCount),
        React__default.createElement("br", null),
        "Hidden-Exception-IDs Count: ",
        React__default.createElement("code", null, hiddenExceptionsCount),
        React__default.createElement("br", null),
        "Hidden Exception IDs:",
        ' ',
        hiddenExceptionIds.length > 0 ? (React__default.createElement("code", null,
            "[",
            hiddenExceptionIds
                .sort((a, b) => String(a).localeCompare(String(b)))
                .map((id) => areIdsMixedType && typeof id === 'string' ? `"${id}"` : id)
                .join(', '),
            "]")) : (React__default.createElement("code", null, "[none]")),
        React__default.createElement("br", null),
        "Disabled Indices:",
        ' ',
        React__default.createElement("code", null,
            "[",
            disabled.length > 0
                ? disabled.sort((a, b) => a - b).join(', ')
                : 'none',
            "]")));
}

var css$v = ".ReorderableRows_module_reorderableRowsBody__7ce6e3ef{height:50vh}.ReorderableRows_module_reorderableRowsBody__7ce6e3ef .ReorderableRows_module_directionalText__7ce6e3ef{display:block;max-width:640px;min-width:480px}.ReorderableRows_module_reorderableRowsBody__7ce6e3ef .ReorderableRows_module_rowSelect__7ce6e3ef{color:#363840;display:flex;flex-direction:row;height:calc(100% - 48px);justify-content:space-between;margin-top:24px}";
window.ADS.injectStyle(css$v,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DataGrid/rows/ReorderableRows.module.scss");
var modules_7f7b20a1 = {"reorderableRowsBody":"ReorderableRows_module_reorderableRowsBody__7ce6e3ef","directionalText":"ReorderableRows_module_directionalText__7ce6e3ef","rowSelect":"ReorderableRows_module_rowSelect__7ce6e3ef"};

const ReorderableRowsListContainer = ({ items, title, setDragIndices }) => {
    const [preferences, setPreferences] = React__default.useState(() => ({
        reorderableRowsDisplay: cloneDeep(items)
    }));
    const getList = React__default.useCallback((id) => {
        switch (id) {
            case 'reorderableRowsDisplay':
                return preferences.reorderableRowsDisplay;
            default:
                return [];
        }
    }, [preferences.reorderableRowsDisplay]);
    const [isDragging, setIsDragging] = React__default.useState(false);
    const handleOnDragEnd = (result) => {
        setIsDragging(false);
        const { source, destination } = result;
        // dropped outside the list
        if (!destination) {
            return;
        }
        // source.droppableId will always be 'reorderableRowsDisplay'
        if (source.droppableId === destination.droppableId) {
            const newItems = reorder(getList(source.droppableId), source.index, destination.index);
            setPreferences((prevState) => (Object.assign(Object.assign({}, prevState), { reorderableRowsDisplay: newItems })));
            setDragIndices({
                sourceIndex: source.index,
                destinationIndex: destination.index
            });
        }
    };
    const handleDragStart = React__default.useCallback(() => {
        setIsDragging(true);
    }, []);
    const draggableItems = React__default.useMemo(() => {
        return preferences.reorderableRowsDisplay.map((item) => {
            return {
                key: item.key,
                name: item.value,
                locked: false,
                lockedEnd: false
            };
        });
    }, [preferences.reorderableRowsDisplay]);
    return (React__default.createElement(React__default.Fragment, null, preferences.reorderableRowsDisplay && (React__default.createElement(DragDropContext, { onDragEnd: handleOnDragEnd, onDragStart: handleDragStart },
        React__default.createElement(DragAndDropList, { id: 'reorderableRowsDisplay', testId: 'sortable-rows-dnd-list', items: draggableItems, title: title, isDragging: isDragging })))));
};

const cx$B = BindStyles(modules_7f7b20a1);
const TEST_IDS$2 = {
    submitButton: (rest) => `reorderableRowsSubmit${rest !== null && rest !== void 0 ? rest : ''}`
};
const ReorderableRowsModal = ({ onClose, testId, reorderableRowsConfig, rowIdField, rows }) => {
    const [dragIndices, setDragIndices] = React__default.useState(null);
    const { onRowsSorted } = reorderableRowsConfig;
    const handleSortRows = React__default.useCallback((oldRows, sourceIndex, destinationIndex) => {
        const newRows = reorder(oldRows, sourceIndex, destinationIndex);
        const items = newRows.map((row) => row.data.item);
        if (onRowsSorted) {
            onRowsSorted(items);
        }
    }, [onRowsSorted]);
    const { t } = useTranslation();
    const displayedItems = React__default.useMemo(() => {
        return (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (rows === null || rows === void 0 ? void 0 : rows.map((row) => {
            return {
                value: row.data.item[reorderableRowsConfig.displayColumn],
                key: String(row.data.item[rowIdField])
            };
        })) || []);
    }, [reorderableRowsConfig.displayColumn, rows, rowIdField]);
    return (React__default.createElement(Modal, { open: true, title: reorderableRowsConfig.modalTitle, testId: "reorderableRowsModal", onClose: onClose },
        React__default.createElement(ModalBody, null,
            React__default.createElement("div", { className: cx$B('reorderableRowsBody') },
                React__default.createElement("span", { className: cx$B('directionalText') }, reorderableRowsConfig.modalDescription),
                React__default.createElement("div", { className: cx$B('rowSelect') },
                    React__default.createElement(ReorderableRowsListContainer, { items: displayedItems, setDragIndices: setDragIndices, title: reorderableRowsConfig.listName })))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(Button, { testId: testId ? `reorderableRowsCancel${testId}` : 'reorderableRowsCancel', type: "tertiary", onClick: onClose, className: "mr-100" }, t('CANCEL')),
            React__default.createElement(Button, { testId: TEST_IDS$2.submitButton(testId), type: "primary", submit: true, onClick: () => {
                    if (dragIndices) {
                        handleSortRows(rows, dragIndices.sourceIndex, dragIndices.destinationIndex);
                    }
                    onClose();
                } }, t('SAVE')))));
};

const TEST_IDS$1 = {
    triggerButton: 'reorderable'
};
const ReorderableRowsButton = ({ testId, reorderableRowsConfig, rowIdField, rows }) => {
    const [open, setOpen] = React__default.useState(false);
    const dataGridAppearsLoading = React__default.useMemo(() => RowsUtils.anyRowsAppearLoading(rows), [rows]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, { testId: TEST_IDS$1.triggerButton, type: "secondary", size: "md", onClick: () => setOpen(true), disabled: dataGridAppearsLoading }, reorderableRowsConfig.buttonLabel),
        open && (React__default.createElement(ReorderableRowsModal, { rowIdField: rowIdField, reorderableRowsConfig: reorderableRowsConfig, rows: rows, testId: testId, onClose: () => {
                setOpen(false);
            } }))));
};

function useDataGridColumns(columnModels, gridRef) {
    const [columnState, setColumnState] = React__default.useState({ status: 'frozen', width: '' });
    const columnsRef = React__default.useRef(columnModels);
    const freezeColumns = React__default.useCallback(() => {
        var _a;
        if (!columnsRef.current.length) {
            return;
        }
        // Our frozen widths are the columns current widths
        const widths = Array.from(((_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(':scope > [data-column]')) || []).map((el) => {
            return `${el.getBoundingClientRect().width}px`;
        });
        setColumnState((state) => {
            if (state.status === 'frozen') {
                return state;
            }
            return {
                status: 'frozen',
                width: widths.join(' ')
            };
        });
    }, [gridRef, setColumnState]);
    // Unfreeze columns, if force is true we will recalculate our column widths
    const unfreezeColumns = React__default.useCallback((force = false) => {
        if (!columnsRef.current.length) {
            return;
        }
        setColumnState((state) => {
            if (state.status === 'thawed' && !force) {
                return state;
            }
            // Unfrozen widths are the columns width settings
            return {
                status: 'thawed',
                width: columnsRef.current.map((c) => c.width).join(' ')
            };
        });
    }, [setColumnState]);
    React__default.useEffect(() => {
        columnsRef.current = columnModels;
        // Unfreeze our columns and force a recalculation of our column widths
        unfreezeColumns(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(columnsRef.current) !== JSON.stringify(columnModels)]);
    return { columnState, freezeColumns, unfreezeColumns };
}

const SELECTED_ROWS_DEP_MSG = 'The `selectedRows` prop. is deprecated. Use the replacement `selectedRow` prop.';
const ON_SELECTED_ROWS_DEP_MSG = 'The `onSelectedRowsChange` prop. is deprecated. Use the replacement `onSelectedRowChange` prop.';
const SELECTED_ROWS_MIX_MSG = 'Do not use the deprecated `selectedRow` and `selectedRows` props. Use only `selectedRow`';
const ON_SELECTED_ROWS_MIX_MSG = 'Do not use the deprecated `onSelectedRowsChange` and `onSelectedRowChange` props. Use only `onSelectedRowChange`';
const ON_SELECTABLE_COLUMNS_CHANGE_MSG = 'Do not use the deprecated `onColumnsChange`. Please use the replacement `onColumnsChange` within `selectableColumns`';
function useDeprecationWarnings(selectedRow, onSelectedRowChange, selectedRows, onSelectedRowsChange, onColumnsChange) {
    // warn if using a deprecated prop
    useADSWarnOnce(SELECTED_ROWS_DEP_MSG, selectedRows !== undefined);
    useADSWarnOnce(ON_SELECTED_ROWS_DEP_MSG, onSelectedRowsChange !== undefined);
    // warn if mixing deprecated and replacement props simultaneously
    useADSWarnOnce(SELECTED_ROWS_MIX_MSG, selectedRow !== undefined && selectedRows !== undefined);
    useADSWarnOnce(ON_SELECTED_ROWS_MIX_MSG, onSelectedRowChange !== undefined && onSelectedRowsChange !== undefined);
    useADSWarnOnce(ON_SELECTABLE_COLUMNS_CHANGE_MSG, onColumnsChange !== undefined);
}

const cx$A = BindStyles(modules_b8d590e8);
const I18N_KEYS = {
    actions: 'ACTIONS',
    bulkActionsTooltip: 'BULK_ACTIONS_COL_HEADER_TOOLTIP'
};
const VISIBILITY_BEHAVIOR_CONFIG_DEFAULT = {
    onlyScrollIfHidden: false
};
const TEST_IDS = {
    checkAllHeader: (dataGridTestID) => `${dataGridTestID}-check-all`,
    grid: (dataGridTestID) => `${dataGridTestID}-column-grid`,
    rowActionsHeader: (dataGridTestID) => `${dataGridTestID}-row-actions-header`,
    rowActionsHeaderTooltip: (dataGridTestID) => `${dataGridTestID}-row-actions-header-tooltip`,
    searchBox: (dataGridTestID) => `${dataGridTestID}-search-box`
};
const Spacer = ({ height }) => (React__default.createElement("div", { style: {
        height,
        gridColumnStart: 1,
        gridColumnEnd: -1
    } }));
/**
 * IMPORTANT! If you add any new props to this object, make sure to update the `DataGridBaseCore`,
 * `DataGrid`, and `DataGridPaginated` components to use the new props. Otherwise, they will not show
 * up in the ArgsTable of Storybook
 */
const defaultDataGridBaseProps = {
    hideFooter: false,
    maxHeight: 800,
    minWidth: 350,
    noResultsText: 'NO_ITEMS_FOUND',
    resultsText: 'ITEMS',
    rowIdField: 'id'
};
const searchablePropsDefaults = {
    enabled: false,
    highlightOnly: false,
    text: {
        placeholder: '',
        noResults: 'NO_RESULTS_FOUND'
    },
    searchTerm: '',
    modeState: {
        disabled: false
    }
};
const viewModePropsDefaults = {
    enabled: false,
    options: [{ text: 'All' }]
};
const nestedPropsDefaults = {
    enabled: false,
    sortChildren: false,
    resultsText: {}
};
const checkboxPropsDefaults = {
    enabled: false,
    hideCheckAll: false,
    disableShift: false,
    bypassDisabledList: false,
    text: {
        selectedResultsText: ''
    }
};
const radioPropsDefaults = {
    enabled: false
};
const columnResizeConfigDefaults = {
    enabled: false
};
const defaultSortableRowConfig = {
    enabled: false
};
// Number of milliseconds to wait before showing a loading indicator to the user
// when an action is taken that could take time to complete (i.e. sort columns, search etc).
const SHOW_LOADING_DELAY = 20;
const DataGridBaseCore = ({ customDataProps, actionContent, checkbox = checkboxPropsDefaults, rowActionsConfig = { type: 'feature-disabled' }, columns, dataSource, error, height, helpers, hideFooter = defaultDataGridBaseProps.hideFooter, initColumnSortState, maxHeight = defaultDataGridBaseProps.maxHeight, minHeight, minWidth = defaultDataGridBaseProps.minWidth, nested = nestedPropsDefaults, noResultsText = defaultDataGridBaseProps.noResultsText, onBlur, onCheckedRowsChange, onColumnsChange, onSort, onDataGridReady, onRowDoubleClicked, onSelectedRowsChange, onRowContextMenu, onSelectedRowChange, onViewModeChange, radio = radioPropsDefaults, resultsText = defaultDataGridBaseProps.resultsText, rowChildContainer, hideRowChildContainer, rowIdField = defaultDataGridBaseProps.rowIdField, searchable = searchablePropsDefaults, selectableColumns, selectedRows, selectedRow, testId = 'data-grid', viewMode, warning, viewModes = viewModePropsDefaults, debugConfig = null, isPaginated = false, actionContentRef, actionsMenuConfig, onVisibleRowsChange, columnResizeConfig = columnResizeConfigDefaults, reorderableRowsConfig = defaultSortableRowConfig }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    const { t } = useTranslation();
    const gridRef = React__default.useRef(null);
    const rowsRef = React__default.useRef(undefined);
    const dataReady = React__default.useRef(false);
    const [altHeld, setAltHeld] = React__default.useState(false);
    const [shiftHeld, setShiftHeld] = React__default.useState(false);
    const [ctrlcmdHeld, setCtrlcmdHeld] = React__default.useState(false);
    const [ctrlcmdCHeld, setCtrlcmdCHeld] = React__default.useState(false);
    const [hoverState, setHoverState] = React__default.useState();
    const [gridHeaderHover, setHeaderGridHover] = React__default.useState(false);
    const [gridHover, setGridHover] = React__default.useState(false);
    const [allowGhost, setAllowGhost] = React__default.useState(true);
    const size = useSize(gridRef.current);
    const [searchTerm, setSearchTerm] = React__default.useState((_a = searchable.initialSearchTerm) !== null && _a !== void 0 ? _a : searchablePropsDefaults.searchTerm);
    const scrollToSelected = React__default.useRef(false);
    const scrollDataReady = React__default.useRef(false);
    const [columnSortState, setColumnSortState] = React__default.useState(initColumnSortState || null);
    const [totalItems, setTotalItems] = React__default.useState(undefined);
    // Ideally, this should be managed via state. However, due to the current column header rendering method,
    // triggering the useEffect hook using state is not feasible.
    // Consider updating to use useState when we move away from storing rows as refs.
    const isCheckAllDisabled = React__default.useRef(false);
    const { registerRun, isFirstRun } = useIsFirstRun();
    const [isSearching, setIsSearching] = React__default.useState(false);
    const [elementToFocus, setElementToFocus] = React__default.useState(null);
    useDeprecationWarnings(selectedRow, onSelectedRowChange, selectedRows, onSelectedRowsChange, onColumnsChange);
    useADSWarnOnce('`radio.enabled` should only be set to true when using a selectable Data Grid.', !onSelectedRowChange && !onSelectedRowChange && !!(radio === null || radio === void 0 ? void 0 : radio.enabled));
    const rowActionsRendererEnabled = React__default.useMemo(() => {
        return (rowActionsConfig &&
            (rowActionsConfig.type === 'multi-action' ||
                rowActionsConfig.type === 'multi-action-conditionable' ||
                rowActionsConfig.type === 'single-action' ||
                rowActionsConfig.type === 'single-action-conditionable') &&
            rowActionsConfig.buttonConfig &&
            rowActionsConfig.buttonConfig.renderer);
    }, [rowActionsConfig]);
    // This was previously used to determine if the checkboxes were disabled based off the rowActionsConfig.
    // However, this has since changed because we are now able to have enabled checkboxes even if the row actions button is disabled.
    const getDisabledCheckboxRowsIndexes = React__default.useCallback(() => {
        var _a;
        const disabledIndices = [];
        if (checkbox.renderer) {
            if (rowsRef.current) {
                for (let index = 0; index < rowsRef.current.length; index++) {
                    const row = rowsRef.current[index];
                    if ((_a = row.data) === null || _a === void 0 ? void 0 : _a.item) {
                        const isDisabled = checkbox.renderer(row.data.item).disabled;
                        if (isDisabled) {
                            disabledIndices.push(index);
                        }
                    }
                }
            }
        }
        return disabledIndices;
    }, [checkbox]);
    // We need to store a timer references for when we need to show loading indicators
    // for situations like when the user searches or sorts a column and we are going to
    // leverage an outside source to do that work (i.e. server side API call). If getting
    // data takes awhile we want the user to have some feedback we are working on it. But when
    // client side we don't want a quick flash of a spinner icon as it causes weird flashes.
    const timersRef = React__default.useRef({ search: null, columnSort: null });
    const { state: toggleAnimate, start: startToggleAnimate } = useDelayedFalse();
    const { start: searchDebouce } = useDelayedFalse(500);
    // This indicates if we are in the middle of sorting the user's data or not.
    const [isSortingColumn, setIsSortingColumn] = React__default.useState(false);
    const [columnModels, setColumnModels] = React__default.useState([]);
    // We have some internal special columns like row child container or selected rows
    // that we need to treated differently as they are not part of the DataGrid content.
    const [specialColumns, setSpecialColumns] = React__default.useState([]);
    const visibleColumns = React__default.useMemo(() => columnModels.filter((c) => c.isVisible), [columnModels]);
    const [actionsColumnWidth, updateWidth] = useRACWidthConfig();
    const generation = 'buttonConfig' in rowActionsConfig
        ? (_b = rowActionsConfig.buttonConfig.generation) !== null && _b !== void 0 ? _b : CONSTANTS$1['default-generation']
        : undefined;
    const openCloseCacheRef = React__default.useRef(new OpenCloseCache('close', [], 'openclose', generation, checkbox.bypassDisabledList));
    const checkedCacheRef = React__default.useRef(new OpenCloseCache('close', [], 'check', generation, checkbox.bypassDisabledList));
    // We need to store our open close cache in a ref, and then use this when we update it
    // (react is silly sometimes, but this avoids )
    const refresh = useTrigger();
    // Apply searchable prop defaults in case they pass a partially filled search config
    defaultsDeep(searchable, searchablePropsDefaults);
    defaultsDeep(viewModes, viewModePropsDefaults);
    // When our grid is initializing, we don't mess with the columns.
    // It's going to render a row of data, figure out row height, and then finish
    // rendering it's first page of rows. After that we can then track if our
    // columns are frozen or thawed.
    const { columnState, freezeColumns, unfreezeColumns } = useDataGridColumns([...specialColumns, ...visibleColumns], gridRef);
    // Combines selectedRow and selectedRows to return the one selectedRow or undefined
    const combinedSelectedRow = React__default.useMemo(() => {
        if (!selectedRow) {
            if (!selectedRows || selectedRows.length < 1) {
                return undefined;
            }
            // 💀 Dangerous Code: TRow is not guaranteed to be a Record
            return selectedRows[0];
        }
        // 💀 Dangerous Code: TRow is not guaranteed to be a Record
        return selectedRow;
    }, [selectedRow, selectedRows]);
    const radioIsDisabled = radio.enabled && ((_c = radio.modeState) === null || _c === void 0 ? void 0 : _c.disabled);
    const radioIsReadOnly = radio.enabled && ((_d = radio.modeState) === null || _d === void 0 ? void 0 : _d.readOnly);
    // Combines the deprecated and new onSelectedRowChange props
    const handleOnSelectedRowChange = React__default.useCallback((row) => {
        // don't allow selection if the radio is enabled and is disabled or readOnly
        if (radioIsDisabled || radioIsReadOnly) {
            return;
        }
        onSelectedRowChange && onSelectedRowChange(row);
        onSelectedRowsChange && onSelectedRowsChange([row]);
    }, [
        onSelectedRowChange,
        onSelectedRowsChange,
        radioIsDisabled,
        radioIsReadOnly
    ]);
    const paginationLevel = ((_e = nested === null || nested === void 0 ? void 0 : nested.paginationLevel) !== null && _e !== void 0 ? _e : 'all') === 'parent' ? 0 : -1;
    // We process rows of data for DataGrid in the following manner:
    //  1. useDataSource passes us a pages of row data
    //  2. these are already processed to be searchable by DataGrid or in DataGridPaginated uses rowToData to process
    //  3. if we need to highlight only we do so
    // This hook manages getting data from a data source. By the time the rows
    // are passed to here they have been converted to be SearchableRows by DataGrid
    // and DataGridPaginated.
    const { lastPagination, rows, rowsLastChanged, getData, mapDataRows } = useDataSource(dataSource, paginationLevel);
    // This logic assumes that all placeholder rows are undefined, which is the case as of
    const dataGridAppearsLoading = React__default.useMemo(() => RowsUtils.allRowsAppearLoading(rows), [rows]);
    const { singlyActionableRowIds, singlyActionableRows, bulkActionableRowIds } = RowActionsConfigUtils.getActionableRowsAndIds(rows !== null && rows !== void 0 ? rows : [], rowIdField, checkedCacheRef.current, rowActionsConfig, checkbox.enabled, nested.enabled, dataGridAppearsLoading);
    rowsRef.current = rows;
    const rowsWithData = (_f = rowsRef.current) === null || _f === void 0 ? void 0 : _f.filter((row) => row.data !== undefined);
    // Debugging
    // console.log('Checked-Cache Status', checkedCacheRef.current.status());
    const conditionalRowActionsState = useConditionalRowActionsState(rowActionsConfig, singlyActionableRowIds, singlyActionableRows, rowIdField, rowsLastChanged, dataGridAppearsLoading, isPaginated, (_g = debugConfig === null || debugConfig === void 0 ? void 0 : debugConfig.showConditionableRowActionsConsoleLogs) !== null && _g !== void 0 ? _g : false);
    const sharedRowActionsConfig = useSharedInternalRowActionsConfig(conditionalRowActionsState, rowActionsConfig, isPaginated, updateWidth);
    // We are debouncing so we don't over fire when user types in search box or rapidly clicks around.
    // 100ms is an arbitrary number that seems to work well.
    // Create a memoized debounced function per instance
    const onVisibleRowsChangeDebounced = React__default.useMemo(() => {
        return debounce((rows, rowIdField, onVisibleRowsChange) => {
            var _a;
            const visibleRows = (_a = rows === null || rows === void 0 ? void 0 : rows.map((r) => {
                var _a, _b;
                const rowId = (_a = r.data) === null || _a === void 0 ? void 0 : _a.item[rowIdField];
                return rowId !== null && rowId !== undefined
                    ? { id: rowId, data: (_b = r.data) === null || _b === void 0 ? void 0 : _b.item }
                    : null;
            })) !== null && _a !== void 0 ? _a : [];
            // Passing array without filtering nulls (matching original behavior)
            onVisibleRowsChange(visibleRows);
        }, 100);
    }, []);
    /** tunnels dependencies into a useEffect without being in the dependency array */
    const visibleRowsTunnelRef = React__default.useRef({
        rowIdField,
        onVisibleRowsChange,
        onVisibleRowsChangeDebounced
    });
    // keep the references fresh in the tunnel each render
    React__default.useEffect(() => {
        visibleRowsTunnelRef.current = {
            rowIdField,
            onVisibleRowsChange,
            onVisibleRowsChangeDebounced
        };
    });
    const { setBatchSize, setRowIndexInFlight, isRowIndexInFlight, clearInFlightRowIndex } = useFetchingDataBlock();
    if (rows) {
        const sortList = rows.map((r) => RowIdUtils.getId(r, rowIdField, 'none'));
        // set the ID lists for the checkmark cache and open container cache
        const doNesting = openCloseCacheRef.current.sortIdList(sortList);
        checkedCacheRef.current.sortIdList(sortList);
        if (nested.enabled && doNesting) {
            const nestingData = rows.map((r) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                return {
                    parentIds: ((_a = r.data) === null || _a === void 0 ? void 0 : _a.parentIds) || [],
                    childIds: ((_e = (_d = (_c = (_b = r.data) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.map((c) => {
                        var _a, _b;
                        return [
                            (_a = c[rowIdField]) !== null && _a !== void 0 ? _a : c.id,
                            (_b = c.children) === null || _b === void 0 ? void 0 : _b.map((gc) => { var _a; return (_a = gc[rowIdField]) !== null && _a !== void 0 ? _a : gc.id; })
                        ]
                            .flat()
                            .filter((c) => c !== null && c !== void 0 ? c : -1 >= 0);
                    })) !== null && _e !== void 0 ? _e : []).flat(),
                    hasChildren: ((_h = (_g = (_f = r.data) === null || _f === void 0 ? void 0 : _f.item) === null || _g === void 0 ? void 0 : _g.children) === null || _h === void 0 ? void 0 : _h.length) > 0
                };
            });
            openCloseCacheRef.current.setNesting(nestingData);
            checkedCacheRef.current.setNesting(nestingData);
        }
        // assign the generation to our Id List
        openCloseCacheRef.current.setIdListWithGeneration();
        checkedCacheRef.current.setIdListWithGeneration();
    }
    // Everything is based off the rows so when we start searching, that rows array gets smaller
    // and then our checkedIdsAtCorrectGeneration array gets smaller.
    // Thus causing the currentCheckedCount to be wrong for rowActions
    const currentCheckedCount = sharedRowActionsConfig &&
        (sharedRowActionsConfig.type === 'multi-action' ||
            sharedRowActionsConfig.type === 'multi-action-conditionable' ||
            sharedRowActionsConfig.type === 'single-action' ||
            sharedRowActionsConfig.type === 'single-action-conditionable')
        ? checkedCacheRef.current.totalOpen(totalItems !== null && totalItems !== void 0 ? totalItems : 0, sharedRowActionsConfig.buttonConfig.generation)
        : checkedCacheRef.current.totalOpen(totalItems !== null && totalItems !== void 0 ? totalItems : 0);
    React__default.useEffect(() => {
        var _a;
        if (sharedRowActionsConfig.type === 'multi-action' ||
            sharedRowActionsConfig.type === 'multi-action-conditionable' ||
            sharedRowActionsConfig.type === 'single-action' ||
            sharedRowActionsConfig.type === 'single-action-conditionable') {
            if (searchTerm || isSearching) {
                return;
            }
            const rowsAtCorrectGeneration = rows === null || rows === void 0 ? void 0 : rows.filter((row) => 'buttonConfig' in sharedRowActionsConfig &&
                checkedCacheRef.current.getRowGeneration(row.index) ===
                    sharedRowActionsConfig.buttonConfig.generation);
            setTotalItems((_a = rowsAtCorrectGeneration === null || rowsAtCorrectGeneration === void 0 ? void 0 : rowsAtCorrectGeneration.length) !== null && _a !== void 0 ? _a : 0);
        }
        else {
            const datasetTotalsType = getTotalsAndType(lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.datasetTotal);
            setTotalItems(datasetTotalsType.totals.total);
        }
    }, [
        isSearching,
        lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.datasetTotal,
        searchTerm,
        sharedRowActionsConfig.type,
        rows,
        sharedRowActionsConfig
    ]);
    const { virtualRange, initialRender, spacing, updateRowHeight, resetHeightCache, setNestedHeights, scrollToIndex } = useVariableVirtualList({
        rowCount: (_h = rows === null || rows === void 0 ? void 0 : rows.length) !== null && _h !== void 0 ? _h : 0, // We need to make sure this matches the number of rows rendered
        windowHeight: (_j = size.height) !== null && _j !== void 0 ? _j : 0,
        windowRef: gridRef,
        opened: openCloseCacheRef.current.totalOpenCalc()
    });
    const handleOnCheckedRowsChange = (changed) => {
        setAllowGhost(false);
        if (onCheckedRowsChange) {
            const helpers = buildHelpers();
            const changedData = checkedChangedResult(changed);
            onCheckedRowsChange(changedData, helpers);
        }
        refresh();
    };
    const virtualRangePageStart = (_m = (rows && ((_l = (_k = rows[virtualRange.start]) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.pageIndex))) !== null && _m !== void 0 ? _m : 0;
    // we need to keep the height cache up to date based on whats open and closed
    // when in nested row mode.
    React__default.useEffect(() => {
        var _a, _b;
        if (nested.enabled && ((_a = rows === null || rows === void 0 ? void 0 : rows.length) !== null && _a !== void 0 ? _a : 0) > 0 && ((_b = size.height) !== null && _b !== void 0 ? _b : 0) > 0) {
            setNestedHeights(openCloseCacheRef.current, rows);
        }
    }, [
        nested.enabled,
        openCloseCacheRef.current.totalOpenCalc,
        rows,
        setNestedHeights,
        size
    ]);
    // Focuses on provided element when the elementToFocus state is updated and the element is rendered
    React__default.useEffect(() => {
        var _a, _b;
        if (!elementToFocus) {
            return;
        }
        if (!rows || !((_b = (_a = rows[elementToFocus.index]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.item)) {
            return;
        }
        const rowItem = rows[elementToFocus.index].data.item;
        if (elementToFocus.triggerOnSelectedRowChange && onSelectedRowChange) {
            onSelectedRowChange(rowItem);
        }
        const elementToFocusId = `${elementToFocus.idPrefix}-${rowItem === null || rowItem === void 0 ? void 0 : rowItem[rowIdField]}`;
        const element = document.getElementById(elementToFocusId);
        if (!element) {
            return;
        }
        element.focus();
        setElementToFocus(null);
    }, [elementToFocus, rows, onSelectedRowChange, rowIdField]);
    const handleOnBlur = React__default.useCallback((event) => {
        if (!onBlur || !gridRef.current) {
            return;
        }
        // if focus is still inside the grid, don't call onBlur
        OnFocusOutside(event, [gridRef.current], () => {
            onBlur(event);
        });
    }, [onBlur]);
    const { onSearchTermChange } = searchable;
    const updateSearchTerm = React__default.useCallback((term) => {
        onSearchTermChange && onSearchTermChange(term);
        setSearchTerm(term);
    }, [onSearchTermChange]);
    // We need to freeze columns if the user scrolls the grid to keep widths from
    // moving all over the place.
    React__default.useEffect(() => {
        const onScroll = () => {
            if (!initialRender) {
                freezeColumns();
            }
        };
        const el = gridRef.current;
        // Binding on scroll and focusout event listeners
        if (el) {
            el.removeEventListener('scroll', onScroll);
            el.addEventListener('scroll', onScroll, { passive: true });
            el.addEventListener('focusout', handleOnBlur);
        }
        return () => {
            if (el) {
                el.removeEventListener('scroll', onScroll);
                el.removeEventListener('focusout', handleOnBlur);
            }
        };
    }, [freezeColumns, handleOnBlur, initialRender, onBlur]);
    // If they need datagrid helpers expose the helpers object
    React__default.useEffect(() => {
        if (helpers) {
            const dataGridHelpers = {
                scrollToRowById: (id, visibilityBehaviorConfig = VISIBILITY_BEHAVIOR_CONFIG_DEFAULT) => {
                    const index = rows === null || rows === void 0 ? void 0 : rows.findIndex((r) => RowIdUtils.getId(r, rowIdField, 'none') === id);
                    if (index !== undefined)
                        scrollToIndex(index, visibilityBehaviorConfig);
                },
                searchTerm: searchTerm,
                clearSearchTerm: () => updateSearchTerm(''),
                getRowData: (id) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    const index = rows === null || rows === void 0 ? void 0 : rows.findIndex((r) => RowIdUtils.getId(r, rowIdField, 'none') === id);
                    return index !== undefined && index > -1
                        ? {
                            index: index,
                            data: (_c = (_b = (_a = rows === null || rows === void 0 ? void 0 : rows[index]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.item) !== null && _c !== void 0 ? _c : null,
                            siblings: {
                                prev: (_f = (_e = (_d = rows === null || rows === void 0 ? void 0 : rows[index - 1]) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.item) !== null && _f !== void 0 ? _f : null,
                                next: (_j = (_h = (_g = rows === null || rows === void 0 ? void 0 : rows[index + 1]) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.item) !== null && _j !== void 0 ? _j : null
                            }
                        }
                        : null;
                }
            };
            if (isPaginated) {
                helpers(Object.assign(Object.assign({}, dataGridHelpers), { updateRowData: (callback) => {
                        var _a;
                        const rowsToUpdate = callback(
                        // provide a list of only the rows' data.item objects, for rows that have been loaded.
                        (_a = rows === null || rows === void 0 ? void 0 : rows.filter((r) => r.data).map((r) => r.data.item)) !== null && _a !== void 0 ? _a : []);
                        // run this matcher function on every row from the stored state.
                        mapDataRows((previous) => {
                            const rowId = RowIdUtils.getId(previous, rowIdField, 'none');
                            const updatedRow = rowsToUpdate === null || rowsToUpdate === void 0 ? void 0 : rowsToUpdate[rowId];
                            if (!updatedRow) {
                                return previous;
                            }
                            const _a = updatedRow, 
                            // @ts-expect-error TRow is not guaranteed to be a record yet so this prop may not exist.
                            _b = rowIdField; 
                            // @ts-expect-error TRow is not guaranteed to be a record yet so this prop may not exist.
                            _a[_b]; const { 
                            // @ts-expect-error TRow is not guaranteed to be a record yet so this prop may not exist.
                            children } = _a, rowDataToUpdate = __rest(_a, [typeof _b === "symbol" ? _b : _b + "", "children"]);
                            if (children) {
                                ADSError('updateRowData does not support updating children. Please update the child using its unique id.');
                            }
                            const newItem = Object.assign(Object.assign({}, previous.data.item), rowDataToUpdate);
                            // update the item and recreate cells for the matched row.
                            const newCells = createSearchableCells(newItem !== null && newItem !== void 0 ? newItem : [], previous.index, visibleColumns);
                            // ensure we break referential equality
                            return Object.assign(Object.assign({}, previous), { data: Object.assign(Object.assign({}, previous.data), { item: newItem, cells: newCells }) });
                        });
                        refresh();
                    } }));
            }
            else {
                // this casting is bad but we already validate above that dataGridHelpers satisfiesDataGridHelpers
                helpers(dataGridHelpers);
            }
        }
    }, [
        helpers,
        isPaginated,
        mapDataRows,
        refresh,
        rowIdField,
        rows,
        scrollToIndex,
        searchTerm,
        updateSearchTerm,
        visibleColumns
    ]);
    // for nested helpers
    React__default.useEffect(() => {
        if (nested.helpers) {
            const rowIndex = (id) => {
                var _a;
                return ((_a = rows === null || rows === void 0 ? void 0 : rows.findIndex((r) => RowIdUtils.getId(r, rowIdField, 'none') === id)) !== null && _a !== void 0 ? _a : -1);
            };
            nested.helpers({
                isOpen: (id) => {
                    return openCloseCacheRef.current.isOpen(rowIndex(id));
                },
                toggle: (ids) => {
                    ids.forEach((id) => {
                        openCloseCacheRef.current.toggle(rowIndex(id));
                    });
                    refresh();
                },
                openAll: () => {
                    openCloseCacheRef.current.openAll();
                    refresh();
                },
                closeAll: () => {
                    openCloseCacheRef.current.closeAll();
                    refresh();
                }
            });
        }
    }, [nested, nested.helpers, refresh, rowIdField, rows]);
    React__default.useEffect(() => {
        // We only care to disable the check all checkbox if row actions is enabled and we have a renderer.
        if (rowActionsRendererEnabled) {
            isCheckAllDisabled.current =
                (lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.total) !== (rowsWithData === null || rowsWithData === void 0 ? void 0 : rowsWithData.length);
        }
    }, [rowsWithData === null || rowsWithData === void 0 ? void 0 : rowsWithData.length, lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.total, rowActionsRendererEnabled]);
    // If we have a rowChildContainer we need to add a toggle column to the beginning
    // of our column models. If not we can just set our column models.
    React__default.useEffect(() => {
        var _a;
        const rowContainerColumn = rowChildContainer
            ? new SpecialDataColumnModel({
                name: SPECIAL_COLUMN_TYPES.rowChildContainer,
                title: '',
                width: '42px',
                isSortable: false,
                cellIsClickable: true,
                isVisible: true,
                onColumnClick: () => {
                    openCloseCacheRef.current.toggleAll();
                    refresh();
                    // We have to wait till we are done animating the open or close of the row child container
                    // before we clear our row height cache. This is to ensure we get the new height
                    // with the rows as the new default when we calculate our virtual space.
                    setTimeout(() => {
                        resetHeightCache();
                    }, 200);
                },
                columnRenderer: () => {
                    return openCloseCacheRef.current.status() === 'mix' ? (React__default.createElement(Icon, { icon: "DashIcon", size: 16 })) : (React__default.createElement(DataGridToggleIcon, { open: openCloseCacheRef.current.status() === 'open' }));
                }
            })
            : null;
        const nestedToggleColumn = nested.enabled
            ? new SpecialDataColumnModel({
                name: SPECIAL_COLUMN_TYPES.nestedToggle,
                title: '',
                width: '63px',
                isSortable: false,
                cellIsClickable: true,
                isVisible: true,
                onColumnClick: () => {
                    openCloseCacheRef.current.toggleAll();
                    startToggleAnimate();
                    refresh();
                },
                columnRenderer: () => {
                    return openCloseCacheRef.current.status() === 'mix' ? (React__default.createElement(Icon, { className: cx$A('toggleDash'), icon: "DashIcon", size: 16 })) : (React__default.createElement(DataGridToggleIcon, { open: openCloseCacheRef.current.status() === 'open', nested: true }));
                }
            })
            : null;
        const checkboxColumn = checkbox.enabled
            ? new SpecialDataColumnModel({
                name: SPECIAL_COLUMN_TYPES.checkbox,
                title: '',
                width: '43px',
                isSortable: false,
                cellIsClickable: true,
                isVisible: true,
                columnRenderer: () => {
                    return checkbox.hideCheckAll ? (React__default.createElement(React__default.Fragment, null)) : (React__default.createElement(Tooltip, { disabled: !isCheckAllDisabled.current, content: `${t('CHECK_ALL_DISABLED_TOOLTIP')}` },
                        React__default.createElement(Checkbox, { name: "check-all", testId: TEST_IDS.checkAllHeader(testId), className: cx$A('checkboxHeader', (checkedCacheRef.current.status() === 'mix' ||
                                checkedCacheRef.current.status() === 'mix-disabled') &&
                                'indeterminate'), type: "reverse", value: checkedCacheRef.current.status() !== 'close', disabled: isCheckAllDisabled.current, onChange: () => {
                                const changed = checkedCacheRef.current.toggleAll();
                                handleOnCheckedRowsChange(changed);
                            } })));
                }
            })
            : null;
        const rowActionsColumn = sharedRowActionsConfig.type !== 'feature-disabled' &&
            sharedRowActionsConfig.type !== 'multi-action-context-menu'
            ? new SpecialDataColumnModel({
                name: SPECIAL_COLUMN_TYPES.rowActions,
                title: '',
                width: actionsColumnWidth,
                isSortable: false,
                isIconOnly: true,
                cellIsClickable: true,
                isVisible: true,
                columnRenderer: () => {
                    if (sharedRowActionsConfig.buttonConfig.type !== 'with-label') {
                        const tooltipContent = checkbox.enabled
                            ? t(I18N_KEYS.bulkActionsTooltip)
                            : t(I18N_KEYS.actions);
                        return (React__default.createElement(Tooltip, { content: tooltipContent, testId: TEST_IDS.rowActionsHeaderTooltip(testId) },
                            React__default.createElement(Icon, { size: 16, icon: "MeatballIcon", testId: TEST_IDS.rowActionsHeader(testId) })));
                    }
                    return (React__default.createElement("span", { "data-test": TEST_IDS.rowActionsHeader(testId) }, t(I18N_KEYS.actions)));
                }
            })
            : null;
        const radioColumn = (() => {
            var _a, _b;
            if (!radio.enabled) {
                return null;
            }
            if (checkbox.enabled) {
                ADSWarn('Single selection radio button cannot be used with Checkbox DataGrid :(');
                return null;
            }
            if (nested.enabled) {
                ADSWarn('Single selection radio button cannot be used with Nested DataGrids :(');
                return null;
            }
            if (rowActionsColumn) {
                ADSWarn('Single selection radio button cannot be used with Row Action DataGrids :(');
                return null;
            }
            return new SpecialDataColumnModel({
                name: SPECIAL_COLUMN_TYPES.radio,
                title: '',
                width: '43px',
                isSortable: false,
                cellIsClickable: false,
                isVisible: true,
                isReadOnly: (_a = radio.modeState) === null || _a === void 0 ? void 0 : _a.readOnly,
                isDisabled: (_b = radio.modeState) === null || _b === void 0 ? void 0 : _b.disabled,
                inputRef: radio.firstInputRef
            });
        })();
        setColumnModels(formatVisibleColumns(columns));
        // Update special column state
        const spColumns = [...specialColumns];
        // Add rowChildContainer if it's enabled
        if (rowChildContainer &&
            rowContainerColumn &&
            !specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.rowChildContainer)) {
            if (nested.enabled) {
                ADSWarn('Row Child Containers cannot be used with Nested DataGrids :(');
            }
            else {
                spColumns.push(rowContainerColumn);
            }
        }
        // Make sure it's been removed if it's disabled
        if (!rowChildContainer &&
            specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.rowChildContainer)) {
            remove(spColumns, { name: SPECIAL_COLUMN_TYPES.rowChildContainer });
        }
        // Check state of nested
        if (nested.enabled && nestedToggleColumn) {
            if (!specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.nestedToggle)) {
                spColumns.push(nestedToggleColumn);
            }
            else {
                const index = spColumns.findIndex((c) => c.name === SPECIAL_COLUMN_TYPES.nestedToggle);
                spColumns[index] = nestedToggleColumn;
            }
        }
        // Make sure it's been removed if it's disabled
        if (!nested.enabled &&
            specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.nestedToggle)) {
            remove(spColumns, { name: SPECIAL_COLUMN_TYPES.nestedToggle });
        }
        // Set/Remove checkbox column
        if (checkbox.enabled && checkboxColumn) {
            if (!specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.checkbox)) {
                spColumns.push(checkboxColumn);
            }
            else {
                const index = spColumns.findIndex((c) => c.name === SPECIAL_COLUMN_TYPES.checkbox);
                spColumns[index] = checkboxColumn;
            }
        }
        if (!checkbox.enabled &&
            specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.checkbox)) {
            remove(spColumns, { name: SPECIAL_COLUMN_TYPES.checkbox });
        }
        // Set/Remove row actions column
        // - set:
        if (sharedRowActionsConfig && rowActionsColumn) {
            const rowActionsColumnExists = specialColumns.some((c) => c.name === SPECIAL_COLUMN_TYPES.rowActions);
            if (rowActionsColumnExists) {
                const rowActionsColumnWidth = (_a = specialColumns.find((c) => c.name === SPECIAL_COLUMN_TYPES.rowActions)) === null || _a === void 0 ? void 0 : _a.width;
                if (rowActionsColumnWidth !== actionsColumnWidth) {
                    remove(spColumns, { name: SPECIAL_COLUMN_TYPES.rowActions });
                    spColumns.push(rowActionsColumn);
                }
            }
            else {
                spColumns.push(rowActionsColumn);
            }
        }
        // - remove:
        else {
            remove(spColumns, { name: SPECIAL_COLUMN_TYPES.rowActions });
        }
        if (radio.enabled && radioColumn) {
            if (!specialColumns.find((c) => c.name === SPECIAL_COLUMN_TYPES.radio)) {
                spColumns.push(radioColumn);
            }
            else {
                const index = spColumns.findIndex((c) => c.name === SPECIAL_COLUMN_TYPES.radio);
                spColumns[index] = radioColumn;
            }
        }
        if (!radio.enabled &&
            specialColumns.find((c) => c.name === SPECIAL_COLUMN_TYPES.radio)) {
            remove(spColumns, { name: SPECIAL_COLUMN_TYPES.radio });
        }
        setSpecialColumns(spColumns);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        rowChildContainer,
        setColumnModels,
        checkbox.enabled,
        radio.enabled,
        nested.enabled,
        columns,
        actionsColumnWidth
    ]);
    // scope: local to this block
    {
        const { height, width } = size;
        const effectRef = React__default.useRef({ unfreezeColumns });
        React__default.useEffect(() => {
            effectRef.current = { unfreezeColumns };
        });
        React__default.useEffect(() => {
            if (height && width) {
                effectRef.current.unfreezeColumns();
            }
        }, [height, width]);
    }
    const commonId = React__default.useMemo(() => UUIDv4(), []);
    const handleColumnSort = (columnName, direction) => {
        // Close all row child containers on a sort
        refresh();
        // Freeze our column widths
        freezeColumns();
        // Update column sort state
        setColumnSortState({
            column: columnName,
            direction
        });
        onSort && onSort(columnName, direction);
    };
    const isRowSelected = (row) => {
        if (combinedSelectedRow && (row === null || row === void 0 ? void 0 : row.data)) {
            return (combinedSelectedRow &&
                combinedSelectedRow[rowIdField] !== undefined &&
                combinedSelectedRow[rowIdField] ===
                    RowIdUtils.getId(row, rowIdField, 'none'));
        }
        return false;
    };
    const clearTimers = () => {
        let k;
        for (k in timersRef.current) {
            const timer = timersRef.current[k];
            if (timer) {
                clearTimeout(timer);
                timersRef.current[k] = null;
            }
        }
    };
    React__default.useEffect(() => {
        return () => {
            // when we unmount, we need to clear out our timers
            clearTimers();
        };
    }, []);
    // Calls for a new set of data (used when search or column sort state changes).
    const refreshData = React__default.useCallback((options) => {
        const pageStart = (options === null || options === void 0 ? void 0 : options.resetStartIndex) ? 0 : virtualRangePageStart;
        // We ask for data with a callback once the data has returned so we can
        // handle indicating if our columns are mid sorting or not. Without this
        // the user could click a column to sort and the DataGrid look like nothing was
        // happening if the sort takes some time.
        getData(pageStart, columnSortState, searchTerm, false, (pagination) => {
            // We have data so we must be done searching
            setIsSearching(false);
            clearTimers();
            setBatchSize(pagination.end - pagination.start);
            setIsSortingColumn(false);
            if (scrollToSelected.current) {
                scrollDataReady.current = true;
            }
            refresh();
        });
    }, [
        columnSortState,
        getData,
        searchTerm,
        setBatchSize,
        virtualRangePageStart,
        refresh
    ]);
    // Anytime our search term changes we need to refresh our data using the search term
    // if nested, start a timer to decide to open parent rows if their children match.
    React__default.useEffect(() => {
        // If searching takes longer than 20ms, we want to show the user some
        // sort of loading indicator.
        if (searchTerm) {
            timersRef.current.search = setTimeout(() => {
                setIsSearching(true);
            }, SHOW_LOADING_DELAY);
            checkedCacheRef.current.setSearching(true);
            if (nested.enabled) {
                openCloseCacheRef.current.setSearching(true);
                searchDebouce(() => {
                    openCloseCacheRef.current.openParents();
                    refresh();
                });
            }
        }
        else {
            openCloseCacheRef.current.setSearching(false);
            checkedCacheRef.current.setSearching(false);
            if (scrollToSelected &&
                !scrollToSelected.current &&
                combinedSelectedRow &&
                !isFirstRun('search')) {
                scrollToSelected.current = true;
            }
        }
        if (!isFirstRun('search')) {
            refreshData({ resetStartIndex: true });
        }
        registerRun('search');
        // The linter is wrong in this case. We only want to run when searchTerm runs.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);
    // Anytime our column sort state changes we need to refresh our and request data sorted
    React__default.useEffect(() => {
        // If sorting a column takes longer than 20ms, we want to show the user some
        // sort of loading indicator.
        timersRef.current.columnSort = setTimeout(() => {
            setIsSortingColumn(true);
        }, SHOW_LOADING_DELAY);
        if (!isFirstRun('columnSort')) {
            refreshData();
        }
        registerRun('columnSort');
        // The linter is wrong in this case. We only want to run this when columns sort changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnSortState]);
    useHandleColumnOrderChanged(isPaginated, visibleColumns, refreshData, isFirstRun, registerRun);
    const handleEmptyRow = React__default.useCallback((index) => {
        var _a, _b;
        // if paginated and nested, find a nearby row with a page index and use that.
        // note - when not nested, index = data.pageIndex
        let pageIndex = index;
        if (paginationLevel > -1) {
            const known = (rows === null || rows === void 0 ? void 0 : rows.filter((r) => r.data)) || [];
            const nextPage = known.find((f) => f.data && f.index > index);
            const prevPage = known.reverse().find((f) => f.data && f.index < index);
            const pageSize = ((_a = lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.end) !== null && _a !== void 0 ? _a : 0) - ((_b = lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.start) !== null && _b !== void 0 ? _b : 0);
            if (!nextPage && prevPage) {
                pageIndex = prevPage.data.pageIndex + 1;
            }
            else if (!prevPage && nextPage) {
                pageIndex =
                    nextPage.data.pageIndex - 1 - pageSize < 0
                        ? 0
                        : nextPage.data.pageIndex - 1 - pageSize;
            }
            else if (nextPage && prevPage) {
                if (Math.abs(prevPage.index - index) <= nextPage.index - index) {
                    pageIndex = prevPage.data.pageIndex + 1;
                }
                else {
                    pageIndex =
                        nextPage.data.pageIndex - 1 - pageSize < 0
                            ? 0
                            : nextPage.data.pageIndex - 1 - pageSize;
                }
            }
        }
        if (!isRowIndexInFlight(pageIndex)) {
            setRowIndexInFlight(pageIndex);
            // Ask for the section of data and merge it into our data set.
            getData(pageIndex, columnSortState, searchTerm, true, () => {
                clearInFlightRowIndex();
            });
        }
    }, [
        clearInFlightRowIndex,
        columnSortState,
        getData,
        isRowIndexInFlight,
        lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.end,
        lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.start,
        paginationLevel,
        rows,
        searchTerm,
        setRowIndexInFlight
    ]);
    const gridTemplate = React__default.useMemo(() => {
        return (columnState.width ||
            [...specialColumns, ...visibleColumns].map((c) => c.width).join(' '));
    }, [columnState.width, specialColumns, visibleColumns]);
    // Kick off initial request for data when component mounts
    React__default.useEffect(() => {
        refreshData({ resetStartIndex: true });
        // We only want this running once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const selectableColumnsOn = typeof selectableColumns === 'boolean'
        ? selectableColumns && onColumnsChange !== undefined
        : (_o = selectableColumns === null || selectableColumns === void 0 ? void 0 : selectableColumns.enabled) !== null && _o !== void 0 ? _o : false;
    const hasActionBar = viewModes.enabled ||
        searchable.enabled ||
        selectableColumnsOn ||
        reorderableRowsConfig.enabled ||
        actionContent ||
        actionsMenuConfig;
    const { rowVisibleState, prevVisibleIndex, nextVisibleIndex } = getNestedVisibleRows(nested.enabled, rows !== null && rows !== void 0 ? rows : [], virtualRange, openCloseCacheRef.current);
    const searchTotal = paginationLevel > -1 && rows
        ? rows.filter((i) => { var _a, _b, _c; return ((_c = (_b = (_a = i.data) === null || _a === void 0 ? void 0 : _a.parents) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : -1) === paginationLevel; })
            .length
        : rows === null || rows === void 0 ? void 0 : rows.length;
    const nestedTotals = nested.enabled
        ? Array(3)
            .fill(0)
            .map((_, idx) => { var _a; return (_a = rows === null || rows === void 0 ? void 0 : rows.filter((p) => { var _a, _b; return ((_b = (_a = p.data) === null || _a === void 0 ? void 0 : _a.parents) === null || _b === void 0 ? void 0 : _b.length) === idx; }).length) !== null && _a !== void 0 ? _a : 0; })
        : null;
    useEventListener(['keydown', 'keyup'], (e) => {
        const keyState = e;
        setAltHeld(keyState.altKey);
        setShiftHeld(keyState.shiftKey);
        setCtrlcmdHeld(keyState.ctrlKey || keyState.metaKey);
        setCtrlcmdCHeld((keyState.ctrlKey || keyState.metaKey) && keyState.code === 'KeyC');
        // if ctrl/cmd have been let go, ghosting can happen again.
        if (!keyState.ctrlKey && !keyState.metaKey)
            setAllowGhost(true);
    });
    const onFocusCaptureHandlerForSingleSelect = (e) => {
        var _a, _b, _c, _d;
        if (!radio.enabled || ((_a = radio.modeState) === null || _a === void 0 ? void 0 : _a.disabled)) {
            return;
        }
        if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'radio') {
            return;
        }
        // When related target is the grid itself, the focus event is coming from the mouse click
        if (!e.relatedTarget || e.relatedTarget === gridRef.current) {
            return;
        }
        if (!rows || rows.length === 0) {
            return;
        }
        // When there is a selected row, ensure is in view
        if (combinedSelectedRow) {
            const index = (_c = (rows &&
                ((_b = rows.find((r) => r.data &&
                    RowIdUtils.getId(r, rowIdField, 'none') ===
                        combinedSelectedRow[rowIdField])) === null || _b === void 0 ? void 0 : _b.index))) !== null && _c !== void 0 ? _c : -1;
            if (index >= 0) {
                const selectedRowElId = `${e.target.name}-${combinedSelectedRow[rowIdField]}`;
                const selectedRowEl = document.getElementById(selectedRowElId);
                if (!selectedRowEl) {
                    //Scroll to index only if it is not already in view
                    scrollToIndex(index);
                    //Defer focusing on the element since it will not yet be in the DOM
                    setElementToFocus({
                        idPrefix: e.target.name,
                        index: index,
                        triggerOnSelectedRowChange: false
                    });
                }
            }
            return;
        }
        if (e.relatedTarget instanceof HTMLInputElement &&
            e.relatedTarget.type === 'radio' &&
            e.relatedTarget.name === e.target.name) {
            return;
        }
        //There is no selected row, ensure the first row is in the view
        const firstRowElementId = `${e.target.name}-${RowIdUtils.getId(rows[0], rowIdField, 'none')}`;
        if (firstRowElementId === e.target.id) {
            return;
        }
        const elementToFocus = document.getElementById(firstRowElementId);
        if (elementToFocus) {
            if (!(elementToFocus instanceof HTMLInputElement)) {
                return;
            }
            elementToFocus.focus();
            return;
        }
        const firstRowIndex = (_d = rows[0].index) !== null && _d !== void 0 ? _d : 0;
        scrollToIndex(firstRowIndex);
        // Defer focusing on the element since it will not yet be in the DOM
        setElementToFocus({
            idPrefix: e.target.name,
            index: firstRowIndex,
            triggerOnSelectedRowChange: false
        });
    };
    const onFocusCaptureHandler = (e) => {
        onFocusCaptureHandlerForSingleSelect(e);
    };
    /**
     * The purpose of this handler is to facilitate keyboard navigation within
     * the DataGrid when using single-row selection.
     * It specifically responds to arrow key inputs and adjusts the selected row based
     * on the direction of the arrow key.
     * Importantly, this behavior occurs only when transitioning from the first row
     * to the last row or vice versa.
     */
    const keyDownHandlerForSingleSelect = (e) => {
        var _a, _b, _c;
        if (!radio.enabled || ((_a = radio.modeState) === null || _a === void 0 ? void 0 : _a.disabled)) {
            return;
        }
        if (e.key !== 'ArrowDown' &&
            e.key !== 'ArrowRight' &&
            e.key !== 'ArrowUp' &&
            e.key !== 'ArrowLeft' &&
            e.key !== ' ' // space
        ) {
            return;
        }
        if (!rows || rows.length === 0) {
            return;
        }
        if (!(document.activeElement instanceof HTMLInputElement)) {
            return;
        }
        const currentIndex = combinedSelectedRow
            ? rows.findIndex((r) => r.data &&
                RowIdUtils.getId(r, rowIdField, 'none') ===
                    combinedSelectedRow[rowIdField])
            : rows[0].index;
        if (e.key === ' ' /*space*/) {
            if (onSelectedRowChange && ((_b = rows[currentIndex]) === null || _b === void 0 ? void 0 : _b.data)) {
                onSelectedRowChange(rows[currentIndex].data.item);
            }
            return;
        }
        const direction = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 'down' : 'up';
        if ((direction === 'down' && currentIndex !== rows.length - 1) ||
            (direction === 'up' && currentIndex !== 0)) {
            // out of the box the browser will handle the focus but we have to select the focused row
            const nextRowIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;
            if (onSelectedRowChange && ((_c = rows[nextRowIndex]) === null || _c === void 0 ? void 0 : _c.data)) {
                onSelectedRowChange(rows[nextRowIndex].data.item);
            }
            return;
        }
        const nextRowIndex = direction === 'down' ? rows[0].index : rows[rows.length - 1].index;
        // If prevent default is not used, the selected element will only be partially in view.
        // The scrollbar will be adjusted to be some pixels off the top or the bottom.
        e.preventDefault();
        scrollToIndex(nextRowIndex);
        // Defer focusing on the element since it may not yet be in the DOM
        setElementToFocus({
            idPrefix: document.activeElement.name,
            index: nextRowIndex,
            triggerOnSelectedRowChange: true
        });
    };
    const keyDownHandler = (e) => {
        // Handle the event based off which key was pressed
        keyDownHandlerForSingleSelect(e);
    };
    /**
     * 💀 dangerous code: this logic runs on every render and should be refactored to call `scrollToIndex` when a specific action happens.
     * It gets a little complicated because when we want to autoscroll after clearing a search term, our rows change and some nested rows may open or collapse.
     * As a result, we have to have a "short delay" before calling `scrollToIndex` to all rows have settled with the amount of space they take up.
     *
     * When we updated to React 18, we needed to increase the timeout here from 0ms to 1ms. This is not a viable long term solution and we should clean this code up.
     */
    if (scrollToSelected.current && scrollDataReady.current) {
        const index = (_q = (combinedSelectedRow &&
            rows &&
            ((_p = rows.find((r) => RowIdUtils.getId(r, rowIdField, 'none') ===
                combinedSelectedRow[rowIdField])) === null || _p === void 0 ? void 0 : _p.index))) !== null && _q !== void 0 ? _q : -1;
        if ((index !== null && index !== void 0 ? index : -1) >= 0) {
            scrollToSelected.current = false;
            scrollDataReady.current = false;
            setTimeout((idx) => scrollToIndex(idx !== null && idx !== void 0 ? idx : 0), 1, index);
        }
    }
    const checkedChangedResult = React__default.useCallback((changedIndices) => {
        var _a, _b;
        return {
            all: checkedCacheRef.current.status() === 'open',
            none: checkedCacheRef.current.status() === 'close',
            items: (_b = (_a = rowsRef.current) === null || _a === void 0 ? void 0 : _a.filter((r) => changedIndices.includes(r.index)).map((r) => {
                var _a;
                return {
                    id: RowIdUtils.getId(r, rowIdField),
                    item: (_a = r.data) === null || _a === void 0 ? void 0 : _a.item,
                    checked: checkedCacheRef.current.isOpen(r.index)
                };
            })) !== null && _b !== void 0 ? _b : []
        };
    }, [rowIdField]);
    // list of rows that would be impacted by a group select:
    const ghostCheckedRows = rows &&
        (shiftHeld &&
            !checkbox.disableShift &&
            checkedCacheRef.current.lastOpen() > -1
            ? rows === null || rows === void 0 ? void 0 : rows.filter((r) => {
                var _a, _b, _c;
                const last = checkedCacheRef.current.lastOpen();
                return last > -1
                    ? ((_a = hoverState === null || hoverState === void 0 ? void 0 : hoverState.row) !== null && _a !== void 0 ? _a : 0) > last
                        ? (r === null || r === void 0 ? void 0 : r.index) >= last && (r === null || r === void 0 ? void 0 : r.index) <= ((_b = hoverState === null || hoverState === void 0 ? void 0 : hoverState.row) !== null && _b !== void 0 ? _b : 0)
                        : (r === null || r === void 0 ? void 0 : r.index) <= last && (r === null || r === void 0 ? void 0 : r.index) >= ((_c = hoverState === null || hoverState === void 0 ? void 0 : hoverState.row) !== null && _c !== void 0 ? _c : 0)
                    : false;
            }).map((r) => r === null || r === void 0 ? void 0 : r.index)
            : ((shiftHeld && !checkbox.disableShift) || ctrlcmdHeld) &&
                hoverState &&
                ((_r = hoverState === null || hoverState === void 0 ? void 0 : hoverState.row) !== null && _r !== void 0 ? _r : -1) > -1
                ? rows === null || rows === void 0 ? void 0 : rows.filter((_, idx) => idx === (hoverState === null || hoverState === void 0 ? void 0 : hoverState.row)).map((r) => r === null || r === void 0 ? void 0 : r.index)
                : []);
    // get the checked state of the row being hovered over.
    const ghostHoverRowState = checkedCacheRef.current.getNestedOpenStatus((_s = hoverState === null || hoverState === void 0 ? void 0 : hoverState.row) !== null && _s !== void 0 ? _s : 0);
    /**
     * All instances of `rowsRef.current` in this function should probably be just `rows`.
     * Given the heavy use of ignoring the react-hooks/exhaustive-deps rules in this file, it is difficult to trace through
     * and identify when certain values are stale. Once we remove all of those eslint ignore comments, we should be able to remove the
     * ref to the rows entirely.
     */
    const buildHelpers = React__default.useCallback(() => {
        // index is not really stable outside the datagrid
        // so we only allow checking based on the rowIDField (a number!)
        const rowIndex = (id) => {
            var _a, _b, _c;
            return ((_c = (_b = (_a = rowsRef.current) === null || _a === void 0 ? void 0 : _a.find((r) => RowIdUtils.getId(r, rowIdField, 'id') === id)) === null || _b === void 0 ? void 0 : _b.index) !== null && _c !== void 0 ? _c : -1);
        };
        const helpers = {
            getRowGeneration: (id) => {
                return checkedCacheRef.current.getRowGeneration(rowIndex(id));
            },
            isChecked: (id) => {
                const idIndex = rowIndex(id);
                return idIndex > -1
                    ? checkedCacheRef.current.isOpen(idIndex)
                    : checkedCacheRef.current.hiddenExceptionIds().includes(id);
            },
            toggleChecked: (rowIds) => {
                const changed = [];
                rowIds
                    .map((id) => ({ index: rowIndex(id), id }))
                    .forEach(({ index, id }) => {
                    if (index > -1) {
                        checkedCacheRef.current
                            .toggleFamily(index)
                            .forEach((c) => !changed.includes(c) && changed.push(c));
                    }
                    else {
                        checkedCacheRef.current.toggleUnseenRow(id);
                    }
                });
                setAllowGhost(false);
                // raise the event if they're watching for it.
                onCheckedRowsChange &&
                    onCheckedRowsChange(checkedChangedResult(changed), helpers);
                refresh();
            },
            setCheckboxDisabledList: (rowIndices, enabled) => {
                const prevDisabledList = checkedCacheRef.current.getDisabledList();
                checkedCacheRef.current.setDisabledIndicesList(rowIndices, enabled);
                const updatedDisabledList = checkedCacheRef.current.getDisabledList();
                // We need to refresh, but ONLY if the disabled list has changed.
                if (!isEqual(prevDisabledList, updatedDisabledList)) {
                    refresh();
                }
            },
            getChecked: () => {
                var _a, _b;
                return {
                    all: checkedCacheRef.current.status() === 'open',
                    none: checkedCacheRef.current.status() === 'close',
                    ids: [
                        ...((_b = (_a = rowsRef.current) === null || _a === void 0 ? void 0 : _a.filter((f) => checkedCacheRef.current.isOpen(f.index)).map((r) => RowIdUtils.getId(r, rowIdField))) !== null && _b !== void 0 ? _b : []),
                        ...checkedCacheRef.current.hiddenExceptionIds(),
                        ...checkedCacheRef.current.getOpenUnseenIds()
                    ]
                };
            },
            checkAll: () => {
                checkedCacheRef.current.openAll();
                refresh();
            },
            checkNone: () => {
                checkedCacheRef.current.closeAll();
                refresh();
            },
            purgeRowReferences: (rowIds) => {
                checkedCacheRef.current.purgeRowReferences(rowIds);
                refresh();
            }
        };
        return helpers;
    }, [
        rowIdField,
        checkedCacheRef,
        setAllowGhost,
        onCheckedRowsChange,
        checkedChangedResult,
        refresh
    ]);
    // When row actions are enabled and a renderer was provided, we need to update the list of disabled rows.
    // This allows the row actions renderer to assert against all rows, not just currently rendered ones, and disable them as needed.
    React__default.useEffect(() => {
        if (rowsRef.current && rowsRef.current.length > 0) {
            const helpers = buildHelpers();
            helpers.setCheckboxDisabledList(getDisabledCheckboxRowsIndexes(), true);
        }
    }, [buildHelpers, getDisabledCheckboxRowsIndexes, isPaginated]);
    // helper functions that allow setting or getting checkbox values.
    React__default.useEffect(() => {
        if ((checkbox === null || checkbox === void 0 ? void 0 : checkbox.helpers) && rows) {
            checkbox === null || checkbox === void 0 ? void 0 : checkbox.helpers(buildHelpers());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        checkbox,
        checkedCacheRef,
        refresh,
        rows,
        rowIdField,
        onCheckedRowsChange,
        checkedChangedResult
    ]);
    // We need to call onVisibleRowsChanged to anytime our "visible" rows change. The word "visible" is meant to communicate the set of rows
    // the data grid is able to render. The DataGrid for performance reasons doesn't actually render all the visible rows at once, but cycles them through
    // so "visible" in this sense is the set or rows that "could be" rendered (but in practice it will be a subset of that).
    React__default.useEffect(() => {
        const { rowIdField, onVisibleRowsChange, onVisibleRowsChangeDebounced } = visibleRowsTunnelRef.current;
        if (onVisibleRowsChange) {
            onVisibleRowsChangeDebounced(rows, rowIdField, onVisibleRowsChange);
        }
    }, [rows]);
    React__default.useEffect(() => {
        if (onDataGridReady) {
            if (!dataReady.current && rows) {
                dataReady.current = true;
                onDataGridReady();
            }
            if (dataReady.current && !rows) {
                dataReady.current = false;
            }
        }
    }, [rows, onDataGridReady]);
    const haunt = allowGhost && gridHover && !gridHeaderHover;
    const handleOnDoubleClicked = React__default.useCallback((rowItem) => {
        // don't allow selection if the radio is enabled and is disabled or readOnly
        if (radioIsDisabled || radioIsReadOnly) {
            return;
        }
        onRowDoubleClicked && onRowDoubleClicked(rowItem);
    }, [onRowDoubleClicked, radioIsDisabled, radioIsReadOnly]);
    /**
     * As of DX-337 (2024Q4), this scroll position is only needed when row-actions context menus are enabled.
     * (Thus the "maybe" in the name.)
     * Should it be needed elsewhere, ensure the below `ScrollPositionManager` is enabled in such conditions.
     */
    const [maybeGridScrollPosition, setMaybeGridScrollPosition] = React__default.useState(None);
    React__default.useEffect(() => {
        rows === null || rows === void 0 ? void 0 : rows.slice(virtualRange.start, virtualRange.end).map((row) => {
            // If we encounter a row with no data, it means we haven't loaded it yet
            if (!row.data) {
                handleEmptyRow(row.index);
            }
        });
    }, [handleEmptyRow, rows, virtualRange.end, virtualRange.start]);
    return (React__default.createElement(ColumnResizeProvider, { allColumns: columns, visibleColumns: columnModels, dataGridHeight: gridRef.current ? gridRef.current.clientHeight : 0, columnResizeConfig: columnResizeConfig },
        React__default.createElement("div", Object.assign({ className: cx$A('container', { hideFooter }, !ctrlcmdCHeld && ctrlcmdHeld && 'noSelect'), style: { minWidth, maxHeight, minHeight, height } }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId }),
            hasActionBar && (React__default.createElement(Flex, { ref: actionContentRef, testId: testId ? `${testId}-actionbar` : 'datagrid-actionbar', className: "mb-100 gap-h-200 gap-v-100" },
                React__default.createElement(Flex, { className: "flex-item gap-100" },
                    viewModes.enabled && (React__default.createElement(Flex, null,
                        React__default.createElement(EmbeddedLabelSelect, { name: 'datagrid-view-mode-select', testId: `${testId}-view-mode`, className: cx$A('viewBox'), value: { text: viewMode || '' }, onChange: (e) => {
                                onViewModeChange && onViewModeChange(e.target.name);
                            }, options: viewModes.options, text: (_t = viewModes.text) === null || _t === void 0 ? void 0 : _t.label, disabled: (_u = viewModes.modeState) === null || _u === void 0 ? void 0 : _u.disabled, readOnly: (_v = viewModes.modeState) === null || _v === void 0 ? void 0 : _v.readonly, width: viewModes.width }))),
                    React__default.createElement(Flex, { className: "flex-item gap-h-100 flex-no-wrap" },
                        searchable.enabled && (React__default.createElement(SearchBox, { testId: TEST_IDS.searchBox(testId), name: "grid-search", className: cx$A('searchBox', 'flex-item'), value: searchTerm, onChange: updateSearchTerm, placeholder: (_w = searchable === null || searchable === void 0 ? void 0 : searchable.text) === null || _w === void 0 ? void 0 : _w.placeholder, isLoading: isSearching, disabled: (_x = searchable === null || searchable === void 0 ? void 0 : searchable.modeState) === null || _x === void 0 ? void 0 : _x.disabled })),
                        searchable.actionContent && (React__default.createElement("div", null, searchable.actionContent)))),
                (selectableColumnsOn ||
                    actionsMenuConfig ||
                    actionContent ||
                    (reorderableRowsConfig.enabled && rows)) && (React__default.createElement(Flex, { className: "flex-align-end gap-h-100 flex-valign-end" },
                    (actionsMenuConfig || selectableColumnsOn) && (React__default.createElement(PreferencesTrigger, { actionsMenuConfig: actionsMenuConfig !== null && actionsMenuConfig !== void 0 ? actionsMenuConfig : null, columnPreferencesDisabled: typeof selectableColumns === 'object' &&
                            selectableColumns.enabled &&
                            ((_y = selectableColumns.modeState) === null || _y === void 0 ? void 0 : _y.disabled), columns: columns, hasColumnPreferences: selectableColumnsOn, testId: testId, title: t('CUSTOMIZE_COLUMNS'), onColumnsChange: (columns) => {
                            onColumnsChange && onColumnsChange(columns);
                            if (typeof selectableColumns === 'object' &&
                                selectableColumns.enabled) {
                                selectableColumns.onColumnsChange &&
                                    selectableColumns.onColumnsChange(columns);
                            }
                        }, unfreezeColumns: unfreezeColumns })),
                    reorderableRowsConfig.enabled && rows && (React__default.createElement(ReorderableRowsButton, { testId: TestIdUtils.composeId(testId, 'sortable-rows-button'), reorderableRowsConfig: reorderableRowsConfig, rows: rows, rowIdField: rowIdField })),
                    actionContent && (React__default.createElement(Flex, { className: "flex-align-end" }, actionContent)))))),
            React__default.createElement("div", { "data-test": TEST_IDS.grid(testId), "data-overlaps-footer": 
                // defaults to 'bottom' if no scroll bar
                OptionUtils.value(maybeGridScrollPosition, 'bottom') === 'bottom' &&
                    // only needed for the row-actions context menus
                    RowActionsConfigUtils.configSupportsRowActionsContextMenus(rowActionsConfig), ref: gridRef, className: cx$A('grid', altHeld ? 'alt' : ''), style: { gridTemplateColumns: gridTemplate }, onMouseEnter: () => setGridHover(true), onMouseLeave: () => setGridHover(false), 
                // When single-select radio is enabled, adding a tabIndex is necessary to properly handle the onBlur event.
                // This ensures that the event’s related target property is set, which is required for correct event handling.
                tabIndex: radio.enabled ? -1 : undefined, onKeyDown: keyDownHandler, onFocusCapture: onFocusCaptureHandler },
                specialColumns.map((c, i) => (React__default.createElement(DataGridColumn, { key: c.name, index: i, column: c, onHover: (inside) => setHeaderGridHover(inside) }))),
                columnModels.map((c, i) => (React__default.createElement(DataGridColumn, { zIndexOffset: columnResizeConfig.enabled
                        ? columnModels.length - 1 - i
                        : undefined, initialRender: initialRender, dataColumnIndex: i, key: c.name, index: specialColumns.length + i, column: c, onSort: handleColumnSort, onHover: (inside) => setHeaderGridHover(inside), isSorting: ((columnSortState === null || columnSortState === void 0 ? void 0 : columnSortState.column) === c.name && isSortingColumn) || false, sorted: (columnSortState === null || columnSortState === void 0 ? void 0 : columnSortState.column) === c.name
                        ? columnSortState === null || columnSortState === void 0 ? void 0 : columnSortState.direction
                        : undefined }))),
                React__default.createElement(Spacer, { height: spacing.before }),
                rows &&
                    rows
                        .slice(virtualRange.start, virtualRange.end)
                        .map((row, idx, virtualSet) => {
                        var _a, _b, _c, _d;
                        if (nested.enabled && !rowVisibleState[idx]) {
                            // hide row unless all its parents are open
                            // updateRowHeight(row.index, 0);
                            return null;
                        }
                        // set the styles for the box shadows
                        // and the top border if the next item is a lower nest level
                        const nestedStyles = getNestedStyles({
                            previous: prevVisibleIndex(idx),
                            current: idx,
                            next: nextVisibleIndex(idx)
                        }, row, virtualSet);
                        // determine how the checkbox is displayed/ghosting status
                        let checkMode = checkedCacheRef.current.getNestedOpenStatus(row.index);
                        if (haunt &&
                            ((shiftHeld && !checkbox.disableShift) || ctrlcmdHeld) &&
                            ((hoverState === null || hoverState === void 0 ? void 0 : hoverState.special) === 'checkbox' || ctrlcmdHeld) &&
                            (ghostCheckedRows === null || ghostCheckedRows === void 0 ? void 0 : ghostCheckedRows.includes(row.index)) &&
                            (!checkbox.renderer ||
                                !checkbox.renderer(row.data.item).disabled)) {
                            if (ghostHoverRowState === 'open' && checkMode === 'open') {
                                // current hover row is checked, we want to uncheck items by clicking it.
                                checkMode = 'ghost-close';
                            }
                            else if (ghostHoverRowState === 'close' &&
                                checkMode === 'close') {
                                // current hover row is unchecked, we want to check items by clicking it.
                                checkMode = 'ghost-open';
                            }
                        }
                        const rowId = RowIdUtils.getId(row, rowIdField);
                        let rowActionsConfig;
                        switch (sharedRowActionsConfig.type) {
                            case 'feature-disabled': {
                                rowActionsConfig = sharedRowActionsConfig;
                                break;
                            }
                            case 'no-actions': {
                                rowActionsConfig = sharedRowActionsConfig;
                                break;
                            }
                            case 'multi-action-context-menu': {
                                const modeConfig = bulkActionableRowIds !== null &&
                                    checkedCacheRef.current.isOpen(row.index)
                                    ? {
                                        mode: 'bulk-and-single',
                                        checkedIds: [
                                            bulkActionableRowIds[0],
                                            ...bulkActionableRowIds.slice(1)
                                        ],
                                        checkedIdsSet: new Set(bulkActionableRowIds),
                                        currentId: rowId
                                    }
                                    : {
                                        mode: 'single',
                                        currentId: rowId
                                    };
                                const contextMenuMetadata = RowActionsConfigUtils.buildContextMenuMetadata(idx, rows.length - 1, maybeGridScrollPosition);
                                // breaking referential equality here
                                rowActionsConfig = Object.assign(Object.assign({}, sharedRowActionsConfig), { contextMenuMetadata,
                                    modeConfig });
                                break;
                            }
                            // same (single- & multi-action) as of DX-223 (Q4 2023). Reasserted in: DX-338 (Q2 2024).
                            case 'single-action':
                            case 'multi-action': {
                                const modeConfig = bulkActionableRowIds !== null &&
                                    checkedCacheRef.current.isOpen(row.index)
                                    ? {
                                        mode: 'bulk-and-single',
                                        checkedIds: [
                                            bulkActionableRowIds[0],
                                            ...bulkActionableRowIds.slice(1)
                                        ],
                                        checkedIdsSet: new Set(bulkActionableRowIds),
                                        currentId: rowId
                                    }
                                    : {
                                        mode: 'single',
                                        currentId: rowId
                                    };
                                const contextMenuMetadata = ((_b = (_a = sharedRowActionsConfig
                                    .menuConfig) === null || _a === void 0 ? void 0 : _a.contextMenuConfig) === null || _b === void 0 ? void 0 : _b.enabled)
                                    ? OptionUtils.some(RowActionsConfigUtils.buildContextMenuMetadata(idx, rows.length - 1, maybeGridScrollPosition))
                                    : None;
                                // breaking referential equality here
                                rowActionsConfig = Object.assign(Object.assign({}, sharedRowActionsConfig), { contextMenuMetadata,
                                    modeConfig });
                                break;
                            }
                            // same (single- & multi-action-conditionable) as of DX-338 (Q2 2024)
                            case 'single-action-conditionable':
                            case 'multi-action-conditionable': {
                                const modeConfig = bulkActionableRowIds !== null &&
                                    checkedCacheRef.current.isOpen(row.index)
                                    ? {
                                        mode: 'bulk-and-single',
                                        checkedIds: [
                                            bulkActionableRowIds[0],
                                            ...bulkActionableRowIds.slice(1)
                                        ],
                                        checkedIdsSet: new Set(bulkActionableRowIds),
                                        currentId: rowId
                                    }
                                    : {
                                        mode: 'single',
                                        currentId: rowId
                                    };
                                // breaking referential equality here
                                rowActionsConfig = Object.assign(Object.assign({}, sharedRowActionsConfig), { modeConfig: modeConfig });
                                break;
                            }
                        }
                        const helpers = buildHelpers();
                        const generation = helpers.getRowGeneration(rowId);
                        return (React__default.createElement(DataGridRow, { generation: generation, rowActionsConfig: rowActionsConfig, checkboxRenderer: checkbox.renderer, key: row.index, rowIndex: row.index, rowId: rowId, lastRow: row === rows[rows.length - 1] ||
                                (nested.enabled && nextVisibleIndex(idx) === -1), insetClass: nestedStyles, rowData: row.data, specialColumns: specialColumns, columns: visibleColumns, showChildContainer: openCloseCacheRef.current.isOpen(row.index), isSelected: isRowSelected(row), onContextMenu: onRowContextMenu, onSelected: (altKey, ctrlKey, shiftKey, metaKey, rowEl, focusableRowEl, e) => {
                                var _a, _b, _c, _d, _e;
                                // Check if the user is selecting text
                                const selection = document.getSelection();
                                const isTextSelected = selection &&
                                    selection.type === 'Range' &&
                                    selection.toString().length > 0;
                                // If text is selected, cancel the click event and prevent row selection
                                if (isTextSelected) {
                                    e.preventDefault(); // Cancel the click event
                                    return;
                                }
                                const hasNestedChildren = nested.enabled && ((_b = (_a = row.data) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.children);
                                const hasChildContainer = !!rowChildContainer;
                                // alt - expand child rows (requires nested rows)
                                // ctrl/meta - check row (requires checkboxes)
                                // shift - check rows from last checked (required ctrl/meta too)
                                if (altKey && (hasNestedChildren || hasChildContainer)) {
                                    openCloseCacheRef.current.toggleFamily(row.index);
                                    startToggleAnimate();
                                    refresh();
                                }
                                if ((ctrlKey || metaKey) && checkbox.enabled) {
                                    const changed = shiftKey && !checkbox.disableShift
                                        ? checkedCacheRef.current.toggleGroup(row.index)
                                        : !checkbox.renderer ||
                                            !checkbox.renderer(row.data.item).disabled
                                            ? checkedCacheRef.current.toggleFamily(row.index) // toggle family defaults to a single item when not nested.
                                            : [];
                                    handleOnCheckedRowsChange(changed);
                                }
                                if (radio.enabled) {
                                    //need to focus on the radio button
                                    (_c = rowEl.querySelector(`input[type='radio'][name^='single-select-radio']:not([disabled],[readonly])`)) === null || _c === void 0 ? void 0 : _c.focus();
                                    handleOnSelectedRowChange((_d = row === null || row === void 0 ? void 0 : row.data) === null || _d === void 0 ? void 0 : _d.item);
                                }
                                else {
                                    // focus the phantom row element
                                    // used only for keyboard event bubbling
                                    const activeElement = document.activeElement;
                                    if (!rowEl.contains(activeElement)) {
                                        focusableRowEl.focus({ preventScroll: true });
                                    }
                                    handleOnSelectedRowChange((_e = row === null || row === void 0 ? void 0 : row.data) === null || _e === void 0 ? void 0 : _e.item);
                                }
                            }, onRowHover: (e) => {
                                if (e.row !== (hoverState === null || hoverState === void 0 ? void 0 : hoverState.row))
                                    setAllowGhost(true);
                                setHoverState(e);
                            }, isChecked: checkMode, lastChecked: shiftHeld &&
                                !checkbox.disableShift &&
                                haunt &&
                                checkedCacheRef.current.lastOpen() === row.index, onChecked: () => {
                                const changed = shiftHeld && !checkbox.disableShift
                                    ? checkedCacheRef.current.toggleGroup(row.index)
                                    : checkedCacheRef.current.toggleFamily(row.index); // toggle family defaults to a single item when not nested.
                                handleOnCheckedRowsChange(changed);
                            }, toggleShowChildContainer: () => {
                                // We want to make sure our columns are frozen if we are showing
                                // any child containers
                                freezeColumns();
                                openCloseCacheRef.current.toggle(row.index);
                                refresh();
                            }, childContainerContent: rowChildContainer, hideChildContainer: hideRowChildContainer, toggleNested: (altKey) => {
                                var _a, _b;
                                if ((_b = (_a = row.data) === null || _a === void 0 ? void 0 : _a.item) === null || _b === void 0 ? void 0 : _b.children) {
                                    if (altKey)
                                        openCloseCacheRef.current.toggleFamily(row.index);
                                    else
                                        openCloseCacheRef.current.toggle(row.index);
                                    startToggleAnimate();
                                    refresh();
                                }
                            }, animateToggle: toggleAnimate, onRowHeightChange: (height) => updateRowHeight(row.index, height), refresh: refresh, 
                            // The 'isSelectable' property is set to true if either 'onSelectedRowChange' or 'onSelectedRowsChange' callbacks are provided,
                            // and the 'radio' object is not enabled, or when it is enabled it can not be disabled or set to read-only.
                            isSelectable: (!!onSelectedRowChange || !!onSelectedRowsChange) &&
                                !((radio === null || radio === void 0 ? void 0 : radio.enabled) &&
                                    (!!((_c = radio === null || radio === void 0 ? void 0 : radio.modeState) === null || _c === void 0 ? void 0 : _c.disabled) ||
                                        !!((_d = radio === null || radio === void 0 ? void 0 : radio.modeState) === null || _d === void 0 ? void 0 : _d.readOnly))), commonId: commonId, gridTestId: testId, onDoubleClicked: () => row.data.item && handleOnDoubleClicked(row.data.item) }));
                    }),
                React__default.createElement(Spacer, { height: spacing.after }),
                !rows && React__default.createElement("div", { className: cx$A('noResults') }, t('LOADING')),
                rows && !searchTerm && rows.length < 1 && (React__default.createElement("div", { className: cx$A('noResults') }, t(noResultsText !== null && noResultsText !== void 0 ? noResultsText : ''))),
                rows && searchTerm && rows.length < 1 && (React__default.createElement("div", { className: cx$A('noResults') }, t((_0 = (_z = searchable === null || searchable === void 0 ? void 0 : searchable.text) === null || _z === void 0 ? void 0 : _z.noResults) !== null && _0 !== void 0 ? _0 : '')))),
            !hideFooter && (React__default.createElement(DataGridFooter, { testId: testId, nested: nested, total: lastPagination === null || lastPagination === void 0 ? void 0 : lastPagination.datasetTotal, search: {
                    searching: !!searchTerm,
                    total: searchTotal,
                    resultsText: (_1 = searchable === null || searchable === void 0 ? void 0 : searchable.text) === null || _1 === void 0 ? void 0 : _1.resultsText
                }, resultsText: resultsText, checkbox: checkbox, nestedTotals: nestedTotals, checkedTotal: currentCheckedCount, checkedSearchHidden: checkedCacheRef.current.hiddenExceptionCount(totalItems !== null && totalItems !== void 0 ? totalItems : 0), checkedConditionalVerbiage: rowActionsConfig.type === 'single-action-conditionable' ||
                    rowActionsConfig.type === 'multi-action-conditionable' })),
            RowActionsConfigUtils.configSupportsRowActionsContextMenus(rowActionsConfig) && (React__default.createElement(ScrollPositionManager, { elemRef: gridRef, setPosition: setMaybeGridScrollPosition })),
            React__default.createElement(DataGridValidationAlert, { error: error, warning: warning }),
            (debugConfig === null || debugConfig === void 0 ? void 0 : debugConfig.showCheckboxCacheFooter) && (React__default.createElement(OpenCloseCacheFooter, { allRowsCount: totalItems !== null && totalItems !== void 0 ? totalItems : 0, visibleRowsCount: searchTotal !== null && searchTotal !== void 0 ? searchTotal : 0, cache: checkedCacheRef.current, generation: generation, type: "check" })),
            (debugConfig === null || debugConfig === void 0 ? void 0 : debugConfig.showConditionalRowActionsFooter) && (React__default.createElement(ConditionalRowActionsFooter, { conditionalRowActionsState: conditionalRowActionsState, bulkActionIds: bulkActionableRowIds })))));
};
/**
 * This logic is heavily based on the src/components/Field/withFieldSchema.tsx hook but modified for the Data Grid.
 */
const DataGridBaseInForm = (_a) => {
    var _b;
    var { canSelectRow } = _a, props = __rest(_a, ["canSelectRow"]);
    /**
     * We need to grab values and any validation errors from form context.
     * We still let any value or error props values override form values.
     */
    const selectedField = useFieldController(String(props.name) + '.selected');
    let error = props.error;
    let warning = props.warning;
    /**
     * Desired is a weird concept in that the form / schema is still valid
     * but we want to show a validation error. So we handle that logic here.
     * If this is a desired field, has a empty value, does not currently have
     * an error and has been touched, set the warning to the desired warning text.
     */
    if (((_b = props.radio) === null || _b === void 0 ? void 0 : _b.enabled) &&
        props.radio.validation === 'desired' &&
        selectedField.showMessages &&
        IsFalseyOrEmpty(selectedField.field.value)) {
        warning = `A selection from the ${props.label} table is desired`;
    }
    /**
     * If they have not passed in an error and the field has been touched or form
     * submitted and the form has an error, set the message here.
     */
    if (!props.error &&
        selectedField.showMessages &&
        selectedField.fieldState.error) {
        error = selectedField.fieldState.error.message;
    }
    const handleRowChange = (row) => {
        selectedField.field.onChange(row);
        props.onSelectedRowChange && props.onSelectedRowChange(row);
        props.onSelectedRowsChange && props.onSelectedRowsChange([row]);
    };
    const handleBlur = (event) => {
        selectedField.field.onBlur();
        props.onBlur && props.onBlur(event);
    };
    const radio = props.radio
        ? Object.assign({}, props.radio) : undefined;
    if (radio && 'enabled' in radio && radio.enabled) {
        radio.firstInputRef = selectedField.field.ref;
    }
    return (React__default.createElement(DataGridBaseCore, Object.assign({}, props, { radio: radio, error: error, onBlur: handleBlur, onSelectedRowChange: canSelectRow ? handleRowChange : undefined, selectedRow: selectedField.field.value, warning: warning })));
};
/**
 * This hook is created from src/components/Field/withFieldSchemaSupport.tsx. While the DataGrid follows some of these patterns to be used within a form
 * it does not use the same pattern as the Field component. This hook is a modified version of the original hook to be used with the DataGrid.
 *
 * @param FieldComponentBase the base-core data grid without form-related logic
 * @param FieldComponentSchema the base-core data grid wrapped in form-related logic
 * @returns A generic React component that is either the base-core data grid or the base-core data grid wrapped in form-related logic.
 */
function withFieldSchemaSupport(FieldComponentBase, FieldComponentSchema) {
    function WithFieldSchemaSupportComponent(_a) {
        var _b, _c, _d, _e;
        var { name, label, radio } = _a, props = __rest(_a, ["name", "label", "radio"]);
        const fieldSchemaName = useFieldSchemaName(String(name));
        /**
         * Try and pull the field schema from the forms context. If it doesn't exist
         * this will return null values.
         */
        const fieldSchema = useFieldSchema(fieldSchemaName);
        // This schema is specifically for the selected row within the datagrid
        const selectedSchema = useFieldSchema(fieldSchemaName ? `${fieldSchemaName}.selected` : fieldSchemaName);
        // warn if using a data grid within a form for selection without having radio enabled
        useADSWarnOnce('While enforcing a Data Grid selection within a form, you should also set `radio.enabled` on the Data Grid to true', !!(selectedSchema === null || selectedSchema === void 0 ? void 0 : selectedSchema.field) && !(radio === null || radio === void 0 ? void 0 : radio.enabled));
        /**
         * We return a fragment otherwise React's reconciliation was causing a teardown
         * and remount here
         */
        return (React__default.createElement(React__default.Fragment, null,
            fieldSchema && fieldSchema.field && (React__default.createElement(FieldComponentSchema, Object.assign({ key: fieldSchemaName, name: fieldSchemaName, label: label || fieldSchema.field.label, radio: (radio === null || radio === void 0 ? void 0 : radio.enabled)
                    ? Object.assign(Object.assign({}, radio), { modeState: {
                            readOnly: (_c = (_b = radio.modeState) === null || _b === void 0 ? void 0 : _b.readOnly) !== null && _c !== void 0 ? _c : fieldSchema.form.readOnly,
                            disabled: (_e = (_d = radio.modeState) === null || _d === void 0 ? void 0 : _d.disabled) !== null && _e !== void 0 ? _e : fieldSchema.form.disabled
                        }, validation: radio.validation ||
                            match(selectedSchema === null || selectedSchema === void 0 ? void 0 : selectedSchema.field)
                                .with({ required: true }, () => 'required')
                                .with({ desired: true }, () => 'desired')
                                .otherwise(() => undefined) }) : radio, 
                // if we are in a form but there is no selected row field in the schema, prevent selecting a row
                canSelectRow: !!(selectedSchema === null || selectedSchema === void 0 ? void 0 : selectedSchema.field) }, props))),
            !(fieldSchema && fieldSchema.field) && (React__default.createElement(FieldComponentBase, Object.assign({ key: fieldSchemaName, name: fieldSchemaName, label: label, radio: radio }, props)))));
    }
    return WithFieldSchemaSupportComponent;
}
//#endregion Data Grid in Form
const DataGridBase = withFieldSchemaSupport(DataGridBaseCore, DataGridBaseInForm);

// Columns are sorted so that the locked columns are at the front
//then if the user chooses to lock them to the end they are moved
//to the end
function useSelectableColumns(columns) {
    let visibleColumns = columns
        .map((c) => new DataColumnModel(c))
        .filter((c) => c.isVisible);
    //Sort locked columns asc
    visibleColumns = sort(visibleColumns).asc((column) => !column.locked);
    //Sort lockedEnd columns desc
    visibleColumns = sort(visibleColumns).desc((column) => !column.lockedEnd);
    const hiddenColumns = columns
        .map((c) => new DataColumnModel(c))
        .filter((c) => !c.isVisible);
    const columnModels = visibleColumns.concat(hiddenColumns);
    const initialSort = React__default.useMemo(() => {
        const sortedColumn = columnModels.find((c) => c.sorted);
        return sortedColumn
            ? {
                column: sortedColumn.name,
                direction: sortedColumn.sorted
            }
            : undefined;
    }, [columnModels]);
    return { columnModels, visibleColumns, initialSort };
}

function sortItems(rows, columns, sort$1, nested, sortChild, idField = 'id') {
    const sortColumn = columns.find((col) => col.name === sort$1.column);
    if (!sortColumn) {
        ADSError(`DataGrid could not find sortColumn ${sort$1.column} 'in the following column config`, columns);
        return rows;
    }
    // Build a sorter function to extract the value used for sorting
    const sorter = (r) => {
        const sv = sortColumn.sortValue(r.item);
        return isString(sv) ? sv.toLowerCase() : sv;
    };
    // We need an asc and desc sorter function
    const ascSorter = sort(rows).asc(sorter);
    const descSorter = sort(rows).desc(sorter);
    if (nested) {
        let nestedRows;
        if (!sortChild) {
            // exclude children from the sort
            const notParents = rows.filter((c) => c.parents.length > 0);
            const sorted = sort$1.direction === SortDirection.Asc
                ? sort(rows.filter((p) => { var _a; return ((_a = p.parents) === null || _a === void 0 ? void 0 : _a.length) === 0; })).asc((r) => sortColumn.sortValue(r.item))
                : sort(rows.filter((p) => { var _a; return ((_a = p.parents) === null || _a === void 0 ? void 0 : _a.length) === 0; })).desc((r) => sortColumn.sortValue(r.item));
            // plop the children on the end, let the nested resorter fix this mess.
            nestedRows = [...sorted, ...notParents];
        }
        else {
            // sort everything as a lump.
            nestedRows =
                sort$1.direction === SortDirection.Asc ? ascSorter : descSorter;
        }
        // fix the parent/child order
        sortFlatNested(nestedRows, idField);
        return nestedRows;
    }
    else {
        // otherwise - no complicated parent/child order to maintain.
        return sort$1.direction === SortDirection.Asc ? ascSorter : descSorter;
    }
}
const DataGrid = (_a) => {
    var { columns, hideFooter = defaultDataGridBaseProps.hideFooter, maxHeight = defaultDataGridBaseProps.maxHeight, minWidth = defaultDataGridBaseProps.minWidth, nested, noResultsText = defaultDataGridBaseProps.noResultsText, resultsText = defaultDataGridBaseProps.resultsText, rowIdField = defaultDataGridBaseProps.rowIdField, rows, searchable } = _a, props = __rest(_a, ["columns", "hideFooter", "maxHeight", "minWidth", "nested", "noResultsText", "resultsText", "rowIdField", "rows", "searchable"]);
    const setItemsRef = React__default.useRef(null);
    const [sort, setSort] = React__default.useState(null);
    const [searchTerm, setSearchTerm] = React__default.useState(null);
    /*
     * Since an array of undefined or null is used to indicate a loading state
     * that shows one row skeleton for each `null | undefined` in the array. Do
     * not consider this "valid data."
     * - E.g.: Searching during this time would be nonsensical.
     *
     * Note: By using `any[]` for the type of `rows`, it is possible and also
     * inherently ambiguous if `rows` could be partially "valid" and partially
     * `null | undefined`.
     */
    const hasPlaceholderRows = React__default.useMemo(() => {
        var _a;
        return ((_a = (rows &&
            (rows === null || rows === void 0 ? void 0 : rows.length) > 0 &&
            rows.every((r) => r === undefined || r === null))) !== null && _a !== void 0 ? _a : false);
    }, [rows]);
    // Apply searchable prop defaults in case they pass a partially filled search config
    defaultsDeep(searchable, searchablePropsDefaults);
    const { columnModels, visibleColumns, initialSort } = useSelectableColumns(columns);
    const searchableRows = React__default.useMemo(() => convertToSearchableRows(rows, visibleColumns, rowIdField), [rows, rowIdField, visibleColumns]);
    React__default.useEffect(() => {
        if (setItemsRef.current && searchableRows) {
            let nRows = searchableRows;
            // if and only if [valid rows of data] then [search and sort]
            if (!hasPlaceholderRows) {
                // 1st) search (if needed)
                if (nRows && (searchable === null || searchable === void 0 ? void 0 : searchable.enabled) && searchTerm) {
                    const searchKeys = visibleColumns.map((_c, i) => `cells.${i}.text`);
                    nRows = FuzzSearch(nRows, searchKeys, searchTerm, searchable === null || searchable === void 0 ? void 0 : searchable.exactMatch, rowIdField);
                }
                // 2nd) sort (if needed)
                if (sort && columnModels) {
                    nRows = sortItems(nRows, columnModels, sort, nested === null || nested === void 0 ? void 0 : nested.enabled, nested === null || nested === void 0 ? void 0 : nested.sortChildren, rowIdField);
                }
                else if (nested === null || nested === void 0 ? void 0 : nested.enabled) {
                    // if the list is nested, get the parents and children back together again.
                    sortFlatNested(nRows, rowIdField);
                }
            }
            if (setItemsRef.current) {
                const totals = getDatasetTotals(rows);
                setItemsRef.current(nRows, {
                    start: 0,
                    end: nRows.length,
                    total: nRows.length,
                    datasetTotal: totals
                });
            }
        }
    }, [
        columnModels,
        hasPlaceholderRows,
        nested,
        rows,
        searchable === null || searchable === void 0 ? void 0 : searchable.enabled,
        searchableRows,
        searchTerm,
        sort,
        visibleColumns,
        rowIdField,
        searchable === null || searchable === void 0 ? void 0 : searchable.exactMatch
    ]);
    const dataSource = (setItems, 
    // We don't care about the startIndex for DataGrid since we will return all data
    _startIndex, sort, searchTerm) => {
        setItemsRef.current = setItems;
        setSort(sort);
        setSearchTerm(searchTerm);
    };
    return (React__default.createElement(DataGridBase, Object.assign({ columns: columnModels, dataSource: dataSource, 
        // do not show an item-count footer for placeholder "loading" rows
        hideFooter: hideFooter || hasPlaceholderRows, initColumnSortState: initialSort, maxHeight: maxHeight, minWidth: minWidth, nested: nested, noResultsText: noResultsText, resultsText: resultsText, rowIdField: rowIdField, searchable: searchable }, props)));
};

const DataGridPaginated = (_a) => {
    var _b;
    var { columns, dataSource, hideFooter = defaultDataGridBaseProps.hideFooter, maxHeight = defaultDataGridBaseProps.maxHeight, minWidth = defaultDataGridBaseProps.minWidth, nested, noResultsText = defaultDataGridBaseProps.noResultsText, resultsText = defaultDataGridBaseProps.resultsText, rowIdField = defaultDataGridBaseProps.rowIdField, searchable } = _a, props = __rest(_a, ["columns", "dataSource", "hideFooter", "maxHeight", "minWidth", "nested", "noResultsText", "resultsText", "rowIdField", "searchable"]);
    // Set searchable defaults for paginated. We want highlightOnly to default to true
    searchable = searchable !== null && searchable !== void 0 ? searchable : { enabled: false };
    searchable.highlightOnly = (_b = searchable.highlightOnly) !== null && _b !== void 0 ? _b : true;
    const totalItemsRef = React__default.useRef(0);
    const { columnModels, visibleColumns, initialSort } = useSelectableColumns(columns);
    // We need to convert all incoming rows of data to be our SearchableRows
    // which is what the base components expects.
    const paginatedDataSource = React__default.useCallback((_setItems, startIndex, sort, searchTerm) => {
        const setItems = (rawItems, pagination) => {
            var _a, _b;
            // Convert all rows into Searchable rows
            // console.log('Raw Items:', rawItems);
            totalItemsRef.current = ((_a = rawItems === null || rawItems === void 0 ? void 0 : rawItems.length) !== null && _a !== void 0 ? _a : 0) - 1;
            const items = convertToSearchableRows(rawItems, visibleColumns, rowIdField, ((_b = nested === null || nested === void 0 ? void 0 : nested.paginationLevel) !== null && _b !== void 0 ? _b : 'all') === 'parent' ? 0 : -1, totalItemsRef.current, pagination.start);
            if (items && searchable && searchable.highlightOnly && searchTerm) {
                // In some cases we want to highlight the rows but not sort or filter the rows.
                // This is used in the DataGridPaginated case. This would probably be cleaner
                // if done in the DataGridPaginated component but would require some hoops to hijack
                // the setItems function of dataSource.
                const searchKeys = visibleColumns.map((_c, i) => `cells.${i}.text`);
                HighlightOnly(searchTerm, searchKeys, items);
            }
            _setItems(items !== null && items !== void 0 ? items : [], pagination);
        };
        dataSource(setItems, startIndex, sort, searchTerm);
    }, [
        dataSource,
        searchable,
        visibleColumns,
        rowIdField,
        nested === null || nested === void 0 ? void 0 : nested.paginationLevel
    ]);
    return (React__default.createElement(DataGridBase, Object.assign({ columns: columnModels, dataSource: paginatedDataSource, hideFooter: hideFooter, initColumnSortState: initialSort, isPaginated: true, maxHeight: maxHeight, minWidth: minWidth, nested: nested, noResultsText: noResultsText, resultsText: resultsText, rowIdField: rowIdField, searchable: searchable }, props)));
};

var css$u = ".Calendar_module_datePickerCalendar__b0de2d27{font-size:14px;line-height:20px;margin:8px 12px;width:fit-content}.Calendar_module_datePickerCalendar__b0de2d27 .Calendar_module_datePickerCalendarToday__b0de2d27{border-top:1px solid #d9dbe3;display:grid;padding-top:8px}.Calendar_module_datePickerCalendar__b0de2d27 .Calendar_module_datePickerCalendarToday__b0de2d27 button{border-radius:2px;margin:0;padding:6px 8px;text-decoration:none;width:auto}.Calendar_module_datePickerCalendar__b0de2d27 .Calendar_module_datePickerCalendarToday__b0de2d27 button:hover{background-color:#e3eafc;border-color:#0000}.Calendar_module_datePickerCalendar__b0de2d27 .Calendar_module_datePickerCalendarToday__b0de2d27 button:active{background-color:#d5e1fb}[class*=datePickerCalendar] .react-calendar button{border-radius:2px;color:#363840;font:inherit}[class*=datePickerCalendar] .react-calendar{background:#fff;border:1px solid #b0b4bf;max-width:100%;width:350px}[class*=datePickerCalendar] .react-calendar--doubleView{width:700px}[class*=datePickerCalendar] .react-calendar--doubleView .react-calendar__viewContainer{display:flex;margin:-.5em}[class*=datePickerCalendar] .react-calendar--doubleView .react-calendar__viewContainer>*{margin:.5em;width:50%}[class*=datePickerCalendar] .react-calendar,[class*=datePickerCalendar] .react-calendar *,[class*=datePickerCalendar] .react-calendar :after,[class*=datePickerCalendar] .react-calendar :before{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}[class*=datePickerCalendar] .react-calendar button{border:0;margin:0;outline:none}[class*=datePickerCalendar] .react-calendar button.react-calendar__tile--active{outline:1px solid #1ea7fd}[class*=datePickerCalendar] .react-calendar button:enabled:hover{cursor:pointer}[class*=datePickerCalendar] .react-calendar__navigation{display:flex;height:44px;margin-bottom:1em}[class*=datePickerCalendar] .react-calendar__navigation button{background:none;min-width:44px}[class*=datePickerCalendar] .react-calendar__navigation button:enabled:focus,[class*=datePickerCalendar] .react-calendar__navigation button:enabled:hover{background-color:#e6e6e6}[class*=datePickerCalendar] .react-calendar__navigation button[disabled]{background-color:#f0f0f0}[class*=datePickerCalendar] .react-calendar__month-view__weekdays{border-bottom:1px solid #b0b4bf;font-weight:700;text-align:center;text-transform:uppercase}[class*=datePickerCalendar] .react-calendar__month-view__weekdays__weekday{padding:.5em}[class*=datePickerCalendar] .react-calendar__month-view__weekNumbers .react-calendar__tile{align-items:center;display:flex;font-weight:700;justify-content:center;padding:1em .6666666667em}[class*=datePickerCalendar] .react-calendar__month-view__days__day--weekend{color:#d10000}[class*=datePickerCalendar] .react-calendar__month-view__days__day--neighboringMonth{color:#757575}[class*=datePickerCalendar] .react-calendar__century-view .react-calendar__tile,[class*=datePickerCalendar] .react-calendar__decade-view .react-calendar__tile,[class*=datePickerCalendar] .react-calendar__year-view .react-calendar__tile{padding:2em .5em}[class*=datePickerCalendar] .react-calendar__tile{background:none;max-width:100%;padding:.75em .5em;text-align:center}[class*=datePickerCalendar] .react-calendar__tile:disabled{background-color:#f0f0f0}[class*=datePickerCalendar] .react-calendar__tile:enabled:focus,[class*=datePickerCalendar] .react-calendar__tile:enabled:hover{background-color:#e6e6e6}[class*=datePickerCalendar] .react-calendar__tile--now{outline:#1ea7fd}[class*=datePickerCalendar] .react-calendar__tile--hasActive,[class*=datePickerCalendar] .react-calendar__tile--hasActive:enabled:focus,[class*=datePickerCalendar] .react-calendar__tile--hasActive:enabled:hover,[class*=datePickerCalendar] .react-calendar__tile--now:enabled:focus,[class*=datePickerCalendar] .react-calendar__tile--now:enabled:hover{background:#1ea7fd}[class*=datePickerCalendar] .react-calendar__tile--active:enabled:focus,[class*=datePickerCalendar] .react-calendar__tile--active:enabled:hover{background:#e6e6e6}[class*=datePickerCalendar] .react-calendar--selectRange .react-calendar__tile--hover{background-color:#e6e6e6}.react-calendar.ads-calendar{border:none;color:#363840;width:300px}.react-calendar.ads-calendar button.react-calendar__tile--active,.react-calendar.ads-calendar button.react-calendar__tile--active:hover{outline:1px solid #1ea7fd}.react-calendar.ads-calendar .react-calendar__navigation{gap:8px;height:32px;margin-bottom:8px}.react-calendar.ads-calendar .react-calendar__navigation__label{font-weight:600}.react-calendar.ads-calendar .react-calendar__navigation button{max-height:32px;min-width:36px}.react-calendar.ads-calendar .react-calendar__navigation button:enabled:focus,.react-calendar.ads-calendar .react-calendar__navigation button:enabled:hover{background-color:#e3eafc}.react-calendar.ads-calendar .react-calendar__navigation button:enabled:active{background-color:#d5e1fb}.react-calendar.ads-calendar .react-calendar__navigation__next-button,.react-calendar.ads-calendar .react-calendar__navigation__next2-button,.react-calendar.ads-calendar .react-calendar__navigation__prev-button,.react-calendar.ads-calendar .react-calendar__navigation__prev2-button{font-size:20px;line-height:20px;padding-bottom:6px}.react-calendar.ads-calendar .react-calendar__navigation button[disabled]{background:none;color:#b0b4bf}.react-calendar.ads-calendar .react-calendar__month-view__weekdays{border-bottom:1px solid #d9dbe3;font-size:12px;font-weight:700;gap:4px 8px}.react-calendar.ads-calendar .react-calendar__month-view__weekdays abbr{text-decoration:none}.react-calendar.ads-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday{flex-shrink:1!important}.react-calendar.ads-calendar .react-calendar__tile:enabled:focus,.react-calendar.ads-calendar .react-calendar__tile:enabled:hover{background-color:#e3eafc}.react-calendar.ads-calendar .react-calendar__tile:enabled:active{background-color:#d5e1fb}.react-calendar.ads-calendar .react-calendar__tile--now:enabled:focus,.react-calendar.ads-calendar .react-calendar__tile--now:enabled:hover{border-color:#365ef6}.react-calendar.ads-calendar .react-calendar__month-view__days{gap:4px 8px;margin:8px 0}.react-calendar.ads-calendar .react-calendar__month-view__days__day{height:32px!important;max-width:36px!important;min-width:36px!important}.react-calendar.ads-calendar .react-calendar__month-view__days__day--neighboringMonth{color:#b0b4bf!important}.react-calendar.ads-calendar .react-calendar__month-view__days__day.react-calendar__tile{padding:0}.react-calendar.ads-calendar .react-calendar__century-view .react-calendar__tile,.react-calendar.ads-calendar .react-calendar__decade-view .react-calendar__tile,.react-calendar.ads-calendar .react-calendar__year-view .react-calendar__tile{padding:8px}.react-calendar.ads-calendar .react-calendar__year-view__months{gap:8px;margin:8px 0}.react-calendar.ads-calendar .react-calendar__year-view__months__month{flex-basis:calc(25% - 6px)!important;min-height:67px}.react-calendar.ads-calendar .react-calendar__decade-view__years{gap:8px;margin:8px 0}.react-calendar.ads-calendar .react-calendar__decade-view__years__year{flex-basis:calc(25% - 6px)!important;max-width:calc(25% - 6px)!important;min-height:67px}.react-calendar.ads-calendar .react-calendar__century-view__decades{gap:8px;margin:8px 0}.react-calendar.ads-calendar .react-calendar__century-view__decades__decade{flex-basis:calc(25% - 6px)!important;max-width:calc(25% - 6px)!important;min-height:67px}.react-calendar.ads-calendar button{border:1px solid #0000;margin:0;outline:none}.react-calendar.ads-calendar button.react-calendar__tile--active,.react-calendar.ads-calendar button.react-calendar__tile--active:hover,.react-calendar.ads-calendar button.react-calendar__tile--hasActive{background-color:#365ef6!important;color:#fff;font-weight:700;outline:none}";
window.ADS.injectStyle(css$u,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/DatePicker/Calendar.module.scss");
var modules_c3828464 = {"datePickerCalendar":"Calendar_module_datePickerCalendar__b0de2d27","datePickerCalendarToday":"Calendar_module_datePickerCalendarToday__b0de2d27"};

const cx$z = BindStyles(modules_c3828464);
function formatSingleDigitDateLabel(locale, date) {
    return date.toLocaleString(locale !== null && locale !== void 0 ? locale : 'en-US', { weekday: 'narrow' });
}
function formatShortMonthLabel(locale, date) {
    return date.toLocaleString(locale !== null && locale !== void 0 ? locale : 'en-US', { month: 'short' });
}
function Calendar(_a) {
    var _b;
    var { dateOrderFormat, locale = 'en-US', testId = 'datePickerCalendar', value, onChange } = _a, props = __rest(_a, ["dateOrderFormat", "locale", "testId", "value", "onChange"]);
    const inputRef = React__default.useRef(null);
    const { t } = useTranslation();
    const currentDate = DateTime.now().startOf('day').toJSDate();
    let linkDate = DateTime.fromJSDate(new Date()).startOf('day');
    let linkText = '';
    if (props.minDate && props.minDate.getTime() > currentDate.getTime()) {
        linkDate = DateTime.fromJSDate((_b = props.minDate) !== null && _b !== void 0 ? _b : new Date()).startOf('day');
        linkText = 'EARLIEST_DATE';
    }
    if ((props.minDate && props.minDate.getTime() <= currentDate.getTime()) ||
        !props.minDate) {
        linkText = 'TODAY';
    }
    const todayLinkText = React__default.useMemo(() => {
        const dateWithLocale = linkDate.setLocale(locale);
        const displayDateFormat = match(dateOrderFormat)
            .with('DMY', () => 'd MMMM yyyy')
            .with('MDY', () => 'MMMM d, yyyy')
            .with('YMD', () => 'yyyy-MM-dd')
            .exhaustive();
        return `${t(linkText)} (${dateWithLocale.toFormat(displayDateFormat)})`;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locale]);
    function handleTodayClick() {
        onChange(linkDate.toJSDate());
    }
    if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
        inputRef.current.focus();
    }
    function handleChange(value) {
        if (value instanceof Date) {
            onChange(value);
        }
    }
    return (React__default.createElement("div", { className: cx$z('datePickerCalendar'), "data-test": testId },
        React__default.createElement(ReactCalendar, Object.assign({ inputRef: inputRef, className: "ads-calendar", onChange: handleChange, value: value, locale: locale, showFixedNumberOfWeeks: true, minDetail: 'decade', formatShortWeekday: formatSingleDigitDateLabel, formatMonth: formatShortMonthLabel }, props)),
        React__default.createElement("span", { className: cx$z('datePickerCalendarToday') },
            React__default.createElement(Button, { testId: `${testId}-todayButton`, onClick: handleTodayClick, type: "link" }, todayLinkText))));
}

const DATE_PARTS_CONFIG_MAP = {
    inputPattern: {
        day: '[00]',
        month: '[00]',
        year: '[0000]'
    },
    dateFromStringFormat: {
        day: 'd',
        month: 'M',
        year: 'yy'
    }
};
const useFormatDate = () => {
    const { locale, localeData } = useLocale();
    const { dateDelimiter, date: inputDisplayFormat, dateOrderFormat } = localeData;
    const inputMaskPattern = React__default.useMemo(() => {
        return getDateFormat(dateOrderFormat, dateDelimiter, 'inputPattern');
    }, [dateOrderFormat, dateDelimiter]);
    const dateFromStringFormat = React__default.useMemo(() => {
        return getDateFormat(dateOrderFormat, dateDelimiter, 'dateFromStringFormat');
    }, [dateDelimiter, dateOrderFormat]);
    const dateFromStringFormatWithoutYear = React__default.useMemo(() => {
        return (dateFromStringFormat
            // remove the year and takeoff the delimiter from the start and end
            .replaceAll('y', '')
            /**
             * Our delimiters can only be `/` or `-` today so we are stripping out those two characters.
             * We can use the `new Regexp()` syntax to take in the `dateDelimiter` variable but
             * Orca flagged this as a potential security issue. Our tests ensure that if a new delimiter type was added,
             * that it would be caught. We can revisit this if we add a new delimiter type.
             */
            .replace(/^[-/]|[-/]$/g, ''));
    }, [dateFromStringFormat]);
    // Utility function to return a `DateTime` from `any | string`.
    // Will check for a full date string first, if that fails it will
    // check if the year is missing and append the current year.
    const dateTimeFromFormat = React__default.useCallback((value) => {
        const fullDateOutput = DateTime.fromFormat(value, dateFromStringFormat);
        if (fullDateOutput.isValid) {
            return fullDateOutput;
        }
        else {
            // If the date is not valid, check if the year is missing. Trim any divider chars from the end.
            const trimVal = ['/', '-'].includes(value.slice(-1))
                ? value.slice(0, -1)
                : value;
            return DateTime.fromFormat(trimVal, dateFromStringFormatWithoutYear);
        }
    }, [dateFromStringFormat, dateFromStringFormatWithoutYear]);
    const getDateFromValue = React__default.useCallback((value, UTCDate) => {
        if (IsFalseyOrEmpty(value)) {
            return undefined;
        }
        if (value instanceof Date) {
            if (UTCDate) {
                return AddTimezoneOffset(value);
            }
            else {
                return value;
            }
        }
        if (typeof value === 'string') {
            if (IsISODateString(value)) {
                if (DateTime.fromISO(String(value)).isValid) {
                    if (UTCDate) {
                        return AddTimezoneOffset(new Date(String(value)));
                    }
                    else {
                        return new Date(String(value));
                    }
                }
            }
            else {
                const parsedDate = dateTimeFromFormat(value);
                return parsedDate.isValid
                    ? UTCDate
                        ? AddTimezoneOffset(parsedDate.toJSDate())
                        : parsedDate.toJSDate()
                    : undefined;
            }
        }
        throw new Error(`value: ${value} is not a string, Date or undefined`);
    }, [dateTimeFromFormat]);
    // Utility function to return a `string` from `Date`.
    const dateTimeToFormat = React__default.useCallback((date) => {
        return DateTime.fromJSDate(date).toFormat(inputDisplayFormat);
    }, [inputDisplayFormat]);
    return {
        dateOrderFormat,
        inputMaskPattern,
        locale,
        dateTimeFromFormat,
        dateTimeToFormat,
        getDateFromValue
    };
};
// Convert the date order format to a true date format, depending on the use case
function getDateFormat(dateOrderFormat, delimiter, config) {
    return dateOrderFormat
        .split('') // split the date order format into an array of characters
        .join(delimiter)
        .replace('D', DATE_PARTS_CONFIG_MAP[config].day)
        .replace('M', DATE_PARTS_CONFIG_MAP[config].month)
        .replace('Y', DATE_PARTS_CONFIG_MAP[config].year);
}

// Define a default placement configuration
const DEFAULT_DATEPICKER_PLACEMENT = {
    placement: 'bottom-start',
    fallbackPlacements: ['top-start', 'bottom-end', 'top-end']
};
// Utility function to return to the provided callback an modified date object
// that's been translated from the passed in duration
function updateDate(duration, min, max, setDate) {
    setDate((old) => {
        if (old) {
            const newDate = DateTime.fromJSDate(old).plus(duration);
            if (newDate.startOf('day') >= DateTime.fromJSDate(min).startOf('day') &&
                newDate.startOf('day') <= DateTime.fromJSDate(max).startOf('day')) {
                return newDate.toJSDate();
            }
            return old;
        }
        else {
            return DateTime.now().toJSDate();
        }
    });
}
const DatePickerBase = (_a) => {
    var { customDataProps, className, disabled, label, max = new Date(2499, 11, 31), min = new Date(1700, 0, 1), name, UTCDate, onBlur, onChange, readOnly, testId, placementConfig = DEFAULT_DATEPICKER_PLACEMENT, value, onContextMenu } = _a, props = __rest(_a, ["customDataProps", "className", "disabled", "label", "max", "min", "name", "UTCDate", "onBlur", "onChange", "readOnly", "testId", "placementConfig", "value", "onContextMenu"]);
    const textFieldRef = React__default.useRef(null);
    const currentDate = DateTime.now().startOf('day').toJSDate();
    const { dateOrderFormat, inputMaskPattern, locale, dateTimeFromFormat, dateTimeToFormat, getDateFromValue } = useFormatDate();
    // If we have a value and it's not a date object, convert it to a date object
    if (value !== undefined) {
        value = getDateFromValue(value, UTCDate);
    }
    const [currentValue, setCurrentValue] = React__default.useState(value);
    const [calendarValue, setCalendarValue] = React__default.useState(value);
    const [textValue, setTextValue] = React__default.useState();
    const { dropdown, dropdownProps, dropdownAnchorRef } = useDropdown({
        numberOfItems: 1,
        keyboardEnabled: !(disabled || readOnly),
        onEnterKey: (e) => {
            const handleSelection = () => {
                setCurrentValue(calendarValue);
                if (!textValue &&
                    calendarValue &&
                    (currentValue === null || currentValue === void 0 ? void 0 : currentValue.valueOf()) === (calendarValue === null || calendarValue === void 0 ? void 0 : calendarValue.valueOf())) {
                    // Text value was cleared without blurring -
                    // But the selection made was the same as the old date
                    // Reset the text value in this case.
                    setTextValue(dateTimeToFormat(calendarValue));
                }
                dropdown.setOpen(false);
                onChange && onChange({ target: { name, value: calendarValue } });
            };
            if (e.target === textFieldRef.current) {
                if (dropdown.open) {
                    handleSelection();
                }
            }
            else {
                // We hit enter with the icon focused
                if (dropdown.open) {
                    handleSelection();
                }
                else {
                    dropdown.setOpen(true);
                }
            }
        },
        onArrowUpKey: () => {
            if (!dropdown.open)
                dropdown.setOpen(true);
            else
                updateDate({ weeks: -1 }, min, max, setCalendarValue);
        },
        onArrowDownKey: () => {
            if (!dropdown.open)
                dropdown.setOpen(true);
            else
                updateDate({ weeks: 1 }, min, max, setCalendarValue);
        }
    });
    // To prevent mousedown events in the dropdown from triggering blur
    React__default.useEffect(() => {
        if (!dropdown.el || !dropdown.open)
            return;
        // Prevent mousedown events on the calendar from triggering focus changes
        // which would cause blur events that close the dropdown
        const handleCalendarMouseDown = (e) => {
            e.preventDefault();
        };
        dropdown.el.addEventListener('mousedown', handleCalendarMouseDown);
        return () => {
            if (dropdown.el) {
                dropdown.el.removeEventListener('mousedown', handleCalendarMouseDown);
            }
        };
    }, [dropdown.el, dropdown.open]);
    React__default.useEffect(() => {
        if (value &&
            value instanceof Date &&
            value.getTime() !== (currentValue === null || currentValue === void 0 ? void 0 : currentValue.getTime())) {
            setCurrentValue(value);
        }
        else {
            if (!value) {
                setCurrentValue(undefined);
                setTextValue('');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(value)]);
    React__default.useEffect(() => {
        let displayDate = new Date();
        if (min && min.getTime() > currentDate.getTime()) {
            displayDate = min;
        }
        if ((min && min.getTime() <= currentDate.getTime()) || !min) {
            displayDate = currentDate;
        }
        if (dropdown.open) {
            const dateValue = dateTimeFromFormat(textValue !== null && textValue !== void 0 ? textValue : '');
            setCalendarValue(dateValue.isValid ? dateValue.toJSDate() : displayDate);
        }
        else {
            if (!isEqual(currentValue, calendarValue)) {
                setCalendarValue(currentValue);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dropdown.open]);
    React__default.useEffect(() => {
        if (currentValue) {
            const dateString = dateTimeToFormat(currentValue);
            setTextValue(dateString);
        }
        setCalendarValue(currentValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(currentValue), locale]);
    const handleChange = (e) => {
        // special cases for preventing overzealous divider formatting
        const invalid = ['/', '-', '//', '--'];
        let val = e.target.value;
        if (invalid.includes(val)) {
            // val is one or both dividers, just clear it
            val = '';
        }
        else if (val.length > 2 && invalid.includes(val.slice(-2))) {
            val = val.slice(0, -1);
        }
        setTextValue(val);
    };
    const focusInput = () => {
        var _a, _b;
        const el = textFieldRef.current;
        if (el) {
            const valueLength = (_b = (_a = el.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
            el.focus();
            el.setSelectionRange(valueLength, valueLength);
        }
    };
    const handleCalendarChange = (changedValue) => {
        let valueChanged = true;
        if (UTCDate) {
            // PW-10841
            if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.getTime()) === (changedValue === null || changedValue === void 0 ? void 0 : changedValue.getTime())) {
                valueChanged = false;
            }
            else {
                if (changedValue) {
                    changedValue = SubtractTimezoneOffset(changedValue);
                }
            }
        }
        if (valueChanged) {
            onChange &&
                onChange({
                    target: {
                        name,
                        value: changedValue
                    }
                });
            setCurrentValue(changedValue !== null && changedValue !== void 0 ? changedValue : undefined);
            if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.valueOf()) === (changedValue === null || changedValue === void 0 ? void 0 : changedValue.valueOf()) && !textValue) {
                // Text value was cleared without blurring -
                // But the selection made was the same as the old date
                // so reset the text value
                if (changedValue) {
                    setTextValue(dateTimeToFormat(changedValue));
                }
            }
        }
        dropdown.setOpen(false);
        focusInput();
    };
    const handleInputBlur = (e) => {
        // We only want this to happen if we are losing focus to something outside the input
        // or icon.
        OnFocusOutside(e, [dropdownProps.anchorEl, dropdown.el], () => {
            if (!e.target.value) {
                // value has been cleared so we need to delete it from form state
                onChange &&
                    onChange({
                        target: {
                            name,
                            value: null
                        }
                    });
                return;
            }
            // When our input is blurred, we try and take the inputted value
            // and parse it into a valid date object. If not we clear the field.
            const selection = dateTimeFromFormat(e.target.value);
            if (!selection.isValid ||
                selection.toJSDate().getTime() < min.getTime() ||
                selection.toJSDate().getTime() > max.getTime()) {
                // Clear our values as it's not a valid date.
                if (currentValue !== undefined) {
                    onChange &&
                        onChange({
                            target: { name, value: undefined }
                        });
                }
                setCurrentValue(undefined);
                setTextValue(undefined);
            }
            else {
                // UTC-date case
                if (UTCDate) {
                    // current value is changing
                    if (!currentValue ||
                        (currentValue &&
                            (currentValue === null || currentValue === void 0 ? void 0 : currentValue.getTime()) !==
                                SubtractTimezoneOffset(selection.toJSDate()).getTime() &&
                            SubtractTimezoneOffset(currentValue).getTime() !==
                                SubtractTimezoneOffset(selection.toJSDate()).getTime())) {
                        onChange &&
                            onChange({
                                target: {
                                    name,
                                    value: SubtractTimezoneOffset(selection.toJSDate())
                                }
                            });
                        setCurrentValue(SubtractTimezoneOffset(selection.toJSDate()));
                    }
                    // current value is *not* changing
                    else {
                        setTextValue(dateTimeToFormat(currentValue));
                    }
                }
                // non-UTC-date case
                else {
                    // current value is changing
                    if ((currentValue === null || currentValue === void 0 ? void 0 : currentValue.getTime()) !== selection.toJSDate().getTime()) {
                        onChange &&
                            onChange({ target: { name, value: selection.toJSDate() } });
                        setCurrentValue(selection.toJSDate());
                    }
                    // current value is *not* changing
                    else {
                        setTextValue(dateTimeToFormat(currentValue));
                    }
                }
            }
        });
    };
    const handleBlur = (e) => {
        OnFocusOutside(e, [dropdownProps.anchorEl, dropdown.el], () => {
            onBlur && onBlur({ target: { name, value } });
            dropdown.blurred(e);
        });
    };
    const onKeyDownHandler = (e) => {
        if (disabled || readOnly) {
            return;
        }
        const keyMap = [
            {
                ArrowLeft: () => dropdown.open && updateDate({ days: -1 }, min, max, setCalendarValue)
            },
            {
                ArrowRight: () => dropdown.open && updateDate({ days: 1 }, min, max, setCalendarValue)
            }
        ];
        // Handle the event based off which key was pressed
        const handled = KeyHandleMap(e, keyMap);
        // If we handled the keydown event, cancel it from propagating
        if (handled && dropdown.open) {
            CancelReactEvent(e);
        }
    };
    const handleIconClick = () => {
        dropdown.toggle();
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, onKeyDown: onKeyDownHandler, onBlur: handleBlur, tabIndex: -1, className: className, onContextMenu: onContextMenu }),
        React__default.createElement(TextField, Object.assign({}, props, { label: label, testId: testId ? `${testId}-textfield` : undefined, ref: textFieldRef, wrapperRef: dropdownAnchorRef, name: `${name}-mask`, onChange: handleChange, disabled: disabled, readOnly: readOnly, value: textValue, onBlur: handleInputBlur, format: { pattern: inputMaskPattern }, endIcon: { name: 'CalendarIcon', onClick: handleIconClick } })),
        React__default.createElement(Dropdown, Object.assign({}, dropdownProps, { placementConfig: placementConfig }),
            React__default.createElement(DropdownContainer, { maxHeight: 1000, maxWidth: 336 },
                React__default.createElement(Calendar, { dateOrderFormat: dateOrderFormat, locale: locale, maxDate: max, minDate: min, onChange: handleCalendarChange, testId: testId ? `${testId}-calendar` : undefined, value: calendarValue })))));
};
// Version of component that is not controlled. Meaning it will
// keep it's own state. This is the version used if value
// and onChange is not used directly OR by a form. Maybe they are
// only grabbing the value on blur?
const UnControlledDatePicker = (props) => {
    const { getDateFromValue } = useFormatDate();
    const [value, setValue] = React__default.useState(getDateFromValue(props.value, props.UTCDate) || '');
    return (React__default.createElement(DatePickerBase, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneDatePicker = withStandAlone(UnControlledDatePicker, DatePickerBase);
/**
 * `DatePicker` allows the user to select a date.
 */
const DatePicker = withFieldSchemaSupport$1(StandAloneDatePicker, withFieldSchema(DatePickerBase));

const defaultFormatConfig$1 = {
    allowNegative: undefined,
    decimal: {
        maxLength: 2,
        minLength: undefined
    },
    hasThousandsSeparator: true,
    integral: {
        maxLength: undefined
    }
};
const DecimalField = (_a) => {
    var { locale, maximumDecimals = defaultFormatConfig$1.decimal.maxLength } = _a, props = __rest(_a, ["locale", "maximumDecimals"]);
    const { locale: detectedLocale } = useLocale(locale);
    return (React__default.createElement(NumberField, Object.assign({}, props, { locale: detectedLocale, formatStyle: FormatStyleTypes.DECIMAL, maximumDecimals: maximumDecimals, defaultFormatConfig: defaultFormatConfig$1 })));
};

/**
 * Wrapper around a set of children fields. SubForms work by adding their
 * schema to the parent form's schema. It also creates a name context
 * for the SubForm's child fields to use. The child fields use the name value
 * in the SubForm context to make the path they should use to look up their
 * errors, labels, and values.
 */
const SubForm = ({ name, schema, clearSchemaOnUnmount, children }) => {
    var _a;
    const subFormSchema = React__default.useMemo(() => schema !== null && schema !== void 0 ? schema : object(), [schema]);
    const { clearSchemaOnUnmount: formClearSchemaOnUnmount, formId, inForm, registerSubSchema, unRegisterSubSchema } = useInternalFormContext();
    const subFormName = useFieldSchemaName(name);
    /**
     * We cast this as a partial because we may not be in a form which would result in useFormContext
     * returning undefined. This partial enforces that Typescript will give us an error if we don't check
     * that these functions are defined before using them.
     */
    const { unregister, resetField } = ((_a = useFormContext$1()) !== null && _a !== void 0 ? _a : {});
    // If clearSchemaOnUnmount is not set for the SubForm, use the value set for Form
    if (clearSchemaOnUnmount === undefined) {
        clearSchemaOnUnmount = formClearSchemaOnUnmount;
    }
    React__default.useEffect(() => {
        registerSubSchema(subFormName, subFormSchema);
    }, [registerSubSchema, subFormName, subFormSchema]);
    // On unmount we want to null out our schema.
    React__default.useEffect(() => {
        return () => {
            if (clearSchemaOnUnmount) {
                // if we don't call resetField, the top level isDirty does not update correctly.
                resetField &&
                    resetField(subFormName, {
                        keepDirty: false,
                        keepError: false,
                        keepTouched: false,
                        defaultValue: null
                    });
                unregister &&
                    unregister(subFormName, {
                        keepDefaultValue: false,
                        keepDirty: false,
                        keepError: false,
                        keepIsValid: false,
                        keepTouched: false,
                        keepValue: false
                    });
                unRegisterSubSchema(subFormName);
            }
        };
    }, [
        clearSchemaOnUnmount,
        resetField,
        subFormName,
        unRegisterSubSchema,
        unregister
    ]);
    const contextValue = React__default.useMemo(() => ({
        name: subFormName,
        parentFormId: formId
    }), [formId, subFormName]);
    if (!inForm) {
        ADSError(`SubForm named ${name} did not find a parent form context. Make sure all SubForms are nested under a Form component.`);
        return null;
    }
    return (React__default.createElement(SubFormContext.Provider, { value: contextValue }, children));
};

var css$t = ".RowWrapper_module_hideLabels__4d0be08c [data-label]{height:0;margin-bottom:0;max-height:0;min-height:0;visibility:hidden}.RowWrapper_module_removeBtn__4d0be08c{align-items:center;cursor:pointer;display:block;display:flex;height:32px}.RowWrapper_module_removeBtn__4d0be08c:hover:not(.RowWrapper_module_disabled__4d0be08c) .RowWrapper_module_stroke__4d0be08c{stroke:#fff}.RowWrapper_module_removeBtn__4d0be08c:hover:not(.RowWrapper_module_disabled__4d0be08c) rect.RowWrapper_module_stroke__4d0be08c{fill:#ea0a3b;stroke:#ea0a3b}.RowWrapper_module_removeBtn__4d0be08c.RowWrapper_module_disabled__4d0be08c{cursor:auto}.RowWrapper_module_removeBtn__4d0be08c.RowWrapper_module_disabled__4d0be08c .RowWrapper_module_stroke__4d0be08c{stroke:#cbced7}.RowWrapper_module_removeBtn__4d0be08c .RowWrapper_module_stroke__4d0be08c{stroke:#ea0a3b}";
window.ADS.injectStyle(css$t,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FieldRow/RowWrapper.module.scss");
var modules_ef0577da = {"hideLabels":"RowWrapper_module_hideLabels__4d0be08c","removeBtn":"RowWrapper_module_removeBtn__4d0be08c","disabled":"RowWrapper_module_disabled__4d0be08c","stroke":"RowWrapper_module_stroke__4d0be08c"};

const cx$y = classnames.bind(modules_ef0577da);
// RemoveButton component
const RemoveButton = ({ testId, index, removable, showLabels, onClickHandler, onRemove }) => {
    const handleClick = () => {
        const removeRow = () => removable && onClickHandler();
        // If they have passed us the onRemove prop, we call that with a function
        // that if invoked will finish the removal process, if not we just invoke removeRow now.
        if (removable && onRemove)
            onRemove(removeRow);
        else
            removeRow();
    };
    // We want to include the label spacer
    // IF showLabels is true (label for every row)
    // IF showLabels is 'firstRowOnly' and this is the first row
    // ELSE do not show the label spacer
    const includeLabelSpacer = showLabels === true || (showLabels === 'firstRowOnly' && index === 0);
    return (React__default.createElement("div", null,
        includeLabelSpacer && React__default.createElement(LabelSpacer, null),
        React__default.createElement(Button, { onClick: handleClick, disabled: !removable, icon: "TrashCanIcon", testId: testId && `${testId}-delete-button` })));
};
// Wraps a row for the FieldRow
const RowWrapper = ({ onRemove, removable, showLabels, index, testId, children }) => {
    // The field names need to include the row number they are being rendered at.
    // We pass the children render prop this field name generator function to hide
    // the implementation details of generating the correct field name from the user.
    const fieldName = (rowNumber) => (fieldName) => {
        return `[${rowNumber}].${fieldName}`;
    };
    return (React__default.createElement(AnimateHeightRender, null, ({ animateExit }) => (React__default.createElement("div", { className: cx$y('mb-100', { hideLabels: !showLabels }), "data-test": testId ? `${testId}-${index}` : null }, children({
        removeButton: (React__default.createElement(RemoveButton, { testId: testId && `${testId}-${index}`, showLabels: showLabels, index: index, removable: removable, onClickHandler: () => animateExit(() => onRemove(index)) })),
        fieldName: fieldName(index),
        rowIndex: index
    })))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const FieldRow = ({ customDataProps, addRow, children, clearSchemaOnUnmount, initialRows, maxRows = 50, minRows = 1, name, rowSchema, showLabels = 'firstRowOnly', testId }) => {
    const schema = React__default.useMemo(() => {
        const defaultRows = [...(initialRows !== null && initialRows !== void 0 ? initialRows : [])];
        for (let i = 0; i < minRows; i++) {
            if (!defaultRows[i]) {
                defaultRows.push(rowSchema.getDefault());
            }
        }
        return array().of(rowSchema).default(defaultRows);
    }, [initialRows, minRows, rowSchema]);
    const fullName = useFieldSchemaName(name);
    return (React__default.createElement(SubForm, { name: name, schema: schema, clearSchemaOnUnmount: clearSchemaOnUnmount },
        React__default.createElement(FieldRowItem, { customDataProps: customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}, fullName: fullName, testId: testId, rowSchema: rowSchema, addRow: addRow, showLabels: showLabels, maxRows: maxRows, minRows: minRows }, children)));
};
const FieldRowItem = ({ customDataProps, fullName, testId, rowSchema, addRow, showLabels, maxRows, minRows, children }) => {
    const { fields, append, remove } = useFieldArray({ name: fullName });
    const { setValue: setFieldValue } = useFormContext$1();
    const addBlankRow = React__default.useCallback(() => {
        // The append method causes the form to be dirty if the schema contains defaults
        // Clear the defaults out and set them later when actually appending the row.
        const data = Object.assign({}, rowSchema.getDefault());
        Object.keys(data).forEach((key) => {
            set(data, key, null);
        });
        append(data);
        // We have added a blank row, now update their values with the defaults
        const rowDefault = rowSchema.getDefault();
        Object.entries(rowDefault).forEach(([key, fieldDefault]) => {
            if (fieldDefault) {
                setFieldValue(`${fullName}[${(fields === null || fields === void 0 ? void 0 : fields.length) ? fields.length : 0}].${key}`, fieldDefault, {
                    shouldDirty: true,
                    shouldValidate: true
                });
            }
        });
    }, [append, fields.length, fullName, rowSchema, setFieldValue]);
    const addRowHandler = () => {
        if (fields.length < maxRows) {
            addBlankRow();
        }
    };
    const removeRow = (remove, i) => {
        if (fields.length > minRows) {
            remove(i);
        }
    };
    return (React__default.createElement("div", Object.assign({}, customDataProps, { "data-test": testId }),
        fields.map((field, index) => (React__default.createElement(RowWrapper, { testId: testId, key: field.id, showLabels: showLabels === 'firstRowOnly' ? index === 0 : showLabels, index: index, removable: fields.length > minRows, onRemove: (i) => removeRow(remove, i) }, children))),
        React__default.cloneElement(addRow, {
            disabled: fields.length >= maxRows,
            onClick: addRowHandler
        })));
};

var css$s = ".FieldSummary_module_summary__17af53cc{align-items:center;color:#363840;display:flex;font-size:14px;line-height:20px;min-height:32px}.FieldSummary_module_subLine__17af53cc{color:#363840;font-size:12px;line-height:16px;margin-top:4px}.FieldSummary_module_subLine__17af53cc.FieldSummary_module_disabled__17af53cc{color:#b0b4bf}.FieldSummary_module_icon__17af53cc{height:16px;width:16px}.FieldSummary_module_empty__17af53cc{color:#6a6f82;font-style:italic}";
window.ADS.injectStyle(css$s,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FieldSummary/FieldSummary.module.scss");
var modules_8e02205b = {"summary":"FieldSummary_module_summary__17af53cc","subLine":"FieldSummary_module_subLine__17af53cc","disabled":"FieldSummary_module_disabled__17af53cc","icon":"FieldSummary_module_icon__17af53cc","empty":"FieldSummary_module_empty__17af53cc"};

const cx$x = BindStyles(modules_8e02205b);
const cloneWithDisabled = (element, disabled) => {
    if (React__default.isValidElement(element)) {
        return React__default.cloneElement(element, {
            disabled
        });
    }
    return element;
};
const FieldSummary = ({ customDataProps, testId, label, subline, startIcon, endIcon, summary, width, maxWidth, minWidth, helpText, className, disabled = false, emptyText: _emptyText, truncateSummary = false }) => {
    const { t } = useTranslation();
    const emptyText = _emptyText !== null && _emptyText !== void 0 ? _emptyText : t('NO_INFO_ENTERED');
    const isEmpty = !summary;
    const { isDisabled, disableSummary } = React__default.useMemo(() => {
        if (typeof disabled === 'boolean') {
            return { isDisabled: disabled, disableSummary: disabled };
        }
        return {
            isDisabled: disabled.disableField,
            disableSummary: !disabled.excludeSummary
        };
    }, [disabled]);
    if (isTextOrSpan(summary)) {
        summary = (React__default.createElement(FieldHeightText, { disabled: isDisabled, testId: `${testId}-body`, truncateText: truncateSummary }, summary ? summary : emptyText));
    }
    else if (disableSummary) {
        summary = cloneWithDisabled(summary, isDisabled);
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId }, (className ? { className } : null), { style: { width, maxWidth, minWidth } }),
        label && (React__default.createElement(Label, { testId: testId ? `${testId}-label` : 'field-summary-label', disabled: isDisabled, helpText: helpText }, label)),
        React__default.createElement("div", { "data-test": testId ? `${testId}-summary` : 'field-summary', className: cx$x('summary', { empty: isEmpty }) },
            startIcon && (React__default.createElement("div", { className: cx$x('icon', 'mr-50') },
                React__default.createElement(Icon, { disabled: isDisabled, size: 16, icon: startIcon, testId: testId ? `${testId}-start-icon` : 'field-summary-start-icon' }))),
            summary ? summary : emptyText,
            endIcon && (React__default.createElement("div", { className: cx$x('icon', 'ml-50') },
                React__default.createElement(Icon, { disabled: isDisabled, size: 16, icon: endIcon, testId: testId ? `${testId}-end-icon` : 'field-summary-end-icon' })))),
        subline && (React__default.createElement("div", { "data-test": testId ? `${testId}-subline` : 'field-summary-subline', className: cx$x('subLine', className, {
                disabled: isDisabled
            }) }, subline))));
};

//#region 🛠 Utilities
function isFileTypeAllowed(filename, allowedTypes) {
    var _a;
    if (allowedTypes.length === 0) {
        return true;
    }
    const fileExtension = (_a = filename.split('.').pop()) !== null && _a !== void 0 ? _a : '';
    return allowedTypes
        .map((allowedType) => 
    // remove leading dot if present
    allowedType.startsWith('.') ? allowedType.slice(1) : allowedType)
        .some((allowedType) => {
        // compare case insensitively
        return allowedType.toLowerCase() === fileExtension.toLowerCase();
    });
}
/**
 * Guarantees file types to be trimmed, lowercase, and unique.
 */
function toAssertedFileTypes(filetypes) {
    if (!filetypes) {
        return [];
    }
    const formatted = filetypes.map((filetype) => match(filetype
        // assert blank space is trimmed
        .trim()
        // assert lowercase (not required but is a common practice)
        .toLowerCase())
        /* We do not support MIME types at this time.
         * // if is a MIME type: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
         * .when(
         *   (fileType) => fileType.includes('/'),
         *   // then display as is
         *   (mimeType) => mimeType
         * )
         */
        // if is a file extension
        .otherwise((fileExtension) => 
    // then assert a leading dot unless an empty string
    fileExtension === '' || fileExtension.startsWith('.')
        ? fileExtension
        : `.${fileExtension}`));
    const unique = Array.from(new Set(formatted));
    return unique;
}
/**
 * @see{@link https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/accept#limiting_accepted_file_types}
 */
function toInputAcceptFormat(filetypes) {
    return filetypes
        .map((filetype) => match(filetype
        // assert lowercase (not required but is a common practice)
        .toLowerCase())
        /* We do not support MIME types at this time.
         * // if is a MIME type: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
         * .when(
         *   (fileType) => fileType.includes('/'),
         *   // then display as is
         *   (mimeType) => mimeType
         * )
         */
        // if is a file extension
        .otherwise((fileExtension) => 
    // then assert a leading dot unless an empty string
    fileExtension === '' || fileExtension.startsWith('.')
        ? fileExtension
        : `.${fileExtension}`))
        .join(',');
}
function toDisplayedFormat(filetypes) {
    return filetypes
        .map((filetype) => match(filetype
        // display in uppercase
        .toUpperCase())
        /* We do not support MIME types at this time.
         * // if is a MIME type: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
         * .when(
         *   (fileType) => fileType.includes('/'),
         *   // then display as is
         *   (mimeType) => mimeType
         * )
         */
        // if is a file extension
        .otherwise((fileExtension) => 
    // then display without the leading dot
    fileExtension.startsWith('.') ? fileExtension.slice(1) : fileExtension))
        .join(', ');
}
//#endregion 🛠 Utilities

var css$r = ".FileDropZone_module_parent__2b20aa98{position:relative}.FileDropZone_module_wrapper__2b20aa98{opacity:1;transition:opacity .25s ease-in-out}.FileDropZone_module_wrapper__2b20aa98.FileDropZone_module_hide__2b20aa98{pointer-events:none}.FileDropZone_module_wrapper__2b20aa98.FileDropZone_module_dropzone__2b20aa98{display:inline-flex}.FileDropZone_module_dropzone__2b20aa98{align-items:center;background-color:#ffffffd9;border:2px dashed #b0b4bf;border-radius:8px;bottom:-8px;justify-content:center;left:-8px;overflow:hidden;padding:16px;position:absolute;top:-8px;width:calc(100% + 16px);z-index:200}.FileDropZone_module_dropzone__2b20aa98.FileDropZone_module_doNotExpand__2b20aa98{bottom:0;left:0;top:0;width:100%}.FileDropZone_module_dropzone__2b20aa98.FileDropZone_module_hide__2b20aa98{opacity:0}.FileDropZone_module_dropzone__2b20aa98:hover:not(.FileDropZone_module_disabled__2b20aa98){border-color:#365ef6}.FileDropZone_module_dropzone__2b20aa98:not(.FileDropZone_module_dragHover__2b20aa98){transition:all 275ms cubic-bezier(.25,.25,.25,1)}.FileDropZone_module_dropzone__2b20aa98.FileDropZone_module_dragHover__2b20aa98{background-color:#f1f4fd;border-color:#365ef6;transition:all 275ms cubic-bezier(.25,.25,.25,1)}.FileDropZone_module_dropzone__2b20aa98.FileDropZone_module_dragHover__2b20aa98 .FileDropZone_module_instructionBox__2b20aa98{background-color:#fff0;box-shadow:0 0 0 0 #fff0;transition:all 275ms cubic-bezier(.25,.25,.25,1)}.FileDropZone_module_instructionBox__2b20aa98{background-color:#fff;border-radius:8px;box-shadow:0 0 24px 24px #fff;max-height:114px;padding:16px 32px;pointer-events:none}.FileDropZone_module_instructions__2b20aa98{align-items:center;display:flex;flex-direction:column;justify-content:center}.FileDropZone_module_instructions__2b20aa98 .FileDropZone_module_iconText__2b20aa98{align-items:center;display:flex;flex-direction:row;gap:0 4px;justify-content:center;white-space:nowrap}.FileDropZone_module_instructions__2b20aa98 .FileDropZone_module_uploadIconFill__2b20aa98{fill:#6a6f82}.FileDropZone_module_instructions__2b20aa98 .FileDropZone_module_uploadIconFill__2b20aa98.FileDropZone_module_disabled__2b20aa98{fill:#b0b4bf}";
window.ADS.injectStyle(css$r,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FileDropZone/FileDropZone.module.scss");
var modules_ccd7613f = {"parent":"FileDropZone_module_parent__2b20aa98","wrapper":"FileDropZone_module_wrapper__2b20aa98","hide":"FileDropZone_module_hide__2b20aa98","dropzone":"FileDropZone_module_dropzone__2b20aa98","do-not-expand":"FileDropZone_module_doNotExpand__2b20aa98","disabled":"FileDropZone_module_disabled__2b20aa98","dragHover":"FileDropZone_module_dragHover__2b20aa98","instructionBox":"FileDropZone_module_instructionBox__2b20aa98","instructions":"FileDropZone_module_instructions__2b20aa98","iconText":"FileDropZone_module_iconText__2b20aa98","uploadIconFill":"FileDropZone_module_uploadIconFill__2b20aa98"};

/**
 * A custom hook that detects if child components have wrapped to a new line within a container.
 * This can be useful for responsive designs where the layout of child components changes based on the container's width.
 *
 * @param containerRef - A ref object pointing to the container element.
 * @param childrenRefs - An object containing ref objects for each child component, keyed by a unique identifier.
 * @returns An object containing the wrapped status of each child component.
 */
function useWrapDetection(containerRef, childrenRefs) {
    const [wrapped, setWrapped] = React__default.useState({});
    // Function to determine if child components have wrapped to a new line
    const determineWrappedStatus = React__default.useCallback(() => {
        var _a;
        const container = containerRef.current;
        if (!container)
            return;
        const newWrapped = {};
        // Get the top offset of the first child to determine the baseline for wrapping
        const firstElementTopOffset = ((_a = container.children[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) || 0;
        const keys = Object.keys(childrenRefs);
        keys.forEach((key) => {
            const el = childrenRefs[key].current;
            if (el) {
                // Determine if the child has wrapped by comparing its top offset to the first child's
                const isWrapped = el.getBoundingClientRect().top > firstElementTopOffset;
                newWrapped[key] = isWrapped;
            }
        });
        // Check if the wrapped status has changed to avoid unnecessary state updates
        setWrapped((prevWrapped) => {
            const isWrappedChanged = keys.some((key) => newWrapped[key] !== prevWrapped[key]);
            if (isWrappedChanged) {
                return newWrapped;
            }
            return prevWrapped;
        });
    }, [childrenRefs, containerRef]);
    useResizeObserver({
        ref: containerRef,
        throttleAmount: 200,
        onResize: determineWrappedStatus,
        observeOptions: 'width'
    });
    return { wrapped };
}

var css$q = ".Restrictions_module_detailInfo__f6230fa6{color:#585c6a;font-size:12px;line-height:16px;padding-top:4px}.Restrictions_module_detailInfo__f6230fa6.Restrictions_module_disabled__f6230fa6{color:#b0b4bf}.Restrictions_module_text__f6230fa6{display:flex}.Restrictions_module_allowedTypes__f6230fa6,.Restrictions_module_maxFileSize__f6230fa6{font-weight:600;text-transform:uppercase}.Restrictions_module_restrictionSpacer__f6230fa6{align-self:stretch;border-left:1px solid #b0b4bf;height:16px;margin:0 12px}.Restrictions_module_wrapped__f6230fa6{margin:0 12.5px}";
window.ADS.injectStyle(css$q,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FileUpload/components/Restrictions/Restrictions.module.scss");
var modules_7ea2d9b6 = {"detailInfo":"Restrictions_module_detailInfo__f6230fa6","disabled":"Restrictions_module_disabled__f6230fa6","text":"Restrictions_module_text__f6230fa6","allowedTypes":"Restrictions_module_allowedTypes__f6230fa6","maxFileSize":"Restrictions_module_maxFileSize__f6230fa6","restrictionSpacer":"Restrictions_module_restrictionSpacer__f6230fa6","wrapped":"Restrictions_module_wrapped__f6230fa6"};

const cx$w = BindStyles(modules_7ea2d9b6);
const Restrictions = ({ testId, types, maxSize, maxFileCount = 1, disabled, displayAllSupportedFileTypes = false }) => {
    const { t } = useTranslation();
    const restrictionsRef = React__default.useRef(null);
    const maxFileCountRef = React__default.useRef(null);
    const supportedTypesRef = React__default.useRef(null);
    const childrenRefs = React__default.useMemo(() => ({
        maxFileCountHasWrapped: maxFileCountRef,
        supportedTypesHasWrapped: supportedTypesRef
    }), []);
    const { wrapped } = useWrapDetection(restrictionsRef, childrenRefs);
    // Determine the presence of each element
    const hasMaxSize = !!maxSize;
    const hasMaxFileCount = maxFileCount > 1;
    const hasTypes = types.length > 0;
    // Calculate the number of elements that will be displayed
    const displayedElementsCount = [hasMaxSize, hasMaxFileCount, hasTypes].filter(Boolean).length;
    const showSpacer1 = (displayedElementsCount === 3 ||
        (displayedElementsCount === 2 && hasMaxSize && hasMaxFileCount)) &&
        !wrapped.maxFileCountHasWrapped;
    const showSpacer2 = (displayedElementsCount === 3 ||
        (displayedElementsCount === 2 && hasMaxSize && hasTypes)) &&
        !wrapped.supportedTypesHasWrapped;
    const supportedFileTypes = types.length > 3 && !displayAllSupportedFileTypes
        ? `${toDisplayedFormat(types.slice(0, 3))}...`
        : toDisplayedFormat(types);
    return (React__default.createElement(Flex, { testId: `${testId}-restrictions`, ref: restrictionsRef, className: cx$w('detailInfo', 'text', 'flex-valign-baseline flex-align-center gap-h-0 gap-v-50', {
            disabled
        }) },
        hasMaxSize && (React__default.createElement(Flex, { testId: `${testId}-restrictions-max-size`, className: "flex-no-wrap gap-h-0" },
            React__default.createElement("span", { className: "mr-25 no-wrap" }, t('MAX_FILE_SIZE')),
            React__default.createElement("span", { className: cx$w('maxFileSize') }, FormatFileSize(maxSize).full))),
        showSpacer1 && (React__default.createElement("span", { "data-test": `${testId}-restrictions-spacer1`, className: cx$w('restrictionSpacer') })),
        hasMaxFileCount && (React__default.createElement(Flex, { ref: maxFileCountRef, testId: `${testId}-restrictions-max-file-count`, className: cx$w(wrapped.maxFileCountHasWrapped ? 'wrapped' : '', 'flex-no-wrap gap-h-0') },
            React__default.createElement("span", { className: "mr-25 no-wrap" }, `${t('MAX_FILE_COUNT')}:`),
            React__default.createElement("span", { className: cx$w('allowedTypes') }, maxFileCount))),
        showSpacer2 && (React__default.createElement("span", { "data-test": `${testId}-restrictions-spacer2`, className: cx$w('restrictionSpacer') })),
        hasTypes && (React__default.createElement(Flex, { ref: supportedTypesRef, className: cx$w(wrapped.supportedTypesHasWrapped ? 'wrapped' : '', 'flex-no-wrap gap-h-0') },
            React__default.createElement("span", { className: "mr-25 no-wrap" }, t('SUPPORTED_FILE_TYPES')),
            React__default.createElement(Flex, { className: cx$w('allowedTypes', 'flex-no-wrap gap-h-25') },
                React__default.createElement("span", { "data-test": `${testId}-restriction-types` }, supportedFileTypes),
                types.length > 3 && !displayAllSupportedFileTypes && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Tooltip, { disabled: disabled, testId: `${testId}-restriction-types-tooltip`, content: React__default.createElement("div", { "data-test": `${testId}-restriction-types-tooltip-content` },
                            t('SUPPORTED_FILE_TYPES_TOOLTIP'),
                            React__default.createElement("br", null),
                            React__default.createElement("strong", null, toDisplayedFormat(types))) },
                        React__default.createElement(Icon, { disabled: disabled, testId: `${testId}-restriction-types-icon`, icon: "ICircleIcon", size: 16, className: "help-hover" })))))))));
};

const cx$v = BindStyles(modules_ccd7613f);
const FileInstructions = ({ testId, disabled, allowedTypes: unassertedAllowedTypes, maxSize, maxFiles = 1 }) => {
    const { t } = useTranslation();
    const allowedTypes = React__default.useMemo(() => toAssertedFileTypes(unassertedAllowedTypes), [unassertedAllowedTypes]);
    return (React__default.createElement(Flex, { className: cx$v('instructionBox', 'gap-h-150 gap-v-25 flex-align-center flex-d-column flex-no-wrap') },
        React__default.createElement(Flex, { className: cx$v('instructions', 'gap-25 flex-no-wrap') },
            React__default.createElement("div", { className: `${cx$v('iconText')}` },
                React__default.createElement(Icon, { icon: "UploadIcon", size: 32, fillClass: cx$v('uploadIconFill', { disabled }) }),
                React__default.createElement("div", { className: "mx-25" }, t('DROP_INSTRUCTION', { count: maxFiles })))),
        React__default.createElement(Restrictions, { testId: testId, maxSize: maxSize, types: allowedTypes, maxFileCount: maxFiles, disabled: disabled, displayAllSupportedFileTypes: true })));
};

const cx$u = BindStyles(modules_ccd7613f);
const FileDropZone = ({ allowedTypes: unassertedAllowedTypes, children, customDataProps, debug = false, disabled = false, doNotExpandDropZone, maxFileCount = 9999, maxSize, testId = 'FileDropZone', onFilesDropped }) => {
    const { t } = useTranslation();
    const { dragActive } = useFileDragging();
    const [dragHover, setDragHover] = React__default.useState(false);
    const allowedTypes = React__default.useMemo(() => toAssertedFileTypes(unassertedAllowedTypes), [unassertedAllowedTypes]);
    const showDropZone = dragActive && !disabled;
    const mapPickedFile = (file) => {
        let errorText = '';
        let status = 'pending';
        // check for simple errors before sending.
        if (!isFileTypeAllowed(file.name, allowedTypes)) {
            errorText = t('FILE_TYPE_UNSUPPORTED', { count: maxFileCount });
            status = 'error';
        }
        else if (file.size > maxSize) {
            errorText = t('FILE_TOO_LARGE');
            status = 'error';
        }
        return {
            name: file.name,
            size: file.size,
            transferred: 0,
            status,
            errorText
        };
    };
    const handleDragEvent = (event, eventType) => {
        // Required to prevent the browser from opening the file when dropped in a new tab.
        event.preventDefault();
        // NOTE: we want to propagate the event to the parent component for drag-over events.
        // We are not using event.stopPropagation() intentionally.  If we stop propagation,
        // consuming applications will no longer think a DragOver event is happening when hovering the drop zone.
        if (!disabled) {
            switch (eventType) {
                case 'DRAG_OVER':
                    // this controls what the OS will show as the drop effect when hovering - e.g. "copy" vs "move" or "not allowed".
                    // user can modify this by holding modifier keys like "ctrl" to force a copy action, or "shift" to force a move action.
                    // We want to only allow copying because we don't want to appear to "move" files when accepting them in all circumstances.
                    // Currently this gets overridden by the useFileDragging hook - need to find a way to make this event the shown dropEffect.
                    //  --- this is cosmetic only, and only impacts FireFox (Chrome just shows Copy in all circumstances).
                    // note - this is not impacted by the above CancelReactEvent call.
                    event.dataTransfer.dropEffect = 'copy';
                    break;
                case 'DROP':
                    handleFilesChosen(event.dataTransfer.files);
                    break;
            }
        }
    };
    const handleFilesChosen = (files) => {
        setDragHover(false);
        if (files && files.length > maxFileCount) {
            const errorMessage = maxFileCount === 1
                ? t('SINGLE_FILE_ONLY')
                : t('MAX_FILE_COUNT_EXCEEDED');
            // return picked files with an error so the consuming application can handle it.
            const upload = [];
            for (const f of files) {
                upload.push({
                    name: f.name,
                    size: f.size,
                    transferred: 0,
                    status: 'error',
                    errorText: errorMessage
                });
            }
            onFilesDropped && onFilesDropped(upload, files);
            return;
        }
        const upload = [];
        if (files) {
            for (const f of files) {
                upload.push(mapPickedFile(f));
            }
            onFilesDropped && onFilesDropped(upload, files);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$u('parent'), onDragOver: (event) => handleDragEvent(event, 'DRAG_OVER'), onDrop: (event) => handleDragEvent(event, 'DROP'), onDragEnter: () => setDragHover(true), onDragLeave: () => setDragHover(false), "data-test": `${testId}-drag-area` }),
            React__default.createElement("div", { className: cx$u('wrapper', showDropZone && 'hide') }, children),
            React__default.createElement("div", { "data-test": `${testId}-instruction-area`, className: cx$u('wrapper', 'dropzone', { 'do-not-expand': doNotExpandDropZone }, { dragHover }, !showDropZone && 'hide') }, showDropZone && (React__default.createElement(FileInstructions, { testId: testId, maxSize: maxSize, allowedTypes: unassertedAllowedTypes, disabled: disabled, maxFiles: maxFileCount })))),
        debug && (React__default.createElement("div", { className: "my-100" },
            React__default.createElement(InlineAlert, { testId: "file-dropzone-debug-panel", type: dragActive ? BrandType.Success : BrandType.Info, closeable: false },
                "Dragging is ",
                dragActive ? 'Active' : 'Inactive')))));
};

var css$p = ".ListItem_module_listItem__f7ae972b{color:#363840;font-size:14px;line-height:20px;list-style-type:none}";
window.ADS.injectStyle(css$p,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/List/ListItem/ListItem.module.scss");
var modules_adbd7d28 = {"listItem":"ListItem_module_listItem__f7ae972b"};

const cx$t = classnames.bind(modules_adbd7d28);
const ListItem = ({ customDataProps, testId, children }) => {
    return (React__default.createElement("li", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId !== null && testId !== void 0 ? testId : 'list-item', className: cx$t('listItem') }), children));
};
ListItem.displayName = 'ListItem';

var css$o = ".SimpleList_module_simpleList__b05cad33 .SimpleList_module_list__b05cad33{list-style-type:none;margin:0;padding:0}.SimpleList_module_simpleList__b05cad33 .SimpleList_module_list__b05cad33 li{padding:8px 0}.SimpleList_module_showBorder__b05cad33 li:not(:last-of-type){border-bottom:1px solid #cbced7}";
window.ADS.injectStyle(css$o,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/List/SimpleList/SimpleList.module.scss");
var modules_5be24c35 = {"simpleList":"SimpleList_module_simpleList__b05cad33","list":"SimpleList_module_list__b05cad33","showBorder":"SimpleList_module_showBorder__b05cad33"};

const cx$s = BindStyles(modules_5be24c35);
const SimpleList = ({ customDataProps, title, hideBorder = false, className, testId, children }) => {
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$s(className, 'simpleList', !hideBorder && 'showBorder'), "data-test": testId }),
        title && React__default.createElement(H3, { className: "mb-100" }, title),
        React__default.createElement("ul", { className: cx$s('list') }, children)));
};
SimpleList.displayName = 'SimpleList';

var css$n = ".FilesSelectedModal_module_fileName__67254e97{flex-shrink:1;overflow:hidden;white-space:nowrap}.FilesSelectedModal_module_fileSize__67254e97{flex-shrink:0}";
window.ADS.injectStyle(css$n,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FileUpload/components/FilesSelectedModal/FilesSelectedModal.module.scss");
var modules_5580cb5e = {"fileName":"FilesSelectedModal_module_fileName__67254e97","fileSize":"FilesSelectedModal_module_fileSize__67254e97"};

const cx$r = BindStyles(modules_5580cb5e);
/**
 * Provides a visual summary of the files selected by the user, including the file name and size.
 */
const FilesSelectedModal = ({ testId = 'files-selected-modal', open, setShowFilesModal, files }) => {
    const { t } = useTranslation();
    return (React__default.createElement(Modal, { testId: testId, open: open, title: `${t('FILES_SELECTED_TITLE')} (${files.length})`, onClose: () => setShowFilesModal(false) },
        React__default.createElement(ModalBody, null,
            React__default.createElement(SimpleList, null, files.map((file, idx) => (React__default.createElement(ListItem, { key: idx, testId: `${testId}-list-item-${idx}` },
                React__default.createElement(Flex, { className: "flex-no-wrap flex-align-space-between gap-h-50" },
                    React__default.createElement(Flex, { className: cx$r('fileName', 'flex-no-wrap gap-h-50') },
                        React__default.createElement(Flex, { className: "flex-align-start" },
                            React__default.createElement(Icon, { testId: `${testId}-icon-${idx}`, icon: GetFileIcon(file.name), size: 20, fillClass: cx$r('documentIconFill') })),
                        React__default.createElement(Flex, { className: cx$r('fileName') },
                            React__default.createElement(CellText, { testId: `${testId}-file-name-${idx}` }, file.name))),
                    React__default.createElement(Flex, { className: cx$r('fileSize', 'flex-no-wrap flex-align-end w-96 gap-h-25') },
                        React__default.createElement(CellText, { testId: `${testId}-file-size-count-${idx}` }, FormatFileSize(file.size).count),
                        React__default.createElement(Flex, { testId: `${testId}-file-size-rank-${idx}` }, FormatFileSize(file.size).rank)))))))),
        React__default.createElement(ModalFooter, null,
            React__default.createElement(Button, { testId: `${testId}-close-btn`, onClick: () => setShowFilesModal(false), autoFocus: true }, t('CLOSE')))));
};

var css$m = ".FileUpload_module_fileUpload__2e02ce71{align-items:center;border:1px solid #b0b4bf;border-radius:8px;display:flex;justify-content:center;min-height:80px;min-width:400px;padding:25px;position:relative}.FileUpload_module_fileUpload__2e02ce71 .FileUpload_module_text__2e02ce71{display:flex}.FileUpload_module_fileUpload__2e02ce71.FileUpload_module_disabled__2e02ce71{background-color:#f5f5f7;border:1px solid #cbced7;color:#b0b4bf}.FileUpload_module_fileUpload__2e02ce71 input[type=file]{display:none}.FileUpload_module_fileUpload__2e02ce71.FileUpload_module_allowDrag__2e02ce71{border-style:dashed;border-width:2px;padding:24px}.FileUpload_module_fileUpload__2e02ce71.FileUpload_module_allowDrag__2e02ce71.FileUpload_module_dragHover__2e02ce71,.FileUpload_module_fileUpload__2e02ce71.FileUpload_module_allowDrag__2e02ce71:hover:not(.FileUpload_module_disabled__2e02ce71){background-color:#f1f4fd;border-color:#365ef6}.FileUpload_module_listFiles__2e02ce71,.FileUpload_module_loading__2e02ce71{left:0;overflow:hidden;padding:25px;position:absolute;right:0}.FileUpload_module_loading__2e02ce71{background-color:#f5f5f7;bottom:0;top:0}.FileUpload_module_loading__2e02ce71 .FileUpload_module_loadingSpinner__2e02ce71{stroke:#1a46ef}.FileUpload_module_uploadIconFill__2e02ce71{fill:#6a6f82}.FileUpload_module_uploadIconFill__2e02ce71.FileUpload_module_disabled__2e02ce71{fill:#b0b4bf}.FileUpload_module_documentIconFill__2e02ce71{fill:#444750}.FileUpload_module_documentIconFill__2e02ce71.FileUpload_module_disabled__2e02ce71{fill:#b0b4bf}.FileUpload_module_instructions__2e02ce71{align-items:center;display:flex;flex-direction:column}.FileUpload_module_instructions__2e02ce71.FileUpload_module_hideInstructions__2e02ce71{visibility:hidden}.FileUpload_module_instructions__2e02ce71.FileUpload_module_dragHover__2e02ce71{pointer-events:none}.FileUpload_module_wrapped__2e02ce71{margin:0 12.5px}.FileUpload_module_fileName__2e02ce71{display:block;overflow:hidden;white-space:nowrap}.FileUpload_module_error__2e02ce71{border-color:#ea0a3b}.FileUpload_module_desired__2e02ce71{border-color:#f45110}";
window.ADS.injectStyle(css$m,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/FileUpload/FileUpload.module.scss");
var modules_84c8f6e7 = {"fileUpload":"FileUpload_module_fileUpload__2e02ce71","text":"FileUpload_module_text__2e02ce71","disabled":"FileUpload_module_disabled__2e02ce71","allowDrag":"FileUpload_module_allowDrag__2e02ce71","dragHover":"FileUpload_module_dragHover__2e02ce71","listFiles":"FileUpload_module_listFiles__2e02ce71","loading":"FileUpload_module_loading__2e02ce71","loadingSpinner":"FileUpload_module_loadingSpinner__2e02ce71","uploadIconFill":"FileUpload_module_uploadIconFill__2e02ce71","documentIconFill":"FileUpload_module_documentIconFill__2e02ce71","instructions":"FileUpload_module_instructions__2e02ce71","hideInstructions":"FileUpload_module_hideInstructions__2e02ce71","wrapped":"FileUpload_module_wrapped__2e02ce71","fileName":"FileUpload_module_fileName__2e02ce71","error":"FileUpload_module_error__2e02ce71","desired":"FileUpload_module_desired__2e02ce71"};

const cx$q = BindStyles(modules_84c8f6e7);
const FileText = ({ testId = 'file-text', name, size, maxWidth, disabled, onClick }) => {
    const nameWidth = useRenderTextWidth(true, [{ text: name }]);
    const truncate = nameWidth > maxWidth * 0.75;
    // Conditionally render as a link label or plain text
    const renderName = () => {
        if (onClick) {
            return (React__default.createElement(Button, { testId: `${testId}-link-label`, type: "link", className: cx$q('mx-25', 'nowrap'), onClick: onClick },
                React__default.createElement(CellText, null, name)));
        }
        else {
            return (React__default.createElement("div", { "data-test": `${testId}-label`, className: cx$q('mx-25', 'nowrap', 'fileName'), style: truncate ? { width: maxWidth * 0.75 } : {} },
                React__default.createElement(CellText, null, name)));
        }
    };
    return (React__default.createElement("div", { className: cx$q('text', 'flex-valign-center', 'gap-h-25', 'flex-no-wrap') },
        renderName(),
        React__default.createElement("div", { "data-test": `${testId}-size`, className: cx$q('detailInfo', { disabled }) }, `(${FormatFileSize(size).full})`)));
};

const cx$p = BindStyles(modules_84c8f6e7);
const getSingleFileConfigLocal = (singleFileConfig) => {
    const singleFileDefaultConfig = {
        showRemoveButton: true
    };
    const _a = singleFileConfig || {}, { showRemoveButton = singleFileDefaultConfig.showRemoveButton } = _a, restOfSingleFileConfig = __rest(_a, ["showRemoveButton"]);
    return Object.assign({ showRemoveButton }, restOfSingleFileConfig);
};
const FileUploadCore = ({ allowedTypes: unassertedAllowedTypes, autoFocus, disabled, error, formControlled = false, inputRef, maxFileCount = 1, height, maxSize, singleFileConfig, testId = 'file-upload', uploadUrl, value, warning, onDelete, onError, onFileChange }) => {
    var _a, _b;
    const { t } = useTranslation();
    const sizeRef = React__default.useRef(null);
    const size = useSize(sizeRef.current);
    const { state: unmountInputEl, start: clearInputEl } = useDelayedFalse(50);
    const localInputRef = React__default.useRef(null);
    const [dragHover, setDragHover] = React__default.useState(false);
    const [showFilesModal, setShowFilesModal] = React__default.useState(false);
    const singleFileConfigLocal = getSingleFileConfigLocal(singleFileConfig);
    const allowedTypes = React__default.useMemo(() => toAssertedFileTypes(unassertedAllowedTypes), [unassertedAllowedTypes]);
    const mapPickedFile = (file) => {
        let errorText = '';
        let status = 'pending';
        // check for simple errors before sending.
        if (!isFileTypeAllowed(file.name, allowedTypes)) {
            errorText = t('FILE_TYPE_UNSUPPORTED', { count: maxFileCount });
            status = 'error';
        }
        else if (file.size > maxSize) {
            errorText = t('FILE_TOO_LARGE');
            status = 'error';
        }
        return {
            name: file.name,
            size: file.size,
            transferred: 0,
            status,
            errorText
        };
    };
    const handleFilesChosen = (files) => {
        setDragHover(false);
        if (uploadUrl && onFileChange && !formControlled) {
            ADSWarn('Unnecessary upload URL prop provided, expecting onFileChange handler to upload file.');
        }
        if (value && value.filter((f) => f.status !== 'error').length > 0) {
            onError && onError(value, t('REMOVE_EXISTING'));
            return;
        }
        if (files && files.length > maxFileCount) {
            const errorMessage = maxFileCount === 1
                ? t('SINGLE_FILE_ONLY')
                : t('MAX_FILE_COUNT_EXCEEDED');
            onError && onError([], errorMessage);
            return;
        }
        const upload = [];
        if (files && files.length <= maxFileCount) {
            for (const f of files) {
                upload.push(mapPickedFile(f));
            }
            const errors = upload.filter((f) => f.status === 'error');
            if (errors.length > 0) {
                onError && onError(errors, errors[0].errorText || t('GENERIC_ERROR'));
            }
            else {
                onFileChange && onFileChange(upload, files);
            }
        }
        else {
            onError && onError([], t('SINGLE_FILE_ONLY'));
        }
    };
    const handleDragEvent = (event, eventType) => {
        event.preventDefault();
        event.stopPropagation();
        if (!disabled) {
            switch (eventType) {
                case 'DRAG_OVER':
                    event.dataTransfer.dropEffect = 'copy';
                    break;
                case 'DROP':
                    handleFilesChosen(event.dataTransfer.files);
                    break;
            }
        }
    };
    const validFiles = (_a = (value && value.filter((f) => f.status !== 'error'))) !== null && _a !== void 0 ? _a : [];
    // determine if any files are still being transferred
    // if the file size is greater than the transfer size,
    // show the loading state.
    const loading = validFiles
        .map((f) => f.transferred !== f.size && !['error', 'defer'].includes(f.status))
        .reduce((p, c) => p || c, false);
    const hideInstructions = !(!loading && validFiles.length === 0);
    const calcTotalSize = React__default.useCallback((files) => {
        return files.reduce((acc, f) => acc + f.size, 0);
    }, []);
    return (React__default.createElement("div", { style: { height }, className: cx$p('fileUpload', { allowDrag: !hideInstructions && !disabled }, { dragHover }, { disabled }, { error }, { desired: warning }), onDragOver: (event) => handleDragEvent(event, 'DRAG_OVER'), onDrop: (event) => handleDragEvent(event, 'DROP'), onDragEnter: () => setDragHover(true), onDragLeave: () => setDragHover(false), "data-test": `${testId}-drag-area` },
        React__default.createElement("div", { ref: sizeRef, className: cx$p('instructions', 'gap-v-25', { dragHover }, { hideInstructions }) },
            !unmountInputEl && (React__default.createElement("input", { type: "file", multiple: maxFileCount > 1, ref: localInputRef, onChange: (e) => {
                    handleFilesChosen(e.target.files);
                    /* So, you can't programmatically set the value
                    of a file input element.  As a result, if the user
                    picks the same file two times in a row, the input element
                    does not raise its onChange event because the
                    value doesn't change.  So... a way to get around that is to
                    unmount the element and remount after a short delay.*/
                    clearInputEl();
                }, accept: allowedTypes.length > 0
                    ? toInputAcceptFormat(allowedTypes)
                    : undefined })),
            React__default.createElement(Flex, { className: "gap-h-150 gap-v-25 flex-align-center flex-d-column flex-no-wrap" },
                React__default.createElement(Flex, { className: "gap-h-25 flex-no-wrap" },
                    React__default.createElement("div", { className: cx$p('text') },
                        React__default.createElement(Icon, { icon: "UploadIcon", size: 32, fillClass: cx$p('uploadIconFill', { disabled }) })),
                    React__default.createElement("div", { "data-test": `${testId}-drag-instruction`, className: `${cx$p('text', 'flex-valign-center')}` },
                        React__default.createElement("span", { className: "m-25 no-wrap" }, maxFileCount > 1
                            ? t('DRAG_INSTRUCTION_plural')
                            : t('DRAG_INSTRUCTION')),
                        React__default.createElement(Button, { autoFocus: autoFocus, disabled: disabled, ref: inputRef, testId: testId && `${testId}-browse-button`, type: "link", onClick: () => {
                                if (localInputRef.current !== null) {
                                    localInputRef.current.click();
                                }
                            } }, t('BROWSE')))),
                React__default.createElement(Restrictions, { testId: testId, maxSize: maxSize, types: allowedTypes, maxFileCount: maxFileCount, disabled: disabled }))),
        !loading && validFiles.length === 1 && (React__default.createElement("div", { className: cx$p('listFiles', { disabled }) }, value &&
            value.map((file) => {
                var _a;
                return (React__default.createElement(Flex, { key: file.name, className: "flex-align-center gap-v-100" },
                    React__default.createElement(Flex, { className: "gap-h-25 flex-no-wrap" },
                        React__default.createElement("div", { className: cx$p('text') },
                            React__default.createElement(Icon, { icon: "DocumentIcon", size: 16, fillClass: cx$p('documentIconFill', { disabled }) })),
                        React__default.createElement(FileText, { testId: `${testId}-file-text`, name: file.name, size: file.size, disabled: disabled, maxWidth: (_a = size.width) !== null && _a !== void 0 ? _a : 0, onClick: singleFileConfigLocal.onFileNameClick })),
                    singleFileConfigLocal.showRemoveButton && (React__default.createElement("div", null,
                        React__default.createElement(Button, { testId: testId && `${testId}-replace-button`, size: 'sm', disabled: disabled, onClick: () => {
                                setDragHover(false);
                                if (value)
                                    onDelete && onDelete(value);
                            } }, t('REMOVE'))))));
            }))),
        !loading && validFiles.length > 1 && maxFileCount > 1 && (React__default.createElement("div", { className: cx$p('listFiles', { disabled }) },
            React__default.createElement(Flex, { className: "flex-align-center gap-v-100" },
                React__default.createElement(Flex, { className: "gap-h-25 flex-no-wrap" },
                    React__default.createElement("div", { className: cx$p('text') },
                        React__default.createElement(Icon, { icon: "DocumentMultiFileIcon", size: 16, fillClass: cx$p('documentIconFill', { disabled }) })),
                    React__default.createElement(FileText, { testId: `${testId}-file-text`, name: `${validFiles.length} ${t('FILES_SELECTED')}`, size: calcTotalSize(validFiles), disabled: disabled, maxWidth: (_b = size.width) !== null && _b !== void 0 ? _b : 0, onClick: () => setShowFilesModal(true) })),
                React__default.createElement("div", null,
                    React__default.createElement(Button, { testId: testId && `${testId}-replace-button`, size: 'sm', disabled: disabled, onClick: () => {
                            setDragHover(false);
                            if (value)
                                onDelete && onDelete(validFiles);
                        } }, t('REMOVE_ALL')))))),
        React__default.createElement(FilesSelectedModal, { testId: testId ? `${testId}-files-selected-modal` : undefined, open: showFilesModal, setShowFilesModal: setShowFilesModal, files: validFiles }),
        loading && (React__default.createElement("div", { className: cx$p('loading') },
            React__default.createElement(Icon, { icon: "SpinnerIcon", size: 32, strokeClass: cx$p('loadingSpinner') })))));
};
// Base version - requires controlling to function.
// uncontrolled and schema version build off this.
const FileUploadBase = withField(FileUploadCore);

/* eslint-disable @typescript-eslint/no-explicit-any */
// version of the component that handles sending the file itself
// and keeps it's own state - "Uncontrolled by the consuming application"
const FileUploadUncontrolled = (props) => {
    const { t } = useTranslation();
    const [val, setVal] = React__default.useState([]);
    const [error, setError] = React__default.useState();
    React__default.useEffect(() => {
        if (props.error) {
            setError(`${props.error}` || undefined);
        }
        else if (props.value &&
            props.value.filter((f) => f.status === 'error').length > 0) {
            // set the error from the first file found since we have no capacity to do multiple error messages yet.
            setError(props.value[0].errorText);
        }
    }, [props.error, props.value]);
    const handleError = (errorFiles, error) => {
        if (error)
            setError(error);
        else
            setError(errorFiles[0].errorText);
        props.onError && props.onError(errorFiles, error);
    };
    const handlePickedFile = (files, fileList) => {
        if (!props.uploadUrl) {
            ADSError('File Upload URL not provided!');
            return;
        }
        setError(undefined);
        setVal([...files]);
        axios
            .postForm(props.uploadUrl, fileList, {
            onUploadProgress: (p) => {
                var _a;
                // note - the final onUploadProgress may be executed after the
                // file server responds with a success message.  Prevent it
                // from setting state.
                if (((_a = p.progress) !== null && _a !== void 0 ? _a : 0) < 1) {
                    setVal([
                        ...files.map((f) => {
                            return Object.assign(Object.assign({}, f), { transferred: p.loaded });
                        })
                    ]);
                }
            }
        })
            .then((result) => {
            setVal([
                ...files.map((f) => {
                    var _a, _b, _c, _d;
                    return Object.assign(Object.assign({}, f), { id: (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.find((r) => r.name === f.name)) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '', transferred: f.size, status: 'success' });
                })
            ]);
        })
            .catch((error) => {
            ADSError('Server Error uploading files', error);
            const errorFiles = [
                ...files.map((f) => {
                    var _a;
                    return Object.assign(Object.assign({}, f), { status: 'error', errorText: (_a = error.errorMessage) !== null && _a !== void 0 ? _a : t('GENERIC_ERROR') });
                })
            ];
            setVal(errorFiles);
            handleError(errorFiles, '');
        });
    };
    const handleDelete = (_files) => {
        // send a request to remove the previously uploaded files
        if (val.length > 0) {
            axios
                .request({
                url: props.uploadUrl,
                method: 'delete',
                data: { ids: val.map((f) => f.id) }
            })
                .catch(() => {
                ADSError('Server error attempting to delete file.');
            });
            setVal([]);
            setError(undefined);
        }
    };
    return (React__default.createElement(FileUploadBase, Object.assign({}, props, { uploadUrl: '', value: val, onError: handleError, onFileChange: handlePickedFile, onDelete: handleDelete, error: error })));
};
// version to use in a schema
const FileUploadSchema = (props) => {
    var _a;
    const { t } = useTranslation();
    const { setValue, setError, clearErrors } = useFormContext();
    const { field, fieldState, showMessages } = useFieldController(props.name);
    const filesRef = React__default.useRef();
    const warning = (_a = (props.desired &&
        showMessages &&
        !fieldState.error &&
        IsFalseyOrEmpty(field.value) &&
        `${props.label || props.defaultLabel} is desired`)) !== null && _a !== void 0 ? _a : '';
    const handleError = (errorFiles, error) => {
        const msg = error ? error : errorFiles[0].errorText;
        setValue(props.name, errorFiles, { shouldTouch: true });
        setError(props.name, { type: 'custom', message: msg }, { shouldFocus: true });
        props.onError && props.onError(errorFiles, error);
    };
    const handlePick = (files, list) => {
        if (!props.uploadUrl) {
            ADSError('File Upload URL not provided!');
            return;
        }
        clearErrors(props.name);
        setValue(props.name, files);
        axios
            .postForm(props.uploadUrl, list, {
            onUploadProgress: (p) => {
                var _a;
                // note - the final onUploadProgress may be executed after the
                // file server responds with a success message.  Prevent it
                // from setting state.
                if (((_a = p.progress) !== null && _a !== void 0 ? _a : 0) < 1) {
                    setValue(props.name, [
                        ...files.map((f) => {
                            return Object.assign(Object.assign({}, f), { transferred: p.loaded });
                        })
                    ]);
                }
            }
        })
            .then((result) => {
            setValue(props.name, [
                ...files.map((f) => {
                    var _a, _b, _c, _d;
                    return Object.assign(Object.assign({}, f), { id: (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.find((r) => r.name === f.name)) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '', transferred: f.size, status: 'success' });
                })
            ]);
        })
            .catch((error) => {
            ADSError('Server Error uploading files', error);
            const errorFiles = [
                ...files.map((f) => {
                    var _a;
                    return Object.assign(Object.assign({}, f), { status: 'error', errorText: (_a = error.errorMessage) !== null && _a !== void 0 ? _a : t('GENERIC_ERROR') });
                })
            ];
            handleError(errorFiles, '');
        });
    };
    const handleDelete = (_files) => {
        // send a request to remove the previously uploaded files
        if (field.value.length > 0) {
            setValue(props.name, []);
        }
    };
    React__default.useEffect(() => {
        var _a;
        if ((!field.value || field.value.length === 0) &&
            filesRef.current &&
            filesRef.current.length > 0 &&
            filesRef.current.find((f) => f.id)) {
            axios
                .request({
                url: props.uploadUrl,
                method: 'delete',
                data: { ids: (_a = filesRef.current.map((f) => f.id)) !== null && _a !== void 0 ? _a : [] }
            })
                .catch(() => {
                ADSError('Server error attempting to delete file.');
            })
                .finally(() => {
                filesRef.current = [];
            });
        }
        else {
            filesRef.current = field.value;
        }
    }, [field.value, props.uploadUrl]);
    return (React__default.createElement(FileUploadBase, Object.assign({}, props, { value: field.value, onError: handleError, onFileChange: handlePick, onDelete: handleDelete, warning: warning, error: showMessages && fieldState.error && fieldState.error.message, formControlled: true })));
};
// Choose between "controlled" and "uncontrolled" based on the
// existence of the onFileChange prop.
const FileUploadStandAlone = withStandAloneGeneric(FileUploadUncontrolled, FileUploadBase, 'onFileChange');
// choose between the whatever the standalone type was that was picked
// or the schema-aware version.
const FileUploadDefault = withFieldSchemaSupport$1(FileUploadStandAlone, withFieldSchema(FileUploadSchema));
const FileUpload = React__default.forwardRef((props, ref) => React__default.createElement(FileUploadDefault, Object.assign({}, props, { inputRef: ref })));
FileUpload.displayName = 'FileUpload';

const Alert = ({ children, customDataProps, focusLock = true, icon, isClosable, maxWidth, open, stripeColor, testId, title, titleColor, type = BrandType.Info, zIndex, onClose }) => {
    return (React__default.createElement(ModalBase, { alert: true, customDataProps: customDataProps, focusLock: focusLock, icon: icon, isClosable: isClosable, maxWidth: maxWidth, onClose: onClose, open: open, stripeColor: stripeColor, testId: testId, title: title, titleColor: titleColor, type: type, zIndex: zIndex }, children));
};

const AlertBody = ({ customDataProps, children, testId = 'alertBody' }) => {
    return (React__default.createElement(ModalBodyBase, { customDataProps: customDataProps, testId: testId, alert: true }, children));
};

var css$l = ".AlertMessage_module_alertMessage__ab09ff85{background:#fff;box-shadow:0 2px 4px -1px #0003,0 4px 5px 0 #00000024,0 1px 10px 0 #0000001f;margin:2px 8px 16px;outline:none;overflow:hidden}.AlertMessage_module_box__ab09ff85{display:flex;padding:12px 16px 16px}.AlertMessage_module_iconBox__ab09ff85{display:flex;justify-content:center;margin-left:-16px;width:68px}.AlertMessage_module_iconBox__ab09ff85 .AlertMessage_module_iconDisc__ab09ff85{align-items:center;border-radius:50%;display:flex;height:36px;justify-content:center;margin-top:4px;width:36px}.AlertMessage_module_iconBox__ab09ff85 .AlertMessage_module_iconDisc__ab09ff85 svg{opacity:1}.AlertMessage_module_title__ab09ff85{margin:2px 0!important}.AlertMessage_module_title__ab09ff85 .AlertMessage_module_time__ab09ff85{display:inline-block;margin-left:8px}.AlertMessage_module_closeButton__ab09ff85{float:right;margin:0 0 16px 16px}.AlertMessage_module_contentBox__ab09ff85{flex:1}.AlertMessage_module_content__ab09ff85{color:#444750;font-size:14px;font-weight:400;line-height:20px;margin-top:4px}.AlertMessage_module_toast__ab09ff85{margin-right:24px;margin-top:12px}.AlertMessage_module_fadeOut__ab09ff85{opacity:0;transition:opacity 1s ease-in-out}";
window.ADS.injectStyle(css$l,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Internal_AlertMessage/AlertMessage.module.scss");
var modules_e536257d = {"alertMessage":"AlertMessage_module_alertMessage__ab09ff85","box":"AlertMessage_module_box__ab09ff85","iconBox":"AlertMessage_module_iconBox__ab09ff85","iconDisc":"AlertMessage_module_iconDisc__ab09ff85","title":"AlertMessage_module_title__ab09ff85","time":"AlertMessage_module_time__ab09ff85","closeButton":"AlertMessage_module_closeButton__ab09ff85","contentBox":"AlertMessage_module_contentBox__ab09ff85","content":"AlertMessage_module_content__ab09ff85","toast":"AlertMessage_module_toast__ab09ff85","fadeOut":"AlertMessage_module_fadeOut__ab09ff85"};

const TypeToPathMap = {
    [BrandType.Info]: [
        'M8 7C8.55228 7 9 7.44771 9 8V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V8C7 7.44771 7.44772 7 8 7Z',
        'M8 2.27228C8.69036 2.27228 9.25 2.83192 9.25 3.52228V3.52328C9.25 4.21363 8.69036 4.77328 8 4.77328C7.30964 4.77328 6.75 4.21363 6.75 3.52328V3.52228C6.75 2.83192 7.30964 2.27228 8 2.27228Z'
    ],
    [BrandType.Success]: [
        'M13.6156 3.21199C14.0509 3.552 14.128 4.18044 13.788 4.61566L7.53803 12.6157C7.35821 12.8458 7.08675 12.9859 6.79496 12.999C6.50318 13.0121 6.22023 12.897 6.02047 12.684L2.27047 8.68396C1.89274 8.28104 1.91315 7.64821 2.31606 7.27048C2.71897 6.89275 3.35181 6.91316 3.72954 7.31607L6.68088 10.4642L12.212 3.38437C12.552 2.94916 13.1804 2.87198 13.6156 3.21199Z'
    ],
    [BrandType.Warning]: [
        'M6.7929 1.38574C7.31405 0.4303 8.68596 0.4303 9.20711 1.38574L14.3648 10.8416C14.8646 11.7578 14.2014 12.875 13.1577 12.875H2.84227C1.79857 12.875 1.13539 11.7578 1.63517 10.8416L6.7929 1.38574ZM8.21948 3.22965C8.12472 3.05593 7.87528 3.05593 7.78053 3.22965L3.67564 10.7553C3.58477 10.9219 3.70535 11.125 3.89511 11.125H12.1049C12.2947 11.125 12.4152 10.9219 12.3244 10.7553L8.21948 3.22965Z'
    ],
    [BrandType.Error]: [
        // 'M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L8 6.58579L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L9.41421 8L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8 9.41421L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.58579 8L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z'
        'M8 7C8.55228 7 9 7.44771 9 8V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V8C7 7.44771 7.44772 7 8 7Z',
        'M8 2.27228C8.69036 2.27228 9.25 2.83192 9.25 3.52228V3.52328C9.25 4.21363 8.69036 4.77328 8 4.77328C7.30964 4.77328 6.75 4.21363 6.75 3.52328V3.52228C6.75 2.83192 7.30964 2.27228 8 2.27228Z'
    ],
    [BrandType.Inverse]: [
        'M8 7C8.55228 7 9 7.44771 9 8V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V8C7 7.44771 7.44772 7 8 7Z',
        'M8 2.27228C8.69036 2.27228 9.25 2.83192 9.25 3.52228V3.52328C9.25 4.21363 8.69036 4.77328 8 4.77328C7.30964 4.77328 6.75 4.21363 6.75 3.52328V3.52228C6.75 2.83192 7.30964 2.27228 8 2.27228Z'
    ]
};
const AlertMessageIcon = ({ color, testId, type }) => {
    return (React__default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-test": TestIdUtils.composeId(testId, 'icon') }, TypeToPathMap[type].map((pathDefinition, index) => (React__default.createElement("path", { key: index, fillRule: "evenodd", clipRule: "evenodd", d: pathDefinition, fill: color, transform: type === BrandType.Error ? 'rotate(180, 8, 8)' : '' })))));
};

const cx$o = classnames.bind(modules_e536257d);
const autoDismissStop = -1;
const autoDismissFadeOutInSec = 1;
const autoDismissDefaultDelayInSec = 5;
const autoDismissMinDelayInSec = 2;
const defaultAutoDismissConfig = { enabled: false };
var UserEvent;
(function (UserEvent) {
    UserEvent["Blur"] = "blur";
    UserEvent["Focus"] = "focus";
    UserEvent["MouseEnter"] = "mouseEnter";
    UserEvent["MouseLeave"] = "mouseLeave";
})(UserEvent || (UserEvent = {}));
const AlertMessage = React__default.forwardRef(({ id, testId, type = BrandType.Info, content, icon, color, onDismissal, autoFocus, customDataProps, lastUserEvent, autoDismissConfig = defaultAutoDismissConfig }, ref) => {
    const [autoDismissFadeOut, setAutoDismissFadeOut] = React__default.useState(false);
    const onInternalDismissal = (id, dismissedHow) => {
        onDismissal(id, dismissedHow);
    };
    const dismissTimerRef = React__default.useRef(null);
    color = color !== null && color !== void 0 ? color : BrandTypeColorMap[type];
    const closeButtonRef = React__default.useRef(null);
    const localRef = React__default.useRef(null);
    if (icon !== false) {
        icon = icon || (React__default.createElement(AlertMessageIcon, { type: type, color: color, testId: testId }));
    }
    React__default.useEffect(() => {
        var _a;
        if (autoDismissConfig.enabled) {
            autoDismissTimer((_a = autoDismissConfig.delayInSec) !== null && _a !== void 0 ? _a : autoDismissDefaultDelayInSec);
        }
        return () => {
            // Clear the timer when the component is unmounted
            stopTimer();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React__default.useEffect(() => {
        if (!autoDismissConfig.enabled) {
            return;
        }
        switch (lastUserEvent) {
            case UserEvent.MouseEnter:
            case UserEvent.Focus:
                autoDismissTimer(autoDismissStop);
                break;
            case UserEvent.MouseLeave:
            case UserEvent.Blur:
                autoDismissTimer(autoDismissMinDelayInSec);
                break;
        }
        // disable exhaustive deps because we don't want to trigger this effect
        // when autoDismissTimer or one of its dependencies changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoDismissConfig.enabled, lastUserEvent]);
    const stopTimer = () => {
        if (dismissTimerRef.current) {
            clearTimeout(dismissTimerRef.current);
            dismissTimerRef.current = null;
        }
    };
    const autoDismissTimer = (delayInSeconds) => {
        if (!autoDismissConfig.enabled) {
            return;
        }
        if (delayInSeconds === autoDismissStop) {
            setAutoDismissFadeOut(false);
            stopTimer();
            return;
        }
        if (dismissTimerRef.current) {
            // if timer is running, ignore request to start a new one
            return;
        }
        if (delayInSeconds > autoDismissFadeOutInSec) {
            dismissTimerRef.current = setTimeout(() => {
                stopTimer();
                autoDismissTimer(autoDismissFadeOutInSec);
            }, (delayInSeconds - autoDismissFadeOutInSec) * 1000);
        }
        else if (delayInSeconds === autoDismissFadeOutInSec) {
            setAutoDismissFadeOut(true);
            dismissTimerRef.current = setTimeout(() => {
                onInternalDismissal(id, DismissedBy.AutoDismiss);
            }, autoDismissFadeOutInSec * 1000);
        }
    };
    const keyDownHandler = (e) => {
        const handled = KeyHandleMap(e, [
            { Escape: () => onInternalDismissal(id, DismissedBy.Escape) }
        ]);
        // If we handled the keydown event, cancel it from propagating
        if (handled) {
            CancelReactEvent(e);
        }
    };
    const focusCloseButton = () => {
        var _a;
        (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus({
            preventScroll: false
        });
    };
    const focusHandler = (e) => {
        // React <17 uses focusin (not focus) which
        // will fire when a focus event happens within
        // it's container (bubble). So we only want to do this
        // if the parent was focused, or the related target isn't the close button.
        // This handles both tabbing in, and tabbing out (shift + tab)
        if (e.target === localRef.current &&
            e.relatedTarget !== closeButtonRef.current) {
            focusCloseButton();
        }
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: MergeRefs([localRef, ref]), onFocus: focusHandler, "data-test": testId || id, tabIndex: -1, onKeyDown: keyDownHandler, className: cx$o('alertMessage', { fadeOut: autoDismissFadeOut }) }),
        React__default.createElement("div", null,
            React__default.createElement(Stripe, { color: color, height: 4 }),
            React__default.createElement("div", { className: cx$o('box') },
                icon && (React__default.createElement("div", { className: cx$o('iconBox') },
                    React__default.createElement("div", { className: cx$o('iconDisc'), style: { background: `${color}10` } }, icon))),
                React__default.createElement("div", { className: cx$o('contentBox') },
                    React__default.createElement(CloseButton, { testId: `alertMessage-close-${id}`, autoFocus: autoFocus, ref: closeButtonRef, size: "xs", className: cx$o('closeButton'), v2Spacing: true, onClick: () => onInternalDismissal(id, DismissedBy.CloseClick) }),
                    React__default.createElement("div", { className: cx$o('content') }, content))))));
});
AlertMessage.displayName = 'AlertMessage';

const cx$n = classnames.bind(modules_e536257d);
const Notification = React__default.forwardRef((props, ref) => {
    return (React__default.createElement(AlertMessage, Object.assign({}, props, { ref: ref, content: React__default.createElement(React__default.Fragment, null,
            React__default.createElement(H6, { overline: true, className: cx$n('title') },
                props.title,
                " ",
                React__default.createElement("span", { className: cx$n('time') }, props.time)),
            props.content) })));
});
Notification.displayName = 'Notification';

const cx$m = classnames.bind(modules_e536257d);
/**
 * IMPORTANT! If you add any new props to this object, make sure to update the `ToastItemArgsTable`
 * and `Toast` components to use the new props. Otherwise, they will not show
 * up in the ArgsTable of Storybook
 */
const defaultToastProps = {
    type: BrandType.Info
};
const Toast = React__default.forwardRef((_a, ref) => {
    var { type = defaultToastProps.type } = _a, props = __rest(_a, ["type"]);
    return (React__default.createElement(AlertMessage, Object.assign({}, props, { content: React__default.createElement("div", { className: cx$m('toast') }, props.content), ref: ref, type: type })));
});
Toast.displayName = 'Toast';

var css$k = ".AlertMessages_module_alertMessages__fb01ab62{font-size:14px;max-height:100%;overflow-x:hidden;overflow-y:auto;padding:16px;position:fixed;right:0;top:0;width:350px;z-index:1000}.AlertMessages_module_alertMessages__fb01ab62:after,.AlertMessages_module_alertMessages__fb01ab62:before{content:\"\";height:20px;position:fixed;right:20px;width:320px}.AlertMessages_module_alertMessages__fb01ab62:before{background-image:linear-gradient(#fff,#0000);top:0}.AlertMessages_module_alertMessages__fb01ab62:after{background-image:linear-gradient(#0000,#fff);bottom:0}.AlertMessages_module_notificationBox__fb01ab62{transform:translateX(100%);transition:transform .3s cubic-bezier(0,0,.4,1),opacity .2s linear,height .35s cubic-bezier(.3,0,.7,1) 50ms}.AlertMessages_module_toastBox__fb01ab62{transform:translateY(-100%);transition:transform .22s cubic-bezier(.46,1.22,.74,1)}.AlertMessages_module_appear__fb01ab62,.AlertMessages_module_enterDone__fb01ab62,.AlertMessages_module_enter__fb01ab62{transform:none}.AlertMessages_module_exit__fb01ab62{opacity:0;transform:none;transition:opacity .22s}.AlertMessages_module_toast__fb01ab62{left:50%;overflow-y:hidden;right:50%;transform:translateX(-50%);width:382px}.AlertMessages_module_toast__fb01ab62:after,.AlertMessages_module_toast__fb01ab62:before{display:none}";
window.ADS.injectStyle(css$k,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Internal_AlertMessage/AlertMessages.module.scss");
var modules_069058d0 = {"alertMessages":"AlertMessages_module_alertMessages__fb01ab62","notificationBox":"AlertMessages_module_notificationBox__fb01ab62","toastBox":"AlertMessages_module_toastBox__fb01ab62","appear":"AlertMessages_module_appear__fb01ab62","enter":"AlertMessages_module_enter__fb01ab62","enterDone":"AlertMessages_module_enterDone__fb01ab62","exit":"AlertMessages_module_exit__fb01ab62","toast":"AlertMessages_module_toast__fb01ab62"};

const cx$l = classnames.bind(modules_069058d0);
const AlertMessages = ({ messages, type }) => {
    // We keep track of all the refs for the individual notification components
    // so we can manage their focus.
    const alertsRefMap = React__default.useRef(new Map());
    const msgPropRef = React__default.useRef(messages);
    msgPropRef.current = messages;
    // If we just rendered based off of having notifications, the last notification would be
    // removed from the DOM as it's trying to do it's exit animation. So we need to control if
    // the notification component renders separately, and hide it when the last notification has exited.
    const [show, setShow] = React__default.useState(false);
    const [lastUserEvent, setLastUserEvent] = React__default.useState(undefined);
    const alertMessagesRef = React__default.useRef(null);
    const onMessageExiting = (n) => {
        var _a, _b;
        // notifications for some reason is stale here and still includes
        // the notification being removed.
        const currentMsgs = (_a = msgPropRef.current) === null || _a === void 0 ? void 0 : _a.filter((msg) => msg.id !== n.id);
        if (currentMsgs.length > 0) {
            // Focus top notification
            (_b = alertsRefMap.current.get(currentMsgs[0].id)) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    // When a notification is fully exited (animation done)
    const onMessageExited = (n) => {
        var _a;
        // Remove ref from our map
        alertsRefMap.current.delete(n.id);
        const currentMsgs = (_a = msgPropRef.current) === null || _a === void 0 ? void 0 : _a.filter((msg) => msg.id !== n.id);
        if (currentMsgs.length < 1) {
            setShow(false);
            setLastUserEvent(undefined);
        }
    };
    React__default.useEffect(() => {
        if (messages.length > 0) {
            setShow(true);
        }
    }, [messages]);
    function mouseEnterHandler() {
        if (type === AlertMessageType.Toast) {
            setLastUserEvent(UserEvent.MouseEnter);
        }
    }
    function mouseLeaveHandler() {
        if (type === AlertMessageType.Toast) {
            setLastUserEvent(UserEvent.MouseLeave);
        }
    }
    const keyDownHandler = (e) => {
        if (type === AlertMessageType.Toast && e.key === 'Tab') {
            setLastUserEvent(UserEvent.Focus);
        }
    };
    function blurHandler(e) {
        OnFocusOutside(e, [alertMessagesRef.current], () => {
            setLastUserEvent(UserEvent.Blur);
        });
    }
    return show ? (React__default.createElement(Portal, null,
        React__default.createElement("div", { ref: alertMessagesRef, className: cx$l('alertMessages', type), onMouseEnter: mouseEnterHandler, onMouseLeave: mouseLeaveHandler, onKeyDown: keyDownHandler, onBlur: blurHandler },
            React__default.createElement(TransitionGroup, null, messages.map((n, idx) => {
                // We need to get access to the ability to animate our exit from
                // AnimateHeightRender component (HOC). So we need to hoist
                // that up into this closure so we can animate the height when it's exiting.
                let exit = () => null;
                return (React__default.createElement(CSSTransition, { key: n.id, appear: true, timeout: 400, unmountOnExit: true, onExited: () => onMessageExited(n), onExiting: () => {
                        exit && exit(() => null);
                        onMessageExiting(n);
                    }, classNames: Object.assign({}, modules_069058d0) },
                    React__default.createElement("div", { className: cx$l(`${type}Box`) },
                        React__default.createElement(AnimateHeightRender, null, ({ animateExit }) => {
                            exit = animateExit;
                            return (React__default.createElement(React__default.Fragment, null, type === AlertMessageType.Toast ? (React__default.createElement(Toast, Object.assign({ ref: (ref) => alertsRefMap.current.set(n.id, ref), autoFocus: idx === 0, lastUserEvent: lastUserEvent }, n))) : (React__default.createElement(Notification, Object.assign({ ref: (ref) => alertsRefMap.current.set(n.id, ref), autoFocus: idx === 0 }, n)))));
                        }))));
            }))))) : null;
};

var css$j = ".Popover_module_popover__e2ccd97d{filter:drop-shadow(0 3px 3px rgba(0,0,0,.185)) drop-shadow(0 5px 4px rgba(0,0,0,.14)) drop-shadow(0 1px 8px rgba(0,0,0,.1));max-width:calc(100vw - 100px);z-index:850}.Popover_module_popover__e2ccd97d .Popover_module_arrow__e2ccd97d{height:12px;position:absolute;visibility:hidden;width:12px;z-index:-1}.Popover_module_popover__e2ccd97d .Popover_module_arrow__e2ccd97d:before{background:inherit;content:\"\";height:12px;position:absolute;transform:rotate(45deg);visibility:visible;width:12px}.Popover_module_popover__e2ccd97d[data-floating-ui-placement^=top]>.Popover_module_arrow__e2ccd97d{bottom:-4px}.Popover_module_popover__e2ccd97d[data-floating-ui-placement^=bottom]>.Popover_module_arrow__e2ccd97d{top:-4px}.Popover_module_popover__e2ccd97d[data-floating-ui-placement^=left]>.Popover_module_arrow__e2ccd97d{right:-4px}.Popover_module_popover__e2ccd97d[data-floating-ui-placement^=right]>.Popover_module_arrow__e2ccd97d{left:-4px}";
window.ADS.injectStyle(css$j,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/floating/Popover/Popover.module.scss");
var modules_ef8f756f = {"popover":"Popover_module_popover__e2ccd97d","arrow":"Popover_module_arrow__e2ccd97d"};

const cx$k = classnames.bind(modules_ef8f756f);
const Popover = (_a) => {
    var _b, _c;
    var { customDataProps, anchorEl, testId, placement = 'auto', width = 500, type = BrandType.Info, title, titleColor } = _a, props = __rest(_a, ["customDataProps", "anchorEl", "testId", "placement", "width", "type", "title", "titleColor"]);
    const stripeColor = BrandTypeColorMap[type];
    const [floatingEl, setFloatingEl] = React__default.useState(null);
    const [arrowEl, setArrowEl] = React__default.useState(null);
    const isAutoPlacement = placement === 'auto';
    const { floatingStyles: styles, middlewareData, placement: currentPlacement } = useFloating({
        elements: {
            reference: anchorEl,
            floating: floatingEl
        },
        // We use this so we can pop out of our parent's container
        // and not be hidden by a overflow: hidden setting.
        strategy: 'fixed',
        placement: !isAutoPlacement ? placement : undefined,
        middleware: [
            // Popover is 16px away from the anchor element
            offset(16),
            // Shifts popover to keep it in view. limitShift() is used to prevent detachment of the popover from the anchor element.
            shift({
                limiter: limitShift()
            }),
            // Use either `autoPlacement` or `flip`, but not both simultaneously.
            // See: https://floating-ui.com/docs/flip#conflict-with-autoplacement
            isAutoPlacement && autoPlacement(),
            !isAutoPlacement &&
                flip({
                    // Determines the order of fallback placements.
                    fallbackAxisSideDirection: 'end'
                }),
            // Provides positioning data for an arrow element.
            arrow({ element: arrowEl })
        ],
        // Automatically updates the position of the popover element when necessary to ensure it stays anchored.
        whileElementsMounted: autoUpdate
    });
    // Add custom attributes to the popover element.
    // Popper would add the `data-popper-placement` attribute to the popover element.
    // To maintain backward compatibility, include both `data-popper-placement` and `data-floating-ui-placement`.
    // Note: Remove `data-popper-placement` in the next major version.
    const customAttributes = {
        'data-floating-ui-placement': currentPlacement,
        'data-popper-placement': currentPlacement
    };
    // If they didn't provide a title color, and the type is one of the following
    // default to the type's color.
    if (!titleColor &&
        [
            BrandType.Info,
            BrandType.Success,
            BrandType.Warning,
            BrandType.Error
        ].includes(type)) {
        titleColor = BrandTypeColorMap[type];
    }
    const dialogTitle = {
        text: title,
        color: titleColor
    };
    // We need to set the arrow's color to be white in most cases. If the popover
    // is on the bottom, then the arrow is on top and since we have have colored
    // stripe bar, our arrow needs to match the stripe in that situation.
    const arrowStyleOverrides = {
        background: currentPlacement === 'bottom' ? stripeColor : '#fff'
    };
    return anchorEl ? (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, ref: setFloatingEl, className: cx$k('popover'), style: Object.assign({ width: width }, styles) }, customAttributes),
        React__default.createElement("div", { className: cx$k('arrow'), ref: setArrowEl, style: Object.assign(Object.assign({}, arrowStyleOverrides), { position: 'absolute', 
                // Position the arrow at the middle of the anchor element.
                // Set either 'left' or 'top' based on the popover's placement.
                // The `popover` CSS class manages the remaining positioning details.
                // When the popover is at the top or bottom, assign value of arrow.x to
                // `left` as it is the x-axis offset to the horizontal center of the anchor.
                // When the popover is on the right or left, assign value of arrow.y to
                // `top` as it is the y-axis offset value to vertical center of the anchor.
                left: ((_b = middlewareData.arrow) === null || _b === void 0 ? void 0 : _b.x)
                    ? `${middlewareData.arrow.x}px`
                    : undefined, top: ((_c = middlewareData.arrow) === null || _c === void 0 ? void 0 : _c.y)
                    ? `${middlewareData.arrow.y}px`
                    : undefined }) }),
        React__default.createElement(DialogBox, Object.assign({ stripeColor: stripeColor, contentClassName: "px-150 pb-150", testId: testId }, props, { title: dialogTitle })))) : null;
};

var css$i = ".FormDebugger_module_debugger__e9da98b0{transition:all 1s}.FormDebugger_module_debugger__e9da98b0 pre{font-family:monospace;margin:5px;padding:5px;white-space:pre-wrap}.FormDebugger_module_debugger__e9da98b0 .FormDebugger_module_key__e9da98b0{color:#881391}.FormDebugger_module_debugger__e9da98b0 .FormDebugger_module_string__e9da98b0{color:green}.FormDebugger_module_debugger__e9da98b0 .FormDebugger_module_number__e9da98b0{color:#ff8c00}.FormDebugger_module_debugger__e9da98b0 .FormDebugger_module_boolean__e9da98b0{color:#0d22aa}.FormDebugger_module_debugger__e9da98b0 .FormDebugger_module_null__e9da98b0{color:#f0f}.FormDebugger_module_panel__e9da98b0{padding:10px}.FormDebugger_module_panel__e9da98b0 .FormDebugger_module_body__e9da98b0{background:#f5f5f7;border:1px solid #d9dbe3;overflow:auto}";
window.ADS.injectStyle(css$i,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Form/FormDebugger.module.scss");
var modules_daa6fd0e = {"debugger":"FormDebugger_module_debugger__e9da98b0","key":"FormDebugger_module_key__e9da98b0","string":"FormDebugger_module_string__e9da98b0","number":"FormDebugger_module_number__e9da98b0","boolean":"FormDebugger_module_boolean__e9da98b0","null":"FormDebugger_module_null__e9da98b0","panel":"FormDebugger_module_panel__e9da98b0","body":"FormDebugger_module_body__e9da98b0"};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$j = classnames.bind(modules_daa6fd0e);
const syntaxHighlightClassMap = {
    number: modules_daa6fd0e.number,
    key: modules_daa6fd0e.key,
    string: modules_daa6fd0e.string,
    boolean: modules_daa6fd0e.boolean,
    null: modules_daa6fd0e.null
};
const JSONPanel = ({ title, value, height = 200, titleColor }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: cx$j('header'), style: { color: titleColor !== null && titleColor !== void 0 ? titleColor : '' } }, title),
        React__default.createElement("div", { className: cx$j('body'), style: { height } },
            React__default.createElement("pre", { dangerouslySetInnerHTML: {
                    __html: SyntaxHighlightJS(value, syntaxHighlightClassMap)
                } }))));
};
const FormDebugger = ({ control }) => {
    const { isValid, isDirty, errors, dirtyFields, submitCount } = useFormState({
        control
    });
    const values = useWatch({ control });
    return (React__default.createElement("div", { className: cx$j('debugger') },
        React__default.createElement(Row, null,
            React__default.createElement(Col, { xs: 6, className: cx$j('panel') },
                React__default.createElement(JSONPanel, { title: "Values", value: values, height: 468, titleColor: "green" })),
            React__default.createElement(Col, { xs: 6, className: cx$j('panel') },
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { xs: 12, className: cx$j('panel') },
                        React__default.createElement(JSONPanel, { title: "Errors", value: errors, titleColor: "red" }))),
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { xs: 12, className: cx$j('panel') },
                        React__default.createElement(JSONPanel, { title: "Form State", value: { isValid, isDirty, dirtyFields, submitCount } })))))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Wrapper around react hook form. This also provides it's own FormProvider so
 * fields can auto fill in props like label, required, and desired.
 */
const Form = ({ children, clearSchemaOnUnmount = false, customDataProps, debug = false, disabled = false, mode = 'onTouched', readOnly = false, schema, testId, onSubmit, onSubmitFailure }) => {
    const defaultSchema = React__default.useMemo(() => schema !== null && schema !== void 0 ? schema : object(), [schema]);
    // Assign our form a globally unique id so that we can associate subForms to it.
    const formId = React__default.useMemo(() => {
        return UUIDv4();
    }, []);
    const initialState = React__default.useMemo(() => ({
        clearSchemaOnUnmount,
        combinedSchema: defaultSchema,
        disabled,
        formId,
        formSchema: defaultSchema,
        inForm: true,
        readOnly
    }), [clearSchemaOnUnmount, defaultSchema, disabled, formId, readOnly]);
    return (React__default.createElement(FormProvider, { initialState: initialState },
        React__default.createElement(InnerForm, { customDataProps: customDataProps, testId: testId, debug: debug, onSubmit: onSubmit, onSubmitFailure: onSubmitFailure, mode: mode, schema: defaultSchema, disabled: disabled, readOnly: readOnly }, children)));
};
const InnerForm = ({ customDataProps, testId, children, debug, disabled, mode, schema, onSubmit, onSubmitFailure, readOnly }) => {
    const { formSchema, subFormSchemas, registerSchema, setIsDisabled, setIsReadOnly } = useInternalFormContext();
    /**
     * We are using a ref so setting defaults below doesn't happen again if this changes.
     * The alternate I saw was removing the `disabled` prop from the dependency array of the useEffect below.
     * However, then we'd need to add an eslint ignore which could potentially introduce defects in the
     * future if we added additional items to that useEffect
     */
    const disabledPropRef = React__default.useRef();
    disabledPropRef.current = disabled;
    React__default.useEffect(() => {
        setIsDisabled(disabled);
    }, [disabled, setIsDisabled]);
    React__default.useEffect(() => {
        setIsReadOnly(readOnly);
    }, [readOnly, setIsReadOnly]);
    const resolver = React__default.useCallback((values, context, options) => yupResolver(formSchema.nonNullable())(values, Object.assign(Object.assign({}, context), values), options), [formSchema]);
    const form = useForm({
        mode,
        reValidateMode: 'onChange',
        resolver
        // We intentionally don't set defaults here because we need to set defaults after our schema changes.
        // Since subForms will be added to our schema and we don't know when that happens, it doesn't do us any good to set defaults here.
    });
    // Our reset supports settings current values along with updating our default values.
    const onReset = (values, defaultValues) => {
        var _a;
        // We reset the form with the defaults from our schema
        form.reset((_a = values !== null && values !== void 0 ? values : defaultValues) !== null && _a !== void 0 ? _a : formSchema.getDefault());
    };
    // Returns the version of formMethods we expose to the consumer.
    const getFormMethods = () => {
        const formMethods = Object.assign(Object.assign({}, form), { reset: onReset });
        return formMethods;
    };
    const { register, unregister, formState, watch, handleSubmit, reset, resetField, setError, clearErrors, setValue, setFocus, getValues, getFieldState, trigger, control } = form;
    const setDefaults = React__default.useCallback((parentName, values, subFormSchemas) => {
        // When our schema changes we have to manually apply defaults to fields
        // who are not dirty.
        if (!values) {
            return;
        }
        if (Array.isArray(values)) {
            if (control.getFieldState(parentName).isDirty) {
                return;
            }
            // If the default is an empty array, unregister the parent field so no untouched children maintain their value
            if (values.length === 0) {
                control.unregister(parentName, { keepDefaultValue: false });
            }
            defaultFieldValue({
                control,
                fieldName: parentName,
                resetField,
                valueToSet: values
            });
            // If our array contains objects, we need to recursively set the defaults for those objects
            values.forEach((value, index) => {
                if (typeof value === 'object') {
                    setDefaults(`${parentName}.${index}`, value, subFormSchemas);
                }
            });
            return;
        }
        for (const [name, value] of Object.entries(values)) {
            let propertyName = name;
            if (parentName !== '') {
                propertyName = `${parentName}.${name}`;
            }
            if (subFormSchemas[propertyName]) {
                setDefaults(propertyName, value, subFormSchemas);
                continue;
            }
            // If the field is not dirty, we need to set the default value.
            if (!control.getFieldState(propertyName).isDirty) {
                // We need to change this to null if the value is undefined. Otherwise, we are unable to update the Control's _defaultValues.
                // This is what react-hook-form uses to determine if the form is dirty or not (isDirty if schema.getDefaults() !== control._defaultValues).
                const valueToSet = value !== null && value !== void 0 ? value : null;
                defaultFieldValue({
                    control,
                    fieldName: propertyName,
                    resetField,
                    valueToSet
                });
            }
            const nestedSchema = getNestedSchema(formSchema, propertyName);
            if (
            // We want to recursively set the defaults for nested object schemas and arrays
            nestedSchema &&
                ((nestedSchema instanceof Yup.ObjectSchema &&
                    nestedSchema.fields &&
                    Object.keys(nestedSchema.fields).length > 0) ||
                    nestedSchema instanceof Yup.ArraySchema)) {
                setDefaults(propertyName, value, subFormSchemas);
            }
        }
    }, [control, formSchema, resetField]);
    React__default.useEffect(() => {
        registerSchema(schema);
    }, [registerSchema, schema]);
    // Every time our form schema changes, we need to reset the default values.
    React__default.useEffect(() => {
        var _a;
        // Set form to disabled so a user cannot interact with fields while the form schema is changing and defaults are getting updated
        setIsDisabled(true);
        const defaultValues = formSchema.getDefault();
        setDefaults('', defaultValues, subFormSchemas);
        trigger();
        // We don't want to override the disabled prop if we have marked the form as always disabled
        setIsDisabled((_a = disabledPropRef.current) !== null && _a !== void 0 ? _a : false);
    }, [formSchema, setDefaults, setIsDisabled, subFormSchemas, trigger]);
    // Called when submission is attempted and passes validation.
    const onSubmitHandler = () => {
        // onSubmit is passed values, but it wasn't correct. Using getValues was so
        // we are using that.
        let values = getValues();
        // Remove any undefined values
        values = omitBy(values, isUndefined);
        onSubmit && onSubmit(values, getFormMethods());
    };
    // Called when submission is attempted but failed validation with errors.
    const onSubmissionFailureHandler = (errors) => {
        onSubmitFailure && onSubmitFailure(errors, getFormMethods());
    };
    return (React__default.createElement(FormProvider$1, { register: register, unregister: unregister, formState: formState, watch: watch, handleSubmit: handleSubmit, reset: reset, resetField: resetField, setError: setError, clearErrors: clearErrors, setValue: setValue, setFocus: setFocus, getValues: getValues, getFieldState: getFieldState, trigger: trigger, control: control },
        React__default.createElement("form", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, onReset: (e) => {
                e.preventDefault();
                // Call our internal version of reset
                onReset();
            }, onSubmit: handleSubmit(onSubmitHandler, onSubmissionFailureHandler) }),
            debug && React__default.createElement(FormDebugger, { control: control }),
            children)));
};
function getNestedSchema(schema, path) {
    try {
        return Yup.reach(schema, path);
    }
    catch (_a) {
        // Yup.reach will throw an error if it doesn't find a field via the name.
    }
    return undefined;
}
function defaultFieldValue({ control, fieldName, resetField, valueToSet }) {
    const isMounted = control._names.mount.has(fieldName);
    if (!isMounted) {
        /**
         * If the field is not mounted, we are unable to set the default values which will cause issues with the isDirty status downstream.
         * This typically happens with the use of SubForms. In that instance, we manually register the field and then unregister it after we default it.
         */
        control.register(fieldName, { value: valueToSet });
    }
    resetField(fieldName, {
        keepError: false,
        keepDirty: true,
        keepTouched: true,
        defaultValue: valueToSet
    });
    if (!isMounted) {
        /**
         * Since we manually registered, we want to unregister now but keep all of the form state. This will cause a re-render at the form level which
         * will cause the children components to re-render and re-register their fields as they appear in the UI. This is helpful for focussing the first invalid
         * field when submission fails.
         */
        control.unregister(fieldName, {
            keepDefaultValue: true,
            // Set to false so we recompute dirty status after we update the values. https://github.com/react-hook-form/react-hook-form/blob/v7.45.4/src/logic/createFormControl.ts#L931
            keepDirty: false,
            keepDirtyValues: true,
            keepError: true,
            keepIsValid: true,
            keepTouched: true,
            keepValue: true
        });
    }
}

var css$h = "@charset \"UTF-8\";.DescriptionList_module_dList__c771121f{margin:0}.DescriptionList_module_dListItem__c771121f{border-top:1px solid #d9dbe3;display:flex;gap:16px;padding:6px 4px}.DescriptionList_module_dListItem__c771121f:first-of-type{border-top:none}.DescriptionList_module_dListItem__c771121f dt{display:flex;flex:0 0 auto;font-weight:600;gap:6px}.DescriptionList_module_dListItem__c771121f dt .DescriptionList_module_helpTextIcon__c771121f{display:inline;height:16px;margin-top:2px;width:16px}.DescriptionList_module_dListItem__c771121f dt .DescriptionList_module_helpTextIcon__c771121f.DescriptionList_module_huggingIcon__c771121f{display:inline-flex;margin-left:5px;margin-top:0;position:relative}.DescriptionList_module_dListItem__c771121f dt .DescriptionList_module_helpTextIcon__c771121f.DescriptionList_module_huggingIcon__c771121f div:first-child{position:absolute;top:3px}.DescriptionList_module_dListItem__c771121f dd.DescriptionList_module_dTruncated__c771121f,.DescriptionList_module_dListItem__c771121f dt div:first-child.DescriptionList_module_dTruncated__c771121f{display:inline-block;height:20px}.DescriptionList_module_dListItem__c771121f .DescriptionList_module_dDetails__c771121f{display:grid;flex:1;gap:16px;justify-content:space-between}.DescriptionList_module_dListItem__c771121f .DescriptionList_module_dDetails__c771121f dd:not(:empty){margin:0}.DescriptionList_module_dListItem__c771121f .DescriptionList_module_truncated__c771121f{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.DescriptionList_module_dListItem__c771121f .DescriptionList_module_truncated__c771121f span{display:inline;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_wideMode__c771121f .DescriptionList_module_empty__c771121f{margin-inline-start:0}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_wideMode__c771121f dd div:first-child:empty:after,.DescriptionList_module_dListItem__c771121f.DescriptionList_module_wideMode__c771121f dd:empty:after{color:#858b9d;content:\"–\"}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_stackedMode__c771121f .DescriptionList_module_dDetails__c771121f,.DescriptionList_module_dListItem__c771121f.DescriptionList_module_thinMode__c771121f .DescriptionList_module_dDetails__c771121f{display:flex;flex-flow:column nowrap;gap:4px}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_stackedMode__c771121f .DescriptionList_module_dDetails__c771121f .DescriptionList_module_empty__c771121f,.DescriptionList_module_dListItem__c771121f.DescriptionList_module_thinMode__c771121f .DescriptionList_module_dDetails__c771121f .DescriptionList_module_empty__c771121f{display:none}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_stackedMode__c771121f .DescriptionList_module_dDetails__c771121f dd:not(:empty),.DescriptionList_module_dListItem__c771121f.DescriptionList_module_thinMode__c771121f .DescriptionList_module_dDetails__c771121f dd:not(:empty){padding-left:16px;position:relative}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_stackedMode__c771121f .DescriptionList_module_dDetails__c771121f dd:not(:empty):before,.DescriptionList_module_dListItem__c771121f.DescriptionList_module_thinMode__c771121f .DescriptionList_module_dDetails__c771121f dd:not(:empty):before{content:\"•\";left:4px;position:absolute;top:0}.DescriptionList_module_dListItem__c771121f.DescriptionList_module_stackedMode__c771121f{flex-flow:column nowrap;gap:4px}";
window.ADS.injectStyle(css$h,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/List/DescriptionList/DescriptionList.module.scss");
var modules_87684fe6 = {"d-list":"DescriptionList_module_dList__c771121f","d-list-item":"DescriptionList_module_dListItem__c771121f","help-text-icon":"DescriptionList_module_helpTextIcon__c771121f","hugging-icon":"DescriptionList_module_huggingIcon__c771121f","d-truncated":"DescriptionList_module_dTruncated__c771121f","d-details":"DescriptionList_module_dDetails__c771121f","truncated":"DescriptionList_module_truncated__c771121f","wide-mode":"DescriptionList_module_wideMode__c771121f","empty":"DescriptionList_module_empty__c771121f","stacked-mode":"DescriptionList_module_stackedMode__c771121f","thin-mode":"DescriptionList_module_thinMode__c771121f"};

const cx$i = classnames.bind(modules_87684fe6);
var DListItemLayoutModes;
(function (DListItemLayoutModes) {
    DListItemLayoutModes["STACKED"] = "stacked";
    DListItemLayoutModes["THIN"] = "thin";
    DListItemLayoutModes["WIDE"] = "wide";
})(DListItemLayoutModes || (DListItemLayoutModes = {}));
const DListDetails = ({ text, index, testId, truncateText = false }) => {
    return (React__default.createElement("dd", { "data-test": TestIdUtils.composeId(testId, `details-${index}`), key: index, className: cx$i({
            truncated: truncateText,
            empty: text === ''
        }) }, truncateText ? React__default.createElement(CellText, null, text) : text));
};
const DListItem = ({ details, helpText, layout, parentWidth, term, testId }) => {
    var _a;
    // Because our parent will pass in a layout config every time when it clones
    // its children we know layout won't be empty, but TS doesn't know that.
    const filledLayout = layout;
    // On every render we need to figure out what our layout mode will be. This
    // would only need to be re-checked if the parentWidth prop passed in changes
    // which would cycle a re-render.
    const layoutMode = (() => {
        var _a, _b;
        if ((filledLayout === null || filledLayout === void 0 ? void 0 : filledLayout.breakpoints) && parentWidth) {
            if (parentWidth <= ((_a = filledLayout === null || filledLayout === void 0 ? void 0 : filledLayout.breakpoints) === null || _a === void 0 ? void 0 : _a.stacked)) {
                return DListItemLayoutModes.STACKED;
            }
            if (parentWidth <= ((_b = filledLayout === null || filledLayout === void 0 ? void 0 : filledLayout.breakpoints) === null || _b === void 0 ? void 0 : _b.thin)) {
                return DListItemLayoutModes.THIN;
            }
        }
        return DListItemLayoutModes.WIDE;
    })();
    const detailsArray = React__default.useMemo(() => {
        const originalArray = isArray(details) ? details : [details];
        return layoutMode === DListItemLayoutModes.WIDE
            ? padArray(originalArray, filledLayout.numColumns, '')
            : originalArray;
    }, [details, filledLayout.numColumns, layoutMode]);
    // If we don't have a parentWidth or assume it's zero we will get a flash
    // of stacked mode followed by the actual mode
    if (!parentWidth) {
        return null;
    }
    return (React__default.createElement("div", { "data-test": `${testId}-list-item`, className: cx$i('d-list-item', `${layoutMode}-mode`), "data-layout-mode": layoutMode },
        React__default.createElement("dt", { "data-test": `${testId}-term`, style: {
                width: layoutMode !== DListItemLayoutModes.STACKED
                    ? filledLayout.termWidth
                    : '100%'
            } },
            React__default.createElement("div", { className: cx$i({
                    truncated: filledLayout.truncateText
                }) }, filledLayout.truncateText ? (React__default.createElement(CellText, null, term)) : (React__default.createElement(React__default.Fragment, null,
                term,
                helpText && (React__default.createElement("div", { className: cx$i('help-text-icon', 'hugging-icon') },
                    React__default.createElement(HelpIcon, { text: helpText })))))),
            filledLayout.truncateText && helpText && (React__default.createElement("div", { className: cx$i('help-text-icon') },
                React__default.createElement(HelpIcon, { text: helpText })))),
        React__default.createElement("div", { "data-test": `${testId}-details`, className: cx$i('d-details', {
                truncated: filledLayout.truncateText
            }), style: {
                gridTemplateColumns: ((_a = filledLayout.columnsConfig) === null || _a === void 0 ? void 0 : _a.type) === 'grid-columns'
                    ? filledLayout.columnsConfig.columns
                    : undefined
            } }, detailsArray.map((dd, i) => (React__default.createElement(DListDetails, { text: dd, index: i, key: i, testId: testId, truncateText: filledLayout.truncateText }))))));
};
DListItem.displayName = 'DListItem';
const columnsConfigDefault = {
    type: 'grid-columns',
    columns: 'repeat(auto-fit, minmax(10px, 1fr))'
};
const DescriptionList = ({ breakpoints, children, className, columnsConfig = columnsConfigDefault, customDataProps, termWidth = 192, testId, truncateText = false }) => {
    const ref = React__default.useRef(null);
    useRestrictedChildType('DescriptionList', ['DListItem'], children);
    const typedChildren = children;
    // Would love to use CSS container queries, but given we want this configurable
    // we are going to use JS's version of container queries by watching for changes to our
    // container's width.
    const { width } = useSize(ref.current);
    // Calculate # columns by observing the details array
    const numColumns = React__default.useMemo(() => {
        let colCount = 1;
        React__default.Children.toArray(typedChildren)
            .filter((React__default.isValidElement))
            .forEach((detailsRow) => {
            const detailsList = detailsRow.props.details;
            if (detailsList &&
                isArray(detailsList) &&
                colCount < detailsList.length) {
                colCount = detailsList.length;
            }
        });
        return colCount;
    }, [typedChildren]);
    const clonedChildren = React__default.Children.toArray(typedChildren)
        .filter(React__default.isValidElement)
        .map((child, index) => {
        const uniqueTestId = `${testId}-row-${index}`;
        const props = {
            layout: {
                columnsConfig,
                numColumns,
                termWidth: termWidth,
                // we spread these in like this so if they only set one of the properties we get both set still
                breakpoints: Object.assign({ stacked: 350, thin: 500 }, breakpoints),
                truncateText
            },
            parentWidth: width !== null && width !== void 0 ? width : undefined,
            testId: uniqueTestId
            // term and details are required props for DListItem and don't come from the DescriptionList
        };
        return React__default.cloneElement(child, props);
    });
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: ref, "data-test": testId, className: cx$i(className) }),
        React__default.createElement("dl", { className: cx$i('d-list') }, clonedChildren)));
};
const HelpIcon = ({ text }) => (React__default.createElement(Icon, { icon: "ICircleIcon", size: 16, onClick: (evt) => evt.stopPropagation(), tooltip: {
        content: text,
        trigger: 'mouseenter click'
    }, className: "help-hover" }));

const defaultFormatConfig = {
    allowNegative: undefined,
    decimal: {
        maxLength: 0,
        minLength: undefined
    },
    hasThousandsSeparator: true,
    integral: {
        maxLength: undefined
    }
};
const PercentField = (_a) => {
    var { maximumDecimals = defaultFormatConfig.decimal.maxLength, locale } = _a, props = __rest(_a, ["maximumDecimals", "locale"]);
    const { locale: detectedLocale } = useLocale(locale);
    return (React__default.createElement(NumberField, Object.assign({}, props, { locale: detectedLocale, endIcon: { name: 'PercentIcon' }, formatStyle: FormatStyleTypes.DECIMAL, maximumDecimals: maximumDecimals, defaultFormatConfig: defaultFormatConfig })));
};

var css$g = ".PhoneField_module_phoneField__ae534636{display:flex}.PhoneField_module_countrySelect__ae534636{background-color:#f5f5f7;border-right-color:#0000;margin-right:-1px;text-overflow:clip;transition:none;width:68px}.PhoneField_module_countrySelect__ae534636 button{border-radius:2px 0 0 2px!important;max-height:none;transition:all 275ms cubic-bezier(.25,.25,.25,1),background-color 0ms}.PhoneField_module_countrySelect__ae534636 button:focus{box-shadow:0 0 0 3px #365ef64d!important}.PhoneField_module_countrySelect__ae534636[disabled]{background-color:#f5f5f7;border-color:#cbced7 #0000 #cbced7 #cbced7;color:#b0b4bf;opacity:1}.PhoneField_module_countrySelect__ae534636[disabled] input{background-color:#f5f5f7;color:#b0b4bf}.PhoneField_module_countrySelect__ae534636:focus{z-index:99}.PhoneField_module_ext__ae534636{margin-left:12px;width:64px}.PhoneField_module_error__ae534636 .PhoneField_module_countrySelect__ae534636{border-color:#ea0a3b #0000 #ea0a3b #ea0a3b}.PhoneField_module_warning__ae534636 .PhoneField_module_countrySelect__ae534636{border-color:#d93f02 #0000 #d93f02 #d93f02}";
window.ADS.injectStyle(css$g,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/PhoneField/PhoneField.module.scss");
var modules_a0fccd31 = {"phoneField":"PhoneField_module_phoneField__ae534636","countrySelect":"PhoneField_module_countrySelect__ae534636","ext":"PhoneField_module_ext__ae534636","error":"PhoneField_module_error__ae534636","warning":"PhoneField_module_warning__ae534636"};

const cx$h = BindStyles(modules_a0fccd31);
const CountrySelect = React__default.forwardRef(({ name, countries = [], disabled = false, readOnly = false, testId, value, onChange, onBlur, onFocus }, ref) => {
    const countryList = countries.length < 1
        ? CountryData
        : CountryData.filter((c) => countries.includes(c.code) || countries.includes(c.code3));
    return (React__default.createElement(Select, { ref: ref, name: name, className: cx$h('countrySelect'), testId: testId, value: countryList
            .filter((c) => c.code === value)
            .map((c) => {
            return {
                id: c.code3,
                text: c.code,
                description: `+(${c.dialingCode})`
            };
        })[0], onBlur: onBlur, onChange: onChange, onFocus: onFocus, disabled: readOnly || disabled, options: countryList.map((c) => {
            return {
                id: c.code3,
                text: c.code,
                description: `+(${c.dialingCode})`
            };
        }), tabIndex: 0 }));
});
CountrySelect.displayName = 'CountrySelect';

const cx$g = BindStyles(modules_a0fccd31);
const MAX_EXT_LENGTH_RECOMMENDED_RANGE = { min: 1, max: 20 };
const DEFAULTS = {
    countryCode: 'US',
    countryCode3: 'USA'
};
const PhoneFieldBase = ({ autoFocus, customDataProps, className, countries, desired, disabled, error, helpText, inputRef, label, name, readOnly, required, testId, value, warning, defaultCountry = 'US', disableAutoFill = true, disableExt = false, extClassName = '', hideExt = false, maxExtLength = 8, onBlur, onChange, onContextMenu }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const phoneNumberRef = React__default.useRef(new PhoneNumber(countries));
    const phoneInputRef = React__default.useRef(null);
    const countrySelectRef = React__default.useRef(null);
    const userCountryCode = useLocaleCountryCode();
    const sendOnChange = (value) => {
        onChange({
            target: { name, value }
        });
    };
    // Reducer handler for when we want to update the telephone value.
    const setPhoneNumber = (v) => {
        var _a, _b;
        // If a alpha character is detected we just don't do anything and short
        // circuit this update attempt.
        if (/[a-zA-Z]/.test(v) || !value) {
            return;
        }
        let formatted = phoneNumberRef.current.setValue(v).toString();
        // By default, if a value is something like `"(123)"`
        // then Backspace would only erase the rightmost brace
        // becoming something like `"(123"`
        // which would give the same `"123"` value
        // which would then be formatted back to `"(123)"`
        // and so a user wouldn't be able to erase the phone number.
        // Working around this issue with this simple hack.
        // Update: Also had to add support for 1 (235) (7 characters)
        if (formatted === value.phoneNumber &&
            (formatted.length === 5 || formatted.length === 7)) {
            formatted = formatted.slice(0, -1);
        }
        sendOnChange(Object.assign(Object.assign({}, value), { countryCode: (_a = phoneNumberRef.current.getCountry()) === null || _a === void 0 ? void 0 : _a.code, countryCode3: (_b = phoneNumberRef.current.getCountry()) === null || _b === void 0 ? void 0 : _b.code3, phoneNumber: formatted, E164Number: phoneNumberRef.current.toInternationalString(), isValid: phoneNumberRef.current.isValid() }));
    };
    const defaultCountryData = GetCountryByCode(defaultCountry);
    const valueWasEmpty = !value;
    value = value || {
        countryCode: (_a = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code) !== null && _a !== void 0 ? _a : DEFAULTS.countryCode,
        countryCode3: (_b = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code3) !== null && _b !== void 0 ? _b : DEFAULTS.countryCode3,
        phoneNumber: '',
        E164Number: '',
        extNumber: ''
    };
    if (valueWasEmpty) {
        phoneNumberRef.current.setValue('');
        phoneNumberRef.current.setCountryCode((_c = defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code3) !== null && _c !== void 0 ? _c : DEFAULTS.countryCode3);
    }
    let countryChanged = false;
    if (!valueWasEmpty) {
        const valueCountryData = GetCountryByCode(value.countryCode || value.countryCode3 || '');
        if (value.countryCode !== ((_d = valueCountryData === null || valueCountryData === void 0 ? void 0 : valueCountryData.code) !== null && _d !== void 0 ? _d : 'US') ||
            value.countryCode3 !== ((_e = valueCountryData === null || valueCountryData === void 0 ? void 0 : valueCountryData.code3) !== null && _e !== void 0 ? _e : 'USA')) {
            countryChanged = true;
            value.countryCode =
                (_g = (_f = valueCountryData === null || valueCountryData === void 0 ? void 0 : valueCountryData.code) !== null && _f !== void 0 ? _f : defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code) !== null && _g !== void 0 ? _g : 'US';
            value.countryCode3 =
                (_j = (_h = valueCountryData === null || valueCountryData === void 0 ? void 0 : valueCountryData.code3) !== null && _h !== void 0 ? _h : defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code3) !== null && _j !== void 0 ? _j : 'USA';
        }
    }
    // Reducer handler for when we need to update the country code.
    const setCountryCode = (v) => {
        var _a, _b;
        if (!value) {
            return;
        }
        phoneNumberRef.current.setCountryCode(v);
        sendOnChange(Object.assign(Object.assign({}, value), { phoneNumber: phoneNumberRef.current.toString(), countryCode: (_a = phoneNumberRef.current.getCountry()) === null || _a === void 0 ? void 0 : _a.code, countryCode3: (_b = phoneNumberRef.current.getCountry()) === null || _b === void 0 ? void 0 : _b.code3, isValid: phoneNumberRef.current.isValid() }));
    };
    const setExtNumber = (v) => {
        sendOnChange(Object.assign(Object.assign({}, value), { extNumber: v }));
    };
    const handleBlur = (e) => {
        if (countrySelectRef.current) {
            countrySelectRef.current.tabIndex = 0;
        }
        onBlur && onBlur(e);
    };
    const focusHandler = (e) => {
        var _a;
        // e.target is the element gaining focus, and relatedTarget is the element
        // losing focus. So if country select is gaining focus and it's not coming
        // back from the phoneInput, then we want to forward our focus to the phoneInput.
        if (e.target === countrySelectRef.current &&
            e.relatedTarget !== phoneInputRef.current) {
            (_a = phoneInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    // Initial setup
    React__default.useEffect(() => {
        var _a, _b, _c;
        if (userCountryCode) {
            phoneNumberRef.current.setUsersCountryCode(userCountryCode);
        }
        // Make sure we have our initial country set either from the value or defaultCountry
        if (!phoneNumberRef.current.getCountry()) {
            phoneNumberRef.current.setCountryCode((_a = ((value === null || value === void 0 ? void 0 : value.countryCode) ||
                (value === null || value === void 0 ? void 0 : value.countryCode3) ||
                (defaultCountryData === null || defaultCountryData === void 0 ? void 0 : defaultCountryData.code))) !== null && _a !== void 0 ? _a : 'US');
            // If we update the country fire a change event
            if (!(value === null || value === void 0 ? void 0 : value.countryCode) || !(value === null || value === void 0 ? void 0 : value.countryCode3) || countryChanged) {
                sendOnChange(Object.assign(Object.assign({}, value), { countryCode: (_b = phoneNumberRef.current.getCountry()) === null || _b === void 0 ? void 0 : _b.code, countryCode3: (_c = phoneNumberRef.current.getCountry()) === null || _c === void 0 ? void 0 : _c.code3 }));
            }
        }
        if (!hideExt &&
            (maxExtLength < MAX_EXT_LENGTH_RECOMMENDED_RANGE.min ||
                maxExtLength > MAX_EXT_LENGTH_RECOMMENDED_RANGE.max)) {
            console.warn(`value of maxExtLength: ${maxExtLength} is outside of the recommended range ${MAX_EXT_LENGTH_RECOMMENDED_RANGE.min}-${MAX_EXT_LENGTH_RECOMMENDED_RANGE.max}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // This sets the phoneNumberRef's initial value and countryCode and
    // keeps phoneNumberRef in sync with the [value] prop
    React__default.useEffect(() => {
        if (value.phoneNumber &&
            value.countryCode3 &&
            phoneNumberRef.current.getValue() === '') {
            phoneNumberRef.current.setValue(value === null || value === void 0 ? void 0 : value.phoneNumber);
            phoneNumberRef.current.setCountryCode(value.countryCode3);
        }
    }, [value]);
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { onFocus: focusHandler, tabIndex: -1, "data-test": testId, className: cx$g(className, { disabled, error, warning }) }),
        React__default.createElement("div", { className: "d-flex" },
            React__default.createElement("div", null,
                React__default.createElement(Label, { required: required, desired: desired, disabled: disabled, helpText: helpText }, label || ' '),
                React__default.createElement("div", { className: cx$g('phoneField'), onContextMenu: onContextMenu },
                    (!countries || (countries && countries.length > 1)) && (React__default.createElement(CountrySelect, { ref: countrySelectRef, name: `${name}__country`, countries: countries, readOnly: readOnly, testId: `${testId !== null && testId !== void 0 ? testId : 'phoneField_country'}_dropdown`, value: value.countryCode, onChange: (e) => setCountryCode(e.target.value.text), disabled: disabled, onFocus: () => {
                            if (countrySelectRef.current) {
                                countrySelectRef.current.tabIndex = -1;
                            }
                        }, onBlur: () => {
                            if (countrySelectRef.current) {
                                countrySelectRef.current.tabIndex = 0;
                            }
                        } })),
                    React__default.createElement(TextField, { appearError: !!error, appearWarning: !!warning, autoFocus: autoFocus, disableAutoFill: disableAutoFill, disabled: disabled, maxLength: 18, name: `${name}__phone`, readOnly: readOnly, ref: MergeRefs([phoneInputRef, inputRef]), testId: `${testId !== null && testId !== void 0 ? testId : 'phoneField'}_inputField`, tightGroup: true, value: value.phoneNumber, width: "auto", onBlur: handleBlur, onChange: (e) => setPhoneNumber(e.target.value), onFocus: () => {
                            if (countrySelectRef.current) {
                                countrySelectRef.current.tabIndex = -1;
                            }
                        } }))),
            !hideExt && (React__default.createElement("div", { "data-test": testId ? `${testId}_ext` : 'phoneField_ext', className: cx$g('ext', extClassName) },
                React__default.createElement(Label, { disabled: disabled || disableExt }, "Ext"),
                React__default.createElement(TextField, { name: `${name}__ext`, maxLength: maxExtLength, readOnly: readOnly, format: "decimal-digits", disabled: disabled || disableExt, value: value.extNumber, onChange: (e) => setExtNumber(e.target.value), onContextMenu: onContextMenu })))),
        React__default.createElement(FieldMessage, { message: error }),
        React__default.createElement(FieldMessage, { message: warning, messageStyle: "warning" })));
};
const PhoneFieldSchema = (_a) => {
    var { desired, disabled, error, label, name, readOnly, required, warning, onBlur, onChange } = _a, props = __rest(_a, ["desired", "disabled", "error", "label", "name", "readOnly", "required", "warning", "onBlur", "onChange"]);
    // We need to grab values and any validation errors from form context.
    // We still let any value or error props values override react-hook-form's values.
    const { field, fieldState, showMessages } = useFieldController(name);
    const { formSchema } = useInternalFormContext();
    const fieldSchema = React__default.useMemo(() => {
        try {
            const phoneSchema = Yup.reach(formSchema, name);
            const differingProps = {};
            if (props.countries && !isEqual(props.countries, phoneSchema.countries)) {
                differingProps['countries'] = {
                    schema: phoneSchema.countries,
                    props: props.countries
                };
            }
            // if the consumer provided a value for defaultCountry that differs from the schema value...
            if (props.defaultCountry &&
                props.defaultCountry !== phoneSchema.defaultCountry) {
                differingProps['defaultCountry'] = {
                    schema: phoneSchema.defaultCountry,
                    props: props.defaultCountry
                };
            }
            if (Object.keys(differingProps).length) {
                ADSWarn(`Your phone schema and phone field have different values for ${Object.keys(differingProps).join(' and')}. Since you are in a form and these values are needed to default the phone filed, these must be provided as part of the phoneNumber() schema. Please refer to your schema to provide these values.`, differingProps);
            }
            return {
                countries: phoneSchema.countries,
                defaultCountry: phoneSchema.defaultCountry
            };
        }
        catch (_a) {
            return undefined;
        }
    }, [formSchema, name, props.countries, props.defaultCountry]);
    // Desired is a weird concept in that the form / schema is still valid
    // but we want to show a validation error. So we handle that logic here.
    // If this is a desired field, has a empty value, does not currently have
    // an error and has been touched, set the error to the desired error text.
    if (desired && showMessages && IsFalseyOrEmpty(field.value)) {
        warning = `${label} is desired`;
    }
    // If they have not passed in an error and the field has been touched or form
    // submitted and the form has an error, set the message here.
    if (!error && showMessages && fieldState.error) {
        error = fieldState.error.message;
    }
    const handleChange = (e) => {
        field.onChange(e);
        onChange && onChange(e);
    };
    const handleBlur = (e) => {
        e.persist && e.persist();
        e.target.name = name;
        field.onBlur();
        onBlur && onBlur(e);
    };
    // When we are part of a Form schema, the schema's value for this field
    // set the value.
    if (!(isString(field.value) || isNumber$1(field.value))) {
        props.value = field.value;
    }
    // If we are readOnly or disabled we can't also be required or desired
    if (readOnly || disabled) {
        required = false;
        desired = false;
        error = false;
        warning = false;
    }
    return (React__default.createElement(PhoneFieldBase, Object.assign({ name: name, label: label, disabled: disabled, readOnly: readOnly, error: error, onChange: handleChange, onBlur: handleBlur, required: required, desired: desired, warning: warning }, props, { inputRef: field.ref, countries: fieldSchema === null || fieldSchema === void 0 ? void 0 : fieldSchema.countries, defaultCountry: fieldSchema === null || fieldSchema === void 0 ? void 0 : fieldSchema.defaultCountry })));
};
// We need a version that is standalone
const UnControlledPhoneField = (props) => {
    const [value, setValue] = React__default.useState(undefined);
    return (React__default.createElement(PhoneFieldBase, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandalonePhoneField = withStandAlone(UnControlledPhoneField, PhoneFieldBase);
const PhoneField = withFieldSchemaSupport$1(StandalonePhoneField, PhoneFieldSchema);

var css$f = ".PrivacyField_module_wrapper__6b285df9 input[type=password]::-ms-reveal{display:none}";
window.ADS.injectStyle(css$f,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/PrivacyField/PrivacyField.module.scss");
var modules_1c1f3702 = {"wrapper":"PrivacyField_module_wrapper__6b285df9"};

const cx$f = BindStyles(modules_1c1f3702);
const HIDE_TIMEOUT = 5000;
const PrivacyField = (_a) => {
    var { className, customDataProps, disabled, interimNumCharcters = 0, spellCheck = false, testId, value = '', onBlur, onFocus, onLoadValue, onContextMenu } = _a, props = __rest(_a, ["className", "customDataProps", "disabled", "interimNumCharcters", "spellCheck", "testId", "value", "onBlur", "onFocus", "onLoadValue", "onContextMenu"]);
    // This a ref to an array of functions that need to run after our value is loaded IF
    // we don't start with a value.
    const afterValueLoaded = React__default.useRef([]);
    // Detect if we are in interimValue mode or not (i.e. don't have a value to show)
    const [interimValue, setInterimValue] = React__default.useState(() => {
        if (interimNumCharcters && !value) {
            if (!onLoadValue) {
                ADSError('Prop interimNumCharacters was provided but onLoadValue was undefined. Please provide a function for onLoadValue');
            }
            return '*'.repeat(interimNumCharcters);
        }
        return '';
    });
    const [visible, setVisible] = React__default.useState(false);
    const [el, setEl] = React__default.useState(null);
    const [isLoading, setIsLoading] = React__default.useState(false);
    const inputRef = React__default.useRef(null);
    const timerRef = React__default.useRef(null);
    const focusInput = () => {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            const inputEl = inputRef.current;
            const end = inputEl.value.length;
            inputEl.setSelectionRange(end, end);
            inputEl.focus();
        }
    };
    const handleIconClick = (e) => {
        e.stopPropagation();
        // If we are needing to load our value wait
        if (interimValue) {
            setIsLoading(true);
            onLoadValue && onLoadValue();
            afterValueLoaded.current.push(() => setVisible(true));
            return;
        }
        setVisible(!visible);
        if (inputRef) {
            // We wait a cycle for React to re-render so cursor is at the end
            setTimeout(focusInput, 1);
        }
    };
    const handleBlur = (e) => {
        const event = e;
        if (visible && el) {
            // Only if blur is outside our comp, do we conceal on blur. If we have
            // blurred to a child element we don't do anything yet.
            OnFocusOutside(event, [el], () => setVisible(false));
        }
        onBlur && onBlur(e);
    };
    const handleIconKeyDown = (e) => {
        // Handle the event based off which key was pressed
        const handled = KeyHandleMap(e, [
            {
                Enter: () => setVisible(!visible)
            }
        ]);
        // If we handled the keydown event, cancel it from propagating
        if (handled) {
            CancelReactEvent(e);
        }
    };
    // Detect when we switch from no value to value loaded.
    React__default.useEffect(() => {
        if (interimValue && isLoading && value) {
            setIsLoading(false);
            setInterimValue('');
            setTimeout(focusInput, 1);
            // Invoke all functions queued up to run after our value has been loaded.
            while (afterValueLoaded.current.length > 0) {
                const cb = afterValueLoaded.current.pop();
                cb && cb();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const handleFocus = (e) => {
        // If we don't have our value loaded yet, go into loading state
        // and request the value.
        if (interimValue) {
            setIsLoading(true);
            onLoadValue && onLoadValue();
        }
        else {
            onFocus && onFocus(e);
        }
    };
    const stopTimer = React__default.useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    const startTimer = React__default.useCallback(() => {
        stopTimer();
        // Just need access to current visible state without
        // creating a dep on visible.
        if (el) {
            setVisible((v) => {
                if (v) {
                    timerRef.current = setTimeout(() => {
                        setVisible(false);
                    }, HIDE_TIMEOUT);
                }
                return v;
            });
        }
    }, [stopTimer, el]);
    // Anytime our visible status changes, start or stop our timer
    React__default.useEffect(() => {
        if (visible)
            startTimer();
        else
            stopTimer();
        // On unmount stop any timers that had started. To reveal a privacy field
        // value and then have it be unmount was a memory leak.
        return () => stopTimer();
    }, [visible, stopTimer, startTimer]);
    return (React__default.createElement("div", { ref: setEl, className: `${cx$f('wrapper')} ${className}`, "data-test": TestIdUtils.composeId(testId, 'privacyField-wrapper') },
        React__default.createElement(TextField, Object.assign({ customDataProps: customDataProps }, props, { onFocus: handleFocus, ref: inputRef, isLoading: isLoading, disabled: disabled, onBlur: handleBlur, onKeyDown: startTimer, password: !visible, spellCheck: spellCheck, testId: testId, value: value || interimValue, onContextMenu: onContextMenu, endIcon: {
                name: visible ? 'EyeIcon' : 'EyeOffIcon',
                onKeyDown: handleIconKeyDown,
                onClick: handleIconClick,
                readOnlyEnabled: true
            } }))));
};

var css$e = ".RadioV2_module_radio__cff6c5d9{align-items:start;display:inline-flex;gap:0;margin:6px 0;position:relative}.RadioV2_module_radio__cff6c5d9.RadioV2_module_hasRenderContent__cff6c5d9:not(.RadioV2_module_wrapped__cff6c5d9){margin-bottom:14px;margin-top:14px}.RadioV2_module_radio__cff6c5d9 label{align-items:center;cursor:pointer;font-weight:400;line-height:20px;padding-left:8px}.RadioV2_module_radio__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9{display:inline-block;flex:0 0 18px;height:18px;position:relative;width:18px}.RadioV2_module_radio__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:after,.RadioV2_module_radio__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before{height:18px;left:0;margin:1px 0;position:absolute;top:0;width:18px}.RadioV2_module_radio__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before{background-color:#fff;border:1px solid #b0b4bf;border-radius:50%;content:\"\";display:inline-block;transition:all .2s cubic-bezier(.78,.14,.15,.86)}.RadioV2_module_radio__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:after{background-color:#444750;border-radius:50%;display:inline-block;height:6px;left:6px;top:6px;width:6px}.RadioV2_module_radio__cff6c5d9.RadioV2_module_wrapped__cff6c5d9{flex:1 1}.RadioV2_module_radio__cff6c5d9.RadioV2_module_disabled__cff6c5d9,.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9{pointer-events:none}.RadioV2_module_radio__cff6c5d9.RadioV2_module_disabled__cff6c5d9 label,.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9 label{color:#b0b4bf;cursor:default!important}.RadioV2_module_radio__cff6c5d9.RadioV2_module_disabled__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before,.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before{background-color:#f5f5f7!important;border-color:#cbced7}.RadioV2_module_radio__cff6c5d9.RadioV2_module_disabled__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:after,.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:after{background-color:#b0b4bf}.RadioV2_module_radio__cff6c5d9.RadioV2_module_disabled__cff6c5d9{user-select:none}.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9 label{color:#363840}.RadioV2_module_radio__cff6c5d9.RadioV2_module_readOnly__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:after{background-color:#444750}.RadioV2_module_renderContent__cff6c5d9{padding-bottom:8px;padding-top:8px}.RadioV2_module_renderContent__cff6c5d9.RadioV2_module_wrapped__cff6c5d9{padding-bottom:12px;padding-left:26px;padding-top:0}.RadioV2_module_renderContent__cff6c5d9.RadioV2_module_isLastChild__cff6c5d9{padding-bottom:0}.RadioV2_module_input__cff6c5d9{cursor:pointer;height:18px;left:0;margin:0;opacity:0;position:absolute;top:0;width:18px;z-index:1}.RadioV2_module_input__cff6c5d9+.RadioV2_module_inputStyleMask__cff6c5d9:after{content:none}.RadioV2_module_input__cff6c5d9:hover+.RadioV2_module_inputStyleMask__cff6c5d9:before{border-color:#365ef6}.RadioV2_module_input__cff6c5d9:checked+.RadioV2_module_inputStyleMask__cff6c5d9:after{content:\"\"}.RadioV2_module_input__cff6c5d9:focus+.RadioV2_module_inputStyleMask__cff6c5d9:before{border-color:#365ef6;box-shadow:0 0 0 3px #365ef64d}.RadioV2_module_input__cff6c5d9:checked+.RadioV2_module_inputStyleMask__cff6c5d9:before{background-color:#fff}.RadioV2_module_input__cff6c5d9:checked:focus+.RadioV2_module_inputStyleMask__cff6c5d9:before{box-shadow:0 0 0 3px #365ef64d}.RadioV2_module_input__cff6c5d9.RadioV2_module_disabled__cff6c5d9,.RadioV2_module_input__cff6c5d9.RadioV2_module_readOnly__cff6c5d9{cursor:default!important;pointer-events:none;user-select:none}.RadioV2_module_input__cff6c5d9.RadioV2_module_disabled__cff6c5d9+.RadioV2_module_inputStyleMask__cff6c5d9:before,.RadioV2_module_input__cff6c5d9.RadioV2_module_readOnly__cff6c5d9+.RadioV2_module_inputStyleMask__cff6c5d9:before{background-color:#f5f5f7;border-color:#cbced7;cursor:default!important}.RadioV2_module_input__cff6c5d9.RadioV2_module_disabled__cff6c5d9+.RadioV2_module_inputStyleMask__cff6c5d9:after,.RadioV2_module_input__cff6c5d9.RadioV2_module_readOnly__cff6c5d9+.RadioV2_module_inputStyleMask__cff6c5d9:after{background-color:#b0b4bf}.RadioV2_module_error__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before{border-color:#ea0a3b}.RadioV2_module_desired__cff6c5d9 .RadioV2_module_inputStyleMask__cff6c5d9:before{border-color:#f45110}";
window.ADS.injectStyle(css$e,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Radio/RadioV2.module.scss");
var modules_d61f1b99 = {"radio":"RadioV2_module_radio__cff6c5d9","hasRenderContent":"RadioV2_module_hasRenderContent__cff6c5d9","wrapped":"RadioV2_module_wrapped__cff6c5d9","input-style-mask":"RadioV2_module_inputStyleMask__cff6c5d9","disabled":"RadioV2_module_disabled__cff6c5d9","readOnly":"RadioV2_module_readOnly__cff6c5d9","renderContent":"RadioV2_module_renderContent__cff6c5d9","isLastChild":"RadioV2_module_isLastChild__cff6c5d9","input":"RadioV2_module_input__cff6c5d9","error":"RadioV2_module_error__cff6c5d9","desired":"RadioV2_module_desired__cff6c5d9"};

const cx$e = classnames.bind(modules_d61f1b99);
const RadioV2 = (props) => (React__default.createElement(BaseRadioV2, Object.assign({}, props)));
RadioV2.displayName = 'Radio'; // used for type validation in RadioGroup
const BaseRadioV2 = ({ autoFocus, checked, className, contentConfig, customDataProps, desired, disabled, error, id, inputRef, isLastChild, label, name, readOnly, renderContent, testId, value, onBlur, onChange, onClick }) => {
    const _id = id !== null && id !== void 0 ? id : `${name}-${value}`;
    const handleChange = (e) => {
        e.persist();
        onChange && onChange(e);
    };
    return (React__default.createElement(Flex, { testId: TestIdUtils.composeId(testId, 'container'), className: cx$e('gap-v-0', 'flex-no-wrap', {
            'flex-d-column': contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
            'flex-d-row': !(contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped),
            'gap-h-50': !label
        }) },
        React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, style: {
                width: !(contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped)
                    ? contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.controlColumnWidth
                    : '100%'
            }, className: cx$e('radio', className, {
                error,
                desired,
                disabled,
                readOnly,
                wrapped: contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
                hasRenderContent: renderContent
            }) }),
            React__default.createElement("input", { "data-test": TestIdUtils.composeId(testId, 'input'), autoFocus: autoFocus, checked: checked, className: cx$e('input'), disabled: disabled || readOnly, id: _id, name: name, ref: inputRef, type: "radio", value: `${value}`, onBlur: onBlur, onChange: handleChange, onClick: onClick }),
            React__default.createElement("span", { "data-test": TestIdUtils.composeId(testId, 'style-mask'), className: cx$e('input-style-mask') }),
            label && (React__default.createElement("label", { "data-test": TestIdUtils.composeId(testId, 'label'), htmlFor: _id }, label))),
        renderContent && (React__default.createElement("div", { "data-test": TestIdUtils.composeId(testId, 'render-content'), className: cx$e('renderContent', 'flex-item', {
                wrapped: contentConfig === null || contentConfig === void 0 ? void 0 : contentConfig.wrapped,
                isLastChild
            }) }, renderContent({ disabled: disabled || !checked })))));
};

var css$d = ".RadioGroup_module_group__52897c18{border-radius:3px;display:inline-flex;flex-wrap:wrap;gap:0 16px}.RadioGroup_module_vertical__52897c18{flex-direction:column;row-gap:0}.RadioGroup_module_vertical__52897c18.RadioGroup_module_wrappingEnabled__52897c18{width:100%}.RadioGroup_module_vertical__52897c18 .RadioGroup_module_adsQBox__52897c18{padding-bottom:1px;padding-top:1px}";
window.ADS.injectStyle(css$d,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/RadioGroup/RadioGroup.module.scss");
var modules_ffc222cf = {"group":"RadioGroup_module_group__52897c18","vertical":"RadioGroup_module_vertical__52897c18","wrappingEnabled":"RadioGroup_module_wrappingEnabled__52897c18","ads-q-box":"RadioGroup_module_adsQBox__52897c18"};

const cx$d = BindStyles(modules_ffc222cf);
/** Returns true if the the contentLayoutOverride prop exists on the child */
const hasContentLayoutOverride = (props) => {
    return 'contentLayoutOverride' in props;
};
/**
 * `RadioGroup` contains radio buttons in a group. It is the ideal control for
 * when there are between 3 and 7 options. If you have one or two options, a checkbox
 * should be used. If you have 7 or more options, then a combobox dropdown should
 * be used instead.
 *
 * RadioGroup extends the `FieldProps`, and will have all the props of a `Field`
 * component.
 */
const RadioGroupBase = ({ autoFocus, children, customDataProps, desired, direction = 'horizontal', disabled, error, inputRef, items, name, readOnly, testId, value, onBlur, onChange, contentLayoutConfig }) => {
    useRestrictedChildType('RadioGroup', ['Radio'], children);
    const ref = React__default.useRef(null);
    const { width } = useSize(ref.current);
    const contentConfig = React__default.useCallback((contentLayoutOverride) => {
        var _a, _b;
        // Use the controlColumnWidth override if provided, otherwise use the group layout controlColumnWidth config
        const columnWidth = (_a = contentLayoutOverride === null || contentLayoutOverride === void 0 ? void 0 : contentLayoutOverride.controlColumnWidth) !== null && _a !== void 0 ? _a : contentLayoutConfig === null || contentLayoutConfig === void 0 ? void 0 : contentLayoutConfig.controlColumnWidth;
        // Use the wrapBreakpoint override if provided, otherwise use the group layout wrapBreakpoint config
        const wrapBreakpoint = (_b = contentLayoutOverride === null || contentLayoutOverride === void 0 ? void 0 : contentLayoutOverride.contentWrapBreakpoint) !== null && _b !== void 0 ? _b : contentLayoutConfig === null || contentLayoutConfig === void 0 ? void 0 : contentLayoutConfig.contentWrapBreakpoint;
        return {
            controlColumnWidth: columnWidth,
            wrapped: wrapBreakpoint && width ? width <= wrapBreakpoint : false
        };
    }, [contentLayoutConfig, width]);
    useADSWarnOnce('RadioGroup: `direction` prop should be set to `vertical` when rendering `Radio` components with both `label` and `renderContent` props.', direction === 'horizontal' && children
        ? React__default.Children.toArray(children).some((child) => React__default.isValidElement(child) &&
            child.props.renderContent &&
            child.props.label)
        : false);
    // Detect if we are in "boolean" mode. This means we have two children
    // with boolean values.
    const [booleanMode] = React__default.useState(() => {
        if (React__default.Children.count(children) === 2) {
            return React__default.Children.toArray(children).every((c) => {
                if (React__default.isValidElement(c)) {
                    return isBoolean(c.props.value);
                }
                return false;
            });
        }
        return false;
    });
    const handleOnChange = (e) => {
        // If we are in boolean mode change value to a boolean
        if (booleanMode) {
            e.target = Object.assign(Object.assign({}, e.target), { value: e.target.value === 'true' });
        }
        onChange && onChange(e);
    };
    const renderChildren = () => {
        return React__default.Children.map(children, (child, index) => {
            var _a, _b;
            if (React__default.isValidElement(child)) {
                const childAutoFocus = match([
                    autoFocus,
                    index,
                    child.props.autoFocus
                ])
                    // if the group has autoFocus set, then the first child should have autoFocus
                    .with([true, 0, P.any], () => true)
                    // if the group has autoFocus set, then all other children should not have autoFocus
                    .with([true, P.any, P.any], () => undefined)
                    // if the group does not have autoFocus set, then use the child's autoFocus
                    .with([P.not(true), P.any, P.any], () => child.props.autoFocus)
                    .exhaustive();
                // Builds the contentConfig for the child.
                const childContentConfig = contentConfig(hasContentLayoutOverride(child.props)
                    ? child.props.contentLayoutOverride
                    : undefined);
                return React__default.cloneElement(child, {
                    autoFocus: childAutoFocus,
                    checked: child.props.value === value,
                    desired,
                    disabled: (_a = child.props.disabled) !== null && _a !== void 0 ? _a : disabled,
                    error,
                    inputRef: index === 0 ? inputRef : undefined,
                    name,
                    readOnly: (_b = child.props.readOnly) !== null && _b !== void 0 ? _b : readOnly,
                    testId: testId ? `${testId}-${child.props.value}` : undefined,
                    onBlur,
                    onChange: handleOnChange,
                    contentConfig: childContentConfig,
                    isLastChild: index === React__default.Children.count(children) - 1
                });
            }
            return child;
        });
    };
    if (items) {
        if (isArray(items)) {
            children = items.map((item, index) => (React__default.createElement(RadioV2, { label: item, autoFocus: index === 0 ? autoFocus : undefined, inputRef: index === 0 ? inputRef : undefined, key: item, value: item })));
        }
        else {
            children = Object.entries(items).map(([name, label], index) => (React__default.createElement(RadioV2, { label: label, autoFocus: index === 0 ? autoFocus : undefined, inputRef: index === 0 ? inputRef : undefined, key: name, value: name })));
        }
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-testid": testId, "data-test": `${testId}Group`, ref: ref, className: cx$d('group', modules_ffc222cf[direction], {
            wrappingEnabled: contentLayoutConfig === null || contentLayoutConfig === void 0 ? void 0 : contentLayoutConfig.contentWrapBreakpoint
        }) }), renderChildren()));
};
const RadioGroupBaseField = withField(RadioGroupBase);
// Version of component that is not controlled. Meaning it will
// keep it's own state. This is the version used if value
// and onChange is not used directly OR by a form.
const UnControlledRadioGroup = (props) => {
    var _a;
    const [value, setValue] = React__default.useState((_a = props.value) !== null && _a !== void 0 ? _a : null);
    return (React__default.createElement(RadioGroupBaseField, Object.assign({}, props, { value: value, onChange: (e) => setValue(e.target.value) })));
};
const StandAloneRadioGroup = withStandAlone(UnControlledRadioGroup, RadioGroupBaseField);
const RadioGroup = withFieldSchemaSupport$1(StandAloneRadioGroup, withFieldSchema(RadioGroupBaseField));

var css$c = ".Section_module_section__a4d51a09{width:100%}.Section_module_section__a4d51a09.Section_module_h1__a4d51a09 .Section_module_body__a4d51a09,.Section_module_section__a4d51a09.Section_module_h1__a4d51a09 .Section_module_body__a4d51a09>.Section_module_h2__a4d51a09:first-child{margin-top:32px}.Section_module_section__a4d51a09.Section_module_h2__a4d51a09{margin-top:48px}.Section_module_section__a4d51a09.Section_module_h2__a4d51a09 .Section_module_body__a4d51a09{margin-top:24px}.Section_module_section__a4d51a09.Section_module_h3__a4d51a09,.Section_module_section__a4d51a09.Section_module_h4__a4d51a09{margin-top:32px}.Section_module_section__a4d51a09.Section_module_h3__a4d51a09 .Section_module_body__a4d51a09,.Section_module_section__a4d51a09.Section_module_h4__a4d51a09 .Section_module_body__a4d51a09{margin-top:16px}.Section_module_section__a4d51a09.Section_module_top__a4d51a09{margin-top:0!important}.Section_module_section__a4d51a09 .Section_module_description__a4d51a09{margin-top:8px}[data-grid-row]:first-of-type .Section_module_h2__a4d51a09{margin-top:0}[data-grid-row] .Section_module_h3__a4d51a09,[data-grid-row] .Section_module_h4__a4d51a09{margin-top:12px}";
window.ADS.injectStyle(css$c,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Section/Section.module.scss");
var modules_b63111ab = {"section":"Section_module_section__a4d51a09","h1":"Section_module_h1__a4d51a09","body":"Section_module_body__a4d51a09","h2":"Section_module_h2__a4d51a09","h3":"Section_module_h3__a4d51a09","h4":"Section_module_h4__a4d51a09","top":"Section_module_top__a4d51a09","description":"Section_module_description__a4d51a09"};

const cx$c = BindStyles(modules_b63111ab);
// Hook for getting next level a section should use. When sections are nested
// they should drop a level like this (H1 -> H2 -> H3 -> H4).
function useGetNextSectionType$1(parent) {
    if (!parent || !parent.type) {
        return SectionTypes.H1;
    }
    // If we aren't passed in a type, and we detect our parent has a type
    // set our type to parent minus one.
    const parentLevel = parseInt(parent.type.slice(-1), 10);
    return `h${Math.min(parentLevel + 1, 4)}`;
}
const TypeMap$1 = {
    [SectionTypes.H1]: {
        titleComp: H1,
        buttonSize: 'md'
    },
    [SectionTypes.H2]: {
        titleComp: H2,
        buttonSize: 'md'
    },
    [SectionTypes.H3]: {
        titleComp: H3,
        buttonSize: 'sm'
    },
    [SectionTypes.H4]: {
        titleComp: H4,
        buttonSize: 'xs'
    }
};
/** @deprecated Use SectionV2 instead as that will provide the correct spacing between sections and their content. This will be removed in ADS V8. */
const SectionV1 = ({ customDataProps, testId, type, className, title, top, contentClassName, description, actionContent, children }) => {
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType$1(parent);
    type = type !== null && type !== void 0 ? type : detectedType;
    const TitleComp = TypeMap$1[type].titleComp;
    // Memorize context value since it's a non stable (object) value
    const contextValue = React__default.useMemo(() => ({ type: type !== null && type !== void 0 ? type : SectionTypes.H1 }), [type]);
    // We accept string or a SectionTitleProp object.
    const titleData = title && typeof title === 'string'
        ? { text: title !== null && title !== void 0 ? title : '' }
        : title;
    return (React__default.createElement("section", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$c('section', { top: top || !parent }, className, type) }),
        (titleData === null || titleData === void 0 ? void 0 : titleData.text) && (React__default.createElement("div", { className: cx$c('title', 'flex-container') },
            React__default.createElement(TitleComp, { className: "flex-item", underline: type === 'h2' && typeof titleData.underline === 'boolean'
                    ? titleData.underline
                    : !actionContent }, titleData === null || titleData === void 0 ? void 0 : titleData.text),
            actionContent && (React__default.createElement("div", null, typeof actionContent === 'function'
                ? actionContent({
                    buttonSize: TypeMap$1[type].buttonSize
                })
                : actionContent)))),
        description && React__default.createElement("div", { className: cx$c('description') }, description),
        React__default.createElement("div", { "data-test": testId ? `${testId}-section-body` : 'section-body', className: cx$c('body', { 'mt-0': !title }, contentClassName) },
            React__default.createElement(SectionContext.Provider, { value: contextValue }, children))));
};
// Utility component that makes making 2up layouts with sections easier. This leverages
// the responsive row and responsive css utility classes to get the spacing right
/** @deprecated Use Section2UpV2 instead as that will provide the correct spacing between sections and their content. This will be removed in ADS V8. */
const Section2UpV1 = ({ customDataProps, testId = 'section2up-v1', left, right, leftColSpan = 6, breakpoint = BreakPoint.XS }) => {
    if (typeof leftColSpan === 'number') {
        leftColSpan = {
            [breakpoint]: leftColSpan
        };
    }
    const breakPointProps = {
        left: leftColSpan,
        right: {}
    };
    for (const bp in breakPointProps.left) {
        const leftValue = breakPointProps.left[bp];
        if (leftValue) {
            breakPointProps.right[bp] = 12 - leftValue;
        }
    }
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType$1(parent);
    // We need additional spacing to handle when we are laying out horizontally
    // vs vertically. By default we assume we are ALWAYS horizontal so need
    // 12px of padding on each side of left and right (i.e. need 48px of col gap
    // (already have 24 plus 12 from each side = 48px)).
    const cssClasses = {
        left: ['pr-75'],
        right: ['pl-75']
    };
    // If the breakpoint is not XS, then we need to change things up. We will need
    // XS breakpoint to be vertical stacking, and whatever breakpoint passed in
    // will set the 2up (i.e. 6 columns).
    if (breakpoint !== BreakPoint.XS) {
        breakPointProps.left[BreakPoint.XS] = 12;
        breakPointProps.right[BreakPoint.XS] = 12;
        // When we are vertically stacked we need no right padding for left section
        // (pr-0), but we do need 12px of padding on the right when laid out horizontally
        // (pr-75).
        cssClasses.left = ['pr-0', `pr-${breakpoint}-75`];
        // If we are going to flip between 2up and vertically stacked,
        // we need to have our spacing adapt. It also has to add it's share of
        // additional col gap when horizontal.
        cssClasses.right = ['pl-0', `pl-${breakpoint}-75`];
        // When vertically stacked we AND we have H2 sections we need 24px more
        // space(mt-150), but that space needs to be removed when laying horizontally
        // (mt-breakpoint-0).
        if (detectedType === SectionTypes.H2) {
            cssClasses.right.push('mt-150', `mt-${breakpoint}-0`);
        }
    }
    return (React__default.createElement(Row, { customDataProps: customDataProps, testId: testId },
        React__default.createElement(Col, Object.assign({}, breakPointProps.left, { className: cx$c(cssClasses.left) }), left),
        React__default.createElement(Col, Object.assign({}, breakPointProps.right, { className: cx$c(cssClasses.right) }), right)));
};
// Utility component that makes making 3up layouts with sections easier. This leverages
// the responsive grid and responsive css utility classes to get the spacing right
/** @deprecated Use Section3UpV2 instead as that will provide the correct spacing between sections and their content. This will be removed in ADS V8. */
const Section3UpV1 = ({ customDataProps, testId = 'section3up-v1', left, center, right, breakpoint = BreakPoint.XS }) => {
    // We start out assuming breakpoint is XS and 2up is wanted all the time.
    const breakPointProps = {
        [BreakPoint.XS]: 4
    };
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType$1(parent);
    // We need additional spacing to handle when we are laying out horizontally
    // vs vertically. By default we assume we are ALWAYS horizontal so need
    // additional 24px of gap (already will have 24px) between left and center, and
    // center and right like this:
    //    [left] -> 24px < -[center] -> 24px < -[right].
    const cssClasses = {
        left: ['pr-75'],
        center: ['px-75'],
        right: ['pl-75']
    };
    // If the breakpoint is not XS, then we need to change things up. We will need
    // XS breakpoint to be vertical stacking, and whatever breakpoint passed in
    // will set the 3up (i.e. 4 columns).
    if (breakpoint !== BreakPoint.XS) {
        breakPointProps[BreakPoint.XS] = 12;
        breakPointProps[breakpoint] = 4;
        // When we are vertically stacked we need no right padding for left section
        // (pr-0), but we do need 12px of padding on the right when laid out horizontally
        // (pr-75).
        cssClasses.left = ['pr-0', `pr-${breakpoint}-75`];
        // Center needs to handle both horizontal and vertical
        cssClasses.center = ['px-0', `px-${breakpoint}-75`];
        // If we are going to flip between 2up and vertically stacked,
        // we need to have our spacing adapt. It also has to add it's share of
        // additional col gap when horizontal.
        cssClasses.right = ['pl-0', `pl-${breakpoint}-75`];
        // When vertically stacked we AND we have H2 sections we need 24px more
        // space(mt-150), but that space needs to be removed when laying horizontally
        // (mt-breakpoint-0).
        if (detectedType === SectionTypes.H2) {
            cssClasses.center.push('mt-150', `mt-${breakpoint}-0`);
            cssClasses.right.push('mt-150', `mt-${breakpoint}-0`);
        }
    }
    return (React__default.createElement(Row, { customDataProps: customDataProps, testId: testId },
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$c(cssClasses.left) }), left),
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$c(cssClasses.center) }), center),
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$c(cssClasses.right) }), right)));
};

var css$b = ".SectionV2_module_section__9bd9168a{width:100%}.SectionV2_module_section__9bd9168a.SectionV2_module_top__9bd9168a{margin-top:0!important}.SectionV2_module_section__9bd9168a .SectionV2_module_description__9bd9168a{margin-top:8px}.SectionV2_module_title__9bd9168a{align-items:flex-start;display:flex;justify-content:space-between;width:100%}.SectionV2_module_title__9bd9168a.SectionV2_module_truncated__9bd9168a .SectionV2_module_titleContent__9bd9168a{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.SectionV2_module_title__9bd9168a:not(.SectionV2_module_truncated__9bd9168a){flex-wrap:wrap}.SectionV2_module_title__9bd9168a:not(.SectionV2_module_truncated__9bd9168a) .SectionV2_module_titleContent__9bd9168a{min-width:auto;overflow:visible}.SectionV2_module_titleContent__9bd9168a{flex:1;min-width:0}.SectionV2_module_sectionTitleText__9bd9168a{max-width:100%}.SectionV2_module_actionContentWrapper__9bd9168a{align-items:flex-start;display:flex;flex-shrink:0;margin-left:24px}.SectionV2_module_actionContentWrapper__9bd9168a.SectionV2_module_actionContentWrapperH1__9bd9168a{padding-top:2px}.SectionV2_module_h1__9bd9168a{margin-top:0}.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a{margin-top:32px}[data-grid-row]:has(.SectionV2_module_h1__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h1__9bd9168a:first-child) .SectionV2_module_h1__9bd9168a{margin-top:-32px}[class~=flex-container]>[data-grid-row]:has(.SectionV2_module_h1__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h1__9bd9168a:first-child) .SectionV2_module_h1__9bd9168a{margin-top:-56px}[class~=flex-container]:not([data-grid-row] [class~=flex-container])>.SectionV2_module_h1__9bd9168a:not(:first-child){margin-top:-24px}[class~=flex-container]>.SectionV2_module_h1__9bd9168a:not(:only-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:8px}[class~=flex-container]>.SectionV2_module_h1__9bd9168a:only-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:0}[class~=flex-container]>[data-grid-row]:not(:only-child) .SectionV2_module_h1__9bd9168a:not(:first-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:8px}[class~=flex-container]>[data-grid-row]:not(:first-child) .SectionV2_module_h1__9bd9168a:first-child,[data-grid-row] [class~=flex-container]>.SectionV2_module_h1__9bd9168a:not(:first-child){margin-top:-24px}[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h1__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h1__9bd9168a:first-child) .SectionV2_module_h1__9bd9168a{margin-top:0}[class~=flex-container]>.SectionV2_module_h1__9bd9168a:has(>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+.SectionV2_module_h1__9bd9168a{margin-top:-32px}.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a>.SectionV2_module_h2__9bd9168a:first-child{margin-top:32px}.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a [data-grid-row]:first-of-type .SectionV2_module_h2__9bd9168a:first-child,.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:first-child>[class~=flex-container]:first-child>.SectionV2_module_h2__9bd9168a:first-child,.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:not([data-grid-row]:first-child [class~=flex-container])>.SectionV2_module_h2__9bd9168a:first-child,.SectionV2_module_h1__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]>.SectionV2_module_h2__9bd9168a:first-child{margin-top:0}.SectionV2_module_h2__9bd9168a{margin-top:48px}.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a{margin-top:24px}[data-grid-row]:has(.SectionV2_module_h2__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h2__9bd9168a:first-child) .SectionV2_module_h2__9bd9168a{margin-top:24px}[class~=flex-container]>[data-grid-row]:has(.SectionV2_module_h2__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h2__9bd9168a:first-child) .SectionV2_module_h2__9bd9168a{margin-top:0}[class~=flex-container]:not([data-grid-row] [class~=flex-container])>.SectionV2_module_h2__9bd9168a:not(:first-child){margin-top:24px}[class~=flex-container]>.SectionV2_module_h2__9bd9168a:not(:only-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a,[class~=flex-container]>.SectionV2_module_h2__9bd9168a:only-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a,[class~=flex-container]>[data-grid-row]:not(:only-child) .SectionV2_module_h2__9bd9168a:not(:first-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:0}[class~=flex-container]>[data-grid-row]:not(:first-child) .SectionV2_module_h2__9bd9168a:first-child,[data-grid-row] [class~=flex-container]>.SectionV2_module_h2__9bd9168a:not(:first-child){margin-top:24px}[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h2__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h2__9bd9168a:first-child) .SectionV2_module_h2__9bd9168a{margin-top:48px}[class~=flex-container]>.SectionV2_module_h2__9bd9168a:has(>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+.SectionV2_module_h2__9bd9168a{margin-top:24px}.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a>.SectionV2_module_h3__9bd9168a:first-child{margin-top:32px}.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a [data-grid-row]:first-of-type .SectionV2_module_h3__9bd9168a:first-child,.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:first-child>[class~=flex-container]:first-child>.SectionV2_module_h3__9bd9168a:first-child,.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:not([data-grid-row]:first-child [class~=flex-container])>.SectionV2_module_h3__9bd9168a:first-child,.SectionV2_module_h2__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]>.SectionV2_module_h3__9bd9168a:first-child{margin-top:8px}.SectionV2_module_h3__9bd9168a{margin-top:32px}.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a{margin-top:16px}[data-grid-row]:has(.SectionV2_module_h3__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h3__9bd9168a:first-child) .SectionV2_module_h3__9bd9168a{margin-top:16px}[class~=flex-container]>[data-grid-row]:has(.SectionV2_module_h3__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h3__9bd9168a:first-child) .SectionV2_module_h3__9bd9168a{margin-top:-8px}[class~=flex-container]:not([data-grid-row] [class~=flex-container])>.SectionV2_module_h3__9bd9168a:not(:first-child){margin-top:8px}[class~=flex-container]>.SectionV2_module_h3__9bd9168a:not(:only-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:-8px}[class~=flex-container]>.SectionV2_module_h3__9bd9168a:only-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:0}[class~=flex-container]>[data-grid-row]:not(:only-child) .SectionV2_module_h3__9bd9168a:not(:first-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:-8px}[class~=flex-container]>[data-grid-row]:not(:first-child) .SectionV2_module_h3__9bd9168a:first-child,[data-grid-row] [class~=flex-container]>.SectionV2_module_h3__9bd9168a:not(:first-child){margin-top:8px}[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h3__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h3__9bd9168a:first-child) .SectionV2_module_h3__9bd9168a{margin-top:32px}[class~=flex-container]>.SectionV2_module_h3__9bd9168a:has(>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+.SectionV2_module_h3__9bd9168a{margin-top:16px}.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a>.SectionV2_module_h4__9bd9168a:first-child{margin-top:32px}.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a [data-grid-row]:first-of-type .SectionV2_module_h4__9bd9168a:first-child,.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:first-child>[class~=flex-container]:first-child>.SectionV2_module_h4__9bd9168a:first-child,.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]:not([data-grid-row]:first-child [class~=flex-container])>.SectionV2_module_h4__9bd9168a:first-child,.SectionV2_module_h3__9bd9168a .SectionV2_module_body__9bd9168a>[class~=flex-container]>.SectionV2_module_h4__9bd9168a:first-child{margin-top:16px}.SectionV2_module_h4__9bd9168a{margin-top:32px}.SectionV2_module_h4__9bd9168a .SectionV2_module_body__9bd9168a{margin-top:16px}[data-grid-row]:has(.SectionV2_module_h4__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h4__9bd9168a:first-child) .SectionV2_module_h4__9bd9168a{margin-top:16px}[class~=flex-container]>[data-grid-row]:has(.SectionV2_module_h4__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has(.SectionV2_module_h4__9bd9168a:first-child) .SectionV2_module_h4__9bd9168a{margin-top:-8px}[class~=flex-container]:not([data-grid-row] [class~=flex-container])>.SectionV2_module_h4__9bd9168a:not(:first-child){margin-top:8px}[class~=flex-container]>.SectionV2_module_h4__9bd9168a:not(:only-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:-8px}[class~=flex-container]>.SectionV2_module_h4__9bd9168a:only-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:0}[class~=flex-container]>[data-grid-row]:not(:only-child) .SectionV2_module_h4__9bd9168a:not(:first-child)>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a{margin-top:-8px}[class~=flex-container]>[data-grid-row]:not(:first-child) .SectionV2_module_h4__9bd9168a:first-child,[data-grid-row] [class~=flex-container]>.SectionV2_module_h4__9bd9168a:not(:first-child){margin-top:8px}[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h4__9bd9168a:last-child>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+[data-grid-row]:has([class~=flex-container]>.SectionV2_module_h4__9bd9168a:first-child) .SectionV2_module_h4__9bd9168a{margin-top:32px}[class~=flex-container]>.SectionV2_module_h4__9bd9168a:has(>.SectionV2_module_body__9bd9168a.SectionV2_module_empty__9bd9168a)+.SectionV2_module_h4__9bd9168a{margin-top:16px}.SectionV2_module_mt_50__9bd9168a{margin-top:-8px}";
window.ADS.injectStyle(css$b,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Section/SectionV2.module.scss");
var modules_0a559741 = {"section":"SectionV2_module_section__9bd9168a","top":"SectionV2_module_top__9bd9168a","description":"SectionV2_module_description__9bd9168a","title":"SectionV2_module_title__9bd9168a","truncated":"SectionV2_module_truncated__9bd9168a","title-content":"SectionV2_module_titleContent__9bd9168a","section-title-text":"SectionV2_module_sectionTitleText__9bd9168a","action-content-wrapper":"SectionV2_module_actionContentWrapper__9bd9168a","action-content-wrapper-h1":"SectionV2_module_actionContentWrapperH1__9bd9168a","h1":"SectionV2_module_h1__9bd9168a","body":"SectionV2_module_body__9bd9168a","empty":"SectionV2_module_empty__9bd9168a","h2":"SectionV2_module_h2__9bd9168a","h3":"SectionV2_module_h3__9bd9168a","h4":"SectionV2_module_h4__9bd9168a","mt--50":"SectionV2_module_mt_50__9bd9168a"};

const cx$b = BindStyles(modules_0a559741);
// Hook for getting next level a section should use. When sections are nested
// they should drop a level like this (H1 -> H2 -> H3 -> H4).
function useGetNextSectionType(parent) {
    if (!parent || !parent.type) {
        return SectionTypes.H1;
    }
    // If we aren't passed in a type, and we detect our parent has a type
    // set our type to parent minus one.
    const parentLevel = parseInt(parent.type.slice(-1), 10);
    return `h${Math.min(parentLevel + 1, 4)}`;
}
const TypeMap = {
    [SectionTypes.H1]: {
        titleComp: H1Base,
        buttonSize: 'md'
    },
    [SectionTypes.H2]: {
        titleComp: H2Base,
        buttonSize: 'md'
    },
    [SectionTypes.H3]: {
        titleComp: H3Base,
        buttonSize: 'sm'
    },
    [SectionTypes.H4]: {
        titleComp: H4Base,
        buttonSize: 'xs'
    }
};
const Section = ({ actionContent, children, className, contentClassName, customDataProps, description, testId, title, top, type, truncateTitle = false // Default to the original behavior
 }) => {
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType(parent);
    type = type !== null && type !== void 0 ? type : detectedType;
    const TitleComp = TypeMap[type].titleComp;
    // Memorize context value since it's a non stable (object) value
    const contextValue = React__default.useMemo(() => ({ type: type !== null && type !== void 0 ? type : SectionTypes.H1 }), [type]);
    // We accept undefined, a string, or a SectionTitleProp object.
    const titleData = match(title)
        .with(P.nullish, () => undefined)
        .with(P.string, (title) => ({ text: title }))
        .otherwise((title) => title);
    const hasActionContent = !!actionContent;
    return (React__default.createElement("section", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, className: cx$b('section', { top: top || !parent }, className, type) }),
        (titleData === null || titleData === void 0 ? void 0 : titleData.text) && (React__default.createElement("div", { className: cx$b('title', { truncated: truncateTitle }) },
            React__default.createElement("div", { className: cx$b('title-content') },
                React__default.createElement(TitleComp, { className: cx$b('section-title-text'), testId: TestIdUtils.composeId(testId, 'title'), helpText: titleData.tooltip, badges: titleData.badgeProps, truncateTitle: truncateTitle, underline: titleData.underline, hasActionContent: hasActionContent }, titleData.text)),
            actionContent && (React__default.createElement("div", { className: cx$b('action-content-wrapper', {
                    'action-content-wrapper-h1': type === 'h1'
                }) }, typeof actionContent === 'function'
                ? actionContent({
                    buttonSize: TypeMap[type].buttonSize
                })
                : actionContent)))),
        description && (React__default.createElement("div", { className: cx$b('description'), "data-test": testId ? `${testId}-section-description` : 'section-description' }, description)),
        React__default.createElement("div", { "data-test": testId ? `${testId}-section-body` : 'section-body', className: cx$b('body', { 'mt-0': !title, empty: !children }, contentClassName) },
            React__default.createElement(SectionContext.Provider, { value: contextValue }, children))));
};
// Utility component that makes making 2up layouts with sections easier. This leverages
// the responsive row and responsive css utility classes to get the spacing right
const Section2Up = ({ left, right, leftColSpan = 6, breakpoint = BreakPoint.XS, customDataProps, testId }) => {
    if (typeof leftColSpan === 'number') {
        leftColSpan = {
            [breakpoint]: leftColSpan
        };
    }
    const breakPointProps = {
        left: leftColSpan,
        right: {}
    };
    for (const bp in breakPointProps.left) {
        const leftValue = breakPointProps.left[bp];
        if (leftValue) {
            breakPointProps.right[bp] = 12 - leftValue;
        }
    }
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType(parent);
    // We need additional spacing to handle when we are laying out horizontally
    // vs vertically. By default we assume we are ALWAYS horizontal so need
    // 12px of padding on each side of left and right (i.e. need 48px of col gap
    // (already have 24 plus 12 from each side = 48px)).
    const cssClasses = {
        left: ['pr-75'],
        right: ['pl-75']
    };
    // If the breakpoint is not XS, then we need to change things up. We will need
    // XS breakpoint to be vertical stacking, and whatever breakpoint passed in
    // will set the 2up (i.e. 6 columns).
    if (breakpoint !== BreakPoint.XS) {
        breakPointProps.left[BreakPoint.XS] = 12;
        breakPointProps.right[BreakPoint.XS] = 12;
        // When we are vertically stacked we need no right padding for left section
        // (pr-0), but we do need 12px of padding on the right when laid out horizontally
        // (pr-75).
        cssClasses.left = ['pr-0', `pr-${breakpoint}-75`];
        // If we are going to flip between 2up and vertically stacked,
        // we need to have our spacing adapt. It also has to add it's share of
        // additional col gap when horizontal.
        cssClasses.right = ['pl-0', `pl-${breakpoint}-75`];
        // When vertically stacked we AND we have H2 sections we need 24px more
        // space(mt-150), but that space needs to be removed when laying horizontally
        // (mt-breakpoint-0).
        if (detectedType === SectionTypes.H2) {
            cssClasses.right.push('mt-150', `mt-${breakpoint}-0`);
        }
        else if (detectedType === SectionTypes.H4) {
            cssClasses.right.push('mt--50', `mt-${breakpoint}-0`);
        }
    }
    return (React__default.createElement(Row, { customDataProps: Object.assign(Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {})), { 'data-ads-component-type': 'section2Up' }), testId: testId },
        React__default.createElement(Col, Object.assign({}, breakPointProps.left, { className: cx$b(cssClasses.left) }), left),
        React__default.createElement(Col, Object.assign({}, breakPointProps.right, { className: cx$b(cssClasses.right) }), right)));
};
// Utility component that makes making 3up layouts with sections easier. This leverages
// the responsive grid and responsive css utility classes to get the spacing right
const Section3Up = ({ left, center, right, breakpoint = BreakPoint.XS, customDataProps, testId }) => {
    // We start out assuming breakpoint is XS and 2up is wanted all the time.
    const breakPointProps = {
        [BreakPoint.XS]: 4
    };
    const parent = React__default.useContext(SectionContext);
    const detectedType = useGetNextSectionType(parent);
    // We need additional spacing to handle when we are laying out horizontally
    // vs vertically. By default we assume we are ALWAYS horizontal so need
    // additional 24px of gap (already will have 24px) between left and center, and
    // center and right like this:
    //    [left] -> 24px < -[center] -> 24px < -[right].
    const cssClasses = {
        left: ['pr-75'],
        center: ['px-75'],
        right: ['pl-75']
    };
    // If the breakpoint is not XS, then we need to change things up. We will need
    // XS breakpoint to be vertical stacking, and whatever breakpoint passed in
    // will set the 3up (i.e. 4 columns).
    if (breakpoint !== BreakPoint.XS) {
        breakPointProps[BreakPoint.XS] = 12;
        breakPointProps[breakpoint] = 4;
        // When we are vertically stacked we need no right padding for left section
        // (pr-0), but we do need 12px of padding on the right when laid out horizontally
        // (pr-75).
        cssClasses.left = ['pr-0', `pr-${breakpoint}-75`];
        // Center needs to handle both horizontal and vertical
        cssClasses.center = ['px-0', `px-${breakpoint}-75`];
        // If we are going to flip between 2up and vertically stacked,
        // we need to have our spacing adapt. It also has to add it's share of
        // additional col gap when horizontal.
        cssClasses.right = ['pl-0', `pl-${breakpoint}-75`];
        // When vertically stacked we AND we have H2 sections we need 24px more
        // space(mt-150), but that space needs to be removed when laying horizontally
        // (mt-breakpoint-0).
        if (detectedType === SectionTypes.H2) {
            cssClasses.center.push('mt-150', `mt-${breakpoint}-0`);
            cssClasses.right.push('mt-150', `mt-${breakpoint}-0`);
        }
        else if (detectedType === SectionTypes.H4) {
            cssClasses.center.push('mt--50', `mt-${breakpoint}-0`);
            cssClasses.right.push('mt--50', `mt-${breakpoint}-0`);
        }
    }
    return (React__default.createElement(Row, { customDataProps: Object.assign(Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {})), { 'data-ads-component-type': 'section3Up' }), testId: testId },
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$b(cssClasses.left) }), left),
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$b(cssClasses.center) }), center),
        React__default.createElement(Col, Object.assign({}, breakPointProps, { className: cx$b(cssClasses.right) }), right)));
};

var css$a = ".Skeleton_module_skeleton__fa74f26f{display:flex;flex-direction:column;gap:4px}.Skeleton_module_skeleton__fa74f26f .Skeleton_module_label__fa74f26f{width:75px}";
window.ADS.injectStyle(css$a,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Skeleton/Skeleton.module.scss");
var modules_1fe82d8f = {"skeleton":"Skeleton_module_skeleton__fa74f26f","label":"Skeleton_module_label__fa74f26f"};

const cx$a = classnames.bind(modules_1fe82d8f);
/**
 * `LabeledSkeleton` is a basic skeleton component for a labeled field.  It will stretch
 * to the width of its parent container
 */
const LabeledSkeleton = ({ customDataProps, height, showLabel = true, className, testId, wrapperClassName }) => (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: cx$a('skeleton', wrapperClassName), "data-test": testId }),
    showLabel && (React__default.createElement("div", { className: cx$a('label') },
        React__default.createElement(SkeletonLoader, { height: 20, testId: testId && `${testId}-label` }))),
    React__default.createElement(SkeletonLoader, { height: height, className: className, testId: testId && `${testId}-field` })));

const FieldSkeleton = ({ customDataProps, className, testId, height = 32, showLabel = true, wrapperClassName }) => (React__default.createElement(LabeledSkeleton, { customDataProps: customDataProps, height: height, showLabel: showLabel, className: className, testId: testId, wrapperClassName: wrapperClassName }));

/**
 * `TextAreaSkeleton` is a basic skeleton component for a labeled textarea.  It will stretch
 * to the width of its parent container
 */
const TextAreaSkeleton = ({ customDataProps, height = 52, className, testId, showLabel = true }) => (React__default.createElement(LabeledSkeleton, { customDataProps: customDataProps, height: height, className: className, showLabel: showLabel, testId: testId }));

var css$9 = ".Sticky_module_sticky__a8cccb1d{background:#fff;margin-left:-32px;margin-right:-32px;padding:24px 32px;position:sticky;z-index:500}.Sticky_module_sticky__a8cccb1d .Sticky_module_shadowContainer__a8cccb1d{position:relative}.Sticky_module_sticky__a8cccb1d.Sticky_module_top__a8cccb1d{margin-top:-32px;padding-top:32px;top:-32px}.Sticky_module_sticky__a8cccb1d.Sticky_module_top__a8cccb1d .Sticky_module_shadowContainer__a8cccb1d{bottom:-24px}.Sticky_module_sticky__a8cccb1d.Sticky_module_bottom__a8cccb1d{bottom:-32px;margin-bottom:-32px;padding-bottom:32px}.Sticky_module_sticky__a8cccb1d.Sticky_module_bottom__a8cccb1d .Sticky_module_shadowContainer__a8cccb1d{top:-24px}";
window.ADS.injectStyle(css$9,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Sticky/Sticky.module.scss");
var modules_9edb0a3b = {"sticky":"Sticky_module_sticky__a8cccb1d","shadow-container":"Sticky_module_shadowContainer__a8cccb1d","top":"Sticky_module_top__a8cccb1d","bottom":"Sticky_module_bottom__a8cccb1d"};

const cx$9 = classnames.bind(modules_9edb0a3b);
var StickyPlacement;
(function (StickyPlacement) {
    StickyPlacement["Bottom"] = "bottom";
    StickyPlacement["Top"] = "top";
})(StickyPlacement || (StickyPlacement = {}));
const Sticky = ({ customDataProps, testId, placement = StickyPlacement.Bottom, className, children }) => {
    // We need to have access to our parent / grandparent container element so we can
    // monitor it's scroll situation to know when to show / hide scroll shadows. We could
    // have used a context from the container but context can easily cause over re-rendering
    // so trying to avoid sending data that will frequently change like scroll info.
    const [containerEl, setContainerEl] = React__default.useState(null);
    const { hasScroll, isAtBottom, isAtTop } = useScrollPosition(containerEl);
    const ref = React__default.useRef(null);
    React__default.useEffect(() => {
        var _a;
        const container = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.closest('[data-grid-container="true"]');
        if (!container) {
            ADSWarn('Sticky component could not find a parent Container component. Make sure your Sticky component is a child of the Container component.');
        }
        setContainerEl(container);
    }, []);
    // We show the bottom shadow when all the following conditions are met:
    // - sticky is placed at the bottom
    // - container has a scrollbar
    // - container's scroll bar is not at the bottom
    const showBottomShadow = placement === StickyPlacement.Bottom && hasScroll && !isAtBottom;
    // We show the bottom shadow when all the following conditions are met:
    // - sticky is placed at the top
    // - container has a scrollbar
    // - container's scroll bar is not at the top
    const showTopShadow = placement === StickyPlacement.Top && hasScroll && !isAtTop;
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, ref: ref, className: cx$9('sticky', placement, className) }),
        showBottomShadow && (React__default.createElement("div", { className: cx$9('shadow-container') },
            React__default.createElement(ScrollShadow, { testId: `${testId}_bottomScrollShadow`, position: "bottom", visible: true }))),
        children,
        showTopShadow && (React__default.createElement("div", { className: cx$9('shadow-container') },
            React__default.createElement(ScrollShadow, { testId: `${testId}_topScrollShadow`, position: "top", visible: true })))));
};
const StickyHeader = (_a) => {
    var { testId, customDataProps } = _a, props = __rest(_a, ["testId", "customDataProps"]);
    return (React__default.createElement(Sticky, Object.assign({ testId: testId, customDataProps: customDataProps, placement: StickyPlacement.Top }, props)));
};
StickyHeader.displayName = 'StickyHeader';
const StickyFooter = (_a) => {
    var { testId, customDataProps } = _a, props = __rest(_a, ["testId", "customDataProps"]);
    return (React__default.createElement(Sticky, Object.assign({ testId: testId, customDataProps: customDataProps, placement: StickyPlacement.Bottom }, props)));
};
StickyFooter.displayName = 'StickyFooter';

var css$8 = ".Tab_module_dropdownTab__fd43fcfb,.Tab_module_tab__fd43fcfb{background-color:#f5f5f7;color:#6a6f82;cursor:pointer;display:flex;font-weight:700;height:48px;padding:0 24px;position:relative;transition:color .15s cubic-bezier(.25,.25,.25,1),background-color .15s cubic-bezier(.25,.25,.25,1);user-select:none;white-space:nowrap}.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover,.Tab_module_tab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_tab__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover{background-color:#e3eafc;color:#365ef6}.Tab_module_dropdownTab__fd43fcfb:focus,.Tab_module_tab__fd43fcfb:focus{outline:none}.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_tab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active{background-color:#d5e1fb}.Tab_module_dropdownTab__fd43fcfb:focus-visible:after,.Tab_module_tab__fd43fcfb:focus-visible:after{border:1px solid #365ef6;border-radius:3px;bottom:-1px;box-shadow:0 0 0 3px #365ef64d;content:\"\";left:0;pointer-events:none;position:absolute;right:0;top:0;z-index:10}.Tab_module_active__fd43fcfb.Tab_module_dropdownTab__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_active__fd43fcfb{color:#365ef6;cursor:default}.Tab_module_active__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:after,.Tab_module_tab__fd43fcfb.Tab_module_active__fd43fcfb:after{border-bottom:4px solid #365ef6;bottom:0;content:\"\";left:0;position:absolute;right:0}.Tab_module_success__fd43fcfb.Tab_module_dropdownTab__fd43fcfb,.Tab_module_success__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_success__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover,.Tab_module_tab__fd43fcfb.Tab_module_success__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_success__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_tab__fd43fcfb.Tab_module_success__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover{color:#02785f}.Tab_module_success__fd43fcfb.Tab_module_dropdownTab__fd43fcfb .Tab_module_icon__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_success__fd43fcfb .Tab_module_icon__fd43fcfb{margin-right:4px;opacity:1;width:20px}.Tab_module_success__fd43fcfb.Tab_module_active__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:after,.Tab_module_tab__fd43fcfb.Tab_module_success__fd43fcfb.Tab_module_active__fd43fcfb:after{border-bottom-color:#03866a}.Tab_module_error__fd43fcfb.Tab_module_dropdownTab__fd43fcfb,.Tab_module_error__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_error__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover,.Tab_module_tab__fd43fcfb.Tab_module_error__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_error__fd43fcfb:not(.Tab_module_active__fd43fcfb):active,.Tab_module_tab__fd43fcfb.Tab_module_error__fd43fcfb:not(.Tab_module_active__fd43fcfb):hover{color:#d80936}.Tab_module_error__fd43fcfb.Tab_module_dropdownTab__fd43fcfb .Tab_module_icon__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_error__fd43fcfb .Tab_module_icon__fd43fcfb{margin-right:4px;opacity:1;width:20px}.Tab_module_error__fd43fcfb.Tab_module_active__fd43fcfb.Tab_module_dropdownTab__fd43fcfb:after,.Tab_module_tab__fd43fcfb.Tab_module_error__fd43fcfb.Tab_module_active__fd43fcfb:after{border-bottom-color:#ea0a3b}.Tab_module_tab__fd43fcfb.Tab_module_unvalidated__fd43fcfb,.Tab_module_unvalidated__fd43fcfb.Tab_module_dropdownTab__fd43fcfb{padding:0 36px}.Tab_module_disabled__fd43fcfb.Tab_module_dropdownTab__fd43fcfb,.Tab_module_tab__fd43fcfb.Tab_module_disabled__fd43fcfb{background-color:#f5f5f7!important;color:#b0b4bf!important;cursor:default;pointer-events:none}.Tab_module_snugTab__fd43fcfb{padding:0 16px}.Tab_module_snugTab__fd43fcfb.Tab_module_unvalidated__fd43fcfb{padding:0 28px}.Tab_module_scrollMargin__fd43fcfb{scroll-margin:0 48px}.Tab_module_dropdownTabContainer__fd43fcfb{display:flex}.Tab_module_dropdownTab__fd43fcfb{align-items:center;background:none;display:flex;height:32px;justify-content:flex-start}.Tab_module_dropdownTab__fd43fcfb.Tab_module_disabled__fd43fcfb{background:none!important}.Tab_module_dropdownTab__fd43fcfb:not(.Tab_module_activeDropdownTab__fd43fcfb):hover{background:unset;color:#6a6f82}.Tab_module_activeDropdownTab__fd43fcfb{background-color:#e3eafc;color:#365ef6}.Tab_module_icon__fd43fcfb{display:flex;flex:1;flex-direction:column;justify-content:center;margin:0;opacity:0;transition:opacity .15s cubic-bezier(.25,.25,.25,1);width:0}.Tab_module_label__fd43fcfb{display:flex;flex-direction:column;font-weight:700;justify-content:center}";
window.ADS.injectStyle(css$8,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Tabs/Tab.module.scss");
var modules_da373891 = {"tab":"Tab_module_tab__fd43fcfb","dropdownTab":"Tab_module_dropdownTab__fd43fcfb","active":"Tab_module_active__fd43fcfb","success":"Tab_module_success__fd43fcfb","icon":"Tab_module_icon__fd43fcfb","error":"Tab_module_error__fd43fcfb","unvalidated":"Tab_module_unvalidated__fd43fcfb","disabled":"Tab_module_disabled__fd43fcfb","snugTab":"Tab_module_snugTab__fd43fcfb","scrollMargin":"Tab_module_scrollMargin__fd43fcfb","dropdownTabContainer":"Tab_module_dropdownTabContainer__fd43fcfb","activeDropdownTab":"Tab_module_activeDropdownTab__fd43fcfb","label":"Tab_module_label__fd43fcfb"};

const cx$8 = classnames.bind(modules_da373891);
const ALL_NON_ALPHANUMERIC_REGEX = /[^a-zA-Z0-9]/gi;
const Tab = React__default.forwardRef(({ customDataProps, title, tabKey, tooltip, disabled = false, testId, tabClassName, active = false, isKeyboardFocusable = false, validationOn, validationState, onClick, onUnmount }, ref) => {
    // We need to track our prev active status so we know when we gain / lose activation.
    const prevActiveRef = React__default.useRef(false);
    // We maybe passed a validationState that is a string (enum) or a return
    // of the useGetFormSectionStatus hook.
    let onTabDeactivated;
    if (validationState && typeof validationState !== 'string') {
        onTabDeactivated = validationState.onBlur;
        validationState = validationState.status;
    }
    const handleMouseDown = (e) => {
        // Focus fires before click, so we need to prevent the event
        // from changing focus if we want to ignore clicks (active or disabled).
        // Mousedown is the earliest event in the sequence of events.
        if (active || disabled) {
            e.preventDefault();
        }
    };
    const handleClick = () => {
        onClick && onClick(tabKey);
    };
    const onDeactivation = () => {
        onTabDeactivated && onTabDeactivated();
    };
    // Track when we gain or lose activation.
    React__default.useEffect(() => {
        if (active !== prevActiveRef.current) {
            if (!active) {
                onDeactivation();
            }
            prevActiveRef.current = active;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
    // Unmount
    React__default.useEffect(() => {
        return () => onUnmount && onUnmount(tabKey);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const tabElement = (React__default.createElement("div", Object.assign({ ref: ref, id: `tab-${title
            .replace(ALL_NON_ALPHANUMERIC_REGEX, '')
            .toLowerCase()}-tabKey-${tabKey}`, tabIndex: isKeyboardFocusable ? 0 : -1, className: cx$8('tab', { active }, { disabled }, {
            unvalidated: validationOn &&
                (!validationState || validationState === FormValidationState.None)
        }, { error: validationState === FormValidationState.Error }, { success: validationState === FormValidationState.Success }, tabClassName) }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), (testId && { 'data-test': testId }), { onMouseDown: handleMouseDown, onClick: handleClick }),
        validationOn && (React__default.createElement("div", { className: cx$8('icon') },
            validationState === FormValidationState.Success && (React__default.createElement(Icon, { icon: "SuccessIconFilled", size: 20 })),
            validationState === FormValidationState.Error && (React__default.createElement(Icon, { icon: "ErrorIconFilled", size: 20 })))),
        React__default.createElement("div", { className: modules_da373891.label }, title)));
    return disabled && tooltip ? (React__default.createElement(Tooltip, Object.assign({}, tooltip, { className: cx$8(tooltip.className) }), tabElement)) : (tabElement);
});
Tab.displayName = 'Tab'; // used for type validation in TabGroup

var css$7 = ".TabContent_module_tabContent__201796e1{display:none}.TabContent_module_tabContent__201796e1.TabContent_module_isActive__201796e1{display:block}";
window.ADS.injectStyle(css$7,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Tabs/TabContent.module.scss");
var modules_56ed7ac1 = {"tabContent":"TabContent_module_tabContent__201796e1","isActive":"TabContent_module_isActive__201796e1"};

const cx$7 = BindStyles(modules_56ed7ac1);
const TabContent = ({ isActive, testId, focusChildren = false, className, children }) => {
    const ref = React__default.useRef(null);
    const focusFirstChild = () => {
        if (ref.current) {
            const focusableChildren = GetAllFocusableElements(ref.current);
            if (focusableChildren[0]) {
                focusableChildren[0].focus();
            }
        }
    };
    // If any our children are focusable, focus the first one, anytime our content
    // changes.
    React__default.useEffect(() => {
        if (isActive && focusChildren) {
            setTimeout(() => focusFirstChild(), 0);
        }
    }, [focusChildren, isActive, children]);
    return (React__default.createElement("div", { "data-test": testId, ref: ref, className: cx$7('tabContent', className, { isActive }) }, typeof children === 'function' ? children({ isActive }) : children));
};

var css$6 = ".TabGroup_module_tabGroupWrapper__35d4acb6{max-width:100%}.TabGroup_module_tabGroup__35d4acb6{outline:none}.TabGroup_module_scrollableTabGroupContainer__35d4acb6{align-items:center;display:flex;position:relative}.TabGroup_module_scrollableTabGroup__35d4acb6{display:flex;margin:-4px;overflow-x:hidden;padding:4px;scroll-behavior:smooth;white-space:nowrap}.TabGroup_module_scrollableTabButton__35d4acb6{align-items:center;background-color:#f5f5f7;cursor:pointer;display:flex;height:48px;justify-content:center;margin-bottom:32px;min-width:48px;z-index:1}.TabGroup_module_scrollableTabButton__35d4acb6:hover{background-color:#e3eafc;color:#365ef6}.TabGroup_module_scrollableTabButton__35d4acb6:active{background-color:#d5e1fb;color:#365ef6}.TabGroup_module_scrollableTabButton__35d4acb6:focus{border:1px solid #365ef6!important;border-radius:3px;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.TabGroup_module_scrollableTabButtonLeft__35d4acb6{left:-4px;position:absolute;top:0}.TabGroup_module_scrollableTabButtonRight__35d4acb6{position:absolute;right:-4px;top:0}.TabGroup_module_scrollableTabButtonLeft__35d4acb6:before{background:linear-gradient(90deg,#36384066 -40%,#36384040 0,#36384000);content:\"\";height:100%;pointer-events:none;position:absolute;right:-20%;width:20%;z-index:-1}.TabGroup_module_scrollableTabButtonRight__35d4acb6:before{background:linear-gradient(270deg,#36384066 -40%,#36384040 0,#36384000);content:\"\";height:100%;left:-20%;pointer-events:none;position:absolute;width:20%;z-index:-1}.TabGroup_module_scrollableTabButtonIcon__35d4acb6{align-items:center;display:flex;pointer-events:none;z-index:2}.TabGroup_module_tabHeaders__35d4acb6{background-clip:content-box;background-color:#f5f5f7;display:flex;margin-bottom:32px}.TabGroup_module_dropdownItem__35d4acb6{background-color:#f5f5f7;cursor:pointer;height:48px}.TabGroup_module_dropdownItem__35d4acb6:hover{background-color:#e3eafc;color:#365ef6}";
window.ADS.injectStyle(css$6,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Tabs/TabGroup.module.scss");
var modules_aa1c7ff8 = {"tabGroupWrapper":"TabGroup_module_tabGroupWrapper__35d4acb6","tabGroup":"TabGroup_module_tabGroup__35d4acb6","scrollableTabGroupContainer":"TabGroup_module_scrollableTabGroupContainer__35d4acb6","scrollableTabGroup":"TabGroup_module_scrollableTabGroup__35d4acb6","scrollableTabButton":"TabGroup_module_scrollableTabButton__35d4acb6","scrollableTabButtonLeft":"TabGroup_module_scrollableTabButtonLeft__35d4acb6","scrollableTabButtonRight":"TabGroup_module_scrollableTabButtonRight__35d4acb6","scrollableTabButtonIcon":"TabGroup_module_scrollableTabButtonIcon__35d4acb6","tabHeaders":"TabGroup_module_tabHeaders__35d4acb6","dropdown-item":"TabGroup_module_dropdownItem__35d4acb6"};

const cx$6 = classnames.bind(modules_da373891);
const ScrollableTabDropdownItem = ({ tabLabel, tabKey, validationOn, validationState, disabled, testId, tooltip, rowIndex, activeRowIndex, handleSelectTab, handleRowHover }) => {
    const dropdownTabElement = (React__default.createElement("div", Object.assign({ className: cx$6('dropdownTab', { disabled }, {
            unvalidated: validationOn &&
                (!validationState || validationState === FormValidationState.None)
        }, { error: validationState === FormValidationState.Error }, { success: validationState === FormValidationState.Success }, { activeDropdownTab: activeRowIndex === rowIndex }), onMouseDown: () => handleSelectTab(tabKey), onMouseEnter: (event) => handleRowHover(event, rowIndex) }, (testId && { 'data-test': testId })),
        React__default.createElement("div", { className: cx$6('dropdownTabContainer') },
            validationOn && (React__default.createElement("div", { className: cx$6('icon') },
                validationState === FormValidationState.Success && (React__default.createElement(Icon, { icon: "SuccessIconFilled", size: 20 })),
                validationState === FormValidationState.Error && (React__default.createElement(Icon, { icon: "ErrorIconFilled", size: 20 })))),
            tabLabel)));
    return disabled && tooltip ? (React__default.createElement(Tooltip, Object.assign({}, tooltip, { className: cx$6(tooltip.className) }), dropdownTabElement)) : (dropdownTabElement);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$5 = classnames.bind(modules_aa1c7ff8);
const SCROLL_SET_DELAY = 500;
const ScrollableEllipsesButton = ({ dropdown, dropdownProps, anchorId, overflowedTabs, validationOn, tabHeaderRef, handleSelectTab, isTabDisabled, headerEl }) => {
    const ellipsesButtonRef = React__default.useRef(null);
    const [isButtonHovered, setIsButtonHovered] = React__default.useState(false);
    const handleClick = (event) => {
        const eventTarget = event.target;
        if (dropdown.open && eventTarget.id !== anchorId) {
            dropdown.setOpen(false);
        }
    };
    const handleUpArrowPress = () => {
        const anchor = document.getElementById(anchorId);
        if (ElementIsOrChildOf(document.activeElement, [tabHeaderRef.current])) {
            if (anchorId.includes('scrollableTabButtonLeft')) {
                if (!dropdown.open) {
                    dropdown.toggle();
                    anchor === null || anchor === void 0 ? void 0 : anchor.focus();
                }
            }
        }
        if (ElementIsOrChildOf(document.activeElement, [anchor]) && dropdown.open) {
            if (dropdown.activeRowIndex > 0)
                dropdown.setActiveRowIndex(dropdown.activeRowIndex - 1);
        }
    };
    const handleDownArrowPress = () => {
        const anchor = document.getElementById(anchorId);
        if (ElementIsOrChildOf(document.activeElement, [tabHeaderRef.current])) {
            if (anchorId.includes('scrollableTabButtonRight')) {
                if (!dropdown.open) {
                    dropdown.toggle();
                    anchor === null || anchor === void 0 ? void 0 : anchor.focus();
                }
            }
        }
        if (ElementIsOrChildOf(document.activeElement, [anchor]) && dropdown.open) {
            if (dropdown.activeRowIndex < overflowedTabs.length - 1)
                dropdown.setActiveRowIndex(dropdown.activeRowIndex + 1);
        }
    };
    const handleKeydown = (event) => {
        const mappedKeys = ['ArrowUp', 'ArrowDown', 'Escape', 'Enter'];
        if (!mappedKeys.includes(event.key))
            return;
        event.preventDefault();
        if (event.type === 'keydown') {
            switch (event.key) {
                case 'ArrowUp':
                    handleUpArrowPress();
                    break;
                case 'ArrowDown':
                    handleDownArrowPress();
                    break;
                case 'Escape':
                    dropdown.setOpen(false);
                    break;
                case 'Enter':
                    if (ElementIsOrChildOf(document.activeElement, [
                        document.getElementById(anchorId)
                    ]) &&
                        !isTabDisabled(overflowedTabs[dropdown.activeRowIndex]))
                        handleEllipsesTabClick(overflowedTabs[dropdown.activeRowIndex].props.tabKey);
                    dropdown.setOpen(false);
                    break;
                default:
                    return;
            }
        }
    };
    const handleMouseEnter = (event) => {
        const target = event.target;
        if (target.id !== anchorId) {
            return setIsButtonHovered(false);
        }
        setIsButtonHovered(true);
    };
    const handleMouseLeave = () => {
        setIsButtonHovered(false);
    };
    useEventListener('click', (event) => handleClick(event), [
        ellipsesButtonRef.current
    ]);
    useEventListener('keydown', (event) => handleKeydown(event), [headerEl]);
    const handleRowHover = (event, rowIndex) => {
        handleMouseEnter(event);
        dropdown.setActiveRowIndex(rowIndex);
    };
    /**
     * Intent of this specific function is to wait for the scrolling to complete before calling onActiveTabChange
     * This is to allow for any input's autofocus within TabContents to work properly
     * @param tabKey The tab key to change to
     */
    const handleEllipsesTabClick = (tabKey) => {
        setTimeout(() => handleSelectTab(tabKey), SCROLL_SET_DELAY);
    };
    React__default.useEffect(() => {
        var _a;
        if (!dropdown.open) {
            (_a = document.getElementById(anchorId)) === null || _a === void 0 ? void 0 : _a.blur();
        }
    }, [anchorId, dropdown.open]);
    React__default.useEffect(() => {
        if (overflowedTabs.length === 0)
            dropdown.setOpen(false);
    }, [dropdown, overflowedTabs.length]);
    return (React__default.createElement("div", Object.assign({ ref: ellipsesButtonRef, className: cx$5('scrollableTabButton', anchorId.includes('Left')
            ? 'scrollableTabButtonLeft'
            : 'scrollableTabButtonRight'), onClick: () => dropdown.toggle(), id: anchorId }, (anchorId && { 'data-test': anchorId }), { tabIndex: dropdown.open ? 0 : -1, onMouseEnter: (event) => handleMouseEnter(event), onMouseLeave: handleMouseLeave, onBlur: () => dropdown.setOpen(false) }),
        React__default.createElement("div", { className: cx$5('scrollableTabButtonIcon') },
            React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React__default.createElement("path", { d: "M8 12C8 13.1046 7.10457 14 6 14C4.89543 14 4 13.1046 4 12C4 10.8954 4.89543 10 6 10C7.10457 10 8 10.8954 8 12Z", fill: isButtonHovered ? '#365ef6' : '#6A6F82' }),
                React__default.createElement("path", { d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z", fill: isButtonHovered ? '#365ef6' : '#6A6F82' }),
                React__default.createElement("path", { d: "M20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z", fill: isButtonHovered ? '#365ef6' : '#6A6F82' }))),
        React__default.createElement("div", { onClick: (e) => e.stopPropagation() /* for `handleClick` */ },
            React__default.createElement(Dropdown, Object.assign({}, dropdownProps, { anchorEl: document.getElementById(anchorId) }),
                React__default.createElement(DropdownContainer, null, overflowedTabs.map((tab, i) => (React__default.createElement(ScrollableTabDropdownItem, { key: tab.props.tabKey, tabLabel: tab.props.title, tabKey: tab.props.tabKey, handleSelectTab: handleEllipsesTabClick, disabled: isTabDisabled(tab), tooltip: tab.props.tooltip, validationOn: validationOn, validationState: tab.props.validationState, testId: `dropdown-tab-${tab.props.tabKey}`, rowIndex: i, activeRowIndex: dropdown.activeRowIndex, handleRowHover: handleRowHover }))))))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const cx$4 = classnames.bind(modules_aa1c7ff8);
const getTabKeyFromId = (text) => { var _a, _b; return (_b = (_a = text.split('-tabKey-')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.trim(); };
const ellipsesButtonWidth = 48;
// If at least the set threshold percentage of a tab is visible,
// it will not be considered an overflowed tab
const thresholdPercentage = 0.75;
// Amount that is added to left edge and subtracted from right edge to prevent
// almost entirely invisible tabs from being considered partially visible
const partialVisibilityOffset = 5;
const TabHeader = ({ tabs, tabRefMap, tabHeaderRef, activeTab, activeTabFocusable, id, testId, headersClassName, validationOn, onActiveTabChange, setActiveTabFocusable, isTabActive, isTabDisabled }) => {
    const headerEl = React__default.useRef(null);
    const [overflowedTabs, setOverflowedTabs] = React__default.useState({
        left: [],
        right: []
    });
    const [maxLeftScroll, setMaxLeftScroll] = React__default.useState(tabHeaderRef.current
        ? tabHeaderRef.current.scrollWidth - tabHeaderRef.current.clientWidth
        : 0);
    // Used to determine when to apply ellipses button pixel offset on left side
    const previousActiveTabIndex = React__default.useRef(0);
    const [tippyInstances, setTippyInstances] = React__default.useState({});
    const [isScrolling, setIsScrolling] = React__default.useState(false);
    const isScrollable = React__default.useMemo(() => {
        return overflowedTabs.left.length > 0 || overflowedTabs.right.length > 0;
    }, [overflowedTabs.left.length, overflowedTabs.right.length]);
    const initialScrollableStatus = React__default.useMemo(() => {
        var _a;
        let totalTabWidth = 0;
        tabRefMap.current.forEach((tab) => (totalTabWidth += tab.getBoundingClientRect().width));
        if (!tabHeaderRef.current)
            return false;
        return ((_a = tabHeaderRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) <= totalTabWidth;
    }, [tabHeaderRef, tabRefMap]);
    const { dropdown: leftDropdown, dropdownProps: leftDropdownProps } = useDropdown({
        numberOfItems: overflowedTabs.left.length
    });
    const { dropdown: rightDropdown, dropdownProps: rightDropdownProps } = useDropdown({
        numberOfItems: overflowedTabs.right.length
    });
    const updateOverflow = React__default.useCallback(() => {
        const navbarElement = tabHeaderRef === null || tabHeaderRef === void 0 ? void 0 : tabHeaderRef.current;
        if (!navbarElement)
            return;
        const navbarRect = navbarElement === null || navbarElement === void 0 ? void 0 : navbarElement.getBoundingClientRect();
        const newLeftOverflowedTabs = [];
        const newRightOverflowedTabs = [];
        const activeIndex = tabs.findIndex((tab) => tab.props.tabKey === activeTab);
        tabs.forEach((tab) => {
            var _a;
            const tabRect = (_a = tabRefMap.current
                .get(tab.props.tabKey)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            const threshold = tabRect ? tabRect.width * thresholdPercentage : 0;
            const adjustedRightEdge = (tabRect === null || tabRect === void 0 ? void 0 : tabRect.right) - (activeIndex <= 1 ? 0 : ellipsesButtonWidth);
            const adjustedLeftEdge = (tabRect === null || tabRect === void 0 ? void 0 : tabRect.left) +
                (activeIndex >= tabs.length - 2 ? 0 : ellipsesButtonWidth);
            if (adjustedRightEdge - threshold < navbarRect.left) {
                if (navbarElement.scrollLeft > 0)
                    newLeftOverflowedTabs.push(tab);
            }
            else if (adjustedLeftEdge + threshold > navbarRect.right) {
                if (Math.ceil(navbarElement.scrollLeft) < maxLeftScroll)
                    newRightOverflowedTabs.push(tab);
            }
        });
        setOverflowedTabs({
            left: newLeftOverflowedTabs.reverse(),
            right: newRightOverflowedTabs
        });
    }, [activeTab, maxLeftScroll, tabHeaderRef, tabRefMap, tabs]);
    const debouncedUpdateOverflow = React__default.useMemo(() => debounce(updateOverflow, 100), [updateOverflow]);
    const getTabVisibilityLevel = React__default.useCallback((tabElement, navbar) => {
        if (!navbar)
            return;
        const navbarRect = navbar.getBoundingClientRect();
        const tabRect = tabElement === null || tabElement === void 0 ? void 0 : tabElement.getBoundingClientRect();
        if (!tabRect)
            return 'none';
        const adjustedLeft = overflowedTabs.left.length > 0
            ? navbarRect.left + ellipsesButtonWidth
            : navbarRect.left;
        const adjustedRight = overflowedTabs.right.length > 0
            ? navbarRect.right - ellipsesButtonWidth
            : navbarRect.right;
        const isLeftEdgeInView = tabRect.left + partialVisibilityOffset >= adjustedLeft &&
            tabRect.left + partialVisibilityOffset <= adjustedRight;
        const isRightEdgeInView = tabRect.right - partialVisibilityOffset >= adjustedLeft &&
            tabRect.right - partialVisibilityOffset <= adjustedRight;
        if (!isLeftEdgeInView && !isRightEdgeInView)
            return 'none';
        if ((isLeftEdgeInView && !isRightEdgeInView) ||
            (isRightEdgeInView && !isLeftEdgeInView))
            return 'partial';
        if (isLeftEdgeInView && isRightEdgeInView)
            return 'full';
    }, [overflowedTabs.left.length, overflowedTabs.right.length]);
    const scrollToTab = React__default.useCallback((focusedTabKey) => {
        if (!isScrollable)
            return;
        setIsScrolling(true);
        const tabElement = tabRefMap.current.get(focusedTabKey !== null && focusedTabKey !== void 0 ? focusedTabKey : activeTab);
        if (!tabElement || !tabHeaderRef)
            return;
        const previousTabElement = tabElement.previousElementSibling;
        const nextTabElement = tabElement.nextElementSibling;
        const selectedIndex = tabs.findIndex((tab) => tab.props.tabKey === (focusedTabKey !== null && focusedTabKey !== void 0 ? focusedTabKey : activeTab));
        // Early exit if focused tab is scrolled away from active tab
        // in order to not automatically scroll back to active tab
        if (ElementIsOrChildOf(document.activeElement, [tabHeaderRef.current]) &&
            !focusedTabKey &&
            document.activeElement !== tabRefMap.current.get(activeTab))
            return;
        if (selectedIndex === 0 || selectedIndex === tabs.length - 1) {
            // Scrolling to the first or last tab
            ScrollIntoView(tabElement);
        }
        else if (selectedIndex > previousActiveTabIndex.current &&
            getTabVisibilityLevel(nextTabElement, tabHeaderRef.current) !== 'full') {
            // Scrolling to the right
            ScrollIntoView(nextTabElement);
        }
        else if (selectedIndex < previousActiveTabIndex.current &&
            getTabVisibilityLevel(previousTabElement, tabHeaderRef.current) !==
                'full') {
            // Scrolling to the left
            ScrollIntoView(previousTabElement);
        }
        previousActiveTabIndex.current = selectedIndex;
    }, [
        isScrollable,
        tabRefMap,
        activeTab,
        tabHeaderRef,
        tabs,
        getTabVisibilityLevel
    ]);
    const handleResize = React__default.useCallback(() => {
        if (tabHeaderRef.current)
            setMaxLeftScroll(tabHeaderRef.current.scrollWidth - tabHeaderRef.current.clientWidth);
        debouncedUpdateOverflow();
    }, [debouncedUpdateOverflow, tabHeaderRef]);
    const handleFocusChange = (event) => {
        if (ElementIsOrChildOf(document.activeElement, [tabHeaderRef.current])) {
            const focusedTab = document.activeElement;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft')
                if (focusedTab &&
                    getTabVisibilityLevel(focusedTab, tabHeaderRef.current) !== 'full') {
                    event.preventDefault();
                    scrollToTab(getTabKeyFromId(focusedTab.id));
                }
        }
    };
    React__default.useEffect(() => {
        if (isScrollable)
            scrollToTab();
    }, [activeTab, isScrollable, scrollToTab]);
    // Used to determine overflowed tabs on mount,
    // will assure scrollable styles are applied if needed
    React__default.useEffect(() => {
        handleResize();
    }, [handleResize]);
    useEventListener('resize', handleResize, [window]);
    useEventListener('scroll', debouncedUpdateOverflow, [tabHeaderRef.current]);
    useEventListener('keydown', (event) => handleFocusChange(event), [window]);
    const handleHeaderGroupFocus = () => {
        // Anytime our header group gets focus, we need to make all tab headers not keyboard
        // focusable as we will manage it via arrow keys.
        setActiveTabFocusable(false);
    };
    const handleHeaderGroupBlur = (e) => {
        // Anytime our header group is blurred outside of the group, we need to make the active
        // tab keyboard focusable.
        OnFocusOutside(e, [tabHeaderRef.current], () => {
            setActiveTabFocusable(true);
        });
    };
    const baseTabHeader = (React__default.createElement("div", { ref: tabHeaderRef, "data-test": testId ? `${testId}-headers` : '', onFocus: handleHeaderGroupFocus, onBlur: handleHeaderGroupBlur, className: cx$4('tabHeaders', headersClassName, isScrollable && 'scrollableTabGroup') }, React__default.Children.map(tabs, (child) => {
        const isActiveTab = isTabActive(child);
        return React__default.cloneElement(child, {
            validationOn,
            ref: (ref) => tabRefMap.current.set(child.props.tabKey, ref),
            onUnmount: (tabKey) => tabRefMap.current.delete(tabKey),
            testId: testId && `${testId}-${child.props.tabKey}`,
            active: isActiveTab,
            tabClassName: {
                scrollMargin: isScrollable,
                snugTab: initialScrollableStatus
            },
            disabled: isTabDisabled(child),
            // Only the active tab AND if we are allowing tab headers to be part of the
            // keyboard focus path do we set this to true.
            isKeyboardFocusable: isActiveTab && activeTabFocusable,
            onClick: (tabKey) => {
                if (!isTabDisabled(child)) {
                    onActiveTabChange(tabKey);
                }
            }
        });
    })));
    // Initialize or destroy tippy instances
    React__default.useEffect(() => {
        var _a;
        if (isScrollable && isEmpty(tippyInstances)) {
            const instancesToInitialize = {};
            [...tabRefMap.current].forEach(([_, value], i) => {
                const title = tabs[i] ? tabs[i].props.title : '';
                instancesToInitialize[value.id] = tippy(`#${value.id}`, {
                    placement: 'auto-start',
                    delay: [250, 0],
                    content: title
                }).pop();
            });
            setTippyInstances(Object.assign(Object.assign({}, tippyInstances), instancesToInitialize));
        }
        else if (!isScrollable && !isEmpty(tippyInstances)) {
            for (const instance in tippyInstances) {
                (_a = tippyInstances[instance]) === null || _a === void 0 ? void 0 : _a.destroy();
                setTippyInstances({});
            }
        }
    }, [isScrollable, tabRefMap, tabs, tippyInstances]);
    // Wait for scrolling to apply new tooltip visibilities
    React__default.useEffect(() => {
        if (isScrollable && isScrolling) {
            setTimeout(() => setIsScrolling(false), SCROLL_SET_DELAY);
        }
    }, [isScrollable, isScrolling]);
    React__default.useEffect(() => {
        var _a, _b;
        if (isEmpty(tippyInstances))
            return;
        for (const instance in tippyInstances) {
            // gets the tab key from the end part of the tabId
            const instanceTabKey = getTabKeyFromId(instance);
            const tabRef = tabRefMap.current.get(instanceTabKey !== null && instanceTabKey !== void 0 ? instanceTabKey : '');
            if (isScrolling) {
                (_a = tippyInstances[instance]) === null || _a === void 0 ? void 0 : _a.disable();
            }
            else if (getTabVisibilityLevel(tabRef, tabHeaderRef.current) === 'partial') {
                (_b = tippyInstances[instance]) === null || _b === void 0 ? void 0 : _b.enable();
            }
        }
    }, [
        activeTab,
        isScrolling,
        getTabVisibilityLevel,
        tabHeaderRef,
        tabRefMap,
        tippyInstances
    ]);
    return (React__default.createElement("div", { ref: headerEl, className: cx$4(isScrollable && 'scrollableTabGroupContainer') },
        overflowedTabs.left.length > 0 && (React__default.createElement(ScrollableEllipsesButton, { dropdown: leftDropdown, dropdownProps: leftDropdownProps, anchorId: id ? `scrollableTabButtonLeft-${id}` : `scrollableTabButtonLeft`, overflowedTabs: overflowedTabs.left, validationOn: true, handleSelectTab: onActiveTabChange, tabHeaderRef: tabHeaderRef, isTabDisabled: isTabDisabled, headerEl: headerEl.current })),
        baseTabHeader,
        overflowedTabs.right.length > 0 && (React__default.createElement(ScrollableEllipsesButton, { dropdown: rightDropdown, dropdownProps: rightDropdownProps, anchorId: id ? `scrollableTabButtonRight-${id}` : `scrollableTabButtonRight`, overflowedTabs: overflowedTabs.right, validationOn: true, handleSelectTab: onActiveTabChange, tabHeaderRef: tabHeaderRef, isTabDisabled: isTabDisabled, headerEl: headerEl.current }))));
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const TabGroupBase = ({ customDataProps, id, testId, activeTab, onActiveTabChange, disabled = false, focusChildOnActivate = false, renderHeadersAt, headersClassName, contentClassName, children }) => {
    useRestrictedChildType('TabGroup', ['Tab'], children);
    const tabRefMap = React__default.useRef(new Map());
    const [validationOn, setValidationOn] = React__default.useState(false);
    const [activeTabFocusable, setActiveTabFocusable] = React__default.useState(true);
    const [headerRenderEl, setHeaderRenderEl] = React__default.useState(null);
    const tabHeaderRef = React__default.useRef(null);
    // Filter out any children that aren't a tab components
    const tabs = React__default.Children.toArray(children).filter((child) => {
        return child.type === Tab;
    });
    const isTabActive = (tab) => tab.props.tabKey === activeTab;
    const isTabDisabled = (tab) => {
        var _a;
        return !isTabActive(tab) && ((_a = tab.props.disabled) !== null && _a !== void 0 ? _a : disabled);
    };
    const handleArrow = (direction) => {
        const disabledTabKeys = tabs
            .filter(isTabDisabled)
            .map((t) => t.props.tabKey);
        // We need a list of tabs, but filter out any disabled ones tabs
        // since disabled tabs should be focusable
        const tabArray = Array.from(tabRefMap.current).filter(([tabKey]) => !disabledTabKeys.includes(tabKey));
        const focusedIndex = tabArray.findIndex(([_, tabEl]) => tabEl === document.activeElement);
        const { next, prev } = BookEndArray(tabArray, focusedIndex);
        const [_, nextTabEl] = direction === 'right' ? next() : prev();
        if (nextTabEl !== document.activeElement) {
            nextTabEl.focus();
        }
    };
    const handleEnter = () => {
        const tabArray = Array.from(tabRefMap.current);
        const tabToActivate = tabArray.find(([_, tabEl]) => tabEl === document.activeElement);
        if (tabToActivate[0] !== activeTab) {
            onActiveTabChange(tabToActivate[0]);
        }
    };
    const handleKeyDown = (e) => {
        // If one of our tabs is focused, and the user hit one of the left or right
        // arrow keys, we want to shift focus to the prev / next tab.
        if (ElementIsOrChildOf(document.activeElement, Array.from(tabRefMap.current.values()))) {
            KeyHandleMap(e, [
                { ArrowLeft: () => handleArrow('left') },
                { ArrowRight: () => handleArrow('right') },
                { Enter: handleEnter }
            ]);
        }
    };
    // We need to know if any of our children are setting validation state. If so
    // we change spacing to account for a possible icon.
    React__default.useEffect(() => {
        // Using some so we can short circuit if we find a positive case.
        React__default.Children.toArray(tabs).some((child) => {
            if (child.props.validationState !== undefined) {
                setValidationOn(true);
                return true;
            }
            return false;
        });
    });
    React__default.useLayoutEffect(() => {
        let headerRenderEl = null;
        if (renderHeadersAt) {
            headerRenderEl = document.getElementById(renderHeadersAt);
            if (!headerRenderEl) {
                ADSWarn(`TabGroup renderHeaderAt was not able to find an element with the id of ${renderHeadersAt}`);
            }
            else {
                setHeaderRenderEl(headerRenderEl);
            }
        }
    }, [renderHeadersAt]);
    const renderHeaders = () => {
        return (React__default.createElement(TabHeader, { tabs: tabs, tabHeaderRef: tabHeaderRef, tabRefMap: tabRefMap, activeTab: activeTab, activeTabFocusable: activeTabFocusable, id: id, testId: testId, headersClassName: headersClassName, validationOn: validationOn, onActiveTabChange: onActiveTabChange, setActiveTabFocusable: setActiveTabFocusable, isTabActive: isTabActive, isTabDisabled: isTabDisabled }));
    };
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, onKeyDown: handleKeyDown, className: modules_aa1c7ff8.tabGroupWrapper }),
        headerRenderEl && (React__default.createElement(Portal, { renderLocation: headerRenderEl }, renderHeaders())),
        !headerRenderEl && renderHeaders(),
        tabs.map((tab) => {
            const isActive = activeTab === tab.props.tabKey;
            const focusChildren = tab.props.focusChildOnActivate !== undefined
                ? tab.props.focusChildOnActivate
                : focusChildOnActivate;
            return (React__default.createElement(TabContent, { key: tab.props.tabKey, isActive: isActive, className: contentClassName, testId: testId && isActive ? `${testId}-content` : undefined, focusChildren: focusChildren }, tab.props.children));
        })));
};
const UnControlledTabGroup = (props) => {
    const [activeTab, setActiveTab] = React__default.useState(() => {
        if (props.activeTab) {
            return props.activeTab;
        }
        // If we are here we need to select the first tab child as the activeTab.
        const tabs = React__default.Children.toArray(props.children).filter((child) => {
            return child.type === Tab;
        });
        if (tabs.length) {
            return tabs[0].props.tabKey;
        }
        return '';
    });
    return (React__default.createElement(TabGroupBase, Object.assign({}, props, { activeTab: activeTab, onActiveTabChange: setActiveTab })));
};
const TabGroup = (props) => {
    return props.onActiveTabChange && props.activeTab ? (
    // @ts-ignore - not sure why it thinks props.activeTab can be undefined given we check above for that case
    React__default.createElement(TabGroupBase, Object.assign({}, props))) : (React__default.createElement(UnControlledTabGroup, Object.assign({}, props)));
};

var css$5 = ".TextArea_module_textarea__51f09e97{background-color:#fff;background:#fff;border:1px solid #b0b4bf;border-radius:2px;color:#363840;cursor:text;cursor:auto;display:block;font-size:14px;line-height:20px;padding:5px 8px;position:relative;resize:none;text-overflow:ellipsis;transition:all 275ms cubic-bezier(.25,.25,.25,1),background-color 0ms;z-index:10}.TextArea_module_textarea__51f09e97.TextArea_module_error__51f09e97{border-color:#ea0a3b}.TextArea_module_textarea__51f09e97.TextArea_module_warning__51f09e97{border-color:#f45110}.TextArea_module_textarea__51f09e97:hover{border-color:#365ef6}.TextArea_module_textarea__51f09e97.TextArea_module_readOnly__51f09e97{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf;color:#363840}.TextArea_module_textarea__51f09e97.TextArea_module_readOnly__51f09e97 input{background-color:#f5f5f7;color:#b0b4bf;color:#363840}.TextArea_module_textarea__51f09e97.TextArea_module_isLoading__51f09e97{background-color:#f1f4fd;border-color:#365ef6}.TextArea_module_textarea__51f09e97.TextArea_module_isLoading__51f09e97 input{background-color:#f1f4fd}.TextArea_module_textarea__51f09e97.TextArea_module_focus__51f09e97,.TextArea_module_textarea__51f09e97:focus,.TextArea_module_textarea__51f09e97:focus-within{border-color:#365ef6!important;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.TextArea_module_textarea__51f09e97.TextArea_module_focus__51f09e97.TextArea_module_readOnly__51f09e97,.TextArea_module_textarea__51f09e97:focus-within.TextArea_module_readOnly__51f09e97,.TextArea_module_textarea__51f09e97:focus.TextArea_module_readOnly__51f09e97{border-color:#cbced7!important;box-shadow:none!important}.TextArea_module_textarea__51f09e97.TextArea_module_disabled__51f09e97,.TextArea_module_textarea__51f09e97:disabled{background-color:#f5f5f7;border-color:#cbced7;color:#b0b4bf}.TextArea_module_textarea__51f09e97.TextArea_module_disabled__51f09e97 input,.TextArea_module_textarea__51f09e97:disabled input{background-color:#f5f5f7;color:#b0b4bf}";
window.ADS.injectStyle(css$5,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/TextArea/TextArea.module.scss");
var modules_923c63ea = {"textarea":"TextArea_module_textarea__51f09e97","error":"TextArea_module_error__51f09e97","warning":"TextArea_module_warning__51f09e97","readOnly":"TextArea_module_readOnly__51f09e97","isLoading":"TextArea_module_isLoading__51f09e97","focus":"TextArea_module_focus__51f09e97","disabled":"TextArea_module_disabled__51f09e97"};

const cx$3 = classnames.bind(modules_923c63ea);
/**
 * `TextArea` allows the user to enter multi-line free form text.
 *
 * `TextArea` extends the `FieldProps`, and will have all the props of a `Field`
 * component.
 */
const TextAreaBase = ({ appearError, appearWarning, error, inputRef: textAreaRef, labelledBy, maxLength, name, placeholder, warning, autoFocus = false, disabled = false, height = '100%', readOnly = false, resize = 'none', value = '', width = '100%', onBlur, onChange, onFocus, customDataProps, onContextMenu }) => (React__default.createElement("textarea", Object.assign({}, customDataProps, { ref: textAreaRef, "aria-labelledby": labelledBy, autoFocus: autoFocus, onFocus: onFocus, name: name, id: name, placeholder: placeholder, disabled: disabled, readOnly: readOnly, value: value !== null && value !== void 0 ? value : '', onChange: onChange, onBlur: onBlur, style: { height, width, resize }, maxLength: maxLength, onContextMenu: onContextMenu, className: cx$3('textarea', {
        error: error || appearError,
        warning: warning || appearWarning,
        readOnly
    }) })));
const TextAreaBaseField = withField(TextAreaBase);
const UncontrolledTextArea = (props) => {
    const [value, setValue] = React__default.useState('');
    return (React__default.createElement(TextAreaBaseField, Object.assign({ value: value, onChange: (e) => setValue(e.target.value) }, props)));
};
const StandAloneTextArea = withStandAlone(UncontrolledTextArea, TextAreaBaseField);
const TextArea = withFieldSchemaSupport$1(StandAloneTextArea, withFieldSchema(TextAreaBaseField));

var css$4 = "@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap\");";
window.ADS.injectFont(css$4,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/styles/fonts/open-sans.scss");

var css$3 = ".d-flex,.d-flex-row{display:flex}.d-flex-row{flex-wrap:wrap;gap:24px}.flex-align-center{align-items:center}.d-iflex{display:inline-flex}.d-block{display:block}.d-iblock{display:inline-block}.d-none{display:none}.f-right{float:right}.f-left{float:left}.text-left{text-align:left}.text-center{text-align:center}.text-right{text-align:right}.w-100p{width:100%!important}.h-100p{height:100%!important}.maxw-100p{max-width:100%!important}.maxh-100p{max-height:100%!important}.minw-auto{min-width:auto!important}.no-wrap{white-space:nowrap}.center-fixed{align-items:center;display:grid;height:100vh;justify-content:center;position:fixed;right:0;top:0;width:100vw}.scroll-no-clip{margin:-4px;overflow:auto;padding:4px}.help-hover svg path{fill:#6a6f82}.help-hover svg:hover path{fill:#444750}.ads-color-info{color:#365ef6}.ads-color-warning{color:#d93f02}.ads-color-error{color:#ea0a3b}.ads-color-success{color:#03866a}.ads-color-disabled{color:#b0b4bf}.m-0{margin:0!important}.mt-0{margin-top:0!important}.mr-0{margin-right:0!important}.mb-0{margin-bottom:0!important}.ml-0,.mx-0{margin-left:0!important}.mx-0{margin-right:0!important}.my-0{margin-bottom:0!important;margin-top:0!important}.m-25{margin:4px!important}.mt-25{margin-top:4px!important}.mr-25{margin-right:4px!important}.mb-25{margin-bottom:4px!important}.ml-25,.mx-25{margin-left:4px!important}.mx-25{margin-right:4px!important}.my-25{margin-bottom:4px!important;margin-top:4px!important}.m-50{margin:8px!important}.mt-50{margin-top:8px!important}.mr-50{margin-right:8px!important}.mb-50{margin-bottom:8px!important}.ml-50,.mx-50{margin-left:8px!important}.mx-50{margin-right:8px!important}.my-50{margin-bottom:8px!important;margin-top:8px!important}.m-75{margin:12px!important}.mt-75{margin-top:12px!important}.mr-75{margin-right:12px!important}.mb-75{margin-bottom:12px!important}.ml-75,.mx-75{margin-left:12px!important}.mx-75{margin-right:12px!important}.my-75{margin-bottom:12px!important;margin-top:12px!important}.m-100{margin:16px!important}.mt-100{margin-top:16px!important}.mr-100{margin-right:16px!important}.mb-100{margin-bottom:16px!important}.ml-100,.mx-100{margin-left:16px!important}.mx-100{margin-right:16px!important}.my-100{margin-bottom:16px!important;margin-top:16px!important}.m-125{margin:20px!important}.mt-125{margin-top:20px!important}.mr-125{margin-right:20px!important}.mb-125{margin-bottom:20px!important}.ml-125,.mx-125{margin-left:20px!important}.mx-125{margin-right:20px!important}.my-125{margin-bottom:20px!important;margin-top:20px!important}.m-150{margin:24px!important}.mt-150{margin-top:24px!important}.mr-150{margin-right:24px!important}.mb-150{margin-bottom:24px!important}.ml-150,.mx-150{margin-left:24px!important}.mx-150{margin-right:24px!important}.my-150{margin-bottom:24px!important;margin-top:24px!important}.m-200{margin:32px!important}.mt-200{margin-top:32px!important}.mr-200{margin-right:32px!important}.mb-200{margin-bottom:32px!important}.ml-200,.mx-200{margin-left:32px!important}.mx-200{margin-right:32px!important}.my-200{margin-bottom:32px!important;margin-top:32px!important}.m-250{margin:40px!important}.mt-250{margin-top:40px!important}.mr-250{margin-right:40px!important}.mb-250{margin-bottom:40px!important}.ml-250,.mx-250{margin-left:40px!important}.mx-250{margin-right:40px!important}.my-250{margin-bottom:40px!important;margin-top:40px!important}.m-300{margin:48px!important}.mt-300{margin-top:48px!important}.mr-300{margin-right:48px!important}.mb-300{margin-bottom:48px!important}.ml-300,.mx-300{margin-left:48px!important}.mx-300{margin-right:48px!important}.my-300{margin-bottom:48px!important;margin-top:48px!important}.m-350{margin:56px!important}.mt-350{margin-top:56px!important}.mr-350{margin-right:56px!important}.mb-350{margin-bottom:56px!important}.ml-350,.mx-350{margin-left:56px!important}.mx-350{margin-right:56px!important}.my-350{margin-bottom:56px!important;margin-top:56px!important}.m-400{margin:64px!important}.mt-400{margin-top:64px!important}.mr-400{margin-right:64px!important}.mb-400{margin-bottom:64px!important}.ml-400,.mx-400{margin-left:64px!important}.mx-400{margin-right:64px!important}.my-400{margin-bottom:64px!important;margin-top:64px!important}.m-450{margin:72px!important}.mt-450{margin-top:72px!important}.mr-450{margin-right:72px!important}.mb-450{margin-bottom:72px!important}.ml-450,.mx-450{margin-left:72px!important}.mx-450{margin-right:72px!important}.my-450{margin-bottom:72px!important;margin-top:72px!important}.m-500{margin:80px!important}.mt-500{margin-top:80px!important}.mr-500{margin-right:80px!important}.mb-500{margin-bottom:80px!important}.ml-500,.mx-500{margin-left:80px!important}.mx-500{margin-right:80px!important}.my-500{margin-bottom:80px!important;margin-top:80px!important}.p-0{padding:0!important}.pt-0{padding-top:0!important}.pr-0{padding-right:0!important}.pb-0{padding-bottom:0!important}.pl-0,.px-0{padding-left:0!important}.px-0{padding-right:0!important}.py-0{padding-bottom:0!important;padding-top:0!important}.p-25{padding:4px!important}.pt-25{padding-top:4px!important}.pr-25{padding-right:4px!important}.pb-25{padding-bottom:4px!important}.pl-25,.px-25{padding-left:4px!important}.px-25{padding-right:4px!important}.py-25{padding-bottom:4px!important;padding-top:4px!important}.p-50{padding:8px!important}.pt-50{padding-top:8px!important}.pr-50{padding-right:8px!important}.pb-50{padding-bottom:8px!important}.pl-50,.px-50{padding-left:8px!important}.px-50{padding-right:8px!important}.py-50{padding-bottom:8px!important;padding-top:8px!important}.p-75{padding:12px!important}.pt-75{padding-top:12px!important}.pr-75{padding-right:12px!important}.pb-75{padding-bottom:12px!important}.pl-75,.px-75{padding-left:12px!important}.px-75{padding-right:12px!important}.py-75{padding-bottom:12px!important;padding-top:12px!important}.p-100{padding:16px!important}.pt-100{padding-top:16px!important}.pr-100{padding-right:16px!important}.pb-100{padding-bottom:16px!important}.pl-100,.px-100{padding-left:16px!important}.px-100{padding-right:16px!important}.py-100{padding-bottom:16px!important;padding-top:16px!important}.p-125{padding:20px!important}.pt-125{padding-top:20px!important}.pr-125{padding-right:20px!important}.pb-125{padding-bottom:20px!important}.pl-125,.px-125{padding-left:20px!important}.px-125{padding-right:20px!important}.py-125{padding-bottom:20px!important;padding-top:20px!important}.p-150{padding:24px!important}.pt-150{padding-top:24px!important}.pr-150{padding-right:24px!important}.pb-150{padding-bottom:24px!important}.pl-150,.px-150{padding-left:24px!important}.px-150{padding-right:24px!important}.py-150{padding-bottom:24px!important;padding-top:24px!important}.p-200{padding:32px!important}.pt-200{padding-top:32px!important}.pr-200{padding-right:32px!important}.pb-200{padding-bottom:32px!important}.pl-200,.px-200{padding-left:32px!important}.px-200{padding-right:32px!important}.py-200{padding-bottom:32px!important;padding-top:32px!important}.p-250{padding:40px!important}.pt-250{padding-top:40px!important}.pr-250{padding-right:40px!important}.pb-250{padding-bottom:40px!important}.pl-250,.px-250{padding-left:40px!important}.px-250{padding-right:40px!important}.py-250{padding-bottom:40px!important;padding-top:40px!important}.p-300{padding:48px!important}.pt-300{padding-top:48px!important}.pr-300{padding-right:48px!important}.pb-300{padding-bottom:48px!important}.pl-300,.px-300{padding-left:48px!important}.px-300{padding-right:48px!important}.py-300{padding-bottom:48px!important;padding-top:48px!important}.p-350{padding:56px!important}.pt-350{padding-top:56px!important}.pr-350{padding-right:56px!important}.pb-350{padding-bottom:56px!important}.pl-350,.px-350{padding-left:56px!important}.px-350{padding-right:56px!important}.py-350{padding-bottom:56px!important;padding-top:56px!important}.p-400{padding:64px!important}.pt-400{padding-top:64px!important}.pr-400{padding-right:64px!important}.pb-400{padding-bottom:64px!important}.pl-400,.px-400{padding-left:64px!important}.px-400{padding-right:64px!important}.py-400{padding-bottom:64px!important;padding-top:64px!important}.p-450{padding:72px!important}.pt-450{padding-top:72px!important}.pr-450{padding-right:72px!important}.pb-450{padding-bottom:72px!important}.pl-450,.px-450{padding-left:72px!important}.px-450{padding-right:72px!important}.py-450{padding-bottom:72px!important;padding-top:72px!important}.p-500{padding:80px!important}.pt-500{padding-top:80px!important}.pr-500{padding-right:80px!important}.pb-500{padding-bottom:80px!important}.pl-500,.px-500{padding-left:80px!important}.px-500{padding-right:80px!important}.py-500{padding-bottom:80px!important;padding-top:80px!important}.w-80{width:80px!important}.w-96{width:96px!important}.w-128{width:128px!important}.w-160{width:160px!important}.w-192{width:192px!important}.w-224{width:224px!important}.w-256{width:256px!important}.w-320{width:320px!important}.w-400{width:400px!important}.w-480{width:480px!important}.w-768{width:768px!important}.minw-80{min-width:80px!important}.minw-96{min-width:96px!important}.minw-128{min-width:128px!important}.minw-160{min-width:160px!important}.minw-192{min-width:192px!important}.minw-224{min-width:224px!important}.minw-256{min-width:256px!important}.minw-320{min-width:320px!important}.minw-400{min-width:400px!important}.minw-480{min-width:480px!important}.minw-768{min-width:768px!important}.maxw-80{max-width:80px!important}.maxw-96{max-width:96px!important}.maxw-128{max-width:128px!important}.maxw-160{max-width:160px!important}.maxw-192{max-width:192px!important}.maxw-224{max-width:224px!important}.maxw-256{max-width:256px!important}.maxw-320{max-width:320px!important}.maxw-400{max-width:400px!important}.maxw-480{max-width:480px!important}.maxw-768{max-width:768px!important}.flex-container{display:flex;flex-wrap:wrap;gap:24px}.flex-align-start{justify-content:flex-start!important}.flex-align-center{justify-content:center!important}.flex-align-end{justify-content:flex-end!important}.flex-align-space-between{justify-content:space-between!important}.flex-align-space-around{justify-content:space-around!important}.flex-align-space-evenly{justify-content:space-evenly!important}.flex-valign-start{align-items:flex-start!important}.flex-valign-center{align-items:center!important}.flex-valign-baseline{align-items:baseline!important}.flex-valign-end{align-items:flex-end!important}.flex-wrap{flex-wrap:wrap!important}.flex-no-wrap{flex-wrap:nowrap!important}.flex-d-column{flex-direction:column!important}.flex-d-column-reverse{flex-direction:column-reverse!important}.flex-d-row{flex-direction:row!important}.flex-d-row-reverse{flex-direction:row-reverse!important}.flex-grow-0{flex-grow:0!important}.flex-item{flex:1}.gap-0{gap:0!important}.gap-h-0{column-gap:0!important}.gap-v-0{row-gap:0!important}.gap-25{gap:4px!important}.gap-h-25{column-gap:4px!important}.gap-v-25{row-gap:4px!important}.gap-50{gap:8px!important}.gap-h-50{column-gap:8px!important}.gap-v-50{row-gap:8px!important}.gap-75{gap:12px!important}.gap-h-75{column-gap:12px!important}.gap-v-75{row-gap:12px!important}.gap-100{gap:16px!important}.gap-h-100{column-gap:16px!important}.gap-v-100{row-gap:16px!important}.gap-125{gap:20px!important}.gap-h-125{column-gap:20px!important}.gap-v-125{row-gap:20px!important}.gap-150{gap:24px!important}.gap-h-150{column-gap:24px!important}.gap-v-150{row-gap:24px!important}.gap-200{gap:32px!important}.gap-h-200{column-gap:32px!important}.gap-v-200{row-gap:32px!important}.gap-250{gap:40px!important}.gap-h-250{column-gap:40px!important}.gap-v-250{row-gap:40px!important}.gap-300{gap:48px!important}.gap-h-300{column-gap:48px!important}.gap-v-300{row-gap:48px!important}.gap-350{gap:56px!important}.gap-h-350{column-gap:56px!important}.gap-v-350{row-gap:56px!important}.gap-400{gap:64px!important}.gap-h-400{column-gap:64px!important}.gap-v-400{row-gap:64px!important}.gap-450{gap:72px!important}.gap-h-450{column-gap:72px!important}.gap-v-450{row-gap:72px!important}.gap-500{gap:80px!important}.gap-h-500{column-gap:80px!important}.gap-v-500{row-gap:80px!important}@media (min-width:576px){.w-sm-80{width:80px!important}.w-sm-96{width:96px!important}.w-sm-128{width:128px!important}.w-sm-160{width:160px!important}.w-sm-192{width:192px!important}.w-sm-224{width:224px!important}.w-sm-256{width:256px!important}.w-sm-320{width:320px!important}.w-sm-400{width:400px!important}.w-sm-480{width:480px!important}.w-sm-768{width:768px!important}.minw-sm-80{min-width:80px!important}.minw-sm-96{min-width:96px!important}.minw-sm-128{min-width:128px!important}.minw-sm-160{min-width:160px!important}.minw-sm-192{min-width:192px!important}.minw-sm-224{min-width:224px!important}.minw-sm-256{min-width:256px!important}.minw-sm-320{min-width:320px!important}.minw-sm-400{min-width:400px!important}.minw-sm-480{min-width:480px!important}.minw-sm-768{min-width:768px!important}.maxw-sm-80{max-width:80px!important}.maxw-sm-96{max-width:96px!important}.maxw-sm-128{max-width:128px!important}.maxw-sm-160{max-width:160px!important}.maxw-sm-192{max-width:192px!important}.maxw-sm-224{max-width:224px!important}.maxw-sm-256{max-width:256px!important}.maxw-sm-320{max-width:320px!important}.maxw-sm-400{max-width:400px!important}.maxw-sm-480{max-width:480px!important}.maxw-sm-768{max-width:768px!important}.w-sm-auto{width:auto!important}.minw-sm-auto{min-width:auto!important}.maxw-sm-auto{max-width:auto!important}.w-sm-100p{width:100%!important}.h-sm-100p{height:100%!important}.m-sm-0{margin:0!important}.mt-sm-0{margin-top:0!important}.mr-sm-0{margin-right:0!important}.mb-sm-0{margin-bottom:0!important}.ml-sm-0,.mx-sm-0{margin-left:0!important}.mx-sm-0{margin-right:0!important}.my-sm-0{margin-bottom:0!important;margin-top:0!important}.m-sm-25{margin:4px!important}.mt-sm-25{margin-top:4px!important}.mr-sm-25{margin-right:4px!important}.mb-sm-25{margin-bottom:4px!important}.ml-sm-25,.mx-sm-25{margin-left:4px!important}.mx-sm-25{margin-right:4px!important}.my-sm-25{margin-bottom:4px!important;margin-top:4px!important}.m-sm-50{margin:8px!important}.mt-sm-50{margin-top:8px!important}.mr-sm-50{margin-right:8px!important}.mb-sm-50{margin-bottom:8px!important}.ml-sm-50,.mx-sm-50{margin-left:8px!important}.mx-sm-50{margin-right:8px!important}.my-sm-50{margin-bottom:8px!important;margin-top:8px!important}.m-sm-75{margin:12px!important}.mt-sm-75{margin-top:12px!important}.mr-sm-75{margin-right:12px!important}.mb-sm-75{margin-bottom:12px!important}.ml-sm-75,.mx-sm-75{margin-left:12px!important}.mx-sm-75{margin-right:12px!important}.my-sm-75{margin-bottom:12px!important;margin-top:12px!important}.m-sm-100{margin:16px!important}.mt-sm-100{margin-top:16px!important}.mr-sm-100{margin-right:16px!important}.mb-sm-100{margin-bottom:16px!important}.ml-sm-100,.mx-sm-100{margin-left:16px!important}.mx-sm-100{margin-right:16px!important}.my-sm-100{margin-bottom:16px!important;margin-top:16px!important}.m-sm-125{margin:20px!important}.mt-sm-125{margin-top:20px!important}.mr-sm-125{margin-right:20px!important}.mb-sm-125{margin-bottom:20px!important}.ml-sm-125,.mx-sm-125{margin-left:20px!important}.mx-sm-125{margin-right:20px!important}.my-sm-125{margin-bottom:20px!important;margin-top:20px!important}.m-sm-150{margin:24px!important}.mt-sm-150{margin-top:24px!important}.mr-sm-150{margin-right:24px!important}.mb-sm-150{margin-bottom:24px!important}.ml-sm-150,.mx-sm-150{margin-left:24px!important}.mx-sm-150{margin-right:24px!important}.my-sm-150{margin-bottom:24px!important;margin-top:24px!important}.m-sm-200{margin:32px!important}.mt-sm-200{margin-top:32px!important}.mr-sm-200{margin-right:32px!important}.mb-sm-200{margin-bottom:32px!important}.ml-sm-200,.mx-sm-200{margin-left:32px!important}.mx-sm-200{margin-right:32px!important}.my-sm-200{margin-bottom:32px!important;margin-top:32px!important}.m-sm-250{margin:40px!important}.mt-sm-250{margin-top:40px!important}.mr-sm-250{margin-right:40px!important}.mb-sm-250{margin-bottom:40px!important}.ml-sm-250,.mx-sm-250{margin-left:40px!important}.mx-sm-250{margin-right:40px!important}.my-sm-250{margin-bottom:40px!important;margin-top:40px!important}.m-sm-300{margin:48px!important}.mt-sm-300{margin-top:48px!important}.mr-sm-300{margin-right:48px!important}.mb-sm-300{margin-bottom:48px!important}.ml-sm-300,.mx-sm-300{margin-left:48px!important}.mx-sm-300{margin-right:48px!important}.my-sm-300{margin-bottom:48px!important;margin-top:48px!important}.m-sm-350{margin:56px!important}.mt-sm-350{margin-top:56px!important}.mr-sm-350{margin-right:56px!important}.mb-sm-350{margin-bottom:56px!important}.ml-sm-350,.mx-sm-350{margin-left:56px!important}.mx-sm-350{margin-right:56px!important}.my-sm-350{margin-bottom:56px!important;margin-top:56px!important}.m-sm-400{margin:64px!important}.mt-sm-400{margin-top:64px!important}.mr-sm-400{margin-right:64px!important}.mb-sm-400{margin-bottom:64px!important}.ml-sm-400,.mx-sm-400{margin-left:64px!important}.mx-sm-400{margin-right:64px!important}.my-sm-400{margin-bottom:64px!important;margin-top:64px!important}.m-sm-450{margin:72px!important}.mt-sm-450{margin-top:72px!important}.mr-sm-450{margin-right:72px!important}.mb-sm-450{margin-bottom:72px!important}.ml-sm-450,.mx-sm-450{margin-left:72px!important}.mx-sm-450{margin-right:72px!important}.my-sm-450{margin-bottom:72px!important;margin-top:72px!important}.m-sm-500{margin:80px!important}.mt-sm-500{margin-top:80px!important}.mr-sm-500{margin-right:80px!important}.mb-sm-500{margin-bottom:80px!important}.ml-sm-500,.mx-sm-500{margin-left:80px!important}.mx-sm-500{margin-right:80px!important}.my-sm-500{margin-bottom:80px!important;margin-top:80px!important}.p-sm-0{padding:0!important}.pt-sm-0{padding-top:0!important}.pr-sm-0{padding-right:0!important}.pb-sm-0{padding-bottom:0!important}.pl-sm-0,.px-sm-0{padding-left:0!important}.px-sm-0{padding-right:0!important}.py-sm-0{padding-bottom:0!important;padding-top:0!important}.p-sm-25{padding:4px!important}.pt-sm-25{padding-top:4px!important}.pr-sm-25{padding-right:4px!important}.pb-sm-25{padding-bottom:4px!important}.pl-sm-25,.px-sm-25{padding-left:4px!important}.px-sm-25{padding-right:4px!important}.py-sm-25{padding-bottom:4px!important;padding-top:4px!important}.p-sm-50{padding:8px!important}.pt-sm-50{padding-top:8px!important}.pr-sm-50{padding-right:8px!important}.pb-sm-50{padding-bottom:8px!important}.pl-sm-50,.px-sm-50{padding-left:8px!important}.px-sm-50{padding-right:8px!important}.py-sm-50{padding-bottom:8px!important;padding-top:8px!important}.p-sm-75{padding:12px!important}.pt-sm-75{padding-top:12px!important}.pr-sm-75{padding-right:12px!important}.pb-sm-75{padding-bottom:12px!important}.pl-sm-75,.px-sm-75{padding-left:12px!important}.px-sm-75{padding-right:12px!important}.py-sm-75{padding-bottom:12px!important;padding-top:12px!important}.p-sm-100{padding:16px!important}.pt-sm-100{padding-top:16px!important}.pr-sm-100{padding-right:16px!important}.pb-sm-100{padding-bottom:16px!important}.pl-sm-100,.px-sm-100{padding-left:16px!important}.px-sm-100{padding-right:16px!important}.py-sm-100{padding-bottom:16px!important;padding-top:16px!important}.p-sm-125{padding:20px!important}.pt-sm-125{padding-top:20px!important}.pr-sm-125{padding-right:20px!important}.pb-sm-125{padding-bottom:20px!important}.pl-sm-125,.px-sm-125{padding-left:20px!important}.px-sm-125{padding-right:20px!important}.py-sm-125{padding-bottom:20px!important;padding-top:20px!important}.p-sm-150{padding:24px!important}.pt-sm-150{padding-top:24px!important}.pr-sm-150{padding-right:24px!important}.pb-sm-150{padding-bottom:24px!important}.pl-sm-150,.px-sm-150{padding-left:24px!important}.px-sm-150{padding-right:24px!important}.py-sm-150{padding-bottom:24px!important;padding-top:24px!important}.p-sm-200{padding:32px!important}.pt-sm-200{padding-top:32px!important}.pr-sm-200{padding-right:32px!important}.pb-sm-200{padding-bottom:32px!important}.pl-sm-200,.px-sm-200{padding-left:32px!important}.px-sm-200{padding-right:32px!important}.py-sm-200{padding-bottom:32px!important;padding-top:32px!important}.p-sm-250{padding:40px!important}.pt-sm-250{padding-top:40px!important}.pr-sm-250{padding-right:40px!important}.pb-sm-250{padding-bottom:40px!important}.pl-sm-250,.px-sm-250{padding-left:40px!important}.px-sm-250{padding-right:40px!important}.py-sm-250{padding-bottom:40px!important;padding-top:40px!important}.p-sm-300{padding:48px!important}.pt-sm-300{padding-top:48px!important}.pr-sm-300{padding-right:48px!important}.pb-sm-300{padding-bottom:48px!important}.pl-sm-300,.px-sm-300{padding-left:48px!important}.px-sm-300{padding-right:48px!important}.py-sm-300{padding-bottom:48px!important;padding-top:48px!important}.p-sm-350{padding:56px!important}.pt-sm-350{padding-top:56px!important}.pr-sm-350{padding-right:56px!important}.pb-sm-350{padding-bottom:56px!important}.pl-sm-350,.px-sm-350{padding-left:56px!important}.px-sm-350{padding-right:56px!important}.py-sm-350{padding-bottom:56px!important;padding-top:56px!important}.p-sm-400{padding:64px!important}.pt-sm-400{padding-top:64px!important}.pr-sm-400{padding-right:64px!important}.pb-sm-400{padding-bottom:64px!important}.pl-sm-400,.px-sm-400{padding-left:64px!important}.px-sm-400{padding-right:64px!important}.py-sm-400{padding-bottom:64px!important;padding-top:64px!important}.p-sm-450{padding:72px!important}.pt-sm-450{padding-top:72px!important}.pr-sm-450{padding-right:72px!important}.pb-sm-450{padding-bottom:72px!important}.pl-sm-450,.px-sm-450{padding-left:72px!important}.px-sm-450{padding-right:72px!important}.py-sm-450{padding-bottom:72px!important;padding-top:72px!important}.p-sm-500{padding:80px!important}.pt-sm-500{padding-top:80px!important}.pr-sm-500{padding-right:80px!important}.pb-sm-500{padding-bottom:80px!important}.pl-sm-500,.px-sm-500{padding-left:80px!important}.px-sm-500{padding-right:80px!important}.py-sm-500{padding-bottom:80px!important;padding-top:80px!important}}@media (min-width:768px){.w-md-80{width:80px!important}.w-md-96{width:96px!important}.w-md-128{width:128px!important}.w-md-160{width:160px!important}.w-md-192{width:192px!important}.w-md-224{width:224px!important}.w-md-256{width:256px!important}.w-md-320{width:320px!important}.w-md-400{width:400px!important}.w-md-480{width:480px!important}.w-md-768{width:768px!important}.minw-md-80{min-width:80px!important}.minw-md-96{min-width:96px!important}.minw-md-128{min-width:128px!important}.minw-md-160{min-width:160px!important}.minw-md-192{min-width:192px!important}.minw-md-224{min-width:224px!important}.minw-md-256{min-width:256px!important}.minw-md-320{min-width:320px!important}.minw-md-400{min-width:400px!important}.minw-md-480{min-width:480px!important}.minw-md-768{min-width:768px!important}.maxw-md-80{max-width:80px!important}.maxw-md-96{max-width:96px!important}.maxw-md-128{max-width:128px!important}.maxw-md-160{max-width:160px!important}.maxw-md-192{max-width:192px!important}.maxw-md-224{max-width:224px!important}.maxw-md-256{max-width:256px!important}.maxw-md-320{max-width:320px!important}.maxw-md-400{max-width:400px!important}.maxw-md-480{max-width:480px!important}.maxw-md-768{max-width:768px!important}.w-md-auto{width:auto!important}.minw-md-auto{min-width:auto!important}.maxw-md-auto{max-width:auto!important}.w-md-100p{width:100%!important}.h-md-100p{height:100%!important}.m-md-0{margin:0!important}.mt-md-0{margin-top:0!important}.mr-md-0{margin-right:0!important}.mb-md-0{margin-bottom:0!important}.ml-md-0,.mx-md-0{margin-left:0!important}.mx-md-0{margin-right:0!important}.my-md-0{margin-bottom:0!important;margin-top:0!important}.m-md-25{margin:4px!important}.mt-md-25{margin-top:4px!important}.mr-md-25{margin-right:4px!important}.mb-md-25{margin-bottom:4px!important}.ml-md-25,.mx-md-25{margin-left:4px!important}.mx-md-25{margin-right:4px!important}.my-md-25{margin-bottom:4px!important;margin-top:4px!important}.m-md-50{margin:8px!important}.mt-md-50{margin-top:8px!important}.mr-md-50{margin-right:8px!important}.mb-md-50{margin-bottom:8px!important}.ml-md-50,.mx-md-50{margin-left:8px!important}.mx-md-50{margin-right:8px!important}.my-md-50{margin-bottom:8px!important;margin-top:8px!important}.m-md-75{margin:12px!important}.mt-md-75{margin-top:12px!important}.mr-md-75{margin-right:12px!important}.mb-md-75{margin-bottom:12px!important}.ml-md-75,.mx-md-75{margin-left:12px!important}.mx-md-75{margin-right:12px!important}.my-md-75{margin-bottom:12px!important;margin-top:12px!important}.m-md-100{margin:16px!important}.mt-md-100{margin-top:16px!important}.mr-md-100{margin-right:16px!important}.mb-md-100{margin-bottom:16px!important}.ml-md-100,.mx-md-100{margin-left:16px!important}.mx-md-100{margin-right:16px!important}.my-md-100{margin-bottom:16px!important;margin-top:16px!important}.m-md-125{margin:20px!important}.mt-md-125{margin-top:20px!important}.mr-md-125{margin-right:20px!important}.mb-md-125{margin-bottom:20px!important}.ml-md-125,.mx-md-125{margin-left:20px!important}.mx-md-125{margin-right:20px!important}.my-md-125{margin-bottom:20px!important;margin-top:20px!important}.m-md-150{margin:24px!important}.mt-md-150{margin-top:24px!important}.mr-md-150{margin-right:24px!important}.mb-md-150{margin-bottom:24px!important}.ml-md-150,.mx-md-150{margin-left:24px!important}.mx-md-150{margin-right:24px!important}.my-md-150{margin-bottom:24px!important;margin-top:24px!important}.m-md-200{margin:32px!important}.mt-md-200{margin-top:32px!important}.mr-md-200{margin-right:32px!important}.mb-md-200{margin-bottom:32px!important}.ml-md-200,.mx-md-200{margin-left:32px!important}.mx-md-200{margin-right:32px!important}.my-md-200{margin-bottom:32px!important;margin-top:32px!important}.m-md-250{margin:40px!important}.mt-md-250{margin-top:40px!important}.mr-md-250{margin-right:40px!important}.mb-md-250{margin-bottom:40px!important}.ml-md-250,.mx-md-250{margin-left:40px!important}.mx-md-250{margin-right:40px!important}.my-md-250{margin-bottom:40px!important;margin-top:40px!important}.m-md-300{margin:48px!important}.mt-md-300{margin-top:48px!important}.mr-md-300{margin-right:48px!important}.mb-md-300{margin-bottom:48px!important}.ml-md-300,.mx-md-300{margin-left:48px!important}.mx-md-300{margin-right:48px!important}.my-md-300{margin-bottom:48px!important;margin-top:48px!important}.m-md-350{margin:56px!important}.mt-md-350{margin-top:56px!important}.mr-md-350{margin-right:56px!important}.mb-md-350{margin-bottom:56px!important}.ml-md-350,.mx-md-350{margin-left:56px!important}.mx-md-350{margin-right:56px!important}.my-md-350{margin-bottom:56px!important;margin-top:56px!important}.m-md-400{margin:64px!important}.mt-md-400{margin-top:64px!important}.mr-md-400{margin-right:64px!important}.mb-md-400{margin-bottom:64px!important}.ml-md-400,.mx-md-400{margin-left:64px!important}.mx-md-400{margin-right:64px!important}.my-md-400{margin-bottom:64px!important;margin-top:64px!important}.m-md-450{margin:72px!important}.mt-md-450{margin-top:72px!important}.mr-md-450{margin-right:72px!important}.mb-md-450{margin-bottom:72px!important}.ml-md-450,.mx-md-450{margin-left:72px!important}.mx-md-450{margin-right:72px!important}.my-md-450{margin-bottom:72px!important;margin-top:72px!important}.m-md-500{margin:80px!important}.mt-md-500{margin-top:80px!important}.mr-md-500{margin-right:80px!important}.mb-md-500{margin-bottom:80px!important}.ml-md-500,.mx-md-500{margin-left:80px!important}.mx-md-500{margin-right:80px!important}.my-md-500{margin-bottom:80px!important;margin-top:80px!important}.p-md-0{padding:0!important}.pt-md-0{padding-top:0!important}.pr-md-0{padding-right:0!important}.pb-md-0{padding-bottom:0!important}.pl-md-0,.px-md-0{padding-left:0!important}.px-md-0{padding-right:0!important}.py-md-0{padding-bottom:0!important;padding-top:0!important}.p-md-25{padding:4px!important}.pt-md-25{padding-top:4px!important}.pr-md-25{padding-right:4px!important}.pb-md-25{padding-bottom:4px!important}.pl-md-25,.px-md-25{padding-left:4px!important}.px-md-25{padding-right:4px!important}.py-md-25{padding-bottom:4px!important;padding-top:4px!important}.p-md-50{padding:8px!important}.pt-md-50{padding-top:8px!important}.pr-md-50{padding-right:8px!important}.pb-md-50{padding-bottom:8px!important}.pl-md-50,.px-md-50{padding-left:8px!important}.px-md-50{padding-right:8px!important}.py-md-50{padding-bottom:8px!important;padding-top:8px!important}.p-md-75{padding:12px!important}.pt-md-75{padding-top:12px!important}.pr-md-75{padding-right:12px!important}.pb-md-75{padding-bottom:12px!important}.pl-md-75,.px-md-75{padding-left:12px!important}.px-md-75{padding-right:12px!important}.py-md-75{padding-bottom:12px!important;padding-top:12px!important}.p-md-100{padding:16px!important}.pt-md-100{padding-top:16px!important}.pr-md-100{padding-right:16px!important}.pb-md-100{padding-bottom:16px!important}.pl-md-100,.px-md-100{padding-left:16px!important}.px-md-100{padding-right:16px!important}.py-md-100{padding-bottom:16px!important;padding-top:16px!important}.p-md-125{padding:20px!important}.pt-md-125{padding-top:20px!important}.pr-md-125{padding-right:20px!important}.pb-md-125{padding-bottom:20px!important}.pl-md-125,.px-md-125{padding-left:20px!important}.px-md-125{padding-right:20px!important}.py-md-125{padding-bottom:20px!important;padding-top:20px!important}.p-md-150{padding:24px!important}.pt-md-150{padding-top:24px!important}.pr-md-150{padding-right:24px!important}.pb-md-150{padding-bottom:24px!important}.pl-md-150,.px-md-150{padding-left:24px!important}.px-md-150{padding-right:24px!important}.py-md-150{padding-bottom:24px!important;padding-top:24px!important}.p-md-200{padding:32px!important}.pt-md-200{padding-top:32px!important}.pr-md-200{padding-right:32px!important}.pb-md-200{padding-bottom:32px!important}.pl-md-200,.px-md-200{padding-left:32px!important}.px-md-200{padding-right:32px!important}.py-md-200{padding-bottom:32px!important;padding-top:32px!important}.p-md-250{padding:40px!important}.pt-md-250{padding-top:40px!important}.pr-md-250{padding-right:40px!important}.pb-md-250{padding-bottom:40px!important}.pl-md-250,.px-md-250{padding-left:40px!important}.px-md-250{padding-right:40px!important}.py-md-250{padding-bottom:40px!important;padding-top:40px!important}.p-md-300{padding:48px!important}.pt-md-300{padding-top:48px!important}.pr-md-300{padding-right:48px!important}.pb-md-300{padding-bottom:48px!important}.pl-md-300,.px-md-300{padding-left:48px!important}.px-md-300{padding-right:48px!important}.py-md-300{padding-bottom:48px!important;padding-top:48px!important}.p-md-350{padding:56px!important}.pt-md-350{padding-top:56px!important}.pr-md-350{padding-right:56px!important}.pb-md-350{padding-bottom:56px!important}.pl-md-350,.px-md-350{padding-left:56px!important}.px-md-350{padding-right:56px!important}.py-md-350{padding-bottom:56px!important;padding-top:56px!important}.p-md-400{padding:64px!important}.pt-md-400{padding-top:64px!important}.pr-md-400{padding-right:64px!important}.pb-md-400{padding-bottom:64px!important}.pl-md-400,.px-md-400{padding-left:64px!important}.px-md-400{padding-right:64px!important}.py-md-400{padding-bottom:64px!important;padding-top:64px!important}.p-md-450{padding:72px!important}.pt-md-450{padding-top:72px!important}.pr-md-450{padding-right:72px!important}.pb-md-450{padding-bottom:72px!important}.pl-md-450,.px-md-450{padding-left:72px!important}.px-md-450{padding-right:72px!important}.py-md-450{padding-bottom:72px!important;padding-top:72px!important}.p-md-500{padding:80px!important}.pt-md-500{padding-top:80px!important}.pr-md-500{padding-right:80px!important}.pb-md-500{padding-bottom:80px!important}.pl-md-500,.px-md-500{padding-left:80px!important}.px-md-500{padding-right:80px!important}.py-md-500{padding-bottom:80px!important;padding-top:80px!important}}@media (min-width:992px){.w-lg-80{width:80px!important}.w-lg-96{width:96px!important}.w-lg-128{width:128px!important}.w-lg-160{width:160px!important}.w-lg-192{width:192px!important}.w-lg-224{width:224px!important}.w-lg-256{width:256px!important}.w-lg-320{width:320px!important}.w-lg-400{width:400px!important}.w-lg-480{width:480px!important}.w-lg-768{width:768px!important}.minw-lg-80{min-width:80px!important}.minw-lg-96{min-width:96px!important}.minw-lg-128{min-width:128px!important}.minw-lg-160{min-width:160px!important}.minw-lg-192{min-width:192px!important}.minw-lg-224{min-width:224px!important}.minw-lg-256{min-width:256px!important}.minw-lg-320{min-width:320px!important}.minw-lg-400{min-width:400px!important}.minw-lg-480{min-width:480px!important}.minw-lg-768{min-width:768px!important}.maxw-lg-80{max-width:80px!important}.maxw-lg-96{max-width:96px!important}.maxw-lg-128{max-width:128px!important}.maxw-lg-160{max-width:160px!important}.maxw-lg-192{max-width:192px!important}.maxw-lg-224{max-width:224px!important}.maxw-lg-256{max-width:256px!important}.maxw-lg-320{max-width:320px!important}.maxw-lg-400{max-width:400px!important}.maxw-lg-480{max-width:480px!important}.maxw-lg-768{max-width:768px!important}.w-lg-auto{width:auto!important}.minw-lg-auto{min-width:auto!important}.maxw-lg-auto{max-width:auto!important}.w-lg-100p{width:100%!important}.h-lg-100p{height:100%!important}.m-lg-0{margin:0!important}.mt-lg-0{margin-top:0!important}.mr-lg-0{margin-right:0!important}.mb-lg-0{margin-bottom:0!important}.ml-lg-0,.mx-lg-0{margin-left:0!important}.mx-lg-0{margin-right:0!important}.my-lg-0{margin-bottom:0!important;margin-top:0!important}.m-lg-25{margin:4px!important}.mt-lg-25{margin-top:4px!important}.mr-lg-25{margin-right:4px!important}.mb-lg-25{margin-bottom:4px!important}.ml-lg-25,.mx-lg-25{margin-left:4px!important}.mx-lg-25{margin-right:4px!important}.my-lg-25{margin-bottom:4px!important;margin-top:4px!important}.m-lg-50{margin:8px!important}.mt-lg-50{margin-top:8px!important}.mr-lg-50{margin-right:8px!important}.mb-lg-50{margin-bottom:8px!important}.ml-lg-50,.mx-lg-50{margin-left:8px!important}.mx-lg-50{margin-right:8px!important}.my-lg-50{margin-bottom:8px!important;margin-top:8px!important}.m-lg-75{margin:12px!important}.mt-lg-75{margin-top:12px!important}.mr-lg-75{margin-right:12px!important}.mb-lg-75{margin-bottom:12px!important}.ml-lg-75,.mx-lg-75{margin-left:12px!important}.mx-lg-75{margin-right:12px!important}.my-lg-75{margin-bottom:12px!important;margin-top:12px!important}.m-lg-100{margin:16px!important}.mt-lg-100{margin-top:16px!important}.mr-lg-100{margin-right:16px!important}.mb-lg-100{margin-bottom:16px!important}.ml-lg-100,.mx-lg-100{margin-left:16px!important}.mx-lg-100{margin-right:16px!important}.my-lg-100{margin-bottom:16px!important;margin-top:16px!important}.m-lg-125{margin:20px!important}.mt-lg-125{margin-top:20px!important}.mr-lg-125{margin-right:20px!important}.mb-lg-125{margin-bottom:20px!important}.ml-lg-125,.mx-lg-125{margin-left:20px!important}.mx-lg-125{margin-right:20px!important}.my-lg-125{margin-bottom:20px!important;margin-top:20px!important}.m-lg-150{margin:24px!important}.mt-lg-150{margin-top:24px!important}.mr-lg-150{margin-right:24px!important}.mb-lg-150{margin-bottom:24px!important}.ml-lg-150,.mx-lg-150{margin-left:24px!important}.mx-lg-150{margin-right:24px!important}.my-lg-150{margin-bottom:24px!important;margin-top:24px!important}.m-lg-200{margin:32px!important}.mt-lg-200{margin-top:32px!important}.mr-lg-200{margin-right:32px!important}.mb-lg-200{margin-bottom:32px!important}.ml-lg-200,.mx-lg-200{margin-left:32px!important}.mx-lg-200{margin-right:32px!important}.my-lg-200{margin-bottom:32px!important;margin-top:32px!important}.m-lg-250{margin:40px!important}.mt-lg-250{margin-top:40px!important}.mr-lg-250{margin-right:40px!important}.mb-lg-250{margin-bottom:40px!important}.ml-lg-250,.mx-lg-250{margin-left:40px!important}.mx-lg-250{margin-right:40px!important}.my-lg-250{margin-bottom:40px!important;margin-top:40px!important}.m-lg-300{margin:48px!important}.mt-lg-300{margin-top:48px!important}.mr-lg-300{margin-right:48px!important}.mb-lg-300{margin-bottom:48px!important}.ml-lg-300,.mx-lg-300{margin-left:48px!important}.mx-lg-300{margin-right:48px!important}.my-lg-300{margin-bottom:48px!important;margin-top:48px!important}.m-lg-350{margin:56px!important}.mt-lg-350{margin-top:56px!important}.mr-lg-350{margin-right:56px!important}.mb-lg-350{margin-bottom:56px!important}.ml-lg-350,.mx-lg-350{margin-left:56px!important}.mx-lg-350{margin-right:56px!important}.my-lg-350{margin-bottom:56px!important;margin-top:56px!important}.m-lg-400{margin:64px!important}.mt-lg-400{margin-top:64px!important}.mr-lg-400{margin-right:64px!important}.mb-lg-400{margin-bottom:64px!important}.ml-lg-400,.mx-lg-400{margin-left:64px!important}.mx-lg-400{margin-right:64px!important}.my-lg-400{margin-bottom:64px!important;margin-top:64px!important}.m-lg-450{margin:72px!important}.mt-lg-450{margin-top:72px!important}.mr-lg-450{margin-right:72px!important}.mb-lg-450{margin-bottom:72px!important}.ml-lg-450,.mx-lg-450{margin-left:72px!important}.mx-lg-450{margin-right:72px!important}.my-lg-450{margin-bottom:72px!important;margin-top:72px!important}.m-lg-500{margin:80px!important}.mt-lg-500{margin-top:80px!important}.mr-lg-500{margin-right:80px!important}.mb-lg-500{margin-bottom:80px!important}.ml-lg-500,.mx-lg-500{margin-left:80px!important}.mx-lg-500{margin-right:80px!important}.my-lg-500{margin-bottom:80px!important;margin-top:80px!important}.p-lg-0{padding:0!important}.pt-lg-0{padding-top:0!important}.pr-lg-0{padding-right:0!important}.pb-lg-0{padding-bottom:0!important}.pl-lg-0,.px-lg-0{padding-left:0!important}.px-lg-0{padding-right:0!important}.py-lg-0{padding-bottom:0!important;padding-top:0!important}.p-lg-25{padding:4px!important}.pt-lg-25{padding-top:4px!important}.pr-lg-25{padding-right:4px!important}.pb-lg-25{padding-bottom:4px!important}.pl-lg-25,.px-lg-25{padding-left:4px!important}.px-lg-25{padding-right:4px!important}.py-lg-25{padding-bottom:4px!important;padding-top:4px!important}.p-lg-50{padding:8px!important}.pt-lg-50{padding-top:8px!important}.pr-lg-50{padding-right:8px!important}.pb-lg-50{padding-bottom:8px!important}.pl-lg-50,.px-lg-50{padding-left:8px!important}.px-lg-50{padding-right:8px!important}.py-lg-50{padding-bottom:8px!important;padding-top:8px!important}.p-lg-75{padding:12px!important}.pt-lg-75{padding-top:12px!important}.pr-lg-75{padding-right:12px!important}.pb-lg-75{padding-bottom:12px!important}.pl-lg-75,.px-lg-75{padding-left:12px!important}.px-lg-75{padding-right:12px!important}.py-lg-75{padding-bottom:12px!important;padding-top:12px!important}.p-lg-100{padding:16px!important}.pt-lg-100{padding-top:16px!important}.pr-lg-100{padding-right:16px!important}.pb-lg-100{padding-bottom:16px!important}.pl-lg-100,.px-lg-100{padding-left:16px!important}.px-lg-100{padding-right:16px!important}.py-lg-100{padding-bottom:16px!important;padding-top:16px!important}.p-lg-125{padding:20px!important}.pt-lg-125{padding-top:20px!important}.pr-lg-125{padding-right:20px!important}.pb-lg-125{padding-bottom:20px!important}.pl-lg-125,.px-lg-125{padding-left:20px!important}.px-lg-125{padding-right:20px!important}.py-lg-125{padding-bottom:20px!important;padding-top:20px!important}.p-lg-150{padding:24px!important}.pt-lg-150{padding-top:24px!important}.pr-lg-150{padding-right:24px!important}.pb-lg-150{padding-bottom:24px!important}.pl-lg-150,.px-lg-150{padding-left:24px!important}.px-lg-150{padding-right:24px!important}.py-lg-150{padding-bottom:24px!important;padding-top:24px!important}.p-lg-200{padding:32px!important}.pt-lg-200{padding-top:32px!important}.pr-lg-200{padding-right:32px!important}.pb-lg-200{padding-bottom:32px!important}.pl-lg-200,.px-lg-200{padding-left:32px!important}.px-lg-200{padding-right:32px!important}.py-lg-200{padding-bottom:32px!important;padding-top:32px!important}.p-lg-250{padding:40px!important}.pt-lg-250{padding-top:40px!important}.pr-lg-250{padding-right:40px!important}.pb-lg-250{padding-bottom:40px!important}.pl-lg-250,.px-lg-250{padding-left:40px!important}.px-lg-250{padding-right:40px!important}.py-lg-250{padding-bottom:40px!important;padding-top:40px!important}.p-lg-300{padding:48px!important}.pt-lg-300{padding-top:48px!important}.pr-lg-300{padding-right:48px!important}.pb-lg-300{padding-bottom:48px!important}.pl-lg-300,.px-lg-300{padding-left:48px!important}.px-lg-300{padding-right:48px!important}.py-lg-300{padding-bottom:48px!important;padding-top:48px!important}.p-lg-350{padding:56px!important}.pt-lg-350{padding-top:56px!important}.pr-lg-350{padding-right:56px!important}.pb-lg-350{padding-bottom:56px!important}.pl-lg-350,.px-lg-350{padding-left:56px!important}.px-lg-350{padding-right:56px!important}.py-lg-350{padding-bottom:56px!important;padding-top:56px!important}.p-lg-400{padding:64px!important}.pt-lg-400{padding-top:64px!important}.pr-lg-400{padding-right:64px!important}.pb-lg-400{padding-bottom:64px!important}.pl-lg-400,.px-lg-400{padding-left:64px!important}.px-lg-400{padding-right:64px!important}.py-lg-400{padding-bottom:64px!important;padding-top:64px!important}.p-lg-450{padding:72px!important}.pt-lg-450{padding-top:72px!important}.pr-lg-450{padding-right:72px!important}.pb-lg-450{padding-bottom:72px!important}.pl-lg-450,.px-lg-450{padding-left:72px!important}.px-lg-450{padding-right:72px!important}.py-lg-450{padding-bottom:72px!important;padding-top:72px!important}.p-lg-500{padding:80px!important}.pt-lg-500{padding-top:80px!important}.pr-lg-500{padding-right:80px!important}.pb-lg-500{padding-bottom:80px!important}.pl-lg-500,.px-lg-500{padding-left:80px!important}.px-lg-500{padding-right:80px!important}.py-lg-500{padding-bottom:80px!important;padding-top:80px!important}}@media (min-width:1200px){.w-xl-80{width:80px!important}.w-xl-96{width:96px!important}.w-xl-128{width:128px!important}.w-xl-160{width:160px!important}.w-xl-192{width:192px!important}.w-xl-224{width:224px!important}.w-xl-256{width:256px!important}.w-xl-320{width:320px!important}.w-xl-400{width:400px!important}.w-xl-480{width:480px!important}.w-xl-768{width:768px!important}.minw-xl-80{min-width:80px!important}.minw-xl-96{min-width:96px!important}.minw-xl-128{min-width:128px!important}.minw-xl-160{min-width:160px!important}.minw-xl-192{min-width:192px!important}.minw-xl-224{min-width:224px!important}.minw-xl-256{min-width:256px!important}.minw-xl-320{min-width:320px!important}.minw-xl-400{min-width:400px!important}.minw-xl-480{min-width:480px!important}.minw-xl-768{min-width:768px!important}.maxw-xl-80{max-width:80px!important}.maxw-xl-96{max-width:96px!important}.maxw-xl-128{max-width:128px!important}.maxw-xl-160{max-width:160px!important}.maxw-xl-192{max-width:192px!important}.maxw-xl-224{max-width:224px!important}.maxw-xl-256{max-width:256px!important}.maxw-xl-320{max-width:320px!important}.maxw-xl-400{max-width:400px!important}.maxw-xl-480{max-width:480px!important}.maxw-xl-768{max-width:768px!important}.w-xl-auto{width:auto!important}.minw-xl-auto{min-width:auto!important}.maxw-xl-auto{max-width:auto!important}.w-xl-100p{width:100%!important}.h-xl-100p{height:100%!important}.m-xl-0{margin:0!important}.mt-xl-0{margin-top:0!important}.mr-xl-0{margin-right:0!important}.mb-xl-0{margin-bottom:0!important}.ml-xl-0,.mx-xl-0{margin-left:0!important}.mx-xl-0{margin-right:0!important}.my-xl-0{margin-bottom:0!important;margin-top:0!important}.m-xl-25{margin:4px!important}.mt-xl-25{margin-top:4px!important}.mr-xl-25{margin-right:4px!important}.mb-xl-25{margin-bottom:4px!important}.ml-xl-25,.mx-xl-25{margin-left:4px!important}.mx-xl-25{margin-right:4px!important}.my-xl-25{margin-bottom:4px!important;margin-top:4px!important}.m-xl-50{margin:8px!important}.mt-xl-50{margin-top:8px!important}.mr-xl-50{margin-right:8px!important}.mb-xl-50{margin-bottom:8px!important}.ml-xl-50,.mx-xl-50{margin-left:8px!important}.mx-xl-50{margin-right:8px!important}.my-xl-50{margin-bottom:8px!important;margin-top:8px!important}.m-xl-75{margin:12px!important}.mt-xl-75{margin-top:12px!important}.mr-xl-75{margin-right:12px!important}.mb-xl-75{margin-bottom:12px!important}.ml-xl-75,.mx-xl-75{margin-left:12px!important}.mx-xl-75{margin-right:12px!important}.my-xl-75{margin-bottom:12px!important;margin-top:12px!important}.m-xl-100{margin:16px!important}.mt-xl-100{margin-top:16px!important}.mr-xl-100{margin-right:16px!important}.mb-xl-100{margin-bottom:16px!important}.ml-xl-100,.mx-xl-100{margin-left:16px!important}.mx-xl-100{margin-right:16px!important}.my-xl-100{margin-bottom:16px!important;margin-top:16px!important}.m-xl-125{margin:20px!important}.mt-xl-125{margin-top:20px!important}.mr-xl-125{margin-right:20px!important}.mb-xl-125{margin-bottom:20px!important}.ml-xl-125,.mx-xl-125{margin-left:20px!important}.mx-xl-125{margin-right:20px!important}.my-xl-125{margin-bottom:20px!important;margin-top:20px!important}.m-xl-150{margin:24px!important}.mt-xl-150{margin-top:24px!important}.mr-xl-150{margin-right:24px!important}.mb-xl-150{margin-bottom:24px!important}.ml-xl-150,.mx-xl-150{margin-left:24px!important}.mx-xl-150{margin-right:24px!important}.my-xl-150{margin-bottom:24px!important;margin-top:24px!important}.m-xl-200{margin:32px!important}.mt-xl-200{margin-top:32px!important}.mr-xl-200{margin-right:32px!important}.mb-xl-200{margin-bottom:32px!important}.ml-xl-200,.mx-xl-200{margin-left:32px!important}.mx-xl-200{margin-right:32px!important}.my-xl-200{margin-bottom:32px!important;margin-top:32px!important}.m-xl-250{margin:40px!important}.mt-xl-250{margin-top:40px!important}.mr-xl-250{margin-right:40px!important}.mb-xl-250{margin-bottom:40px!important}.ml-xl-250,.mx-xl-250{margin-left:40px!important}.mx-xl-250{margin-right:40px!important}.my-xl-250{margin-bottom:40px!important;margin-top:40px!important}.m-xl-300{margin:48px!important}.mt-xl-300{margin-top:48px!important}.mr-xl-300{margin-right:48px!important}.mb-xl-300{margin-bottom:48px!important}.ml-xl-300,.mx-xl-300{margin-left:48px!important}.mx-xl-300{margin-right:48px!important}.my-xl-300{margin-bottom:48px!important;margin-top:48px!important}.m-xl-350{margin:56px!important}.mt-xl-350{margin-top:56px!important}.mr-xl-350{margin-right:56px!important}.mb-xl-350{margin-bottom:56px!important}.ml-xl-350,.mx-xl-350{margin-left:56px!important}.mx-xl-350{margin-right:56px!important}.my-xl-350{margin-bottom:56px!important;margin-top:56px!important}.m-xl-400{margin:64px!important}.mt-xl-400{margin-top:64px!important}.mr-xl-400{margin-right:64px!important}.mb-xl-400{margin-bottom:64px!important}.ml-xl-400,.mx-xl-400{margin-left:64px!important}.mx-xl-400{margin-right:64px!important}.my-xl-400{margin-bottom:64px!important;margin-top:64px!important}.m-xl-450{margin:72px!important}.mt-xl-450{margin-top:72px!important}.mr-xl-450{margin-right:72px!important}.mb-xl-450{margin-bottom:72px!important}.ml-xl-450,.mx-xl-450{margin-left:72px!important}.mx-xl-450{margin-right:72px!important}.my-xl-450{margin-bottom:72px!important;margin-top:72px!important}.m-xl-500{margin:80px!important}.mt-xl-500{margin-top:80px!important}.mr-xl-500{margin-right:80px!important}.mb-xl-500{margin-bottom:80px!important}.ml-xl-500,.mx-xl-500{margin-left:80px!important}.mx-xl-500{margin-right:80px!important}.my-xl-500{margin-bottom:80px!important;margin-top:80px!important}.p-xl-0{padding:0!important}.pt-xl-0{padding-top:0!important}.pr-xl-0{padding-right:0!important}.pb-xl-0{padding-bottom:0!important}.pl-xl-0,.px-xl-0{padding-left:0!important}.px-xl-0{padding-right:0!important}.py-xl-0{padding-bottom:0!important;padding-top:0!important}.p-xl-25{padding:4px!important}.pt-xl-25{padding-top:4px!important}.pr-xl-25{padding-right:4px!important}.pb-xl-25{padding-bottom:4px!important}.pl-xl-25,.px-xl-25{padding-left:4px!important}.px-xl-25{padding-right:4px!important}.py-xl-25{padding-bottom:4px!important;padding-top:4px!important}.p-xl-50{padding:8px!important}.pt-xl-50{padding-top:8px!important}.pr-xl-50{padding-right:8px!important}.pb-xl-50{padding-bottom:8px!important}.pl-xl-50,.px-xl-50{padding-left:8px!important}.px-xl-50{padding-right:8px!important}.py-xl-50{padding-bottom:8px!important;padding-top:8px!important}.p-xl-75{padding:12px!important}.pt-xl-75{padding-top:12px!important}.pr-xl-75{padding-right:12px!important}.pb-xl-75{padding-bottom:12px!important}.pl-xl-75,.px-xl-75{padding-left:12px!important}.px-xl-75{padding-right:12px!important}.py-xl-75{padding-bottom:12px!important;padding-top:12px!important}.p-xl-100{padding:16px!important}.pt-xl-100{padding-top:16px!important}.pr-xl-100{padding-right:16px!important}.pb-xl-100{padding-bottom:16px!important}.pl-xl-100,.px-xl-100{padding-left:16px!important}.px-xl-100{padding-right:16px!important}.py-xl-100{padding-bottom:16px!important;padding-top:16px!important}.p-xl-125{padding:20px!important}.pt-xl-125{padding-top:20px!important}.pr-xl-125{padding-right:20px!important}.pb-xl-125{padding-bottom:20px!important}.pl-xl-125,.px-xl-125{padding-left:20px!important}.px-xl-125{padding-right:20px!important}.py-xl-125{padding-bottom:20px!important;padding-top:20px!important}.p-xl-150{padding:24px!important}.pt-xl-150{padding-top:24px!important}.pr-xl-150{padding-right:24px!important}.pb-xl-150{padding-bottom:24px!important}.pl-xl-150,.px-xl-150{padding-left:24px!important}.px-xl-150{padding-right:24px!important}.py-xl-150{padding-bottom:24px!important;padding-top:24px!important}.p-xl-200{padding:32px!important}.pt-xl-200{padding-top:32px!important}.pr-xl-200{padding-right:32px!important}.pb-xl-200{padding-bottom:32px!important}.pl-xl-200,.px-xl-200{padding-left:32px!important}.px-xl-200{padding-right:32px!important}.py-xl-200{padding-bottom:32px!important;padding-top:32px!important}.p-xl-250{padding:40px!important}.pt-xl-250{padding-top:40px!important}.pr-xl-250{padding-right:40px!important}.pb-xl-250{padding-bottom:40px!important}.pl-xl-250,.px-xl-250{padding-left:40px!important}.px-xl-250{padding-right:40px!important}.py-xl-250{padding-bottom:40px!important;padding-top:40px!important}.p-xl-300{padding:48px!important}.pt-xl-300{padding-top:48px!important}.pr-xl-300{padding-right:48px!important}.pb-xl-300{padding-bottom:48px!important}.pl-xl-300,.px-xl-300{padding-left:48px!important}.px-xl-300{padding-right:48px!important}.py-xl-300{padding-bottom:48px!important;padding-top:48px!important}.p-xl-350{padding:56px!important}.pt-xl-350{padding-top:56px!important}.pr-xl-350{padding-right:56px!important}.pb-xl-350{padding-bottom:56px!important}.pl-xl-350,.px-xl-350{padding-left:56px!important}.px-xl-350{padding-right:56px!important}.py-xl-350{padding-bottom:56px!important;padding-top:56px!important}.p-xl-400{padding:64px!important}.pt-xl-400{padding-top:64px!important}.pr-xl-400{padding-right:64px!important}.pb-xl-400{padding-bottom:64px!important}.pl-xl-400,.px-xl-400{padding-left:64px!important}.px-xl-400{padding-right:64px!important}.py-xl-400{padding-bottom:64px!important;padding-top:64px!important}.p-xl-450{padding:72px!important}.pt-xl-450{padding-top:72px!important}.pr-xl-450{padding-right:72px!important}.pb-xl-450{padding-bottom:72px!important}.pl-xl-450,.px-xl-450{padding-left:72px!important}.px-xl-450{padding-right:72px!important}.py-xl-450{padding-bottom:72px!important;padding-top:72px!important}.p-xl-500{padding:80px!important}.pt-xl-500{padding-top:80px!important}.pr-xl-500{padding-right:80px!important}.pb-xl-500{padding-bottom:80px!important}.pl-xl-500,.px-xl-500{padding-left:80px!important}.px-xl-500{padding-right:80px!important}.py-xl-500{padding-bottom:80px!important;padding-top:80px!important}}@media (min-width:1536px){.w-xxl-80{width:80px!important}.w-xxl-96{width:96px!important}.w-xxl-128{width:128px!important}.w-xxl-160{width:160px!important}.w-xxl-192{width:192px!important}.w-xxl-224{width:224px!important}.w-xxl-256{width:256px!important}.w-xxl-320{width:320px!important}.w-xxl-400{width:400px!important}.w-xxl-480{width:480px!important}.w-xxl-768{width:768px!important}.minw-xxl-80{min-width:80px!important}.minw-xxl-96{min-width:96px!important}.minw-xxl-128{min-width:128px!important}.minw-xxl-160{min-width:160px!important}.minw-xxl-192{min-width:192px!important}.minw-xxl-224{min-width:224px!important}.minw-xxl-256{min-width:256px!important}.minw-xxl-320{min-width:320px!important}.minw-xxl-400{min-width:400px!important}.minw-xxl-480{min-width:480px!important}.minw-xxl-768{min-width:768px!important}.maxw-xxl-80{max-width:80px!important}.maxw-xxl-96{max-width:96px!important}.maxw-xxl-128{max-width:128px!important}.maxw-xxl-160{max-width:160px!important}.maxw-xxl-192{max-width:192px!important}.maxw-xxl-224{max-width:224px!important}.maxw-xxl-256{max-width:256px!important}.maxw-xxl-320{max-width:320px!important}.maxw-xxl-400{max-width:400px!important}.maxw-xxl-480{max-width:480px!important}.maxw-xxl-768{max-width:768px!important}.w-xxl-auto{width:auto!important}.minw-xxl-auto{min-width:auto!important}.maxw-xxl-auto{max-width:auto!important}.w-xxl-100p{width:100%!important}.h-xxl-100p{height:100%!important}.m-xxl-0{margin:0!important}.mt-xxl-0{margin-top:0!important}.mr-xxl-0{margin-right:0!important}.mb-xxl-0{margin-bottom:0!important}.ml-xxl-0,.mx-xxl-0{margin-left:0!important}.mx-xxl-0{margin-right:0!important}.my-xxl-0{margin-bottom:0!important;margin-top:0!important}.m-xxl-25{margin:4px!important}.mt-xxl-25{margin-top:4px!important}.mr-xxl-25{margin-right:4px!important}.mb-xxl-25{margin-bottom:4px!important}.ml-xxl-25,.mx-xxl-25{margin-left:4px!important}.mx-xxl-25{margin-right:4px!important}.my-xxl-25{margin-bottom:4px!important;margin-top:4px!important}.m-xxl-50{margin:8px!important}.mt-xxl-50{margin-top:8px!important}.mr-xxl-50{margin-right:8px!important}.mb-xxl-50{margin-bottom:8px!important}.ml-xxl-50,.mx-xxl-50{margin-left:8px!important}.mx-xxl-50{margin-right:8px!important}.my-xxl-50{margin-bottom:8px!important;margin-top:8px!important}.m-xxl-75{margin:12px!important}.mt-xxl-75{margin-top:12px!important}.mr-xxl-75{margin-right:12px!important}.mb-xxl-75{margin-bottom:12px!important}.ml-xxl-75,.mx-xxl-75{margin-left:12px!important}.mx-xxl-75{margin-right:12px!important}.my-xxl-75{margin-bottom:12px!important;margin-top:12px!important}.m-xxl-100{margin:16px!important}.mt-xxl-100{margin-top:16px!important}.mr-xxl-100{margin-right:16px!important}.mb-xxl-100{margin-bottom:16px!important}.ml-xxl-100,.mx-xxl-100{margin-left:16px!important}.mx-xxl-100{margin-right:16px!important}.my-xxl-100{margin-bottom:16px!important;margin-top:16px!important}.m-xxl-125{margin:20px!important}.mt-xxl-125{margin-top:20px!important}.mr-xxl-125{margin-right:20px!important}.mb-xxl-125{margin-bottom:20px!important}.ml-xxl-125,.mx-xxl-125{margin-left:20px!important}.mx-xxl-125{margin-right:20px!important}.my-xxl-125{margin-bottom:20px!important;margin-top:20px!important}.m-xxl-150{margin:24px!important}.mt-xxl-150{margin-top:24px!important}.mr-xxl-150{margin-right:24px!important}.mb-xxl-150{margin-bottom:24px!important}.ml-xxl-150,.mx-xxl-150{margin-left:24px!important}.mx-xxl-150{margin-right:24px!important}.my-xxl-150{margin-bottom:24px!important;margin-top:24px!important}.m-xxl-200{margin:32px!important}.mt-xxl-200{margin-top:32px!important}.mr-xxl-200{margin-right:32px!important}.mb-xxl-200{margin-bottom:32px!important}.ml-xxl-200,.mx-xxl-200{margin-left:32px!important}.mx-xxl-200{margin-right:32px!important}.my-xxl-200{margin-bottom:32px!important;margin-top:32px!important}.m-xxl-250{margin:40px!important}.mt-xxl-250{margin-top:40px!important}.mr-xxl-250{margin-right:40px!important}.mb-xxl-250{margin-bottom:40px!important}.ml-xxl-250,.mx-xxl-250{margin-left:40px!important}.mx-xxl-250{margin-right:40px!important}.my-xxl-250{margin-bottom:40px!important;margin-top:40px!important}.m-xxl-300{margin:48px!important}.mt-xxl-300{margin-top:48px!important}.mr-xxl-300{margin-right:48px!important}.mb-xxl-300{margin-bottom:48px!important}.ml-xxl-300,.mx-xxl-300{margin-left:48px!important}.mx-xxl-300{margin-right:48px!important}.my-xxl-300{margin-bottom:48px!important;margin-top:48px!important}.m-xxl-350{margin:56px!important}.mt-xxl-350{margin-top:56px!important}.mr-xxl-350{margin-right:56px!important}.mb-xxl-350{margin-bottom:56px!important}.ml-xxl-350,.mx-xxl-350{margin-left:56px!important}.mx-xxl-350{margin-right:56px!important}.my-xxl-350{margin-bottom:56px!important;margin-top:56px!important}.m-xxl-400{margin:64px!important}.mt-xxl-400{margin-top:64px!important}.mr-xxl-400{margin-right:64px!important}.mb-xxl-400{margin-bottom:64px!important}.ml-xxl-400,.mx-xxl-400{margin-left:64px!important}.mx-xxl-400{margin-right:64px!important}.my-xxl-400{margin-bottom:64px!important;margin-top:64px!important}.m-xxl-450{margin:72px!important}.mt-xxl-450{margin-top:72px!important}.mr-xxl-450{margin-right:72px!important}.mb-xxl-450{margin-bottom:72px!important}.ml-xxl-450,.mx-xxl-450{margin-left:72px!important}.mx-xxl-450{margin-right:72px!important}.my-xxl-450{margin-bottom:72px!important;margin-top:72px!important}.m-xxl-500{margin:80px!important}.mt-xxl-500{margin-top:80px!important}.mr-xxl-500{margin-right:80px!important}.mb-xxl-500{margin-bottom:80px!important}.ml-xxl-500,.mx-xxl-500{margin-left:80px!important}.mx-xxl-500{margin-right:80px!important}.my-xxl-500{margin-bottom:80px!important;margin-top:80px!important}.p-xxl-0{padding:0!important}.pt-xxl-0{padding-top:0!important}.pr-xxl-0{padding-right:0!important}.pb-xxl-0{padding-bottom:0!important}.pl-xxl-0,.px-xxl-0{padding-left:0!important}.px-xxl-0{padding-right:0!important}.py-xxl-0{padding-bottom:0!important;padding-top:0!important}.p-xxl-25{padding:4px!important}.pt-xxl-25{padding-top:4px!important}.pr-xxl-25{padding-right:4px!important}.pb-xxl-25{padding-bottom:4px!important}.pl-xxl-25,.px-xxl-25{padding-left:4px!important}.px-xxl-25{padding-right:4px!important}.py-xxl-25{padding-bottom:4px!important;padding-top:4px!important}.p-xxl-50{padding:8px!important}.pt-xxl-50{padding-top:8px!important}.pr-xxl-50{padding-right:8px!important}.pb-xxl-50{padding-bottom:8px!important}.pl-xxl-50,.px-xxl-50{padding-left:8px!important}.px-xxl-50{padding-right:8px!important}.py-xxl-50{padding-bottom:8px!important;padding-top:8px!important}.p-xxl-75{padding:12px!important}.pt-xxl-75{padding-top:12px!important}.pr-xxl-75{padding-right:12px!important}.pb-xxl-75{padding-bottom:12px!important}.pl-xxl-75,.px-xxl-75{padding-left:12px!important}.px-xxl-75{padding-right:12px!important}.py-xxl-75{padding-bottom:12px!important;padding-top:12px!important}.p-xxl-100{padding:16px!important}.pt-xxl-100{padding-top:16px!important}.pr-xxl-100{padding-right:16px!important}.pb-xxl-100{padding-bottom:16px!important}.pl-xxl-100,.px-xxl-100{padding-left:16px!important}.px-xxl-100{padding-right:16px!important}.py-xxl-100{padding-bottom:16px!important;padding-top:16px!important}.p-xxl-125{padding:20px!important}.pt-xxl-125{padding-top:20px!important}.pr-xxl-125{padding-right:20px!important}.pb-xxl-125{padding-bottom:20px!important}.pl-xxl-125,.px-xxl-125{padding-left:20px!important}.px-xxl-125{padding-right:20px!important}.py-xxl-125{padding-bottom:20px!important;padding-top:20px!important}.p-xxl-150{padding:24px!important}.pt-xxl-150{padding-top:24px!important}.pr-xxl-150{padding-right:24px!important}.pb-xxl-150{padding-bottom:24px!important}.pl-xxl-150,.px-xxl-150{padding-left:24px!important}.px-xxl-150{padding-right:24px!important}.py-xxl-150{padding-bottom:24px!important;padding-top:24px!important}.p-xxl-200{padding:32px!important}.pt-xxl-200{padding-top:32px!important}.pr-xxl-200{padding-right:32px!important}.pb-xxl-200{padding-bottom:32px!important}.pl-xxl-200,.px-xxl-200{padding-left:32px!important}.px-xxl-200{padding-right:32px!important}.py-xxl-200{padding-bottom:32px!important;padding-top:32px!important}.p-xxl-250{padding:40px!important}.pt-xxl-250{padding-top:40px!important}.pr-xxl-250{padding-right:40px!important}.pb-xxl-250{padding-bottom:40px!important}.pl-xxl-250,.px-xxl-250{padding-left:40px!important}.px-xxl-250{padding-right:40px!important}.py-xxl-250{padding-bottom:40px!important;padding-top:40px!important}.p-xxl-300{padding:48px!important}.pt-xxl-300{padding-top:48px!important}.pr-xxl-300{padding-right:48px!important}.pb-xxl-300{padding-bottom:48px!important}.pl-xxl-300,.px-xxl-300{padding-left:48px!important}.px-xxl-300{padding-right:48px!important}.py-xxl-300{padding-bottom:48px!important;padding-top:48px!important}.p-xxl-350{padding:56px!important}.pt-xxl-350{padding-top:56px!important}.pr-xxl-350{padding-right:56px!important}.pb-xxl-350{padding-bottom:56px!important}.pl-xxl-350,.px-xxl-350{padding-left:56px!important}.px-xxl-350{padding-right:56px!important}.py-xxl-350{padding-bottom:56px!important;padding-top:56px!important}.p-xxl-400{padding:64px!important}.pt-xxl-400{padding-top:64px!important}.pr-xxl-400{padding-right:64px!important}.pb-xxl-400{padding-bottom:64px!important}.pl-xxl-400,.px-xxl-400{padding-left:64px!important}.px-xxl-400{padding-right:64px!important}.py-xxl-400{padding-bottom:64px!important;padding-top:64px!important}.p-xxl-450{padding:72px!important}.pt-xxl-450{padding-top:72px!important}.pr-xxl-450{padding-right:72px!important}.pb-xxl-450{padding-bottom:72px!important}.pl-xxl-450,.px-xxl-450{padding-left:72px!important}.px-xxl-450{padding-right:72px!important}.py-xxl-450{padding-bottom:72px!important;padding-top:72px!important}.p-xxl-500{padding:80px!important}.pt-xxl-500{padding-top:80px!important}.pr-xxl-500{padding-right:80px!important}.pb-xxl-500{padding-bottom:80px!important}.pl-xxl-500,.px-xxl-500{padding-left:80px!important}.px-xxl-500{padding-right:80px!important}.py-xxl-500{padding-bottom:80px!important;padding-top:80px!important}}.ads-highlight{background-color:#fae085}.tippy-arrow{color:#363840}.tippy-box{background-color:#363840}.ads-theme{color:#363840;font-family:Open Sans,sans-serif;font-size:14px;line-height:20px}.ads-theme,.ads-theme *,.ads-theme :after,.ads-theme :before{box-sizing:border-box}.ads-theme h1,.ads-theme h2,.ads-theme h3,.ads-theme h4,.ads-theme h5,.ads-theme h6{margin:0}.ads-theme a{border-radius:3px;color:#365ef6;margin:-1px -2px;padding:1px 2px}.ads-theme a:focus{box-shadow:0 0 0 4px #365ef64d;outline:none}@supports not selector(::-webkit-scrollbar){.ads-theme *{scrollbar-color:#0000004d #fff0;scrollbar-width:thin}}.ads-theme ::-webkit-scrollbar{height:16px;width:16px}.ads-theme ::-webkit-scrollbar-track{background-color:#fff0;transition:background-color .4s linear}.ads-theme ::-webkit-scrollbar-track:hover{background-color:#ffffff1a}.ads-theme ::-webkit-scrollbar-thumb{background-clip:padding-box;background-color:#0000004d;border:5px solid #0000;border-radius:8px;min-height:35px}.ads-theme ::-webkit-scrollbar-thumb:hover{background-color:#0000006b}body,button,input,select,textarea{font-family:Open Sans,sans-serif}";
window.ADS.injectStyle(css$3,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/Theme/Theme.scss");

/* eslint-disable @typescript-eslint/no-explicit-any */
const DEFAULT_LOCALE = 'en-US';
const SUPPORTED_LOCALES = ['en-US', 'en-CA', 'en-GB', 'fr-CA'];
function mergeTranslations(translations, key) {
    const mEnUS = Object.assign(Object.assign(Object.assign({}, enUS), (translations ? translations.en : {})), (translations ? translations['en-US'] : {}));
    const mEnCA = Object.assign(Object.assign(Object.assign({}, enCA), (translations ? translations.en : {})), (translations ? translations['en-CA'] : {}));
    const mEnGB = Object.assign(Object.assign(Object.assign({}, enGB), (translations ? translations.en : {})), (translations ? translations['en-GB'] : {}));
    const mFrCA = Object.assign(Object.assign(Object.assign({}, frCA), (translations ? translations.fr : {})), (translations ? translations['fr-CA'] : {}));
    return key
        ? {
            'en-US': { [key]: mEnUS },
            'en-CA': { [key]: mEnCA },
            'en-GB': { [key]: mEnGB },
            'fr-CA': { [key]: mFrCA }
        }
        : {
            'en-US': mEnUS,
            'en-CA': mEnCA,
            'en-GB': mEnGB,
            'fr-CA': mFrCA
        };
}
class i18nWrapper {
    constructor(initLocale, localeData, translations, pseudo = false, i18NextConfig = null, cb) {
        this.isInitialized = false;
        this.pseudo = new Pseudo({
            enabled: pseudo,
            languageToPseudo: initLocale
        });
        this.localeData = localeData;
        this.instance = i18next.createInstance();
        // The init call will call a callback after everything is setup
        this.instance.init(Object.assign(Object.assign({ fallbackLng: DEFAULT_LOCALE, lng: initLocale, saveMissing: false }, i18NextConfig), { 
            // These properties ADS relies on to be set a certain way to handle it's own internal translation needs
            react: {
                bindI18nStore: 'added', // re-render when adding translations to our store,
                useSuspense: false
            }, interpolation: {
                escapeValue: false, // React has XSS protection, don't need i18next to also escape input
                formatSeparator: '|',
                // This allows us to customize how formating with the pipe is handled.
                format: (value, format, lng) => this.i18nFormat(value, format, lng),
                prefix: '{{',
                suffix: '}}'
            }, resources: mergeTranslations(translations, 'translation'), postProcess: ['pseudo'] // enable our pseudo plugin. Will only run if enabled,
         }), () => {
            cb(this);
        });
        this.instance.use(this.pseudo);
    }
    i18nFormat(value, format, lng) {
        const locale = lng !== null && lng !== void 0 ? lng : 'en-US';
        // Handle date formatting
        if (value instanceof Date) {
            return DateTime.fromJSDate(value).toFormat(format || this.localeData.date);
        }
        // Handle currency formatting
        if (format === 'currency') {
            return new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: LocaleDataMap[locale].currency
            }).format(value);
        }
        if (format === 'number') {
            return value.toLocaleString(locale);
        }
        // Default to no formatting
        return value;
    }
    enablePseudo(enabled) {
        if (enabled !== this.pseudo.options.enabled) {
            this.pseudo.configurePseudo({ enabled });
        }
    }
    setLocale(loc, data) {
        if (loc === this.instance.language) {
            return;
        }
        this.instance.changeLanguage(loc);
        // Update luxon's default locale, update our dateFormat and then finally update
        // i18next's actual language
        Settings.defaultLocale = loc;
        this.localeData = data;
        // If language changes, we need to keep our plugin in sync. It's configured to only run
        // if it's enabled AND the current langauge matches it's configured language which is silly.
        this.pseudo.configurePseudo({
            languageToPseudo: loc
        });
    }
    setTranslations(translations) {
        translations = mergeTranslations(translations);
        for (const locale of SUPPORTED_LOCALES) {
            this.instance.addResourceBundle(locale, 'translation', translations[locale], true, true);
        }
    }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// When modal count changes, we see if we need to change our scrollbar situation.
// Modals report in when they open and close, and we keep track of the number of
// open modals.
const modalCountChanged = (modalCount) => {
    document.body.style.overflow = modalCount > 0 ? 'hidden' : '';
};
// Given a locale string, return a SupportedLocale string
// along with it's localeData, or default back to the defaultLocale.
function getSupportedLocale(locale) {
    const data = LocaleDataMap[locale];
    if (data) {
        return { usedLocale: locale, localeData: data };
    }
    ADSWarn(`Locale ${locale} is not one of the supported ADS locales. Using "${DEFAULT_LOCALE}" instead.`);
    return {
        usedLocale: DEFAULT_LOCALE,
        localeData: LocaleDataMap[DEFAULT_LOCALE]
    };
}
/**
 * `<Theme>` provides the global styles like the default font-family and size. This should be at the top level of your
 * app and all ADS components should be nested inside the `<Theme>` component. */
const Theme = ({ testId, customDataProps, children, configuration, i18NextConfig, locale = 'en-US', onI18NextInit, pseudolocalization = false, translations }) => {
    const { usedLocale, localeData } = getSupportedLocale(locale);
    const [i18NextWrapper, setI18NextWrapper] = React__default.useState(null);
    React__default.useEffect(() => {
        if (!i18NextWrapper) {
            new i18nWrapper(usedLocale, localeData, translations, pseudolocalization, i18NextConfig, (wrapper) => {
                setI18NextWrapper(wrapper);
                onI18NextInit && onI18NextInit(wrapper.instance);
            });
        }
        else {
            i18NextWrapper.setLocale(usedLocale, localeData);
            i18NextWrapper.enablePseudo(pseudolocalization);
            i18NextWrapper.setTranslations(translations);
        }
    }, [
        i18NextConfig,
        i18NextWrapper,
        localeData,
        onI18NextInit,
        pseudolocalization,
        translations,
        usedLocale
    ]);
    // We have a single instance of notifications and toasts for the app and manage their
    // state here.
    const [notificationsProps, setNotificationsProps] = React__default.useState({ notifications: [] });
    const [toastsProps, setToastsProps] = React__default.useState({
        toasts: []
    });
    // Depending on how many modals are open, we need to modify the body's overflow
    // setting. If one or more are open we want overflow hidden so body doesn't have a
    // scrollbar. After all modals are closed, restore it back.
    const openModalsRef = React__default.useRef([]);
    const buildConfiguration = (configuration) => {
        return {
            dateOrderFormat: configuration === null || configuration === void 0 ? void 0 : configuration.dateOrderFormat,
            tabSelect: (configuration === null || configuration === void 0 ? void 0 : configuration.tabSelect) || false
        };
    };
    const ADSContextValue = React__default.useMemo(() => ({
        env: { scrollBarWidth: GetBrowsersScrollbarWidth() },
        locale: usedLocale,
        setNotificationState: setNotificationsProps,
        setToastState: setToastsProps,
        setModalOpenCount: (cb) => {
            openModalsRef.current = cb(openModalsRef.current);
            modalCountChanged(openModalsRef.current.length);
        },
        dateFormat: localeData.date,
        i18next: i18NextWrapper === null || i18NextWrapper === void 0 ? void 0 : i18NextWrapper.instance,
        configuration: buildConfiguration(configuration)
    }), [
        usedLocale,
        i18NextWrapper,
        setNotificationsProps,
        localeData.date,
        configuration
    ]);
    return (i18NextWrapper && (React__default.createElement(ADSContext.Provider, { value: ADSContextValue },
        React__default.createElement(I18nextProvider, { i18n: i18NextWrapper.instance },
            React__default.createElement("div", Object.assign({ "data-test": testId }, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { className: "ads-theme" }), children),
            React__default.createElement(AlertMessages, { messages: notificationsProps.notifications, type: AlertMessageType.Notification }),
            React__default.createElement(AlertMessages, { messages: toastsProps.toasts, type: AlertMessageType.Toast })))));
};

var css$2 = ".Step_module_step__2aeaa924{background:#0000;border:2px solid #0000;border-radius:5px;cursor:pointer;display:flex;gap:8px;padding:16px;position:relative;transition:border-color .15s ease-in-out,background-color .15s ease-in-out}.Step_module_step__2aeaa924 .Step_module_title__2aeaa924{color:#262860;font-size:18px;font-weight:700;line-height:28px;margin-top:2px}.Step_module_step__2aeaa924 .Step_module_description__2aeaa924{font-size:14px;line-height:20px;margin-bottom:0;margin-top:4px}.Step_module_step__2aeaa924 .Step_module_indicator__2aeaa924{align-items:center;background-color:#f1f4fd;border-radius:50%;box-shadow:inset 0 0 0 2px #aabff8;color:#262860;display:flex;flex:none;font-size:18px;font-weight:700;height:32px;justify-content:center;line-height:28px;transition:all .15s ease-in-out;width:32px}.Step_module_step__2aeaa924 .Step_module_indicator__2aeaa924:before{background-color:#aabff8;content:\" \";height:16px;position:absolute;top:0;transition:opacity .15s ease-in-out;width:2px}.Step_module_step__2aeaa924 .Step_module_indicator__2aeaa924:after{background-color:#aabff8;content:\" \";height:calc(100% - 40px);position:absolute;top:48px;transition:opacity .15s ease-in-out;width:2px}.Step_module_step__2aeaa924:hover{background-color:#fff;border-color:#aabff8}.Step_module_step__2aeaa924:focus{border-color:#365ef6!important;box-shadow:0 0 0 3px #365ef64d!important;outline:none}.Step_module_step__2aeaa924:focus .Step_module_indicator__2aeaa924:before{opacity:0}.Step_module_step__2aeaa924:focus .Step_module_indicator__2aeaa924:after{bottom:-8px;height:6px;top:unset}.Step_module_step__2aeaa924:hover .Step_module_indicator__2aeaa924:before{opacity:0;transition:opacity .15s ease-in-out}.Step_module_step__2aeaa924:hover .Step_module_indicator__2aeaa924:after{bottom:-8px;height:6px;top:unset;transition:height 50ms ease-in-out}.Step_module_step__2aeaa924:first-of-type .Step_module_indicator__2aeaa924:before,.Step_module_step__2aeaa924:last-of-type .Step_module_indicator__2aeaa924:after{opacity:0}.Step_module_step__2aeaa924.Step_module_isActive__2aeaa924{background-color:#f1f4fd;border-color:#aabff8;cursor:default}.Step_module_step__2aeaa924.Step_module_isActive__2aeaa924 .Step_module_title__2aeaa924{color:#365ef6}.Step_module_step__2aeaa924.Step_module_isActive__2aeaa924 .Step_module_indicator__2aeaa924{background-color:#365ef6;box-shadow:inset 0 0 0 2px #365ef6;color:#fff}.Step_module_step__2aeaa924.Step_module_isActive__2aeaa924 .Step_module_indicator__2aeaa924:before{opacity:0}.Step_module_step__2aeaa924.Step_module_isActive__2aeaa924 .Step_module_indicator__2aeaa924:after{bottom:-8px;height:6px;top:unset}.Step_module_step__2aeaa924.Step_module_success__2aeaa924 .Step_module_indicator__2aeaa924{background-color:#03866a;box-shadow:none}.Step_module_step__2aeaa924.Step_module_success__2aeaa924 .Step_module_title__2aeaa924{color:#03866a}.Step_module_step__2aeaa924.Step_module_error__2aeaa924 .Step_module_indicator__2aeaa924{background-color:#ea0a3b;box-shadow:none}.Step_module_step__2aeaa924.Step_module_error__2aeaa924 .Step_module_title__2aeaa924{color:#ea0a3b}";
window.ADS.injectStyle(css$2,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/WizardStepper/Step.module.scss");
var modules_95e42bd7 = {"step":"Step_module_step__2aeaa924","title":"Step_module_title__2aeaa924","description":"Step_module_description__2aeaa924","indicator":"Step_module_indicator__2aeaa924","isActive":"Step_module_isActive__2aeaa924","success":"Step_module_success__2aeaa924","error":"Step_module_error__2aeaa924"};

const cx$2 = BindStyles(modules_95e42bd7);
// Icon is only used for this Step component so far.
const SuccessIcon = () => (React__default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.53 3.24997C14.0607 3.65226 14.1563 4.39767 13.7435 4.91489L7.65658 12.542C7.4422 12.8106 7.11978 12.9766 6.77128 12.9977C6.42277 13.0189 6.08172 12.8931 5.83481 12.6525L2.35656 9.26269C1.88115 8.79936 1.88115 8.04815 2.35656 7.58482C2.83198 7.12149 3.60279 7.12149 4.07821 7.58482L6.58133 10.0243L11.8216 3.45809C12.2344 2.94087 12.9992 2.84769 13.53 3.24997Z", fill: "#fff" })));
// Icon is only used for this Step component so far.
const ErrorIcon = () => (React__default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.5C8.82843 1.5 9.5 2.17157 9.5 3V7.5C9.5 8.32843 8.82843 9 8 9C7.17157 9 6.5 8.32843 6.5 7.5V3C6.5 2.17157 7.17157 1.5 8 1.5Z", fill: "#fff" }),
    React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00002 11.4C8.88368 11.4 9.60002 12.1163 9.60002 13V13.01C9.60002 13.8936 8.88368 14.61 8.00002 14.61C7.11637 14.61 6.40002 13.8936 6.40002 13.01V13C6.40002 12.1163 7.11637 11.4 8.00002 11.4Z", fill: "#fff" })));
const Step = React__default.forwardRef(({ customDataProps, testId, active = false, step = 1, validationState, title, isFocusable = false, description, onUnmount, onActivate }, ref) => {
    // We need to track our prev active status so we know when we gain / lose activation.
    const wasActiveRef = React__default.useRef(false);
    let onStepDeactivated;
    if (validationState && typeof validationState !== 'string') {
        onStepDeactivated = validationState.onBlur;
        validationState = validationState.status;
    }
    const onDeactivation = () => {
        onStepDeactivated && onStepDeactivated();
    };
    // Track when we gain or lose activation.
    React__default.useEffect(() => {
        // If we are active, indicate that in a ref so if we go inactive we can run our onDeactivation
        // handler.
        if (active) {
            wasActiveRef.current = true;
        }
        else {
            if (wasActiveRef.current) {
                onDeactivation();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);
    // Unmount
    React__default.useEffect(() => {
        return () => onUnmount && onUnmount(step);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { ref: ref, tabIndex: isFocusable ? 0 : -1, "data-test": testId, "data-step": step, className: cx$2('step', validationState, { isActive: active }), onClick: () => onActivate && onActivate(step !== null && step !== void 0 ? step : 0) }),
        React__default.createElement("div", { className: cx$2('indicator') },
            (!validationState || validationState === FormValidationState.None) &&
                step,
            validationState === FormValidationState.Success && React__default.createElement(SuccessIcon, null),
            validationState === FormValidationState.Error && React__default.createElement(ErrorIcon, null)),
        React__default.createElement("div", null,
            React__default.createElement("h3", { className: cx$2('title') }, title),
            React__default.createElement("p", { className: cx$2('description') }, description))));
});
Step.displayName = 'Step';

var css$1 = ".WizardContent_module_content__c55e3bdc{display:none;height:100%;margin:-2px;padding:2px;width:100%}.WizardContent_module_content__c55e3bdc.WizardContent_module_isActive__c55e3bdc{display:block}";
window.ADS.injectStyle(css$1,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/WizardStepper/WizardContent.module.scss");
var modules_f16c3252 = {"content":"WizardContent_module_content__c55e3bdc","isActive":"WizardContent_module_isActive__c55e3bdc"};

const cx$1 = BindStyles(modules_f16c3252);
const WizardContent = React__default.forwardRef(({ isActive, testId, step, className, children }, ref) => {
    return (React__default.createElement("div", { ref: ref, "data-test": testId, className: cx$1('content', className, { isActive }) }, typeof children === 'function'
        ? children({ isActive, step })
        : children));
});
WizardContent.displayName = 'WizardContent';

var css = ".WizardStepper_module_wizardStepper__36455173{display:flex;flex-wrap:nowrap;height:100%;overflow:hidden}.WizardStepper_module_wizardStepper__36455173 .WizardStepper_module_steps__36455173{border-right:1px solid #cbced7;display:flex;flex:0 0 auto;position:relative;z-index:200}.WizardStepper_module_wizardStepper__36455173 .WizardStepper_module_steps__36455173 .WizardStepper_module_stepsContainer__36455173{display:flex;flex-direction:column;gap:4px;height:100%;max-width:320px;overflow:auto;padding:24px 24px 24px 4px}.WizardStepper_module_wizardStepper__36455173 .WizardStepper_module_content__36455173{display:flex;flex:1 1 auto;position:relative}.WizardStepper_module_wizardStepper__36455173 .WizardStepper_module_content__36455173 .WizardStepper_module_contentWrapper__36455173{flex:1;height:100%;overflow:auto}";
window.ADS.injectStyle(css,"/builds/appliedsystems/enterprise/user-interface/applied-design-system/src/components/WizardStepper/WizardStepper.module.scss");
var modules_d3494f2b = {"wizardStepper":"WizardStepper_module_wizardStepper__36455173","steps":"WizardStepper_module_steps__36455173","stepsContainer":"WizardStepper_module_stepsContainer__36455173","content":"WizardStepper_module_content__36455173","contentWrapper":"WizardStepper_module_contentWrapper__36455173"};

const cx = BindStyles(modules_d3494f2b);
const calcStepData = (stepsLength, activeStep) => {
    return {
        prev: activeStep === 1 ? false : activeStep - 1,
        next: activeStep === stepsLength ? false : activeStep + 1
    };
};
const WizardStepperBase = ({ customDataProps, testId, className, activeStep, onActiveStepChange, onStepDataChange, stepsClassName, contentOpts, children }) => {
    // Filter out any children that aren't a step component
    const steps = React__default.Children.toArray(children).filter((child) => {
        return child.type === Step;
    });
    if (steps.length < 1) {
        ADSWarn('WizardStepper component did not have any <Step> children.');
    }
    const stepDataRef = React__default.useRef(null);
    const [stepsDivElem, setStepsDivElem] = React__default.useState(null);
    const [contentDivElem, setContentDivElem] = React__default.useState(null);
    const activeContentElRef = React__default.useRef(null);
    // We have to maintain a map of all our steps refs so we can focus the right step
    // and respond to keyboard nav requests (arrowup / arrowdown)
    const stepsRefMap = React__default.useRef(new Map());
    const [stepsIsFocused, setStepsIsFocused] = React__default.useState(false);
    const stepsScroll = useScrollPosition(stepsDivElem);
    const contentScroll = useScrollPosition(contentDivElem);
    // We do not let activeStep be less than 1
    if (activeStep < 1) {
        activeStep = 1;
    }
    // Make sure we aren't given a step greater than the steps we have.
    if (activeStep > steps.length + 1) {
        activeStep = steps.length;
    }
    // Can be invoked by prev / next buttons when content needs to be focused.
    const focusContentFirstChild = () => {
        var _a;
        if (activeContentElRef.current) {
            const focusableChildren = GetAllFocusableElements(activeContentElRef.current);
            (_a = focusableChildren[0]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    React__default.useEffect(() => {
        // Check if our activeStep is no longer a step. If so reset it to the first step.
        if (activeStep > steps.length) {
            onActiveStepChange(1);
        }
        // Make sure activeStep if in view
        const activeStepEl = stepsRefMap.current.get(activeStep);
        ScrollIntoView(activeStepEl);
    }, [activeStep, steps.length, onActiveStepChange]);
    React__default.useEffect(() => {
        const data = calcStepData(steps.length, activeStep);
        if (onStepDataChange && !isEqual(stepDataRef.current, data)) {
            stepDataRef.current = data;
            onStepDataChange(Object.assign(Object.assign({}, data), { 
                // We have to wait a cycle for react to sync with the DOM. This prob isn't ideal.
                focusContent: () => setTimeout(focusContentFirstChild, 0) }));
        }
    }, [activeStep, onStepDataChange, steps.length]);
    const handleStepsFocus = () => {
        // Anytime our header group gets focus, we need to make all tab headers not keyboard
        // focusable as we will manage it via arrow keys.
        setStepsIsFocused(true);
    };
    const handleStepsBlur = (e) => {
        // Anytime our header group is blurred outside of the group, we need to make the active
        // tab keyboard focusable.
        OnFocusOutside(e, [stepsDivElem], () => {
            setStepsIsFocused(false);
        });
    };
    const handleArrow = (direction) => {
        const focusedStep = Number((document === null || document === void 0 ? void 0 : document.activeElement).dataset.step);
        if ((direction === 'up' && focusedStep === 1) ||
            (direction === 'down' && focusedStep === steps.length)) {
            return;
        }
        const nextStepToFocusNumber = direction === 'up' ? focusedStep - 1 : focusedStep + 1;
        const nextStepToFocus = stepsRefMap.current.get(nextStepToFocusNumber);
        nextStepToFocus === null || nextStepToFocus === void 0 ? void 0 : nextStepToFocus.focus();
    };
    const handleEnter = () => {
        const focusedStep = document.activeElement;
        onActiveStepChange(Number(focusedStep.dataset.step));
    };
    const handleKeyDown = (e) => {
        // If one of our steps is focused, and the user hit one of the up or down
        // arrow keys, we want to shift focus to the prev / next step.
        if (ElementIsOrChildOf(document.activeElement, Array.from(stepsRefMap.current.values()))) {
            KeyHandleMap(e, [
                { ArrowUp: () => handleArrow('up') },
                { ArrowDown: () => handleArrow('down') },
                { Enter: handleEnter }
            ]);
        }
    };
    // When a step component requests a change of the active step either by it being clicked
    // or user using keyboard nav.
    const onStepChangeRequest = (requestedStep) => {
        // Make sure the requested step is a valid step.
        if (requestedStep > 0 && requestedStep <= steps.length) {
            onActiveStepChange(requestedStep);
        }
    };
    const renderStepsNav = () => {
        return React__default.Children.map(steps, (step, index) => {
            const stepNumber = index + 1;
            const isActive = activeStep === stepNumber;
            return React__default.cloneElement(step, {
                step: stepNumber,
                ref: (ref) => stepsRefMap.current.set(stepNumber, ref),
                onUnmount: (step) => stepsRefMap.current.delete(step),
                testId: testId && `${testId}-${stepNumber}`,
                onActivate: onStepChangeRequest,
                isFocusable: !stepsIsFocused && isActive,
                active: isActive
            });
        });
    };
    // We have to turn off flex grow if we are using explicit sizing for the width.
    let contentStyles = contentOpts;
    if (contentStyles && (contentOpts === null || contentOpts === void 0 ? void 0 : contentOpts.width)) {
        contentStyles = Object.assign(Object.assign({}, contentOpts), { flexGrow: 0 });
    }
    return (React__default.createElement("div", Object.assign({}, (customDataProps !== null && customDataProps !== void 0 ? customDataProps : {}), { "data-test": testId, onKeyDown: handleKeyDown, className: cx('ads-wizard-stepper', // Modal has to target wizard steppers to add negative margin to stretch to the edges for borders
        'wizardStepper', 'flex-container', 'gap-0', className) }),
        React__default.createElement("div", { className: cx('steps', stepsClassName), "data-test": testId ? `${testId}-steps` : '' },
            React__default.createElement(ScrollShadow, { testId: testId ? `${testId}-steps-scrollShadow-top` : '', position: "top", visible: stepsScroll.hasScroll && !stepsScroll.isAtTop }),
            React__default.createElement("div", { ref: setStepsDivElem, "data-test": testId ? `${testId}-steps-scroll` : '', onFocus: handleStepsFocus, onBlur: handleStepsBlur, 
                // Modal has special styling for the step container (padding-left)
                className: cx('ads-wizard-steps-container', 'stepsContainer') }, renderStepsNav()),
            React__default.createElement(ScrollShadow, { testId: testId ? `${testId}-steps-scrollShadow-bottom` : '', position: "bottom", visible: stepsScroll.hasScroll && !stepsScroll.isAtBottom })),
        React__default.createElement("div", { className: cx('content', 'flex-item'), "data-test": testId ? `${testId}-content-container` : undefined, style: contentStyles && contentStyles },
            React__default.createElement(ScrollShadow, { testId: testId ? `${testId}-content-scrollShadow-top` : '', position: "top", visible: contentScroll.hasScroll && !contentScroll.isAtTop }),
            React__default.createElement("div", { ref: setContentDivElem, "data-test": testId ? `${testId}-content-scroll` : undefined, 
                // Modal needs to target to add correct amount of padding
                className: cx('ads-wizard-content-container', 'contentWrapper', 'py-200', 'pl-200') }, steps.map((step, index) => {
                const isActive = activeStep === index + 1;
                return (React__default.createElement(WizardContent, { className: step.props.className, key: step.props.id || step.props.title, step: index + 1, ref: (el) => {
                        // We need this to focus the content of the active content
                        if (isActive) {
                            activeContentElRef.current = el;
                        }
                    }, isActive: isActive, testId: testId && isActive ? `${testId}-content` : undefined }, step.props.children));
            })),
            React__default.createElement(ScrollShadow, { testId: testId ? `${testId}-content-scrollShadow-bottom` : '', position: "bottom", visible: contentScroll.hasScroll && !contentScroll.isAtBottom }))));
};
const UnControlledWizardStepper = (_a) => {
    var { onActiveStepChange } = _a, props = __rest(_a, ["onActiveStepChange"]);
    const [activeStep, setActiveStep] = React__default.useState(1);
    const handleStepChange = (activeStep) => {
        setActiveStep(activeStep);
        // If we have an onActiveStepChange handler invoke it.
        onActiveStepChange && onActiveStepChange(activeStep);
    };
    return (React__default.createElement(WizardStepperBase, Object.assign({}, props, { activeStep: activeStep, onActiveStepChange: handleStepChange })));
};
const WizardStepper = (props) => {
    return props.activeStep ? (
    // @ts-ignore - not sure why it thinks props.activeTab can be undefined given we check above for that case
    React__default.createElement(WizardStepperBase, Object.assign({}, props))) : (React__default.createElement(UnControlledWizardStepper, Object.assign({}, props)));
};

const WizardStepperButtons = ({ customDataProps, testId, stepData, onActiveStepChange, buttons }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const buttonsDefault = {
        prev: {
            label: 'Prev'
        },
        next: {
            label: 'Next',
            className: 'minw-80'
        },
        final: {
            label: 'Final',
            className: 'minw-80',
            submit: true
        }
    };
    // Apply default button config. We need a deep merge not a shallow merge hence why
    // we are using lodash's merge.
    buttons = merge(buttonsDefault, buttons);
    return (React__default.createElement(ButtonContainer, { customDataProps: customDataProps, testId: testId },
        (buttons === null || buttons === void 0 ? void 0 : buttons.preSlot) && buttons.preSlot,
        React__default.createElement(Button, { disabled: !(stepData === null || stepData === void 0 ? void 0 : stepData.prev), testId: testId ? `${testId}-prev-btn` : undefined, className: (_a = buttons === null || buttons === void 0 ? void 0 : buttons.prev) === null || _a === void 0 ? void 0 : _a.className, onClick: () => {
                var _a, _b;
                if (stepData === null || stepData === void 0 ? void 0 : stepData.prev) {
                    // Set step to prev step
                    onActiveStepChange(stepData === null || stepData === void 0 ? void 0 : stepData.prev);
                    // Focus content
                    stepData === null || stepData === void 0 ? void 0 : stepData.focusContent();
                    // Fire callback if we have one.
                    ((_a = buttons === null || buttons === void 0 ? void 0 : buttons.prev) === null || _a === void 0 ? void 0 : _a.onClick) && ((_b = buttons === null || buttons === void 0 ? void 0 : buttons.prev) === null || _b === void 0 ? void 0 : _b.onClick());
                }
            } }, (_b = buttons === null || buttons === void 0 ? void 0 : buttons.prev) === null || _b === void 0 ? void 0 : _b.label),
        React__default.createElement(Button, { type: "primary", testId: testId
                ? (stepData === null || stepData === void 0 ? void 0 : stepData.next)
                    ? `${testId}-next-btn`
                    : `${testId}-final-btn`
                : undefined, className: (stepData === null || stepData === void 0 ? void 0 : stepData.next) ? (_c = buttons === null || buttons === void 0 ? void 0 : buttons.next) === null || _c === void 0 ? void 0 : _c.className : (_d = buttons === null || buttons === void 0 ? void 0 : buttons.final) === null || _d === void 0 ? void 0 : _d.className, submit: !(stepData === null || stepData === void 0 ? void 0 : stepData.next) && ((_e = buttons === null || buttons === void 0 ? void 0 : buttons.final) === null || _e === void 0 ? void 0 : _e.submit), onClick: () => {
                var _a, _b, _c, _d;
                // Is this the last step?
                if (stepData === null || stepData === void 0 ? void 0 : stepData.next) {
                    // Set step to next step
                    onActiveStepChange(stepData === null || stepData === void 0 ? void 0 : stepData.next);
                    // Focus content
                    stepData === null || stepData === void 0 ? void 0 : stepData.focusContent();
                    // Fire callback if we have one.
                    ((_a = buttons === null || buttons === void 0 ? void 0 : buttons.next) === null || _a === void 0 ? void 0 : _a.onClick) && ((_b = buttons === null || buttons === void 0 ? void 0 : buttons.next) === null || _b === void 0 ? void 0 : _b.onClick());
                }
                else {
                    ((_c = buttons === null || buttons === void 0 ? void 0 : buttons.final) === null || _c === void 0 ? void 0 : _c.onClick) && ((_d = buttons === null || buttons === void 0 ? void 0 : buttons.final) === null || _d === void 0 ? void 0 : _d.onClick());
                }
            } },
            (stepData === null || stepData === void 0 ? void 0 : stepData.next) && ((_f = buttons === null || buttons === void 0 ? void 0 : buttons.next) === null || _f === void 0 ? void 0 : _f.label),
            !(stepData === null || stepData === void 0 ? void 0 : stepData.next) && ((_g = buttons === null || buttons === void 0 ? void 0 : buttons.final) === null || _g === void 0 ? void 0 : _g.label))));
};

export { Accordion, AccordionTypes, ActionsMenuButton, Address, AddressFieldLabels, AddressFields, AddressMode, Alert, AlertBody, AlertMessageType, Align, Badge, BadgeShape, BadgeType, BrandType, BreakPoint, Button, ButtonContainer, ButtonGroup, Card, CellText, Checkbox, CheckboxItem, CheckboxItemV2, CheckboxList, CheckboxV2, ClickEventBoundary, CloseButton, Col, ColumnMode, Combobox, ComboboxPaginated, Container$1 as Container, CurrencyField, DListItem, DataGrid, DataGridPaginated, DatePicker, DecimalField, DescriptionList, DismissedBy, DropdownButton, EmbeddedLabelSelect, ExactMatchOptionKeys, FieldHeightLabel, FieldHeightText, FieldMessage, FieldRow, FieldSkeleton, FieldSummary, FileDropZone, FileUpload, Flex, ForeignAddress, Form, FormValidationState, FormatFileSize, GetCountryByCode, GetCountryByName, GetFileIcon, H1, H2, H3, H4, H6, HelpButton, Icon, IconPlacement, InlineAlert, IsAdsComponent, Label, LabelSpacer, LinkLabelSpacer, ListItem, Modal, ModalBody, ModalFooter, NestedPaginationLevel, OneOrMoreUtils, PercentField, PhoneField, PlacementPosition, Popover, PrivacyField, Radio, RadioGroup, RadioV2, Row, SearchBox, SectionV1 as Section, Section2UpV1 as Section2Up, Section2Up as Section2UpV2, Section3UpV1 as Section3Up, Section3Up as Section3UpV2, SectionTypes, Section as SectionV2, SelectType, SimpleList, SortDirection, SplitButton, Step, StickyFooter, StickyHeader, SubForm, SuggestionField, Tab, TabGroup, TextAlign, TextArea, TextAreaSkeleton, TextField, TextFieldFormats, Theme, Tooltip, Trans, Visible, WizardStepper, WizardStepperButtons, array, boolean, dataGrid, date, fieldRow, getPhoneNumberDefault, getSchemaField, number, object, objectExtend, phoneNumber, string, useDefaultCountry, useFieldSchemaName, useFormContext, useGetCountryByTranslatedName, useGetFormSectionStatus, useLocale, useNotifications, useResizeObserver, useRestrictedChildType, useSubFormContext, useSubFormPath, useToast, useTranslation, useTrigger };
//# sourceMappingURL=index.bundle.js.map
